import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  AppPeopleSelectionKey: { input: any; output: any }
  DateTime: { input: any; output: any }
  EmailAddress: { input: any; output: any }
  JSON: { input: any; output: any }
  JWT: { input: any; output: any }
  NonEmptyString: { input: any; output: any }
  URL: { input: any; output: any }
  UUID: { input: any; output: any }
}

/** Result of updating a completion via API */
export type ApiCompletionUpdate = {
  __typename?: "APICompletionUpdate"
  completion_id?: Maybe<Scalars["Int"]["output"]>
  /** Reason, if any, for why the update was ignored. */
  ignored_reason?: Maybe<ApiCompletionUpdateIgnoredReason>
  new_path_progress?: Maybe<Scalars["Float"]["output"]>
  new_points_assigned?: Maybe<Scalars["Float"]["output"]>
  new_step_progress?: Maybe<Scalars["Float"]["output"]>
  prev_path_progress?: Maybe<Scalars["Float"]["output"]>
  prev_points_assigned?: Maybe<Scalars["Float"]["output"]>
  prev_step_progress?: Maybe<Scalars["Float"]["output"]>
  success?: Maybe<Scalars["Boolean"]["output"]>
}

export enum ApiCompletionUpdateAction {
  Complete = "complete",
  Reset = "reset",
  Skip = "skip"
}

export enum ApiCompletionUpdateIgnoredReason {
  /** Completion has already been completed and no there was points change. */
  AlreadyCompleted = "already_completed",
  /** Completion has already been reset. */
  AlreadyReset = "already_reset",
  /** Completion has already been skipped. */
  AlreadySkipped = "already_skipped"
}

/** The context of a Pathwright 'session' in a school. */
export type AccountContext = {
  __typename?: "AccountContext"
  membership?: Maybe<Membership>
  permissions: ContextPermissions
  school: School
  theme?: Maybe<Theme>
  translation?: Maybe<Translation>
  user?: Maybe<User>
}

export enum ActionType {
  CanceledPausedSubscription = "canceled_paused_subscription",
  CanceledSubscription = "canceled_subscription",
  CompleteCourse = "complete_course",
  CompleteStep = "complete_step",
  CreateDiscussion = "create_discussion",
  CreateGroup = "create_group",
  CreateMembership = "create_membership",
  CreateRegistration = "create_registration",
  CreateResponse = "create_response",
  CreateSubscription = "create_subscription",
  PausedSubscription = "paused_subscription",
  SkipStep = "skip_step",
  SubscriptionCanceledImmediately = "subscription_canceled_immediately",
  SubscriptionEnded = "subscription_ended",
  UnpausedSubscription = "unpaused_subscription"
}

export type ActionTypeFilter = {
  eq?: InputMaybe<ActionType>
  gt?: InputMaybe<ActionType>
  gte?: InputMaybe<ActionType>
  in?: InputMaybe<Array<InputMaybe<ActionType>>>
  lt?: InputMaybe<ActionType>
  lte?: InputMaybe<ActionType>
  neq?: InputMaybe<ActionType>
  nin?: InputMaybe<Array<InputMaybe<ActionType>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright Activity */
export type Activity = {
  __typename?: "Activity"
  action?: Maybe<ActionType>
  action_dtime?: Maybe<Scalars["DateTime"]["output"]>
  action_type?: Maybe<Scalars["Int"]["output"]>
  discussion?: Maybe<Discussion>
  discussion_response?: Maybe<Response>
  group?: Maybe<Group>
  id?: Maybe<Scalars["Int"]["output"]>
  interest_level?: Maybe<Scalars["Int"]["output"]>
  offering_id?: Maybe<Scalars["Int"]["output"]>
  registration?: Maybe<Registration>
  resource?: Maybe<Resource>
  step?: Maybe<PathItem>
  triggered_by?: Maybe<User>
  user?: Maybe<User>
}

/** A connection to a list of items. */
export type ActivityConnection = {
  __typename?: "ActivityConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ActivityEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type ActivityEdge = {
  __typename?: "ActivityEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Activity>
}

export type ActivityStats = {
  __typename?: "ActivityStats"
  discussion_responses?: Maybe<Scalars["Int"]["output"]>
  discussions?: Maybe<Scalars["Int"]["output"]>
  registrations?: Maybe<Scalars["Int"]["output"]>
  steps_completed?: Maybe<Scalars["Int"]["output"]>
  /** @deprecated `total` no longer provided. Insteaed, query the `total` on activity. */
  total?: Maybe<Scalars["Int"]["output"]>
}

export type AddPeopleSelection = {
  add_to: Array<InputMaybe<AddPeopleSelectionTo>>
  key: Scalars["AppPeopleSelectionKey"]["input"]
  type: AddPeopleSelectionType
}

export type AddPeopleSelectionTo = {
  key: Scalars["String"]["input"]
  role: AddPeopleSelectionToRole
  type: AddPeopleSelectionToType
}

export enum AddPeopleSelectionToRole {
  CohortCourseEditor = "cohort_course_editor",
  CohortLearner = "cohort_learner",
  CohortModerator = "cohort_moderator",
  CohortObserver = "cohort_observer",
  CohortTeacher = "cohort_teacher",
  GroupAdmin = "group_admin",
  GroupMember = "group_member",
  GroupModerator = "group_moderator",
  SchoolAdmin = "school_admin",
  SchoolMember = "school_member",
  SchoolStaff = "school_staff"
}

export enum AddPeopleSelectionToType {
  Cohort = "cohort",
  Group = "group"
}

export enum AddPeopleSelectionType {
  Cohort = "cohort",
  Email = "email",
  Group = "group",
  User = "user"
}

export type AssignConfig = {
  target_role?: InputMaybe<RegistrationRoleEnum>
}

/** Methods for authenticating a user in a space */
export type AuthMethod = {
  __typename?: "AuthMethod"
  /** Whether this auth method is enabled for the Space */
  enabled: Scalars["Boolean"]["output"]
  id: Scalars["String"]["output"]
  meta: NodeMeta
}

/** A request made by the user to authenticate by some other means than username/password. */
export type AuthRequest = {
  __typename?: "AuthRequest"
  /** How many times this request has attempted confirmation, for preventing brute-force attacks. */
  confirmation_attempts: Scalars["Int"]["output"]
  /** When the authentication request was confirmed and an auth token was issued. */
  confirmed_dtime?: Maybe<Scalars["DateTime"]["output"]>
  /** A place for storing extra information about the request. May include information such as the user's IP address, invite tokens, etc. */
  context?: Maybe<Scalars["JSON"]["output"]>
  /** If set, after this time, the authentication request will be considered invalid. */
  expiration_dtime?: Maybe<Scalars["DateTime"]["output"]>
  /** If this authentication request was successful, this is the auth token that was issued. */
  issued_auth_token?: Maybe<JsonWebToken>
  /** When the authentication request was initially started. */
  request_dtime: Scalars["DateTime"]["output"]
  /** A 'secret key' that must be provided by the client in order to confirm the request. Always null as this key cannot be exposed. */
  request_key?: Maybe<Scalars["String"]["output"]>
  /** The authentication method being used, such as an Email-based OTP (magic link). */
  request_method: AuthRequestMethod
  school?: Maybe<School>
  truncated_email?: Maybe<Scalars["String"]["output"]>
  /** A customer-viewable ID for the authentication request. Must be used for all API calls to prevent sequentially enumerating auth requests. */
  uuid: Scalars["UUID"]["output"]
}

export enum AuthRequestMethod {
  EmailOtp = "email_otp"
}

/** A Pathwright Author */
export type Author = {
  __typename?: "Author"
  avatar?: Maybe<Scalars["String"]["output"]>
  bio?: Maybe<Scalars["String"]["output"]>
  display_name?: Maybe<Scalars["String"]["output"]>
  first_name?: Maybe<Scalars["String"]["output"]>
  full_name?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  image?: Maybe<Scalars["String"]["output"]>
  last_name?: Maybe<Scalars["String"]["output"]>
  meta: NodeMeta
  order?: Maybe<Scalars["Int"]["output"]>
  salutation?: Maybe<Scalars["String"]["output"]>
  slug?: Maybe<Scalars["String"]["output"]>
  title?: Maybe<Scalars["String"]["output"]>
}

/** A Pathwright Author */
export type AuthorImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** A connection to a list of items. */
export type AuthorConnection = {
  __typename?: "AuthorConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AuthorEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type AuthorEdge = {
  __typename?: "AuthorEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Author>
}

/** A background task. */
export type BackgroundTask = {
  __typename?: "BackgroundTask"
  id: Scalars["UUID"]["output"]
  result?: Maybe<Scalars["JSON"]["output"]>
  status: BackgroundTaskStatus
}

export enum BackgroundTaskStatus {
  Failure = "failure",
  Pending = "pending",
  Retry = "retry",
  Revoked = "revoked",
  Started = "started",
  Success = "success"
}

/** A Pathwright Banner */
export type Banner = {
  __typename?: "Banner"
  background_image?: Maybe<Scalars["String"]["output"]>
  background_image_raw?: Maybe<Scalars["String"]["output"]>
  background_overlay?: Maybe<Scalars["String"]["output"]>
  background_type?: Maybe<Scalars["Int"]["output"]>
  button_func?: Maybe<Scalars["String"]["output"]>
  button_text?: Maybe<Scalars["String"]["output"]>
  button_url?: Maybe<Scalars["String"]["output"]>
  font_color?: Maybe<Scalars["String"]["output"]>
  heading?: Maybe<Scalars["String"]["output"]>
  hide_for_products?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>
  hide_for_subscription_plans?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>
  id?: Maybe<Scalars["Int"]["output"]>
  is_visible?: Maybe<Scalars["Boolean"]["output"]>
  order?: Maybe<Scalars["Int"]["output"]>
  readability?: Maybe<Scalars["Boolean"]["output"]>
  show_for_products?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>
  show_for_subscription_plans?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>
  subhead?: Maybe<Scalars["String"]["output"]>
}

/** A Pathwright Banner */
export type BannerBackground_ImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** A connection to a list of items. */
export type BannerConnection = {
  __typename?: "BannerConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BannerEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type BannerEdge = {
  __typename?: "BannerEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Banner>
}

export type BatchMentorGroupMembershipResult = {
  __typename?: "BatchMentorGroupMembershipResult"
  group_memberships_created_count?: Maybe<Scalars["Int"]["output"]>
  success?: Maybe<Scalars["Boolean"]["output"]>
}

export type BlocksContent = {
  __typename?: "BlocksContent"
  content_last_modified?: Maybe<Scalars["DateTime"]["output"]>
  created?: Maybe<Scalars["DateTime"]["output"]>
  created_by_id?: Maybe<Scalars["Int"]["output"]>
  data?: Maybe<Scalars["JSON"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  last_published?: Maybe<Scalars["DateTime"]["output"]>
  method?: Maybe<Scalars["String"]["output"]>
  modified?: Maybe<Scalars["DateTime"]["output"]>
  modified_by_id?: Maybe<Scalars["Int"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
}

export type Calendar = {
  __typename?: "Calendar"
  events?: Maybe<Array<Maybe<CalendarEvent>>>
  id?: Maybe<Scalars["ID"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  timezone?: Maybe<Scalars["String"]["output"]>
  url?: Maybe<Scalars["String"]["output"]>
}

export type CalendarEvent = {
  __typename?: "CalendarEvent"
  completion_status?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  end?: Maybe<Scalars["DateTime"]["output"]>
  ical_url?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["ID"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  relative_url?: Maybe<Scalars["String"]["output"]>
  start?: Maybe<Scalars["DateTime"]["output"]>
  summary?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  url?: Maybe<Scalars["String"]["output"]>
}

export type CalendarStats = {
  __typename?: "CalendarStats"
  due?: Maybe<Scalars["Int"]["output"]>
  late?: Maybe<Scalars["Int"]["output"]>
  total?: Maybe<Scalars["Int"]["output"]>
  upcoming?: Maybe<Scalars["Int"]["output"]>
}

/** A Course Category */
export type Category = {
  __typename?: "Category"
  description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  order?: Maybe<Scalars["Int"]["output"]>
  slug?: Maybe<Scalars["String"]["output"]>
}

/** A connection to a list of items. */
export type CategoryConnection = {
  __typename?: "CategoryConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CategoryEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type CategoryEdge = {
  __typename?: "CategoryEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Category>
}

export type Certificate = {
  __typename?: "Certificate"
  created_time?: Maybe<Scalars["DateTime"]["output"]>
  /** Generated download url based on optionally provided path_id. */
  download_url?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  /** Whether the certificate is currently active. */
  is_active?: Maybe<Scalars["Boolean"]["output"]>
  /** Name of certificate for visual identification. */
  name?: Maybe<Scalars["String"]["output"]>
  school?: Maybe<School>
  /** The PDF template URL. */
  template?: Maybe<Scalars["String"]["output"]>
  /** List of text objects to be merged with PDF template. */
  text_objects?: Maybe<Scalars["JSON"]["output"]>
}

export type CertificateDownload_UrlArgs = {
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  variables?: InputMaybe<Scalars["JSON"]["input"]>
}

/** A connection to a list of items. */
export type CertificateConnection = {
  __typename?: "CertificateConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CertificateEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type CertificateEdge = {
  __typename?: "CertificateEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Certificate>
}

export type CertificateVariables = {
  __typename?: "CertificateVariables"
  id?: Maybe<Scalars["Int"]["output"]>
  /** Key/value pairs of variable paths and the number of times they are used by all courses. */
  stats?: Maybe<Scalars["JSON"]["output"]>
  /** Key/value pairs of variable paths and their values. Only applicable when scoping to a resource. */
  variables?: Maybe<Scalars["JSON"]["output"]>
}

export type CertificateVariablesContextInput = {
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type CertificateVariablesMergeInput = {
  /** Old name of a key that should be transitioned to new_key. */
  current_key?: InputMaybe<Scalars["String"]["input"]>
  /** New name of a key that should be transitioned from current_key. Omitting this arg will result in deleting current_key. */
  new_key?: InputMaybe<Scalars["String"]["input"]>
  /** New value of the new_key. Omitting this arg will result in the current value of current_key to be used by default. */
  new_value?: InputMaybe<Scalars["String"]["input"]>
}

export type Codex = {
  __typename?: "Codex"
  config?: Maybe<CodexConfig>
  space?: Maybe<CodexSpace>
}

export type CodexSpaceArgs = {
  join?: InputMaybe<Scalars["Boolean"]["input"]>
  key: Scalars["String"]["input"]
}

export type CodexAccount = {
  __typename?: "CodexAccount"
  id: Scalars["ID"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
}

export type CodexConfig = {
  __typename?: "CodexConfig"
  account?: Maybe<CodexAccount>
  firebase?: Maybe<FirebaseConfig>
  user?: Maybe<CodexUser>
}

export type CodexNode = {
  __typename?: "CodexNode"
  created?: Maybe<Scalars["DateTime"]["output"]>
  data: Scalars["JSON"]["output"]
  fromId?: Maybe<Scalars["ID"]["output"]>
  graphId?: Maybe<Scalars["ID"]["output"]>
  id: Scalars["ID"]["output"]
  key?: Maybe<Scalars["String"]["output"]>
  parentId?: Maybe<Scalars["ID"]["output"]>
  rootId?: Maybe<Scalars["ID"]["output"]>
  toId?: Maybe<Scalars["ID"]["output"]>
  type: Scalars["String"]["output"]
  updated?: Maybe<Scalars["DateTime"]["output"]>
  userId?: Maybe<Scalars["ID"]["output"]>
}

/** A publish to Paths (codex data structure) */
export type CodexPathPublish = {
  __typename?: "CodexPathPublish"
  node?: Maybe<PathsCodexNode>
}

export type CodexSpace = {
  __typename?: "CodexSpace"
  id: Scalars["ID"]["output"]
  membership?: Maybe<CodexNode>
  nodes?: Maybe<Array<Maybe<CodexNode>>>
}

export type CodexSpaceNodesArgs = {
  last_x_days?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<Scalars["String"]["input"]>
}

export type CodexUser = {
  __typename?: "CodexUser"
  authToken: Scalars["String"]["output"]
  displayName: Scalars["String"]["output"]
  id: Scalars["ID"]["output"]
  image?: Maybe<Scalars["String"]["output"]>
}

/** Whether user can use Cohort share UI. */
export type CohortShareAccess = {
  __typename?: "CohortShareAccess"
  /** A user's access level to share UI. */
  access?: Maybe<ShareAccessPermission>
  /** When share UI is gated, this will be the reason for why. */
  gated_reason?: Maybe<CohortShareAccessGatedReasonType>
}

export enum CohortShareAccessGatedReasonType {
  CohortCompleted = "COHORT_COMPLETED",
  CohortEnded = "COHORT_ENDED",
  CohortLicensedSeatsFilled = "COHORT_LICENSED_SEATS_FILLED",
  CohortRegistrationEnded = "COHORT_REGISTRATION_ENDED",
  CohortSeatsFilled = "COHORT_SEATS_FILLED"
}

/** Whether user can use Cohort share > add UI. */
export type CohortShareAddAccess = {
  __typename?: "CohortShareAddAccess"
  /** A user's access level to share > add UI. */
  access?: Maybe<ShareAccessPermission>
  /** When share > add UI is gated, this will be the reason for why. */
  gated_reason?: Maybe<CohortShareAddAccessGatedReasonType>
}

export enum CohortShareAddAccessGatedReasonType {
  SchoolInactive = "SCHOOL_INACTIVE"
}

/** Whether user can use Cohort share > link UI. */
export type CohortShareLinkAccess = {
  __typename?: "CohortShareLinkAccess"
  /** A user's access level to share > link UI. */
  access?: Maybe<ShareAccessPermission>
  /** When share > link UI is gated, this will be the reason for why. */
  gated_reason?: Maybe<CohortShareLinkAccessGatedReasonType>
}

export enum CohortShareLinkAccessGatedReasonType {
  SchoolInactive = "SCHOOL_INACTIVE"
}

/** Whether user can use Cohort share > track UI. */
export type CohortShareTrackAccess = {
  __typename?: "CohortShareTrackAccess"
  /** A user's access level to share > track UI. */
  access?: Maybe<ShareAccessPermission>
  /** When share > track UI is gated, this will be the reason for why. */
  gated_reason?: Maybe<CohortShareTrackAccessGatedReasonType>
}

export enum CohortShareTrackAccessGatedReasonType {
  Placeholder = "PLACEHOLDER"
}

export type CohortsStatusMeta = {
  __typename?: "CohortsStatusMeta"
  completed?: Maybe<Scalars["Int"]["output"]>
  in_progress?: Maybe<Scalars["Int"]["output"]>
}

/** Computed fields on path item */
export type Completion = {
  __typename?: "Completion"
  checked_by?: Maybe<User>
  checked_by_id?: Maybe<Scalars["Int"]["output"]>
  checked_date?: Maybe<Scalars["DateTime"]["output"]>
  completion_attempts?: Maybe<Scalars["Int"]["output"]>
  completion_comment?: Maybe<Scalars["String"]["output"]>
  completion_date?: Maybe<Scalars["DateTime"]["output"]>
  completion_due?: Maybe<Scalars["DateTime"]["output"]>
  feedback_discussion_context?: Maybe<CompletionFeedbackDiscussionContext>
  grading_type?: Maybe<Scalars["String"]["output"]>
  has_failed_passing_attempt?: Maybe<Scalars["Boolean"]["output"]>
  has_points?: Maybe<Scalars["Boolean"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  is_auto_graded?: Maybe<Scalars["Boolean"]["output"]>
  is_complete?: Maybe<Scalars["Boolean"]["output"]>
  is_forced_completion?: Maybe<Scalars["Boolean"]["output"]>
  is_graded?: Maybe<Scalars["Boolean"]["output"]>
  is_late?: Maybe<Scalars["Boolean"]["output"]>
  is_skipped?: Maybe<Scalars["Boolean"]["output"]>
  last_completion_attempt_date?: Maybe<Scalars["DateTime"]["output"]>
  minimum_passing_score?: Maybe<Scalars["Int"]["output"]>
  needs_grading?: Maybe<Scalars["Boolean"]["output"]>
  overridden_by?: Maybe<User>
  overridden_by_api?: Maybe<Scalars["Boolean"]["output"]>
  requires_api_completion?: Maybe<Scalars["Boolean"]["output"]>
  /** Legacy content (only applicable to Path Items using legacy content, pre-dating Blocks). */
  submission?: Maybe<UserSubmission>
  user?: Maybe<User>
  userpoints_earned?: Maybe<Scalars["Int"]["output"]>
  userpoints_explanation?: Maybe<Scalars["String"]["output"]>
  userpoints_value?: Maybe<Scalars["Int"]["output"]>
}

/** Link to the feedback discussion context for a completion */
export type CompletionFeedbackDiscussionContext = {
  __typename?: "CompletionFeedbackDiscussionContext"
  discussion_id?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  num_responses?: Maybe<Scalars["Int"]["output"]>
}

export enum CompletionStateFilter {
  Completed = "completed",
  InProgress = "in_progress",
  Unstarted = "unstarted"
}

/** Computed discount values for an enrollment */
export type ComputedDiscount = {
  __typename?: "ComputedDiscount"
  discount_amount?: Maybe<Scalars["Float"]["output"]>
  discount_percent?: Maybe<Scalars["Float"]["output"]>
  discounted_total?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  max_seat_discount?: Maybe<Scalars["Int"]["output"]>
}

export type ContextModelInput = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  path_item_id?: InputMaybe<Scalars["Int"]["input"]>
  path_item_source_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type ContextPermissions = {
  __typename?: "ContextPermissions"
  can_administrate?: Maybe<Scalars["Boolean"]["output"]>
  can_edit_library?: Maybe<Scalars["Boolean"]["output"]>
  has_member_access?: Maybe<Scalars["Boolean"]["output"]>
  has_pathwright_staff_access?: Maybe<Scalars["Boolean"]["output"]>
  is_school_owner?: Maybe<Scalars["Boolean"]["output"]>
}

/** Contextual permissions for a PathwrightFeature */
export type ContextualFeaturePermission = {
  __typename?: "ContextualFeaturePermission"
  cohort_id?: Maybe<Scalars["Int"]["output"]>
  feature_action: FeatureAction
  feature_key: FeatureKey
  id?: Maybe<Scalars["Int"]["output"]>
  permission_in_context: FeaturePermission
  resource_id?: Maybe<Scalars["Int"]["output"]>
  school_id?: Maybe<Scalars["Int"]["output"]>
}

/** A Coupon applicable to Paths or */
export type Coupon = {
  __typename?: "Coupon"
  /** If True, this coupon applies to all courses. */
  allCourses: Scalars["Boolean"]["output"]
  /** The unique code used to redeem this coupon. */
  code: Scalars["String"]["output"]
  /** Percent in the range of 0...1. */
  discountPercent: Scalars["Int"]["output"]
  /** Subscriptions plans billing cycles can have varying intervals (weeks, months, years, etc). This determines how many cycles are being discounted. */
  discountedSubscriptionCycles?: Maybe<Scalars["Int"]["output"]>
  /** Coupon can't be used after this date. */
  endDtime?: Maybe<Scalars["DateTime"]["output"]>
  /** The ID of the Coupon. */
  id: Scalars["Int"]["output"]
  /** If True, this can only be redeemed once per user. */
  isOnePerUser: Scalars["Boolean"]["output"]
  /** The max # of times this coupon can be used. */
  maxNumRedemptions?: Maybe<Scalars["Int"]["output"]>
  /** Maximum number of seats that the discount percent can be applied to. */
  maxSeatDiscount: Scalars["Int"]["output"]
  /** Coupon can't be used before this date. */
  startDtime?: Maybe<Scalars["DateTime"]["output"]>
}

/** A coupon discount applicable to a course or school subscription plan */
export type CouponDiscount = {
  __typename?: "CouponDiscount"
  /** The total before discount */
  amount?: Maybe<Scalars["Float"]["output"]>
  code?: Maybe<Scalars["String"]["output"]>
  /** How much the user will save */
  discount_amount?: Maybe<Scalars["Float"]["output"]>
  discount_percent?: Maybe<Scalars["Float"]["output"]>
  discounted_subscription_cycles?: Maybe<Scalars["Int"]["output"]>
  /** How much the user will pay */
  discounted_total?: Maybe<Scalars["Float"]["output"]>
  end_date?: Maybe<Scalars["DateTime"]["output"]>
  has_ended?: Maybe<Scalars["Boolean"]["output"]>
  has_started?: Maybe<Scalars["Boolean"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  is_one_per_user?: Maybe<Scalars["Boolean"]["output"]>
  max_num_redemptions?: Maybe<Scalars["Int"]["output"]>
  max_seat_discount?: Maybe<Scalars["Int"]["output"]>
  num_redemptions?: Maybe<Scalars["Int"]["output"]>
  start_date?: Maybe<Scalars["DateTime"]["output"]>
  user_can_redeem?: Maybe<Scalars["Boolean"]["output"]>
  user_redeemed?: Maybe<Scalars["Boolean"]["output"]>
}

export type CouponExistsInput = {
  /** Scope coupons to paths. */
  path?: InputMaybe<CouponForPathExistsInput>
  /** Scope coupons to subscription plans. */
  plan?: InputMaybe<CouponForPlanExistsInput>
}

export type CouponForPathExistsInput = {
  /** A minimum number of seats required. Anything over 0 signifies the coupon must be used for member-created Cohorts. */
  minSeats?: InputMaybe<Scalars["Int"]["input"]>
  /** ID of the resource to scope coupons to. */
  resourceId: Scalars["Int"]["input"]
}

export type CouponForPlanExistsInput = {
  /** ID of the school subscription plan to scope coupons to. */
  schoolSubscriptionPlanId: Scalars["Int"]["input"]
}

/** The record of a Coupon redemption. */
export type CouponRedemption = {
  __typename?: "CouponRedemption"
  /** The Coupon that was redeemed. */
  coupon: Coupon
  /** The ID of the CouponRedemption. */
  id: Scalars["Int"]["output"]
  /** The time at which the coupon was redeemed. */
  redeemedDtime: Scalars["DateTime"]["output"]
}

export type CreateInvitationsSuccess = {
  __typename?: "CreateInvitationsSuccess"
  invitations_attempted_count?: Maybe<Scalars["Int"]["output"]>
  invitations_sent_count?: Maybe<Scalars["Int"]["output"]>
  /** An array of unsuccessful invitations containing email, role, type, and error. */
  unsuccessful_invitations?: Maybe<Scalars["JSON"]["output"]>
}

/** Curriculum license order data */
export type CurriculumLicenseOrderData = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  license_offering_id: Scalars["Int"]["input"]
  licensee_school_id: Scalars["Int"]["input"]
  licensor_school_id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  role?: InputMaybe<RegistrationRoleEnum>
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
}

/** A school licensing school curriculum subscription */
export type CurriculumSubscription = {
  __typename?: "CurriculumSubscription"
  curriculum_plan?: Maybe<SchoolCurriculumPlan>
  id: Scalars["Int"]["output"]
  licensee: School
  licensor: School
  subscription?: Maybe<Subscription>
}

/** A connection to a list of items. */
export type CurriculumSubscriptionConnection = {
  __typename?: "CurriculumSubscriptionConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CurriculumSubscriptionEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type CurriculumSubscriptionEdge = {
  __typename?: "CurriculumSubscriptionEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<CurriculumSubscription>
}

/** Curriculum subscription order data */
export type CurriculumSubscriptionOrderData = {
  curriculum_plan_id: Scalars["Int"]["input"]
  licensee_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
}

export enum CurriculumType {
  /** The source curriculum for this group (what the teacher edits) */
  Source = "source",
  /** The current logged in user's curriculum */
  User = "user"
}

export type DateFilter = {
  eq?: InputMaybe<Scalars["DateTime"]["input"]>
  gt?: InputMaybe<Scalars["DateTime"]["input"]>
  gte?: InputMaybe<Scalars["DateTime"]["input"]>
  in?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>
  lt?: InputMaybe<Scalars["DateTime"]["input"]>
  lte?: InputMaybe<Scalars["DateTime"]["input"]>
  neq?: InputMaybe<Scalars["DateTime"]["input"]>
  nin?: InputMaybe<Array<InputMaybe<Scalars["DateTime"]["input"]>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type DeferOrExecuteResourceCopyConfigResult = {
  __typename?: "DeferOrExecuteResourceCopyConfigResult"
  defer: Scalars["JSON"]["output"]
  execute: Scalars["JSON"]["output"]
}

/** Pathwright discussion */
export type Discussion = {
  __typename?: "Discussion"
  allow_replies: Scalars["Boolean"]["output"]
  body?: Maybe<Scalars["String"]["output"]>
  cohort?: Maybe<Group>
  cohort_id?: Maybe<Scalars["Int"]["output"]>
  context_id?: Maybe<Scalars["Int"]["output"]>
  created_time: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  is_discussion_question: Scalars["Boolean"]["output"]
  last_activity_time?: Maybe<Scalars["DateTime"]["output"]>
  likes: Scalars["Int"]["output"]
  modified_time: Scalars["DateTime"]["output"]
  order: Scalars["Int"]["output"]
  path_item?: Maybe<PathItem>
  /** @deprecated No longer used. */
  path_item_name?: Maybe<Scalars["String"]["output"]>
  resource?: Maybe<Resource>
  resource_id?: Maybe<Scalars["Int"]["output"]>
  response?: Maybe<Response>
  responses?: Maybe<ResponseConnection>
  step_id?: Maybe<Scalars["Int"]["output"]>
  tagLinks?: Maybe<TagLinkConnection>
  title: Scalars["String"]["output"]
  total_responses: Scalars["Int"]["output"]
  type: Scalars["Int"]["output"]
  user?: Maybe<User>
  user_has_viewed_recent: Scalars["Boolean"]["output"]
  user_is_subscribed?: Maybe<Scalars["Boolean"]["output"]>
  user_last_responded_time?: Maybe<Scalars["DateTime"]["output"]>
  user_last_viewed_time?: Maybe<Scalars["DateTime"]["output"]>
  user_liked?: Maybe<Scalars["Boolean"]["output"]>
}

/** Pathwright discussion */
export type DiscussionResponseArgs = {
  response_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright discussion */
export type DiscussionResponsesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
}

/** Pathwright discussion */
export type DiscussionTagLinksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  discussion_context_id?: InputMaybe<Scalars["Int"]["input"]>
  first: Scalars["Int"]["input"]
  tag_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A connection to a list of items. */
export type DiscussionConnection = {
  __typename?: "DiscussionConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DiscussionEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

export type DiscussionContextInput = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  completion_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** An edge in a connection. */
export type DiscussionEdge = {
  __typename?: "DiscussionEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Discussion>
}

/** Pathwright user discussion history */
export type DiscussionParticipant = {
  __typename?: "DiscussionParticipant"
  display_name?: Maybe<Scalars["String"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  external_account_link?: Maybe<ExternalAccountLink>
  first_name: Scalars["String"]["output"]
  full_name: Scalars["String"]["output"]
  gravatar?: Maybe<Gravatar>
  group_role_stats?: Maybe<Array<Maybe<GroupRoleStats>>>
  id: Scalars["Int"]["output"]
  /** A user account setup is onl considered 'finalized' when the `first_name` and `last_name` fields have been set. */
  is_finalized?: Maybe<Scalars["Boolean"]["output"]>
  is_staff?: Maybe<Scalars["Boolean"]["output"]>
  is_superuser?: Maybe<Scalars["Boolean"]["output"]>
  last_name: Scalars["String"]["output"]
  membership?: Maybe<Membership>
  memberships?: Maybe<MembershipConnection>
  mentorGroupMemberships?: Maybe<MentorGroupMembershipConnection>
  no_password_set?: Maybe<Scalars["Boolean"]["output"]>
  /** The user's payment history */
  payment_history: PaymentHistory
  permissions?: Maybe<ContextPermissions>
  profile?: Maybe<Profile>
  registrations?: Maybe<RegistrationConnection>
  school_group_subscriptions?: Maybe<SchoolGroupSubscriptionConnection>
  school_subscription?: Maybe<SchoolSubscription>
  token?: Maybe<Token>
  username?: Maybe<Scalars["String"]["output"]>
}

/** Pathwright user discussion history */
export type DiscussionParticipantMembershipsArgs = {
  access_revoked_date_filter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  after?: InputMaybe<Scalars["String"]["input"]>
  archived_date_filter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  daysInactive?: InputMaybe<Scalars["Int"]["input"]>
  first: Scalars["Int"]["input"]
  global?: InputMaybe<Scalars["Boolean"]["input"]>
  hasAccess?: InputMaybe<Scalars["Boolean"]["input"]>
  orderBy?: InputMaybe<Scalars["String"]["input"]>
  role_filter?: InputMaybe<Array<InputMaybe<MembershipRoleFilter>>>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright user discussion history */
export type DiscussionParticipantMentorGroupMembershipsArgs = {
  _or?: InputMaybe<MentorGroupMembershipOr>
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  group_type?: InputMaybe<MentorGroupType>
  group_types?: InputMaybe<MentorGroupTypeFilter>
  mentor_group_seat_limit?: InputMaybe<Scalars["Int"]["input"]>
  mentor_group_seat_limit_filter?: InputMaybe<IntFilter>
  mentor_group_seats_filled?: InputMaybe<Scalars["Int"]["input"]>
  mentor_group_seats_filled_filter?: InputMaybe<IntFilter>
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  role?: InputMaybe<MentorGroupMembershipRoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright user discussion history */
export type DiscussionParticipantRegistrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  completion_state?: InputMaybe<CompletionStateFilter>
  created?: InputMaybe<DateFilter>
  first: Scalars["Int"]["input"]
  has_parent_registration?: InputMaybe<Scalars["Boolean"]["input"]>
  lastSeen?: InputMaybe<DateFilter>
  last_active?: InputMaybe<DateFilter>
  orderBy?: InputMaybe<Array<InputMaybe<RegistrationOrderByInput>>>
  parent_cohort_filter?: InputMaybe<IdFilter>
  positioningContext?: InputMaybe<PositioningContextInput>
  progress_filter?: InputMaybe<ProgressFilter>
  role?: InputMaybe<RegistrationRoleEnum>
  role_filter?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  send_discussion_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  send_due_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  softArchived?: InputMaybe<DateFilter>
}

/** Pathwright user discussion history */
export type DiscussionParticipantSchool_Group_SubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A connection to a list of items. */
export type DiscussionParticipantConnection = {
  __typename?: "DiscussionParticipantConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DiscussionParticipantEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type DiscussionParticipantEdge = {
  __typename?: "DiscussionParticipantEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<DiscussionParticipant>
}

export type DiscussionPostInput = {
  body?: InputMaybe<Scalars["String"]["input"]>
  is_discussion_question?: InputMaybe<Scalars["Boolean"]["input"]>
  title?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<Scalars["Int"]["input"]>
}

export type DiscussionResponseContextInput = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  completion_id?: InputMaybe<Scalars["Int"]["input"]>
  discussion_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type DiscussionResponseInput = {
  attachments?: InputMaybe<Scalars["JSON"]["input"]>
  body: Scalars["String"]["input"]
  depth?: InputMaybe<Scalars["Int"]["input"]>
  discussion_id?: InputMaybe<Scalars["Int"]["input"]>
  reply_parent_id?: InputMaybe<Scalars["Int"]["input"]>
}

export enum DiscussionTypeInput {
  Faq = "faq",
  Feedback = "feedback",
  Post = "post",
  Question = "question",
  Review = "review"
}

export enum EmailDeliveryStatus {
  Bounced = "bounced",
  Clicked = "clicked",
  Complained = "complained",
  Deferred = "deferred",
  Opened = "opened",
  Queued = "queued",
  Rejected = "rejected",
  Sent = "sent",
  Unsubscribed = "unsubscribed"
}

/** Related data regarding an email */
export type EmailMessageData = {
  __typename?: "EmailMessageData"
  created_dtime?: Maybe<Scalars["DateTime"]["output"]>
  delivery_status?: Maybe<EmailDeliveryStatus>
  delivery_status_updated?: Maybe<Scalars["DateTime"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  message_id?: Maybe<Scalars["Int"]["output"]>
  recipient?: Maybe<Scalars["String"]["output"]>
  reject_reason?: Maybe<Scalars["String"]["output"]>
}

export type EquivalenceIdFilter = {
  eq?: InputMaybe<Scalars["ID"]["input"]>
  neq?: InputMaybe<Scalars["ID"]["input"]>
}

/** An SSO ExternalAccountLink */
export type ExternalAccountLink = {
  __typename?: "ExternalAccountLink"
  external_id?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  last_external_update?: Maybe<Scalars["DateTime"]["output"]>
  link_type?: Maybe<ExternalAccountType>
  linked_oidc_idp_id?: Maybe<Scalars["Int"]["output"]>
  linked_saml2_idp_id?: Maybe<Scalars["Int"]["output"]>
  user?: Maybe<User>
}

export enum ExternalAccountType {
  Generic = "generic",
  Oidc = "oidc",
  Saml2 = "saml2"
}

export enum FeatureAction {
  AuthLogin = "auth__login",
  HomeScreenView = "home_screen__view",
  UpdateVisibility = "update__visibility",
  View = "view"
}

export type FeatureContextInput = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
}

export enum FeatureKey {
  AuthLoginOptionEmailLink = "auth__login_option__email_link",
  AuthLoginOptionGlobalSsoApple = "auth__login_option__global_sso__apple",
  AuthLoginOptionGlobalSsoGoogle = "auth__login_option__global_sso__google",
  AuthLoginOptionPassword = "auth__login_option__password",
  AuthPlatform = "auth__platform",
  CohortActivityFeed = "cohort__activity_feed",
  CohortMemberDirectory = "cohort__member_directory",
  HomeScreenUnified = "home_screen__unified",
  LibraryCoverPages = "library__cover_pages",
  MediaDownloadableVideos = "media__downloadable_videos",
  PathsAppPublish = "paths_app__publish"
}

export type FeatureKeyFilter = {
  eq?: InputMaybe<FeatureKey>
  gt?: InputMaybe<FeatureKey>
  gte?: InputMaybe<FeatureKey>
  in?: InputMaybe<Array<InputMaybe<FeatureKey>>>
  lt?: InputMaybe<FeatureKey>
  lte?: InputMaybe<FeatureKey>
  neq?: InputMaybe<FeatureKey>
  nin?: InputMaybe<Array<InputMaybe<FeatureKey>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export enum FeaturePermission {
  AdminOnly = "admin_only",
  Disabled = "disabled",
  Everyone = "everyone",
  StaffOnly = "staff_only"
}

/** List of reviewers that have left a discussion, ordered by earliest response. */
export type FeedbackReviewers = {
  __typename?: "FeedbackReviewers"
  id?: Maybe<Scalars["Int"]["output"]>
  reviewers?: Maybe<Array<Maybe<Scalars["JSON"]["output"]>>>
}

/** Filestack keys */
export type FilestackInfo = {
  __typename?: "FilestackInfo"
  api_key?: Maybe<Scalars["String"]["output"]>
  policy?: Maybe<Scalars["String"]["output"]>
  signature?: Maybe<Scalars["String"]["output"]>
}

export type FirebaseConfig = {
  __typename?: "FirebaseConfig"
  apiKey: Scalars["String"]["output"]
  databaseURL: Scalars["String"]["output"]
  projectId: Scalars["String"]["output"]
  userToken?: Maybe<Scalars["String"]["output"]>
}

export type FirebaseIntegration = {
  __typename?: "FirebaseIntegration"
  auth_token?: Maybe<Scalars["String"]["output"]>
  client_api_key?: Maybe<Scalars["String"]["output"]>
  url?: Maybe<Scalars["String"]["output"]>
}

/** Gift subscription order data */
export type GiftSubscriptionOrderData = {
  gift_message?: InputMaybe<Scalars["String"]["input"]>
  num_cycles: Scalars["Int"]["input"]
  plan_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
  recipient_first_name: Scalars["String"]["input"]
  recipient_last_name: Scalars["String"]["input"]
}

/** A Gravatar profile. See https://en.gravatar.com/site/implement/profiles/ */
export type Gravatar = {
  __typename?: "Gravatar"
  /** The user's Gravatar Profile first name */
  first_name: Scalars["String"]["output"]
  /** The user's Gravatar Profile last name */
  last_name: Scalars["String"]["output"]
  meta: NodeMeta
}

/** A Pathwright Group */
export type Group = {
  __typename?: "Group"
  access_ended?: Maybe<Scalars["Boolean"]["output"]>
  access_ends?: Maybe<Scalars["DateTime"]["output"]>
  access_started?: Maybe<Scalars["Boolean"]["output"]>
  access_starts?: Maybe<Scalars["DateTime"]["output"]>
  analytics_disabled?: Maybe<Scalars["Boolean"]["output"]>
  created?: Maybe<Scalars["DateTime"]["output"]>
  created_by_id?: Maybe<Scalars["Int"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  discussion_enabled?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["Int"]["output"]
  include_in_plans?: Maybe<SchoolSubscriptionPlanConnection>
  include_with_products?: Maybe<StripeProductConnection>
  invite_urls?: Maybe<GroupInviteUrls>
  is_collection_linked?: Maybe<Scalars["Boolean"]["output"]>
  is_master?: Maybe<Scalars["Boolean"]["output"]>
  is_source_cohort?: Maybe<Scalars["Boolean"]["output"]>
  is_subscription_only?: Maybe<Scalars["Boolean"]["output"]>
  member_stats?: Maybe<GroupMemberStats>
  meta: NodeMeta
  name: Scalars["String"]["output"]
  parent?: Maybe<Group>
  parent_section_id?: Maybe<Scalars["Int"]["output"]>
  path: Path
  permissions?: Maybe<GroupPermissions>
  price?: Maybe<Scalars["Float"]["output"]>
  registration?: Maybe<Registration>
  registration_ended?: Maybe<Scalars["Boolean"]["output"]>
  registration_ends?: Maybe<Scalars["DateTime"]["output"]>
  registration_started?: Maybe<Scalars["Boolean"]["output"]>
  registration_starts?: Maybe<Scalars["DateTime"]["output"]>
  registrations?: Maybe<RegistrationConnection>
  resource?: Maybe<Resource>
  resource_id?: Maybe<Scalars["Int"]["output"]>
  resource_license?: Maybe<ResourceLicense>
  seats?: Maybe<Scalars["Int"]["output"]>
  seats_available?: Maybe<Scalars["Int"]["output"]>
  seats_filled?: Maybe<Scalars["Int"]["output"]>
  source?: Maybe<Group>
  source_cohort_id?: Maybe<Scalars["Int"]["output"]>
  stats?: Maybe<GroupStats>
  status: GroupStatus
  /** The current user's (or queried user's) registration in the parent cohort. */
  user_parent_registration?: Maybe<Registration>
  /** The current user (or queried user) registration in the cohort. */
  user_registration?: Maybe<Registration>
  /** The current user's (or queried user's) registration in the source cohort. */
  user_source_registration?: Maybe<Registration>
  visibility?: Maybe<Scalars["Int"]["output"]>
}

/** A Pathwright Group */
export type GroupInclude_In_PlansArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A Pathwright Group */
export type GroupInclude_With_ProductsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A Pathwright Group */
export type GroupPathArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<CurriculumType>
}

/** A Pathwright Group */
export type GroupRegistrationArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright Group */
export type GroupRegistrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  completion_state?: InputMaybe<CompletionStateFilter>
  created?: InputMaybe<DateFilter>
  first: Scalars["Int"]["input"]
  has_parent_registration?: InputMaybe<Scalars["Boolean"]["input"]>
  lastSeen?: InputMaybe<DateFilter>
  last_active?: InputMaybe<DateFilter>
  orderBy?: InputMaybe<Array<InputMaybe<RegistrationOrderByInput>>>
  parent_cohort_filter?: InputMaybe<IdFilter>
  positioningContext?: InputMaybe<PositioningContextInput>
  progress_filter?: InputMaybe<ProgressFilter>
  role?: InputMaybe<RegistrationRoleEnum>
  role_filter?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  send_discussion_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  send_due_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  softArchived?: InputMaybe<DateFilter>
}

/** A Pathwright Group */
export type GroupUser_Parent_RegistrationArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright Group */
export type GroupUser_RegistrationArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright Group */
export type GroupUser_Source_RegistrationArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A connection to a list of items. */
export type GroupConnection = {
  __typename?: "GroupConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GroupEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type GroupEdge = {
  __typename?: "GroupEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Group>
}

export type GroupInviteUrls = {
  __typename?: "GroupInviteUrls"
  editor?: Maybe<Scalars["String"]["output"]>
  moderator?: Maybe<Scalars["String"]["output"]>
  observer?: Maybe<Scalars["String"]["output"]>
  student?: Maybe<Scalars["String"]["output"]>
  teacher?: Maybe<Scalars["String"]["output"]>
  viewer?: Maybe<Scalars["String"]["output"]>
}

/** Group license order data */
export type GroupLicenseOrderData = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  license_offering_id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  role?: InputMaybe<RegistrationRoleEnum>
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
}

export type GroupMemberStats = {
  __typename?: "GroupMemberStats"
  send_discussion_notifications?: Maybe<Scalars["Int"]["output"]>
  staff?: Maybe<Scalars["Int"]["output"]>
  total?: Maybe<Scalars["Int"]["output"]>
}

export type GroupPermissions = {
  __typename?: "GroupPermissions"
  can_invite_editor?: Maybe<Scalars["Boolean"]["output"]>
  can_invite_moderator?: Maybe<Scalars["Boolean"]["output"]>
  can_invite_observer?: Maybe<Scalars["Boolean"]["output"]>
  can_invite_student?: Maybe<Scalars["Boolean"]["output"]>
  can_invite_teacher?: Maybe<Scalars["Boolean"]["output"]>
  can_make_public?: Maybe<Scalars["Boolean"]["output"]>
  can_publish?: Maybe<Scalars["Boolean"]["output"]>
}

export type GroupRoleStats = {
  __typename?: "GroupRoleStats"
  role?: Maybe<Scalars["Int"]["output"]>
  total?: Maybe<Scalars["Int"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
}

/** Whether user can use Group share UI. */
export type GroupShareAccess = {
  __typename?: "GroupShareAccess"
  /** A user's access level to share UI. */
  access?: Maybe<ShareAccessPermission>
  /** When share UI is gated, this will be the reason for why. */
  gated_reason?: Maybe<GroupShareAccessGatedReasonType>
}

export enum GroupShareAccessGatedReasonType {
  Placeholder = "PLACEHOLDER"
}

/** Whether user can use Group share > add UI. */
export type GroupShareAddAccess = {
  __typename?: "GroupShareAddAccess"
  /** A user's access level to share > add UI. */
  access?: Maybe<ShareAccessPermission>
  /** When share > add UI is gated, this will be the reason for why. */
  gated_reason?: Maybe<GroupShareAddAccessGatedReasonType>
}

export enum GroupShareAddAccessGatedReasonType {
  GroupSeatsFilled = "GROUP_SEATS_FILLED",
  GroupSubscriptionInactive = "GROUP_SUBSCRIPTION_INACTIVE"
}

/** Whether user can use Group share > link UI. */
export type GroupShareLinkAccess = {
  __typename?: "GroupShareLinkAccess"
  /** A user's access level to share > link UI. */
  access?: Maybe<ShareAccessPermission>
  /** When share > link UI is gated, this will be the reason for why. */
  gated_reason?: Maybe<GroupShareLinkAccessGatedReasonType>
}

export enum GroupShareLinkAccessGatedReasonType {
  GroupSeatsFilled = "GROUP_SEATS_FILLED",
  GroupSubscriptionInactive = "GROUP_SUBSCRIPTION_INACTIVE"
}

/** Whether user can use Group share > track UI. */
export type GroupShareTrackAccess = {
  __typename?: "GroupShareTrackAccess"
  /** A user's access level to share > track UI. */
  access?: Maybe<ShareAccessPermission>
  /** When share > track UI is gated, this will be the reason for why. */
  gated_reason?: Maybe<GroupShareTrackAccessGatedReasonType>
}

export enum GroupShareTrackAccessGatedReasonType {
  Placeholder = "PLACEHOLDER"
}

export type GroupStats = {
  __typename?: "GroupStats"
  completion?: Maybe<Scalars["Float"]["output"]>
  points?: Maybe<Scalars["Int"]["output"]>
  total_points?: Maybe<Scalars["Int"]["output"]>
}

export enum GroupStatus {
  /** The cohort has been completed */
  Completed = "completed",
  /** The cohort is in progress */
  InProgress = "in_progress"
}

/** Group subscription order data */
export type GroupSubscriptionOrderData = {
  group_name: Scalars["String"]["input"]
  price_id: Scalars["Int"]["input"]
  quantity: Scalars["Int"]["input"]
  redirect_to?: InputMaybe<Scalars["String"]["input"]>
}

export enum GroupType {
  /** The curriculum group */
  Curriculum = "curriculum"
}

export enum GroupVisibility {
  MembersOnly = "members_only",
  Private = "private",
  Public = "public"
}

export type GroupVisibilityFilter = {
  eq?: InputMaybe<GroupVisibility>
  gt?: InputMaybe<GroupVisibility>
  gte?: InputMaybe<GroupVisibility>
  in?: InputMaybe<Array<InputMaybe<GroupVisibility>>>
  lt?: InputMaybe<GroupVisibility>
  lte?: InputMaybe<GroupVisibility>
  neq?: InputMaybe<GroupVisibility>
  nin?: InputMaybe<Array<InputMaybe<GroupVisibility>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type IdFilter = {
  eq?: InputMaybe<Scalars["ID"]["input"]>
  gt?: InputMaybe<Scalars["ID"]["input"]>
  gte?: InputMaybe<Scalars["ID"]["input"]>
  in?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>
  lt?: InputMaybe<Scalars["ID"]["input"]>
  lte?: InputMaybe<Scalars["ID"]["input"]>
  neq?: InputMaybe<Scalars["ID"]["input"]>
  nin?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type ImageInput = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** Provides context data for the inbox. A group, cohort, or user. */
export type InboxContext = {
  __typename?: "InboxContext"
  /** A cohort of students */
  cohort?: Maybe<Group>
  /** A group of students */
  group?: Maybe<MentorGroup>
  id?: Maybe<Scalars["String"]["output"]>
}

/** A combo query of inbox groups */
export type InboxGroupConnection = {
  __typename?: "InboxGroupConnection"
  cohort?: Maybe<Group>
  mentor_group?: Maybe<MentorGroup>
}

/** A connection to a list of items. */
export type InboxGroupConnectionConnection = {
  __typename?: "InboxGroupConnectionConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InboxGroupConnectionEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type InboxGroupConnectionEdge = {
  __typename?: "InboxGroupConnectionEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<InboxGroupConnection>
}

/** A mentor group with reviewable items */
export type InboxMentorGroupConnection = {
  __typename?: "InboxMentorGroupConnection"
  group?: Maybe<MentorGroup>
  id?: Maybe<Scalars["Int"]["output"]>
  pending_review_count?: Maybe<Scalars["Int"]["output"]>
}

/** A path with reviewable items (pending_review_count) */
export type InboxPath = {
  __typename?: "InboxPath"
  group?: Maybe<Group>
  id?: Maybe<Scalars["Int"]["output"]>
  pending_review_count?: Maybe<Scalars["Int"]["output"]>
  registration?: Maybe<Registration>
  resource?: Maybe<Resource>
}

/** A connection to a list of items. */
export type InboxPathConnection = {
  __typename?: "InboxPathConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InboxPathEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type InboxPathEdge = {
  __typename?: "InboxPathEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<InboxPath>
}

/** A pending review count of reviewable items for target (InboxPendingReviewTarget) */
export type InboxPendingReview = {
  __typename?: "InboxPendingReview"
  count?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** A connection to a list of items. */
export type InboxPendingReviewConnection = {
  __typename?: "InboxPendingReviewConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InboxPendingReviewEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type InboxPendingReviewEdge = {
  __typename?: "InboxPendingReviewEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<InboxPendingReview>
}

export enum InboxPendingReviewTarget {
  Group = "group",
  Path = "path"
}

/** A count of completion items for people within a cohort or mentor group */
export type InboxPeopleCompletionCounts = {
  __typename?: "InboxPeopleCompletionCounts"
  count?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  user?: Maybe<User>
}

/** A connection to a list of items. */
export type InboxPeopleCompletionCountsConnection = {
  __typename?: "InboxPeopleCompletionCountsConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InboxPeopleCompletionCountsEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type InboxPeopleCompletionCountsEdge = {
  __typename?: "InboxPeopleCompletionCountsEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<InboxPeopleCompletionCounts>
}

export enum InboxPeopleCompletionCountsTarget {
  Cohort = "cohort",
  Group = "group"
}

/** A reviewer of a reviewable path item */
export type InboxReviewer = {
  __typename?: "InboxReviewer"
  can_review: Scalars["Boolean"]["output"]
  cohort_role?: Maybe<RegistrationRoleEnum>
  group_or_cohort_id: Scalars["Int"]["output"]
  group_role?: Maybe<MentorGroupMembershipRole>
  id: Scalars["Int"]["output"]
  user: User
}

/** A connection to a list of items. */
export type InboxReviewerConnection = {
  __typename?: "InboxReviewerConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InboxReviewerEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type InboxReviewerEdge = {
  __typename?: "InboxReviewerEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<InboxReviewer>
}

export type IntFilter = {
  eq?: InputMaybe<Scalars["Int"]["input"]>
  gt?: InputMaybe<Scalars["Int"]["input"]>
  gte?: InputMaybe<Scalars["Int"]["input"]>
  in?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  lt?: InputMaybe<Scalars["Int"]["input"]>
  lte?: InputMaybe<Scalars["Int"]["input"]>
  neq?: InputMaybe<Scalars["Int"]["input"]>
  nin?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type Integrations = {
  __typename?: "Integrations"
  firebase?: Maybe<FirebaseIntegration>
  intercom?: Maybe<IntercomIntegration>
}

export type IntercomIntegration = {
  __typename?: "IntercomIntegration"
  /** The Intercom app ID that will be used by the client. */
  app_id?: Maybe<Scalars["String"]["output"]>
  /** Pathwright's Intercom app ID. */
  pathwright_app_id?: Maybe<Scalars["String"]["output"]>
  /** Intercom access token, used for tracking events, only exposed to school admin. */
  school_access_token?: Maybe<Scalars["String"]["output"]>
  /** The school's Intercom app ID. */
  school_app_id?: Maybe<Scalars["String"]["output"]>
  /** Intercom secret key, used for Identification Verification, only exposed to school admin. */
  school_secret_key?: Maybe<Scalars["String"]["output"]>
  team?: Maybe<Array<IntercomTeamMember>>
  /** If an Intercom secret key is available, a user_hash will be generated for the current user which will be passed to Intercom for Identification Verification. */
  user_hash?: Maybe<Scalars["String"]["output"]>
}

export type IntercomTeamMember = {
  __typename?: "IntercomTeamMember"
  avatar?: Maybe<Scalars["String"]["output"]>
  email: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  job_title: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
}

export enum InterestLevel {
  High = "high",
  Low = "low",
  Medium = "medium"
}

/** An invitation for a user to join a school, an offering, or a community group as a given role. */
export type Invitation = {
  __typename?: "Invitation"
  community_group?: Maybe<MentorGroup>
  community_group_membership?: Maybe<MentorGroupMembership>
  created_dtime: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  invitation_accepted_dtime?: Maybe<Scalars["DateTime"]["output"]>
  invitation_email?: Maybe<EmailMessageData>
  invitation_hash?: Maybe<Scalars["String"]["output"]>
  invitation_message?: Maybe<Scalars["String"]["output"]>
  /** Specific to which type of invitation this is (see invitation_type) */
  invitation_role: Scalars["Int"]["output"]
  invitation_status: InvitationStatus
  invitation_subject?: Maybe<Scalars["String"]["output"]>
  /** Invitation to offering, school, or community group */
  invitation_type: InvitationType
  invitation_url: Scalars["String"]["output"]
  offering?: Maybe<Group>
  offering_registration?: Maybe<Registration>
  school: School
  school_membership?: Maybe<Membership>
  to_email: Scalars["String"]["output"]
  to_first_name?: Maybe<Scalars["String"]["output"]>
  to_last_name?: Maybe<Scalars["String"]["output"]>
  to_user?: Maybe<User>
}

/** A connection to a list of items. */
export type InvitationConnection = {
  __typename?: "InvitationConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InvitationEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

export type InvitationContext = {
  /** Scope invitations to cohort */
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  /** Scope invitations to community group */
  community_group_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** An edge in a connection. */
export type InvitationEdge = {
  __typename?: "InvitationEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Invitation>
}

export enum InvitationStatus {
  Accepted = "accepted",
  NotAccepted = "not_accepted"
}

/** The data embedded in an invitation token. */
export type InvitationToken = {
  __typename?: "InvitationToken"
  cohort?: Maybe<Group>
  group?: Maybe<MentorGroup>
  id: Scalars["String"]["output"]
  invite_type: InvitationType
  role: Scalars["Int"]["output"]
  sender?: Maybe<User>
}

export enum InvitationType {
  Cohort = "cohort",
  CommunityGroup = "community_group",
  School = "school"
}

/** Analytics data for a path or path item */
export type ItemAnalytics = {
  __typename?: "ItemAnalytics"
  avg_score?: Maybe<Scalars["Float"]["output"]>
  /** The number of users who have completed the whole path */
  complete?: Maybe<Scalars["Int"]["output"]>
  completion_rate?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  /** The number of users who still are working on this path */
  incomplete?: Maybe<Scalars["Int"]["output"]>
  item?: Maybe<PathItem>
  items?: Maybe<Scalars["JSON"]["output"]>
  /** The number of step completions in the path that need grading */
  need_feedback?: Maybe<Scalars["Int"]["output"]>
  next_count?: Maybe<Scalars["Int"]["output"]>
  path_id?: Maybe<Scalars["Int"]["output"]>
  /** This is a list of up to 10 users who have completed this path (used to render avatar stacks).  */
  students_here?: Maybe<Scalars["JSON"]["output"]>
  /** The number of earned points across all steps in this path (Note: this excludes steps that aren't due if due dates are in use) */
  total_points?: Maybe<Scalars["Int"]["output"]>
  /** The number of available points across all completed and past due student steps in this path */
  total_points_available?: Maybe<Scalars["Int"]["output"]>
  total_users?: Maybe<Scalars["Int"]["output"]>
}

/** A JSONWebToken. */
export type JsonWebToken = {
  __typename?: "JSONWebToken"
  token: Scalars["String"]["output"]
}

/** A resource license offering */
export type LicenseOffering = {
  __typename?: "LicenseOffering"
  /** @deprecated Deprecated in favor of `licensing_mode`. */
  allow_private_group_licensing?: Maybe<Scalars["Boolean"]["output"]>
  /** @deprecated Deprecated in favor of `licensing_mode`. */
  allow_school_licensing?: Maybe<Scalars["Boolean"]["output"]>
  cost_per_seat?: Maybe<Scalars["Float"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  include_creator_seat?: Maybe<Scalars["Boolean"]["output"]>
  include_in_curriculum_plans?: Maybe<SchoolCurriculumPlanConnection>
  include_in_school_curriculum_subscriptions?: Maybe<CurriculumSubscriptionConnection>
  include_in_subscription_plans?: Maybe<SchoolSubscriptionPlanConnection>
  included_in_user_subscription?: Maybe<Scalars["Boolean"]["output"]>
  licensing_mode?: Maybe<LicenseOfferingLicensingMode>
  licensor?: Maybe<School>
  minimum_license_duration?: Maybe<Scalars["Int"]["output"]>
  minimum_seat_count?: Maybe<Scalars["Int"]["output"]>
  minimum_seat_count_for_private_group_licensing?: Maybe<
    Scalars["Int"]["output"]
  >
  minimum_seat_count_for_school_licensing?: Maybe<Scalars["Int"]["output"]>
  register_creator_as?: Maybe<RegistrationRoleEnum>
  resource?: Maybe<Resource>
  school_license?: Maybe<ResourceLicense>
}

/** A resource license offering */
export type LicenseOfferingInclude_In_Curriculum_PlansArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A resource license offering */
export type LicenseOfferingInclude_In_School_Curriculum_SubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  licensee_id?: InputMaybe<IdFilter>
  licensor_id?: InputMaybe<IdFilter>
}

/** A resource license offering */
export type LicenseOfferingInclude_In_Subscription_PlansArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A resource license offering */
export type LicenseOfferingSchool_LicenseArgs = {
  licensee_school_id: Scalars["Int"]["input"]
}

/** A connection to a list of items. */
export type LicenseOfferingConnection = {
  __typename?: "LicenseOfferingConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LicenseOfferingEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type LicenseOfferingEdge = {
  __typename?: "LicenseOfferingEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<LicenseOffering>
}

export enum LicenseOfferingFor {
  /** This license is for private groups */
  PrivateGroup = "private_group",
  /** This license is for other schools */
  School = "school"
}

export enum LicenseOfferingLicensingMode {
  /** Resource: Group subscriptions */
  GroupSubscription = "group_subscription",
  /** Resource: Private cohorts */
  PrivateCohorts = "private_cohorts",
  /** Resource: School licensing */
  SchoolLicensing = "school_licensing"
}

export enum LicenseRoleEnum {
  Moderator = "moderator",
  Student = "student",
  Teacher = "teacher"
}

/** A Licensee School */
export type LicenseeSchool = {
  __typename?: "LicenseeSchool"
  about?: Maybe<Scalars["String"]["output"]>
  created?: Maybe<Scalars["DateTime"]["output"]>
  currency_code?: Maybe<Scalars["String"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  ietf_language_tag?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  subdomain?: Maybe<Scalars["String"]["output"]>
  website?: Maybe<Scalars["String"]["output"]>
}

/** Lifetime school subscription order data */
export type LifetimeSchoolSubscriptionOrderData = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  plan_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
}

export type ListOrderInput = {
  id: Scalars["Int"]["input"]
  order: Scalars["Int"]["input"]
}

/** Info about a user's login options */
export type LoginInfo = {
  __typename?: "LoginInfo"
  auth_url?: Maybe<Scalars["String"]["output"]>
  is_external?: Maybe<Scalars["Boolean"]["output"]>
  primary_color?: Maybe<Scalars["String"]["output"]>
  prompt?: Maybe<Scalars["String"]["output"]>
}

/** Not-CSS Media Queries */
export type Media = {
  __typename?: "Media"
  filestack?: Maybe<FilestackInfo>
  image?: Maybe<Scalars["String"]["output"]>
}

/** Not-CSS Media Queries */
export type MediaImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  url: Scalars["String"]["input"]
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** Contextual data needed for the Media Manager */
export type MediaContext = {
  __typename?: "MediaContext"
  accountID?: Maybe<Scalars["String"]["output"]>
  mediaStoragePath?: Maybe<Scalars["String"]["output"]>
  user?: Maybe<User>
}

/** A Pathwright User's Membership to a School */
export type Membership = {
  __typename?: "Membership"
  access_revoked_time?: Maybe<Scalars["DateTime"]["output"]>
  archived_time?: Maybe<Scalars["DateTime"]["output"]>
  consent_dtime?: Maybe<Scalars["DateTime"]["output"]>
  consent_snapshot?: Maybe<Scalars["String"]["output"]>
  created: Scalars["DateTime"]["output"]
  has_access: Scalars["Boolean"]["output"]
  id: Scalars["Int"]["output"]
  last_active?: Maybe<Scalars["DateTime"]["output"]>
  last_seen?: Maybe<Scalars["DateTime"]["output"]>
  role: Scalars["Int"]["output"]
  school: School
  school_id: Scalars["Int"]["output"]
  user: User
}

/** A connection to a list of items. */
export type MembershipConnection = {
  __typename?: "MembershipConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MembershipEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type MembershipEdge = {
  __typename?: "MembershipEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Membership>
}

export type MembershipMeta = {
  __typename?: "MembershipMeta"
  editor?: Maybe<Scalars["Int"]["output"]>
  lead_mentor?: Maybe<Scalars["Int"]["output"]>
  learner?: Maybe<Scalars["Int"]["output"]>
  mentor?: Maybe<Scalars["Int"]["output"]>
  moderator?: Maybe<Scalars["Int"]["output"]>
  observer?: Maybe<Scalars["Int"]["output"]>
  teacher?: Maybe<Scalars["Int"]["output"]>
}

export enum MembershipRole {
  Administrator = "administrator",
  Editor = "editor",
  Facilitator = "facilitator",
  Student = "student"
}

export type MembershipRoleFilter = {
  eq?: InputMaybe<MembershipRole>
  gt?: InputMaybe<MembershipRole>
  gte?: InputMaybe<MembershipRole>
  in?: InputMaybe<Array<InputMaybe<MembershipRole>>>
  lt?: InputMaybe<MembershipRole>
  lte?: InputMaybe<MembershipRole>
  neq?: InputMaybe<MembershipRole>
  nin?: InputMaybe<Array<InputMaybe<MembershipRole>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type MembershipStats = {
  __typename?: "MembershipStats"
  /** Active within the last 30 days */
  active?: Maybe<Scalars["Int"]["output"]>
  has_access?: Maybe<Scalars["Int"]["output"]>
  /** Inactive for over 60 days */
  inactive?: Maybe<Scalars["Int"]["output"]>
  no_access?: Maybe<Scalars["Int"]["output"]>
  /** Inactive within the last 60 days  */
  slipping?: Maybe<Scalars["Int"]["output"]>
  total?: Maybe<Scalars["Int"]["output"]>
}

export type MentorGroup = {
  __typename?: "MentorGroup"
  child_groups?: Maybe<MentorGroupConnection>
  created?: Maybe<Scalars["DateTime"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  flattened_child_groups?: Maybe<MentorGroupConnection>
  group_subscription?: Maybe<SchoolGroupSubscription>
  group_subscriptions?: Maybe<SchoolGroupSubscriptionConnection>
  has_child_groups?: Maybe<Scalars["Boolean"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  invitations?: Maybe<InvitationConnection>
  memberships?: Maybe<MentorGroupMembershipConnection>
  modified?: Maybe<Scalars["DateTime"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  owner?: Maybe<User>
  parent?: Maybe<MentorGroup>
  parent_id?: Maybe<Scalars["Int"]["output"]>
  permissions?: Maybe<MentorGroupPermissions>
  school?: Maybe<School>
  seat_limit?: Maybe<Scalars["Int"]["output"]>
  seats_available?: Maybe<Scalars["Int"]["output"]>
  seats_filled?: Maybe<Scalars["Int"]["output"]>
  slug?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["Int"]["output"]>
  user_membership?: Maybe<MentorGroupMembership>
}

export type MentorGroupChild_GroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  descendant_of_parent_id?: InputMaybe<EquivalenceIdFilter>
  first: Scalars["Int"]["input"]
  id?: InputMaybe<IdFilter>
  parent_id?: InputMaybe<IdFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  seat_limit?: InputMaybe<Scalars["Int"]["input"]>
  seat_limit_filter?: InputMaybe<IntFilter>
  top_level_only?: InputMaybe<Scalars["Boolean"]["input"]>
  type?: InputMaybe<MentorGroupType>
}

export type MentorGroupFlattened_Child_GroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  descendant_of_parent_id?: InputMaybe<EquivalenceIdFilter>
  first: Scalars["Int"]["input"]
  id?: InputMaybe<IdFilter>
  parent_id?: InputMaybe<IdFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  seat_limit?: InputMaybe<Scalars["Int"]["input"]>
  seat_limit_filter?: InputMaybe<IntFilter>
  top_level_only?: InputMaybe<Scalars["Boolean"]["input"]>
  type?: InputMaybe<MentorGroupType>
}

export type MentorGroupGroup_SubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

export type MentorGroupInvitationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context?: InputMaybe<InvitationContext>
  delivery_status?: InputMaybe<EmailDeliveryStatus>
  first: Scalars["Int"]["input"]
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  search?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<InvitationStatus>
  type?: InputMaybe<InvitationType>
}

export type MentorGroupMembershipsArgs = {
  _or?: InputMaybe<MentorGroupMembershipOr>
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  group_type?: InputMaybe<MentorGroupType>
  group_types?: InputMaybe<MentorGroupTypeFilter>
  mentor_group_seat_limit?: InputMaybe<Scalars["Int"]["input"]>
  mentor_group_seat_limit_filter?: InputMaybe<IntFilter>
  mentor_group_seats_filled?: InputMaybe<Scalars["Int"]["input"]>
  mentor_group_seats_filled_filter?: InputMaybe<IntFilter>
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  role?: InputMaybe<MentorGroupMembershipRoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** A connection to a list of items. */
export type MentorGroupConnection = {
  __typename?: "MentorGroupConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MentorGroupEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type MentorGroupEdge = {
  __typename?: "MentorGroupEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<MentorGroup>
}

export type MentorGroupMembership = {
  __typename?: "MentorGroupMembership"
  access_revoked_time?: Maybe<Scalars["DateTime"]["output"]>
  can_review: Scalars["Boolean"]["output"]
  created: Scalars["DateTime"]["output"]
  group: MentorGroup
  group_id: Scalars["Int"]["output"]
  id: Scalars["Int"]["output"]
  role: Scalars["Int"]["output"]
  school: School
  send_mentor_digest?: Maybe<Scalars["Boolean"]["output"]>
  user: User
}

/** A connection to a list of items. */
export type MentorGroupMembershipConnection = {
  __typename?: "MentorGroupMembershipConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MentorGroupMembershipEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type MentorGroupMembershipEdge = {
  __typename?: "MentorGroupMembershipEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<MentorGroupMembership>
}

export type MentorGroupMembershipOr = {
  group_type?: InputMaybe<MentorGroupType>
  group_types?: InputMaybe<MentorGroupTypeFilter>
  mentor_group_seat_limit?: InputMaybe<Scalars["Int"]["input"]>
  mentor_group_seat_limit_filter?: InputMaybe<IntFilter>
  mentor_group_seats_filled?: InputMaybe<Scalars["Int"]["input"]>
  mentor_group_seats_filled_filter?: InputMaybe<IntFilter>
  role?: InputMaybe<MentorGroupMembershipRoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
}

export enum MentorGroupMembershipRole {
  Admin = "admin",
  Member = "member",
  Moderator = "moderator"
}

export type MentorGroupMembershipRoleFilter = {
  eq?: InputMaybe<MentorGroupMembershipRole>
  gt?: InputMaybe<MentorGroupMembershipRole>
  gte?: InputMaybe<MentorGroupMembershipRole>
  in?: InputMaybe<Array<InputMaybe<MentorGroupMembershipRole>>>
  lt?: InputMaybe<MentorGroupMembershipRole>
  lte?: InputMaybe<MentorGroupMembershipRole>
  neq?: InputMaybe<MentorGroupMembershipRole>
  nin?: InputMaybe<Array<InputMaybe<MentorGroupMembershipRole>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type MentorGroupPermissions = {
  __typename?: "MentorGroupPermissions"
  can_add_admin?: Maybe<Scalars["Boolean"]["output"]>
  can_add_group?: Maybe<Scalars["Boolean"]["output"]>
  can_add_member?: Maybe<Scalars["Boolean"]["output"]>
  can_add_moderator?: Maybe<Scalars["Boolean"]["output"]>
  can_change_parent?: Maybe<Scalars["Boolean"]["output"]>
  can_delete_group?: Maybe<Scalars["Boolean"]["output"]>
  can_edit_group?: Maybe<Scalars["Boolean"]["output"]>
  can_edit_subscription?: Maybe<Scalars["Boolean"]["output"]>
  can_update_admin_review_permission?: Maybe<Scalars["Boolean"]["output"]>
  can_update_member_review_permission?: Maybe<Scalars["Boolean"]["output"]>
  can_update_moderator_review_permission?: Maybe<Scalars["Boolean"]["output"]>
}

export type MentorGroupStats = {
  __typename?: "MentorGroupStats"
  community?: Maybe<Scalars["Int"]["output"]>
  group_subscription?: Maybe<Scalars["Int"]["output"]>
  personal?: Maybe<Scalars["Int"]["output"]>
  total?: Maybe<Scalars["Int"]["output"]>
}

export enum MentorGroupType {
  Community = "community",
  GroupSubscription = "group_subscription",
  Personal = "personal"
}

export type MentorGroupTypeFilter = {
  eq?: InputMaybe<MentorGroupType>
  gt?: InputMaybe<MentorGroupType>
  gte?: InputMaybe<MentorGroupType>
  in?: InputMaybe<Array<InputMaybe<MentorGroupType>>>
  lt?: InputMaybe<MentorGroupType>
  lte?: InputMaybe<MentorGroupType>
  neq?: InputMaybe<MentorGroupType>
  nin?: InputMaybe<Array<InputMaybe<MentorGroupType>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

/** A scheduled message */
export type Message = {
  __typename?: "Message"
  based_on_step_date?: Maybe<MessageStepDateField>
  body?: Maybe<Scalars["String"]["output"]>
  channels?: Maybe<Array<Maybe<MessageChannel>>>
  id?: Maybe<Scalars["Int"]["output"]>
  is_active?: Maybe<Scalars["Boolean"]["output"]>
  path_id?: Maybe<Scalars["Int"]["output"]>
  recipient_filter?: Maybe<MessageRecipientFilter>
  send_date?: Maybe<Scalars["DateTime"]["output"]>
  sent_date?: Maybe<Scalars["DateTime"]["output"]>
  step_source_id?: Maybe<Scalars["Int"]["output"]>
  subject?: Maybe<Scalars["String"]["output"]>
  threshold_minutes?: Maybe<Scalars["Int"]["output"]>
  type?: Maybe<MessageType>
}

export enum MessageChannel {
  Email = "email",
  Notification = "notification"
}

/** A connection to a list of items. */
export type MessageConnection = {
  __typename?: "MessageConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MessageEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

export type MessageContext = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  source_id: Scalars["Int"]["input"]
}

/** An edge in a connection. */
export type MessageEdge = {
  __typename?: "MessageEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Message>
}

export type MessageInput = {
  based_on_step_date?: InputMaybe<MessageStepDateField>
  body: Scalars["String"]["input"]
  channels: Array<InputMaybe<MessageChannel>>
  recipient_filter?: InputMaybe<MessageRecipientFilter>
  subject: Scalars["String"]["input"]
  threshold_minutes: Scalars["Int"]["input"]
  type: MessageType
}

export enum MessageRecipientFilter {
  /** All learners */
  All = "all",
  /** Learners with completed steps */
  StepComplete = "step_complete",
  /** Learners with incomplete steps */
  StepIncomplete = "step_incomplete"
}

export enum MessageStepDateField {
  Due = "due",
  Starts = "starts"
}

export enum MessageType {
  Reminder = "reminder"
}

export type MessageTypeFilter = {
  eq?: InputMaybe<MessageType>
  gt?: InputMaybe<MessageType>
  gte?: InputMaybe<MessageType>
  in?: InputMaybe<Array<InputMaybe<MessageType>>>
  lt?: InputMaybe<MessageType>
  lte?: InputMaybe<MessageType>
  neq?: InputMaybe<MessageType>
  nin?: InputMaybe<Array<InputMaybe<MessageType>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type Mutations = {
  __typename?: "Mutations"
  /** Accepts a community group invitation */
  acceptCommunityGroupInvitation?: Maybe<Scalars["Boolean"]["output"]>
  /** Add people to group or cohort */
  addPeopleTo?: Maybe<BackgroundTask>
  apiCompletionUpdate?: Maybe<ApiCompletionUpdate>
  /** Creates a registration for the user */
  assign?: Maybe<Scalars["JSON"]["output"]>
  /** Creates multiple new mentor group memberships */
  batchCreateMentorGroupMembership?: Maybe<BatchMentorGroupMembershipResult>
  /** Cancels a new subscription for the user. */
  cancelSchoolSubscription?: Maybe<SchoolSubscription>
  /** Changes a user's password */
  changePassword?: Maybe<Scalars["Boolean"]["output"]>
  /** Marks a path item as completed */
  completePathItem?: Maybe<PathItem>
  /** Allows a user to attempt to confirm an AuthRequest */
  confirmAuthRequest?: Maybe<AuthRequest>
  /** Copies an existing resource */
  copyResource?: Maybe<Resource>
  /** Creat a banner */
  createBanner?: Maybe<Banner>
  /** Creates Blocks (DB) content */
  createBlocksContent?: Maybe<BlocksContent>
  /** Creates a certificate for a school */
  createCertificate?: Maybe<Certificate>
  /** Creates a contextualFeaturePermission for a given context */
  createContextualFeaturePermission?: Maybe<ContextualFeaturePermission>
  /** Create a curriculum license order */
  createCurriculumLicenseOrder?: Maybe<Order>
  /** Create a curriculum subscription order */
  createCurriculumSubscriptionOrder?: Maybe<Order>
  createDiscussion?: Maybe<Discussion>
  createDiscussionLike?: Maybe<Discussion>
  createDiscussionResponse?: Maybe<Response>
  createDiscussionResponseLike?: Maybe<Response>
  createDiscussionSubscription?: Maybe<Discussion>
  /** Creates an external account link for a user in a school, associating them with an external ID. */
  createExternalAccountLink?: Maybe<ExternalAccountLink>
  /** Create a gift subscription order */
  createGiftSubscriptionOrder?: Maybe<Order>
  /** Creates a new cohort for a resource */
  createGroup?: Maybe<Group>
  /** Create a group license order */
  createGroupLicenseOrder?: Maybe<Order>
  /** Create a group subscription order */
  createGroupSubscriptionOrder?: Maybe<Order>
  /** Creates invitations for the given invite emails */
  createInvitations?: Maybe<CreateInvitationsSuccess>
  /** Create a lifetime school subscription order */
  createLifetimeSchoolSubscriptionOrder?: Maybe<Order>
  /** Creates a school membership for a user who already has an account on Pathwright, but is not yet a member of the school. Allowed only for schools who have API access enabled. */
  createMembershipForExistingUser?: Maybe<Membership>
  /** Creates a new mentor group */
  createMentorGroup?: Maybe<MentorGroup>
  /** Creates a new mentor group membership */
  createMentorGroupMembership?: Maybe<MentorGroupMembership>
  /** Creates a message. */
  createMessage?: Maybe<Message>
  /** Create an order. Only one order may be created at a time. */
  createOrder?: Maybe<Order>
  /** Create a page. */
  createPage?: Maybe<Page>
  /** Creates a user's password, only in cases where a user does not already have a password. */
  createPassword?: Maybe<Scalars["Boolean"]["output"]>
  /** creates a path divider, lesson, step, or resource. */
  createPathItem?: Maybe<PathItem>
  /** Create a platform subscription order */
  createPlatformSubscriptionOrder?: Maybe<Order>
  /** Create a registration order */
  createRegistrationOrder?: Maybe<Order>
  /** Potentially creates a new cohort within a Collection (if a cohort does not already exist for the for the provided resource_id). Optionally registers the user to that cohort. */
  createRegistrationUpsertGroup?: Maybe<Group>
  /** Creates a new resource */
  createResource?: Maybe<Resource>
  /** Create a school with a name and domain. Returns the school if successful. */
  createSchool?: Maybe<School>
  /** Create a school subscription order */
  createSchoolSubscriptionOrder?: Maybe<Order>
  /** Create a school theme. */
  createSchoolTheme?: Maybe<Theme>
  /** Creates a store link for a school. */
  createStoreLink?: Maybe<StoreLink>
  /** Create a storefront */
  createStorefront?: Maybe<Storefront>
  /** Creates a new, unattached tag. */
  createTag?: Maybe<Tag>
  /** Creates a new tagAttachment. */
  createTagAttachment?: Maybe<TagAttachment>
  /** Creates a new tagAttachment. */
  createTagLink?: Maybe<TagLink>
  /** Creates a new translation */
  createTranslation?: Maybe<Translation>
  /** Either defer or execute a copy config. */
  deferOrExecuteResourceCopyConfig?: Maybe<DeferOrExecuteResourceCopyConfigResult>
  /** Creat a banner */
  deleteBanner?: Maybe<Scalars["Boolean"]["output"]>
  /** Archives a certificate */
  deleteCertificate?: Maybe<Scalars["Boolean"]["output"]>
  /** Permanently deletes a contextualFeaturePermission */
  deleteContextualFeaturePermission?: Maybe<Scalars["Boolean"]["output"]>
  deleteDiscussion?: Maybe<Scalars["Boolean"]["output"]>
  deleteDiscussionLike?: Maybe<Discussion>
  deleteDiscussionResponse?: Maybe<Scalars["Boolean"]["output"]>
  deleteDiscussionResponseLike?: Maybe<Scalars["Boolean"]["output"]>
  deleteDiscussionSubscription?: Maybe<Discussion>
  /** Deletes an invitation */
  deleteInvitation?: Maybe<Scalars["Boolean"]["output"]>
  /** Deletes a mentor group */
  deleteMentorGroup?: Maybe<Scalars["Boolean"]["output"]>
  /** Deletes a mentor group membership */
  deleteMentorGroupMembership?: Maybe<Scalars["Boolean"]["output"]>
  /** Deletes a message. */
  deleteMessage?: Maybe<Scalars["Boolean"]["output"]>
  /** deletes a path item */
  deletePathItem?: Maybe<PathItem>
  /** Deletes a positioning context and all related positioning objects. */
  deletePositioningContext?: Maybe<Scalars["Boolean"]["output"]>
  /** (Currently) permanently deletes a user's registration and all child registrations (in the case of Collections). */
  deleteRegistration?: Maybe<Scalars["Boolean"]["output"]>
  /** Delete a given copy config link. This performs a HARD delete, and will not be recoverable. Only available to superusers. */
  deleteResourceCopyConfigLink?: Maybe<Scalars["String"]["output"]>
  /** Deletes an existing tag. */
  deleteTag?: Maybe<Scalars["Boolean"]["output"]>
  /** Deletes an existing tagAttachment, permanently. */
  deleteTagAttachment?: Maybe<Scalars["Boolean"]["output"]>
  /** Deletes an existing tagAttachment, permanently. */
  deleteTagLink?: Maybe<Scalars["Boolean"]["output"]>
  /** Hard delete a WebhookEvent. */
  deleteWebhookEvent?: Maybe<Scalars["Boolean"]["output"]>
  /** Complete a deferred copy config by executing a copy config link. */
  executeDeferredResourceCopyConfig?: Maybe<DeferOrExecuteResourceCopyConfigResult>
  executePathSyncPlan?: Maybe<Scalars["Boolean"]["output"]>
  /** Updates user with require first_name and last_name fields, plus creates school membership and fulfills any pending orders. */
  finalizeAccount?: Maybe<User>
  /** Finalizes an external account link for a user in a school, associating them with an external ID after they complete the account linking process. */
  finalizeExternalAccountLink?: Maybe<ExternalAccountLink>
  /** Get a token with a username/email and password. Returns an auth token if successful. */
  getToken?: Maybe<Token>
  /** Get a token with a sso token. Returns an auth token if successful. */
  getTokenViaSSO?: Maybe<Token>
  /** Update the last time this user was active */
  heartbeat?: Maybe<Scalars["Boolean"]["output"]>
  /** Handles recording consent for a user-space membership, and creating that membership */
  joinSpace?: Maybe<Membership>
  /** Creates a new license for a resource */
  licenseResource?: Maybe<ResourceLicense>
  /** Pastes a path step or lesson from to the given path and location. */
  pastePathItem?: Maybe<PathItem>
  publishPath?: Maybe<Path>
  /** Allows for updating the Space's Pathwright authentication settings. */
  publishPathToCodex?: Maybe<CodexPathPublish>
  /** Rdeems a subscription for the user. */
  redeemSchoolGiftSubscription?: Maybe<SchoolSubscription>
  /** Issues a new token to the currrent user */
  refreshToken?: Maybe<Scalars["String"]["output"]>
  /** Register a push token for user. */
  registerPushToken?: Maybe<Scalars["Boolean"]["output"]>
  /** Revokes access for all members inactive for the the last x days */
  removeAccessForInactiveMembers?: Maybe<Scalars["Boolean"]["output"]>
  /** Remove a push token for user. */
  removePushToken?: Maybe<Scalars["Boolean"]["output"]>
  /** reorders two or more path items */
  reorderPathItems?: Maybe<Scalars["Boolean"]["output"]>
  /** Requests a password reset for a user (admin only) */
  requestPasswordReset?: Maybe<Scalars["Boolean"]["output"]>
  /** Resend an invitation email */
  resendInvitation?: Maybe<Invitation>
  resetCompletionFeedback?: Maybe<Completion>
  /** Resets a user's password based on a valid reset hash token (sent as part of a password reset email link) */
  resetPassword?: Maybe<Scalars["Boolean"]["output"]>
  /** Resets a previously completed or skipped path item */
  resetPathItem?: Maybe<PathItem>
  /** Resets a path item for a user */
  resetPathItemForUser?: Maybe<PathItem>
  saveCompletionFeedback?: Maybe<Completion>
  /** Schedules path item. */
  scheduleItem?: Maybe<PathItem>
  /** Sends email with gifted subscription details to gift recipient. */
  sendGiftSubscriptionEmail?: Maybe<Scalars["Boolean"]["output"]>
  /** Sets the member's access to the school */
  setMemberAccess?: Maybe<Membership>
  /** Archives/unarchives the user's membership to the school */
  setMemberArchived?: Maybe<Membership>
  /** Sets the member's role within the school */
  setMemberRole?: Maybe<Membership>
  /** Show/hide a given copy config link. */
  showHideResourceCopyConfigLink?: Maybe<ResourceCopyConfigLink>
  /** Sign out the current user */
  signOut?: Maybe<Scalars["Boolean"]["output"]>
  /** Sign up with an email and password. Returns the user if successful. */
  signUp?: Maybe<Token>
  /** Skips a path item for a user */
  skipPathItemForUser?: Maybe<PathItem>
  /** Soft archives a registration. */
  softArchiveRegistration?: Maybe<Registration>
  /** Allows a user to start a request to authenticate to their account outside normal username/password authentication. */
  startAuthRequest?: Maybe<AuthRequest>
  /** Sends a password reset email for a user  */
  startPasswordRetrieval?: Maybe<Scalars["Boolean"]["output"]>
  syncPath?: Maybe<Path>
  /** Unarchives a path item and any related archived data. */
  unarchivePathItem?: Maybe<PathItem>
  /** Unlockss a path item with a password lock */
  unlockPathItem?: Maybe<PathItem>
  /** Update a banner */
  updateBanner?: Maybe<Banner>
  /** Update a banner's order */
  updateBannerOrder?: Maybe<Scalars["Boolean"]["output"]>
  /** Updates Blocks (DB) content with published metadata */
  updateBlocksContent?: Maybe<BlocksContent>
  /** Updates a certificate */
  updateCertificate?: Maybe<Certificate>
  /** Updates the certificate_json keys of all resources */
  updateCertificateVariables?: Maybe<CertificateVariables>
  /** Creates a new contextualFeaturePermission */
  updateContextualFeaturePermission?: Maybe<ContextualFeaturePermission>
  updateDiscussion?: Maybe<Discussion>
  updateDiscussionResponse?: Maybe<Response>
  /** Creates a new cohort for a resource */
  updateGroup?: Maybe<Group>
  updateGroupDiscussionEnabled?: Maybe<Group>
  updateGroupStatus?: Maybe<Group>
  /** Updates an local translation files, used only in development of the Pathwright platform. */
  updateLocalTranslation?: Maybe<Scalars["JSON"]["output"]>
  /** Sets the member's profile data */
  updateMemberConsent?: Maybe<Membership>
  /** Updates an existing mentor group */
  updateMentorGroup?: Maybe<MentorGroup>
  /** Updates a mentor group membership */
  updateMentorGroupMembership?: Maybe<MentorGroupMembership>
  /** Updates a message. */
  updateMessage?: Maybe<Message>
  /** Update a user's notifciation digest interval. */
  updateNotificationDigestInterval?: Maybe<Profile>
  /** Update a page. */
  updatePage?: Maybe<Page>
  /** Update page orders. */
  updatePageOrders?: Maybe<Scalars["Boolean"]["output"]>
  /** updates a path item */
  updatePathItem?: Maybe<PathItem>
  /** Allows for updating the Space's Pathwright authentication settings. */
  updatePathwrightAuth?: Maybe<Space>
  /** Creates or updates the existing positioning objects for a given context. */
  updatePositionedObjects?: Maybe<Scalars["JSON"]["output"]>
  /** Updates the referral code for the current user */
  updateReferral?: Maybe<Referral>
  /** Updates a registration */
  updateRegistration?: Maybe<Registration>
  /** Updates an existing resource */
  updateResource?: Maybe<Resource>
  /** Update fields on the school */
  updateSchool?: Maybe<School>
  /** Processes and updates the custom CSS for a school */
  updateSchoolCustomCSS?: Maybe<Theme>
  /** Create a school with a name and domain. Returns the school if successful. */
  updateSchoolProfile?: Maybe<SchoolProfile>
  /** Create a school theme. */
  updateSchoolTheme?: Maybe<Theme>
  /** Updates an existing tag. */
  updateTag?: Maybe<Tag>
  /** Updates a new tagAttachment. Currently only updates the position of the tagAttachment. */
  updateTagAttachment?: Maybe<TagAttachment>
  /** Updates an existing translation */
  updateTranslation?: Maybe<Translation>
  /** Update user and user profile settings. */
  updateUser?: Maybe<User>
  updateUserDiscussionHistory?: Maybe<Discussion>
}

export type MutationsAcceptCommunityGroupInvitationArgs = {
  token: Scalars["String"]["input"]
}

export type MutationsAddPeopleToArgs = {
  notification_message?: InputMaybe<Scalars["String"]["input"]>
  selection: Array<InputMaybe<AddPeopleSelection>>
  send_from_school?: InputMaybe<Scalars["Boolean"]["input"]>
  send_notification?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsApiCompletionUpdateArgs = {
  action: ApiCompletionUpdateAction
  assign_points?: InputMaybe<Scalars["Float"]["input"]>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  step_source_id: Scalars["Int"]["input"]
  user_email?: InputMaybe<Scalars["String"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsAssignArgs = {
  assign_to_user: Scalars["Int"]["input"]
  assignment_message?: InputMaybe<Scalars["String"]["input"]>
  offerings: Array<InputMaybe<Scalars["Int"]["input"]>>
  role: RegistrationRoleEnum
  send_from_school?: InputMaybe<Scalars["Boolean"]["input"]>
  send_notification?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsBatchCreateMentorGroupMembershipArgs = {
  group: Scalars["Int"]["input"]
  role: MentorGroupMembershipRole
  user_ids?: InputMaybe<Array<Scalars["Int"]["input"]>>
}

export type MutationsCancelSchoolSubscriptionArgs = {
  cancel_immediately?: InputMaybe<Scalars["Boolean"]["input"]>
  for_user?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsChangePasswordArgs = {
  current_password: Scalars["String"]["input"]
  password1: Scalars["String"]["input"]
  password2: Scalars["String"]["input"]
}

export type MutationsCompletePathItemArgs = {
  completion_data?: InputMaybe<Scalars["JSON"]["input"]>
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
  skip?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsConfirmAuthRequestArgs = {
  key: Scalars["String"]["input"]
  uuid: Scalars["UUID"]["input"]
}

export type MutationsCopyResourceArgs = {
  create_offering?: InputMaybe<Scalars["Boolean"]["input"]>
  create_registration_with_role?: InputMaybe<RegistrationRoleEnum>
  id: Scalars["Int"]["input"]
  to_school?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsCreateBannerArgs = {
  background_image?: InputMaybe<Scalars["String"]["input"]>
  background_image_raw?: InputMaybe<Scalars["String"]["input"]>
  background_overlay?: InputMaybe<Scalars["String"]["input"]>
  background_type?: InputMaybe<Scalars["Int"]["input"]>
  button_func?: InputMaybe<Scalars["String"]["input"]>
  button_text?: InputMaybe<Scalars["String"]["input"]>
  button_url?: InputMaybe<Scalars["String"]["input"]>
  font_color?: InputMaybe<Scalars["String"]["input"]>
  heading?: InputMaybe<Scalars["String"]["input"]>
  hide_for_products?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  hide_for_subscription_plans?: InputMaybe<
    Array<InputMaybe<Scalars["Int"]["input"]>>
  >
  is_visible?: InputMaybe<Scalars["Boolean"]["input"]>
  show_for_products?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  show_for_subscription_plans?: InputMaybe<
    Array<InputMaybe<Scalars["Int"]["input"]>>
  >
  subhead?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsCreateBlocksContentArgs = {
  content_last_modified?: InputMaybe<Scalars["DateTime"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsCreateCertificateArgs = {
  is_active?: InputMaybe<Scalars["Boolean"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  template: Scalars["String"]["input"]
  text_objects?: InputMaybe<Array<InputMaybe<TextObject>>>
}

export type MutationsCreateContextualFeaturePermissionArgs = {
  context?: InputMaybe<FeatureContextInput>
  feature_action: FeatureAction
  feature_key: FeatureKey
  permission_in_context: FeaturePermission
}

export type MutationsCreateCurriculumLicenseOrderArgs = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  license_offering_id: Scalars["Int"]["input"]
  licensee_school_id: Scalars["Int"]["input"]
  licensor_school_id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  role?: InputMaybe<RegistrationRoleEnum>
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsCreateCurriculumSubscriptionOrderArgs = {
  curriculum_plan_id: Scalars["Int"]["input"]
  licensee_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsCreateDiscussionArgs = {
  context: DiscussionContextInput
  initialResponse?: InputMaybe<DiscussionResponseInput>
  notify?: InputMaybe<Scalars["Boolean"]["input"]>
  post: DiscussionPostInput
}

export type MutationsCreateDiscussionLikeArgs = {
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}

export type MutationsCreateDiscussionResponseArgs = {
  context: DiscussionContextInput
  response: DiscussionResponseInput
}

export type MutationsCreateDiscussionResponseLikeArgs = {
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
  response_id: Scalars["Int"]["input"]
}

export type MutationsCreateDiscussionSubscriptionArgs = {
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}

export type MutationsCreateExternalAccountLinkArgs = {
  external_id: Scalars["String"]["input"]
  link_type?: InputMaybe<ExternalAccountType>
  linked_oidc_idp_id?: InputMaybe<Scalars["Int"]["input"]>
  linked_saml2_idp_id?: InputMaybe<Scalars["Int"]["input"]>
  user_id: Scalars["Int"]["input"]
}

export type MutationsCreateGiftSubscriptionOrderArgs = {
  gift_message?: InputMaybe<Scalars["String"]["input"]>
  num_cycles: Scalars["Int"]["input"]
  plan_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
  recipient_first_name: Scalars["String"]["input"]
  recipient_last_name: Scalars["String"]["input"]
}

export type MutationsCreateGroupArgs = {
  base_resource_id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  parent_offering_id?: InputMaybe<Scalars["Int"]["input"]>
  role?: InputMaybe<RegistrationRoleEnum>
  visibility: Scalars["Int"]["input"]
}

export type MutationsCreateGroupLicenseOrderArgs = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  license_offering_id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  role?: InputMaybe<RegistrationRoleEnum>
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsCreateGroupSubscriptionOrderArgs = {
  group_name: Scalars["String"]["input"]
  price_id: Scalars["Int"]["input"]
  quantity: Scalars["Int"]["input"]
  reactivate_group_subscription_id?: InputMaybe<Scalars["Int"]["input"]>
  redirect_to?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsCreateInvitationsArgs = {
  context?: InputMaybe<InvitationContext>
  invitation_message?: InputMaybe<Scalars["String"]["input"]>
  invitation_subject?: InputMaybe<Scalars["String"]["input"]>
  invite_emails: Array<InputMaybe<Scalars["String"]["input"]>>
  invite_to_cohort_role?: InputMaybe<RegistrationRoleEnum>
  invite_to_community_group_role?: InputMaybe<MentorGroupMembershipRole>
  invite_to_school_role?: InputMaybe<MembershipRole>
  send_from_school?: InputMaybe<Scalars["Boolean"]["input"]>
  type?: InputMaybe<InvitationType>
}

export type MutationsCreateLifetimeSchoolSubscriptionOrderArgs = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  plan_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsCreateMembershipForExistingUserArgs = {
  role?: InputMaybe<MembershipRole>
  user_email: Scalars["String"]["input"]
}

export type MutationsCreateMentorGroupArgs = {
  name: Scalars["String"]["input"]
  parent?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<MentorGroupType>
}

export type MutationsCreateMentorGroupMembershipArgs = {
  group: Scalars["Int"]["input"]
  role: MentorGroupMembershipRole
  user: Scalars["Int"]["input"]
}

export type MutationsCreateMessageArgs = {
  message: MessageInput
  message_context: MessageContext
}

export type MutationsCreateOrderArgs = {
  curriculum_license?: InputMaybe<CurriculumLicenseOrderData>
  curriculum_subscription?: InputMaybe<CurriculumSubscriptionOrderData>
  gift_subscription?: InputMaybe<GiftSubscriptionOrderData>
  group_license?: InputMaybe<GroupLicenseOrderData>
  group_subscription?: InputMaybe<GroupSubscriptionOrderData>
  lifetime_school_subscription?: InputMaybe<LifetimeSchoolSubscriptionOrderData>
  platform_subscription?: InputMaybe<PlatformSubscriptionOrderData>
  registration?: InputMaybe<RegistrationOrderData>
  school_subscription?: InputMaybe<SchoolSubscriptionOrderData>
}

export type MutationsCreatePageArgs = {
  mode?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  page_type?: InputMaybe<Scalars["Int"]["input"]>
  show_in_nav?: InputMaybe<Scalars["Boolean"]["input"]>
  title?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsCreatePasswordArgs = {
  password1: Scalars["String"]["input"]
  password2: Scalars["String"]["input"]
}

export type MutationsCreatePathItemArgs = {
  assignment_type?: InputMaybe<PathItemAssignmentType>
  content_resource?: InputMaybe<Scalars["Int"]["input"]>
  content_type?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  name: Scalars["String"]["input"]
  order: Scalars["Int"]["input"]
  parent?: InputMaybe<Scalars["Int"]["input"]>
  path_id: Scalars["Int"]["input"]
  type: PathItemType
}

export type MutationsCreatePlatformSubscriptionOrderArgs = {
  billing_plan_id: Scalars["Int"]["input"]
  interval: Scalars["Int"]["input"]
  school_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsCreateRegistrationOrderArgs = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  invitation_code?: InputMaybe<Scalars["String"]["input"]>
  offering_id: Scalars["Int"]["input"]
  use_group_subscription_id?: InputMaybe<Scalars["Int"]["input"]>
  use_subscription_plan_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsCreateRegistrationUpsertGroupArgs = {
  create_registration?: InputMaybe<Scalars["Boolean"]["input"]>
  parent_offering_id: Scalars["Int"]["input"]
  resource_id: Scalars["Int"]["input"]
  step_source_id: Scalars["Int"]["input"]
}

export type MutationsCreateResourceArgs = {
  cover_image: Scalars["String"]["input"]
  group_name?: InputMaybe<Scalars["String"]["input"]>
  group_role?: InputMaybe<RegistrationRoleEnum>
  name: Scalars["String"]["input"]
  resource_type?: InputMaybe<ResourceType>
}

export type MutationsCreateSchoolArgs = {
  copy?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  head_markup?: InputMaybe<Scalars["String"]["input"]>
  licensor_id?: InputMaybe<Scalars["Int"]["input"]>
  name: Scalars["String"]["input"]
  script_markup?: InputMaybe<Scalars["String"]["input"]>
  subdomain: Scalars["String"]["input"]
  theme?: InputMaybe<ThemeInput>
  utm_campaign?: InputMaybe<Scalars["String"]["input"]>
  utm_medium?: InputMaybe<Scalars["String"]["input"]>
  utm_source?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsCreateSchoolSubscriptionOrderArgs = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  plan_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
  redirect_to?: InputMaybe<Scalars["String"]["input"]>
  start_free_trial?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsCreateSchoolThemeArgs = {
  theme: ThemeInput
}

export type MutationsCreateStoreLinkArgs = {
  copy?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  school_id: Scalars["Int"]["input"]
}

export type MutationsCreateStorefrontArgs = {
  autoAddPublicResources?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsCreateTagArgs = {
  tag: TagCreateInput
}

export type MutationsCreateTagAttachmentArgs = {
  context: TagAttachmentContextInput
  position?: InputMaybe<Scalars["String"]["input"]>
  tag_id: Scalars["Int"]["input"]
}

export type MutationsCreateTagLinkArgs = {
  context: TagLinkContextInput
  tag_id: Scalars["Int"]["input"]
}

export type MutationsCreateTranslationArgs = {
  translation: Scalars["JSON"]["input"]
}

export type MutationsDeferOrExecuteResourceCopyConfigArgs = {
  copy_code: Scalars["String"]["input"]
  target_school_id: Scalars["Int"]["input"]
}

export type MutationsDeleteBannerArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsDeleteCertificateArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsDeleteContextualFeaturePermissionArgs = {
  context?: InputMaybe<FeatureContextInput>
  feature_action: FeatureAction
  feature_key: FeatureKey
}

export type MutationsDeleteDiscussionArgs = {
  context: DiscussionContextInput
  id: Scalars["Int"]["input"]
}

export type MutationsDeleteDiscussionLikeArgs = {
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}

export type MutationsDeleteDiscussionResponseArgs = {
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
  response_id: Scalars["Int"]["input"]
}

export type MutationsDeleteDiscussionResponseLikeArgs = {
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
  response_id: Scalars["Int"]["input"]
}

export type MutationsDeleteDiscussionSubscriptionArgs = {
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}

export type MutationsDeleteInvitationArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsDeleteMentorGroupArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsDeleteMentorGroupMembershipArgs = {
  group: Scalars["Int"]["input"]
  id: Scalars["Int"]["input"]
}

export type MutationsDeleteMessageArgs = {
  id: Scalars["Int"]["input"]
  message_context: MessageContext
}

export type MutationsDeletePathItemArgs = {
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}

export type MutationsDeletePositioningContextArgs = {
  context: PositioningContextInput
}

export type MutationsDeleteRegistrationArgs = {
  group_id: Scalars["Int"]["input"]
  registration_id: Scalars["Int"]["input"]
}

export type MutationsDeleteResourceCopyConfigLinkArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsDeleteTagArgs = {
  tag: TagDeleteInput
}

export type MutationsDeleteTagAttachmentArgs = {
  context: TagAttachmentContextInput
  tag_id: Scalars["Int"]["input"]
}

export type MutationsDeleteTagLinkArgs = {
  context: TagLinkContextInput
  tag_id: Scalars["Int"]["input"]
}

export type MutationsDeleteWebhookEventArgs = {
  uuid: Scalars["UUID"]["input"]
}

export type MutationsExecuteDeferredResourceCopyConfigArgs = {
  link_id: Scalars["Int"]["input"]
}

export type MutationsExecutePathSyncPlanArgs = {
  sync_plan?: InputMaybe<PathSyncPlanInput>
}

export type MutationsFinalizeAccountArgs = {
  avatar?: InputMaybe<Scalars["String"]["input"]>
  consent?: InputMaybe<Scalars["Boolean"]["input"]>
  first_name: Scalars["String"]["input"]
  last_name: Scalars["String"]["input"]
  password1?: InputMaybe<Scalars["String"]["input"]>
  password2?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsFinalizeExternalAccountLinkArgs = {
  token: Scalars["String"]["input"]
}

export type MutationsGetTokenArgs = {
  invite_token?: InputMaybe<Scalars["String"]["input"]>
  password: Scalars["String"]["input"]
  username: Scalars["String"]["input"]
}

export type MutationsGetTokenViaSsoArgs = {
  sso_token: Scalars["String"]["input"]
}

export type MutationsJoinSpaceArgs = {
  consent: Scalars["Boolean"]["input"]
  invite_token?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsLicenseResourceArgs = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  license_offering_id: Scalars["Int"]["input"]
  licensee_school_id?: InputMaybe<Scalars["Int"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  payment_token?: InputMaybe<Scalars["String"]["input"]>
  resource_id: Scalars["Int"]["input"]
  role?: InputMaybe<LicenseRoleEnum>
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
  use_group_subscription_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsPastePathItemArgs = {
  item_id: Scalars["Int"]["input"]
  order: Scalars["Int"]["input"]
  parent_id?: InputMaybe<Scalars["Int"]["input"]>
  path_id: Scalars["Int"]["input"]
}

export type MutationsPublishPathArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsPublishPathToCodexArgs = {
  override_id?: InputMaybe<Scalars["String"]["input"]>
  path_id: Scalars["Int"]["input"]
  suffix?: InputMaybe<Scalars["String"]["input"]>
  upsert?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsRedeemSchoolGiftSubscriptionArgs = {
  code?: InputMaybe<Scalars["String"]["input"]>
  school_subscription_plan_id: Scalars["Int"]["input"]
}

export type MutationsRefreshTokenArgs = {
  school_id?: InputMaybe<Scalars["ID"]["input"]>
}

export type MutationsRegisterPushTokenArgs = {
  token: Scalars["String"]["input"]
}

export type MutationsRemoveAccessForInactiveMembersArgs = {
  daysInactive?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsRemovePushTokenArgs = {
  token: Scalars["String"]["input"]
}

export type MutationsReorderPathItemsArgs = {
  items: Array<InputMaybe<PathItemOrder>>
  path_id: Scalars["Int"]["input"]
}

export type MutationsRequestPasswordResetArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsResendInvitationArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsResetCompletionFeedbackArgs = {
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}

export type MutationsResetPasswordArgs = {
  password1: Scalars["String"]["input"]
  password2: Scalars["String"]["input"]
  reset_hash: Scalars["String"]["input"]
}

export type MutationsResetPathItemArgs = {
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}

export type MutationsResetPathItemForUserArgs = {
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}

export type MutationsSaveCompletionFeedbackArgs = {
  id: Scalars["Int"]["input"]
  notify?: InputMaybe<Scalars["Boolean"]["input"]>
  path_id: Scalars["Int"]["input"]
  userpoints_earned: Scalars["Int"]["input"]
  userpoints_explanation?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsScheduleItemArgs = {
  due?: InputMaybe<Scalars["DateTime"]["input"]>
  passive_due?: InputMaybe<Scalars["Boolean"]["input"]>
  passive_starts?: InputMaybe<Scalars["Boolean"]["input"]>
  schedule_context: ScheduleItemContext
  starts?: InputMaybe<Scalars["DateTime"]["input"]>
}

export type MutationsSendGiftSubscriptionEmailArgs = {
  gift_id: Scalars["Int"]["input"]
  recipient_email: Scalars["String"]["input"]
}

export type MutationsSetMemberAccessArgs = {
  has_access: Scalars["Boolean"]["input"]
  id: Scalars["Int"]["input"]
}

export type MutationsSetMemberArchivedArgs = {
  id: Scalars["Int"]["input"]
  is_archived: Scalars["Boolean"]["input"]
}

export type MutationsSetMemberRoleArgs = {
  id: Scalars["Int"]["input"]
  role: MembershipRole
}

export type MutationsShowHideResourceCopyConfigLinkArgs = {
  hide?: InputMaybe<Array<InputMaybe<ResourceCopyConfigLinkLocation>>>
  id: Scalars["Int"]["input"]
  show?: InputMaybe<Array<InputMaybe<ResourceCopyConfigLinkLocation>>>
}

export type MutationsSignUpArgs = {
  consent?: InputMaybe<Scalars["Boolean"]["input"]>
  create_membership?: InputMaybe<Scalars["Boolean"]["input"]>
  email: Scalars["String"]["input"]
  first_name: Scalars["String"]["input"]
  invite_token?: InputMaybe<Scalars["String"]["input"]>
  last_name: Scalars["String"]["input"]
  password?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsSkipPathItemForUserArgs = {
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}

export type MutationsSoftArchiveRegistrationArgs = {
  id: Scalars["Int"]["input"]
  softArchive?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsStartAuthRequestArgs = {
  email?: InputMaybe<Scalars["EmailAddress"]["input"]>
  method: AuthRequestMethod
  next_url?: InputMaybe<Scalars["String"]["input"]>
  username?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsStartPasswordRetrievalArgs = {
  email: Scalars["String"]["input"]
  next_url?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsSyncPathArgs = {
  id: Scalars["Int"]["input"]
}

export type MutationsUnarchivePathItemArgs = {
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}

export type MutationsUnlockPathItemArgs = {
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
  step_lock_password: Scalars["String"]["input"]
}

export type MutationsUpdateBannerArgs = {
  background_image?: InputMaybe<Scalars["String"]["input"]>
  background_image_raw?: InputMaybe<Scalars["String"]["input"]>
  background_overlay?: InputMaybe<Scalars["String"]["input"]>
  background_type?: InputMaybe<Scalars["Int"]["input"]>
  button_func?: InputMaybe<Scalars["String"]["input"]>
  button_text?: InputMaybe<Scalars["String"]["input"]>
  button_url?: InputMaybe<Scalars["String"]["input"]>
  font_color?: InputMaybe<Scalars["String"]["input"]>
  heading?: InputMaybe<Scalars["String"]["input"]>
  hide_for_products?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  hide_for_subscription_plans?: InputMaybe<
    Array<InputMaybe<Scalars["Int"]["input"]>>
  >
  id: Scalars["Int"]["input"]
  is_visible?: InputMaybe<Scalars["Boolean"]["input"]>
  show_for_products?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  show_for_subscription_plans?: InputMaybe<
    Array<InputMaybe<Scalars["Int"]["input"]>>
  >
  subhead?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsUpdateBannerOrderArgs = {
  banner_orders: Array<InputMaybe<ListOrderInput>>
}

export type MutationsUpdateBlocksContentArgs = {
  content_last_modified?: InputMaybe<Scalars["DateTime"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
  last_published?: InputMaybe<Scalars["DateTime"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsUpdateCertificateArgs = {
  id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  template?: InputMaybe<Scalars["String"]["input"]>
  text_objects?: InputMaybe<Array<InputMaybe<TextObject>>>
}

export type MutationsUpdateCertificateVariablesArgs = {
  context?: InputMaybe<CertificateVariablesContextInput>
  merge: Array<InputMaybe<CertificateVariablesMergeInput>>
}

export type MutationsUpdateContextualFeaturePermissionArgs = {
  context?: InputMaybe<FeatureContextInput>
  feature_action: FeatureAction
  feature_key: FeatureKey
  permission_in_context: FeaturePermission
}

export type MutationsUpdateDiscussionArgs = {
  context: DiscussionContextInput
  id: Scalars["Int"]["input"]
  post: DiscussionPostInput
}

export type MutationsUpdateDiscussionResponseArgs = {
  context: DiscussionContextInput
  response: DiscussionResponseInput
  response_id: Scalars["Int"]["input"]
}

export type MutationsUpdateGroupArgs = {
  discussion_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  group_id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  visibility?: InputMaybe<GroupVisibility>
}

export type MutationsUpdateGroupDiscussionEnabledArgs = {
  discussion_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  id: Scalars["Int"]["input"]
}

export type MutationsUpdateGroupStatusArgs = {
  id: Scalars["Int"]["input"]
  status?: InputMaybe<GroupStatus>
}

export type MutationsUpdateLocalTranslationArgs = {
  translation: Scalars["JSON"]["input"]
}

export type MutationsUpdateMemberConsentArgs = {
  consents?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsUpdateMentorGroupArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  parent?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<MentorGroupType>
}

export type MutationsUpdateMentorGroupMembershipArgs = {
  can_review?: InputMaybe<Scalars["Boolean"]["input"]>
  group: Scalars["Int"]["input"]
  has_access?: InputMaybe<Scalars["Boolean"]["input"]>
  id: Scalars["Int"]["input"]
  role?: InputMaybe<MentorGroupMembershipRole>
  send_mentor_digest?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsUpdateMessageArgs = {
  id: Scalars["Int"]["input"]
  message: MessageInput
  message_context: MessageContext
}

export type MutationsUpdateNotificationDigestIntervalArgs = {
  interval?: InputMaybe<NotificationDigestInterval>
}

export type MutationsUpdatePageArgs = {
  content_type?: InputMaybe<Scalars["Int"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  external_url?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
  iframe_url?: InputMaybe<Scalars["String"]["input"]>
  is_live?: InputMaybe<Scalars["Boolean"]["input"]>
  mode?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  order?: InputMaybe<Scalars["Int"]["input"]>
  page_type?: InputMaybe<Scalars["Int"]["input"]>
  scripts?: InputMaybe<Scalars["String"]["input"]>
  show_in_nav?: InputMaybe<Scalars["Boolean"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
  template_content?: InputMaybe<Scalars["String"]["input"]>
  title?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsUpdatePageOrdersArgs = {
  page_orders?: InputMaybe<Array<InputMaybe<ListOrderInput>>>
}

export type MutationsUpdatePathItemArgs = {
  allow_resets?: InputMaybe<Scalars["Int"]["input"]>
  assignment_type?: InputMaybe<PathItemAssignmentType>
  completion_comment_required_status?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  grading_type?: InputMaybe<Scalars["String"]["input"]>
  is_previewable?: InputMaybe<Scalars["Boolean"]["input"]>
  is_required?: InputMaybe<Scalars["Boolean"]["input"]>
  lock_password?: InputMaybe<Scalars["String"]["input"]>
  minimum_passing_score?: InputMaybe<Scalars["Int"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  order: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
  points?: InputMaybe<Scalars["Int"]["input"]>
  requires_api_completion?: InputMaybe<Scalars["Boolean"]["input"]>
  show_grading_feedback?: InputMaybe<Scalars["Int"]["input"]>
  source_id: Scalars["Int"]["input"]
  time_to_complete?: InputMaybe<Scalars["Int"]["input"]>
  type: PathItemType
}

export type MutationsUpdatePathwrightAuthArgs = {
  allow_public_signup: Scalars["Boolean"]["input"]
  always_prompt_for_password: Scalars["Boolean"]["input"]
  pathwright_login_enabled: Scalars["Boolean"]["input"]
}

export type MutationsUpdatePositionedObjectsArgs = {
  context: PositioningContextInput
  positions: Array<InputMaybe<PositionedObjectPositionInput>>
}

export type MutationsUpdateReferralArgs = {
  referral: Scalars["String"]["input"]
}

export type MutationsUpdateRegistrationArgs = {
  completion_state?: InputMaybe<CompletionStateFilter>
  expiration_dtime?: InputMaybe<Scalars["DateTime"]["input"]>
  id: Scalars["Int"]["input"]
  role?: InputMaybe<RegistrationRoleEnum>
  send_discussion_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  send_due_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsUpdateResourceArgs = {
  authors?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  categories?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  certificate_generator_class?: InputMaybe<Scalars["String"]["input"]>
  certificate_json?: InputMaybe<Scalars["JSON"]["input"]>
  cover_image?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  discussion_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  resource_type: ResourceType
  short_description?: InputMaybe<Scalars["String"]["input"]>
  trailer_embed_code?: InputMaybe<Scalars["String"]["input"]>
  visibility_level_override?: InputMaybe<Scalars["Int"]["input"]>
}

export type MutationsUpdateSchoolArgs = {
  analytics_account_id?: InputMaybe<Scalars["String"]["input"]>
  consent_description?: InputMaybe<Scalars["String"]["input"]>
  grant_access_upon_authentication?: InputMaybe<Scalars["Boolean"]["input"]>
  has_certificate?: InputMaybe<Scalars["Boolean"]["input"]>
  head_markup?: InputMaybe<Scalars["String"]["input"]>
  image?: InputMaybe<Scalars["String"]["input"]>
  intercom_access_token?: InputMaybe<Scalars["String"]["input"]>
  intercom_app_id?: InputMaybe<Scalars["String"]["input"]>
  intercom_secret_key?: InputMaybe<Scalars["String"]["input"]>
  logo_image?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  pathwright_login_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  script_markup?: InputMaybe<Scalars["String"]["input"]>
  short_description?: InputMaybe<Scalars["String"]["input"]>
  stripe_access_token?: InputMaybe<Scalars["String"]["input"]>
  subdomain?: InputMaybe<Scalars["String"]["input"]>
  support_email?: InputMaybe<Scalars["String"]["input"]>
  support_phone?: InputMaybe<Scalars["String"]["input"]>
  support_policy?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsUpdateSchoolCustomCssArgs = {
  custom_css: Scalars["String"]["input"]
  id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
}

export type MutationsUpdateSchoolProfileArgs = {
  coach_or_tutor?: InputMaybe<Scalars["Boolean"]["input"]>
  id: Scalars["Int"]["input"]
  other?: InputMaybe<Scalars["String"]["input"]>
  plan_to_sell?: InputMaybe<Scalars["Boolean"]["input"]>
  publish_multiple_courses?: InputMaybe<Scalars["Boolean"]["input"]>
  publish_one_course?: InputMaybe<Scalars["Boolean"]["input"]>
  school_type?: InputMaybe<SchoolType>
  teach_formal_classes?: InputMaybe<Scalars["Boolean"]["input"]>
  train_team_customers?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type MutationsUpdateSchoolThemeArgs = {
  id: Scalars["Int"]["input"]
  theme: ThemeInput
}

export type MutationsUpdateTagArgs = {
  tag: TagUpdateInput
}

export type MutationsUpdateTagAttachmentArgs = {
  context: TagAttachmentContextInput
  position?: InputMaybe<Scalars["String"]["input"]>
  tag_id: Scalars["Int"]["input"]
}

export type MutationsUpdateTranslationArgs = {
  id: Scalars["Int"]["input"]
  translation: Scalars["JSON"]["input"]
}

export type MutationsUpdateUserArgs = {
  profile: UserProfileInput
  user: UserInput
}

export type MutationsUpdateUserDiscussionHistoryArgs = {
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}

export enum NodeColorMode {
  Dark = "dark",
  Light = "light"
}

export enum NodeColorTone {
  Muted = "muted",
  Vibrant = "vibrant"
}

export type NodeImage = {
  __typename?: "NodeImage"
  color?: Maybe<Scalars["String"]["output"]>
  height?: Maybe<Scalars["Int"]["output"]>
  raw_src?: Maybe<Scalars["String"]["output"]>
  src?: Maybe<Scalars["String"]["output"]>
  width?: Maybe<Scalars["Int"]["output"]>
}

export type NodeImageColorArgs = {
  alpah?: InputMaybe<Scalars["Int"]["input"]>
  mode?: InputMaybe<NodeColorMode>
  tone?: InputMaybe<NodeColorTone>
}

export enum NodeImageFit {
  Clamp = "clamp",
  Clip = "clip",
  Crop = "crop",
  Facearea = "facearea",
  Fill = "fill"
}

export enum NodeImageFormat {
  Blurhash = "blurhash",
  Default = "default",
  Gif = "gif",
  Jpg = "jpg",
  Png = "png",
  Webp = "webp"
}

export enum NodeImageMask {
  BannerCover = "banner_cover"
}

export enum NodeImageSize {
  Lg = "lg",
  Md = "md",
  Sm = "sm",
  Xl = "xl"
}

export type NodeMeta = {
  __typename?: "NodeMeta"
  _search?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  icon?: Maybe<Scalars["String"]["output"]>
  id: Scalars["String"]["output"]
  image?: Maybe<NodeImage>
  key: Scalars["String"]["output"]
  keywords?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  subtitle?: Maybe<Scalars["String"]["output"]>
  title?: Maybe<Scalars["String"]["output"]>
  type: Scalars["String"]["output"]
  url?: Maybe<Scalars["String"]["output"]>
}

export type NodeMetaImageArgs = {
  ar?: InputMaybe<Scalars["String"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  brightness?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<NodeImageFit>
  format?: InputMaybe<NodeImageFormat>
  height?: InputMaybe<Scalars["Int"]["input"]>
  mask?: InputMaybe<NodeImageMask>
  size?: InputMaybe<NodeImageSize>
  vibrance?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

export type NodeTheme = {
  __typename?: "NodeTheme"
  background?: Maybe<NodeThemeBackground>
  color: Scalars["String"]["output"]
  color_palette?: Maybe<NodeThemeColorPalette>
  fonts?: Maybe<NodeThemeFonts>
}

export type NodeThemeBackground = {
  __typename?: "NodeThemeBackground"
  color?: Maybe<Scalars["String"]["output"]>
  contrast_color?: Maybe<Scalars["String"]["output"]>
  image?: Maybe<NodeImage>
  luminence?: Maybe<Scalars["Float"]["output"]>
}

export type NodeThemeBackgroundImageArgs = {
  ar?: InputMaybe<Scalars["String"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  brightness?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<NodeImageFit>
  format?: InputMaybe<NodeImageFormat>
  height?: InputMaybe<Scalars["Int"]["input"]>
  mask?: InputMaybe<NodeImageMask>
  size?: InputMaybe<NodeImageSize>
  vibrance?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

export type NodeThemeColorPalette = {
  __typename?: "NodeThemeColorPalette"
  _50?: Maybe<Scalars["String"]["output"]>
  _100?: Maybe<Scalars["String"]["output"]>
  _200?: Maybe<Scalars["String"]["output"]>
  _300?: Maybe<Scalars["String"]["output"]>
  _400?: Maybe<Scalars["String"]["output"]>
  _500?: Maybe<Scalars["String"]["output"]>
  _600?: Maybe<Scalars["String"]["output"]>
  _700?: Maybe<Scalars["String"]["output"]>
  _800?: Maybe<Scalars["String"]["output"]>
  _900?: Maybe<Scalars["String"]["output"]>
}

export type NodeThemeFonts = {
  __typename?: "NodeThemeFonts"
  body?: Maybe<Scalars["String"]["output"]>
  subtitle?: Maybe<Scalars["String"]["output"]>
  title?: Maybe<Scalars["String"]["output"]>
}

/** Pathwright note */
export type Note = {
  __typename?: "Note"
  body?: Maybe<Scalars["String"]["output"]>
  cohort_id?: Maybe<Scalars["Int"]["output"]>
  context_id?: Maybe<Scalars["Int"]["output"]>
  created_time?: Maybe<Scalars["DateTime"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  modified_time?: Maybe<Scalars["DateTime"]["output"]>
  resource_id?: Maybe<Scalars["Int"]["output"]>
  step_id?: Maybe<Scalars["Int"]["output"]>
  title?: Maybe<Scalars["String"]["output"]>
  user?: Maybe<User>
  visibility?: Maybe<NoteVisibility>
}

/** A connection to a list of items. */
export type NoteConnection = {
  __typename?: "NoteConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NoteEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type NoteEdge = {
  __typename?: "NoteEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Note>
}

export enum NoteVisibility {
  Author = "author",
  Everyone = "everyone",
  Staff = "staff"
}

export enum NotificationDigestInterval {
  Daily = "daily",
  Never = "never",
  Weekly = "weekly"
}

/** An Offer, a way of offering a Path. */
export type Offer = {
  __typename?: "Offer"
  /** Offer access state and description. */
  access: OfferAccess
  /** The description of the Offer, providing more details about the Cohort or Member-Created Cohort. */
  description: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  price_options: Array<OfferPriceOption>
  /** The source of the Offer. */
  source: OfferSource
  /** The title of the Offer, whether the name of the Cohort or generic title for Member-Created Cohort. */
  title: Scalars["String"]["output"]
}

export type OfferAccess = {
  __typename?: "OfferAccess"
  /** A description of the access limits of the Offer (seats, duration, etc.). */
  meta: Array<Maybe<Scalars["String"]["output"]>>
  /** The state of the access associated with the Offer. */
  state: OfferAccessState
}

/** The various states an Offer access can be in. */
export enum OfferAccessState {
  /** User is registered with active access to the Cohort. */
  Active = "ACTIVE",
  /** User has opportunity to access the Cohort. */
  Available = "AVAILABLE",
  /** User has no access to the Cohort. This could be due to expired registration or Cohort access limits (seats, duration, etc.). */
  Unavailable = "UNAVAILABLE"
}

/** A connection to a list of items. */
export type OfferConnection = {
  __typename?: "OfferConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OfferEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type OfferEdge = {
  __typename?: "OfferEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Offer>
}

export type OfferPriceOption = {
  __typename?: "OfferPriceOption"
  /** The label for the button associated with the Offer. */
  button_label: Scalars["String"]["output"]
  /** The label for the option associated with the Offer. */
  option_label: Scalars["String"]["output"]
  /** A description of the price for the Offer, providing details about the cost or payment options. */
  price_description: Scalars["String"]["output"]
}

/** The source of the Offer. */
export enum OfferSource {
  /** Offer is provided by a Cohort. */
  Cohort = "COHORT",
  /** Offer is provided by a Resource License Offering. */
  Rlo = "RLO"
}

/** A Pathwright Order */
export type Order = {
  __typename?: "Order"
  checkout_session_id?: Maybe<Scalars["String"]["output"]>
  fulfilled_object_id?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  order_data?: Maybe<Scalars["JSON"]["output"]>
  order_status?: Maybe<OrderStatus>
  order_type?: Maybe<OrderType>
  processor_id?: Maybe<Scalars["Int"]["output"]>
  school_id?: Maybe<Scalars["Int"]["output"]>
}

/** Order query results by 'asc' or 'desc'. */
export enum OrderByDir {
  Asc = "ASC",
  Desc = "DESC"
}

/** A connection to a list of items. */
export type OrderConnection = {
  __typename?: "OrderConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrderEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type OrderEdge = {
  __typename?: "OrderEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Order>
}

export enum OrderStatus {
  AwaitingPayment = "awaiting_payment",
  Fulfilled = "fulfilled",
  FulfillmentFailed = "fulfillment_failed",
  FulfillmentInProgress = "fulfillment_in_progress",
  FulfillmentPending = "fulfillment_pending",
  PaymentFailed = "payment_failed",
  PaymentPending = "payment_pending",
  Voided = "voided"
}

export enum OrderType {
  CurriculumLicense = "curriculum_license",
  CurriculumSubscription = "curriculum_subscription",
  GiftSubscription = "gift_subscription",
  GroupLicense = "group_license",
  GroupSubscription = "group_subscription",
  LifetimeSchoolSubscription = "lifetime_school_subscription",
  PlatformSubscription = "platform_subscription",
  Registration = "registration",
  SchoolSubscription = "school_subscription"
}

/** A Page */
export type Page = {
  __typename?: "Page"
  content_type?: Maybe<Scalars["Int"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  external_url?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  iframe_url: Scalars["String"]["output"]
  is_live: Scalars["Boolean"]["output"]
  mode: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  order: Scalars["Int"]["output"]
  page_type: Scalars["Int"]["output"]
  scripts?: Maybe<Scalars["String"]["output"]>
  show_in_nav: Scalars["Boolean"]["output"]
  slug: Scalars["String"]["output"]
  template_content?: Maybe<Scalars["String"]["output"]>
  title?: Maybe<Scalars["String"]["output"]>
  url: Scalars["String"]["output"]
}

/** A connection to a list of items. */
export type PageConnection = {
  __typename?: "PageConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PageEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type PageEdge = {
  __typename?: "PageEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Page>
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: "PageInfo"
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars["String"]["output"]>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars["Boolean"]["output"]
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars["Boolean"]["output"]
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars["String"]["output"]>
}

/** A path */
export type Path = {
  __typename?: "Path"
  analytics?: Maybe<PathAnalytics>
  cohort?: Maybe<Group>
  completion_date?: Maybe<Scalars["DateTime"]["output"]>
  created_date?: Maybe<Scalars["DateTime"]["output"]>
  id: Scalars["Int"]["output"]
  items?: Maybe<PathItemConnection>
  /** @deprecated Deprecated in favor of sync.last_synced_date */
  last_synced_dtime?: Maybe<Scalars["DateTime"]["output"]>
  meta: NodeMeta
  next_step_id?: Maybe<Scalars["Int"]["output"]>
  performance?: Maybe<PathPerformance>
  points?: Maybe<Points>
  previewable_steps?: Maybe<PathItemConnection>
  progress?: Maybe<Scalars["Float"]["output"]>
  publish?: Maybe<PathPublish>
  published_changes?: Maybe<PathChangePublishConnection>
  schedule?: Maybe<PathNodeSchedule>
  sync?: Maybe<PathSync>
  theme: NodeTheme
  user?: Maybe<User>
}

/** A path */
export type PathItemsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  archivedDateFilter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  first: Scalars["Int"]["input"]
  flatten?: InputMaybe<Scalars["Boolean"]["input"]>
  type?: InputMaybe<PathItemType>
}

/** A path */
export type PathPreviewable_StepsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A path */
export type PathPublished_ChangesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** Analytics data for a path or path item */
export type PathAnalytics = {
  __typename?: "PathAnalytics"
  avg_score?: Maybe<Scalars["Float"]["output"]>
  /** The number of users who have completed the whole path */
  complete?: Maybe<Scalars["Int"]["output"]>
  completion_rate?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  /** The number of users who still are working on this path */
  incomplete?: Maybe<Scalars["Int"]["output"]>
  item?: Maybe<PathItem>
  items?: Maybe<Scalars["JSON"]["output"]>
  /** The number of step completions in the path that need grading */
  need_feedback?: Maybe<Scalars["Int"]["output"]>
  next_count?: Maybe<Scalars["Int"]["output"]>
  path_id?: Maybe<Scalars["Int"]["output"]>
  /** This is a list of up to 10 users who have completed this path (used to render avatar stacks).  */
  students_here?: Maybe<Scalars["JSON"]["output"]>
  /** The number of earned points across all steps in this path (Note: this excludes steps that aren't due if due dates are in use) */
  total_points?: Maybe<Scalars["Int"]["output"]>
  /** The number of available points across all completed and past due student steps in this path */
  total_points_available?: Maybe<Scalars["Int"]["output"]>
  total_users?: Maybe<Scalars["Int"]["output"]>
}

/** A published set of changes made to a path */
export type PathChangePublish = {
  __typename?: "PathChangePublish"
  id?: Maybe<Scalars["Int"]["output"]>
  message?: Maybe<Scalars["String"]["output"]>
  path_id?: Maybe<Scalars["Int"]["output"]>
  published_by_id?: Maybe<Scalars["Int"]["output"]>
  published_dtime?: Maybe<Scalars["DateTime"]["output"]>
}

/** A connection to a list of items. */
export type PathChangePublishConnection = {
  __typename?: "PathChangePublishConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PathChangePublishEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type PathChangePublishEdge = {
  __typename?: "PathChangePublishEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<PathChangePublish>
}

/** An item in a path (Lesson, Topic, Step) */
export type PathItem = {
  __typename?: "PathItem"
  allow_resets?: Maybe<Scalars["Int"]["output"]>
  analytics?: Maybe<ItemAnalytics>
  archived_time?: Maybe<Scalars["DateTime"]["output"]>
  assignment_type?: Maybe<PathItemAssignmentType>
  blocks?: Maybe<BlocksContent>
  /** This dynamically calcuates progress for lessons. Avoid for long result sets as it's an N+1 query! */
  calculated_progress?: Maybe<Scalars["Float"]["output"]>
  cohort?: Maybe<Group>
  cohort_id?: Maybe<Scalars["Int"]["output"]>
  cohort_name?: Maybe<Scalars["String"]["output"]>
  completion: Completion
  completion_comment_required_status?: Maybe<Scalars["String"]["output"]>
  /** @deprecated It's inefficient to load content for steps in a loop (N+2). Instead, check the content_id and item_content_type_id and load on demand */
  content?: Maybe<StepContent>
  content_id?: Maybe<Scalars["Int"]["output"]>
  content_type?: Maybe<Scalars["String"]["output"]>
  context?: Maybe<StepContext>
  curriculum_sync_opt_out_dtime?: Maybe<Scalars["DateTime"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  due?: Maybe<Scalars["DateTime"]["output"]>
  grading_type?: Maybe<Scalars["String"]["output"]>
  has_started?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["Int"]["output"]
  is_locked?: Maybe<Scalars["Boolean"]["output"]>
  is_previewable?: Maybe<Scalars["Boolean"]["output"]>
  is_required?: Maybe<Scalars["Boolean"]["output"]>
  item_content_type_id?: Maybe<Scalars["Int"]["output"]>
  item_needs_grading?: Maybe<Scalars["Boolean"]["output"]>
  items?: Maybe<PathItemConnection>
  last_published_dtime?: Maybe<Scalars["DateTime"]["output"]>
  linked_cohort?: Maybe<Group>
  linked_registration?: Maybe<Registration>
  linked_resource?: Maybe<Resource>
  lock_password?: Maybe<Scalars["String"]["output"]>
  lock_unlocked_time?: Maybe<Scalars["DateTime"]["output"]>
  meta: NodeMeta
  minimum_passing_score?: Maybe<Scalars["Int"]["output"]>
  name: Scalars["String"]["output"]
  order: Scalars["Int"]["output"]
  parent?: Maybe<PathItem>
  parent_id?: Maybe<Scalars["Int"]["output"]>
  parent_name?: Maybe<Scalars["String"]["output"]>
  parent_source_id?: Maybe<Scalars["Int"]["output"]>
  passive_due?: Maybe<Scalars["Boolean"]["output"]>
  passive_starts?: Maybe<Scalars["Boolean"]["output"]>
  path?: Maybe<Path>
  path_id: Scalars["Int"]["output"]
  permissions?: Maybe<PathItemPermissions>
  points?: Maybe<Scalars["Int"]["output"]>
  progress: Scalars["Float"]["output"]
  reminders?: Maybe<MessageConnection>
  resource?: Maybe<Resource>
  resource_name?: Maybe<Scalars["String"]["output"]>
  show_grading_feedback?: Maybe<Scalars["Int"]["output"]>
  source_id: Scalars["Int"]["output"]
  starts?: Maybe<Scalars["DateTime"]["output"]>
  time_to_complete?: Maybe<Scalars["Int"]["output"]>
  type: PathItemType
  url?: Maybe<Scalars["String"]["output"]>
  verb?: Maybe<Scalars["String"]["output"]>
}

/** An item in a path (Lesson, Topic, Step) */
export type PathItemItemsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** An item in a path (Lesson, Topic, Step) */
export type PathItemRemindersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

export enum PathItemAssignmentType {
  Assessment = "assessment",
  Audio = "audio",
  Completion = "completion",
  Event = "event",
  Reading = "reading",
  Submission = "submission",
  Video = "video"
}

/** A connection to a list of items. */
export type PathItemConnection = {
  __typename?: "PathItemConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PathItemEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type PathItemEdge = {
  __typename?: "PathItemEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<PathItem>
}

export type PathItemOrder = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  order: Scalars["Int"]["input"]
  parent_id?: InputMaybe<Scalars["Int"]["input"]>
  source_id: Scalars["Int"]["input"]
}

export type PathItemPermissions = {
  __typename?: "PathItemPermissions"
  can_complete?: Maybe<Scalars["Boolean"]["output"]>
  can_discuss?: Maybe<Scalars["Boolean"]["output"]>
  can_edit?: Maybe<Scalars["Boolean"]["output"]>
  can_edit_content?: Maybe<Scalars["Boolean"]["output"]>
  can_note?: Maybe<Scalars["Boolean"]["output"]>
  can_review?: Maybe<Scalars["Boolean"]["output"]>
  can_view?: Maybe<Scalars["Boolean"]["output"]>
  can_view_content?: Maybe<Scalars["Boolean"]["output"]>
}

/** Status for path items */
export type PathItemStats = {
  __typename?: "PathItemStats"
  path_items_needing_review?: Maybe<Scalars["Int"]["output"]>
}

export enum PathItemType {
  Divider = "divider",
  Lesson = "lesson",
  Resource = "resource",
  Step = "step"
}

export enum PathItemTypes {
  Divider = "divider",
  Lesson = "lesson",
  Resource = "resource",
  Step = "step"
}

export type PathNodeSchedule = {
  __typename?: "PathNodeSchedule"
  end?: Maybe<ScheduleDate>
  start?: Maybe<ScheduleDate>
}

/** A path's performance data */
export type PathPerformance = {
  __typename?: "PathPerformance"
  id?: Maybe<Scalars["Int"]["output"]>
  points?: Maybe<PathPerformancePoints>
  progress?: Maybe<PathPerformanceProgress>
}

export type PathPerformancePoints = {
  __typename?: "PathPerformancePoints"
  applicable_score?: Maybe<Scalars["JSON"]["output"]>
  applicable_score_percentage?: Maybe<Scalars["Float"]["output"]>
  earned?: Maybe<Scalars["Int"]["output"]>
  percentage?: Maybe<Scalars["Float"]["output"]>
  possible?: Maybe<Scalars["Int"]["output"]>
  total?: Maybe<Scalars["Int"]["output"]>
}

export type PathPerformanceProgress = {
  __typename?: "PathPerformanceProgress"
  percentage?: Maybe<Scalars["Float"]["output"]>
  required_steps_completed?: Maybe<Scalars["Int"]["output"]>
  steps_completed?: Maybe<Scalars["Int"]["output"]>
  total_required_steps?: Maybe<Scalars["Int"]["output"]>
  total_steps?: Maybe<Scalars["Int"]["output"]>
}

/** A Path's publish status. */
export type PathPublish = {
  __typename?: "PathPublish"
  /** The date when the target path was last published. */
  last_published_date?: Maybe<Scalars["DateTime"]["output"]>
  /** The target path. */
  path_id: Scalars["Int"]["output"]
  /** The target path is considered published if it has no unpublished changes (and has been published in the past). */
  published: Scalars["Boolean"]["output"]
}

/** Status of whether a path needs to be synced with its source path */
export type PathSync = {
  __typename?: "PathSync"
  /** The date when the target path was last synced. */
  last_synced_date?: Maybe<Scalars["DateTime"]["output"]>
  /** The target path. */
  path_id: Scalars["Int"]["output"]
  /** Always points to the path from which the target path syncs. Will be null in the case where the target path is a source path. */
  sync_source_path_id?: Maybe<Scalars["Int"]["output"]>
  /** Whether the target path has been synced with the latest changes from the source path. */
  synced: Scalars["Boolean"]["output"]
  /** The target path user (if present). */
  user_id?: Maybe<Scalars["Int"]["output"]>
}

/** Sync plan for a path */
export type PathSyncPlan = {
  __typename?: "PathSyncPlan"
  excluded_changes: Array<Maybe<PathSyncPlanChange>>
  from_path_id?: Maybe<Scalars["Int"]["output"]>
  hash: Scalars["String"]["output"]
  included_changes: Array<Maybe<PathSyncPlanChange>>
  to_path_id?: Maybe<Scalars["Int"]["output"]>
}

/** A single change of a PathSyncPlan */
export type PathSyncPlanChange = {
  __typename?: "PathSyncPlanChange"
  assignment_type?: Maybe<PathItemAssignmentType>
  change_details?: Maybe<Scalars["JSON"]["output"]>
  forced?: Maybe<PathSyncPlanForceType>
  forced_reasons?: Maybe<Array<Maybe<PathSyncPlanForceReasonType>>>
  item_name: Scalars["String"]["output"]
  item_source_id: Scalars["Int"]["output"]
  item_type: PathItemType
  last_changed?: Maybe<Scalars["DateTime"]["output"]>
  parent_name?: Maybe<Scalars["String"]["output"]>
  parent_source_id?: Maybe<Scalars["Int"]["output"]>
}

export enum PathSyncPlanForceReasonType {
  /** Excluded due to lesson not containing any steps with content */
  ExcludeLessonEmpty = "exclude_lesson_empty",
  /** Excluded due to step having no content */
  ExcludeStepNoContent = "exclude_step_no_content",
  /** Excluded upon user request */
  ExcludeUserRequest = "exclude_user_request",
  /** Included upon user request */
  IncludeUserRequest = "include_user_request"
}

export enum PathSyncPlanForceType {
  /** The path item change is force included and force excluded requiring a conflict to be resolved */
  Conflict = "conflict",
  /** The path item change cannot be included in sync */
  Exclude = "exclude",
  /** The path item change cannot be excluded from sync */
  Include = "include"
}

export type PathSyncPlanInput = {
  /** The source IDs of the path items to exclude from the sync plan. */
  exclude_source_ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  /** The ID of the path from which to generate the sync plan. */
  from_path_id: Scalars["Int"]["input"]
  /** When executing a sync plan, the generated sync plan hash is required to ensure no changes have occurred between generating and executing the sync plan. */
  hash?: InputMaybe<Scalars["String"]["input"]>
  /** The source IDs of the path items to include from the sync plan. */
  include_source_ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>
  /** The ID of the path against which to generate the sync plan. If not provided, the sync plan for the path will be derived from the diff of its current state and unpublished changes. */
  to_path_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A node in the Paths codex data structure */
export type PathsCodexNode = {
  __typename?: "PathsCodexNode"
  key?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
  version?: Maybe<Scalars["Int"]["output"]>
}

/** A Pathwright Payment */
export type Payment = {
  __typename?: "Payment"
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
}

/** A user's payment history. */
export type PaymentHistory = {
  __typename?: "PaymentHistory"
  /** ID of the user. */
  download_url: Scalars["String"]["output"]
  /** ID of the user. */
  payments: Array<PaymentHistoryItem>
}

/** A user's payment history. */
export type PaymentHistoryItem = {
  __typename?: "PaymentHistoryItem"
  /** The total amount in the currency in which the payment was made. */
  currency_display: Scalars["String"]["output"]
  /** The date the payment was made. */
  date: Scalars["DateTime"]["output"]
  /** Whether the payment failed. */
  is_failed: Scalars["String"]["output"]
  /** The name of the item purchased or paid for. */
  item: Scalars["String"]["output"]
  /** The total amount paid. */
  total: Scalars["Float"]["output"]
}

export type PeopleAndGroupConnection = {
  __typename?: "PeopleAndGroupConnection"
  id?: Maybe<Scalars["Int"]["output"]>
  /** The meta data for this 'type'. */
  meta: NodeMeta
  /** The number of people attached to this 'type' */
  people_count?: Maybe<Scalars["Int"]["output"]>
  /** The role of the 'user' type in the queried context. Will be null for all other types. */
  role?: Maybe<Role>
  role_in?: Maybe<Role>
  /** The type of the people source. */
  type?: Maybe<PeopleAndGroupConnectionType>
}

/** A connection to a list of items. */
export type PeopleAndGroupConnectionConnection = {
  __typename?: "PeopleAndGroupConnectionConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PeopleAndGroupConnectionEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

export type PeopleAndGroupConnectionContext = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  group_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** An edge in a connection. */
export type PeopleAndGroupConnectionEdge = {
  __typename?: "PeopleAndGroupConnectionEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<PeopleAndGroupConnection>
}

export enum PeopleAndGroupConnectionType {
  Cohort = "cohort",
  Group = "group",
  User = "user"
}

/** Platform Config */
export type PlatformConfig = {
  __typename?: "PlatformConfig"
  id?: Maybe<Scalars["Int"]["output"]>
  payments_maintenance_mode?: Maybe<Scalars["Boolean"]["output"]>
}

/** Platform subscription order data */
export type PlatformSubscriptionOrderData = {
  billing_plan_id: Scalars["Int"]["input"]
  interval: Scalars["Int"]["input"]
  /** Optionally provide the school ID of the school creating the order. */
  school_id?: InputMaybe<Scalars["Int"]["input"]>
}

export type Points = {
  __typename?: "Points"
  /** Sum of the `userpoints_earned` for each "scoreable" path item completion */
  earned?: Maybe<Scalars["Int"]["output"]>
  /** Whether any path item on the path has `userpoints_available` */
  has_points?: Maybe<Scalars["Boolean"]["output"]>
  path_id?: Maybe<Scalars["Int"]["output"]>
  /** Percentage of earned / total */
  percentage?: Maybe<Scalars["Float"]["output"]>
  /** Sum of the `userpoints_available` for each "scoreable" path item completion */
  total?: Maybe<Scalars["Int"]["output"]>
  /** Sum of `userpoints_available` for each path item */
  total_points_possible?: Maybe<Scalars["Int"]["output"]>
}

/** Assign a lexicographical position to a positioned object */
export type PositionedObjectPositionInput = {
  /** A unique key for this object within the context. For example, registration:1234 for a specific registration on a user's home screen. */
  objKey: Scalars["NonEmptyString"]["input"]
  /** The lexicographical position used for fractional indexing. */
  objPosition: Scalars["NonEmptyString"]["input"]
}

/** A context within which objects can be positioned. */
export type PositioningContext = {
  __typename?: "PositioningContext"
  /** A unique key for this context within the school. For example, user:1234 for a user's home screen. */
  context_key: Scalars["NonEmptyString"]["output"]
  /** The type of context this is. For example, 'home_screen' for a user's home screen. */
  context_type: PositioningContextTypeInput
  /** The ID of this context. */
  id: Scalars["Int"]["output"]
  /** The ID of the school for this context. */
  school_id: Scalars["Int"]["output"]
}

/** Assign the context for positioning an object. */
export type PositioningContextInput = {
  /** A unique key for this context within the school. For example, user:1234 for a user's home screen. */
  contextKey: Scalars["NonEmptyString"]["input"]
  /** The type of context to position the object within. For example, 'home_screen' for a user's home screen. */
  contextType: PositioningContextTypeInput
}

/** The positioning context type. */
export enum PositioningContextTypeInput {
  /** Positioning objects on a user's homescreen. */
  HomeScreen = "HOME_SCREEN",
  /** Positioning objects in the Subscribe flow. */
  SubscribeFlow = "SUBSCRIBE_FLOW"
}

/** A Pathwright User Profile */
export type Profile = {
  __typename?: "Profile"
  bio?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  image?: Maybe<Scalars["String"]["output"]>
  imageRaw?: Maybe<Scalars["String"]["output"]>
  last_activity?: Maybe<Scalars["DateTime"]["output"]>
  location?: Maybe<Scalars["String"]["output"]>
  notification_digest_interval?: Maybe<NotificationDigestInterval>
  rewardful_referral_id?: Maybe<Scalars["String"]["output"]>
}

/** A Pathwright User Profile */
export type ProfileImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

export type ProgressFilter = {
  eq?: InputMaybe<Scalars["Float"]["input"]>
  gt?: InputMaybe<Scalars["Float"]["input"]>
  gte?: InputMaybe<Scalars["Float"]["input"]>
  in?: InputMaybe<Array<InputMaybe<Scalars["Float"]["input"]>>>
  lt?: InputMaybe<Scalars["Float"]["input"]>
  lte?: InputMaybe<Scalars["Float"]["input"]>
  neq?: InputMaybe<Scalars["Float"]["input"]>
  nin?: InputMaybe<Array<InputMaybe<Scalars["Float"]["input"]>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School Publisher */
export type Publisher = {
  __typename?: "Publisher"
  about?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  image?: Maybe<Scalars["String"]["output"]>
  logo?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  theme?: Maybe<Theme>
  website?: Maybe<Scalars["String"]["output"]>
}

/** A Pathwright School Publisher */
export type PublisherImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright School Publisher */
export type PublisherLogoArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** A connection to a list of items. */
export type PublisherConnection = {
  __typename?: "PublisherConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PublisherEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type PublisherEdge = {
  __typename?: "PublisherEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Publisher>
}

/** Pathwright GraphQL Endpoint */
export type Query = {
  __typename?: "Query"
  account?: Maybe<SchoolAcount>
  activity?: Maybe<ActivityConnection>
  activityStats?: Maybe<ActivityStats>
  admin?: Maybe<SchoolConnection>
  assignRoles: Array<Maybe<RegistrationRoleEnum>>
  authRequest?: Maybe<AuthRequest>
  /** The auth token resulting from a confirmed auth request made by the user to authenticate by some other means than username/password. */
  authRequestToken?: Maybe<Scalars["JWT"]["output"]>
  author?: Maybe<Author>
  authors?: Maybe<AuthorConnection>
  backgroundTask?: Maybe<BackgroundTask>
  backgroundTasks?: Maybe<Array<Maybe<BackgroundTask>>>
  calendar?: Maybe<Calendar>
  calendarStats?: Maybe<CalendarStats>
  canReview?: Maybe<Scalars["Boolean"]["output"]>
  categories?: Maybe<CategoryConnection>
  category?: Maybe<Category>
  certificate?: Maybe<Certificate>
  certificatePreview?: Maybe<Scalars["String"]["output"]>
  certificateVariables?: Maybe<CertificateVariables>
  certificates?: Maybe<CertificateConnection>
  codex?: Maybe<Codex>
  computedDiscount?: Maybe<ComputedDiscount>
  context?: Maybe<AccountContext>
  contextualFeaturePermission?: Maybe<ContextualFeaturePermission>
  contextualFeaturePermissions: Array<Maybe<ContextualFeaturePermission>>
  couponExists?: Maybe<Scalars["Boolean"]["output"]>
  curriculumSubscription?: Maybe<CurriculumSubscription>
  discussion?: Maybe<Discussion>
  discussionParticipants?: Maybe<DiscussionParticipantConnection>
  discussions?: Maybe<DiscussionConnection>
  feedbackReviewers?: Maybe<FeedbackReviewers>
  gravatar?: Maybe<Gravatar>
  group?: Maybe<Group>
  groups?: Maybe<GroupConnection>
  inboxContext?: Maybe<InboxContext>
  inboxGroupConnections?: Maybe<InboxGroupConnectionConnection>
  inboxGroups?: Maybe<InboxMentorGroupConnection>
  inboxPaths?: Maybe<InboxPathConnection>
  inboxPendingReview?: Maybe<InboxPendingReview>
  inboxPendingReviewConnections?: Maybe<InboxPendingReviewConnection>
  inboxPeopleCompletionCounts?: Maybe<InboxPeopleCompletionCountsConnection>
  inboxReviewers?: Maybe<InboxReviewerConnection>
  integrations?: Maybe<Integrations>
  invitationToken?: Maybe<InvitationToken>
  invitations?: Maybe<InvitationConnection>
  license_offering?: Maybe<LicenseOffering>
  loginMethod?: Maybe<LoginInfo>
  loginMethods?: Maybe<Array<LoginInfo>>
  me?: Maybe<User>
  media?: Maybe<Media>
  mediaContext?: Maybe<MediaContext>
  membership?: Maybe<Membership>
  membership_meta?: Maybe<MembershipMeta>
  mentorGroupMembership?: Maybe<MentorGroupMembership>
  message?: Maybe<Message>
  messages?: Maybe<MessageConnection>
  note?: Maybe<Note>
  notes?: Maybe<NoteConnection>
  offerConnections?: Maybe<OfferConnection>
  order?: Maybe<Order>
  orders?: Maybe<OrderConnection>
  path?: Maybe<Path>
  pathItem?: Maybe<PathItem>
  pathItemStats?: Maybe<PathItemStats>
  pathItems?: Maybe<PathItemConnection>
  pathSyncPlan?: Maybe<PathSyncPlan>
  peopleAndGroupConnection?: Maybe<PeopleAndGroupConnection>
  peopleAndGroupConnections?: Maybe<PeopleAndGroupConnectionConnection>
  platformConfig?: Maybe<PlatformConfig>
  positioningContext?: Maybe<PositioningContext>
  report?: Maybe<Scalars["JSON"]["output"]>
  resource?: Maybe<Resource>
  resourceCopyConfig?: Maybe<ResourceCopyConfig>
  resourceCopyConfigConnections?: Maybe<ResourceCopyConfigConnection>
  resourceCopyConfigLink?: Maybe<ResourceCopyConfigLink>
  resourceCopyConfigLinkConnections?: Maybe<ResourceCopyConfigLinkConnection>
  resourceImage: Array<Maybe<Scalars["URL"]["output"]>>
  resource_license?: Maybe<ResourceLicense>
  resource_licenses?: Maybe<ResourceLicenseConnection>
  resources?: Maybe<ResourceConnection>
  responses?: Maybe<ResponseConnection>
  restAPIGet?: Maybe<Scalars["JSON"]["output"]>
  school?: Maybe<School>
  schoolGroupSubscription?: Maybe<SchoolGroupSubscription>
  schoolGroupSubscriptions?: Maybe<SchoolGroupSubscriptionConnection>
  schoolSubscriptionDiscount?: Maybe<SchoolSubscriptionDiscount>
  sharePermissions?: Maybe<SharePermissions>
  /** Returns the current space (from request header */
  space: Space
  /** A list of spaces the user has access to */
  spaceConnections?: Maybe<SpaceConnectionConnection>
  store?: Maybe<Store>
  storeBanners?: Maybe<Array<Maybe<StoreBanner>>>
  storeCollection?: Maybe<StoreCollection>
  storeCollections?: Maybe<Array<Maybe<StoreCollection>>>
  storeItem?: Maybe<StoreItem>
  storeLink?: Maybe<StoreLink>
  storeLinks?: Maybe<StoreLinkConnection>
  stripeProduct?: Maybe<StripeProduct>
  stripeProducts?: Maybe<StripeProductConnection>
  subdomain?: Maybe<Subdomain>
  subscription?: Maybe<Subscription>
  subscriptions?: Maybe<SubscriptionConnection>
  tag?: Maybe<Tag>
  tagAttachment?: Maybe<TagAttachment>
  tagAttachments?: Maybe<TagAttachmentConnection>
  tags?: Maybe<TagConnection>
  theme?: Maybe<Theme>
  translation?: Maybe<Translation>
  user?: Maybe<User>
  userStatus?: Maybe<UserStatus>
  webhookEventConnections?: Maybe<WebhookEventConnection>
}

/** Pathwright GraphQL Endpoint */
export type QueryActivityArgs = {
  action_type?: InputMaybe<ActionTypeFilter>
  after?: InputMaybe<Scalars["String"]["input"]>
  date?: InputMaybe<DateFilter>
  first: Scalars["Int"]["input"]
  group_id?: InputMaybe<Scalars["Int"]["input"]>
  interest_level?: InputMaybe<InterestLevel>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryAdminArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  is_activated?: InputMaybe<Scalars["Boolean"]["input"]>
  licensing_from?: InputMaybe<Scalars["Int"]["input"]>
  school_subscription_plan_id?: InputMaybe<Scalars["Int"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryAuthRequestArgs = {
  uuid: Scalars["String"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryAuthRequestTokenArgs = {
  uuid: Scalars["String"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryAuthorArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryAuthorsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  ids?: InputMaybe<IdFilter>
  manage?: InputMaybe<Scalars["Boolean"]["input"]>
  resource_author_ids?: InputMaybe<IdFilter>
  resource_author_names?: InputMaybe<StringFilter>
  resource_category_ids?: InputMaybe<IdFilter>
  resource_category_names?: InputMaybe<StringFilter>
  resource_search?: InputMaybe<Scalars["String"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryBackgroundTaskArgs = {
  id: Scalars["String"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryBackgroundTasksArgs = {
  ids: Array<InputMaybe<Scalars["String"]["input"]>>
}

/** Pathwright GraphQL Endpoint */
export type QueryCalendarArgs = {
  path_id?: InputMaybe<Scalars["ID"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryCalendarStatsArgs = {
  path_id?: InputMaybe<Scalars["ID"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryCanReviewArgs = {
  for_user_id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  ids?: InputMaybe<IdFilter>
  manage?: InputMaybe<Scalars["Boolean"]["input"]>
  resource_author_ids?: InputMaybe<IdFilter>
  resource_author_names?: InputMaybe<StringFilter>
  resource_category_ids?: InputMaybe<IdFilter>
  resource_category_names?: InputMaybe<StringFilter>
  resource_search?: InputMaybe<Scalars["String"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryCertificateArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryCertificatePreviewArgs = {
  template: Scalars["String"]["input"]
  text_objects: Array<InputMaybe<TextObject>>
  variables?: InputMaybe<Scalars["JSON"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryCertificateVariablesArgs = {
  context?: InputMaybe<CertificateVariablesContextInput>
}

/** Pathwright GraphQL Endpoint */
export type QueryCertificatesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryComputedDiscountArgs = {
  discount_code: Scalars["String"]["input"]
  license_offering_id?: InputMaybe<Scalars["Int"]["input"]>
  offering_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_id: Scalars["Int"]["input"]
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryContextArgs = {
  auth_token_id?: InputMaybe<Scalars["String"]["input"]>
  school_id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryContextualFeaturePermissionArgs = {
  context?: InputMaybe<FeatureContextInput>
  feature_action: FeatureAction
  feature_key: FeatureKey
}

/** Pathwright GraphQL Endpoint */
export type QueryContextualFeaturePermissionsArgs = {
  context?: InputMaybe<FeatureContextInput>
  feature_action?: InputMaybe<FeatureAction>
  feature_key?: InputMaybe<FeatureKey>
  feature_keys?: InputMaybe<FeatureKeyFilter>
}

/** Pathwright GraphQL Endpoint */
export type QueryCouponExistsArgs = {
  input?: InputMaybe<CouponExistsInput>
}

/** Pathwright GraphQL Endpoint */
export type QueryCurriculumSubscriptionArgs = {
  id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryDiscussionArgs = {
  context: DiscussionContextInput
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryDiscussionParticipantsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
  first: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryDiscussionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context?: InputMaybe<DiscussionContextInput>
  first: Scalars["Int"]["input"]
  is_discussion_question?: InputMaybe<Scalars["Boolean"]["input"]>
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  tag_id_filter?: InputMaybe<IntFilter>
  total_responses?: InputMaybe<IntFilter>
  type?: InputMaybe<DiscussionTypeInput>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryFeedbackReviewersArgs = {
  completion_id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryGravatarArgs = {
  email: Scalars["String"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryGroupArgs = {
  id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryGroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  assign_config?: InputMaybe<AssignConfig>
  first: Scalars["Int"]["input"]
  include_curriculum?: InputMaybe<Scalars["Boolean"]["input"]>
  is_master?: InputMaybe<Scalars["Boolean"]["input"]>
  parent_group_id?: InputMaybe<IdFilter>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  role?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<GroupStatus>
  visibility?: InputMaybe<GroupVisibility>
  visibility_filter?: InputMaybe<GroupVisibilityFilter>
}

/** Pathwright GraphQL Endpoint */
export type QueryInboxContextArgs = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  group_id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryInboxGroupConnectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryInboxGroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  status?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryInboxPathsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryInboxPendingReviewArgs = {
  target_id: Scalars["Int"]["input"]
  target_type: InboxPendingReviewTarget
}

/** Pathwright GraphQL Endpoint */
export type QueryInboxPendingReviewConnectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  target_ids: IntFilter
  target_type: InboxPendingReviewTarget
}

/** Pathwright GraphQL Endpoint */
export type QueryInboxPeopleCompletionCountsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  archivedDateFilter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  first: Scalars["Int"]["input"]
  is_complete?: InputMaybe<Scalars["Boolean"]["input"]>
  needs_review?: InputMaybe<Scalars["Boolean"]["input"]>
  parent_source_id?: InputMaybe<Scalars["Int"]["input"]>
  step_source_id?: InputMaybe<Scalars["Int"]["input"]>
  target_id: Scalars["Int"]["input"]
  target_type: InboxPeopleCompletionCountsTarget
}

/** Pathwright GraphQL Endpoint */
export type QueryInboxReviewersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryInvitationTokenArgs = {
  token: Scalars["NonEmptyString"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryInvitationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context?: InputMaybe<InvitationContext>
  delivery_status?: InputMaybe<EmailDeliveryStatus>
  first: Scalars["Int"]["input"]
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  search?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<InvitationStatus>
  type?: InputMaybe<InvitationType>
}

/** Pathwright GraphQL Endpoint */
export type QueryLicense_OfferingArgs = {
  id: Scalars["Int"]["input"]
  licensing_mode?: InputMaybe<LicenseOfferingLicensingMode>
}

/** Pathwright GraphQL Endpoint */
export type QueryLoginMethodArgs = {
  email: Scalars["String"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryLoginMethodsArgs = {
  email: Scalars["String"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryMembershipArgs = {
  access_revoked_date_filter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  archived_date_filter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  daysInactive?: InputMaybe<Scalars["Int"]["input"]>
  global?: InputMaybe<Scalars["Boolean"]["input"]>
  hasAccess?: InputMaybe<Scalars["Boolean"]["input"]>
  id: Scalars["Int"]["input"]
  orderBy?: InputMaybe<Scalars["String"]["input"]>
  role_filter?: InputMaybe<Array<InputMaybe<MembershipRoleFilter>>>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryMembership_MetaArgs = {
  user_id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryMentorGroupMembershipArgs = {
  id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryMessageArgs = {
  id: Scalars["Int"]["input"]
  message_context: MessageContext
}

/** Pathwright GraphQL Endpoint */
export type QueryMessagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  message_context: MessageContext
  type?: InputMaybe<MessageTypeFilter>
}

/** Pathwright GraphQL Endpoint */
export type QueryNoteArgs = {
  context: ContextModelInput
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryNotesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context: ContextModelInput
  first: Scalars["Int"]["input"]
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  visibility?: InputMaybe<NoteVisibility>
}

/** Pathwright GraphQL Endpoint */
export type QueryOfferConnectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  resource_id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryOrderArgs = {
  id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryPathArgs = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryPathItemArgs = {
  archivedDateFilter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  source_id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryPathItemStatsArgs = {
  user_id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryPathItemsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  archivedDateFilter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  due?: InputMaybe<DateFilter>
  exclude_default?: InputMaybe<Scalars["Boolean"]["input"]>
  first: Scalars["Int"]["input"]
  group_id?: InputMaybe<Scalars["Int"]["input"]>
  is_complete?: InputMaybe<Scalars["Boolean"]["input"]>
  is_required?: InputMaybe<Scalars["Boolean"]["input"]>
  is_reviewed?: InputMaybe<Scalars["Boolean"]["input"]>
  is_skipped?: InputMaybe<Scalars["Boolean"]["input"]>
  lesson_source_id?: InputMaybe<Scalars["Int"]["input"]>
  needs_attention?: InputMaybe<Scalars["Boolean"]["input"]>
  needs_review?: InputMaybe<Scalars["Boolean"]["input"]>
  next?: InputMaybe<Scalars["Boolean"]["input"]>
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  registration_role_filter?: InputMaybe<RoleFilter>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  reviewable?: InputMaybe<Scalars["Boolean"]["input"]>
  root_level?: InputMaybe<Scalars["Boolean"]["input"]>
  source_id?: InputMaybe<Scalars["Int"]["input"]>
  starts?: InputMaybe<DateFilter>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<PathItemTypes>
  upcoming?: InputMaybe<Scalars["Boolean"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
  with_dates?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryPathSyncPlanArgs = {
  sync_plan?: InputMaybe<PathSyncPlanInput>
}

/** Pathwright GraphQL Endpoint */
export type QueryPeopleAndGroupConnectionArgs = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  group_id?: InputMaybe<Scalars["Int"]["input"]>
  role_in_context?: InputMaybe<RoleInContext>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryPeopleAndGroupConnectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context?: InputMaybe<PeopleAndGroupConnectionContext>
  first: Scalars["Int"]["input"]
  people_count_filter?: InputMaybe<IntFilter>
  role_in_context?: InputMaybe<RoleInContext>
  search_term?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  type?: InputMaybe<PeopleAndGroupConnectionType>
}

/** Pathwright GraphQL Endpoint */
export type QueryPositioningContextArgs = {
  input: PositioningContextInput
}

/** Pathwright GraphQL Endpoint */
export type QueryReportArgs = {
  community_groups?: InputMaybe<Array<InputMaybe<ReportInput>>>
  community_memberships?: InputMaybe<Array<InputMaybe<ReportInput>>>
  group_performance_completion?: InputMaybe<Array<InputMaybe<ReportInput>>>
  group_performance_points?: InputMaybe<Array<InputMaybe<ReportInput>>>
  group_registrations?: InputMaybe<Array<InputMaybe<ReportInput>>>
  licensing_member_created_cohorts?: InputMaybe<Array<InputMaybe<ReportInput>>>
  licensing_store_connected_accounts?: InputMaybe<
    Array<InputMaybe<ReportInput>>
  >
  licensing_store_member_progress?: InputMaybe<Array<InputMaybe<ReportInput>>>
  licensing_store_resource_usage?: InputMaybe<Array<InputMaybe<ReportInput>>>
  school_cohorts?: InputMaybe<Array<InputMaybe<ReportInput>>>
  school_coupon_redemptions?: InputMaybe<Array<InputMaybe<ReportInput>>>
  school_coupon_summary?: InputMaybe<Array<InputMaybe<ReportInput>>>
  school_external_ids?: InputMaybe<Array<InputMaybe<ReportInput>>>
  school_member_progress?: InputMaybe<Array<InputMaybe<ReportInput>>>
  school_members?: InputMaybe<Array<InputMaybe<ReportInput>>>
  school_registrations?: InputMaybe<Array<InputMaybe<ReportInput>>>
  school_resources?: InputMaybe<Array<InputMaybe<ReportInput>>>
}

/** Pathwright GraphQL Endpoint */
export type QueryResourceArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryResourceCopyConfigArgs = {
  fromSpaceId?: InputMaybe<Scalars["Int"]["input"]>
  key: Scalars["String"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryResourceCopyConfigConnectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  fromSpaceId?: InputMaybe<Scalars["Int"]["input"]>
  keys?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
}

/** Pathwright GraphQL Endpoint */
export type QueryResourceCopyConfigLinkArgs = {
  id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryResourceCopyConfigLinkConnectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  copiedTimeDateFilter?: InputMaybe<DateFilter>
  first: Scalars["Int"]["input"]
  hideFromLocationsFilter?: InputMaybe<
    Array<InputMaybe<ResourceCopyConfigLinkLocationFilter>>
  >
}

/** Pathwright GraphQL Endpoint */
export type QueryResourceImageArgs = {
  image?: InputMaybe<Array<InputMaybe<ImageInput>>>
  theme_type?: InputMaybe<ThemeType>
}

/** Pathwright GraphQL Endpoint */
export type QueryResource_LicenseArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  license_offering_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryResource_LicensesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryResourcesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  assign_config?: InputMaybe<AssignConfig>
  author_id?: InputMaybe<Scalars["Int"]["input"]>
  author_ids?: InputMaybe<IdFilter>
  author_names?: InputMaybe<StringFilter>
  author_search?: InputMaybe<Scalars["String"]["input"]>
  category_id?: InputMaybe<Scalars["Int"]["input"]>
  category_ids?: InputMaybe<IdFilter>
  category_names?: InputMaybe<StringFilter>
  category_search?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  has_certificate?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<IdFilter>
  license_offering_licensing_mode?: InputMaybe<LicenseOfferingLicensingMode>
  licensed_from_school?: InputMaybe<IdFilter>
  orderBy?: InputMaybe<Scalars["String"]["input"]>
  publisher_id?: InputMaybe<Scalars["Int"]["input"]>
  publisher_ids?: InputMaybe<IdFilter>
  resource_types?: InputMaybe<ResourceTypeFilter>
  role?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  user_registered?: InputMaybe<IdFilter>
  visibility?: InputMaybe<ResourceVisibility>
}

/** Pathwright GraphQL Endpoint */
export type QueryResponsesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context: DiscussionResponseContextInput
  first: Scalars["Int"]["input"]
  modified_time?: InputMaybe<DateFilter>
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
}

/** Pathwright GraphQL Endpoint */
export type QueryRestApiGetArgs = {
  endpoint: Scalars["String"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QuerySchoolGroupSubscriptionArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QuerySchoolGroupSubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  license_offering_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QuerySchoolSubscriptionDiscountArgs = {
  discount_code: Scalars["String"]["input"]
  school_plan_id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QuerySharePermissionsArgs = {
  context?: InputMaybe<ShareContext>
}

/** Pathwright GraphQL Endpoint */
export type QuerySpaceConnectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryStoreCollectionArgs = {
  id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryStoreCollectionsArgs = {
  author_id?: InputMaybe<Scalars["Int"]["input"]>
  author_ids?: InputMaybe<IdFilter>
  author_search?: InputMaybe<Scalars["String"]["input"]>
  category_id?: InputMaybe<Scalars["Int"]["input"]>
  category_ids?: InputMaybe<IdFilter>
  category_search?: InputMaybe<Scalars["String"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryStoreItemArgs = {
  id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryStoreLinksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  licensor_id?: InputMaybe<IdFilter>
}

/** Pathwright GraphQL Endpoint */
export type QueryStripeProductArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryStripeProductsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  ids?: InputMaybe<IdFilter>
  include_inactive?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QuerySubdomainArgs = {
  subdomain?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QuerySubscriptionArgs = {
  id: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QuerySubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  payment_intent_needing_action_id?: InputMaybe<IdFilter>
}

/** Pathwright GraphQL Endpoint */
export type QueryTagArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryTagAttachmentArgs = {
  context?: InputMaybe<TagAttachmentContextInput>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryTagAttachmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context?: InputMaybe<TagAttachmentContextInput>
  first: Scalars["Int"]["input"]
  tag_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryTagsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context?: InputMaybe<TagAttachmentContextInput>
  first: Scalars["Int"]["input"]
}

/** Pathwright GraphQL Endpoint */
export type QueryTranslationArgs = {
  is_default?: InputMaybe<Scalars["Boolean"]["input"]>
  language?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryUserArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryUserStatusArgs = {
  input?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright GraphQL Endpoint */
export type QueryWebhookEventConnectionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  event?: InputMaybe<WebhookEventType>
  first: Scalars["Int"]["input"]
  last_attempt_dtime_filter?: InputMaybe<DateFilter>
  order_by?: InputMaybe<WebhookEventOrderBy>
  status?: InputMaybe<WebhookEventStatus>
}

export type Referral = {
  __typename?: "Referral"
  referral?: Maybe<Scalars["String"]["output"]>
}

/** A Pathwright Registration */
export type Registration = {
  __typename?: "Registration"
  /**
   * The download URL for the course certificate
   * @deprecated Optimization. `certificate_download_url` field has been moved to its own schema that can be queried separately, `RegistrationCertificate`
   */
  certificate_download_url?: Maybe<Scalars["String"]["output"]>
  completion_state?: Maybe<Scalars["Int"]["output"]>
  created?: Maybe<Scalars["DateTime"]["output"]>
  expiration_dtime?: Maybe<Scalars["DateTime"]["output"]>
  group: Group
  group_sub_community_membership?: Maybe<MentorGroupMembership>
  group_sub_used?: Maybe<SchoolGroupSubscription>
  id: Scalars["Int"]["output"]
  last_activity_time?: Maybe<Scalars["DateTime"]["output"]>
  meta: NodeMeta
  path?: Maybe<Path>
  path_id?: Maybe<Scalars["Int"]["output"]>
  /** The contextual position for this registration based on the `positioningContext` arg. */
  position: Scalars["String"]["output"]
  registration_payment?: Maybe<RegistrationPayment>
  resource: Resource
  role: Scalars["Int"]["output"]
  school_sub_used?: Maybe<SchoolSubscription>
  send_discussion_notifications?: Maybe<Scalars["Boolean"]["output"]>
  send_due_notifications?: Maybe<Scalars["Boolean"]["output"]>
  /** A soft-archived registration will be hidden or demphasized in some UIs. */
  softArchivedTime?: Maybe<Scalars["DateTime"]["output"]>
  user: User
  user_id?: Maybe<Scalars["Int"]["output"]>
}

/** A connection to a list of items. */
export type RegistrationConnection = {
  __typename?: "RegistrationConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RegistrationEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type RegistrationEdge = {
  __typename?: "RegistrationEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Registration>
}

export type RegistrationMeta = {
  __typename?: "RegistrationMeta"
  editor_registration_count?: Maybe<Scalars["Int"]["output"]>
  facilitator_registration_count?: Maybe<Scalars["Int"]["output"]>
  student_registration_count?: Maybe<Scalars["Int"]["output"]>
  teacher_registration_count?: Maybe<Scalars["Int"]["output"]>
  total_registration_count?: Maybe<Scalars["Int"]["output"]>
}

/** Input for ordering the list. */
export type RegistrationOrderByInput = {
  /** Order by created. */
  created?: InputMaybe<OrderByDir>
  /** Order by last_activity_time. */
  last_activity_time?: InputMaybe<OrderByDir>
  /** Order by position. */
  position?: InputMaybe<OrderByDir>
  /** Order by role. */
  role?: InputMaybe<OrderByDir>
}

/** Registration order data */
export type RegistrationOrderData = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  invitation_code?: InputMaybe<Scalars["String"]["input"]>
  offering_id: Scalars["Int"]["input"]
  use_group_subscription_id?: InputMaybe<Scalars["Int"]["input"]>
  use_subscription_plan_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright Registration Payment */
export type RegistrationPayment = {
  __typename?: "RegistrationPayment"
  /** The Coupon that was redeemed (if any). */
  couponRedemption?: Maybe<CouponRedemption>
  group_sub_used?: Maybe<SchoolGroupSubscription>
  id?: Maybe<Scalars["Int"]["output"]>
  payment?: Maybe<Payment>
  school_sub_used?: Maybe<SchoolSubscription>
}

export enum RegistrationRoleEnum {
  Editor = "editor",
  Moderator = "moderator",
  Observer = "observer",
  Student = "student",
  Teacher = "teacher"
}

export type RelativeTime = {
  days?: InputMaybe<Scalars["Float"]["input"]>
  hours?: InputMaybe<Scalars["Float"]["input"]>
  minutes?: InputMaybe<Scalars["Float"]["input"]>
}

export type ReportInput = {
  /** Issue a non-default expiry report link. Pass null for non-expiring. By default a report link is set to expire 1 day from date issued. NOTE: only available to Pathwright admin. */
  exp?: InputMaybe<RelativeTime>
  id_type?: InputMaybe<Scalars["Int"]["input"]>
  offering_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  schedule_id?: InputMaybe<Scalars["Int"]["input"]>
  store_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright Resource */
export type Resource = {
  __typename?: "Resource"
  authors?: Maybe<AuthorConnection>
  background_image?: Maybe<Scalars["String"]["output"]>
  background_luminance?: Maybe<Scalars["Float"]["output"]>
  background_overlay?: Maybe<Scalars["String"]["output"]>
  background_type: ResourceBackgroundType
  categories?: Maybe<CategoryConnection>
  certificate_generator_class?: Maybe<Scalars["String"]["output"]>
  certificate_json?: Maybe<Scalars["JSON"]["output"]>
  cohorts_status_meta?: Maybe<CohortsStatusMeta>
  /** If set, this is the ID of the ResourceCopyConfig used to copy this resource. */
  copied_with_copy_config_id?: Maybe<Scalars["Int"]["output"]>
  created?: Maybe<Scalars["DateTime"]["output"]>
  created_by_id?: Maybe<Scalars["Int"]["output"]>
  curriculum_group?: Maybe<Group>
  description?: Maybe<Scalars["String"]["output"]>
  discussion_enabled?: Maybe<Scalars["Boolean"]["output"]>
  group?: Maybe<Group>
  groups?: Maybe<GroupConnection>
  has_certificate?: Maybe<Scalars["Boolean"]["output"]>
  highest_public_offering_price?: Maybe<Scalars["Float"]["output"]>
  id: Scalars["Int"]["output"]
  image: Scalars["String"]["output"]
  image_raw?: Maybe<Scalars["String"]["output"]>
  is_ambient_background?: Maybe<Scalars["Boolean"]["output"]>
  last_published_dtime?: Maybe<Scalars["DateTime"]["output"]>
  license_offerings?: Maybe<LicenseOfferingConnection>
  licensed_from_resource_id?: Maybe<Scalars["Int"]["output"]>
  licensed_from_school_id?: Maybe<Scalars["Int"]["output"]>
  licensing_enabled?: Maybe<Scalars["Boolean"]["output"]>
  lowest_public_offering_price?: Maybe<Scalars["Float"]["output"]>
  /** In the future, ResourceMeta will simply be NodeMeta, only consisting of NodeMeta fields. */
  meta?: Maybe<ResourceMeta>
  name: Scalars["String"]["output"]
  publisher?: Maybe<Publisher>
  registration_meta?: Maybe<RegistrationMeta>
  resource_type: Scalars["Int"]["output"]
  school?: Maybe<School>
  school_licenses?: Maybe<ResourceLicenseConnection>
  short_description?: Maybe<Scalars["String"]["output"]>
  slug: Scalars["String"]["output"]
  trailer_embed_code?: Maybe<Scalars["String"]["output"]>
  visibility?: Maybe<Scalars["Int"]["output"]>
  visibility_level_override?: Maybe<Scalars["Int"]["output"]>
}

/** A Pathwright Resource */
export type ResourceAuthorsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A Pathwright Resource */
export type ResourceBackground_ImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright Resource */
export type ResourceCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A Pathwright Resource */
export type ResourceGroupArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  is_source?: InputMaybe<Scalars["Boolean"]["input"]>
  parent_group_id?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<GroupType>
}

/** A Pathwright Resource */
export type ResourceGroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  assign_config?: InputMaybe<AssignConfig>
  first: Scalars["Int"]["input"]
  include_curriculum?: InputMaybe<Scalars["Boolean"]["input"]>
  is_master?: InputMaybe<Scalars["Boolean"]["input"]>
  parent_group_id?: InputMaybe<IdFilter>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  role?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  status?: InputMaybe<GroupStatus>
  visibility?: InputMaybe<GroupVisibility>
  visibility_filter?: InputMaybe<GroupVisibilityFilter>
}

/** A Pathwright Resource */
export type ResourceImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright Resource */
export type ResourceLicense_OfferingsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  licensing_mode?: InputMaybe<LicenseOfferingLicensingMode>
}

/** A Pathwright Resource */
export type ResourceSchool_LicensesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  licensee_school_id: Scalars["Int"]["input"]
}

export enum ResourceBackgroundType {
  /** Blur */
  Blur = "BLUR",
  /** Pristine */
  Pristine = "PRISTINE"
}

/** A connection to a list of items. */
export type ResourceConnection = {
  __typename?: "ResourceConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ResourceEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

export type ResourceCopyConfig = {
  __typename?: "ResourceCopyConfig"
  /** If set, linking an account to this Store will result in this copy config being executed. NOTE: For now, only applies to new school sign-ups to the store. */
  allow_copy_via_link: Scalars["Boolean"]["output"]
  /** If creating a cohort and this is set, assign the copier this role. Can be editor for source path, or other roles for non-source paths. */
  assign_copier_role?: Maybe<RegistrationRoleEnum>
  /** All direct child resource copy configs. */
  children?: Maybe<Array<Maybe<ResourceCopyConfig>>>
  cohort?: Maybe<ResourceCopyConfigCohort>
  /** Should authors be copied to the target school if they don't exist? */
  copy_authors: Scalars["Boolean"]["output"]
  /** How/when should the resource be copied by default? This may be overridden by a parent config. */
  copy_behavior: ResourceCopyConfigCopyBehavior
  /** Should categories be copied to the target school if they don't exist? */
  copy_categories: Scalars["Boolean"]["output"]
  /** Create a cohort for the copied resource? */
  create_cohort: Scalars["Boolean"]["output"]
  /** If creating a cohort, this is the name to give to the new cohort. */
  create_cohort_name?: Maybe<Scalars["String"]["output"]>
  /** All recursive child resource copy configs. */
  flat_children?: Maybe<Array<Maybe<ResourceCopyConfig>>>
  id: Scalars["Int"]["output"]
  /** The unique code for this resource copy config. */
  lookup_key: Scalars["String"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  /** The parent resource copy config. If the parent is copied, all child resource copy configs will be copied regardless of how the child resource copy config is configured to run. */
  parent?: Maybe<ResourceCopyConfig>
  resource?: Maybe<ResourceCopyConfigResource>
  school: ResourceCopyConfigSchool
}

export type ResourceCopyConfigCohort = {
  __typename?: "ResourceCopyConfigCohort"
  id: Scalars["Int"]["output"]
  meta: NodeMeta
}

/** A connection to a list of items. */
export type ResourceCopyConfigConnection = {
  __typename?: "ResourceCopyConfigConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ResourceCopyConfigEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** How/when should the resource be copied by default? This may be overridden by a parent config. */
export enum ResourceCopyConfigCopyBehavior {
  /** Defer copying the resource until later (user action triggered). Will create a ResourceCopyConfigLink. */
  Deferred = "DEFERRED",
  /** Immediately copy the resource when processing the config. */
  Instant = "INSTANT"
}

/** An edge in a connection. */
export type ResourceCopyConfigEdge = {
  __typename?: "ResourceCopyConfigEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<ResourceCopyConfig>
}

export type ResourceCopyConfigLink = {
  __typename?: "ResourceCopyConfigLink"
  cohort?: Maybe<ResourceCopyConfigLinkCohort>
  cohortId?: Maybe<Scalars["Int"]["output"]>
  /** When the related ResourceCopyConfig was copied. */
  copiedTime?: Maybe<Scalars["DateTime"]["output"]>
  /** The related Registration, if the ResourceCopyConfig assigned a role. */
  copierRegistration?: Maybe<Registration>
  copierRegistrationId?: Maybe<Scalars["Int"]["output"]>
  /** When the ResourceCopyConfigLink was created. */
  createdTime: Scalars["DateTime"]["output"]
  hideFromLocations?: Maybe<Scalars["JSON"]["output"]>
  id: Scalars["Int"]["output"]
  resource?: Maybe<ResourceCopyConfigLinkResource>
  /** The related ResourceCopyConfig. */
  resourceCopyConfig: ResourceCopyConfig
  resourceId?: Maybe<Scalars["Int"]["output"]>
}

export type ResourceCopyConfigLinkCohort = {
  __typename?: "ResourceCopyConfigLinkCohort"
  id: Scalars["Int"]["output"]
  meta: NodeMeta
}

/** A connection to a list of items. */
export type ResourceCopyConfigLinkConnection = {
  __typename?: "ResourceCopyConfigLinkConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ResourceCopyConfigLinkEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type ResourceCopyConfigLinkEdge = {
  __typename?: "ResourceCopyConfigLinkEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<ResourceCopyConfigLink>
}

/** UI location where a link may be shown or hidden from. */
export enum ResourceCopyConfigLinkLocation {
  HomeScreen = "HOME_SCREEN",
  Library = "LIBRARY"
}

export type ResourceCopyConfigLinkLocationFilter = {
  eq?: InputMaybe<ResourceCopyConfigLinkLocation>
  gt?: InputMaybe<ResourceCopyConfigLinkLocation>
  gte?: InputMaybe<ResourceCopyConfigLinkLocation>
  in?: InputMaybe<Array<InputMaybe<ResourceCopyConfigLinkLocation>>>
  lt?: InputMaybe<ResourceCopyConfigLinkLocation>
  lte?: InputMaybe<ResourceCopyConfigLinkLocation>
  neq?: InputMaybe<ResourceCopyConfigLinkLocation>
  nin?: InputMaybe<Array<InputMaybe<ResourceCopyConfigLinkLocation>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type ResourceCopyConfigLinkResource = {
  __typename?: "ResourceCopyConfigLinkResource"
  id: Scalars["Int"]["output"]
  meta: NodeMeta
}

export type ResourceCopyConfigResource = {
  __typename?: "ResourceCopyConfigResource"
  id: Scalars["Int"]["output"]
  meta: NodeMeta
}

export type ResourceCopyConfigSchool = {
  __typename?: "ResourceCopyConfigSchool"
  id: Scalars["Int"]["output"]
  meta: NodeMeta
}

/** An edge in a connection. */
export type ResourceEdge = {
  __typename?: "ResourceEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Resource>
}

/** A resource license */
export type ResourceLicense = {
  __typename?: "ResourceLicense"
  expiration_dtime?: Maybe<Scalars["DateTime"]["output"]>
  group?: Maybe<Group>
  id?: Maybe<Scalars["Int"]["output"]>
  license_offering?: Maybe<LicenseOffering>
  school?: Maybe<LicenseeSchool>
  seat_count?: Maybe<Scalars["Int"]["output"]>
  seats_available?: Maybe<Scalars["Int"]["output"]>
  seats_filled?: Maybe<Scalars["Int"]["output"]>
}

/** A connection to a list of items. */
export type ResourceLicenseConnection = {
  __typename?: "ResourceLicenseConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ResourceLicenseEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type ResourceLicenseEdge = {
  __typename?: "ResourceLicenseEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<ResourceLicense>
}

export type ResourceMeta = {
  __typename?: "ResourceMeta"
  description?: Maybe<Scalars["String"]["output"]>
  /** @deprecated Use Resource.registration_meta instead! */
  editor_registration_count?: Maybe<Scalars["Int"]["output"]>
  /** @deprecated Use Resource.registration_meta instead! */
  facilitator_registration_count?: Maybe<Scalars["Int"]["output"]>
  icon?: Maybe<Scalars["String"]["output"]>
  image?: Maybe<Scalars["String"]["output"]>
  key: Scalars["String"]["output"]
  /** @deprecated Use Resource.registration_meta instead! */
  student_registration_count?: Maybe<Scalars["Int"]["output"]>
  subtitle?: Maybe<Scalars["String"]["output"]>
  /** @deprecated Use Resource.registration_meta instead! */
  teacher_registration_count?: Maybe<Scalars["Int"]["output"]>
  title?: Maybe<Scalars["String"]["output"]>
  /** @deprecated Use Resource.registration_meta instead! */
  total_registration_count?: Maybe<Scalars["Int"]["output"]>
  type: Scalars["String"]["output"]
  url?: Maybe<Scalars["String"]["output"]>
}

export type ResourceStats = {
  __typename?: "ResourceStats"
  active?: Maybe<Scalars["Int"]["output"]>
  never_active?: Maybe<Scalars["Int"]["output"]>
  private?: Maybe<Scalars["Int"]["output"]>
  public?: Maybe<Scalars["Int"]["output"]>
  total?: Maybe<Scalars["Int"]["output"]>
}

export enum ResourceType {
  Collection = "collection",
  Course = "course",
  Lesson = "lesson"
}

export type ResourceTypeFilter = {
  eq?: InputMaybe<ResourceType>
  gt?: InputMaybe<ResourceType>
  gte?: InputMaybe<ResourceType>
  in?: InputMaybe<Array<InputMaybe<ResourceType>>>
  lt?: InputMaybe<ResourceType>
  lte?: InputMaybe<ResourceType>
  neq?: InputMaybe<ResourceType>
  nin?: InputMaybe<Array<InputMaybe<ResourceType>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type ResourceVisibility = {
  eq?: InputMaybe<ResourceVisibilityEnum>
  gt?: InputMaybe<ResourceVisibilityEnum>
  gte?: InputMaybe<ResourceVisibilityEnum>
  in?: InputMaybe<Array<InputMaybe<ResourceVisibilityEnum>>>
  lt?: InputMaybe<ResourceVisibilityEnum>
  lte?: InputMaybe<ResourceVisibilityEnum>
  neq?: InputMaybe<ResourceVisibilityEnum>
  nin?: InputMaybe<Array<InputMaybe<ResourceVisibilityEnum>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export enum ResourceVisibilityEnum {
  Inactive = "inactive",
  /** Resources visible to members */
  Members = "members",
  Private = "private",
  /** Resources visible to anyone */
  Public = "public"
}

/** Pathwright discussion response */
export type Response = {
  __typename?: "Response"
  attachments?: Maybe<Scalars["JSON"]["output"]>
  body: Scalars["String"]["output"]
  created_time: Scalars["DateTime"]["output"]
  depth?: Maybe<Scalars["Int"]["output"]>
  discussion?: Maybe<Discussion>
  id: Scalars["Int"]["output"]
  likes?: Maybe<Scalars["Int"]["output"]>
  modified_time: Scalars["DateTime"]["output"]
  parent_id?: Maybe<Scalars["Int"]["output"]>
  parent_response?: Maybe<Response>
  responses?: Maybe<ResponseConnection>
  user?: Maybe<User>
  user_liked?: Maybe<Scalars["Boolean"]["output"]>
}

/** Pathwright discussion response */
export type ResponseResponsesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A connection to a list of items. */
export type ResponseConnection = {
  __typename?: "ResponseConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ResponseEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type ResponseEdge = {
  __typename?: "ResponseEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Response>
}

export enum Role {
  CohortCourseEditor = "cohort_course_editor",
  CohortLearner = "cohort_learner",
  CohortModerator = "cohort_moderator",
  CohortObserver = "cohort_observer",
  CohortTeacher = "cohort_teacher",
  GroupAdmin = "group_admin",
  GroupMember = "group_member",
  GroupModerator = "group_moderator",
  SchoolAdmin = "school_admin",
  SchoolLibraryEditor = "school_library_editor",
  SchoolMember = "school_member",
  SchoolStaff = "school_staff"
}

export type RoleFilter = {
  eq?: InputMaybe<RegistrationRoleEnum>
  gt?: InputMaybe<RegistrationRoleEnum>
  gte?: InputMaybe<RegistrationRoleEnum>
  in?: InputMaybe<Array<InputMaybe<RegistrationRoleEnum>>>
  lt?: InputMaybe<RegistrationRoleEnum>
  lte?: InputMaybe<RegistrationRoleEnum>
  neq?: InputMaybe<RegistrationRoleEnum>
  nin?: InputMaybe<Array<InputMaybe<RegistrationRoleEnum>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export type RoleInContext = {
  /** Whether an item with this type of role should be excluded from results. */
  exclude?: InputMaybe<Scalars["Boolean"]["input"]>
  /** The type of the context in which the user has this role (defaults to school). */
  type: RoleInType
  /** The id of the type. */
  type_id?: InputMaybe<Scalars["Int"]["input"]>
}

export enum RoleInType {
  Cohort = "cohort",
  Group = "group",
  School = "school"
}

export type ScheduleDate = {
  __typename?: "ScheduleDate"
  behavior: ScheduleDateBehavior
  date?: Maybe<Scalars["DateTime"]["output"]>
}

export enum ScheduleDateBehavior {
  Lock = "lock",
  Passthrough = "passthrough"
}

export type ScheduleItemContext = {
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  /** The id source ID of the path item to be scheduled. */
  source_id: Scalars["Int"]["input"]
}

/** A Pathwright School */
export type School = {
  __typename?: "School"
  about?: Maybe<Scalars["String"]["output"]>
  /** @deprecated Activity should be queried through root for performance reasons */
  activity?: Maybe<ActivityConnection>
  /** @deprecated Activity stats should be queried through root for performance reasons */
  activity_stats?: Maybe<ActivityStats>
  /** Wheter to prompt users to enter a password when signing up. */
  always_prompt_for_password?: Maybe<Scalars["Boolean"]["output"]>
  author?: Maybe<Author>
  authors?: Maybe<AuthorConnection>
  banner?: Maybe<Banner>
  banners?: Maybe<BannerConnection>
  billing_model?: Maybe<Scalars["Int"]["output"]>
  billing_subscription?: Maybe<SchoolBillingSubscription>
  categories?: Maybe<CategoryConnection>
  category?: Maybe<Category>
  consent_description?: Maybe<Scalars["String"]["output"]>
  couponDiscount?: Maybe<CouponDiscount>
  created?: Maybe<Scalars["DateTime"]["output"]>
  currency_code?: Maybe<Scalars["String"]["output"]>
  curriculum_plans?: Maybe<SchoolCurriculumPlanConnection>
  curriculum_subscription?: Maybe<CurriculumSubscription>
  curriculum_subscriptions?: Maybe<CurriculumSubscriptionConnection>
  email?: Maybe<Scalars["String"]["output"]>
  features: SchoolFeatures
  gift_subscription?: Maybe<SchoolGiftSubscription>
  grant_access_upon_authentication?: Maybe<Scalars["Boolean"]["output"]>
  has_certificate?: Maybe<Scalars["Boolean"]["output"]>
  head_markup?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  ietf_language_tag?: Maybe<Scalars["String"]["output"]>
  image?: Maybe<Scalars["String"]["output"]>
  is_activated?: Maybe<Scalars["Boolean"]["output"]>
  is_curriculum_enabled?: Maybe<Scalars["Boolean"]["output"]>
  is_curriculum_subscriber?: Maybe<Scalars["Boolean"]["output"]>
  license_offering?: Maybe<LicenseOffering>
  logo?: Maybe<Scalars["String"]["output"]>
  members?: Maybe<MembershipConnection>
  membership_stats?: Maybe<MembershipStats>
  mentor_group?: Maybe<MentorGroup>
  mentor_group_stats?: Maybe<MentorGroupStats>
  mentor_groups?: Maybe<MentorGroupConnection>
  name: Scalars["String"]["output"]
  owner?: Maybe<User>
  owner_id?: Maybe<Scalars["Int"]["output"]>
  page?: Maybe<Page>
  pages?: Maybe<PageConnection>
  pathItems?: Maybe<PathItemConnection>
  pathwright_login_enabled?: Maybe<Scalars["Boolean"]["output"]>
  payment_requires_zip_code?: Maybe<Scalars["Boolean"]["output"]>
  platform_version?: Maybe<Scalars["Float"]["output"]>
  primary_domain?: Maybe<Scalars["String"]["output"]>
  profile?: Maybe<SchoolProfile>
  publishers?: Maybe<PublisherConnection>
  registrations?: Maybe<RegistrationConnection>
  resource?: Maybe<Resource>
  resource_license?: Maybe<ResourceLicense>
  resource_licensing_enabled?: Maybe<Scalars["Boolean"]["output"]>
  resource_stats?: Maybe<ResourceStats>
  resources?: Maybe<ResourceConnection>
  school_billing_invoice?: Maybe<SchoolBillingInvoice>
  school_billing_invoices?: Maybe<SchoolBillingInvoiceConnection>
  script_markup?: Maybe<Scalars["String"]["output"]>
  show_stripe_reconnect?: Maybe<Scalars["Boolean"]["output"]>
  sso_link?: Maybe<Scalars["String"]["output"]>
  storeLinks?: Maybe<StoreLinkConnection>
  stripe_access_token?: Maybe<Scalars["String"]["output"]>
  stripe_account_id?: Maybe<Scalars["String"]["output"]>
  stripe_publishable_api_key?: Maybe<Scalars["String"]["output"]>
  subdomain: Scalars["String"]["output"]
  subscription?: Maybe<Subscription>
  subscription_plans?: Maybe<SchoolSubscriptionPlanConnection>
  subscriptions?: Maybe<SubscriptionConnection>
  theme?: Maybe<Theme>
  /** Fakes a school invoice create. */
  upcoming_school_billing_invoice?: Maybe<SchoolBillingInvoice>
  url?: Maybe<Scalars["String"]["output"]>
  website?: Maybe<Scalars["String"]["output"]>
}

/** A Pathwright School */
export type SchoolActivityArgs = {
  action_type?: InputMaybe<ActionTypeFilter>
  after?: InputMaybe<Scalars["String"]["input"]>
  date?: InputMaybe<DateFilter>
  first: Scalars["Int"]["input"]
  group_id?: InputMaybe<Scalars["Int"]["input"]>
  interest_level?: InputMaybe<InterestLevel>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright School */
export type SchoolAuthorArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolAuthorsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  ids?: InputMaybe<IdFilter>
  manage?: InputMaybe<Scalars["Boolean"]["input"]>
  resource_author_ids?: InputMaybe<IdFilter>
  resource_author_names?: InputMaybe<StringFilter>
  resource_category_ids?: InputMaybe<IdFilter>
  resource_category_names?: InputMaybe<StringFilter>
  resource_search?: InputMaybe<Scalars["String"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolBannerArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright School */
export type SchoolBannersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  manage?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** A Pathwright School */
export type SchoolCategoriesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  ids?: InputMaybe<IdFilter>
  manage?: InputMaybe<Scalars["Boolean"]["input"]>
  resource_author_ids?: InputMaybe<IdFilter>
  resource_author_names?: InputMaybe<StringFilter>
  resource_category_ids?: InputMaybe<IdFilter>
  resource_category_names?: InputMaybe<StringFilter>
  resource_search?: InputMaybe<Scalars["String"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolCategoryArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolCouponDiscountArgs = {
  code: Scalars["String"]["input"]
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  resource_license_offering_id?: InputMaybe<Scalars["Int"]["input"]>
  school_subscription_plan_id?: InputMaybe<Scalars["Int"]["input"]>
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright School */
export type SchoolCurriculum_PlansArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  visibility_code?: InputMaybe<Scalars["String"]["input"]>
  visibility_code_filter?: InputMaybe<StringFilter>
}

/** A Pathwright School */
export type SchoolCurriculum_SubscriptionArgs = {
  id: Scalars["Int"]["input"]
}

/** A Pathwright School */
export type SchoolCurriculum_SubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  licensee_id?: InputMaybe<IdFilter>
  licensor_id?: InputMaybe<IdFilter>
}

/** A Pathwright School */
export type SchoolGift_SubscriptionArgs = {
  code?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright School */
export type SchoolImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright School */
export type SchoolLicense_OfferingArgs = {
  id: Scalars["Int"]["input"]
  licensing_mode?: InputMaybe<LicenseOfferingLicensingMode>
}

/** A Pathwright School */
export type SchoolLogoArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright School */
export type SchoolMembersArgs = {
  access_revoked_date_filter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  after?: InputMaybe<Scalars["String"]["input"]>
  archived_date_filter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  daysInactive?: InputMaybe<Scalars["Int"]["input"]>
  first: Scalars["Int"]["input"]
  global?: InputMaybe<Scalars["Boolean"]["input"]>
  hasAccess?: InputMaybe<Scalars["Boolean"]["input"]>
  orderBy?: InputMaybe<Scalars["String"]["input"]>
  role_filter?: InputMaybe<Array<InputMaybe<MembershipRoleFilter>>>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolMentor_GroupArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolMentor_GroupsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  descendant_of_parent_id?: InputMaybe<EquivalenceIdFilter>
  first: Scalars["Int"]["input"]
  id?: InputMaybe<IdFilter>
  parent_id?: InputMaybe<IdFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  seat_limit?: InputMaybe<Scalars["Int"]["input"]>
  seat_limit_filter?: InputMaybe<IntFilter>
  top_level_only?: InputMaybe<Scalars["Boolean"]["input"]>
  type?: InputMaybe<MentorGroupType>
}

/** A Pathwright School */
export type SchoolPageArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  is_live?: InputMaybe<Scalars["Boolean"]["input"]>
  page_type?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolPagesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  is_live?: InputMaybe<Scalars["Boolean"]["input"]>
  show_in_nav?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** A Pathwright School */
export type SchoolPathItemsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  archivedDateFilter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  due?: InputMaybe<DateFilter>
  exclude_default?: InputMaybe<Scalars["Boolean"]["input"]>
  first: Scalars["Int"]["input"]
  group_id?: InputMaybe<Scalars["Int"]["input"]>
  is_complete?: InputMaybe<Scalars["Boolean"]["input"]>
  is_required?: InputMaybe<Scalars["Boolean"]["input"]>
  is_reviewed?: InputMaybe<Scalars["Boolean"]["input"]>
  is_skipped?: InputMaybe<Scalars["Boolean"]["input"]>
  lesson_source_id?: InputMaybe<Scalars["Int"]["input"]>
  needs_attention?: InputMaybe<Scalars["Boolean"]["input"]>
  needs_review?: InputMaybe<Scalars["Boolean"]["input"]>
  next?: InputMaybe<Scalars["Boolean"]["input"]>
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  registration_role_filter?: InputMaybe<RoleFilter>
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
  reviewable?: InputMaybe<Scalars["Boolean"]["input"]>
  root_level?: InputMaybe<Scalars["Boolean"]["input"]>
  source_id?: InputMaybe<Scalars["Int"]["input"]>
  starts?: InputMaybe<DateFilter>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<PathItemTypes>
  upcoming?: InputMaybe<Scalars["Boolean"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
  with_dates?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** A Pathwright School */
export type SchoolPublishersArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A Pathwright School */
export type SchoolRegistrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  completion_state?: InputMaybe<CompletionStateFilter>
  created?: InputMaybe<DateFilter>
  first: Scalars["Int"]["input"]
  has_parent_registration?: InputMaybe<Scalars["Boolean"]["input"]>
  lastSeen?: InputMaybe<DateFilter>
  last_active?: InputMaybe<DateFilter>
  orderBy?: InputMaybe<Array<InputMaybe<RegistrationOrderByInput>>>
  parent_cohort_filter?: InputMaybe<IdFilter>
  positioningContext?: InputMaybe<PositioningContextInput>
  progress_filter?: InputMaybe<ProgressFilter>
  role?: InputMaybe<RegistrationRoleEnum>
  role_filter?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  send_discussion_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  send_due_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  softArchived?: InputMaybe<DateFilter>
}

/** A Pathwright School */
export type SchoolResourceArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolResource_LicenseArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>
  license_offering_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A Pathwright School */
export type SchoolResourcesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  assign_config?: InputMaybe<AssignConfig>
  author_id?: InputMaybe<Scalars["Int"]["input"]>
  author_ids?: InputMaybe<IdFilter>
  author_names?: InputMaybe<StringFilter>
  author_search?: InputMaybe<Scalars["String"]["input"]>
  category_id?: InputMaybe<Scalars["Int"]["input"]>
  category_ids?: InputMaybe<IdFilter>
  category_names?: InputMaybe<StringFilter>
  category_search?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  has_certificate?: InputMaybe<Scalars["Boolean"]["input"]>
  id?: InputMaybe<IdFilter>
  license_offering_licensing_mode?: InputMaybe<LicenseOfferingLicensingMode>
  licensed_from_school?: InputMaybe<IdFilter>
  orderBy?: InputMaybe<Scalars["String"]["input"]>
  publisher_id?: InputMaybe<Scalars["Int"]["input"]>
  publisher_ids?: InputMaybe<IdFilter>
  resource_types?: InputMaybe<ResourceTypeFilter>
  role?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  user_registered?: InputMaybe<IdFilter>
  visibility?: InputMaybe<ResourceVisibility>
}

/** A Pathwright School */
export type SchoolSchool_Billing_InvoiceArgs = {
  id: Scalars["Int"]["input"]
}

/** A Pathwright School */
export type SchoolSchool_Billing_InvoicesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A Pathwright School */
export type SchoolSso_LinkArgs = {
  pathname?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright School */
export type SchoolStoreLinksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  licensor_id?: InputMaybe<IdFilter>
}

/** A Pathwright School */
export type SchoolSubscriptionArgs = {
  id: Scalars["Int"]["input"]
}

/** A Pathwright School */
export type SchoolSubscription_PlansArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  giftable?: InputMaybe<Scalars["Boolean"]["input"]>
  ids?: InputMaybe<IdFilter>
  ignore_visibility?: InputMaybe<Scalars["Boolean"]["input"]>
  interval?: InputMaybe<SubscriptionIntervalType>
  interval_filter?: InputMaybe<SubscriptionIntervalFilter>
  orderBy?: InputMaybe<Array<InputMaybe<SchoolSubscriptionPlanOrderByInput>>>
  positioningContext?: InputMaybe<PositioningContextInput>
  visibility_code?: InputMaybe<Scalars["String"]["input"]>
  visibility_code_filter?: InputMaybe<StringFilter>
}

/** A Pathwright School */
export type SchoolSubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  payment_intent_needing_action_id?: InputMaybe<IdFilter>
}

/** A Pathwright School */
export type SchoolUrlArgs = {
  pathname?: InputMaybe<Scalars["String"]["input"]>
}

/** Pathwright School Account data */
export type SchoolAcount = {
  __typename?: "SchoolAcount"
  billing_model?: Maybe<Scalars["Int"]["output"]>
  billing_plan_set?: Maybe<SchoolBillingPlanSet>
  billing_subscription?: Maybe<SchoolBillingSubscription>
  curriculum_subscription?: Maybe<CurriculumSubscription>
  id?: Maybe<Scalars["Int"]["output"]>
  is_activated?: Maybe<Scalars["Boolean"]["output"]>
  is_activated_via_override?: Maybe<Scalars["Boolean"]["output"]>
  is_on_legacy_plan?: Maybe<Scalars["Boolean"]["output"]>
  scholarship?: Maybe<SchoolBillingScholarship>
}

/** Pathwright School Account data */
export type SchoolAcountBilling_Plan_SetArgs = {
  default?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** School Billing Block used for invoicing */
export type SchoolBillingBlock = {
  __typename?: "SchoolBillingBlock"
  block_size?: Maybe<Scalars["Int"]["output"]>
  block_type?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  price?: Maybe<Scalars["Float"]["output"]>
}

/** A connection to a list of items. */
export type SchoolBillingBlockConnection = {
  __typename?: "SchoolBillingBlockConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SchoolBillingBlockEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type SchoolBillingBlockEdge = {
  __typename?: "SchoolBillingBlockEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<SchoolBillingBlock>
}

/** Pathwright School Billing Invoice */
export type SchoolBillingInvoice = {
  __typename?: "SchoolBillingInvoice"
  child_subscriptions?: Maybe<Scalars["JSON"]["output"]>
  cycle_end?: Maybe<Scalars["DateTime"]["output"]>
  cycle_start?: Maybe<Scalars["DateTime"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  invoice_json?: Maybe<Scalars["JSON"]["output"]>
  invoiced_date?: Maybe<Scalars["DateTime"]["output"]>
  is_initial_prepaid_invoice?: Maybe<Scalars["Boolean"]["output"]>
  is_overdue?: Maybe<Scalars["Boolean"]["output"]>
  parent_subscription?: Maybe<Scalars["JSON"]["output"]>
  payment?: Maybe<Scalars["JSON"]["output"]>
  stripe_invoice_id?: Maybe<Scalars["String"]["output"]>
  stripe_invoice_status?: Maybe<Scalars["String"]["output"]>
  stripe_next_payment_attempt?: Maybe<Scalars["DateTime"]["output"]>
  total_amount_billed?: Maybe<Scalars["Float"]["output"]>
  url?: Maybe<Scalars["String"]["output"]>
}

/** A connection to a list of items. */
export type SchoolBillingInvoiceConnection = {
  __typename?: "SchoolBillingInvoiceConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SchoolBillingInvoiceEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type SchoolBillingInvoiceEdge = {
  __typename?: "SchoolBillingInvoiceEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<SchoolBillingInvoice>
}

/** Pathwright School Subscription Plans Data */
export type SchoolBillingPlan = {
  __typename?: "SchoolBillingPlan"
  amount: Scalars["Float"]["output"]
  billing_blocks?: Maybe<SchoolBillingBlockConnection>
  cohorts_included: Scalars["Int"]["output"]
  color: Scalars["String"]["output"]
  description: Scalars["String"]["output"]
  features: Array<SchoolBillingPlanFeature>
  fee_per_additional_learner: Scalars["Float"]["output"]
  id: Scalars["Int"]["output"]
  image: Scalars["String"]["output"]
  learner_counting_method: Scalars["Int"]["output"]
  learners_included: Scalars["Int"]["output"]
  mentor_groups_included: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  order: Scalars["Int"]["output"]
  plan_derived_from?: Maybe<SchoolBillingPlan>
  scholarships_available: Scalars["Boolean"]["output"]
  should_contact_for_pricing: Scalars["Boolean"]["output"]
  staff_included: Scalars["Int"]["output"]
  visibility: Visibility
}

/** Pathwright School Subscription Plans Data */
export type SchoolBillingPlanBilling_BlocksArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  block_type?: InputMaybe<Scalars["Int"]["input"]>
  first: Scalars["Int"]["input"]
}

/** School Billing Plan Feature Data */
export type SchoolBillingPlanFeature = {
  __typename?: "SchoolBillingPlanFeature"
  description: Scalars["String"]["output"]
  feature_type: Scalars["Int"]["output"]
  icon: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  key: Scalars["String"]["output"]
  link: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  order: Scalars["Int"]["output"]
  platform_version: Scalars["Float"]["output"]
}

/** School Billing Plan Set Data */
export type SchoolBillingPlanSet = {
  __typename?: "SchoolBillingPlanSet"
  id?: Maybe<Scalars["Int"]["output"]>
  is_default?: Maybe<Scalars["Boolean"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  plans?: Maybe<Array<Maybe<SchoolBillingPlan>>>
}

/** Pathwright School Billing Scholarship */
export type SchoolBillingScholarship = {
  __typename?: "SchoolBillingScholarship"
  coupon?: Maybe<StripeCoupon>
  ends?: Maybe<Scalars["DateTime"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  interval?: Maybe<Interval>
  iterations?: Maybe<Scalars["Int"]["output"]>
  order?: Maybe<Scalars["Int"]["output"]>
  plan_id?: Maybe<Scalars["Int"]["output"]>
  starts?: Maybe<Scalars["DateTime"]["output"]>
}

/** Pathwright School Subscription Data */
export type SchoolBillingSubscription = {
  __typename?: "SchoolBillingSubscription"
  charge_type?: Maybe<SubscriptionChargeType>
  child_subscriptions?: Maybe<SchoolBillingSubscriptionConnection>
  extra_cohorts?: Maybe<Scalars["Int"]["output"]>
  extra_mentor_groups?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  interval?: Maybe<SubscriptionIntervalType>
  parent_subscription_id?: Maybe<Scalars["Int"]["output"]>
  plan?: Maybe<SchoolBillingPlan>
  school?: Maybe<School>
  school_id?: Maybe<Scalars["Int"]["output"]>
  subscription?: Maybe<Subscription>
}

/** Pathwright School Subscription Data */
export type SchoolBillingSubscriptionChild_SubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A connection to a list of items. */
export type SchoolBillingSubscriptionConnection = {
  __typename?: "SchoolBillingSubscriptionConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SchoolBillingSubscriptionEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type SchoolBillingSubscriptionEdge = {
  __typename?: "SchoolBillingSubscriptionEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<SchoolBillingSubscription>
}

/** A connection to a list of items. */
export type SchoolConnection = {
  __typename?: "SchoolConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SchoolEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** A school licensing school curriculum subscription plan */
export type SchoolCurriculumPlan = {
  __typename?: "SchoolCurriculumPlan"
  amount?: Maybe<Scalars["Float"]["output"]>
  fee_boundary?: Maybe<Scalars["Int"]["output"]>
  fee_per_user?: Maybe<Scalars["Int"]["output"]>
  id: Scalars["Int"]["output"]
  is_visible?: Maybe<Scalars["Boolean"]["output"]>
  licensor: School
  lower_boundary?: Maybe<Scalars["Int"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  plan_id?: Maybe<Scalars["Int"]["output"]>
  transaction_fee_percent?: Maybe<Scalars["Int"]["output"]>
  upper_boundary?: Maybe<Scalars["Int"]["output"]>
  visibility_code?: Maybe<Scalars["String"]["output"]>
}

/** A connection to a list of items. */
export type SchoolCurriculumPlanConnection = {
  __typename?: "SchoolCurriculumPlanConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SchoolCurriculumPlanEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type SchoolCurriculumPlanEdge = {
  __typename?: "SchoolCurriculumPlanEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<SchoolCurriculumPlan>
}

/** An edge in a connection. */
export type SchoolEdge = {
  __typename?: "SchoolEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<School>
}

/** A list of all features that the school may or may not have access to, with a value indicating whether or not the school has access */
export type SchoolFeatures = {
  __typename?: "SchoolFeatures"
  /** Allows users of a Space to use the Auth Request (via email) feature. */
  auth__login_option__email_link: Scalars["Boolean"]["output"]
  /** Allows users of a Space to use the Apple SSO feature. */
  auth__login_option__global_sso__apple: Scalars["Boolean"]["output"]
  /** Allows users of a Space to use the Google SSO feature. */
  auth__login_option__global_sso__google: Scalars["Boolean"]["output"]
  /** Allows users of a Space to use the Password login feature. */
  auth__login_option__password: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Paths Auth feature. */
  auth__platform: Scalars["Boolean"]["output"]
  /** Allows cohort members to view activity of other members. */
  cohort__activity_feed: Scalars["Boolean"]["output"]
  /** Allows cohort members to view other members in the cohort community. */
  cohort__member_directory: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Community Groups feature. */
  community__groups: Scalars["Boolean"]["output"]
  /** Allows a Space to use the new (unified) Home Screen. */
  home_screen__unified: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Add to Path feature. */
  library__add_to_path: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Collections feature. */
  library__collections: Scalars["Boolean"]["output"]
  /** Allows a Space to enable cover pages for their library. */
  library__cover_pages: Scalars["Boolean"]["output"]
  /** Allows a Space to enable downloadable/offline videos for their users. */
  media__downloadable_videos: Scalars["Boolean"]["output"]
  /** Allows a Space to use sync a Path to paths.app. */
  paths_app__publish: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Share Card feature. */
  school__share_card: Scalars["Boolean"]["output"]
}

export type SchoolGiftSubscription = {
  __typename?: "SchoolGiftSubscription"
  gift_code?: Maybe<Scalars["String"]["output"]>
  gift_message?: Maybe<Scalars["String"]["output"]>
  gifted_subscription_cycles?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  recipient_email?: Maybe<Scalars["String"]["output"]>
  recipient_email_sent_time?: Maybe<Scalars["DateTime"]["output"]>
  recipient_first_name?: Maybe<Scalars["String"]["output"]>
  recipient_last_name?: Maybe<Scalars["String"]["output"]>
  redeemed?: Maybe<Scalars["Boolean"]["output"]>
  redemption_link?: Maybe<Scalars["String"]["output"]>
  school_subscription_plan?: Maybe<SchoolSubscriptionPlan>
  sender?: Maybe<User>
}

/** A School Group Subscription */
export type SchoolGroupSubscription = {
  __typename?: "SchoolGroupSubscription"
  community_group?: Maybe<MentorGroup>
  id?: Maybe<Scalars["Int"]["output"]>
  price?: Maybe<StripePrice>
  school?: Maybe<School>
  subscription?: Maybe<Subscription>
  user?: Maybe<User>
}

/** A connection to a list of items. */
export type SchoolGroupSubscriptionConnection = {
  __typename?: "SchoolGroupSubscriptionConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SchoolGroupSubscriptionEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type SchoolGroupSubscriptionEdge = {
  __typename?: "SchoolGroupSubscriptionEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<SchoolGroupSubscription>
}

export type SchoolProfile = {
  __typename?: "SchoolProfile"
  id?: Maybe<Scalars["Int"]["output"]>
  plan_to_sell?: Maybe<Scalars["Boolean"]["output"]>
  school_type?: Maybe<SchoolType>
}

/** A School Subscription */
export type SchoolSubscription = {
  __typename?: "SchoolSubscription"
  id?: Maybe<Scalars["Int"]["output"]>
  school_subscription_plan?: Maybe<SchoolSubscriptionPlan>
  subscription?: Maybe<Subscription>
  subscription_plan?: Maybe<SubscriptionPlan>
  user?: Maybe<User>
}

export type SchoolSubscriptionDiscount = {
  __typename?: "SchoolSubscriptionDiscount"
  currency_display_discount_amount?: Maybe<Scalars["String"]["output"]>
  currency_display_discount_price?: Maybe<Scalars["String"]["output"]>
  discount_percent?: Maybe<Scalars["Float"]["output"]>
  discounted_price?: Maybe<Scalars["Float"]["output"]>
  discounted_subscription_cycles?: Maybe<Scalars["Int"]["output"]>
}

/** School subscription order data */
export type SchoolSubscriptionOrderData = {
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
  plan_id: Scalars["Int"]["input"]
  plan_visibility_code?: InputMaybe<Scalars["String"]["input"]>
  redirect_to?: InputMaybe<Scalars["String"]["input"]>
  start_free_trial?: InputMaybe<Scalars["Boolean"]["input"]>
}

/** A School Subscription Plan */
export type SchoolSubscriptionPlan = {
  __typename?: "SchoolSubscriptionPlan"
  catalog_header?: Maybe<Scalars["String"]["output"]>
  details_html?: Maybe<Scalars["String"]["output"]>
  giftable_cycles?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>
  id?: Maybe<Scalars["Int"]["output"]>
  image?: Maybe<Scalars["String"]["output"]>
  is_visible?: Maybe<Scalars["Boolean"]["output"]>
  /** The contextual position for this object based on the `positioningContext` arg. */
  position: Scalars["String"]["output"]
  subscribe_complete_html?: Maybe<Scalars["String"]["output"]>
  subscription_plan?: Maybe<SubscriptionPlan>
}

/** A connection to a list of items. */
export type SchoolSubscriptionPlanConnection = {
  __typename?: "SchoolSubscriptionPlanConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SchoolSubscriptionPlanEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type SchoolSubscriptionPlanEdge = {
  __typename?: "SchoolSubscriptionPlanEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<SchoolSubscriptionPlan>
}

/** Input for ordering the list. */
export type SchoolSubscriptionPlanOrderByInput = {
  /** Order by id. */
  id?: InputMaybe<OrderByDir>
  /** Order by position. */
  position?: InputMaybe<OrderByDir>
}

export enum SchoolType {
  CoachTutor = "coach_tutor",
  CurriculumPublisher = "curriculum_publisher",
  CustomerTraining = "customer_training",
  HigherEd = "higher_ed",
  K12 = "k12",
  Ministry = "ministry",
  NonProfit = "non_profit",
  Other = "other",
  ProfessionalDevelopment = "professional_development",
  Training = "training",
  Unspecified = "unspecified"
}

export enum ShareAccessPermission {
  Full = "FULL",
  Gated = "GATED",
  None = "NONE"
}

/** The current user's share permissions pertaining to provided context. */
export type ShareCohortPermissions = {
  __typename?: "ShareCohortPermissions"
  /** The email of the user to contact for activating school on a Pathwright plan. */
  activate_contact_email?: Maybe<Scalars["EmailAddress"]["output"]>
  /** The maximum number, if any, of users that may be added. */
  add_limit?: Maybe<Scalars["Int"]["output"]>
  /** Whether user can activate school on a Pathwright plan. */
  allow_activate?: Maybe<Scalars["Boolean"]["output"]>
  /** Whether user can manage settings for the [type/type_id] item. */
  allow_manage?: Maybe<Scalars["Boolean"]["output"]>
  invite_to_roles?: Maybe<ShareCohortPermissionsInviteToRoles>
  /** The settings URL for the [type/type_id] item. */
  manage_url?: Maybe<Scalars["String"]["output"]>
  /** Whether user can use share UI. */
  share_access?: Maybe<CohortShareAccess>
  /** Whether user can use share > add UI. */
  share_add_access?: Maybe<CohortShareAddAccess>
  /** Whether user can use share > link UI. */
  share_link_access?: Maybe<CohortShareLinkAccess>
  /** Whether user can use share > track UI. */
  share_track_access?: Maybe<CohortShareTrackAccess>
  type?: Maybe<ShareContextType>
  type_id?: Maybe<Scalars["Int"]["output"]>
}

export type ShareCohortPermissionsInviteToRoles = {
  __typename?: "ShareCohortPermissionsInviteToRoles"
  course_editor?: Maybe<Scalars["String"]["output"]>
  learner?: Maybe<Scalars["String"]["output"]>
  moderator?: Maybe<Scalars["String"]["output"]>
  observer?: Maybe<Scalars["String"]["output"]>
  teacher?: Maybe<Scalars["String"]["output"]>
  viewer?: Maybe<Scalars["String"]["output"]>
}

export type ShareContext = {
  /** The type of the context in which the user has the permission (defaults to school). */
  type: ShareContextType
  /** The id of the type. */
  type_id?: InputMaybe<Scalars["Int"]["input"]>
}

export enum ShareContextType {
  Cohort = "cohort",
  Group = "group",
  School = "school"
}

/** The current user's share permissions pertaining to provided context. */
export type ShareGroupPermissions = {
  __typename?: "ShareGroupPermissions"
  /** The email of the user to contact for activating school on a Pathwright plan. */
  activate_contact_email?: Maybe<Scalars["EmailAddress"]["output"]>
  /** The maximum number, if any, of users that may be added. */
  add_limit?: Maybe<Scalars["Int"]["output"]>
  /** Whether user can activate school on a Pathwright plan. */
  allow_activate?: Maybe<Scalars["Boolean"]["output"]>
  /** Whether user can manage settings for the [type/type_id] item. */
  allow_manage?: Maybe<Scalars["Boolean"]["output"]>
  invite_to_roles?: Maybe<ShareGroupPermissionsInviteToRoles>
  /** The settings URL for the [type/type_id] item. */
  manage_url?: Maybe<Scalars["String"]["output"]>
  /** Whether user can use share UI. */
  share_access?: Maybe<GroupShareAccess>
  /** Whether user can use share > add UI. */
  share_add_access?: Maybe<GroupShareAddAccess>
  /** Whether user can use share > link UI. */
  share_link_access?: Maybe<GroupShareLinkAccess>
  /** Whether user can use share > track UI. */
  share_track_access?: Maybe<GroupShareTrackAccess>
  type?: Maybe<ShareContextType>
  type_id?: Maybe<Scalars["Int"]["output"]>
}

export type ShareGroupPermissionsInviteToRoles = {
  __typename?: "ShareGroupPermissionsInviteToRoles"
  admin?: Maybe<Scalars["String"]["output"]>
  member?: Maybe<Scalars["String"]["output"]>
  moderator?: Maybe<Scalars["String"]["output"]>
}

/** The current user's share permissions pertaining to provided context. */
export type SharePermissions = ShareCohortPermissions | ShareGroupPermissions

export type Space = {
  __typename?: "Space"
  /** Whether new users can sign up without an invitation. */
  allow_public_signup?: Maybe<Scalars["Boolean"]["output"]>
  /** Signifies whether a Space allows a user to join as a member */
  allow_signup: Scalars["Boolean"]["output"]
  /** Whether to prompt users to enter a password when signing up. */
  always_prompt_for_password?: Maybe<Scalars["Boolean"]["output"]>
  authMethods: Array<AuthMethod>
  /** Description of consent from user for space to do xy and z. */
  consent_description?: Maybe<Scalars["String"]["output"]>
  created: Scalars["String"]["output"]
  features: SpaceFeatures
  id: Scalars["Int"]["output"]
  ietf_language_tag?: Maybe<Scalars["String"]["output"]>
  image: Scalars["String"]["output"]
  is_activated: Scalars["Boolean"]["output"]
  is_owner: Scalars["Boolean"]["output"]
  logo_image?: Maybe<Scalars["String"]["output"]>
  media?: Maybe<Array<Maybe<SpaceMedia>>>
  meta: NodeMeta
  name: Scalars["String"]["output"]
  /** Whether Pathwright Sign-in options (currently Password and Magic Link) are available. */
  pathwright_login_enabled?: Maybe<Scalars["Boolean"]["output"]>
  primary_domain?: Maybe<Scalars["String"]["output"]>
  subdomain: Scalars["String"]["output"]
  theme: NodeTheme
}

export type SpaceAllow_SignupArgs = {
  invite_token?: InputMaybe<Scalars["String"]["input"]>
}

export type SpaceImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

export type SpaceConnection = {
  __typename?: "SpaceConnection"
  last_activity_date?: Maybe<Scalars["DateTime"]["output"]>
  role: Scalars["Int"]["output"]
  space: Space
}

/** A connection to a list of items. */
export type SpaceConnectionConnection = {
  __typename?: "SpaceConnectionConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SpaceConnectionEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type SpaceConnectionEdge = {
  __typename?: "SpaceConnectionEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<SpaceConnection>
}

/** A list of all features that the space may or may not have access to, with a value indicating whether or not the space has access */
export type SpaceFeatures = {
  __typename?: "SpaceFeatures"
  /** Allows users of a Space to use the Auth Request (via email) feature. */
  auth__login_option__email_link: Scalars["Boolean"]["output"]
  /** Allows users of a Space to use the Apple SSO feature. */
  auth__login_option__global_sso__apple: Scalars["Boolean"]["output"]
  /** Allows users of a Space to use the Google SSO feature. */
  auth__login_option__global_sso__google: Scalars["Boolean"]["output"]
  /** Allows users of a Space to use the Password login feature. */
  auth__login_option__password: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Paths Auth feature. */
  auth__platform: Scalars["Boolean"]["output"]
  /** Allows cohort members to view activity of other members. */
  cohort__activity_feed: Scalars["Boolean"]["output"]
  /** Allows cohort members to view other members in the cohort community. */
  cohort__member_directory: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Community Groups feature. */
  community__groups: Scalars["Boolean"]["output"]
  /** Allows a Space to use the new (unified) Home Screen. */
  home_screen__unified: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Add to Path feature. */
  library__add_to_path: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Collections feature. */
  library__collections: Scalars["Boolean"]["output"]
  /** Allows a Space to enable cover pages for their library. */
  library__cover_pages: Scalars["Boolean"]["output"]
  /** Allows a Space to enable downloadable/offline videos for their users. */
  media__downloadable_videos: Scalars["Boolean"]["output"]
  /** Allows a Space to use sync a Path to paths.app. */
  paths_app__publish: Scalars["Boolean"]["output"]
  /** Allows a Space to use the Share Card feature. */
  school__share_card: Scalars["Boolean"]["output"]
}

export type SpaceMedia = {
  __typename?: "SpaceMedia"
  meta: NodeMeta
}

export type StepContent = {
  __typename?: "StepContent"
  data?: Maybe<Scalars["JSON"]["output"]>
  id?: Maybe<Scalars["String"]["output"]>
  method?: Maybe<Scalars["String"]["output"]>
  type?: Maybe<Scalars["String"]["output"]>
}

/** The context this step belongs to (resource and cohort) */
export type StepContext = {
  __typename?: "StepContext"
  cohort_id?: Maybe<Scalars["Int"]["output"]>
  resource_id?: Maybe<Scalars["Int"]["output"]>
  school_id?: Maybe<Scalars["Int"]["output"]>
}

export type Store = {
  __typename?: "Store"
  id: Scalars["Int"]["output"]
  /** The school providing the curriculum */
  licensor: School
}

export type StoreBanner = {
  __typename?: "StoreBanner"
  button_text?: Maybe<Scalars["String"]["output"]>
  button_url?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  meta: NodeMeta
  theme: NodeTheme
}

export type StoreCollection = {
  __typename?: "StoreCollection"
  id?: Maybe<Scalars["Int"]["output"]>
  items?: Maybe<StoreItemConnection>
  meta: NodeMeta
  theme: NodeTheme
}

export type StoreCollectionItemsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  author_id?: InputMaybe<Scalars["Int"]["input"]>
  category_id?: InputMaybe<Scalars["Int"]["input"]>
  first: Scalars["Int"]["input"]
}

export type StoreItem = {
  __typename?: "StoreItem"
  authors?: Maybe<AuthorConnection>
  category_ids: Array<Maybe<Scalars["Int"]["output"]>>
  description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  meta: NodeMeta
  options: Array<Maybe<StoreItemOption>>
  short_description?: Maybe<Scalars["String"]["output"]>
  theme: NodeTheme
}

export type StoreItemAuthorsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A connection to a list of items. */
export type StoreItemConnection = {
  __typename?: "StoreItemConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StoreItemEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type StoreItemEdge = {
  __typename?: "StoreItemEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<StoreItem>
}

export type StoreItemOption = {
  __typename?: "StoreItemOption"
  id?: Maybe<Scalars["Int"]["output"]>
  meta: NodeMeta
  path_id?: Maybe<Scalars["Int"]["output"]>
  price?: Maybe<Scalars["Int"]["output"]>
}

export type StoreLink = {
  __typename?: "StoreLink"
  id: Scalars["Int"]["output"]
  /** The school licensing the curriculum */
  licensee: School
  /** The store through which curriculum can be licensed */
  store: Store
}

/** A connection to a list of items. */
export type StoreLinkConnection = {
  __typename?: "StoreLinkConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StoreLinkEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type StoreLinkEdge = {
  __typename?: "StoreLinkEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<StoreLink>
}

export type Storefront = {
  __typename?: "Storefront"
  id: Scalars["String"]["output"]
  meta: NodeMeta
}

export type StringFilter = {
  eq?: InputMaybe<Scalars["String"]["input"]>
  gt?: InputMaybe<Scalars["String"]["input"]>
  gte?: InputMaybe<Scalars["String"]["input"]>
  in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  lt?: InputMaybe<Scalars["String"]["input"]>
  lte?: InputMaybe<Scalars["String"]["input"]>
  neq?: InputMaybe<Scalars["String"]["input"]>
  nin?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export enum StripeBillingScheme {
  PerUnit = "per_unit",
  Tiered = "tiered"
}

/** Represents a Coupon for a Subscription on Stripe. Used for Scholarships. */
export type StripeCoupon = {
  __typename?: "StripeCoupon"
  id?: Maybe<Scalars["Int"]["output"]>
  percent_off?: Maybe<Scalars["Float"]["output"]>
}

/** Represents a Price for a Product on Stripe that specifies pricing configuration. */
export type StripePrice = {
  __typename?: "StripePrice"
  active?: Maybe<Scalars["Boolean"]["output"]>
  billing_scheme?: Maybe<StripeBillingScheme>
  currency?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  nickname?: Maybe<Scalars["String"]["output"]>
  product?: Maybe<StripeProduct>
  recurring_interval?: Maybe<StripeRecurringInterval>
  recurring_interval_count?: Maybe<Scalars["Int"]["output"]>
  /** The URL to the connected Stripe dashboard for this price. */
  stripe_connected_account_url?: Maybe<Scalars["String"]["output"]>
  stripe_price_id?: Maybe<Scalars["String"]["output"]>
  tiers?: Maybe<Array<Maybe<StripeTier>>>
  tiers_mode?: Maybe<StripeTiersMode>
  unit_amount_decimal?: Maybe<Scalars["Float"]["output"]>
}

/** A connection to a list of items. */
export type StripePriceConnection = {
  __typename?: "StripePriceConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StripePriceEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type StripePriceEdge = {
  __typename?: "StripePriceEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<StripePrice>
}

/** Represents a Product on Stripe that can be sold. */
export type StripeProduct = {
  __typename?: "StripeProduct"
  active?: Maybe<Scalars["Boolean"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  images?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>
  max_quantity?: Maybe<Scalars["Int"]["output"]>
  min_quantity?: Maybe<Scalars["Int"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  processor?: Maybe<School>
  /** The URL to the connected Stripe dashboard for this product. */
  stripe_connected_account_url?: Maybe<Scalars["String"]["output"]>
  stripe_prices?: Maybe<StripePriceConnection>
  stripe_product_id?: Maybe<Scalars["String"]["output"]>
  unit_label?: Maybe<Scalars["String"]["output"]>
}

/** Represents a Product on Stripe that can be sold. */
export type StripeProductStripe_PricesArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** A connection to a list of items. */
export type StripeProductConnection = {
  __typename?: "StripeProductConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StripeProductEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type StripeProductEdge = {
  __typename?: "StripeProductEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<StripeProduct>
}

export enum StripeRecurringInterval {
  Day = "day",
  Month = "month",
  Week = "week",
  Year = "year"
}

export type StripeTier = {
  __typename?: "StripeTier"
  flat_amount?: Maybe<Scalars["Int"]["output"]>
  flat_amount_decimal?: Maybe<Scalars["String"]["output"]>
  unit_amount?: Maybe<Scalars["Int"]["output"]>
  unit_amount_decimal?: Maybe<Scalars["String"]["output"]>
  up_to?: Maybe<Scalars["Int"]["output"]>
}

export enum StripeTiersMode {
  Graduated = "graduated",
  Volume = "volume"
}

export type Subdomain = {
  __typename?: "Subdomain"
  id?: Maybe<Scalars["Int"]["output"]>
  subdomain?: Maybe<Scalars["String"]["output"]>
}

/** Subscription Data */
export type Subscription = {
  __typename?: "Subscription"
  canceled_dtime?: Maybe<Scalars["DateTime"]["output"]>
  cancellation_reason?: Maybe<Scalars["Int"]["output"]>
  card_last_4?: Maybe<Scalars["String"]["output"]>
  customer?: Maybe<User>
  cycle_end_dtime?: Maybe<Scalars["DateTime"]["output"]>
  cycle_start_dtime?: Maybe<Scalars["DateTime"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  is_canceled_at_cycle_end?: Maybe<Scalars["Boolean"]["output"]>
  is_delinquent?: Maybe<Scalars["Boolean"]["output"]>
  paused_until_dtime?: Maybe<Scalars["DateTime"]["output"]>
  /** The client_secret set on the payment intent associated with this subscription (if subscription.payment_intent_needing_action_id is not null). */
  payment_intent_client_secret?: Maybe<Scalars["String"]["output"]>
  payment_intent_needing_action_id?: Maybe<Scalars["String"]["output"]>
  quantity?: Maybe<Scalars["Int"]["output"]>
  /** Used in conjunction with the payment_intent_client_secret to execute the handleCardAction via Stripe.js. */
  stripe_publishable_api_key?: Maybe<Scalars["String"]["output"]>
  subscription_plan?: Maybe<SubscriptionPlan>
  trial_end_dtime?: Maybe<Scalars["DateTime"]["output"]>
  trial_type?: Maybe<Scalars["Int"]["output"]>
}

export enum SubscriptionChargeType {
  Invoice = "invoice",
  NoCharge = "no_charge",
  PathwrightTeam = "pathwright_team",
  Stripe = "stripe"
}

/** A connection to a list of items. */
export type SubscriptionConnection = {
  __typename?: "SubscriptionConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubscriptionEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type SubscriptionEdge = {
  __typename?: "SubscriptionEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Subscription>
}

export type SubscriptionIntervalFilter = {
  eq?: InputMaybe<SubscriptionIntervalType>
  gt?: InputMaybe<SubscriptionIntervalType>
  gte?: InputMaybe<SubscriptionIntervalType>
  in?: InputMaybe<Array<InputMaybe<SubscriptionIntervalType>>>
  lt?: InputMaybe<SubscriptionIntervalType>
  lte?: InputMaybe<SubscriptionIntervalType>
  neq?: InputMaybe<SubscriptionIntervalType>
  nin?: InputMaybe<Array<InputMaybe<SubscriptionIntervalType>>>
  op?: InputMaybe<Scalars["String"]["input"]>
}

export enum SubscriptionIntervalType {
  Biannually = "biannually",
  Lifetime = "lifetime",
  Monthly = "monthly",
  Yearly = "yearly"
}

/** Payment Subscription Plan Data */
export type SubscriptionPlan = {
  __typename?: "SubscriptionPlan"
  amount?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  interval?: Maybe<Scalars["Int"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  plan_type?: Maybe<Scalars["String"]["output"]>
  /** The URL to the connected Stripe dashboard for this plan. */
  stripe_connected_account_url?: Maybe<Scalars["String"]["output"]>
  trial_period_days?: Maybe<Scalars["Int"]["output"]>
  trial_type?: Maybe<Scalars["Int"]["output"]>
}

/** A generic tag */
export type Tag = {
  __typename?: "Tag"
  color?: Maybe<Scalars["String"]["output"]>
  description?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  school?: Maybe<School>
  slug?: Maybe<Scalars["String"]["output"]>
  tagAttachment?: Maybe<TagAttachment>
  tagAttachments?: Maybe<TagAttachmentConnection>
}

/** A generic tag */
export type TagTagAttachmentArgs = {
  context?: InputMaybe<TagAttachmentContextInput>
  id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A generic tag */
export type TagTagAttachmentsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  context?: InputMaybe<TagAttachmentContextInput>
  first: Scalars["Int"]["input"]
  tag_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** A tag attachment provides a means of attaching a tag to a context. */
export type TagAttachment = {
  __typename?: "TagAttachment"
  id?: Maybe<Scalars["Int"]["output"]>
  position?: Maybe<Scalars["String"]["output"]>
  resource?: Maybe<Resource>
  resource_id?: Maybe<Scalars["Int"]["output"]>
  school?: Maybe<School>
  school_id?: Maybe<Scalars["Int"]["output"]>
  tag?: Maybe<Tag>
  tag_id?: Maybe<Scalars["Int"]["output"]>
}

/** A connection to a list of items. */
export type TagAttachmentConnection = {
  __typename?: "TagAttachmentConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TagAttachmentEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

export type TagAttachmentContextInput = {
  resource_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** An edge in a connection. */
export type TagAttachmentEdge = {
  __typename?: "TagAttachmentEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<TagAttachment>
}

/** A connection to a list of items. */
export type TagConnection = {
  __typename?: "TagConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TagEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

export type TagCreateInput = {
  color?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  name: Scalars["String"]["input"]
}

export type TagDeleteInput = {
  id: Scalars["Int"]["input"]
}

/** An edge in a connection. */
export type TagEdge = {
  __typename?: "TagEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<Tag>
}

/** A tagLink that links tags to other models within a tagAttachment context, currently only to a discussion context. */
export type TagLink = {
  __typename?: "TagLink"
  discussion_context_id?: Maybe<Scalars["Int"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  tag?: Maybe<Tag>
  tag_id?: Maybe<Scalars["Int"]["output"]>
}

/** A connection to a list of items. */
export type TagLinkConnection = {
  __typename?: "TagLinkConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TagLinkEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

export type TagLinkContextInput = {
  discussion_context_id?: InputMaybe<Scalars["Int"]["input"]>
}

/** An edge in a connection. */
export type TagLinkEdge = {
  __typename?: "TagLinkEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<TagLink>
}

export type TagUpdateInput = {
  color?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type TextObject = {
  alignment: TextObjectAlignment
  dimensions: TextObjectDimensions
  font_color: Scalars["String"]["input"]
  font_name: Scalars["String"]["input"]
  font_size: Scalars["Float"]["input"]
  gutter?: InputMaybe<Scalars["Float"]["input"]>
  letter_spacing?: InputMaybe<Scalars["Float"]["input"]>
  line_height?: InputMaybe<Scalars["Float"]["input"]>
  position: TextObjectPosition
  text: Scalars["String"]["input"]
}

export enum TextObjectAlignment {
  Center = "center",
  Left = "left",
  Right = "right"
}

export type TextObjectDimensions = {
  height: Scalars["Float"]["input"]
  width: Scalars["Float"]["input"]
}

export type TextObjectPosition = {
  left: Scalars["Float"]["input"]
  top: Scalars["Float"]["input"]
}

/** A School Theme */
export type Theme = {
  __typename?: "Theme"
  background_image?: Maybe<Scalars["String"]["output"]>
  background_overlay?: Maybe<Scalars["String"]["output"]>
  background_type?: Maybe<Scalars["Int"]["output"]>
  color_palette?: Maybe<NodeThemeColorPalette>
  custom_css?: Maybe<Scalars["String"]["output"]>
  heading_font?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  primary_color?: Maybe<Scalars["String"]["output"]>
  processed_custom_css?: Maybe<Scalars["String"]["output"]>
  theme_type?: Maybe<ThemeType>
  typekit_id?: Maybe<Scalars["String"]["output"]>
}

/** A School Theme */
export type ThemeBackground_ImageArgs = {
  balph?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
  crop?: InputMaybe<Crop>
  dpr?: InputMaybe<Scalars["Int"]["input"]>
  fit?: InputMaybe<Fit>
  fm?: InputMaybe<Scalars["String"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  width?: InputMaybe<Scalars["Int"]["input"]>
}

/** Theme attributes */
export type ThemeInput = {
  background_image?: InputMaybe<Scalars["URL"]["input"]>
  background_overlay?: InputMaybe<Scalars["String"]["input"]>
  background_type?: InputMaybe<Scalars["Int"]["input"]>
  custom_css?: InputMaybe<Scalars["String"]["input"]>
  heading_font?: InputMaybe<Scalars["String"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  primary_color?: InputMaybe<Scalars["String"]["input"]>
  theme_type?: InputMaybe<ThemeType>
}

export enum ThemeType {
  Classic = "CLASSIC",
  Creative = "CREATIVE",
  Default = "DEFAULT",
  Legacy = "LEGACY",
  Modern = "MODERN"
}

/** Auth token */
export type Token = {
  __typename?: "Token"
  created?: Maybe<Scalars["DateTime"]["output"]>
  token?: Maybe<Scalars["String"]["output"]>
  user_id?: Maybe<Scalars["Int"]["output"]>
}

/** The context of a Pathwright 'session' in a school. */
export type Translation = {
  __typename?: "Translation"
  id?: Maybe<Scalars["Int"]["output"]>
  is_default?: Maybe<Scalars["Boolean"]["output"]>
  language?: Maybe<Scalars["String"]["output"]>
  /** Returning the default english translation when the school has a custom translation. */
  master_translation?: Maybe<Scalars["JSON"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  school_translation?: Maybe<Scalars["JSON"]["output"]>
  source_translation?: Maybe<Scalars["JSON"]["output"]>
  translation?: Maybe<Scalars["JSON"]["output"]>
}

/** A Pathwright User */
export type User = {
  __typename?: "User"
  display_name?: Maybe<Scalars["String"]["output"]>
  email?: Maybe<Scalars["String"]["output"]>
  external_account_link?: Maybe<ExternalAccountLink>
  first_name: Scalars["String"]["output"]
  full_name: Scalars["String"]["output"]
  gravatar?: Maybe<Gravatar>
  group_role_stats?: Maybe<Array<Maybe<GroupRoleStats>>>
  id: Scalars["Int"]["output"]
  /** A user account setup is onl considered 'finalized' when the `first_name` and `last_name` fields have been set. */
  is_finalized?: Maybe<Scalars["Boolean"]["output"]>
  is_staff?: Maybe<Scalars["Boolean"]["output"]>
  is_superuser?: Maybe<Scalars["Boolean"]["output"]>
  last_name: Scalars["String"]["output"]
  membership?: Maybe<Membership>
  memberships?: Maybe<MembershipConnection>
  mentorGroupMemberships?: Maybe<MentorGroupMembershipConnection>
  no_password_set?: Maybe<Scalars["Boolean"]["output"]>
  /** The user's payment history */
  payment_history: PaymentHistory
  permissions?: Maybe<ContextPermissions>
  profile?: Maybe<Profile>
  registrations?: Maybe<RegistrationConnection>
  school_group_subscriptions?: Maybe<SchoolGroupSubscriptionConnection>
  school_subscription?: Maybe<SchoolSubscription>
  token?: Maybe<Token>
  username?: Maybe<Scalars["String"]["output"]>
}

/** A Pathwright User */
export type UserMembershipsArgs = {
  access_revoked_date_filter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  after?: InputMaybe<Scalars["String"]["input"]>
  archived_date_filter?: InputMaybe<Array<InputMaybe<DateFilter>>>
  daysInactive?: InputMaybe<Scalars["Int"]["input"]>
  first: Scalars["Int"]["input"]
  global?: InputMaybe<Scalars["Boolean"]["input"]>
  hasAccess?: InputMaybe<Scalars["Boolean"]["input"]>
  orderBy?: InputMaybe<Scalars["String"]["input"]>
  role_filter?: InputMaybe<Array<InputMaybe<MembershipRoleFilter>>>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright User */
export type UserMentorGroupMembershipsArgs = {
  _or?: InputMaybe<MentorGroupMembershipOr>
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  group_type?: InputMaybe<MentorGroupType>
  group_types?: InputMaybe<MentorGroupTypeFilter>
  mentor_group_seat_limit?: InputMaybe<Scalars["Int"]["input"]>
  mentor_group_seat_limit_filter?: InputMaybe<IntFilter>
  mentor_group_seats_filled?: InputMaybe<Scalars["Int"]["input"]>
  mentor_group_seats_filled_filter?: InputMaybe<IntFilter>
  order_by?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
  role?: InputMaybe<MentorGroupMembershipRoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
}

/** A Pathwright User */
export type UserRegistrationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  completion_state?: InputMaybe<CompletionStateFilter>
  created?: InputMaybe<DateFilter>
  first: Scalars["Int"]["input"]
  has_parent_registration?: InputMaybe<Scalars["Boolean"]["input"]>
  lastSeen?: InputMaybe<DateFilter>
  last_active?: InputMaybe<DateFilter>
  orderBy?: InputMaybe<Array<InputMaybe<RegistrationOrderByInput>>>
  parent_cohort_filter?: InputMaybe<IdFilter>
  positioningContext?: InputMaybe<PositioningContextInput>
  progress_filter?: InputMaybe<ProgressFilter>
  role?: InputMaybe<RegistrationRoleEnum>
  role_filter?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  send_discussion_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  send_due_notifications?: InputMaybe<Scalars["Boolean"]["input"]>
  softArchived?: InputMaybe<DateFilter>
}

/** A Pathwright User */
export type UserSchool_Group_SubscriptionsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
}

/** Input type for User. */
export type UserInput = {
  /** Email of the user. */
  email: Scalars["String"]["input"]
  /** First name of the user. */
  firstName: Scalars["String"]["input"]
  /** ID of the user. */
  id: Scalars["Int"]["input"]
  /** Last name of the user. */
  lastName: Scalars["String"]["input"]
}

/** Input type for User Profile. */
export type UserProfileInput = {
  /** Avatar URL of the user. */
  avatar?: InputMaybe<Scalars["String"]["input"]>
  /** Bio of the user. */
  bio: Scalars["String"]["input"]
  /** ID of the user profile. */
  id: Scalars["Int"]["input"]
  /** Location of the user. */
  location: Scalars["String"]["input"]
}

/** Check on the existence and verification status of any email/username. */
export type UserStatus = {
  __typename?: "UserStatus"
  /** Whether a user's email has been verified. */
  email_verified: Scalars["Boolean"]["output"]
  /** Whether a user has a membership for the Space. */
  has_membership: Scalars["Boolean"]["output"]
  /** Indicates the type of input received. */
  input_type: UserStatusInputType
  /** Whether a user has a password set. */
  no_password_set: Scalars["Boolean"]["output"]
  /** Whether the email or username exists. */
  user_exists: Scalars["Boolean"]["output"]
}

export enum UserStatusInputType {
  Email = "email",
  Proxy = "proxy",
  Username = "username"
}

/** Legacy content (only applicable to Path Items using legacy content, pre-dating Blocks). */
export type UserSubmission = {
  __typename?: "UserSubmission"
  file_image?: Maybe<Scalars["String"]["output"]>
  file_name?: Maybe<Scalars["String"]["output"]>
  file_url?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  text?: Maybe<Scalars["String"]["output"]>
}

/** An event from a webhook subscription. Currently these will only be faild webhook events. */
export type WebhookEvent = {
  __typename?: "WebhookEvent"
  /** The event types to being subscribed to. */
  event: WebhookEventType
  event_data: Scalars["JSON"]["output"]
  last_attempt_dtime: Scalars["DateTime"]["output"]
  status: WebhookEventStatus
  uuid: Scalars["UUID"]["output"]
  webhook_subscription: WebhookSubscription
}

/** A connection to a list of items. */
export type WebhookEventConnection = {
  __typename?: "WebhookEventConnection"
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WebhookEventEdge>>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  total: Scalars["Int"]["output"]
}

/** An edge in a connection. */
export type WebhookEventEdge = {
  __typename?: "WebhookEventEdge"
  /** A cursor for use in pagination */
  cursor: Scalars["String"]["output"]
  /** The item at the end of the edge */
  node?: Maybe<WebhookEvent>
}

/** Input for ordering the list. */
export type WebhookEventOrderBy = {
  /** Order by last_attempt_dtime. */
  last_attempt_dtime?: InputMaybe<OrderByDir>
}

export enum WebhookEventStatus {
  Failed = "FAILED"
}

export enum WebhookEventType {
  All = "ALL",
  CohortCreated = "COHORT_CREATED",
  NewLearningActivity = "NEW_LEARNING_ACTIVITY",
  RegistrationSucceeded = "REGISTRATION_SUCCEEDED",
  StepCompletionReviewed = "STEP_COMPLETION_REVIEWED",
  StudentCourseCompleted = "STUDENT_COURSE_COMPLETED",
  StudentMembershipCreated = "STUDENT_MEMBERSHIP_CREATED",
  StudentMembershipUpdated = "STUDENT_MEMBERSHIP_UPDATED",
  StudentRegistrationSucceeded = "STUDENT_REGISTRATION_SUCCEEDED",
  StudentSubscriptionCanceled = "STUDENT_SUBSCRIPTION_CANCELED",
  StudentSubscriptionSucceeded = "STUDENT_SUBSCRIPTION_SUCCEEDED",
  UserEmailUpdated = "USER_EMAIL_UPDATED"
}

/** An event from a webhook subscription. Currently these will only be faild webhook events. */
export type WebhookSubscription = {
  __typename?: "WebhookSubscription"
  /** When the credentials were archived. */
  archived_time?: Maybe<Scalars["DateTime"]["output"]>
  /** The time the credentials were created. */
  created_time: Scalars["DateTime"]["output"]
  /** The event types to being subscribed to. */
  event: WebhookEventType
  id: Scalars["Int"]["output"]
  /** The school this subscription belongs to. */
  school: School
  /** The receiver URL. */
  target_url: Scalars["URL"]["output"]
}

export enum Crop {
  Bottom = "bottom",
  Edges = "edges",
  Entropy = "entropy",
  Faces = "faces",
  Focalpoint = "focalpoint",
  Left = "left",
  Right = "right",
  Top = "top"
}

export enum Fit {
  Clamp = "clamp",
  Clip = "clip",
  Crop = "crop",
  Facearea = "facearea",
  Fill = "fill",
  Fillmax = "fillmax",
  Max = "max",
  Min = "min",
  Scale = "scale"
}

export enum Interval {
  Annually = "annually",
  Monthly = "monthly"
}

export enum Visibility {
  Pathwright_1 = "pathwright_1",
  Pathwright_2 = "pathwright_2",
  PrivateCustom = "private_custom"
}

export type CreatePageMutationVariables = Exact<{
  name: Scalars["String"]["input"]
  title?: InputMaybe<Scalars["String"]["input"]>
  page_type?: InputMaybe<Scalars["Int"]["input"]>
  show_in_nav?: InputMaybe<Scalars["Boolean"]["input"]>
  mode?: InputMaybe<Scalars["String"]["input"]>
}>

export type CreatePageMutation = {
  __typename?: "Mutations"
  createPage?: {
    __typename?: "Page"
    id: number
    name: string
    order: number
    page_type: number
    title?: string | null
    description?: string | null
    url: string
    external_url?: string | null
    iframe_url: string
    template_content?: string | null
    scripts?: string | null
    slug: string
    show_in_nav: boolean
    mode: string
    is_live: boolean
    content_type?: number | null
  } | null
}

export type PageFragment = {
  __typename?: "Page"
  id: number
  name: string
  order: number
  page_type: number
  title?: string | null
  description?: string | null
  url: string
  external_url?: string | null
  iframe_url: string
  template_content?: string | null
  scripts?: string | null
  slug: string
  show_in_nav: boolean
  mode: string
  is_live: boolean
  content_type?: number | null
}

export type PageQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  page_type?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
  is_live?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type PageQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    page?: {
      __typename?: "Page"
      id: number
      name: string
      order: number
      page_type: number
      title?: string | null
      description?: string | null
      url: string
      external_url?: string | null
      iframe_url: string
      template_content?: string | null
      scripts?: string | null
      slug: string
      show_in_nav: boolean
      mode: string
      is_live: boolean
      content_type?: number | null
    } | null
  } | null
}

export type PagesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>
  isLive?: InputMaybe<Scalars["Boolean"]["input"]>
  showInNav?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type PagesQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    pages?: {
      __typename?: "PageConnection"
      edges?: Array<{
        __typename?: "PageEdge"
        node?: {
          __typename?: "Page"
          id: number
          name: string
          order: number
          page_type: number
          title?: string | null
          description?: string | null
          url: string
          external_url?: string | null
          iframe_url: string
          template_content?: string | null
          scripts?: string | null
          slug: string
          show_in_nav: boolean
          mode: string
          is_live: boolean
          content_type?: number | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type UpdatePageMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  page_type?: InputMaybe<Scalars["Int"]["input"]>
  title?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
  show_in_nav?: InputMaybe<Scalars["Boolean"]["input"]>
  external_url?: InputMaybe<Scalars["String"]["input"]>
  iframe_url?: InputMaybe<Scalars["String"]["input"]>
  template_content?: InputMaybe<Scalars["String"]["input"]>
  scripts?: InputMaybe<Scalars["String"]["input"]>
  mode?: InputMaybe<Scalars["String"]["input"]>
  is_live?: InputMaybe<Scalars["Boolean"]["input"]>
  content_type?: InputMaybe<Scalars["Int"]["input"]>
}>

export type UpdatePageMutation = {
  __typename?: "Mutations"
  updatePage?: {
    __typename?: "Page"
    id: number
    name: string
    order: number
    page_type: number
    title?: string | null
    description?: string | null
    url: string
    external_url?: string | null
    iframe_url: string
    template_content?: string | null
    scripts?: string | null
    slug: string
    show_in_nav: boolean
    mode: string
    is_live: boolean
    content_type?: number | null
  } | null
}

export type UpdatePageOrdersMutationVariables = Exact<{
  page_orders: Array<ListOrderInput> | ListOrderInput
}>

export type UpdatePageOrdersMutation = {
  __typename?: "Mutations"
  updatePageOrders?: boolean | null
}

export type CreateSchoolThemeMutationVariables = Exact<{
  theme: ThemeInput
}>

export type CreateSchoolThemeMutation = {
  __typename?: "Mutations"
  createSchoolTheme?: {
    __typename?: "Theme"
    id?: number | null
    name?: string | null
    theme_type?: ThemeType | null
    background_image?: string | null
    background_overlay?: string | null
    background_type?: number | null
    heading_font?: string | null
    primary_color?: string | null
    typekit_id?: string | null
    custom_css?: string | null
    processed_custom_css?: string | null
    color_palette?: {
      __typename?: "NodeThemeColorPalette"
      _50?: string | null
      _100?: string | null
      _200?: string | null
      _300?: string | null
      _400?: string | null
      _500?: string | null
      _600?: string | null
      _700?: string | null
      _800?: string | null
      _900?: string | null
    } | null
  } | null
}

export type UpdateSchoolThemeMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  theme: ThemeInput
}>

export type UpdateSchoolThemeMutation = {
  __typename?: "Mutations"
  updateSchoolTheme?: {
    __typename?: "Theme"
    id?: number | null
    name?: string | null
    theme_type?: ThemeType | null
    background_image?: string | null
    background_overlay?: string | null
    background_type?: number | null
    heading_font?: string | null
    primary_color?: string | null
    typekit_id?: string | null
    custom_css?: string | null
    processed_custom_css?: string | null
    color_palette?: {
      __typename?: "NodeThemeColorPalette"
      _50?: string | null
      _100?: string | null
      _200?: string | null
      _300?: string | null
      _400?: string | null
      _500?: string | null
      _600?: string | null
      _700?: string | null
      _800?: string | null
      _900?: string | null
    } | null
  } | null
}

export type AssignResourceQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  assignConfig?: InputMaybe<AssignConfig>
  search?: InputMaybe<Scalars["String"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type AssignResourceQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    cohorts?: {
      __typename?: "GroupConnection"
      total: number
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges?: Array<{
        __typename?: "GroupEdge"
        node?: {
          __typename?: "Group"
          id: number
          name: string
          created?: any | null
          description?: string | null
          price?: number | null
          seats?: number | null
          seats_filled?: number | null
          seats_available?: number | null
          registration_ends?: any | null
          registration_starts?: any | null
          registration_started?: boolean | null
          registration_ended?: boolean | null
          access_ends?: any | null
          access_starts?: any | null
          is_master?: boolean | null
          is_source_cohort?: boolean | null
          source_cohort_id?: number | null
          parent_section_id?: number | null
          resource_id?: number | null
          visibility?: number | null
          is_collection_linked?: boolean | null
          is_subscription_only?: boolean | null
          status: GroupStatus
          analytics_disabled?: boolean | null
          created_by_id?: number | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type GetTokenViaSsoMutationVariables = Exact<{
  ssoToken: Scalars["String"]["input"]
}>

export type GetTokenViaSsoMutation = {
  __typename?: "Mutations"
  getTokenViaSSO?: { __typename?: "Token"; token?: string | null } | null
}

export type RefreshTokenMutationVariables = Exact<{
  school_id?: InputMaybe<Scalars["ID"]["input"]>
}>

export type RefreshTokenMutation = {
  __typename?: "Mutations"
  refreshToken?: string | null
}

export type AuthorFragment = {
  __typename?: "Author"
  id?: number | null
  bio?: string | null
  image?: string | null
  order?: number | null
  full_name?: string | null
}

export type AuthorQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}>

export type AuthorQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    author?: {
      __typename?: "Author"
      id?: number | null
      bio?: string | null
      image?: string | null
      order?: number | null
      full_name?: string | null
    } | null
  } | null
}

export type AuthorsQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
  school_id: Scalars["Int"]["input"]
  search?: InputMaybe<Scalars["String"]["input"]>
  ids?: InputMaybe<IdFilter>
  manage?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type AuthorsQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url?: string | null
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      authors?: {
        __typename?: "AuthorConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges?: Array<{
          __typename?: "AuthorEdge"
          node?: {
            __typename?: "Author"
            id?: number | null
            bio?: string | null
            image?: string | null
            order?: number | null
            full_name?: string | null
          } | null
        } | null> | null
      } | null
    }
  } | null
}

export type BannerFragment = {
  __typename?: "Banner"
  id?: number | null
  order?: number | null
  heading?: string | null
  subhead?: string | null
  font_color?: string | null
  background_image_raw?: string | null
  background_image?: string | null
  background_type?: number | null
  background_overlay?: string | null
  button_func?: string | null
  button_url?: string | null
  button_text?: string | null
  is_visible?: boolean | null
  hide_for_subscription_plans?: Array<number | null> | null
  show_for_subscription_plans?: Array<number | null> | null
  hide_for_products?: Array<number | null> | null
  show_for_products?: Array<number | null> | null
}

export type BannerQueryVariables = Exact<{
  school_id: Scalars["Int"]["input"]
  id: Scalars["Int"]["input"]
}>

export type BannerQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url?: string | null
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      banner?: {
        __typename?: "Banner"
        id?: number | null
        order?: number | null
        heading?: string | null
        subhead?: string | null
        font_color?: string | null
        background_image_raw?: string | null
        background_image?: string | null
        background_type?: number | null
        background_overlay?: string | null
        button_func?: string | null
        button_url?: string | null
        button_text?: string | null
        is_visible?: boolean | null
        hide_for_subscription_plans?: Array<number | null> | null
        show_for_subscription_plans?: Array<number | null> | null
        hide_for_products?: Array<number | null> | null
        show_for_products?: Array<number | null> | null
      } | null
    }
  } | null
}

export type BannersQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>
  school_id: Scalars["Int"]["input"]
  first: Scalars["Int"]["input"]
  manage?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type BannersQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url?: string | null
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      banners?: {
        __typename?: "BannerConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges?: Array<{
          __typename?: "BannerEdge"
          node?: {
            __typename?: "Banner"
            id?: number | null
            order?: number | null
            heading?: string | null
            subhead?: string | null
            font_color?: string | null
            background_image_raw?: string | null
            background_image?: string | null
            background_type?: number | null
            background_overlay?: string | null
            button_func?: string | null
            button_url?: string | null
            button_text?: string | null
            is_visible?: boolean | null
            hide_for_subscription_plans?: Array<number | null> | null
            show_for_subscription_plans?: Array<number | null> | null
            hide_for_products?: Array<number | null> | null
            show_for_products?: Array<number | null> | null
          } | null
        } | null> | null
      } | null
    }
  } | null
}

export type CreateBannerMutationVariables = Exact<{
  heading?: InputMaybe<Scalars["String"]["input"]>
  subhead?: InputMaybe<Scalars["String"]["input"]>
  font_color?: InputMaybe<Scalars["String"]["input"]>
  background_image?: InputMaybe<Scalars["String"]["input"]>
  background_type?: InputMaybe<Scalars["Int"]["input"]>
  background_overlay?: InputMaybe<Scalars["String"]["input"]>
  button_func?: InputMaybe<Scalars["String"]["input"]>
  button_url?: InputMaybe<Scalars["String"]["input"]>
  button_text?: InputMaybe<Scalars["String"]["input"]>
  is_visible?: InputMaybe<Scalars["Boolean"]["input"]>
  hide_for_subscription_plans?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  show_for_subscription_plans?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  hide_for_products?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  show_for_products?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
}>

export type CreateBannerMutation = {
  __typename?: "Mutations"
  createBanner?: {
    __typename?: "Banner"
    id?: number | null
    order?: number | null
    heading?: string | null
    subhead?: string | null
    font_color?: string | null
    background_image_raw?: string | null
    background_image?: string | null
    background_type?: number | null
    background_overlay?: string | null
    button_func?: string | null
    button_url?: string | null
    button_text?: string | null
    is_visible?: boolean | null
    hide_for_subscription_plans?: Array<number | null> | null
    show_for_subscription_plans?: Array<number | null> | null
    hide_for_products?: Array<number | null> | null
    show_for_products?: Array<number | null> | null
  } | null
}

export type DeleteBannerMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type DeleteBannerMutation = {
  __typename?: "Mutations"
  deleteBanner?: boolean | null
}

export type UpdateBannerMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  heading?: InputMaybe<Scalars["String"]["input"]>
  subhead?: InputMaybe<Scalars["String"]["input"]>
  font_color?: InputMaybe<Scalars["String"]["input"]>
  background_image?: InputMaybe<Scalars["String"]["input"]>
  background_type?: InputMaybe<Scalars["Int"]["input"]>
  background_overlay?: InputMaybe<Scalars["String"]["input"]>
  button_func?: InputMaybe<Scalars["String"]["input"]>
  button_url?: InputMaybe<Scalars["String"]["input"]>
  button_text?: InputMaybe<Scalars["String"]["input"]>
  is_visible?: InputMaybe<Scalars["Boolean"]["input"]>
  hide_for_subscription_plans?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  show_for_subscription_plans?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  hide_for_products?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  show_for_products?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
}>

export type UpdateBannerMutation = {
  __typename?: "Mutations"
  updateBanner?: {
    __typename?: "Banner"
    id?: number | null
    order?: number | null
    heading?: string | null
    subhead?: string | null
    font_color?: string | null
    background_image_raw?: string | null
    background_image?: string | null
    background_type?: number | null
    background_overlay?: string | null
    button_func?: string | null
    button_url?: string | null
    button_text?: string | null
    is_visible?: boolean | null
    hide_for_subscription_plans?: Array<number | null> | null
    show_for_subscription_plans?: Array<number | null> | null
    hide_for_products?: Array<number | null> | null
    show_for_products?: Array<number | null> | null
  } | null
}

export type UpdateBannerOrderMutationVariables = Exact<{
  banner_orders: Array<InputMaybe<ListOrderInput>> | InputMaybe<ListOrderInput>
}>

export type UpdateBannerOrderMutation = {
  __typename?: "Mutations"
  updateBannerOrder?: boolean | null
}

export type BackgroundTaskQueryVariables = Exact<{
  id: Scalars["String"]["input"]
}>

export type BackgroundTaskQuery = {
  __typename?: "Query"
  backgroundTask?: {
    __typename?: "BackgroundTask"
    id: any
    status: BackgroundTaskStatus
    result?: any | null
  } | null
}

export type BackgroundTaskFragment = {
  __typename?: "BackgroundTask"
  id: any
  status: BackgroundTaskStatus
  result?: any | null
}

export type BackgroundTasksQueryVariables = Exact<{
  ids:
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
}>

export type BackgroundTasksQuery = {
  __typename?: "Query"
  backgroundTasks?: Array<{
    __typename?: "BackgroundTask"
    id: any
    status: BackgroundTaskStatus
    result?: any | null
  } | null> | null
}

export type CategoriesQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
  school_id: Scalars["Int"]["input"]
  search?: InputMaybe<Scalars["String"]["input"]>
  ids?: InputMaybe<IdFilter>
  manage?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type CategoriesQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url?: string | null
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      categories?: {
        __typename?: "CategoryConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges?: Array<{
          __typename?: "CategoryEdge"
          node?: {
            __typename?: "Category"
            id?: number | null
            name?: string | null
            slug?: string | null
            order?: number | null
            description?: string | null
          } | null
        } | null> | null
      } | null
    }
  } | null
}

export type CategoryFragment = {
  __typename?: "Category"
  id?: number | null
  name?: string | null
  slug?: string | null
  order?: number | null
  description?: string | null
}

export type CategoryQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}>

export type CategoryQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    category?: {
      __typename?: "Category"
      id?: number | null
      name?: string | null
      slug?: string | null
      order?: number | null
      description?: string | null
    } | null
  } | null
}

export type CertificateFragment = {
  __typename?: "Certificate"
  id?: number | null
  name?: string | null
  template?: string | null
  text_objects?: any | null
}

export type CertificatePreviewQueryVariables = Exact<{
  template: Scalars["String"]["input"]
  textObjects: Array<InputMaybe<TextObject>> | InputMaybe<TextObject>
  variables?: InputMaybe<Scalars["JSON"]["input"]>
}>

export type CertificatePreviewQuery = {
  __typename?: "Query"
  certificatePreview?: string | null
}

export type CertificateQueryVariables = Exact<{ [key: string]: never }>

export type CertificateQuery = {
  __typename?: "Query"
  certificate?: {
    __typename?: "Certificate"
    id?: number | null
    name?: string | null
    template?: string | null
    text_objects?: any | null
  } | null
}

export type CertificateResourcesQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  hasCertificate?: InputMaybe<Scalars["Boolean"]["input"]>
  search?: InputMaybe<Scalars["String"]["input"]>
}>

export type CertificateResourcesQuery = {
  __typename?: "Query"
  resources?: {
    __typename?: "ResourceConnection"
    total: number
    edges?: Array<{
      __typename?: "ResourceEdge"
      node?: {
        __typename?: "Resource"
        trailer_embed_code?: string | null
        visibility_level_override?: number | null
        certificate_generator_class?: string | null
        certificate_json?: any | null
        licensed_from_resource_id?: number | null
        id: number
        name: string
        slug: string
        created?: any | null
        resource_type: number
        visibility?: number | null
        description?: string | null
        short_description?: string | null
        background_overlay?: string | null
        background_image?: string | null
        background_type: ResourceBackgroundType
        image_raw?: string | null
        has_certificate?: boolean | null
        discussion_enabled?: boolean | null
        lowest_public_offering_price?: number | null
        highest_public_offering_price?: number | null
        licensed_from_school_id?: number | null
        created_by_id?: number | null
        copied_with_copy_config_id?: number | null
        image: string
        cover_image: string
        registration_meta?: {
          __typename?: "RegistrationMeta"
          editor_registration_count?: number | null
        } | null
        authors?: {
          __typename?: "AuthorConnection"
          total: number
          edges?: Array<{
            __typename?: "AuthorEdge"
            node?: {
              __typename?: "Author"
              id?: number | null
              bio?: string | null
              image?: string | null
              order?: number | null
              full_name?: string | null
            } | null
          } | null> | null
        } | null
        categories?: {
          __typename?: "CategoryConnection"
          total: number
          edges?: Array<{
            __typename?: "CategoryEdge"
            node?: {
              __typename?: "Category"
              id?: number | null
              name?: string | null
              slug?: string | null
              order?: number | null
              description?: string | null
            } | null
          } | null> | null
        } | null
        groups?: {
          __typename?: "GroupConnection"
          total: number
          edges?: Array<{
            __typename?: "GroupEdge"
            node?: {
              __typename?: "Group"
              id: number
              seats_filled?: number | null
            } | null
          } | null> | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type CertificateVariablesQueryVariables = Exact<{
  context?: InputMaybe<CertificateVariablesContextInput>
}>

export type CertificateVariablesQuery = {
  __typename?: "Query"
  certificateVariables?: {
    __typename?: "CertificateVariables"
    id?: number | null
    stats?: any | null
    variables?: any | null
  } | null
}

export type CreateCertificateMutationVariables = Exact<{
  name?: InputMaybe<Scalars["String"]["input"]>
  template: Scalars["String"]["input"]
  textObjects?: InputMaybe<
    Array<InputMaybe<TextObject>> | InputMaybe<TextObject>
  >
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type CreateCertificateMutation = {
  __typename?: "Mutations"
  createCertificate?: {
    __typename?: "Certificate"
    id?: number | null
    name?: string | null
    template?: string | null
    text_objects?: any | null
  } | null
}

export type DeleteCertificateMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type DeleteCertificateMutation = {
  __typename?: "Mutations"
  deleteCertificate?: boolean | null
}

export type ResourceCertificateContextQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type ResourceCertificateContextQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    trailer_embed_code?: string | null
    visibility_level_override?: number | null
    certificate_generator_class?: string | null
    certificate_json?: any | null
    licensed_from_resource_id?: number | null
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    registration_meta?: {
      __typename?: "RegistrationMeta"
      editor_registration_count?: number | null
    } | null
    authors?: {
      __typename?: "AuthorConnection"
      total: number
      edges?: Array<{
        __typename?: "AuthorEdge"
        node?: {
          __typename?: "Author"
          id?: number | null
          bio?: string | null
          image?: string | null
          order?: number | null
          full_name?: string | null
        } | null
      } | null> | null
    } | null
    categories?: {
      __typename?: "CategoryConnection"
      total: number
      edges?: Array<{
        __typename?: "CategoryEdge"
        node?: {
          __typename?: "Category"
          id?: number | null
          name?: string | null
          slug?: string | null
          order?: number | null
          description?: string | null
        } | null
      } | null> | null
    } | null
    groups?: {
      __typename?: "GroupConnection"
      total: number
      edges?: Array<{
        __typename?: "GroupEdge"
        node?: {
          __typename?: "Group"
          id: number
          seats_filled?: number | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type UpdateCertificateMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  template?: InputMaybe<Scalars["String"]["input"]>
  textObjects?: InputMaybe<
    Array<InputMaybe<TextObject>> | InputMaybe<TextObject>
  >
}>

export type UpdateCertificateMutation = {
  __typename?: "Mutations"
  updateCertificate?: {
    __typename?: "Certificate"
    id?: number | null
    name?: string | null
    template?: string | null
    text_objects?: any | null
  } | null
}

export type UpdateCertificateVariablesMutationVariables = Exact<{
  merge:
    | Array<InputMaybe<CertificateVariablesMergeInput>>
    | InputMaybe<CertificateVariablesMergeInput>
  context?: InputMaybe<CertificateVariablesContextInput>
}>

export type UpdateCertificateVariablesMutation = {
  __typename?: "Mutations"
  updateCertificateVariables?: {
    __typename?: "CertificateVariables"
    id?: number | null
    stats?: any | null
    variables?: any | null
  } | null
}

export type CohortFragment = {
  __typename?: "Group"
  id: number
  name: string
  created?: any | null
  created_by_id?: number | null
  status: GroupStatus
  is_collection_linked?: boolean | null
  is_master?: boolean | null
  access_starts?: any | null
  parent_section_id?: number | null
  access_ends?: any | null
  registration?: {
    __typename?: "Registration"
    id: number
    role: number
    send_due_notifications?: boolean | null
    send_discussion_notifications?: boolean | null
  } | null
  path: { __typename?: "Path"; id: number }
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    image: string
    slug: string
    background_image?: string | null
    background_overlay?: string | null
    resource_type: number
  } | null
  resource_license?: {
    __typename?: "ResourceLicense"
    id?: number | null
    expiration_dtime?: any | null
  } | null
}

export type CohortPermissionsQueryVariables = Exact<{
  cohortId: Scalars["Int"]["input"]
}>

export type CohortPermissionsQuery = {
  __typename?: "Query"
  cohort?: {
    __typename?: "Group"
    id: number
    is_source_cohort?: boolean | null
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
    } | null
    source?: {
      __typename?: "Group"
      id: number
      is_source_cohort?: boolean | null
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
      } | null
    } | null
  } | null
}

export type CohortQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type CohortQuery = {
  __typename?: "Query"
  cohort?: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    created_by_id?: number | null
    status: GroupStatus
    is_collection_linked?: boolean | null
    is_master?: boolean | null
    access_starts?: any | null
    parent_section_id?: number | null
    access_ends?: any | null
    registration?: {
      __typename?: "Registration"
      id: number
      role: number
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
    } | null
    path: { __typename?: "Path"; id: number }
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      image: string
      slug: string
      background_image?: string | null
      background_overlay?: string | null
      resource_type: number
    } | null
    resource_license?: {
      __typename?: "ResourceLicense"
      id?: number | null
      expiration_dtime?: any | null
    } | null
  } | null
}

export type CohortSwitcherCohortsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
  resourceId: Scalars["Int"]["input"]
  role?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
}>

export type CohortSwitcherCohortsQuery = {
  __typename?: "Query"
  cohorts?: {
    __typename?: "GroupConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges?: Array<{
      __typename?: "GroupEdge"
      node?: {
        __typename?: "Group"
        id: number
        name: string
        created?: any | null
        created_by_id?: number | null
        status: GroupStatus
        is_collection_linked?: boolean | null
        is_master?: boolean | null
        access_starts?: any | null
        parent_section_id?: number | null
        access_ends?: any | null
        registration?: {
          __typename?: "Registration"
          id: number
          role: number
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
        } | null
        path: { __typename?: "Path"; id: number }
        resource?: {
          __typename?: "Resource"
          id: number
          name: string
          image: string
          slug: string
          background_image?: string | null
          background_overlay?: string | null
          resource_type: number
        } | null
        resource_license?: {
          __typename?: "ResourceLicense"
          id?: number | null
          expiration_dtime?: any | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type CohortsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type CohortsQuery = {
  __typename?: "Query"
  groups?: {
    __typename?: "GroupConnection"
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges?: Array<{
      __typename?: "GroupEdge"
      node?: {
        __typename?: "Group"
        id: number
        name: string
        created?: any | null
        created_by_id?: number | null
        status: GroupStatus
        is_collection_linked?: boolean | null
        is_master?: boolean | null
        access_starts?: any | null
        parent_section_id?: number | null
        access_ends?: any | null
        registration?: {
          __typename?: "Registration"
          id: number
          role: number
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
        } | null
        path: { __typename?: "Path"; id: number }
        resource?: {
          __typename?: "Resource"
          id: number
          name: string
          image: string
          slug: string
          background_image?: string | null
          background_overlay?: string | null
          resource_type: number
        } | null
        resource_license?: {
          __typename?: "ResourceLicense"
          id?: number | null
          expiration_dtime?: any | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type CohortsStatusQueryVariables = Exact<{
  resourceId: Scalars["Int"]["input"]
}>

export type CohortsStatusQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    licensed_from_school_id?: number | null
    cohorts_status_meta?: {
      __typename?: "CohortsStatusMeta"
      in_progress?: number | null
    } | null
  } | null
}

export type CreateCohortResourceQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type CreateCohortResourceQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    resource_type: number
    image: string
    background_overlay?: string | null
    background_image?: string | null
    source_cohort?: {
      __typename?: "Group"
      id: number
      path: { __typename?: "Path"; id: number; last_synced_dtime?: any | null }
    } | null
    cohorts?: {
      __typename?: "GroupConnection"
      total: number
      edges?: Array<{
        __typename?: "GroupEdge"
        node?: {
          __typename?: "Group"
          id: number
          path: {
            __typename?: "Path"
            id: number
            last_synced_dtime?: any | null
          }
        } | null
      } | null> | null
    } | null
  } | null
}

export type ResourcesQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>
  resourceTypes?: InputMaybe<ResourceTypeFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
}>

export type ResourcesQuery = {
  __typename?: "Query"
  resources?: {
    __typename?: "ResourceConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges?: Array<{
      __typename?: "ResourceEdge"
      node?: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        created?: any | null
        resource_type: number
        visibility?: number | null
        description?: string | null
        short_description?: string | null
        background_overlay?: string | null
        background_image?: string | null
        background_type: ResourceBackgroundType
        image_raw?: string | null
        has_certificate?: boolean | null
        discussion_enabled?: boolean | null
        lowest_public_offering_price?: number | null
        highest_public_offering_price?: number | null
        licensed_from_resource_id?: number | null
        licensed_from_school_id?: number | null
        created_by_id?: number | null
        copied_with_copy_config_id?: number | null
        image: string
        cover_image: string
      } | null
    } | null> | null
  } | null
}

export type UpdateCohortStatusMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  status: GroupStatus
}>

export type UpdateCohortStatusMutation = {
  __typename?: "Mutations"
  updateGroupStatus?: {
    __typename?: "Group"
    id: number
    status: GroupStatus
  } | null
}

export type CompletionFragment = {
  __typename?: "Completion"
  id?: number | null
  checked_date?: any | null
  completion_attempts?: number | null
  completion_comment?: string | null
  completion_date?: any | null
  completion_due?: any | null
  last_completion_attempt_date?: any | null
  has_failed_passing_attempt?: boolean | null
  has_points?: boolean | null
  is_late?: boolean | null
  is_graded?: boolean | null
  is_skipped?: boolean | null
  is_complete?: boolean | null
  is_auto_graded?: boolean | null
  is_forced_completion?: boolean | null
  needs_grading?: boolean | null
  userpoints_earned?: number | null
  userpoints_explanation?: string | null
  userpoints_value?: number | null
  minimum_passing_score?: number | null
  grading_type?: string | null
  requires_api_completion?: boolean | null
  overridden_by_api?: boolean | null
  overridden_by?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  checked_by?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  submission?: {
    __typename?: "UserSubmission"
    id?: number | null
    text?: string | null
    file_url?: string | null
    file_name?: string | null
    file_image?: string | null
  } | null
  feedback_discussion_context?: {
    __typename?: "CompletionFeedbackDiscussionContext"
    id?: number | null
    discussion_id?: number | null
    num_responses?: number | null
  } | null
}

export type CompletionQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type CompletionQuery = {
  __typename?: "Query"
  pathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    archived_time?: any | null
    progress: number
    parent?: { __typename?: "PathItem"; id: number; name: string } | null
    path?: {
      __typename?: "Path"
      id: number
      progress?: number | null
      points?: {
        __typename?: "Points"
        path_id?: number | null
        total?: number | null
        earned?: number | null
        percentage?: number | null
        total_points_possible?: number | null
        has_points?: boolean | null
      } | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      image: string
    } | null
    context?: {
      __typename?: "StepContext"
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id?: number | null
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type CompletionsItemFragment = {
  __typename?: "PathItem"
  id: number
  order: number
  verb?: string | null
  name: string
  type: PathItemType
  path_id: number
  source_id: number
  parent_id?: number | null
  parent_source_id?: number | null
  description?: string | null
  curriculum_sync_opt_out_dtime?: any | null
  assignment_type?: PathItemAssignmentType | null
  content_id?: number | null
  content_type?: string | null
  item_content_type_id?: number | null
  is_required?: boolean | null
  is_previewable?: boolean | null
  due?: any | null
  passive_due?: boolean | null
  starts?: any | null
  passive_starts?: boolean | null
  has_started?: boolean | null
  points?: number | null
  item_needs_grading?: boolean | null
  minimum_passing_score?: number | null
  grading_type?: string | null
  time_to_complete?: number | null
  lock_password?: string | null
  is_locked?: boolean | null
  lock_unlocked_time?: any | null
  allow_resets?: number | null
  show_grading_feedback?: number | null
  completion_comment_required_status?: string | null
  last_published_dtime?: any | null
  archived_time?: any | null
  progress: number
  cohort?: { __typename?: "Group"; id: number; name: string } | null
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    image: string
    background_overlay?: string | null
    background_image?: string | null
    image_raw?: string | null
    blurred_background?: string | null
  } | null
  parent?: {
    __typename?: "PathItem"
    id: number
    source_id: number
    order: number
    name: string
  } | null
  analytics?: {
    __typename?: "ItemAnalytics"
    need_feedback?: number | null
    total_users?: number | null
  } | null
  context?: {
    __typename?: "StepContext"
    resource_id?: number | null
    cohort_id?: number | null
  } | null
  blocks?: {
    __typename?: "BlocksContent"
    content_last_modified?: any | null
    last_published?: any | null
  } | null
  permissions?: {
    __typename?: "PathItemPermissions"
    can_complete?: boolean | null
    can_discuss?: boolean | null
    can_edit?: boolean | null
    can_edit_content?: boolean | null
    can_note?: boolean | null
    can_view?: boolean | null
    can_review?: boolean | null
    can_view_content?: boolean | null
  } | null
  completion: {
    __typename?: "Completion"
    id?: number | null
    checked_date?: any | null
    completion_attempts?: number | null
    completion_comment?: string | null
    completion_date?: any | null
    completion_due?: any | null
    last_completion_attempt_date?: any | null
    has_failed_passing_attempt?: boolean | null
    has_points?: boolean | null
    is_late?: boolean | null
    is_graded?: boolean | null
    is_skipped?: boolean | null
    is_complete?: boolean | null
    is_auto_graded?: boolean | null
    is_forced_completion?: boolean | null
    needs_grading?: boolean | null
    userpoints_earned?: number | null
    userpoints_explanation?: string | null
    userpoints_value?: number | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    requires_api_completion?: boolean | null
    overridden_by_api?: boolean | null
    overridden_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    checked_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    submission?: {
      __typename?: "UserSubmission"
      id?: number | null
      text?: string | null
      file_url?: string | null
      file_name?: string | null
      file_image?: string | null
    } | null
    feedback_discussion_context?: {
      __typename?: "CompletionFeedbackDiscussionContext"
      id?: number | null
      discussion_id?: number | null
      num_responses?: number | null
    } | null
  }
  linked_resource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    curriculum_group?: { __typename?: "Group"; id: number } | null
  } | null
  linked_cohort?: {
    __typename?: "Group"
    id: number
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
  linked_registration?: {
    __typename?: "Registration"
    id: number
    role: number
    completion_state?: number | null
    send_due_notifications?: boolean | null
    send_discussion_notifications?: boolean | null
    last_activity_time?: any | null
    expiration_dtime?: any | null
    created?: any | null
    path?: { __typename?: "Path"; id: number } | null
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
  } | null
}

export type CompletionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  group_id?: InputMaybe<Scalars["Int"]["input"]>
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  step_id?: InputMaybe<Scalars["Int"]["input"]>
  lesson_source_id?: InputMaybe<Scalars["Int"]["input"]>
  source_id?: InputMaybe<Scalars["Int"]["input"]>
  needs_review?: InputMaybe<Scalars["Boolean"]["input"]>
  is_reviewed?: InputMaybe<Scalars["Boolean"]["input"]>
  is_complete?: InputMaybe<Scalars["Boolean"]["input"]>
  archivedDateFilter?: InputMaybe<
    Array<InputMaybe<DateFilter>> | InputMaybe<DateFilter>
  >
  order_by?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type CompletionsQuery = {
  __typename?: "Query"
  pathItems?: {
    __typename?: "PathItemConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges?: Array<{
      __typename?: "PathItemEdge"
      node?: {
        __typename?: "PathItem"
        id: number
        order: number
        verb?: string | null
        name: string
        type: PathItemType
        path_id: number
        source_id: number
        parent_id?: number | null
        parent_source_id?: number | null
        description?: string | null
        curriculum_sync_opt_out_dtime?: any | null
        assignment_type?: PathItemAssignmentType | null
        content_id?: number | null
        content_type?: string | null
        item_content_type_id?: number | null
        is_required?: boolean | null
        is_previewable?: boolean | null
        due?: any | null
        passive_due?: boolean | null
        starts?: any | null
        passive_starts?: boolean | null
        has_started?: boolean | null
        points?: number | null
        item_needs_grading?: boolean | null
        minimum_passing_score?: number | null
        grading_type?: string | null
        time_to_complete?: number | null
        lock_password?: string | null
        is_locked?: boolean | null
        lock_unlocked_time?: any | null
        allow_resets?: number | null
        show_grading_feedback?: number | null
        completion_comment_required_status?: string | null
        last_published_dtime?: any | null
        archived_time?: any | null
        progress: number
        cohort?: { __typename?: "Group"; id: number; name: string } | null
        resource?: {
          __typename?: "Resource"
          id: number
          name: string
          image: string
          background_overlay?: string | null
          background_image?: string | null
          image_raw?: string | null
          blurred_background?: string | null
        } | null
        parent?: {
          __typename?: "PathItem"
          id: number
          source_id: number
          order: number
          name: string
        } | null
        analytics?: {
          __typename?: "ItemAnalytics"
          need_feedback?: number | null
          total_users?: number | null
        } | null
        context?: {
          __typename?: "StepContext"
          resource_id?: number | null
          cohort_id?: number | null
        } | null
        blocks?: {
          __typename?: "BlocksContent"
          content_last_modified?: any | null
          last_published?: any | null
        } | null
        permissions?: {
          __typename?: "PathItemPermissions"
          can_complete?: boolean | null
          can_discuss?: boolean | null
          can_edit?: boolean | null
          can_edit_content?: boolean | null
          can_note?: boolean | null
          can_view?: boolean | null
          can_review?: boolean | null
          can_view_content?: boolean | null
        } | null
        completion: {
          __typename?: "Completion"
          id?: number | null
          checked_date?: any | null
          completion_attempts?: number | null
          completion_comment?: string | null
          completion_date?: any | null
          completion_due?: any | null
          last_completion_attempt_date?: any | null
          has_failed_passing_attempt?: boolean | null
          has_points?: boolean | null
          is_late?: boolean | null
          is_graded?: boolean | null
          is_skipped?: boolean | null
          is_complete?: boolean | null
          is_auto_graded?: boolean | null
          is_forced_completion?: boolean | null
          needs_grading?: boolean | null
          userpoints_earned?: number | null
          userpoints_explanation?: string | null
          userpoints_value?: number | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          requires_api_completion?: boolean | null
          overridden_by_api?: boolean | null
          overridden_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          checked_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          user?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          submission?: {
            __typename?: "UserSubmission"
            id?: number | null
            text?: string | null
            file_url?: string | null
            file_name?: string | null
            file_image?: string | null
          } | null
          feedback_discussion_context?: {
            __typename?: "CompletionFeedbackDiscussionContext"
            id?: number | null
            discussion_id?: number | null
            num_responses?: number | null
          } | null
        }
        linked_resource?: {
          __typename?: "Resource"
          id: number
          name: string
          slug: string
          created?: any | null
          resource_type: number
          visibility?: number | null
          description?: string | null
          short_description?: string | null
          background_overlay?: string | null
          background_image?: string | null
          background_type: ResourceBackgroundType
          image_raw?: string | null
          has_certificate?: boolean | null
          discussion_enabled?: boolean | null
          lowest_public_offering_price?: number | null
          highest_public_offering_price?: number | null
          licensed_from_resource_id?: number | null
          licensed_from_school_id?: number | null
          created_by_id?: number | null
          copied_with_copy_config_id?: number | null
          image: string
          cover_image: string
          curriculum_group?: { __typename?: "Group"; id: number } | null
        } | null
        linked_cohort?: {
          __typename?: "Group"
          id: number
          user_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null
        linked_registration?: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          path?: { __typename?: "Path"; id: number } | null
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
      } | null
    } | null> | null
  } | null
}

export type ResetCompletionFeedbackMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  pathId: Scalars["Int"]["input"]
}>

export type ResetCompletionFeedbackMutation = {
  __typename?: "Mutations"
  resetCompletionFeedback?: {
    __typename?: "Completion"
    id?: number | null
    checked_date?: any | null
    completion_attempts?: number | null
    completion_comment?: string | null
    completion_date?: any | null
    completion_due?: any | null
    last_completion_attempt_date?: any | null
    has_failed_passing_attempt?: boolean | null
    has_points?: boolean | null
    is_late?: boolean | null
    is_graded?: boolean | null
    is_skipped?: boolean | null
    is_complete?: boolean | null
    is_auto_graded?: boolean | null
    is_forced_completion?: boolean | null
    needs_grading?: boolean | null
    userpoints_earned?: number | null
    userpoints_explanation?: string | null
    userpoints_value?: number | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    requires_api_completion?: boolean | null
    overridden_by_api?: boolean | null
    overridden_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    checked_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    submission?: {
      __typename?: "UserSubmission"
      id?: number | null
      text?: string | null
      file_url?: string | null
      file_name?: string | null
      file_image?: string | null
    } | null
    feedback_discussion_context?: {
      __typename?: "CompletionFeedbackDiscussionContext"
      id?: number | null
      discussion_id?: number | null
      num_responses?: number | null
    } | null
  } | null
}

export type SaveCompletionFeedbackMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  pathId: Scalars["Int"]["input"]
  userpointsEarned: Scalars["Int"]["input"]
  userpointsExplanation?: InputMaybe<Scalars["String"]["input"]>
  notify?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type SaveCompletionFeedbackMutation = {
  __typename?: "Mutations"
  saveCompletionFeedback?: {
    __typename?: "Completion"
    id?: number | null
    checked_date?: any | null
    completion_attempts?: number | null
    completion_comment?: string | null
    completion_date?: any | null
    completion_due?: any | null
    last_completion_attempt_date?: any | null
    has_failed_passing_attempt?: boolean | null
    has_points?: boolean | null
    is_late?: boolean | null
    is_graded?: boolean | null
    is_skipped?: boolean | null
    is_complete?: boolean | null
    is_auto_graded?: boolean | null
    is_forced_completion?: boolean | null
    needs_grading?: boolean | null
    userpoints_earned?: number | null
    userpoints_explanation?: string | null
    userpoints_value?: number | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    requires_api_completion?: boolean | null
    overridden_by_api?: boolean | null
    overridden_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    checked_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    submission?: {
      __typename?: "UserSubmission"
      id?: number | null
      text?: string | null
      file_url?: string | null
      file_name?: string | null
      file_image?: string | null
    } | null
    feedback_discussion_context?: {
      __typename?: "CompletionFeedbackDiscussionContext"
      id?: number | null
      discussion_id?: number | null
      num_responses?: number | null
    } | null
  } | null
}

export type UserCompletionsNeedingReviewQueryVariables = Exact<{
  user_id: Scalars["Int"]["input"]
}>

export type UserCompletionsNeedingReviewQuery = {
  __typename?: "Query"
  pathItemStats?: {
    __typename?: "PathItemStats"
    path_items_needing_review?: number | null
  } | null
}

export type CoverPageOfferFragment = {
  __typename?: "Offer"
  id: number
  source: OfferSource
  title: string
  description: string
  access: {
    __typename?: "OfferAccess"
    meta: Array<string | null>
    state: OfferAccessState
  }
  price_options: Array<{
    __typename?: "OfferPriceOption"
    option_label: string
    button_label: string
    price_description: string
  }>
}

export type CoverPageOffersQueryVariables = Exact<{
  resourceId: Scalars["Int"]["input"]
  first?: InputMaybe<Scalars["Int"]["input"]>
}>

export type CoverPageOffersQuery = {
  __typename?: "Query"
  offerConnections?: {
    __typename?: "OfferConnection"
    edges?: Array<{
      __typename?: "OfferEdge"
      node?: {
        __typename?: "Offer"
        id: number
        source: OfferSource
        title: string
        description: string
        access: {
          __typename?: "OfferAccess"
          meta: Array<string | null>
          state: OfferAccessState
        }
        price_options: Array<{
          __typename?: "OfferPriceOption"
          option_label: string
          button_label: string
          price_description: string
        }>
      } | null
    } | null> | null
  } | null
}

export type CoverPagePathItemFragment = {
  __typename?: "PathItem"
  id: number
  order: number
  name: string
  type: PathItemType
  path_id: number
  source_id: number
  parent_id?: number | null
  description?: string | null
  content_id?: number | null
  assignment_type?: PathItemAssignmentType | null
  is_previewable?: boolean | null
  item_content_type_id?: number | null
  verb?: string | null
  points?: number | null
  is_required?: boolean | null
  time_to_complete?: number | null
  step_verb?: string | null
  userpoints_value?: number | null
  context?: { __typename?: "StepContext"; school_id?: number | null } | null
}

export type CoverPageRelatedResourcesQueryVariables = Exact<{
  idFilter?: InputMaybe<IdFilter>
  categoryIdFilter?: InputMaybe<IdFilter>
  resourceTypeFilter?: InputMaybe<ResourceTypeFilter>
  first: Scalars["Int"]["input"]
  orderBy?: InputMaybe<Scalars["String"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type CoverPageRelatedResourcesQuery = {
  __typename?: "Query"
  resources?: {
    __typename?: "ResourceConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges?: Array<{
      __typename?: "ResourceEdge"
      node?: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        resource_type: number
        is_ambient_background?: boolean | null
        created?: any | null
        visibility?: number | null
        description?: string | null
        short_description?: string | null
        background_overlay?: string | null
        background_image?: string | null
        image_raw?: string | null
        has_certificate?: boolean | null
        discussion_enabled?: boolean | null
        lowest_public_offering_price?: number | null
        highest_public_offering_price?: number | null
        licensed_from_resource_id?: number | null
        licensed_from_school_id?: number | null
        created_by_id?: number | null
        trailer_embed_code?: string | null
        blurred_background?: string | null
        cover_image: string
        image: string
        publisher?: { __typename?: "Publisher"; name?: string | null } | null
        curriculum_group?: { __typename?: "Group"; id: number } | null
        contributors?: {
          __typename?: "AuthorConnection"
          total: number
          edges?: Array<{
            __typename?: "AuthorEdge"
            node?: {
              __typename?: "Author"
              id?: number | null
              order?: number | null
              display_name?: string | null
              full_name?: string | null
              first_name?: string | null
              last_name?: string | null
              title?: string | null
              image?: string | null
              bio?: string | null
              avatar?: string | null
              salutation?: string | null
              slug?: string | null
            } | null
          } | null> | null
        } | null
        categories?: {
          __typename?: "CategoryConnection"
          total: number
          edges?: Array<{
            __typename?: "CategoryEdge"
            node?: {
              __typename?: "Category"
              id?: number | null
              name?: string | null
              slug?: string | null
              order?: number | null
              description?: string | null
            } | null
          } | null> | null
        } | null
        previewable_cohorts?: {
          __typename?: "GroupConnection"
          total: number
          edges?: Array<{
            __typename?: "GroupEdge"
            node?: { __typename?: "Group"; id: number } | null
          } | null> | null
        } | null
        group?: {
          __typename?: "Group"
          id: number
          path: {
            __typename?: "Path"
            id: number
            items?: {
              __typename?: "PathItemConnection"
              total: number
              edges?: Array<{
                __typename?: "PathItemEdge"
                node?: {
                  __typename?: "PathItem"
                  id: number
                  order: number
                  name: string
                  type: PathItemType
                  path_id: number
                  source_id: number
                  parent_id?: number | null
                  description?: string | null
                  content_id?: number | null
                  assignment_type?: PathItemAssignmentType | null
                  is_previewable?: boolean | null
                  item_content_type_id?: number | null
                  verb?: string | null
                  points?: number | null
                  is_required?: boolean | null
                  time_to_complete?: number | null
                  step_verb?: string | null
                  userpoints_value?: number | null
                  context?: {
                    __typename?: "StepContext"
                    school_id?: number | null
                  } | null
                } | null
              } | null> | null
            } | null
          }
        } | null
      } | null
    } | null> | null
  } | null
}

export type CoverPageResourceFragment = {
  __typename?: "Resource"
  id: number
  name: string
  slug: string
  resource_type: number
  is_ambient_background?: boolean | null
  created?: any | null
  visibility?: number | null
  description?: string | null
  short_description?: string | null
  background_overlay?: string | null
  background_image?: string | null
  image_raw?: string | null
  has_certificate?: boolean | null
  discussion_enabled?: boolean | null
  lowest_public_offering_price?: number | null
  highest_public_offering_price?: number | null
  licensed_from_resource_id?: number | null
  licensed_from_school_id?: number | null
  created_by_id?: number | null
  trailer_embed_code?: string | null
  blurred_background?: string | null
  cover_image: string
  image: string
  curriculum_group?: { __typename?: "Group"; id: number } | null
  contributors?: {
    __typename?: "AuthorConnection"
    total: number
    edges?: Array<{
      __typename?: "AuthorEdge"
      node?: {
        __typename?: "Author"
        id?: number | null
        order?: number | null
        display_name?: string | null
        full_name?: string | null
        first_name?: string | null
        last_name?: string | null
        title?: string | null
        image?: string | null
        bio?: string | null
        avatar?: string | null
        salutation?: string | null
        slug?: string | null
      } | null
    } | null> | null
  } | null
  categories?: {
    __typename?: "CategoryConnection"
    total: number
    edges?: Array<{
      __typename?: "CategoryEdge"
      node?: {
        __typename?: "Category"
        id?: number | null
        name?: string | null
        slug?: string | null
        order?: number | null
        description?: string | null
      } | null
    } | null> | null
  } | null
  previewable_cohorts?: {
    __typename?: "GroupConnection"
    total: number
    edges?: Array<{
      __typename?: "GroupEdge"
      node?: { __typename?: "Group"; id: number } | null
    } | null> | null
  } | null
  group?: {
    __typename?: "Group"
    id: number
    path: {
      __typename?: "Path"
      id: number
      items?: {
        __typename?: "PathItemConnection"
        total: number
        edges?: Array<{
          __typename?: "PathItemEdge"
          node?: {
            __typename?: "PathItem"
            id: number
            order: number
            name: string
            type: PathItemType
            path_id: number
            source_id: number
            parent_id?: number | null
            description?: string | null
            content_id?: number | null
            assignment_type?: PathItemAssignmentType | null
            is_previewable?: boolean | null
            item_content_type_id?: number | null
            verb?: string | null
            points?: number | null
            is_required?: boolean | null
            time_to_complete?: number | null
            step_verb?: string | null
            userpoints_value?: number | null
            context?: {
              __typename?: "StepContext"
              school_id?: number | null
            } | null
          } | null
        } | null> | null
      } | null
    }
  } | null
}

export type CoverPageResourceQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type CoverPageResourceQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    resource_type: number
    is_ambient_background?: boolean | null
    created?: any | null
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    trailer_embed_code?: string | null
    blurred_background?: string | null
    cover_image: string
    image: string
    curriculum_group?: { __typename?: "Group"; id: number } | null
    contributors?: {
      __typename?: "AuthorConnection"
      total: number
      edges?: Array<{
        __typename?: "AuthorEdge"
        node?: {
          __typename?: "Author"
          id?: number | null
          order?: number | null
          display_name?: string | null
          full_name?: string | null
          first_name?: string | null
          last_name?: string | null
          title?: string | null
          image?: string | null
          bio?: string | null
          avatar?: string | null
          salutation?: string | null
          slug?: string | null
        } | null
      } | null> | null
    } | null
    categories?: {
      __typename?: "CategoryConnection"
      total: number
      edges?: Array<{
        __typename?: "CategoryEdge"
        node?: {
          __typename?: "Category"
          id?: number | null
          name?: string | null
          slug?: string | null
          order?: number | null
          description?: string | null
        } | null
      } | null> | null
    } | null
    previewable_cohorts?: {
      __typename?: "GroupConnection"
      total: number
      edges?: Array<{
        __typename?: "GroupEdge"
        node?: { __typename?: "Group"; id: number } | null
      } | null> | null
    } | null
    group?: {
      __typename?: "Group"
      id: number
      path: {
        __typename?: "Path"
        id: number
        items?: {
          __typename?: "PathItemConnection"
          total: number
          edges?: Array<{
            __typename?: "PathItemEdge"
            node?: {
              __typename?: "PathItem"
              id: number
              order: number
              name: string
              type: PathItemType
              path_id: number
              source_id: number
              parent_id?: number | null
              description?: string | null
              content_id?: number | null
              assignment_type?: PathItemAssignmentType | null
              is_previewable?: boolean | null
              item_content_type_id?: number | null
              verb?: string | null
              points?: number | null
              is_required?: boolean | null
              time_to_complete?: number | null
              step_verb?: string | null
              userpoints_value?: number | null
              context?: {
                __typename?: "StepContext"
                school_id?: number | null
              } | null
            } | null
          } | null> | null
        } | null
      }
    } | null
  } | null
}

export type CreateDiscussionLikeMutationVariables = Exact<{
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}>

export type CreateDiscussionLikeMutation = {
  __typename?: "Mutations"
  createDiscussionLike?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    path_item_name?: string | null
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges?: Array<{
        __typename?: "TagLinkEdge"
        node?: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id?: number | null
            name?: string | null
            slug?: string | null
            description?: string | null
            color?: string | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type CreateDiscussionMutationVariables = Exact<{
  context: DiscussionContextInput
  post: DiscussionPostInput
  initialResponse?: InputMaybe<DiscussionResponseInput>
  notify?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type CreateDiscussionMutation = {
  __typename?: "Mutations"
  createDiscussion?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    path_item_name?: string | null
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges?: Array<{
        __typename?: "TagLinkEdge"
        node?: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id?: number | null
            name?: string | null
            slug?: string | null
            description?: string | null
            color?: string | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type CreateDiscussionResponseLikeMutationVariables = Exact<{
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
  response_id: Scalars["Int"]["input"]
}>

export type CreateDiscussionResponseLikeMutation = {
  __typename?: "Mutations"
  createDiscussionResponseLike?: {
    __typename?: "Response"
    id: number
    parent_id?: number | null
    body: string
    attachments?: any | null
    likes?: number | null
    user_liked?: boolean | null
    created_time: any
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
  } | null
}

export type CreateDiscussionResponseMutationVariables = Exact<{
  context: DiscussionContextInput
  response: DiscussionResponseInput
}>

export type CreateDiscussionResponseMutation = {
  __typename?: "Mutations"
  createDiscussionResponse?: {
    __typename?: "Response"
    id: number
    parent_id?: number | null
    body: string
    attachments?: any | null
    likes?: number | null
    user_liked?: boolean | null
    created_time: any
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
  } | null
}

export type CreateDiscussionSubscriptionMutationVariables = Exact<{
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}>

export type CreateDiscussionSubscriptionMutation = {
  __typename?: "Mutations"
  createDiscussionSubscription?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    path_item_name?: string | null
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges?: Array<{
        __typename?: "TagLinkEdge"
        node?: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id?: number | null
            name?: string | null
            slug?: string | null
            description?: string | null
            color?: string | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type DeleteDiscussionLikeMutationVariables = Exact<{
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}>

export type DeleteDiscussionLikeMutation = {
  __typename?: "Mutations"
  deleteDiscussionLike?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    path_item_name?: string | null
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges?: Array<{
        __typename?: "TagLinkEdge"
        node?: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id?: number | null
            name?: string | null
            slug?: string | null
            description?: string | null
            color?: string | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type DeleteDiscussionMutationVariables = Exact<{
  context: DiscussionContextInput
  id: Scalars["Int"]["input"]
}>

export type DeleteDiscussionMutation = {
  __typename?: "Mutations"
  deleteDiscussion?: boolean | null
}

export type DeleteDiscussionResponseLikeMutationVariables = Exact<{
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
  response_id: Scalars["Int"]["input"]
}>

export type DeleteDiscussionResponseLikeMutation = {
  __typename?: "Mutations"
  deleteDiscussionResponseLike?: boolean | null
}

export type DeleteDiscussionResponseMutationVariables = Exact<{
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
  response_id: Scalars["Int"]["input"]
}>

export type DeleteDiscussionResponseMutation = {
  __typename?: "Mutations"
  deleteDiscussionResponse?: boolean | null
}

export type DeleteDiscussionSubscriptionMutationVariables = Exact<{
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}>

export type DeleteDiscussionSubscriptionMutation = {
  __typename?: "Mutations"
  deleteDiscussionSubscription?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    path_item_name?: string | null
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges?: Array<{
        __typename?: "TagLinkEdge"
        node?: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id?: number | null
            name?: string | null
            slug?: string | null
            description?: string | null
            color?: string | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type DiscussionParticipantFragment = {
  __typename?: "DiscussionParticipant"
  id: number
  email?: string | null
  first_name: string
  last_name: string
  full_name: string
  display_name?: string | null
  profile?: {
    __typename?: "Profile"
    id?: number | null
    bio?: string | null
    image?: string | null
    location?: string | null
    last_activity?: any | null
    rewardful_referral_id?: string | null
  } | null
}

export type DiscussionParticipantsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}>

export type DiscussionParticipantsQuery = {
  __typename?: "Query"
  discussionParticipants?: {
    __typename?: "DiscussionParticipantConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges?: Array<{
      __typename?: "DiscussionParticipantEdge"
      node?: {
        __typename?: "DiscussionParticipant"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type DiscussionPostFragment = {
  __typename?: "Discussion"
  id: number
  title: string
  body?: string | null
  type: number
  likes: number
  total_responses: number
  created_time: any
  is_discussion_question: boolean
  allow_replies: boolean
  path_item_name?: string | null
  last_activity_time?: any | null
  user_last_viewed_time?: any | null
  user_last_responded_time?: any | null
  user_has_viewed_recent: boolean
  user_is_subscribed?: boolean | null
  user_liked?: boolean | null
  context_id?: number | null
  resource_id?: number | null
  cohort_id?: number | null
  step_id?: number | null
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  cohort?: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
  } | null
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
  } | null
  tagLinks?: {
    __typename?: "TagLinkConnection"
    edges?: Array<{
      __typename?: "TagLinkEdge"
      node?: {
        __typename?: "TagLink"
        id?: number | null
        tag_id?: number | null
        discussion_context_id?: number | null
        tag?: {
          __typename?: "Tag"
          id?: number | null
          name?: string | null
          slug?: string | null
          description?: string | null
          color?: string | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type DiscussionPostQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  context: DiscussionContextInput
}>

export type DiscussionPostQuery = {
  __typename?: "Query"
  discussion?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    path_item_name?: string | null
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges?: Array<{
        __typename?: "TagLinkEdge"
        node?: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id?: number | null
            name?: string | null
            slug?: string | null
            description?: string | null
            color?: string | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type DiscussionQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  context: DiscussionContextInput
  orderResponsesBy?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >
  cursor?: InputMaybe<Scalars["String"]["input"]>
  first?: InputMaybe<Scalars["Int"]["input"]>
}>

export type DiscussionQuery = {
  __typename?: "Query"
  discussion?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    path_item_name?: string | null
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    responses?: {
      __typename?: "ResponseConnection"
      total: number
      pageInfo: {
        __typename?: "PageInfo"
        hasNextPage: boolean
        endCursor?: string | null
      }
      edges?: Array<{
        __typename?: "ResponseEdge"
        node?: {
          __typename?: "Response"
          id: number
          parent_id?: number | null
          body: string
          attachments?: any | null
          likes?: number | null
          user_liked?: boolean | null
          created_time: any
          user?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
        } | null
      } | null> | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges?: Array<{
        __typename?: "TagLinkEdge"
        node?: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id?: number | null
            name?: string | null
            slug?: string | null
            description?: string | null
            color?: string | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type DiscussionResponseFragment = {
  __typename?: "Response"
  id: number
  parent_id?: number | null
  body: string
  attachments?: any | null
  likes?: number | null
  user_liked?: boolean | null
  created_time: any
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type DiscussionResponseQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  context: DiscussionContextInput
  response_id: Scalars["Int"]["input"]
}>

export type DiscussionResponseQuery = {
  __typename?: "Query"
  discussion?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    path_item_name?: string | null
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    response?: {
      __typename?: "Response"
      id: number
      parent_id?: number | null
      body: string
      attachments?: any | null
      likes?: number | null
      user_liked?: boolean | null
      created_time: any
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges?: Array<{
        __typename?: "TagLinkEdge"
        node?: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id?: number | null
            name?: string | null
            slug?: string | null
            description?: string | null
            color?: string | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type DiscussionsQueryVariables = Exact<{
  context: DiscussionContextInput
  type?: InputMaybe<DiscussionTypeInput>
  is_discussion_question?: InputMaybe<Scalars["Boolean"]["input"]>
  total_responses?: InputMaybe<IntFilter>
  tagIdFilter?: InputMaybe<IntFilter>
  order_by?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >
  first?: InputMaybe<Scalars["Int"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type DiscussionsQuery = {
  __typename?: "Query"
  discussions?: {
    __typename?: "DiscussionConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges?: Array<{
      __typename?: "DiscussionEdge"
      node?: {
        __typename?: "Discussion"
        id: number
        title: string
        body?: string | null
        type: number
        likes: number
        total_responses: number
        created_time: any
        is_discussion_question: boolean
        allow_replies: boolean
        path_item_name?: string | null
        last_activity_time?: any | null
        user_last_viewed_time?: any | null
        user_last_responded_time?: any | null
        user_has_viewed_recent: boolean
        user_is_subscribed?: boolean | null
        user_liked?: boolean | null
        context_id?: number | null
        resource_id?: number | null
        cohort_id?: number | null
        step_id?: number | null
        user?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
        cohort?: {
          __typename?: "Group"
          id: number
          name: string
          created?: any | null
          description?: string | null
          price?: number | null
          seats?: number | null
          seats_filled?: number | null
          seats_available?: number | null
          registration_ends?: any | null
          registration_starts?: any | null
          registration_started?: boolean | null
          registration_ended?: boolean | null
          access_ends?: any | null
          access_starts?: any | null
          is_master?: boolean | null
          is_source_cohort?: boolean | null
          source_cohort_id?: number | null
          parent_section_id?: number | null
          resource_id?: number | null
          visibility?: number | null
          is_collection_linked?: boolean | null
          is_subscription_only?: boolean | null
          status: GroupStatus
          analytics_disabled?: boolean | null
          created_by_id?: number | null
        } | null
        resource?: {
          __typename?: "Resource"
          id: number
          name: string
          slug: string
          created?: any | null
          resource_type: number
          visibility?: number | null
          description?: string | null
          short_description?: string | null
          background_overlay?: string | null
          background_image?: string | null
          background_type: ResourceBackgroundType
          image_raw?: string | null
          has_certificate?: boolean | null
          discussion_enabled?: boolean | null
          lowest_public_offering_price?: number | null
          highest_public_offering_price?: number | null
          licensed_from_resource_id?: number | null
          licensed_from_school_id?: number | null
          created_by_id?: number | null
          copied_with_copy_config_id?: number | null
          image: string
          cover_image: string
        } | null
        tagLinks?: {
          __typename?: "TagLinkConnection"
          edges?: Array<{
            __typename?: "TagLinkEdge"
            node?: {
              __typename?: "TagLink"
              id?: number | null
              tag_id?: number | null
              discussion_context_id?: number | null
              tag?: {
                __typename?: "Tag"
                id?: number | null
                name?: string | null
                slug?: string | null
                description?: string | null
                color?: string | null
              } | null
            } | null
          } | null> | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type UpdateDiscussionMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  context: DiscussionContextInput
  post: DiscussionPostInput
}>

export type UpdateDiscussionMutation = {
  __typename?: "Mutations"
  updateDiscussion?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    path_item_name?: string | null
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges?: Array<{
        __typename?: "TagLinkEdge"
        node?: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id?: number | null
            name?: string | null
            slug?: string | null
            description?: string | null
            color?: string | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type UpdateDiscussionResponseMutationVariables = Exact<{
  context: DiscussionContextInput
  response: DiscussionResponseInput
  response_id: Scalars["Int"]["input"]
}>

export type UpdateDiscussionResponseMutation = {
  __typename?: "Mutations"
  updateDiscussionResponse?: {
    __typename?: "Response"
    id: number
    parent_id?: number | null
    body: string
    attachments?: any | null
    likes?: number | null
    user_liked?: boolean | null
    created_time: any
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
  } | null
}

export type UpdateUserDiscussionHistoryMutationVariables = Exact<{
  context: DiscussionContextInput
  discussion_id: Scalars["Int"]["input"]
}>

export type UpdateUserDiscussionHistoryMutation = {
  __typename?: "Mutations"
  updateUserDiscussionHistory?: {
    __typename?: "Discussion"
    id: number
    title: string
    body?: string | null
    type: number
    likes: number
    total_responses: number
    created_time: any
    is_discussion_question: boolean
    allow_replies: boolean
    path_item_name?: string | null
    last_activity_time?: any | null
    user_last_viewed_time?: any | null
    user_last_responded_time?: any | null
    user_has_viewed_recent: boolean
    user_is_subscribed?: boolean | null
    user_liked?: boolean | null
    context_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
    step_id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    tagLinks?: {
      __typename?: "TagLinkConnection"
      edges?: Array<{
        __typename?: "TagLinkEdge"
        node?: {
          __typename?: "TagLink"
          id?: number | null
          tag_id?: number | null
          discussion_context_id?: number | null
          tag?: {
            __typename?: "Tag"
            id?: number | null
            name?: string | null
            slug?: string | null
            description?: string | null
            color?: string | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type CommunityEnableMutationVariables = Exact<{
  cohortId: Scalars["Int"]["input"]
  communityEnabled: Scalars["Boolean"]["input"]
}>

export type CommunityEnableMutation = {
  __typename?: "Mutations"
  updateGroupDiscussionEnabled?: {
    __typename?: "Group"
    id: number
    discussion_enabled?: boolean | null
  } | null
}

export type ContextualFeaturePermissionFragment = {
  __typename?: "ContextualFeaturePermission"
  id?: number | null
  feature_key: FeatureKey
  feature_action: FeatureAction
  permission_in_context: FeaturePermission
  school_id?: number | null
  resource_id?: number | null
  cohort_id?: number | null
}

export type ContextualFeaturePermissionQueryVariables = Exact<{
  featureKey: FeatureKey
  featureAction: FeatureAction
  context?: InputMaybe<FeatureContextInput>
}>

export type ContextualFeaturePermissionQuery = {
  __typename?: "Query"
  contextualFeaturePermission?: {
    __typename?: "ContextualFeaturePermission"
    id?: number | null
    feature_key: FeatureKey
    feature_action: FeatureAction
    permission_in_context: FeaturePermission
    school_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
  } | null
}

export type ContextualFeaturePermissionsQueryVariables = Exact<{
  featureKeys?: InputMaybe<FeatureKeyFilter>
  featureAction?: InputMaybe<FeatureAction>
  context?: InputMaybe<FeatureContextInput>
}>

export type ContextualFeaturePermissionsQuery = {
  __typename?: "Query"
  contextualFeaturePermissions: Array<{
    __typename?: "ContextualFeaturePermission"
    id?: number | null
    feature_key: FeatureKey
    feature_action: FeatureAction
    permission_in_context: FeaturePermission
    school_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
  } | null>
}

export type CreateContextualFeaturePermissionMutationVariables = Exact<{
  featureKey: FeatureKey
  featureAction: FeatureAction
  permissionInContext: FeaturePermission
  context?: InputMaybe<FeatureContextInput>
}>

export type CreateContextualFeaturePermissionMutation = {
  __typename?: "Mutations"
  createContextualFeaturePermission?: {
    __typename?: "ContextualFeaturePermission"
    id?: number | null
    feature_key: FeatureKey
    feature_action: FeatureAction
    permission_in_context: FeaturePermission
    school_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
  } | null
}

export type DeleteContextualFeaturePermissionMutationMutationVariables = Exact<{
  featureKey: FeatureKey
  featureAction: FeatureAction
  context?: InputMaybe<FeatureContextInput>
}>

export type DeleteContextualFeaturePermissionMutationMutation = {
  __typename?: "Mutations"
  deleteContextualFeaturePermission?: boolean | null
}

export type FeatureContextQueryVariables = Exact<{
  cohortId: Scalars["Int"]["input"]
}>

export type FeatureContextQuery = {
  __typename?: "Query"
  cohort?: {
    __typename?: "Group"
    id: number
    name: string
    discussion_enabled?: boolean | null
    resource?: {
      __typename?: "Resource"
      id: number
      discussion_enabled?: boolean | null
    } | null
  } | null
}

export type SpaceAuthSettingsQueryVariables = Exact<{ [key: string]: never }>

export type SpaceAuthSettingsQuery = {
  __typename?: "Query"
  space: {
    __typename?: "Space"
    id: number
    pathwright_login_enabled?: boolean | null
    allow_public_signup?: boolean | null
    always_prompt_for_password?: boolean | null
    authMethods: Array<{
      __typename?: "AuthMethod"
      id: string
      enabled: boolean
      meta: {
        __typename?: "NodeMeta"
        id: string
        key: string
        type: string
        url?: string | null
        title?: string | null
        icon?: string | null
      }
    }>
  }
}

export type UpdateContextualFeaturePermissionMutationVariables = Exact<{
  featureKey: FeatureKey
  featureAction: FeatureAction
  permissionInContext: FeaturePermission
  context?: InputMaybe<FeatureContextInput>
}>

export type UpdateContextualFeaturePermissionMutation = {
  __typename?: "Mutations"
  updateContextualFeaturePermission?: {
    __typename?: "ContextualFeaturePermission"
    id?: number | null
    feature_key: FeatureKey
    feature_action: FeatureAction
    permission_in_context: FeaturePermission
    school_id?: number | null
    resource_id?: number | null
    cohort_id?: number | null
  } | null
}

export type UpdateSpaceAuthSettingsMutationVariables = Exact<{
  pathwrightLoginEnabled: Scalars["Boolean"]["input"]
  allowPublicSignup: Scalars["Boolean"]["input"]
  alwaysPromptForPassword: Scalars["Boolean"]["input"]
}>

export type UpdateSpaceAuthSettingsMutation = {
  __typename?: "Mutations"
  updatePathwrightAuth?: {
    __typename?: "Space"
    id: number
    pathwright_login_enabled?: boolean | null
    allow_public_signup?: boolean | null
    always_prompt_for_password?: boolean | null
  } | null
}

export type CreateGroupMutationVariables = Exact<{
  base_resource_id: Scalars["Int"]["input"]
  parent_offering_id?: InputMaybe<Scalars["Int"]["input"]>
  visibility: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  role?: InputMaybe<RegistrationRoleEnum>
}>

export type CreateGroupMutation = {
  __typename?: "Mutations"
  createGroup?: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      blurred_background?: string | null
      cover_image: string
    } | null
  } | null
}

export type GroupContextFragment = {
  __typename?: "Group"
  id: number
  name: string
  created?: any | null
  description?: string | null
  price?: number | null
  seats?: number | null
  seats_filled?: number | null
  seats_available?: number | null
  registration_ends?: any | null
  registration_starts?: any | null
  registration_started?: boolean | null
  registration_ended?: boolean | null
  access_ends?: any | null
  access_starts?: any | null
  is_master?: boolean | null
  is_source_cohort?: boolean | null
  source_cohort_id?: number | null
  parent_section_id?: number | null
  resource_id?: number | null
  visibility?: number | null
  is_collection_linked?: boolean | null
  is_subscription_only?: boolean | null
  status: GroupStatus
  analytics_disabled?: boolean | null
  created_by_id?: number | null
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    blurred_background?: string | null
    cover_image: string
  } | null
  user_registration?: {
    __typename?: "Registration"
    id: number
    role: number
  } | null
  user_source_registration?: {
    __typename?: "Registration"
    id: number
    role: number
  } | null
}

export type GroupFragment = {
  __typename?: "Group"
  id: number
  name: string
  created?: any | null
  description?: string | null
  price?: number | null
  seats?: number | null
  seats_filled?: number | null
  seats_available?: number | null
  registration_ends?: any | null
  registration_starts?: any | null
  registration_started?: boolean | null
  registration_ended?: boolean | null
  access_ends?: any | null
  access_starts?: any | null
  is_master?: boolean | null
  is_source_cohort?: boolean | null
  source_cohort_id?: number | null
  parent_section_id?: number | null
  resource_id?: number | null
  visibility?: number | null
  is_collection_linked?: boolean | null
  is_subscription_only?: boolean | null
  status: GroupStatus
  analytics_disabled?: boolean | null
  created_by_id?: number | null
}

export type GroupQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type GroupQuery = {
  __typename?: "Query"
  group?: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      blurred_background?: string | null
      cover_image: string
    } | null
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
    } | null
    user_source_registration?: {
      __typename?: "Registration"
      id: number
      role: number
    } | null
  } | null
}

export type CreateResourceMutationVariables = Exact<{
  name: Scalars["String"]["input"]
  cover_image: Scalars["String"]["input"]
  resource_type?: InputMaybe<ResourceType>
  group_name?: InputMaybe<Scalars["String"]["input"]>
  group_role?: InputMaybe<RegistrationRoleEnum>
}>

export type CreateResourceMutation = {
  __typename?: "Mutations"
  createResource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    blurred_background?: string | null
    cover_image: string
    curriculum?: { __typename?: "Group"; id: number } | null
    cohort?: {
      __typename?: "Group"
      id: number
      source_cohort_id?: number | null
    } | null
  } | null
}

export type CreatedResourceFragment = {
  __typename?: "Resource"
  id: number
  name: string
  slug: string
  created?: any | null
  resource_type: number
  visibility?: number | null
  description?: string | null
  short_description?: string | null
  background_overlay?: string | null
  background_image?: string | null
  background_type: ResourceBackgroundType
  image_raw?: string | null
  has_certificate?: boolean | null
  discussion_enabled?: boolean | null
  lowest_public_offering_price?: number | null
  highest_public_offering_price?: number | null
  licensed_from_resource_id?: number | null
  licensed_from_school_id?: number | null
  created_by_id?: number | null
  copied_with_copy_config_id?: number | null
  image: string
  blurred_background?: string | null
  cover_image: string
  curriculum?: { __typename?: "Group"; id: number } | null
  cohort?: {
    __typename?: "Group"
    id: number
    source_cohort_id?: number | null
  } | null
}

export type ManageMentorGroupMembershipsQueryVariables = Exact<{
  [key: string]: never
}>

export type ManageMentorGroupMembershipsQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    mentorGroupMemberships?: {
      __typename?: "MentorGroupMembershipConnection"
      total: number
      edges?: Array<{
        __typename?: "MentorGroupMembershipEdge"
        node?: {
          __typename?: "MentorGroupMembership"
          id: number
          role: number
          group_id: number
        } | null
      } | null> | null
    } | null
  } | null
}

export type UserRegistrationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type UserRegistrationsQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    registrations?: {
      __typename?: "RegistrationConnection"
      total: number
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges?: Array<{
        __typename?: "RegistrationEdge"
        node?: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          resource: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
          }
          group: {
            __typename?: "Group"
            id: number
            name: string
            created?: any | null
            description?: string | null
            price?: number | null
            seats?: number | null
            seats_filled?: number | null
            seats_available?: number | null
            registration_ends?: any | null
            registration_starts?: any | null
            registration_started?: boolean | null
            registration_ended?: boolean | null
            access_ends?: any | null
            access_starts?: any | null
            is_master?: boolean | null
            is_source_cohort?: boolean | null
            source_cohort_id?: number | null
            parent_section_id?: number | null
            resource_id?: number | null
            visibility?: number | null
            is_collection_linked?: boolean | null
            is_subscription_only?: boolean | null
            status: GroupStatus
            analytics_disabled?: boolean | null
            created_by_id?: number | null
          }
          path?: {
            __typename?: "Path"
            id: number
            progress?: number | null
            completion_date?: any | null
          } | null
          school_sub_used?: {
            __typename?: "SchoolSubscription"
            id?: number | null
            subscription?: {
              __typename?: "Subscription"
              id?: number | null
              is_delinquent?: boolean | null
              canceled_dtime?: any | null
            } | null
          } | null
          group_sub_used?: {
            __typename?: "SchoolGroupSubscription"
            id?: number | null
          } | null
          group_sub_community_membership?: {
            __typename?: "MentorGroupMembership"
            id: number
            access_revoked_time?: any | null
          } | null
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
      } | null> | null
    } | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type RandomResourceImageQueryVariables = Exact<{
  themeType?: InputMaybe<ThemeType>
}>

export type RandomResourceImageQuery = {
  __typename?: "Query"
  resourceImage: Array<any | null>
}

export type FeedbackReviewersQueryVariables = Exact<{
  completionId: Scalars["Int"]["input"]
}>

export type FeedbackReviewersQuery = {
  __typename?: "Query"
  feedbackReviewers?: {
    __typename?: "FeedbackReviewers"
    id?: number | null
    reviewers?: Array<any | null> | null
  } | null
}

export type InboxContextQueryVariables = Exact<{
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  group_id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type InboxContextQuery = {
  __typename?: "Query"
  inboxContext?: {
    __typename?: "InboxContext"
    id?: string | null
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      resource?: { __typename?: "Resource"; id: number; name: string } | null
    } | null
    group?: {
      __typename?: "MentorGroup"
      id?: number | null
      name?: string | null
    } | null
  } | null
}

export type InboxGroupConnectionFragment = {
  __typename?: "InboxGroupConnection"
  mentor_group?: {
    __typename?: "MentorGroup"
    id?: number | null
    name?: string | null
    memberships?: {
      __typename?: "MentorGroupMembershipConnection"
      edges?: Array<{
        __typename?: "MentorGroupMembershipEdge"
        node?: {
          __typename?: "MentorGroupMembership"
          id: number
          role: number
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
      } | null> | null
    } | null
  } | null
  cohort?: {
    __typename?: "Group"
    id: number
    name: string
    resource?: { __typename?: "Resource"; id: number; name: string } | null
    registrations?: {
      __typename?: "RegistrationConnection"
      edges?: Array<{
        __typename?: "RegistrationEdge"
        node?: {
          __typename?: "Registration"
          id: number
          role: number
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
      } | null> | null
    } | null
  } | null
}

export type InboxGroupConnectionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type InboxGroupConnectionsQuery = {
  __typename?: "Query"
  inboxGroupConnections?: {
    __typename?: "InboxGroupConnectionConnection"
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges?: Array<{
      __typename?: "InboxGroupConnectionEdge"
      node?: {
        __typename?: "InboxGroupConnection"
        mentor_group?: {
          __typename?: "MentorGroup"
          id?: number | null
          name?: string | null
          memberships?: {
            __typename?: "MentorGroupMembershipConnection"
            edges?: Array<{
              __typename?: "MentorGroupMembershipEdge"
              node?: {
                __typename?: "MentorGroupMembership"
                id: number
                role: number
                user: {
                  __typename?: "User"
                  id: number
                  email?: string | null
                  first_name: string
                  last_name: string
                  full_name: string
                  display_name?: string | null
                  profile?: {
                    __typename?: "Profile"
                    id?: number | null
                    bio?: string | null
                    image?: string | null
                    imageRaw?: string | null
                    location?: string | null
                    last_activity?: any | null
                    rewardful_referral_id?: string | null
                  } | null
                }
              } | null
            } | null> | null
          } | null
        } | null
        cohort?: {
          __typename?: "Group"
          id: number
          name: string
          resource?: {
            __typename?: "Resource"
            id: number
            name: string
          } | null
          registrations?: {
            __typename?: "RegistrationConnection"
            edges?: Array<{
              __typename?: "RegistrationEdge"
              node?: {
                __typename?: "Registration"
                id: number
                role: number
                user: {
                  __typename?: "User"
                  id: number
                  email?: string | null
                  first_name: string
                  last_name: string
                  full_name: string
                  display_name?: string | null
                  profile?: {
                    __typename?: "Profile"
                    id?: number | null
                    bio?: string | null
                    image?: string | null
                    imageRaw?: string | null
                    location?: string | null
                    last_activity?: any | null
                    rewardful_referral_id?: string | null
                  } | null
                }
              } | null
            } | null> | null
          } | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type InboxPendingReviewCountQueryVariables = Exact<{
  targetId: Scalars["Int"]["input"]
  targetType: InboxPendingReviewTarget
}>

export type InboxPendingReviewCountQuery = {
  __typename?: "Query"
  inboxPendingReview?: {
    __typename?: "InboxPendingReview"
    id?: number | null
    count?: number | null
  } | null
}

export type InboxPeopleCompletionCountsFragment = {
  __typename?: "InboxPeopleCompletionCounts"
  id?: number | null
  count?: number | null
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type InboxPeopleCompletionCountsQueryVariables = Exact<{
  targetType: InboxPeopleCompletionCountsTarget
  targetId: Scalars["Int"]["input"]
  first: Scalars["Int"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
  isComplete?: InputMaybe<Scalars["Boolean"]["input"]>
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>
  stepSourceId?: InputMaybe<Scalars["Int"]["input"]>
  parentSourceId?: InputMaybe<Scalars["Int"]["input"]>
  archivedDateFilter?: InputMaybe<
    Array<InputMaybe<DateFilter>> | InputMaybe<DateFilter>
  >
}>

export type InboxPeopleCompletionCountsQuery = {
  __typename?: "Query"
  inboxPeopleCompletionCounts?: {
    __typename?: "InboxPeopleCompletionCountsConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      hasNextPage: boolean
      hasPreviousPage: boolean
      startCursor?: string | null
      endCursor?: string | null
    }
    edges?: Array<{
      __typename?: "InboxPeopleCompletionCountsEdge"
      node?: {
        __typename?: "InboxPeopleCompletionCounts"
        id?: number | null
        count?: number | null
        user?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type InboxReviewerFragment = {
  __typename?: "InboxReviewer"
  id: number
  group_or_cohort_id: number
  group_role?: MentorGroupMembershipRole | null
  cohort_role?: RegistrationRoleEnum | null
  can_review: boolean
  user: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  }
}

export type InboxReviewersQueryVariables = Exact<{
  pathId: Scalars["Int"]["input"]
}>

export type InboxReviewersQuery = {
  __typename?: "Query"
  inboxReviewers?: {
    __typename?: "InboxReviewerConnection"
    edges?: Array<{
      __typename?: "InboxReviewerEdge"
      node?: {
        __typename?: "InboxReviewer"
        id: number
        group_or_cohort_id: number
        group_role?: MentorGroupMembershipRole | null
        cohort_role?: RegistrationRoleEnum | null
        can_review: boolean
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null> | null
  } | null
}

export type AcceptCommunityGroupInvitationMutationVariables = Exact<{
  token: Scalars["String"]["input"]
}>

export type AcceptCommunityGroupInvitationMutation = {
  __typename?: "Mutations"
  acceptCommunityGroupInvitation?: boolean | null
}

export type CreateInvitationsMutationVariables = Exact<{
  context?: InputMaybe<InvitationContext>
  type?: InputMaybe<InvitationType>
  invite_emails:
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  invite_to_community_group_role: MentorGroupMembershipRole
}>

export type CreateInvitationsMutation = {
  __typename?: "Mutations"
  createInvitations?: {
    __typename?: "CreateInvitationsSuccess"
    invitations_attempted_count?: number | null
    invitations_sent_count?: number | null
    unsuccessful_invitations?: any | null
  } | null
}

export type DeleteInvitationMutationVariables = Exact<{
  deleteInvitationId: Scalars["Int"]["input"]
}>

export type DeleteInvitationMutation = {
  __typename?: "Mutations"
  deleteInvitation?: boolean | null
}

export type InvitationFragment = {
  __typename?: "Invitation"
  id: number
  created_dtime: any
  invitation_role: number
  invitation_type: InvitationType
  invitation_subject?: string | null
  invitation_status: InvitationStatus
  invitation_url: string
  invitation_message?: string | null
  invitation_accepted_dtime?: any | null
  invitation_hash?: string | null
  to_email: string
  to_first_name?: string | null
  to_last_name?: string | null
  invitation_email?: {
    __typename?: "EmailMessageData"
    id?: number | null
    created_dtime?: any | null
    delivery_status?: EmailDeliveryStatus | null
    delivery_status_updated?: any | null
  } | null
}

export type InvitationsQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
  context?: InputMaybe<InvitationContext>
  deliveryStatus?: InputMaybe<EmailDeliveryStatus>
  status?: InputMaybe<InvitationStatus>
  orderBy?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >
}>

export type InvitationsQuery = {
  __typename?: "Query"
  invitations?: {
    __typename?: "InvitationConnection"
    edges?: Array<{
      __typename?: "InvitationEdge"
      node?: {
        __typename?: "Invitation"
        id: number
        created_dtime: any
        invitation_role: number
        invitation_type: InvitationType
        invitation_subject?: string | null
        invitation_status: InvitationStatus
        invitation_url: string
        invitation_message?: string | null
        invitation_accepted_dtime?: any | null
        invitation_hash?: string | null
        to_email: string
        to_first_name?: string | null
        to_last_name?: string | null
        invitation_email?: {
          __typename?: "EmailMessageData"
          id?: number | null
          created_dtime?: any | null
          delivery_status?: EmailDeliveryStatus | null
          delivery_status_updated?: any | null
        } | null
      } | null
    } | null> | null
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
  } | null
}

export type ResendInvitationMutationVariables = Exact<{
  resendInvitationId: Scalars["Int"]["input"]
}>

export type ResendInvitationMutation = {
  __typename?: "Mutations"
  resendInvitation?: {
    __typename?: "Invitation"
    id: number
    created_dtime: any
    invitation_role: number
    invitation_type: InvitationType
    invitation_subject?: string | null
    invitation_status: InvitationStatus
    invitation_url: string
    invitation_message?: string | null
    invitation_accepted_dtime?: any | null
    invitation_hash?: string | null
    to_email: string
    to_first_name?: string | null
    to_last_name?: string | null
    invitation_email?: {
      __typename?: "EmailMessageData"
      id?: number | null
      created_dtime?: any | null
      delivery_status?: EmailDeliveryStatus | null
      delivery_status_updated?: any | null
    } | null
  } | null
}

export type FeatureLockQueryVariables = Exact<{
  default_billing_plan_set?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type FeatureLockQuery = {
  __typename?: "Query"
  account?: {
    __typename?: "SchoolAcount"
    id?: number | null
    is_activated?: boolean | null
    is_activated_via_override?: boolean | null
    is_on_legacy_plan?: boolean | null
    billing_subscription?: {
      __typename?: "SchoolBillingSubscription"
      id?: number | null
      plan?: {
        __typename?: "SchoolBillingPlan"
        id: number
        order: number
        name: string
        features: Array<{
          __typename?: "SchoolBillingPlanFeature"
          id: number
          key: string
        }>
        plan_derived_from?: {
          __typename?: "SchoolBillingPlan"
          id: number
        } | null
      } | null
    } | null
    billing_plan_set?: {
      __typename?: "SchoolBillingPlanSet"
      id?: number | null
      plans?: Array<{
        __typename?: "SchoolBillingPlan"
        id: number
        order: number
        name: string
        features: Array<{
          __typename?: "SchoolBillingPlanFeature"
          id: number
          key: string
        }>
        plan_derived_from?: {
          __typename?: "SchoolBillingPlan"
          id: number
        } | null
      } | null> | null
    } | null
  } | null
}

export type FeatureLockSchoolBillingPlanFragment = {
  __typename?: "SchoolBillingPlan"
  id: number
  order: number
  name: string
  features: Array<{
    __typename?: "SchoolBillingPlanFeature"
    id: number
    key: string
  }>
  plan_derived_from?: { __typename?: "SchoolBillingPlan"; id: number } | null
}

export type LibraryAuthorsQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]["input"]>
  resourceSearch?: InputMaybe<Scalars["String"]["input"]>
  resourceAuthorNameFilter?: InputMaybe<StringFilter>
  resourceCategoryNameFilter?: InputMaybe<StringFilter>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type LibraryAuthorsQuery = {
  __typename?: "Query"
  authors?: {
    __typename?: "AuthorConnection"
    pageInfo: {
      __typename?: "PageInfo"
      hasNextPage: boolean
      endCursor?: string | null
    }
    edges?: Array<{
      __typename?: "AuthorEdge"
      node?: {
        __typename?: "Author"
        id?: number | null
        bio?: string | null
        image?: string | null
        order?: number | null
        full_name?: string | null
      } | null
    } | null> | null
  } | null
}

export type LibraryCategoriesQueryVariables = Exact<{
  search?: InputMaybe<Scalars["String"]["input"]>
  resourceSearch?: InputMaybe<Scalars["String"]["input"]>
  resourceCategoryNameFilter?: InputMaybe<StringFilter>
  resourceAuthorNameFilter?: InputMaybe<StringFilter>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type LibraryCategoriesQuery = {
  __typename?: "Query"
  categories?: {
    __typename?: "CategoryConnection"
    pageInfo: {
      __typename?: "PageInfo"
      hasNextPage: boolean
      endCursor?: string | null
    }
    edges?: Array<{
      __typename?: "CategoryEdge"
      node?: {
        __typename?: "Category"
        id?: number | null
        name?: string | null
        slug?: string | null
        order?: number | null
        description?: string | null
      } | null
    } | null> | null
  } | null
}

export type LibraryResourcesQueryVariables = Exact<{
  idFilter?: InputMaybe<IdFilter>
  categoryIdFilter?: InputMaybe<IdFilter>
  authorIdFilter?: InputMaybe<IdFilter>
  categoryNameFilter?: InputMaybe<StringFilter>
  authorNameFilter?: InputMaybe<StringFilter>
  resourceTypeFilter?: InputMaybe<ResourceTypeFilter>
  licensedFromSchoolIdFilter?: InputMaybe<IdFilter>
  roleFilter?: InputMaybe<RoleFilter>
  assignConfig?: InputMaybe<AssignConfig>
  search?: InputMaybe<Scalars["String"]["input"]>
  categorySearch?: InputMaybe<Scalars["String"]["input"]>
  authorSearch?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
  orderBy?: InputMaybe<Scalars["String"]["input"]>
}>

export type LibraryResourcesQuery = {
  __typename?: "Query"
  resources?: {
    __typename?: "ResourceConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges?: Array<{
      __typename?: "ResourceEdge"
      node?: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        created?: any | null
        resource_type: number
        visibility?: number | null
        description?: string | null
        short_description?: string | null
        background_overlay?: string | null
        background_image?: string | null
        background_type: ResourceBackgroundType
        image_raw?: string | null
        has_certificate?: boolean | null
        discussion_enabled?: boolean | null
        lowest_public_offering_price?: number | null
        highest_public_offering_price?: number | null
        licensed_from_resource_id?: number | null
        licensed_from_school_id?: number | null
        created_by_id?: number | null
        copied_with_copy_config_id?: number | null
        image: string
        cover_image: string
        authors?: {
          __typename?: "AuthorConnection"
          edges?: Array<{
            __typename?: "AuthorEdge"
            node?: {
              __typename?: "Author"
              id?: number | null
              bio?: string | null
              image?: string | null
              order?: number | null
              full_name?: string | null
            } | null
          } | null> | null
        } | null
        groups?: { __typename?: "GroupConnection"; total: number } | null
        curriculum?: { __typename?: "Group"; id: number } | null
        license_offerings?: {
          __typename?: "LicenseOfferingConnection"
          edges?: Array<{
            __typename?: "LicenseOfferingEdge"
            node?: {
              __typename?: "LicenseOffering"
              id?: number | null
              cost_per_seat?: number | null
            } | null
          } | null> | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type UpdateLocalTranslationMutationVariables = Exact<{
  translation: Scalars["JSON"]["input"]
}>

export type UpdateLocalTranslationMutation = {
  __typename?: "Mutations"
  updateLocalTranslation?: any | null
}

export type TranslationQueryVariables = Exact<{
  language?: InputMaybe<Scalars["String"]["input"]>
  isDefault?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type TranslationQuery = {
  __typename?: "Query"
  translation?: {
    __typename?: "Translation"
    id?: number | null
    name?: string | null
    language?: string | null
    translation?: any | null
    master_translation?: any | null
    is_default?: boolean | null
  } | null
}

export type MembershipFragment = {
  __typename?: "Membership"
  id: number
  created: any
  last_seen?: any | null
  last_active?: any | null
  has_access: boolean
  access_revoked_time?: any | null
  archived_time?: any | null
  role: number
  consent_dtime?: any | null
  consent_snapshot?: string | null
  user: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    school_subscription?: {
      __typename?: "SchoolSubscription"
      id?: number | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      subscription?: {
        __typename?: "Subscription"
        id?: number | null
        quantity?: number | null
        canceled_dtime?: any | null
        cancellation_reason?: number | null
        card_last_4?: string | null
        cycle_end_dtime?: any | null
        cycle_start_dtime?: any | null
        is_canceled_at_cycle_end?: boolean | null
        is_delinquent?: boolean | null
        paused_until_dtime?: any | null
        trial_type?: number | null
        trial_end_dtime?: any | null
        payment_intent_needing_action_id?: string | null
        subscription_plan?: {
          __typename?: "SubscriptionPlan"
          id?: number | null
          name?: string | null
          amount?: number | null
          interval?: number | null
          trial_period_days?: number | null
          trial_type?: number | null
          plan_type?: string | null
          stripe_connected_account_url?: string | null
        } | null
        customer?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
      } | null
      subscription_plan?: {
        __typename?: "SubscriptionPlan"
        id?: number | null
        name?: string | null
        amount?: number | null
        interval?: number | null
        trial_period_days?: number | null
        trial_type?: number | null
        plan_type?: string | null
        stripe_connected_account_url?: string | null
      } | null
      school_subscription_plan?: {
        __typename?: "SchoolSubscriptionPlan"
        id?: number | null
        image?: string | null
        details_html?: string | null
        subscribe_complete_html?: string | null
        catalog_header?: string | null
        is_visible?: boolean | null
        giftable_cycles?: Array<number | null> | null
        subscription_plan?: {
          __typename?: "SubscriptionPlan"
          id?: number | null
          name?: string | null
          amount?: number | null
          interval?: number | null
          trial_period_days?: number | null
          trial_type?: number | null
          plan_type?: string | null
          stripe_connected_account_url?: string | null
        } | null
      } | null
    } | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  }
}

export type BatchCreateMentorGroupMembershipMutationVariables = Exact<{
  user_ids?: InputMaybe<
    Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
  >
  group: Scalars["Int"]["input"]
  role: MentorGroupMembershipRole
}>

export type BatchCreateMentorGroupMembershipMutation = {
  __typename?: "Mutations"
  batchCreateMentorGroupMembership?: {
    __typename?: "BatchMentorGroupMembershipResult"
    success?: boolean | null
    group_memberships_created_count?: number | null
  } | null
}

export type CreateMentorGroupMutationVariables = Exact<{
  name: Scalars["String"]["input"]
  parent?: InputMaybe<Scalars["Int"]["input"]>
  type?: InputMaybe<MentorGroupType>
}>

export type CreateMentorGroupMutation = {
  __typename?: "Mutations"
  createMentorGroup?: {
    __typename?: "MentorGroup"
    id?: number | null
    type?: number | null
    slug?: string | null
    name?: string | null
    description?: string | null
    created?: any | null
    modified?: any | null
    parent_id?: number | null
    has_child_groups?: boolean | null
    seat_limit?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    memberships?: {
      __typename?: "MentorGroupMembershipConnection"
      total: number
      edges?: Array<{
        __typename?: "MentorGroupMembershipEdge"
        node?: {
          __typename?: "MentorGroupMembership"
          id: number
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
      } | null> | null
    } | null
    owner?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    permissions?: {
      __typename?: "MentorGroupPermissions"
      can_add_member?: boolean | null
      can_add_moderator?: boolean | null
      can_add_admin?: boolean | null
      can_add_group?: boolean | null
      can_edit_group?: boolean | null
      can_change_parent?: boolean | null
      can_edit_subscription?: boolean | null
      can_delete_group?: boolean | null
      can_update_member_review_permission?: boolean | null
      can_update_moderator_review_permission?: boolean | null
      can_update_admin_review_permission?: boolean | null
    } | null
  } | null
}

export type DeleteMentorGroupMembershipMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  group: Scalars["Int"]["input"]
}>

export type DeleteMentorGroupMembershipMutation = {
  __typename?: "Mutations"
  deleteMentorGroupMembership?: boolean | null
}

export type DeleteMentorGroupMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type DeleteMentorGroupMutation = {
  __typename?: "Mutations"
  deleteMentorGroup?: boolean | null
}

export type MentorGroupFragment = {
  __typename?: "MentorGroup"
  id?: number | null
  type?: number | null
  slug?: string | null
  name?: string | null
  description?: string | null
  created?: any | null
  modified?: any | null
  parent_id?: number | null
  has_child_groups?: boolean | null
  seat_limit?: number | null
  seats_filled?: number | null
  seats_available?: number | null
  owner?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  permissions?: {
    __typename?: "MentorGroupPermissions"
    can_add_member?: boolean | null
    can_add_moderator?: boolean | null
    can_add_admin?: boolean | null
    can_add_group?: boolean | null
    can_edit_group?: boolean | null
    can_change_parent?: boolean | null
    can_edit_subscription?: boolean | null
    can_delete_group?: boolean | null
    can_update_member_review_permission?: boolean | null
    can_update_moderator_review_permission?: boolean | null
    can_update_admin_review_permission?: boolean | null
  } | null
}

export type MentorGroupInvitationsQueryVariables = Exact<{
  group_id: Scalars["Int"]["input"]
  search?: InputMaybe<Scalars["String"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type MentorGroupInvitationsQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    mentor_group?: {
      __typename?: "MentorGroup"
      id?: number | null
      invitations?: {
        __typename?: "InvitationConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges?: Array<{
          __typename?: "InvitationEdge"
          node?: {
            __typename?: "Invitation"
            id: number
            created_dtime: any
            invitation_role: number
            invitation_type: InvitationType
            invitation_subject?: string | null
            invitation_status: InvitationStatus
            invitation_url: string
            invitation_message?: string | null
            invitation_accepted_dtime?: any | null
            invitation_hash?: string | null
            to_email: string
            to_first_name?: string | null
            to_last_name?: string | null
            invitation_email?: {
              __typename?: "EmailMessageData"
              id?: number | null
              created_dtime?: any | null
              delivery_status?: EmailDeliveryStatus | null
              delivery_status_updated?: any | null
            } | null
          } | null
        } | null> | null
      } | null
    } | null
  } | null
}

export type MentorGroupMembershipFragment = {
  __typename?: "MentorGroupMembership"
  id: number
  role: number
  created: any
  access_revoked_time?: any | null
  group_id: number
  send_mentor_digest?: boolean | null
  can_review: boolean
  user: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  }
}

export type MentorGroupMembershipQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type MentorGroupMembershipQuery = {
  __typename?: "Query"
  mentorGroupMembership?: {
    __typename?: "MentorGroupMembership"
    id: number
    role: number
    created: any
    access_revoked_time?: any | null
    group_id: number
    send_mentor_digest?: boolean | null
    can_review: boolean
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
  } | null
}

export type MentorGroupMembershipsQueryVariables = Exact<{
  group_id: Scalars["Int"]["input"]
  search?: InputMaybe<Scalars["String"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type MentorGroupMembershipsQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    mentor_group?: {
      __typename?: "MentorGroup"
      id?: number | null
      memberships?: {
        __typename?: "MentorGroupMembershipConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges?: Array<{
          __typename?: "MentorGroupMembershipEdge"
          node?: {
            __typename?: "MentorGroupMembership"
            id: number
            role: number
            created: any
            access_revoked_time?: any | null
            group_id: number
            send_mentor_digest?: boolean | null
            can_review: boolean
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null> | null
      } | null
    } | null
  } | null
}

export type MentorGroupQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type MentorGroupQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    mentor_group?: {
      __typename?: "MentorGroup"
      id?: number | null
      type?: number | null
      slug?: string | null
      name?: string | null
      description?: string | null
      created?: any | null
      modified?: any | null
      parent_id?: number | null
      has_child_groups?: boolean | null
      seat_limit?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      user_membership?: {
        __typename?: "MentorGroupMembership"
        id: number
        role: number
        created: any
        access_revoked_time?: any | null
        group_id: number
        send_mentor_digest?: boolean | null
        can_review: boolean
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
      parent?: {
        __typename?: "MentorGroup"
        id?: number | null
        type?: number | null
        slug?: string | null
        name?: string | null
        description?: string | null
        created?: any | null
        modified?: any | null
        parent_id?: number | null
        has_child_groups?: boolean | null
        seat_limit?: number | null
        seats_filled?: number | null
        seats_available?: number | null
        owner?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
        permissions?: {
          __typename?: "MentorGroupPermissions"
          can_add_member?: boolean | null
          can_add_moderator?: boolean | null
          can_add_admin?: boolean | null
          can_add_group?: boolean | null
          can_edit_group?: boolean | null
          can_change_parent?: boolean | null
          can_edit_subscription?: boolean | null
          can_delete_group?: boolean | null
          can_update_member_review_permission?: boolean | null
          can_update_moderator_review_permission?: boolean | null
          can_update_admin_review_permission?: boolean | null
        } | null
      } | null
      owner?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      permissions?: {
        __typename?: "MentorGroupPermissions"
        can_add_member?: boolean | null
        can_add_moderator?: boolean | null
        can_add_admin?: boolean | null
        can_add_group?: boolean | null
        can_edit_group?: boolean | null
        can_change_parent?: boolean | null
        can_edit_subscription?: boolean | null
        can_delete_group?: boolean | null
        can_update_member_review_permission?: boolean | null
        can_update_moderator_review_permission?: boolean | null
        can_update_admin_review_permission?: boolean | null
      } | null
    } | null
  } | null
}

export type MentorGroupStaffMembershipsQueryVariables = Exact<{
  group_id: Scalars["Int"]["input"]
}>

export type MentorGroupStaffMembershipsQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    mentor_group?: {
      __typename?: "MentorGroup"
      id?: number | null
      memberships?: {
        __typename?: "MentorGroupMembershipConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges?: Array<{
          __typename?: "MentorGroupMembershipEdge"
          node?: {
            __typename?: "MentorGroupMembership"
            id: number
            role: number
            created: any
            access_revoked_time?: any | null
            group_id: number
            send_mentor_digest?: boolean | null
            can_review: boolean
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null> | null
      } | null
    } | null
  } | null
}

export type MentorGroupSubscriptionFragment = {
  __typename?: "MentorGroup"
  id?: number | null
  type?: number | null
  slug?: string | null
  name?: string | null
  description?: string | null
  created?: any | null
  modified?: any | null
  parent_id?: number | null
  has_child_groups?: boolean | null
  seat_limit?: number | null
  seats_filled?: number | null
  seats_available?: number | null
  memberships?: {
    __typename?: "MentorGroupMembershipConnection"
    total: number
    edges?: Array<{
      __typename?: "MentorGroupMembershipEdge"
      node?: {
        __typename?: "MentorGroupMembership"
        id: number
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null> | null
  } | null
  group_subscription?: {
    __typename?: "SchoolGroupSubscription"
    id?: number | null
    price?: {
      __typename?: "StripePrice"
      id: number
      active?: boolean | null
      billing_scheme?: StripeBillingScheme | null
      currency?: string | null
      nickname?: string | null
      recurring_interval?: StripeRecurringInterval | null
      recurring_interval_count?: number | null
      stripe_price_id?: string | null
      stripe_connected_account_url?: string | null
      tiers_mode?: StripeTiersMode | null
      unit_amount_decimal?: number | null
      product?: {
        __typename?: "StripeProduct"
        id: number
        min_quantity?: number | null
        max_quantity?: number | null
        active?: boolean | null
        name?: string | null
        description?: string | null
        images?: Array<string | null> | null
        unit_label?: string | null
        stripe_product_id?: string | null
        stripe_connected_account_url?: string | null
      } | null
      tiers?: Array<{
        __typename?: "StripeTier"
        up_to?: number | null
        flat_amount?: number | null
        flat_amount_decimal?: string | null
        unit_amount?: number | null
        unit_amount_decimal?: string | null
      } | null> | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    subscription?: {
      __typename?: "Subscription"
      id?: number | null
      quantity?: number | null
      canceled_dtime?: any | null
      cancellation_reason?: number | null
      card_last_4?: string | null
      cycle_end_dtime?: any | null
      cycle_start_dtime?: any | null
      is_canceled_at_cycle_end?: boolean | null
      is_delinquent?: boolean | null
      paused_until_dtime?: any | null
      trial_type?: number | null
      trial_end_dtime?: any | null
      payment_intent_needing_action_id?: string | null
      subscription_plan?: {
        __typename?: "SubscriptionPlan"
        id?: number | null
        name?: string | null
        amount?: number | null
        interval?: number | null
        trial_period_days?: number | null
        trial_type?: number | null
        plan_type?: string | null
        stripe_connected_account_url?: string | null
      } | null
      customer?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
    } | null
    community_group?: {
      __typename?: "MentorGroup"
      id?: number | null
      type?: number | null
      slug?: string | null
      name?: string | null
      description?: string | null
      created?: any | null
      modified?: any | null
      parent_id?: number | null
      has_child_groups?: boolean | null
      seat_limit?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      owner?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      permissions?: {
        __typename?: "MentorGroupPermissions"
        can_add_member?: boolean | null
        can_add_moderator?: boolean | null
        can_add_admin?: boolean | null
        can_add_group?: boolean | null
        can_edit_group?: boolean | null
        can_change_parent?: boolean | null
        can_edit_subscription?: boolean | null
        can_delete_group?: boolean | null
        can_update_member_review_permission?: boolean | null
        can_update_moderator_review_permission?: boolean | null
        can_update_admin_review_permission?: boolean | null
      } | null
    } | null
  } | null
  owner?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  permissions?: {
    __typename?: "MentorGroupPermissions"
    can_add_member?: boolean | null
    can_add_moderator?: boolean | null
    can_add_admin?: boolean | null
    can_add_group?: boolean | null
    can_edit_group?: boolean | null
    can_change_parent?: boolean | null
    can_edit_subscription?: boolean | null
    can_delete_group?: boolean | null
    can_update_member_review_permission?: boolean | null
    can_update_moderator_review_permission?: boolean | null
    can_update_admin_review_permission?: boolean | null
  } | null
}

export type MentorGroupSubscriptionQueryVariables = Exact<{
  group_id: Scalars["Int"]["input"]
}>

export type MentorGroupSubscriptionQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    mentor_group?: {
      __typename?: "MentorGroup"
      id?: number | null
      type?: number | null
      slug?: string | null
      name?: string | null
      description?: string | null
      created?: any | null
      modified?: any | null
      parent_id?: number | null
      has_child_groups?: boolean | null
      seat_limit?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      memberships?: {
        __typename?: "MentorGroupMembershipConnection"
        total: number
        edges?: Array<{
          __typename?: "MentorGroupMembershipEdge"
          node?: {
            __typename?: "MentorGroupMembership"
            id: number
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null> | null
      } | null
      group_subscription?: {
        __typename?: "SchoolGroupSubscription"
        id?: number | null
        price?: {
          __typename?: "StripePrice"
          id: number
          active?: boolean | null
          billing_scheme?: StripeBillingScheme | null
          currency?: string | null
          nickname?: string | null
          recurring_interval?: StripeRecurringInterval | null
          recurring_interval_count?: number | null
          stripe_price_id?: string | null
          stripe_connected_account_url?: string | null
          tiers_mode?: StripeTiersMode | null
          unit_amount_decimal?: number | null
          product?: {
            __typename?: "StripeProduct"
            id: number
            min_quantity?: number | null
            max_quantity?: number | null
            active?: boolean | null
            name?: string | null
            description?: string | null
            images?: Array<string | null> | null
            unit_label?: string | null
            stripe_product_id?: string | null
            stripe_connected_account_url?: string | null
          } | null
          tiers?: Array<{
            __typename?: "StripeTier"
            up_to?: number | null
            flat_amount?: number | null
            flat_amount_decimal?: string | null
            unit_amount?: number | null
            unit_amount_decimal?: string | null
          } | null> | null
        } | null
        user?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
        subscription?: {
          __typename?: "Subscription"
          id?: number | null
          quantity?: number | null
          canceled_dtime?: any | null
          cancellation_reason?: number | null
          card_last_4?: string | null
          cycle_end_dtime?: any | null
          cycle_start_dtime?: any | null
          is_canceled_at_cycle_end?: boolean | null
          is_delinquent?: boolean | null
          paused_until_dtime?: any | null
          trial_type?: number | null
          trial_end_dtime?: any | null
          payment_intent_needing_action_id?: string | null
          subscription_plan?: {
            __typename?: "SubscriptionPlan"
            id?: number | null
            name?: string | null
            amount?: number | null
            interval?: number | null
            trial_period_days?: number | null
            trial_type?: number | null
            plan_type?: string | null
            stripe_connected_account_url?: string | null
          } | null
          customer?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
        } | null
        community_group?: {
          __typename?: "MentorGroup"
          id?: number | null
          type?: number | null
          slug?: string | null
          name?: string | null
          description?: string | null
          created?: any | null
          modified?: any | null
          parent_id?: number | null
          has_child_groups?: boolean | null
          seat_limit?: number | null
          seats_filled?: number | null
          seats_available?: number | null
          owner?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          permissions?: {
            __typename?: "MentorGroupPermissions"
            can_add_member?: boolean | null
            can_add_moderator?: boolean | null
            can_add_admin?: boolean | null
            can_add_group?: boolean | null
            can_edit_group?: boolean | null
            can_change_parent?: boolean | null
            can_edit_subscription?: boolean | null
            can_delete_group?: boolean | null
            can_update_member_review_permission?: boolean | null
            can_update_moderator_review_permission?: boolean | null
            can_update_admin_review_permission?: boolean | null
          } | null
        } | null
      } | null
      owner?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      permissions?: {
        __typename?: "MentorGroupPermissions"
        can_add_member?: boolean | null
        can_add_moderator?: boolean | null
        can_add_admin?: boolean | null
        can_add_group?: boolean | null
        can_edit_group?: boolean | null
        can_change_parent?: boolean | null
        can_edit_subscription?: boolean | null
        can_delete_group?: boolean | null
        can_update_member_review_permission?: boolean | null
        can_update_moderator_review_permission?: boolean | null
        can_update_admin_review_permission?: boolean | null
      } | null
    } | null
  } | null
}

export type MentorGroupsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<IdFilter>
  topLevelOnly?: InputMaybe<Scalars["Boolean"]["input"]>
  parentId?: InputMaybe<IdFilter>
  descendentOfParentId?: InputMaybe<EquivalenceIdFilter>
  seatLimitFilter?: InputMaybe<IntFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
}>

export type MentorGroupsQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    mentor_groups?: {
      __typename?: "MentorGroupConnection"
      total: number
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges?: Array<{
        __typename?: "MentorGroupEdge"
        node?: {
          __typename?: "MentorGroup"
          id?: number | null
          type?: number | null
          slug?: string | null
          name?: string | null
          description?: string | null
          created?: any | null
          modified?: any | null
          parent_id?: number | null
          has_child_groups?: boolean | null
          seat_limit?: number | null
          seats_filled?: number | null
          seats_available?: number | null
          memberships?: {
            __typename?: "MentorGroupMembershipConnection"
            total: number
            edges?: Array<{
              __typename?: "MentorGroupMembershipEdge"
              node?: {
                __typename?: "MentorGroupMembership"
                id: number
                user: {
                  __typename?: "User"
                  id: number
                  email?: string | null
                  first_name: string
                  last_name: string
                  full_name: string
                  display_name?: string | null
                  profile?: {
                    __typename?: "Profile"
                    id?: number | null
                    bio?: string | null
                    image?: string | null
                    imageRaw?: string | null
                    location?: string | null
                    last_activity?: any | null
                    rewardful_referral_id?: string | null
                  } | null
                }
              } | null
            } | null> | null
          } | null
          owner?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          permissions?: {
            __typename?: "MentorGroupPermissions"
            can_add_member?: boolean | null
            can_add_moderator?: boolean | null
            can_add_admin?: boolean | null
            can_add_group?: boolean | null
            can_edit_group?: boolean | null
            can_change_parent?: boolean | null
            can_edit_subscription?: boolean | null
            can_delete_group?: boolean | null
            can_update_member_review_permission?: boolean | null
            can_update_moderator_review_permission?: boolean | null
            can_update_admin_review_permission?: boolean | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type UpdateMentorGroupMembershipMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  group: Scalars["Int"]["input"]
  role?: InputMaybe<MentorGroupMembershipRole>
  canReview?: InputMaybe<Scalars["Boolean"]["input"]>
  hasAccess?: InputMaybe<Scalars["Boolean"]["input"]>
  sendMentorDigest?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type UpdateMentorGroupMembershipMutation = {
  __typename?: "Mutations"
  updateMentorGroupMembership?: {
    __typename?: "MentorGroupMembership"
    id: number
    role: number
    created: any
    access_revoked_time?: any | null
    group_id: number
    send_mentor_digest?: boolean | null
    can_review: boolean
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
  } | null
}

export type UpdateMentorGroupMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  parent?: InputMaybe<Scalars["Int"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  type?: InputMaybe<MentorGroupType>
}>

export type UpdateMentorGroupMutation = {
  __typename?: "Mutations"
  updateMentorGroup?: {
    __typename?: "MentorGroup"
    id?: number | null
    type?: number | null
    slug?: string | null
    name?: string | null
    description?: string | null
    created?: any | null
    modified?: any | null
    parent_id?: number | null
    has_child_groups?: boolean | null
    seat_limit?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    owner?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    permissions?: {
      __typename?: "MentorGroupPermissions"
      can_add_member?: boolean | null
      can_add_moderator?: boolean | null
      can_add_admin?: boolean | null
      can_add_group?: boolean | null
      can_edit_group?: boolean | null
      can_change_parent?: boolean | null
      can_edit_subscription?: boolean | null
      can_delete_group?: boolean | null
      can_update_member_review_permission?: boolean | null
      can_update_moderator_review_permission?: boolean | null
      can_update_admin_review_permission?: boolean | null
    } | null
  } | null
}

export type NoteFragment = {
  __typename?: "Note"
  id?: number | null
  title?: string | null
  body?: string | null
  visibility?: NoteVisibility | null
  created_time?: any | null
  modified_time?: any | null
  context_id?: number | null
  resource_id?: number | null
  cohort_id?: number | null
  step_id?: number | null
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type NotesQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
  context: ContextModelInput
  visibility?: InputMaybe<NoteVisibility>
}>

export type NotesQuery = {
  __typename?: "Query"
  notes?: {
    __typename?: "NoteConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges?: Array<{
      __typename?: "NoteEdge"
      node?: {
        __typename?: "Note"
        id?: number | null
        title?: string | null
        body?: string | null
        visibility?: NoteVisibility | null
        created_time?: any | null
        modified_time?: any | null
        context_id?: number | null
        resource_id?: number | null
        cohort_id?: number | null
        step_id?: number | null
        user?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type UpdateNotificationDigestIntervalMutationVariables = Exact<{
  interval?: InputMaybe<NotificationDigestInterval>
}>

export type UpdateNotificationDigestIntervalMutation = {
  __typename?: "Mutations"
  updateNotificationDigestInterval?: {
    __typename?: "Profile"
    id?: number | null
    notification_digest_interval?: NotificationDigestInterval | null
  } | null
}

export type CouponExistsQueryVariables = Exact<{
  input?: InputMaybe<CouponExistsInput>
}>

export type CouponExistsQuery = {
  __typename?: "Query"
  couponExists?: boolean | null
}

export type PathCreatorAssignRoleMutationVariables = Exact<{
  cohorts:
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  user: Scalars["Int"]["input"]
  role: RegistrationRoleEnum
  sendNotification?: InputMaybe<Scalars["Boolean"]["input"]>
  message?: InputMaybe<Scalars["String"]["input"]>
}>

export type PathCreatorAssignRoleMutation = {
  __typename?: "Mutations"
  assign?: any | null
}

export type PathCreatorCohortFragment = {
  __typename?: "Group"
  id: number
  name: string
  registrations?: {
    __typename?: "RegistrationConnection"
    total: number
    edges?: Array<{
      __typename?: "RegistrationEdge"
      node?: {
        __typename?: "Registration"
        id: number
        user: {
          __typename?: "User"
          id: number
          first_name: string
          last_name: string
          full_name: string
          profile?: {
            __typename?: "Profile"
            id?: number | null
            image?: string | null
          } | null
        }
      } | null
    } | null> | null
  } | null
}

export type PathCreatorCohortsQueryVariables = Exact<{
  resourceId: Scalars["Int"]["input"]
  targetUserId: Scalars["Int"]["input"]
}>

export type PathCreatorCohortsQuery = {
  __typename?: "Query"
  cohorts?: {
    __typename?: "GroupConnection"
    edges?: Array<{
      __typename?: "GroupEdge"
      node?: {
        __typename?: "Group"
        id: number
        name: string
        user_registration?: {
          __typename?: "Registration"
          id: number
          role: number
        } | null
        registrations?: {
          __typename?: "RegistrationConnection"
          total: number
          edges?: Array<{
            __typename?: "RegistrationEdge"
            node?: {
              __typename?: "Registration"
              id: number
              user: {
                __typename?: "User"
                id: number
                first_name: string
                last_name: string
                full_name: string
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  image?: string | null
                } | null
              }
            } | null
          } | null> | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type PathCreatorCohortWithRegistrationFragment = {
  __typename?: "Group"
  id: number
  name: string
  user_registration?: {
    __typename?: "Registration"
    id: number
    role: number
  } | null
  registrations?: {
    __typename?: "RegistrationConnection"
    total: number
    edges?: Array<{
      __typename?: "RegistrationEdge"
      node?: {
        __typename?: "Registration"
        id: number
        user: {
          __typename?: "User"
          id: number
          first_name: string
          last_name: string
          full_name: string
          profile?: {
            __typename?: "Profile"
            id?: number | null
            image?: string | null
          } | null
        }
      } | null
    } | null> | null
  } | null
}

export type PathCreatorCreateCohortMutationVariables = Exact<{
  resourceId: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
}>

export type PathCreatorCreateCohortMutation = {
  __typename?: "Mutations"
  createCohort?: {
    __typename?: "Group"
    id: number
    name: string
    registrations?: {
      __typename?: "RegistrationConnection"
      total: number
      edges?: Array<{
        __typename?: "RegistrationEdge"
        node?: {
          __typename?: "Registration"
          id: number
          user: {
            __typename?: "User"
            id: number
            first_name: string
            last_name: string
            full_name: string
            profile?: {
              __typename?: "Profile"
              id?: number | null
              image?: string | null
            } | null
          }
        } | null
      } | null> | null
    } | null
  } | null
}

export type PathCreatorCreatePathFragment = {
  __typename?: "Resource"
  id: number
  name: string
  background_image?: string | null
  image: string
  cohort?: {
    __typename?: "Group"
    id: number
    name: string
    registrations?: {
      __typename?: "RegistrationConnection"
      total: number
      edges?: Array<{
        __typename?: "RegistrationEdge"
        node?: {
          __typename?: "Registration"
          id: number
          user: {
            __typename?: "User"
            id: number
            first_name: string
            last_name: string
            full_name: string
            profile?: {
              __typename?: "Profile"
              id?: number | null
              image?: string | null
            } | null
          }
        } | null
      } | null> | null
    } | null
  } | null
  source_cohort?: {
    __typename?: "Group"
    id: number
    registration?: {
      __typename?: "Registration"
      id: number
      role: number
    } | null
  } | null
}

export type PathCreatorCreatePathMutationVariables = Exact<{
  name: Scalars["String"]["input"]
  image: Scalars["String"]["input"]
  resourceType?: InputMaybe<ResourceType>
  cohortName?: InputMaybe<Scalars["String"]["input"]>
}>

export type PathCreatorCreatePathMutation = {
  __typename?: "Mutations"
  createResource?: {
    __typename?: "Resource"
    id: number
    name: string
    background_image?: string | null
    image: string
    cohort?: {
      __typename?: "Group"
      id: number
      name: string
      registrations?: {
        __typename?: "RegistrationConnection"
        total: number
        edges?: Array<{
          __typename?: "RegistrationEdge"
          node?: {
            __typename?: "Registration"
            id: number
            user: {
              __typename?: "User"
              id: number
              first_name: string
              last_name: string
              full_name: string
              profile?: {
                __typename?: "Profile"
                id?: number | null
                image?: string | null
              } | null
            }
          } | null
        } | null> | null
      } | null
    } | null
    source_cohort?: {
      __typename?: "Group"
      id: number
      registration?: {
        __typename?: "Registration"
        id: number
        role: number
      } | null
    } | null
  } | null
}

export type PathCreatorRandomResourceImageQueryVariables = Exact<{
  themeType?: InputMaybe<ThemeType>
}>

export type PathCreatorRandomResourceImageQuery = {
  __typename?: "Query"
  resourceImage: Array<any | null>
}

export type PathCreatorResourceFragment = {
  __typename?: "Resource"
  id: number
  name: string
  background_image?: string | null
  image: string
  source_cohort?: {
    __typename?: "Group"
    id: number
    registration?: {
      __typename?: "Registration"
      id: number
      role: number
    } | null
  } | null
}

export type PathCreatorResourcesQueryVariables = Exact<{ [key: string]: never }>

export type PathCreatorResourcesQuery = {
  __typename?: "Query"
  resources?: {
    __typename?: "ResourceConnection"
    edges?: Array<{
      __typename?: "ResourceEdge"
      node?: {
        __typename?: "Resource"
        id: number
        name: string
        background_image?: string | null
        image: string
        source_cohort?: {
          __typename?: "Group"
          id: number
          registration?: {
            __typename?: "Registration"
            id: number
            role: number
          } | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type CohortSyncPathQueryVariables = Exact<{
  cohortId: Scalars["Int"]["input"]
}>

export type CohortSyncPathQuery = {
  __typename?: "Query"
  cohort?: {
    __typename?: "Group"
    id: number
    name: string
    is_master?: boolean | null
    visibility?: number | null
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
    } | null
    path: { __typename?: "Path"; id: number }
    source?: {
      __typename?: "Group"
      id: number
      name: string
      is_master?: boolean | null
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
      } | null
      path: { __typename?: "Path"; id: number }
    } | null
    resource?: {
      __typename?: "Resource"
      id: number
      slug: string
      background_overlay?: string | null
      background_image?: string | null
      description?: string | null
      short_description?: string | null
      name: string
      licensing_enabled?: boolean | null
      resource_type: number
      blurred_background?: string | null
      cohorts?: {
        __typename?: "GroupConnection"
        total: number
        edges?: Array<{
          __typename?: "GroupEdge"
          node?: {
            __typename?: "Group"
            id: number
            name: string
            is_master?: boolean | null
            path: { __typename?: "Path"; id: number }
          } | null
        } | null> | null
      } | null
      license_offerings?: {
        __typename?: "LicenseOfferingConnection"
        total: number
      } | null
    } | null
    registrations?: {
      __typename?: "RegistrationConnection"
      total: number
      edges?: Array<{
        __typename?: "RegistrationEdge"
        node?: { __typename?: "Registration"; id: number; role: number } | null
      } | null> | null
    } | null
  } | null
}

export type CohortSyncPathCohortFragment = {
  __typename?: "Group"
  id: number
  name: string
  is_master?: boolean | null
  visibility?: number | null
  user_registration?: {
    __typename?: "Registration"
    id: number
    role: number
  } | null
  path: { __typename?: "Path"; id: number }
  source?: {
    __typename?: "Group"
    id: number
    name: string
    is_master?: boolean | null
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
    } | null
    path: { __typename?: "Path"; id: number }
  } | null
  resource?: {
    __typename?: "Resource"
    id: number
    slug: string
    background_overlay?: string | null
    background_image?: string | null
    description?: string | null
    short_description?: string | null
    name: string
    licensing_enabled?: boolean | null
    resource_type: number
    blurred_background?: string | null
    cohorts?: {
      __typename?: "GroupConnection"
      total: number
      edges?: Array<{
        __typename?: "GroupEdge"
        node?: {
          __typename?: "Group"
          id: number
          name: string
          is_master?: boolean | null
          path: { __typename?: "Path"; id: number }
        } | null
      } | null> | null
    } | null
    license_offerings?: {
      __typename?: "LicenseOfferingConnection"
      total: number
    } | null
  } | null
  registrations?: {
    __typename?: "RegistrationConnection"
    total: number
    edges?: Array<{
      __typename?: "RegistrationEdge"
      node?: { __typename?: "Registration"; id: number; role: number } | null
    } | null> | null
  } | null
}

export type CompletePathItemMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
  skip?: InputMaybe<Scalars["Boolean"]["input"]>
  completion_data?: InputMaybe<Scalars["JSON"]["input"]>
}>

export type CompletePathItemMutation = {
  __typename?: "Mutations"
  completePathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    archived_time?: any | null
    progress: number
    path?: {
      __typename?: "Path"
      id: number
      progress?: number | null
      next_step_id?: number | null
      completion_date?: any | null
      points?: {
        __typename?: "Points"
        path_id?: number | null
        total?: number | null
        earned?: number | null
        total_points_possible?: number | null
        percentage?: number | null
        has_points?: boolean | null
      } | null
    } | null
    context?: {
      __typename?: "StepContext"
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id?: number | null
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type CreatePathItemMutationVariables = Exact<{
  path_id: Scalars["Int"]["input"]
  order: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  type: PathItemType
  assignment_type?: InputMaybe<PathItemAssignmentType>
  parent?: InputMaybe<Scalars["Int"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  content_type?: InputMaybe<Scalars["String"]["input"]>
  content_resource?: InputMaybe<Scalars["Int"]["input"]>
}>

export type CreatePathItemMutation = {
  __typename?: "Mutations"
  createPathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    archived_time?: any | null
    progress: number
    items?: {
      __typename?: "PathItemConnection"
      edges?: Array<{
        __typename?: "PathItemEdge"
        node?: {
          __typename?: "PathItem"
          id: number
          order: number
          verb?: string | null
          name: string
          type: PathItemType
          path_id: number
          source_id: number
          parent_id?: number | null
          parent_source_id?: number | null
          description?: string | null
          curriculum_sync_opt_out_dtime?: any | null
          assignment_type?: PathItemAssignmentType | null
          content_id?: number | null
          content_type?: string | null
          item_content_type_id?: number | null
          is_required?: boolean | null
          is_previewable?: boolean | null
          due?: any | null
          passive_due?: boolean | null
          starts?: any | null
          passive_starts?: boolean | null
          has_started?: boolean | null
          points?: number | null
          item_needs_grading?: boolean | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          time_to_complete?: number | null
          lock_password?: string | null
          is_locked?: boolean | null
          lock_unlocked_time?: any | null
          allow_resets?: number | null
          show_grading_feedback?: number | null
          completion_comment_required_status?: string | null
          last_published_dtime?: any | null
          archived_time?: any | null
          progress: number
          context?: {
            __typename?: "StepContext"
            resource_id?: number | null
            cohort_id?: number | null
          } | null
          blocks?: {
            __typename?: "BlocksContent"
            content_last_modified?: any | null
            last_published?: any | null
          } | null
          permissions?: {
            __typename?: "PathItemPermissions"
            can_complete?: boolean | null
            can_discuss?: boolean | null
            can_edit?: boolean | null
            can_edit_content?: boolean | null
            can_note?: boolean | null
            can_view?: boolean | null
            can_review?: boolean | null
            can_view_content?: boolean | null
          } | null
          completion: {
            __typename?: "Completion"
            id?: number | null
            checked_date?: any | null
            completion_attempts?: number | null
            completion_comment?: string | null
            completion_date?: any | null
            completion_due?: any | null
            last_completion_attempt_date?: any | null
            has_failed_passing_attempt?: boolean | null
            has_points?: boolean | null
            is_late?: boolean | null
            is_graded?: boolean | null
            is_skipped?: boolean | null
            is_complete?: boolean | null
            is_auto_graded?: boolean | null
            is_forced_completion?: boolean | null
            needs_grading?: boolean | null
            userpoints_earned?: number | null
            userpoints_explanation?: string | null
            userpoints_value?: number | null
            minimum_passing_score?: number | null
            grading_type?: string | null
            requires_api_completion?: boolean | null
            overridden_by_api?: boolean | null
            overridden_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            checked_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            user?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            submission?: {
              __typename?: "UserSubmission"
              id?: number | null
              text?: string | null
              file_url?: string | null
              file_name?: string | null
              file_image?: string | null
            } | null
            feedback_discussion_context?: {
              __typename?: "CompletionFeedbackDiscussionContext"
              id?: number | null
              discussion_id?: number | null
              num_responses?: number | null
            } | null
          }
          linked_resource?: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
            curriculum_group?: { __typename?: "Group"; id: number } | null
          } | null
          linked_cohort?: {
            __typename?: "Group"
            id: number
            user_registration?: {
              __typename?: "Registration"
              id: number
              role: number
              completion_state?: number | null
              send_due_notifications?: boolean | null
              send_discussion_notifications?: boolean | null
              last_activity_time?: any | null
              expiration_dtime?: any | null
              created?: any | null
              path?: { __typename?: "Path"; id: number } | null
              user: {
                __typename?: "User"
                id: number
                email?: string | null
                first_name: string
                last_name: string
                full_name: string
                display_name?: string | null
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  bio?: string | null
                  image?: string | null
                  imageRaw?: string | null
                  location?: string | null
                  last_activity?: any | null
                  rewardful_referral_id?: string | null
                } | null
              }
            } | null
          } | null
          linked_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null
      } | null> | null
    } | null
    context?: {
      __typename?: "StepContext"
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id?: number | null
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type CreateRegistrationUpsertGroupMutationVariables = Exact<{
  resource_id: Scalars["Int"]["input"]
  parent_offering_id: Scalars["Int"]["input"]
  step_source_id: Scalars["Int"]["input"]
  createrRegistration?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type CreateRegistrationUpsertGroupMutation = {
  __typename?: "Mutations"
  createRegistrationUpsertGroup?: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type DeletePathItemMutationVariables = Exact<{
  path_id: Scalars["Int"]["input"]
  id: Scalars["Int"]["input"]
}>

export type DeletePathItemMutation = {
  __typename?: "Mutations"
  deletePathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    archived_time?: any | null
    progress: number
    context?: {
      __typename?: "StepContext"
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id?: number | null
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type ExecuteSyncPlanMutationVariables = Exact<{
  sync_plan: PathSyncPlanInput
}>

export type ExecuteSyncPlanMutation = {
  __typename?: "Mutations"
  executePathSyncPlan?: boolean | null
}

export type PastePathItemMutationVariables = Exact<{
  pathId: Scalars["Int"]["input"]
  itemId: Scalars["Int"]["input"]
  parentId?: InputMaybe<Scalars["Int"]["input"]>
  order: Scalars["Int"]["input"]
}>

export type PastePathItemMutation = {
  __typename?: "Mutations"
  pastePathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    archived_time?: any | null
    progress: number
    items?: {
      __typename?: "PathItemConnection"
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges?: Array<{
        __typename?: "PathItemEdge"
        node?: {
          __typename?: "PathItem"
          id: number
          order: number
          verb?: string | null
          name: string
          type: PathItemType
          path_id: number
          source_id: number
          parent_id?: number | null
          parent_source_id?: number | null
          description?: string | null
          curriculum_sync_opt_out_dtime?: any | null
          assignment_type?: PathItemAssignmentType | null
          content_id?: number | null
          content_type?: string | null
          item_content_type_id?: number | null
          is_required?: boolean | null
          is_previewable?: boolean | null
          due?: any | null
          passive_due?: boolean | null
          starts?: any | null
          passive_starts?: boolean | null
          has_started?: boolean | null
          points?: number | null
          item_needs_grading?: boolean | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          time_to_complete?: number | null
          lock_password?: string | null
          is_locked?: boolean | null
          lock_unlocked_time?: any | null
          allow_resets?: number | null
          show_grading_feedback?: number | null
          completion_comment_required_status?: string | null
          last_published_dtime?: any | null
          archived_time?: any | null
          progress: number
          context?: {
            __typename?: "StepContext"
            resource_id?: number | null
            cohort_id?: number | null
          } | null
          blocks?: {
            __typename?: "BlocksContent"
            content_last_modified?: any | null
            last_published?: any | null
          } | null
          permissions?: {
            __typename?: "PathItemPermissions"
            can_complete?: boolean | null
            can_discuss?: boolean | null
            can_edit?: boolean | null
            can_edit_content?: boolean | null
            can_note?: boolean | null
            can_view?: boolean | null
            can_review?: boolean | null
            can_view_content?: boolean | null
          } | null
          completion: {
            __typename?: "Completion"
            id?: number | null
            checked_date?: any | null
            completion_attempts?: number | null
            completion_comment?: string | null
            completion_date?: any | null
            completion_due?: any | null
            last_completion_attempt_date?: any | null
            has_failed_passing_attempt?: boolean | null
            has_points?: boolean | null
            is_late?: boolean | null
            is_graded?: boolean | null
            is_skipped?: boolean | null
            is_complete?: boolean | null
            is_auto_graded?: boolean | null
            is_forced_completion?: boolean | null
            needs_grading?: boolean | null
            userpoints_earned?: number | null
            userpoints_explanation?: string | null
            userpoints_value?: number | null
            minimum_passing_score?: number | null
            grading_type?: string | null
            requires_api_completion?: boolean | null
            overridden_by_api?: boolean | null
            overridden_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            checked_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            user?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            submission?: {
              __typename?: "UserSubmission"
              id?: number | null
              text?: string | null
              file_url?: string | null
              file_name?: string | null
              file_image?: string | null
            } | null
            feedback_discussion_context?: {
              __typename?: "CompletionFeedbackDiscussionContext"
              id?: number | null
              discussion_id?: number | null
              num_responses?: number | null
            } | null
          }
          linked_resource?: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
            curriculum_group?: { __typename?: "Group"; id: number } | null
          } | null
          linked_cohort?: {
            __typename?: "Group"
            id: number
            user_registration?: {
              __typename?: "Registration"
              id: number
              role: number
              completion_state?: number | null
              send_due_notifications?: boolean | null
              send_discussion_notifications?: boolean | null
              last_activity_time?: any | null
              expiration_dtime?: any | null
              created?: any | null
              path?: { __typename?: "Path"; id: number } | null
              user: {
                __typename?: "User"
                id: number
                email?: string | null
                first_name: string
                last_name: string
                full_name: string
                display_name?: string | null
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  bio?: string | null
                  image?: string | null
                  imageRaw?: string | null
                  location?: string | null
                  last_activity?: any | null
                  rewardful_referral_id?: string | null
                } | null
              }
            } | null
          } | null
          linked_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null
      } | null> | null
    } | null
    context?: {
      __typename?: "StepContext"
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id?: number | null
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type PathFragment = {
  __typename?: "Path"
  id: number
  progress?: number | null
  next_step_id?: number | null
  completion_date?: any | null
  created_date?: any | null
  points?: {
    __typename?: "Points"
    path_id?: number | null
    total?: number | null
    earned?: number | null
    total_points_possible?: number | null
    percentage?: number | null
    has_points?: boolean | null
  } | null
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  sync?: {
    __typename?: "PathSync"
    path_id: number
    synced: boolean
    last_synced_date?: any | null
    sync_source_path_id?: number | null
    user_id?: number | null
  } | null
  publish?: {
    __typename?: "PathPublish"
    path_id: number
    published: boolean
    last_published_date?: any | null
  } | null
}

export type PathSyncFragment = {
  __typename?: "PathSync"
  path_id: number
  synced: boolean
  last_synced_date?: any | null
  sync_source_path_id?: number | null
  user_id?: number | null
}

export type PathPublishFragment = {
  __typename?: "PathPublish"
  path_id: number
  published: boolean
  last_published_date?: any | null
}

export type PathSyncPublishFragment = {
  __typename?: "Path"
  id: number
  sync?: {
    __typename?: "PathSync"
    path_id: number
    synced: boolean
    last_synced_date?: any | null
    sync_source_path_id?: number | null
    user_id?: number | null
  } | null
  publish?: {
    __typename?: "PathPublish"
    path_id: number
    published: boolean
    last_published_date?: any | null
  } | null
}

export type PathItemFragment = {
  __typename?: "PathItem"
  id: number
  order: number
  verb?: string | null
  name: string
  type: PathItemType
  path_id: number
  source_id: number
  parent_id?: number | null
  parent_source_id?: number | null
  description?: string | null
  curriculum_sync_opt_out_dtime?: any | null
  assignment_type?: PathItemAssignmentType | null
  content_id?: number | null
  content_type?: string | null
  item_content_type_id?: number | null
  is_required?: boolean | null
  is_previewable?: boolean | null
  due?: any | null
  passive_due?: boolean | null
  starts?: any | null
  passive_starts?: boolean | null
  has_started?: boolean | null
  points?: number | null
  item_needs_grading?: boolean | null
  minimum_passing_score?: number | null
  grading_type?: string | null
  time_to_complete?: number | null
  lock_password?: string | null
  is_locked?: boolean | null
  lock_unlocked_time?: any | null
  allow_resets?: number | null
  show_grading_feedback?: number | null
  completion_comment_required_status?: string | null
  last_published_dtime?: any | null
  archived_time?: any | null
  progress: number
  context?: {
    __typename?: "StepContext"
    resource_id?: number | null
    cohort_id?: number | null
  } | null
  blocks?: {
    __typename?: "BlocksContent"
    content_last_modified?: any | null
    last_published?: any | null
  } | null
  permissions?: {
    __typename?: "PathItemPermissions"
    can_complete?: boolean | null
    can_discuss?: boolean | null
    can_edit?: boolean | null
    can_edit_content?: boolean | null
    can_note?: boolean | null
    can_view?: boolean | null
    can_review?: boolean | null
    can_view_content?: boolean | null
  } | null
  completion: {
    __typename?: "Completion"
    id?: number | null
    checked_date?: any | null
    completion_attempts?: number | null
    completion_comment?: string | null
    completion_date?: any | null
    completion_due?: any | null
    last_completion_attempt_date?: any | null
    has_failed_passing_attempt?: boolean | null
    has_points?: boolean | null
    is_late?: boolean | null
    is_graded?: boolean | null
    is_skipped?: boolean | null
    is_complete?: boolean | null
    is_auto_graded?: boolean | null
    is_forced_completion?: boolean | null
    needs_grading?: boolean | null
    userpoints_earned?: number | null
    userpoints_explanation?: string | null
    userpoints_value?: number | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    requires_api_completion?: boolean | null
    overridden_by_api?: boolean | null
    overridden_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    checked_by?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    submission?: {
      __typename?: "UserSubmission"
      id?: number | null
      text?: string | null
      file_url?: string | null
      file_name?: string | null
      file_image?: string | null
    } | null
    feedback_discussion_context?: {
      __typename?: "CompletionFeedbackDiscussionContext"
      id?: number | null
      discussion_id?: number | null
      num_responses?: number | null
    } | null
  }
  linked_resource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    curriculum_group?: { __typename?: "Group"; id: number } | null
  } | null
  linked_cohort?: {
    __typename?: "Group"
    id: number
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
  linked_registration?: {
    __typename?: "Registration"
    id: number
    role: number
    completion_state?: number | null
    send_due_notifications?: boolean | null
    send_discussion_notifications?: boolean | null
    last_activity_time?: any | null
    expiration_dtime?: any | null
    created?: any | null
    path?: { __typename?: "Path"; id: number } | null
    user: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    }
  } | null
}

export type PathItemQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  path_id?: InputMaybe<Scalars["Int"]["input"]>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  user_id?: InputMaybe<Scalars["Int"]["input"]>
  source_id?: InputMaybe<Scalars["Int"]["input"]>
  archivedDateFilter?: InputMaybe<
    Array<InputMaybe<DateFilter>> | InputMaybe<DateFilter>
  >
}>

export type PathItemQuery = {
  __typename?: "Query"
  pathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    archived_time?: any | null
    progress: number
    context?: {
      __typename?: "StepContext"
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id?: number | null
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type PathItemsFragment = {
  __typename?: "Path"
  id: number
  progress?: number | null
  next_step_id?: number | null
  completion_date?: any | null
  created_date?: any | null
  items?: {
    __typename?: "PathItemConnection"
    edges?: Array<{
      __typename?: "PathItemEdge"
      node?: {
        __typename?: "PathItem"
        id: number
        order: number
        verb?: string | null
        name: string
        type: PathItemType
        path_id: number
        source_id: number
        parent_id?: number | null
        parent_source_id?: number | null
        description?: string | null
        curriculum_sync_opt_out_dtime?: any | null
        assignment_type?: PathItemAssignmentType | null
        content_id?: number | null
        content_type?: string | null
        item_content_type_id?: number | null
        is_required?: boolean | null
        is_previewable?: boolean | null
        due?: any | null
        passive_due?: boolean | null
        starts?: any | null
        passive_starts?: boolean | null
        has_started?: boolean | null
        points?: number | null
        item_needs_grading?: boolean | null
        minimum_passing_score?: number | null
        grading_type?: string | null
        time_to_complete?: number | null
        lock_password?: string | null
        is_locked?: boolean | null
        lock_unlocked_time?: any | null
        allow_resets?: number | null
        show_grading_feedback?: number | null
        completion_comment_required_status?: string | null
        last_published_dtime?: any | null
        archived_time?: any | null
        progress: number
        context?: {
          __typename?: "StepContext"
          resource_id?: number | null
          cohort_id?: number | null
        } | null
        blocks?: {
          __typename?: "BlocksContent"
          content_last_modified?: any | null
          last_published?: any | null
        } | null
        permissions?: {
          __typename?: "PathItemPermissions"
          can_complete?: boolean | null
          can_discuss?: boolean | null
          can_edit?: boolean | null
          can_edit_content?: boolean | null
          can_note?: boolean | null
          can_view?: boolean | null
          can_review?: boolean | null
          can_view_content?: boolean | null
        } | null
        completion: {
          __typename?: "Completion"
          id?: number | null
          checked_date?: any | null
          completion_attempts?: number | null
          completion_comment?: string | null
          completion_date?: any | null
          completion_due?: any | null
          last_completion_attempt_date?: any | null
          has_failed_passing_attempt?: boolean | null
          has_points?: boolean | null
          is_late?: boolean | null
          is_graded?: boolean | null
          is_skipped?: boolean | null
          is_complete?: boolean | null
          is_auto_graded?: boolean | null
          is_forced_completion?: boolean | null
          needs_grading?: boolean | null
          userpoints_earned?: number | null
          userpoints_explanation?: string | null
          userpoints_value?: number | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          requires_api_completion?: boolean | null
          overridden_by_api?: boolean | null
          overridden_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          checked_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          user?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          submission?: {
            __typename?: "UserSubmission"
            id?: number | null
            text?: string | null
            file_url?: string | null
            file_name?: string | null
            file_image?: string | null
          } | null
          feedback_discussion_context?: {
            __typename?: "CompletionFeedbackDiscussionContext"
            id?: number | null
            discussion_id?: number | null
            num_responses?: number | null
          } | null
        }
        linked_resource?: {
          __typename?: "Resource"
          id: number
          name: string
          slug: string
          created?: any | null
          resource_type: number
          visibility?: number | null
          description?: string | null
          short_description?: string | null
          background_overlay?: string | null
          background_image?: string | null
          background_type: ResourceBackgroundType
          image_raw?: string | null
          has_certificate?: boolean | null
          discussion_enabled?: boolean | null
          lowest_public_offering_price?: number | null
          highest_public_offering_price?: number | null
          licensed_from_resource_id?: number | null
          licensed_from_school_id?: number | null
          created_by_id?: number | null
          copied_with_copy_config_id?: number | null
          image: string
          cover_image: string
          curriculum_group?: { __typename?: "Group"; id: number } | null
        } | null
        linked_cohort?: {
          __typename?: "Group"
          id: number
          user_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null
        linked_registration?: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          path?: { __typename?: "Path"; id: number } | null
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
      } | null
    } | null> | null
  } | null
  points?: {
    __typename?: "Points"
    path_id?: number | null
    total?: number | null
    earned?: number | null
    total_points_possible?: number | null
    percentage?: number | null
    has_points?: boolean | null
  } | null
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  sync?: {
    __typename?: "PathSync"
    path_id: number
    synced: boolean
    last_synced_date?: any | null
    sync_source_path_id?: number | null
    user_id?: number | null
  } | null
  publish?: {
    __typename?: "PathPublish"
    path_id: number
    published: boolean
    last_published_date?: any | null
  } | null
}

export type PathItemsQueryVariables = Exact<{
  pathId?: InputMaybe<Scalars["Int"]["input"]>
  cohortId?: InputMaybe<Scalars["Int"]["input"]>
  sourceId?: InputMaybe<Scalars["Int"]["input"]>
  lessonSourceId?: InputMaybe<Scalars["Int"]["input"]>
  archivedDateFilter?: InputMaybe<
    Array<InputMaybe<DateFilter>> | InputMaybe<DateFilter>
  >
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type PathItemsQuery = {
  __typename?: "Query"
  pathItems?: {
    __typename?: "PathItemConnection"
    edges?: Array<{
      __typename?: "PathItemEdge"
      node?: {
        __typename?: "PathItem"
        id: number
        order: number
        verb?: string | null
        name: string
        type: PathItemType
        path_id: number
        source_id: number
        parent_id?: number | null
        parent_source_id?: number | null
        description?: string | null
        curriculum_sync_opt_out_dtime?: any | null
        assignment_type?: PathItemAssignmentType | null
        content_id?: number | null
        content_type?: string | null
        item_content_type_id?: number | null
        is_required?: boolean | null
        is_previewable?: boolean | null
        due?: any | null
        passive_due?: boolean | null
        starts?: any | null
        passive_starts?: boolean | null
        has_started?: boolean | null
        points?: number | null
        item_needs_grading?: boolean | null
        minimum_passing_score?: number | null
        grading_type?: string | null
        time_to_complete?: number | null
        lock_password?: string | null
        is_locked?: boolean | null
        lock_unlocked_time?: any | null
        allow_resets?: number | null
        show_grading_feedback?: number | null
        completion_comment_required_status?: string | null
        last_published_dtime?: any | null
        archived_time?: any | null
        progress: number
        context?: {
          __typename?: "StepContext"
          resource_id?: number | null
          cohort_id?: number | null
        } | null
        blocks?: {
          __typename?: "BlocksContent"
          content_last_modified?: any | null
          last_published?: any | null
        } | null
        permissions?: {
          __typename?: "PathItemPermissions"
          can_complete?: boolean | null
          can_discuss?: boolean | null
          can_edit?: boolean | null
          can_edit_content?: boolean | null
          can_note?: boolean | null
          can_view?: boolean | null
          can_review?: boolean | null
          can_view_content?: boolean | null
        } | null
        completion: {
          __typename?: "Completion"
          id?: number | null
          checked_date?: any | null
          completion_attempts?: number | null
          completion_comment?: string | null
          completion_date?: any | null
          completion_due?: any | null
          last_completion_attempt_date?: any | null
          has_failed_passing_attempt?: boolean | null
          has_points?: boolean | null
          is_late?: boolean | null
          is_graded?: boolean | null
          is_skipped?: boolean | null
          is_complete?: boolean | null
          is_auto_graded?: boolean | null
          is_forced_completion?: boolean | null
          needs_grading?: boolean | null
          userpoints_earned?: number | null
          userpoints_explanation?: string | null
          userpoints_value?: number | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          requires_api_completion?: boolean | null
          overridden_by_api?: boolean | null
          overridden_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          checked_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          user?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          submission?: {
            __typename?: "UserSubmission"
            id?: number | null
            text?: string | null
            file_url?: string | null
            file_name?: string | null
            file_image?: string | null
          } | null
          feedback_discussion_context?: {
            __typename?: "CompletionFeedbackDiscussionContext"
            id?: number | null
            discussion_id?: number | null
            num_responses?: number | null
          } | null
        }
        linked_resource?: {
          __typename?: "Resource"
          id: number
          name: string
          slug: string
          created?: any | null
          resource_type: number
          visibility?: number | null
          description?: string | null
          short_description?: string | null
          background_overlay?: string | null
          background_image?: string | null
          background_type: ResourceBackgroundType
          image_raw?: string | null
          has_certificate?: boolean | null
          discussion_enabled?: boolean | null
          lowest_public_offering_price?: number | null
          highest_public_offering_price?: number | null
          licensed_from_resource_id?: number | null
          licensed_from_school_id?: number | null
          created_by_id?: number | null
          copied_with_copy_config_id?: number | null
          image: string
          cover_image: string
          curriculum_group?: { __typename?: "Group"; id: number } | null
        } | null
        linked_cohort?: {
          __typename?: "Group"
          id: number
          user_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null
        linked_registration?: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          path?: { __typename?: "Path"; id: number } | null
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
      } | null
    } | null> | null
  } | null
}

export type PathPerformanceFragment = {
  __typename?: "PathPerformance"
  id?: number | null
  points?: {
    __typename?: "PathPerformancePoints"
    total?: number | null
    earned?: number | null
    possible?: number | null
    percentage?: number | null
    applicable_score?: any | null
    applicable_score_percentage?: number | null
  } | null
  progress?: {
    __typename?: "PathPerformanceProgress"
    steps_completed?: number | null
    required_steps_completed?: number | null
    total_steps?: number | null
    total_required_steps?: number | null
    percentage?: number | null
  } | null
}

export type PathPerformanceQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type PathPerformanceQuery = {
  __typename?: "Query"
  path?: {
    __typename?: "Path"
    id: number
    performance?: {
      __typename?: "PathPerformance"
      id?: number | null
      points?: {
        __typename?: "PathPerformancePoints"
        total?: number | null
        earned?: number | null
        possible?: number | null
        percentage?: number | null
        applicable_score?: any | null
        applicable_score_percentage?: number | null
      } | null
      progress?: {
        __typename?: "PathPerformanceProgress"
        steps_completed?: number | null
        required_steps_completed?: number | null
        total_steps?: number | null
        total_required_steps?: number | null
        percentage?: number | null
      } | null
    } | null
  } | null
}

export type PathPublishQueryVariables = Exact<{
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type PathPublishQuery = {
  __typename?: "Query"
  path?: {
    __typename?: "Path"
    id: number
    publish?: {
      __typename?: "PathPublish"
      path_id: number
      published: boolean
      last_published_date?: any | null
    } | null
  } | null
}

export type PathQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  cohort_id?: InputMaybe<Scalars["Int"]["input"]>
  archivedDateFilter?: InputMaybe<
    Array<InputMaybe<DateFilter>> | InputMaybe<DateFilter>
  >
}>

export type PathQuery = {
  __typename?: "Query"
  path?: {
    __typename?: "Path"
    id: number
    progress?: number | null
    next_step_id?: number | null
    completion_date?: any | null
    created_date?: any | null
    items?: {
      __typename?: "PathItemConnection"
      edges?: Array<{
        __typename?: "PathItemEdge"
        node?: {
          __typename?: "PathItem"
          id: number
          order: number
          verb?: string | null
          name: string
          type: PathItemType
          path_id: number
          source_id: number
          parent_id?: number | null
          parent_source_id?: number | null
          description?: string | null
          curriculum_sync_opt_out_dtime?: any | null
          assignment_type?: PathItemAssignmentType | null
          content_id?: number | null
          content_type?: string | null
          item_content_type_id?: number | null
          is_required?: boolean | null
          is_previewable?: boolean | null
          due?: any | null
          passive_due?: boolean | null
          starts?: any | null
          passive_starts?: boolean | null
          has_started?: boolean | null
          points?: number | null
          item_needs_grading?: boolean | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          time_to_complete?: number | null
          lock_password?: string | null
          is_locked?: boolean | null
          lock_unlocked_time?: any | null
          allow_resets?: number | null
          show_grading_feedback?: number | null
          completion_comment_required_status?: string | null
          last_published_dtime?: any | null
          archived_time?: any | null
          progress: number
          context?: {
            __typename?: "StepContext"
            resource_id?: number | null
            cohort_id?: number | null
          } | null
          blocks?: {
            __typename?: "BlocksContent"
            content_last_modified?: any | null
            last_published?: any | null
          } | null
          permissions?: {
            __typename?: "PathItemPermissions"
            can_complete?: boolean | null
            can_discuss?: boolean | null
            can_edit?: boolean | null
            can_edit_content?: boolean | null
            can_note?: boolean | null
            can_view?: boolean | null
            can_review?: boolean | null
            can_view_content?: boolean | null
          } | null
          completion: {
            __typename?: "Completion"
            id?: number | null
            checked_date?: any | null
            completion_attempts?: number | null
            completion_comment?: string | null
            completion_date?: any | null
            completion_due?: any | null
            last_completion_attempt_date?: any | null
            has_failed_passing_attempt?: boolean | null
            has_points?: boolean | null
            is_late?: boolean | null
            is_graded?: boolean | null
            is_skipped?: boolean | null
            is_complete?: boolean | null
            is_auto_graded?: boolean | null
            is_forced_completion?: boolean | null
            needs_grading?: boolean | null
            userpoints_earned?: number | null
            userpoints_explanation?: string | null
            userpoints_value?: number | null
            minimum_passing_score?: number | null
            grading_type?: string | null
            requires_api_completion?: boolean | null
            overridden_by_api?: boolean | null
            overridden_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            checked_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            user?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            submission?: {
              __typename?: "UserSubmission"
              id?: number | null
              text?: string | null
              file_url?: string | null
              file_name?: string | null
              file_image?: string | null
            } | null
            feedback_discussion_context?: {
              __typename?: "CompletionFeedbackDiscussionContext"
              id?: number | null
              discussion_id?: number | null
              num_responses?: number | null
            } | null
          }
          linked_resource?: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
            curriculum_group?: { __typename?: "Group"; id: number } | null
          } | null
          linked_cohort?: {
            __typename?: "Group"
            id: number
            user_registration?: {
              __typename?: "Registration"
              id: number
              role: number
              completion_state?: number | null
              send_due_notifications?: boolean | null
              send_discussion_notifications?: boolean | null
              last_activity_time?: any | null
              expiration_dtime?: any | null
              created?: any | null
              path?: { __typename?: "Path"; id: number } | null
              user: {
                __typename?: "User"
                id: number
                email?: string | null
                first_name: string
                last_name: string
                full_name: string
                display_name?: string | null
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  bio?: string | null
                  image?: string | null
                  imageRaw?: string | null
                  location?: string | null
                  last_activity?: any | null
                  rewardful_referral_id?: string | null
                } | null
              }
            } | null
          } | null
          linked_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null
      } | null> | null
    } | null
    schedule?: {
      __typename?: "PathNodeSchedule"
      start?: {
        __typename?: "ScheduleDate"
        behavior: ScheduleDateBehavior
        date?: any | null
      } | null
      end?: {
        __typename?: "ScheduleDate"
        behavior: ScheduleDateBehavior
        date?: any | null
      } | null
    } | null
    points?: {
      __typename?: "Points"
      path_id?: number | null
      total?: number | null
      earned?: number | null
      total_points_possible?: number | null
      percentage?: number | null
      has_points?: boolean | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    sync?: {
      __typename?: "PathSync"
      path_id: number
      synced: boolean
      last_synced_date?: any | null
      sync_source_path_id?: number | null
      user_id?: number | null
    } | null
    publish?: {
      __typename?: "PathPublish"
      path_id: number
      published: boolean
      last_published_date?: any | null
    } | null
  } | null
}

export type SyncPathMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type SyncPathMutation = {
  __typename?: "Mutations"
  syncPath?: {
    __typename?: "Path"
    id: number
    progress?: number | null
    next_step_id?: number | null
    completion_date?: any | null
    created_date?: any | null
    items?: {
      __typename?: "PathItemConnection"
      edges?: Array<{
        __typename?: "PathItemEdge"
        node?: {
          __typename?: "PathItem"
          id: number
          order: number
          verb?: string | null
          name: string
          type: PathItemType
          path_id: number
          source_id: number
          parent_id?: number | null
          parent_source_id?: number | null
          description?: string | null
          curriculum_sync_opt_out_dtime?: any | null
          assignment_type?: PathItemAssignmentType | null
          content_id?: number | null
          content_type?: string | null
          item_content_type_id?: number | null
          is_required?: boolean | null
          is_previewable?: boolean | null
          due?: any | null
          passive_due?: boolean | null
          starts?: any | null
          passive_starts?: boolean | null
          has_started?: boolean | null
          points?: number | null
          item_needs_grading?: boolean | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          time_to_complete?: number | null
          lock_password?: string | null
          is_locked?: boolean | null
          lock_unlocked_time?: any | null
          allow_resets?: number | null
          show_grading_feedback?: number | null
          completion_comment_required_status?: string | null
          last_published_dtime?: any | null
          archived_time?: any | null
          progress: number
          context?: {
            __typename?: "StepContext"
            resource_id?: number | null
            cohort_id?: number | null
          } | null
          blocks?: {
            __typename?: "BlocksContent"
            content_last_modified?: any | null
            last_published?: any | null
          } | null
          permissions?: {
            __typename?: "PathItemPermissions"
            can_complete?: boolean | null
            can_discuss?: boolean | null
            can_edit?: boolean | null
            can_edit_content?: boolean | null
            can_note?: boolean | null
            can_view?: boolean | null
            can_review?: boolean | null
            can_view_content?: boolean | null
          } | null
          completion: {
            __typename?: "Completion"
            id?: number | null
            checked_date?: any | null
            completion_attempts?: number | null
            completion_comment?: string | null
            completion_date?: any | null
            completion_due?: any | null
            last_completion_attempt_date?: any | null
            has_failed_passing_attempt?: boolean | null
            has_points?: boolean | null
            is_late?: boolean | null
            is_graded?: boolean | null
            is_skipped?: boolean | null
            is_complete?: boolean | null
            is_auto_graded?: boolean | null
            is_forced_completion?: boolean | null
            needs_grading?: boolean | null
            userpoints_earned?: number | null
            userpoints_explanation?: string | null
            userpoints_value?: number | null
            minimum_passing_score?: number | null
            grading_type?: string | null
            requires_api_completion?: boolean | null
            overridden_by_api?: boolean | null
            overridden_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            checked_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            user?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            submission?: {
              __typename?: "UserSubmission"
              id?: number | null
              text?: string | null
              file_url?: string | null
              file_name?: string | null
              file_image?: string | null
            } | null
            feedback_discussion_context?: {
              __typename?: "CompletionFeedbackDiscussionContext"
              id?: number | null
              discussion_id?: number | null
              num_responses?: number | null
            } | null
          }
          linked_resource?: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
            curriculum_group?: { __typename?: "Group"; id: number } | null
          } | null
          linked_cohort?: {
            __typename?: "Group"
            id: number
            user_registration?: {
              __typename?: "Registration"
              id: number
              role: number
              completion_state?: number | null
              send_due_notifications?: boolean | null
              send_discussion_notifications?: boolean | null
              last_activity_time?: any | null
              expiration_dtime?: any | null
              created?: any | null
              path?: { __typename?: "Path"; id: number } | null
              user: {
                __typename?: "User"
                id: number
                email?: string | null
                first_name: string
                last_name: string
                full_name: string
                display_name?: string | null
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  bio?: string | null
                  image?: string | null
                  imageRaw?: string | null
                  location?: string | null
                  last_activity?: any | null
                  rewardful_referral_id?: string | null
                } | null
              }
            } | null
          } | null
          linked_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null
      } | null> | null
    } | null
    points?: {
      __typename?: "Points"
      path_id?: number | null
      total?: number | null
      earned?: number | null
      total_points_possible?: number | null
      percentage?: number | null
      has_points?: boolean | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    sync?: {
      __typename?: "PathSync"
      path_id: number
      synced: boolean
      last_synced_date?: any | null
      sync_source_path_id?: number | null
      user_id?: number | null
    } | null
    publish?: {
      __typename?: "PathPublish"
      path_id: number
      published: boolean
      last_published_date?: any | null
    } | null
  } | null
}

export type PathSyncPlanChangeFragment = {
  __typename?: "PathSyncPlanChange"
  item_source_id: number
  parent_source_id?: number | null
  item_name: string
  parent_name?: string | null
  item_type: PathItemType
  assignment_type?: PathItemAssignmentType | null
  forced?: PathSyncPlanForceType | null
  forced_reasons?: Array<PathSyncPlanForceReasonType | null> | null
  change_details?: any | null
  last_changed?: any | null
}

export type PathSyncPlanQueryVariables = Exact<{
  sync_plan: PathSyncPlanInput
}>

export type PathSyncPlanQuery = {
  __typename?: "Query"
  pathSyncPlan?: {
    __typename?: "PathSyncPlan"
    from_path_id?: number | null
    to_path_id?: number | null
    hash: string
    included_changes: Array<{
      __typename?: "PathSyncPlanChange"
      item_source_id: number
      parent_source_id?: number | null
      item_name: string
      parent_name?: string | null
      item_type: PathItemType
      assignment_type?: PathItemAssignmentType | null
      forced?: PathSyncPlanForceType | null
      forced_reasons?: Array<PathSyncPlanForceReasonType | null> | null
      change_details?: any | null
      last_changed?: any | null
    } | null>
    excluded_changes: Array<{
      __typename?: "PathSyncPlanChange"
      item_source_id: number
      parent_source_id?: number | null
      item_name: string
      parent_name?: string | null
      item_type: PathItemType
      assignment_type?: PathItemAssignmentType | null
      forced?: PathSyncPlanForceType | null
      forced_reasons?: Array<PathSyncPlanForceReasonType | null> | null
      change_details?: any | null
      last_changed?: any | null
    } | null>
  } | null
}

export type ReorderPathItemsMutationVariables = Exact<{
  path_id: Scalars["Int"]["input"]
  items: Array<InputMaybe<PathItemOrder>> | InputMaybe<PathItemOrder>
}>

export type ReorderPathItemsMutation = {
  __typename?: "Mutations"
  reorderPathItems?: boolean | null
}

export type ResetPathItemForUserMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}>

export type ResetPathItemForUserMutation = {
  __typename?: "Mutations"
  resetPathItemForUser?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    archived_time?: any | null
    progress: number
    context?: {
      __typename?: "StepContext"
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id?: number | null
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type ResetPathItemMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}>

export type ResetPathItemMutation = {
  __typename?: "Mutations"
  resetPathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    archived_time?: any | null
    progress: number
    path?: {
      __typename?: "Path"
      id: number
      progress?: number | null
      next_step_id?: number | null
      completion_date?: any | null
      points?: {
        __typename?: "Points"
        path_id?: number | null
        total?: number | null
        earned?: number | null
        total_points_possible?: number | null
        percentage?: number | null
        has_points?: boolean | null
      } | null
    } | null
    context?: {
      __typename?: "StepContext"
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id?: number | null
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type SingleCohortPathQueryVariables = Exact<{
  cohort_id: Scalars["Int"]["input"]
}>

export type SingleCohortPathQuery = {
  __typename?: "Query"
  path?: {
    __typename?: "Path"
    id: number
    items?: {
      __typename?: "PathItemConnection"
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges?: Array<{
        __typename?: "PathItemEdge"
        node?: {
          __typename?: "PathItem"
          id: number
          type: PathItemType
          blocks?: {
            __typename?: "BlocksContent"
            content_last_modified?: any | null
            last_published?: any | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type SingleCohortPathFragment = {
  __typename?: "Path"
  id: number
  items?: {
    __typename?: "PathItemConnection"
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges?: Array<{
      __typename?: "PathItemEdge"
      node?: {
        __typename?: "PathItem"
        id: number
        type: PathItemType
        blocks?: {
          __typename?: "BlocksContent"
          content_last_modified?: any | null
          last_published?: any | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type SkipPathItemForUserMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
}>

export type SkipPathItemForUserMutation = {
  __typename?: "Mutations"
  skipPathItemForUser?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    archived_time?: any | null
    progress: number
    context?: {
      __typename?: "StepContext"
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id?: number | null
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type UnarchivePathItemMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  pathId: Scalars["Int"]["input"]
}>

export type UnarchivePathItemMutation = {
  __typename?: "Mutations"
  unarchivePathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    archived_time?: any | null
    progress: number
    context?: {
      __typename?: "StepContext"
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id?: number | null
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type UnlockPathItemMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  path_id: Scalars["Int"]["input"]
  step_lock_password: Scalars["String"]["input"]
}>

export type UnlockPathItemMutation = {
  __typename?: "Mutations"
  unlockPathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    archived_time?: any | null
    progress: number
    context?: {
      __typename?: "StepContext"
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id?: number | null
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type UpdatePathItemMutationVariables = Exact<{
  path_id: Scalars["Int"]["input"]
  source_id: Scalars["Int"]["input"]
  order: Scalars["Int"]["input"]
  type: PathItemType
  name: Scalars["String"]["input"]
  description?: InputMaybe<Scalars["String"]["input"]>
  assignment_type?: InputMaybe<PathItemAssignmentType>
  is_required?: InputMaybe<Scalars["Boolean"]["input"]>
  allow_resets?: InputMaybe<Scalars["Int"]["input"]>
  show_grading_feedback?: InputMaybe<Scalars["Int"]["input"]>
  completion_comment_required_status?: InputMaybe<Scalars["String"]["input"]>
  points?: InputMaybe<Scalars["Int"]["input"]>
  minimum_passing_score?: InputMaybe<Scalars["Int"]["input"]>
  grading_type?: InputMaybe<Scalars["String"]["input"]>
  is_previewable?: InputMaybe<Scalars["Boolean"]["input"]>
  lock_password?: InputMaybe<Scalars["String"]["input"]>
  time_to_complete?: InputMaybe<Scalars["Int"]["input"]>
  requires_api_completion?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type UpdatePathItemMutation = {
  __typename?: "Mutations"
  updatePathItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    archived_time?: any | null
    progress: number
    context?: {
      __typename?: "StepContext"
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id?: number | null
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type UserPathReportCardFragment = {
  __typename?: "Path"
  id: number
  progress?: number | null
  next_step_id?: number | null
  completion_date?: any | null
  created_date?: any | null
  performance?: {
    __typename?: "PathPerformance"
    id?: number | null
    points?: {
      __typename?: "PathPerformancePoints"
      total?: number | null
      earned?: number | null
      possible?: number | null
      percentage?: number | null
      applicable_score?: any | null
      applicable_score_percentage?: number | null
    } | null
    progress?: {
      __typename?: "PathPerformanceProgress"
      steps_completed?: number | null
      required_steps_completed?: number | null
      total_steps?: number | null
      total_required_steps?: number | null
      percentage?: number | null
    } | null
  } | null
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  cohort?: { __typename?: "Group"; id: number; name: string } | null
  items?: {
    __typename?: "PathItemConnection"
    edges?: Array<{
      __typename?: "PathItemEdge"
      node?: {
        __typename?: "PathItem"
        id: number
        order: number
        verb?: string | null
        name: string
        type: PathItemType
        path_id: number
        source_id: number
        parent_id?: number | null
        parent_source_id?: number | null
        description?: string | null
        curriculum_sync_opt_out_dtime?: any | null
        assignment_type?: PathItemAssignmentType | null
        content_id?: number | null
        content_type?: string | null
        item_content_type_id?: number | null
        is_required?: boolean | null
        is_previewable?: boolean | null
        due?: any | null
        passive_due?: boolean | null
        starts?: any | null
        passive_starts?: boolean | null
        has_started?: boolean | null
        points?: number | null
        item_needs_grading?: boolean | null
        minimum_passing_score?: number | null
        grading_type?: string | null
        time_to_complete?: number | null
        lock_password?: string | null
        is_locked?: boolean | null
        lock_unlocked_time?: any | null
        allow_resets?: number | null
        show_grading_feedback?: number | null
        completion_comment_required_status?: string | null
        last_published_dtime?: any | null
        archived_time?: any | null
        progress: number
        context?: {
          __typename?: "StepContext"
          resource_id?: number | null
          cohort_id?: number | null
        } | null
        blocks?: {
          __typename?: "BlocksContent"
          content_last_modified?: any | null
          last_published?: any | null
        } | null
        permissions?: {
          __typename?: "PathItemPermissions"
          can_complete?: boolean | null
          can_discuss?: boolean | null
          can_edit?: boolean | null
          can_edit_content?: boolean | null
          can_note?: boolean | null
          can_view?: boolean | null
          can_review?: boolean | null
          can_view_content?: boolean | null
        } | null
        completion: {
          __typename?: "Completion"
          id?: number | null
          checked_date?: any | null
          completion_attempts?: number | null
          completion_comment?: string | null
          completion_date?: any | null
          completion_due?: any | null
          last_completion_attempt_date?: any | null
          has_failed_passing_attempt?: boolean | null
          has_points?: boolean | null
          is_late?: boolean | null
          is_graded?: boolean | null
          is_skipped?: boolean | null
          is_complete?: boolean | null
          is_auto_graded?: boolean | null
          is_forced_completion?: boolean | null
          needs_grading?: boolean | null
          userpoints_earned?: number | null
          userpoints_explanation?: string | null
          userpoints_value?: number | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          requires_api_completion?: boolean | null
          overridden_by_api?: boolean | null
          overridden_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          checked_by?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          user?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          submission?: {
            __typename?: "UserSubmission"
            id?: number | null
            text?: string | null
            file_url?: string | null
            file_name?: string | null
            file_image?: string | null
          } | null
          feedback_discussion_context?: {
            __typename?: "CompletionFeedbackDiscussionContext"
            id?: number | null
            discussion_id?: number | null
            num_responses?: number | null
          } | null
        }
        linked_resource?: {
          __typename?: "Resource"
          id: number
          name: string
          slug: string
          created?: any | null
          resource_type: number
          visibility?: number | null
          description?: string | null
          short_description?: string | null
          background_overlay?: string | null
          background_image?: string | null
          background_type: ResourceBackgroundType
          image_raw?: string | null
          has_certificate?: boolean | null
          discussion_enabled?: boolean | null
          lowest_public_offering_price?: number | null
          highest_public_offering_price?: number | null
          licensed_from_resource_id?: number | null
          licensed_from_school_id?: number | null
          created_by_id?: number | null
          copied_with_copy_config_id?: number | null
          image: string
          cover_image: string
          curriculum_group?: { __typename?: "Group"; id: number } | null
        } | null
        linked_cohort?: {
          __typename?: "Group"
          id: number
          user_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null
        linked_registration?: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          path?: { __typename?: "Path"; id: number } | null
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
      } | null
    } | null> | null
  } | null
  points?: {
    __typename?: "Points"
    path_id?: number | null
    total?: number | null
    earned?: number | null
    total_points_possible?: number | null
    percentage?: number | null
    has_points?: boolean | null
  } | null
  sync?: {
    __typename?: "PathSync"
    path_id: number
    synced: boolean
    last_synced_date?: any | null
    sync_source_path_id?: number | null
    user_id?: number | null
  } | null
  publish?: {
    __typename?: "PathPublish"
    path_id: number
    published: boolean
    last_published_date?: any | null
  } | null
}

export type UserPathReportCardQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type UserPathReportCardQuery = {
  __typename?: "Query"
  path?: {
    __typename?: "Path"
    id: number
    progress?: number | null
    next_step_id?: number | null
    completion_date?: any | null
    created_date?: any | null
    performance?: {
      __typename?: "PathPerformance"
      id?: number | null
      points?: {
        __typename?: "PathPerformancePoints"
        total?: number | null
        earned?: number | null
        possible?: number | null
        percentage?: number | null
        applicable_score?: any | null
        applicable_score_percentage?: number | null
      } | null
      progress?: {
        __typename?: "PathPerformanceProgress"
        steps_completed?: number | null
        required_steps_completed?: number | null
        total_steps?: number | null
        total_required_steps?: number | null
        percentage?: number | null
      } | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    cohort?: { __typename?: "Group"; id: number; name: string } | null
    items?: {
      __typename?: "PathItemConnection"
      edges?: Array<{
        __typename?: "PathItemEdge"
        node?: {
          __typename?: "PathItem"
          id: number
          order: number
          verb?: string | null
          name: string
          type: PathItemType
          path_id: number
          source_id: number
          parent_id?: number | null
          parent_source_id?: number | null
          description?: string | null
          curriculum_sync_opt_out_dtime?: any | null
          assignment_type?: PathItemAssignmentType | null
          content_id?: number | null
          content_type?: string | null
          item_content_type_id?: number | null
          is_required?: boolean | null
          is_previewable?: boolean | null
          due?: any | null
          passive_due?: boolean | null
          starts?: any | null
          passive_starts?: boolean | null
          has_started?: boolean | null
          points?: number | null
          item_needs_grading?: boolean | null
          minimum_passing_score?: number | null
          grading_type?: string | null
          time_to_complete?: number | null
          lock_password?: string | null
          is_locked?: boolean | null
          lock_unlocked_time?: any | null
          allow_resets?: number | null
          show_grading_feedback?: number | null
          completion_comment_required_status?: string | null
          last_published_dtime?: any | null
          archived_time?: any | null
          progress: number
          context?: {
            __typename?: "StepContext"
            resource_id?: number | null
            cohort_id?: number | null
          } | null
          blocks?: {
            __typename?: "BlocksContent"
            content_last_modified?: any | null
            last_published?: any | null
          } | null
          permissions?: {
            __typename?: "PathItemPermissions"
            can_complete?: boolean | null
            can_discuss?: boolean | null
            can_edit?: boolean | null
            can_edit_content?: boolean | null
            can_note?: boolean | null
            can_view?: boolean | null
            can_review?: boolean | null
            can_view_content?: boolean | null
          } | null
          completion: {
            __typename?: "Completion"
            id?: number | null
            checked_date?: any | null
            completion_attempts?: number | null
            completion_comment?: string | null
            completion_date?: any | null
            completion_due?: any | null
            last_completion_attempt_date?: any | null
            has_failed_passing_attempt?: boolean | null
            has_points?: boolean | null
            is_late?: boolean | null
            is_graded?: boolean | null
            is_skipped?: boolean | null
            is_complete?: boolean | null
            is_auto_graded?: boolean | null
            is_forced_completion?: boolean | null
            needs_grading?: boolean | null
            userpoints_earned?: number | null
            userpoints_explanation?: string | null
            userpoints_value?: number | null
            minimum_passing_score?: number | null
            grading_type?: string | null
            requires_api_completion?: boolean | null
            overridden_by_api?: boolean | null
            overridden_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            checked_by?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            user?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            submission?: {
              __typename?: "UserSubmission"
              id?: number | null
              text?: string | null
              file_url?: string | null
              file_name?: string | null
              file_image?: string | null
            } | null
            feedback_discussion_context?: {
              __typename?: "CompletionFeedbackDiscussionContext"
              id?: number | null
              discussion_id?: number | null
              num_responses?: number | null
            } | null
          }
          linked_resource?: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
            curriculum_group?: { __typename?: "Group"; id: number } | null
          } | null
          linked_cohort?: {
            __typename?: "Group"
            id: number
            user_registration?: {
              __typename?: "Registration"
              id: number
              role: number
              completion_state?: number | null
              send_due_notifications?: boolean | null
              send_discussion_notifications?: boolean | null
              last_activity_time?: any | null
              expiration_dtime?: any | null
              created?: any | null
              path?: { __typename?: "Path"; id: number } | null
              user: {
                __typename?: "User"
                id: number
                email?: string | null
                first_name: string
                last_name: string
                full_name: string
                display_name?: string | null
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  bio?: string | null
                  image?: string | null
                  imageRaw?: string | null
                  location?: string | null
                  last_activity?: any | null
                  rewardful_referral_id?: string | null
                } | null
              }
            } | null
          } | null
          linked_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            completion_state?: number | null
            send_due_notifications?: boolean | null
            send_discussion_notifications?: boolean | null
            last_activity_time?: any | null
            expiration_dtime?: any | null
            created?: any | null
            path?: { __typename?: "Path"; id: number } | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null
      } | null> | null
    } | null
    points?: {
      __typename?: "Points"
      path_id?: number | null
      total?: number | null
      earned?: number | null
      total_points_possible?: number | null
      percentage?: number | null
      has_points?: boolean | null
    } | null
    sync?: {
      __typename?: "PathSync"
      path_id: number
      synced: boolean
      last_synced_date?: any | null
      sync_source_path_id?: number | null
      user_id?: number | null
    } | null
    publish?: {
      __typename?: "PathPublish"
      path_id: number
      published: boolean
      last_published_date?: any | null
    } | null
  } | null
}

export type MissingPathItemFragment = {
  __typename?: "PathItem"
  id: number
  source_id: number
  name: string
  archived_time?: any | null
}

export type MissingPathItemQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  pathId?: InputMaybe<Scalars["Int"]["input"]>
}>

export type MissingPathItemQuery = {
  __typename?: "Query"
  missingPathItem?: {
    __typename?: "PathItem"
    id: number
    source_id: number
    name: string
    archived_time?: any | null
  } | null
  missingSourcePathItem?: {
    __typename?: "PathItem"
    id: number
    source_id: number
    name: string
    archived_time?: any | null
  } | null
}

export type ContextQueryVariables = Exact<{ [key: string]: never }>

export type ContextQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    theme?: {
      __typename?: "Theme"
      id?: number | null
      name?: string | null
      theme_type?: ThemeType | null
      background_image?: string | null
      background_overlay?: string | null
      background_type?: number | null
      heading_font?: string | null
      primary_color?: string | null
      typekit_id?: string | null
      custom_css?: string | null
      processed_custom_css?: string | null
      color_palette?: {
        __typename?: "NodeThemeColorPalette"
        _50?: string | null
        _100?: string | null
        _200?: string | null
        _300?: string | null
        _400?: string | null
        _500?: string | null
        _600?: string | null
        _700?: string | null
        _800?: string | null
        _900?: string | null
      } | null
    } | null
    features: {
      __typename?: "SchoolFeatures"
      auth__platform: boolean
      media__downloadable_videos: boolean
      library__cover_pages: boolean
    }
  } | null
  me?: {
    __typename?: "User"
    username?: string | null
    no_password_set?: boolean | null
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    group_role_stats?: Array<{
      __typename?: "GroupRoleStats"
      type?: string | null
      total?: number | null
      role?: number | null
    } | null> | null
    permissions?: {
      __typename?: "ContextPermissions"
      is_school_owner?: boolean | null
      can_administrate?: boolean | null
      can_edit_library?: boolean | null
      has_member_access?: boolean | null
      has_pathwright_staff_access?: boolean | null
    } | null
    membership?: {
      __typename?: "Membership"
      id: number
      created: any
      last_seen?: any | null
      last_active?: any | null
      has_access: boolean
      role: number
      consent_snapshot?: string | null
      consent_dtime?: any | null
    } | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      notification_digest_interval?: NotificationDigestInterval | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  translation?: {
    __typename?: "Translation"
    id?: number | null
    name?: string | null
    language?: string | null
    translation?: any | null
    master_translation?: any | null
    is_default?: boolean | null
  } | null
  platformConfig?: {
    __typename?: "PlatformConfig"
    id?: number | null
    payments_maintenance_mode?: boolean | null
  } | null
  integrations?: {
    __typename?: "Integrations"
    firebase?: {
      __typename?: "FirebaseIntegration"
      auth_token?: string | null
      url?: string | null
      client_api_key?: string | null
    } | null
    intercom?: {
      __typename?: "IntercomIntegration"
      app_id?: string | null
      pathwright_app_id?: string | null
      school_app_id?: string | null
      user_hash?: string | null
    } | null
  } | null
}

export type ContextFragment = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    theme?: {
      __typename?: "Theme"
      id?: number | null
      name?: string | null
      theme_type?: ThemeType | null
      background_image?: string | null
      background_overlay?: string | null
      background_type?: number | null
      heading_font?: string | null
      primary_color?: string | null
      typekit_id?: string | null
      custom_css?: string | null
      processed_custom_css?: string | null
      color_palette?: {
        __typename?: "NodeThemeColorPalette"
        _50?: string | null
        _100?: string | null
        _200?: string | null
        _300?: string | null
        _400?: string | null
        _500?: string | null
        _600?: string | null
        _700?: string | null
        _800?: string | null
        _900?: string | null
      } | null
    } | null
    features: {
      __typename?: "SchoolFeatures"
      auth__platform: boolean
      media__downloadable_videos: boolean
      library__cover_pages: boolean
    }
  } | null
  me?: {
    __typename?: "User"
    username?: string | null
    no_password_set?: boolean | null
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    group_role_stats?: Array<{
      __typename?: "GroupRoleStats"
      type?: string | null
      total?: number | null
      role?: number | null
    } | null> | null
    permissions?: {
      __typename?: "ContextPermissions"
      is_school_owner?: boolean | null
      can_administrate?: boolean | null
      can_edit_library?: boolean | null
      has_member_access?: boolean | null
      has_pathwright_staff_access?: boolean | null
    } | null
    membership?: {
      __typename?: "Membership"
      id: number
      created: any
      last_seen?: any | null
      last_active?: any | null
      has_access: boolean
      role: number
      consent_snapshot?: string | null
      consent_dtime?: any | null
    } | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      notification_digest_interval?: NotificationDigestInterval | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  translation?: {
    __typename?: "Translation"
    id?: number | null
    name?: string | null
    language?: string | null
    translation?: any | null
    master_translation?: any | null
    is_default?: boolean | null
  } | null
  platformConfig?: {
    __typename?: "PlatformConfig"
    id?: number | null
    payments_maintenance_mode?: boolean | null
  } | null
  integrations?: {
    __typename?: "Integrations"
    firebase?: {
      __typename?: "FirebaseIntegration"
      auth_token?: string | null
      url?: string | null
      client_api_key?: string | null
    } | null
    intercom?: {
      __typename?: "IntercomIntegration"
      app_id?: string | null
      pathwright_app_id?: string | null
      school_app_id?: string | null
      user_hash?: string | null
    } | null
  } | null
}

export type MeFragment = {
  __typename?: "User"
  username?: string | null
  no_password_set?: boolean | null
  id: number
  email?: string | null
  first_name: string
  last_name: string
  full_name: string
  display_name?: string | null
  group_role_stats?: Array<{
    __typename?: "GroupRoleStats"
    type?: string | null
    total?: number | null
    role?: number | null
  } | null> | null
  permissions?: {
    __typename?: "ContextPermissions"
    is_school_owner?: boolean | null
    can_administrate?: boolean | null
    can_edit_library?: boolean | null
    has_member_access?: boolean | null
    has_pathwright_staff_access?: boolean | null
  } | null
  membership?: {
    __typename?: "Membership"
    id: number
    created: any
    last_seen?: any | null
    last_active?: any | null
    has_access: boolean
    role: number
    consent_snapshot?: string | null
    consent_dtime?: any | null
  } | null
  profile?: {
    __typename?: "Profile"
    id?: number | null
    notification_digest_interval?: NotificationDigestInterval | null
    bio?: string | null
    image?: string | null
    imageRaw?: string | null
    location?: string | null
    last_activity?: any | null
    rewardful_referral_id?: string | null
  } | null
}

export type PositioningContextQueryVariables = Exact<{
  input: PositioningContextInput
}>

export type PositioningContextQuery = {
  __typename?: "Query"
  positioningContext?: {
    __typename?: "PositioningContext"
    id: number
    context_key: any
    context_type: PositioningContextTypeInput
  } | null
}

export type UpdatePositionedObjectsMutationVariables = Exact<{
  context: PositioningContextInput
  positions:
    | Array<InputMaybe<PositionedObjectPositionInput>>
    | InputMaybe<PositionedObjectPositionInput>
}>

export type UpdatePositionedObjectsMutation = {
  __typename?: "Mutations"
  updatePositionedObjects?: any | null
}

export type __TestRegistrationPositioningQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  positioningContext?: InputMaybe<PositioningContextInput>
}>

export type __TestRegistrationPositioningQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    registrations?: {
      __typename?: "RegistrationConnection"
      edges?: Array<{
        __typename?: "RegistrationEdge"
        node?: {
          __typename?: "Registration"
          id: number
          position: string
        } | null
      } | null> | null
    } | null
  } | null
}

export type __TestRegistrationFragment = {
  __typename?: "Registration"
  id: number
  position: string
}

export type ActiveCertificateQueryVariables = Exact<{ [key: string]: never }>

export type ActiveCertificateQuery = {
  __typename?: "Query"
  certificate?: { __typename?: "Certificate"; id?: number | null } | null
}

export type CertificateDownloadUrlQueryVariables = Exact<{
  pathId?: InputMaybe<Scalars["Int"]["input"]>
}>

export type CertificateDownloadUrlQuery = {
  __typename?: "Query"
  certificate?: {
    __typename?: "Certificate"
    id?: number | null
    download_url?: string | null
  } | null
}

export type UpdateUserMembershipMutationVariables = Exact<{
  consents?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type UpdateUserMembershipMutation = {
  __typename?: "Mutations"
  updateMemberConsent?: {
    __typename?: "Membership"
    id: number
    consent_snapshot?: string | null
    consent_dtime?: any | null
  } | null
}

export type UserProfileQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type UserProfileQuery = {
  __typename?: "Query"
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    membership?: {
      __typename?: "Membership"
      id: number
      role: number
      last_active?: any | null
      last_seen?: any | null
    } | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type PublisherFragment = {
  __typename?: "Publisher"
  id?: number | null
  name?: string | null
  about?: string | null
  website?: string | null
  image?: string | null
}

export type PublishersQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  cursor?: InputMaybe<Scalars["String"]["input"]>
  school_id: Scalars["Int"]["input"]
}>

export type PublishersQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url?: string | null
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      publishers?: {
        __typename?: "PublisherConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges?: Array<{
          __typename?: "PublisherEdge"
          node?: {
            __typename?: "Publisher"
            id?: number | null
            name?: string | null
            about?: string | null
            website?: string | null
            image?: string | null
          } | null
        } | null> | null
      } | null
    }
  } | null
}

export type UpdateReferralMutationVariables = Exact<{
  referral: Scalars["String"]["input"]
}>

export type UpdateReferralMutation = {
  __typename?: "Mutations"
  updateReferral?: { __typename?: "Referral"; referral?: string | null } | null
}

export type DeleteRegistrationMutationVariables = Exact<{
  group_id: Scalars["Int"]["input"]
  registration_id: Scalars["Int"]["input"]
}>

export type DeleteRegistrationMutation = {
  __typename?: "Mutations"
  deleteRegistration?: boolean | null
}

export type RegistrationExpirationQueryVariables = Exact<{
  cohortId: Scalars["Int"]["input"]
}>

export type RegistrationExpirationQuery = {
  __typename?: "Query"
  cohort?: {
    __typename?: "Group"
    id: number
    name: string
    price?: number | null
    is_subscription_only?: boolean | null
    access_ends?: any | null
    resource?: { __typename?: "Resource"; id: number; name: string } | null
    include_in_plans?: {
      __typename?: "SchoolSubscriptionPlanConnection"
      total: number
      edges?: Array<{
        __typename?: "SchoolSubscriptionPlanEdge"
        node?: {
          __typename?: "SchoolSubscriptionPlan"
          id?: number | null
        } | null
      } | null> | null
    } | null
    include_with_products?: {
      __typename?: "StripeProductConnection"
      total: number
      edges?: Array<{
        __typename?: "StripeProductEdge"
        node?: { __typename?: "StripeProduct"; id: number } | null
      } | null> | null
    } | null
    user_registration?: {
      __typename?: "Registration"
      id: number
      expiration_dtime?: any | null
      school_sub_used?: {
        __typename?: "SchoolSubscription"
        id?: number | null
        school_subscription_plan?: {
          __typename?: "SchoolSubscriptionPlan"
          id?: number | null
        } | null
        subscription_plan?: {
          __typename?: "SubscriptionPlan"
          id?: number | null
          name?: string | null
        } | null
        subscription?: {
          __typename?: "Subscription"
          id?: number | null
          quantity?: number | null
          canceled_dtime?: any | null
          cancellation_reason?: number | null
          card_last_4?: string | null
          cycle_end_dtime?: any | null
          cycle_start_dtime?: any | null
          is_canceled_at_cycle_end?: boolean | null
          is_delinquent?: boolean | null
          paused_until_dtime?: any | null
          trial_type?: number | null
          trial_end_dtime?: any | null
          payment_intent_needing_action_id?: string | null
          subscription_plan?: {
            __typename?: "SubscriptionPlan"
            id?: number | null
            name?: string | null
            amount?: number | null
            interval?: number | null
            trial_period_days?: number | null
            trial_type?: number | null
            plan_type?: string | null
            stripe_connected_account_url?: string | null
          } | null
          customer?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
        } | null
      } | null
      group_sub_used?: {
        __typename?: "SchoolGroupSubscription"
        id?: number | null
        price?: {
          __typename?: "StripePrice"
          id: number
          product?: {
            __typename?: "StripeProduct"
            id: number
            name?: string | null
          } | null
        } | null
        community_group?: {
          __typename?: "MentorGroup"
          id?: number | null
          name?: string | null
          seat_limit?: number | null
        } | null
        subscription?: {
          __typename?: "Subscription"
          id?: number | null
          quantity?: number | null
          canceled_dtime?: any | null
          cancellation_reason?: number | null
          card_last_4?: string | null
          cycle_end_dtime?: any | null
          cycle_start_dtime?: any | null
          is_canceled_at_cycle_end?: boolean | null
          is_delinquent?: boolean | null
          paused_until_dtime?: any | null
          trial_type?: number | null
          trial_end_dtime?: any | null
          payment_intent_needing_action_id?: string | null
          subscription_plan?: {
            __typename?: "SubscriptionPlan"
            id?: number | null
            name?: string | null
            amount?: number | null
            interval?: number | null
            trial_period_days?: number | null
            trial_type?: number | null
            plan_type?: string | null
            stripe_connected_account_url?: string | null
          } | null
          customer?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
        } | null
      } | null
      group_sub_community_membership?: {
        __typename?: "MentorGroupMembership"
        id: number
        access_revoked_time?: any | null
      } | null
    } | null
  } | null
}

export type RegistrationFragment = {
  __typename?: "Registration"
  id: number
  role: number
  completion_state?: number | null
  send_due_notifications?: boolean | null
  send_discussion_notifications?: boolean | null
  last_activity_time?: any | null
  expiration_dtime?: any | null
  created?: any | null
  user: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  }
}

export type RegistrationQueryVariables = Exact<{
  group_id: Scalars["Int"]["input"]
  registration_id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type RegistrationQuery = {
  __typename?: "Query"
  group?: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
    permissions?: {
      __typename?: "GroupPermissions"
      can_invite_observer?: boolean | null
      can_invite_student?: boolean | null
      can_invite_moderator?: boolean | null
      can_invite_teacher?: boolean | null
      can_invite_editor?: boolean | null
    } | null
    registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type RegistrationsQueryVariables = Exact<{
  groupId: Scalars["Int"]["input"]
  roleFilter?: InputMaybe<RoleFilter>
  dateLastActive?: InputMaybe<DateFilter>
  dateJoined?: InputMaybe<DateFilter>
  softArchived?: InputMaybe<DateFilter>
  orderBy?: InputMaybe<
    | Array<InputMaybe<RegistrationOrderByInput>>
    | InputMaybe<RegistrationOrderByInput>
  >
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type RegistrationsQuery = {
  __typename?: "Query"
  group?: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
    registrations?: {
      __typename?: "RegistrationConnection"
      total: number
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges?: Array<{
        __typename?: "RegistrationEdge"
        node?: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
      } | null> | null
    } | null
  } | null
}

export type UserProfileRegistrationFragment = {
  __typename?: "Registration"
  id: number
  role: number
  completion_state?: number | null
  send_due_notifications?: boolean | null
  send_discussion_notifications?: boolean | null
  last_activity_time?: any | null
  expiration_dtime?: any | null
  created?: any | null
  resource: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
  }
  group: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
  }
  path?: {
    __typename?: "Path"
    id: number
    progress?: number | null
    completion_date?: any | null
  } | null
  user: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  }
}

export type UserProfileRegistrationsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>
  first?: InputMaybe<Scalars["Int"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
  role_filter?: InputMaybe<RoleFilter>
  progress_filter?: InputMaybe<ProgressFilter>
  parent_cohort_filter?: InputMaybe<IdFilter>
  hasParentRegistration?: InputMaybe<Scalars["Boolean"]["input"]>
  orderBy?: InputMaybe<
    | Array<InputMaybe<RegistrationOrderByInput>>
    | InputMaybe<RegistrationOrderByInput>
  >
}>

export type UserProfileRegistrationsQuery = {
  __typename?: "Query"
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    registrations?: {
      __typename?: "RegistrationConnection"
      total: number
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges?: Array<{
        __typename?: "RegistrationEdge"
        node?: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          resource: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
          }
          group: {
            __typename?: "Group"
            id: number
            name: string
            created?: any | null
            description?: string | null
            price?: number | null
            seats?: number | null
            seats_filled?: number | null
            seats_available?: number | null
            registration_ends?: any | null
            registration_starts?: any | null
            registration_started?: boolean | null
            registration_ended?: boolean | null
            access_ends?: any | null
            access_starts?: any | null
            is_master?: boolean | null
            is_source_cohort?: boolean | null
            source_cohort_id?: number | null
            parent_section_id?: number | null
            resource_id?: number | null
            visibility?: number | null
            is_collection_linked?: boolean | null
            is_subscription_only?: boolean | null
            status: GroupStatus
            analytics_disabled?: boolean | null
            created_by_id?: number | null
          }
          path?: {
            __typename?: "Path"
            id: number
            progress?: number | null
            completion_date?: any | null
          } | null
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
      } | null> | null
    } | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type DeferOrExecuteResourceCopyConfigMutationVariables = Exact<{
  copyCode: Scalars["String"]["input"]
  targetSchoolId: Scalars["Int"]["input"]
}>

export type DeferOrExecuteResourceCopyConfigMutation = {
  __typename?: "Mutations"
  deferOrExecuteResourceCopyConfig?: {
    __typename?: "DeferOrExecuteResourceCopyConfigResult"
    defer: any
    execute: any
  } | null
}

export type DeleteResourceCopyConfigLinkMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type DeleteResourceCopyConfigLinkMutation = {
  __typename?: "Mutations"
  deleteResourceCopyConfigLink?: string | null
}

export type ExecuteDeferredResourceCopyConfigMutationVariables = Exact<{
  linkId: Scalars["Int"]["input"]
}>

export type ExecuteDeferredResourceCopyConfigMutation = {
  __typename?: "Mutations"
  executeDeferredResourceCopyConfig?: {
    __typename?: "DeferOrExecuteResourceCopyConfigResult"
    defer: any
    execute: any
  } | null
}

export type ResourceCopyConfigQueryVariables = Exact<{
  key: Scalars["String"]["input"]
}>

export type ResourceCopyConfigQuery = {
  __typename?: "Query"
  resourceCopyConfig?: {
    __typename?: "ResourceCopyConfig"
    id: number
    name?: string | null
    lookup_key: string
    copy_behavior: ResourceCopyConfigCopyBehavior
    allow_copy_via_link: boolean
    children?: Array<{
      __typename?: "ResourceCopyConfig"
      id: number
      name?: string | null
      lookup_key: string
      copy_behavior: ResourceCopyConfigCopyBehavior
      allow_copy_via_link: boolean
      children?: Array<{
        __typename?: "ResourceCopyConfig"
        id: number
        name?: string | null
        lookup_key: string
        copy_behavior: ResourceCopyConfigCopyBehavior
        allow_copy_via_link: boolean
        children?: Array<{
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        } | null> | null
        resource?: {
          __typename?: "ResourceCopyConfigResource"
          id: number
          meta: {
            __typename?: "NodeMeta"
            id: string
            type: string
            key: string
            title?: string | null
            image?: { __typename?: "NodeImage"; src?: string | null } | null
          }
        } | null
      } | null> | null
      resource?: {
        __typename?: "ResourceCopyConfigResource"
        id: number
        meta: {
          __typename?: "NodeMeta"
          id: string
          type: string
          key: string
          title?: string | null
          image?: { __typename?: "NodeImage"; src?: string | null } | null
        }
      } | null
    } | null> | null
    resource?: {
      __typename?: "ResourceCopyConfigResource"
      id: number
      meta: {
        __typename?: "NodeMeta"
        id: string
        type: string
        key: string
        title?: string | null
        image?: { __typename?: "NodeImage"; src?: string | null } | null
      }
    } | null
  } | null
}

export type ResourceCopyConfigConnectionsQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  keys?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >
  fromSpaceId?: InputMaybe<Scalars["Int"]["input"]>
}>

export type ResourceCopyConfigConnectionsQuery = {
  __typename?: "Query"
  resourceCopyConfigConnections?: {
    __typename?: "ResourceCopyConfigConnection"
    edges?: Array<{
      __typename?: "ResourceCopyConfigEdge"
      node?: {
        __typename?: "ResourceCopyConfig"
        id: number
        name?: string | null
        lookup_key: string
        copy_behavior: ResourceCopyConfigCopyBehavior
        allow_copy_via_link: boolean
        children?: Array<{
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          children?: Array<{
            __typename?: "ResourceCopyConfig"
            id: number
            name?: string | null
            lookup_key: string
            copy_behavior: ResourceCopyConfigCopyBehavior
            allow_copy_via_link: boolean
            children?: Array<{
              __typename?: "ResourceCopyConfig"
              id: number
              name?: string | null
              lookup_key: string
              copy_behavior: ResourceCopyConfigCopyBehavior
              allow_copy_via_link: boolean
              resource?: {
                __typename?: "ResourceCopyConfigResource"
                id: number
                meta: {
                  __typename?: "NodeMeta"
                  id: string
                  type: string
                  key: string
                  title?: string | null
                  image?: {
                    __typename?: "NodeImage"
                    src?: string | null
                  } | null
                }
              } | null
            } | null> | null
            resource?: {
              __typename?: "ResourceCopyConfigResource"
              id: number
              meta: {
                __typename?: "NodeMeta"
                id: string
                type: string
                key: string
                title?: string | null
                image?: { __typename?: "NodeImage"; src?: string | null } | null
              }
            } | null
          } | null> | null
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        } | null> | null
        resource?: {
          __typename?: "ResourceCopyConfigResource"
          id: number
          meta: {
            __typename?: "NodeMeta"
            id: string
            type: string
            key: string
            title?: string | null
            image?: { __typename?: "NodeImage"; src?: string | null } | null
          }
        } | null
      } | null
    } | null> | null
  } | null
}

export type ResourceCopyConfigFragment = {
  __typename?: "ResourceCopyConfig"
  id: number
  name?: string | null
  lookup_key: string
  copy_behavior: ResourceCopyConfigCopyBehavior
  allow_copy_via_link: boolean
  children?: Array<{
    __typename?: "ResourceCopyConfig"
    id: number
    name?: string | null
    lookup_key: string
    copy_behavior: ResourceCopyConfigCopyBehavior
    allow_copy_via_link: boolean
    children?: Array<{
      __typename?: "ResourceCopyConfig"
      id: number
      name?: string | null
      lookup_key: string
      copy_behavior: ResourceCopyConfigCopyBehavior
      allow_copy_via_link: boolean
      children?: Array<{
        __typename?: "ResourceCopyConfig"
        id: number
        name?: string | null
        lookup_key: string
        copy_behavior: ResourceCopyConfigCopyBehavior
        allow_copy_via_link: boolean
        resource?: {
          __typename?: "ResourceCopyConfigResource"
          id: number
          meta: {
            __typename?: "NodeMeta"
            id: string
            type: string
            key: string
            title?: string | null
            image?: { __typename?: "NodeImage"; src?: string | null } | null
          }
        } | null
      } | null> | null
      resource?: {
        __typename?: "ResourceCopyConfigResource"
        id: number
        meta: {
          __typename?: "NodeMeta"
          id: string
          type: string
          key: string
          title?: string | null
          image?: { __typename?: "NodeImage"; src?: string | null } | null
        }
      } | null
    } | null> | null
    resource?: {
      __typename?: "ResourceCopyConfigResource"
      id: number
      meta: {
        __typename?: "NodeMeta"
        id: string
        type: string
        key: string
        title?: string | null
        image?: { __typename?: "NodeImage"; src?: string | null } | null
      }
    } | null
  } | null> | null
  resource?: {
    __typename?: "ResourceCopyConfigResource"
    id: number
    meta: {
      __typename?: "NodeMeta"
      id: string
      type: string
      key: string
      title?: string | null
      image?: { __typename?: "NodeImage"; src?: string | null } | null
    }
  } | null
}

export type ResourceCopyConfigPartialFragment = {
  __typename?: "ResourceCopyConfig"
  id: number
  name?: string | null
  lookup_key: string
  copy_behavior: ResourceCopyConfigCopyBehavior
  allow_copy_via_link: boolean
  resource?: {
    __typename?: "ResourceCopyConfigResource"
    id: number
    meta: {
      __typename?: "NodeMeta"
      id: string
      type: string
      key: string
      title?: string | null
      image?: { __typename?: "NodeImage"; src?: string | null } | null
    }
  } | null
}

export type ResourceCopyConfigLinkConnectionsQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  copiedTimeDateFilter?: InputMaybe<DateFilter>
  hideFromLocationsFilter?: InputMaybe<
    | Array<InputMaybe<ResourceCopyConfigLinkLocationFilter>>
    | InputMaybe<ResourceCopyConfigLinkLocationFilter>
  >
}>

export type ResourceCopyConfigLinkConnectionsQuery = {
  __typename?: "Query"
  resourceCopyConfigLinkConnections?: {
    __typename?: "ResourceCopyConfigLinkConnection"
    edges?: Array<{
      __typename?: "ResourceCopyConfigLinkEdge"
      node?: {
        __typename?: "ResourceCopyConfigLink"
        id: number
        createdTime: any
        copiedTime?: any | null
        resourceId?: number | null
        cohortId?: number | null
        copierRegistrationId?: number | null
        hideFromLocations?: any | null
        resourceCopyConfig: {
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          children?: Array<{
            __typename?: "ResourceCopyConfig"
            id: number
            name?: string | null
            lookup_key: string
            copy_behavior: ResourceCopyConfigCopyBehavior
            allow_copy_via_link: boolean
            children?: Array<{
              __typename?: "ResourceCopyConfig"
              id: number
              name?: string | null
              lookup_key: string
              copy_behavior: ResourceCopyConfigCopyBehavior
              allow_copy_via_link: boolean
              children?: Array<{
                __typename?: "ResourceCopyConfig"
                id: number
                name?: string | null
                lookup_key: string
                copy_behavior: ResourceCopyConfigCopyBehavior
                allow_copy_via_link: boolean
                resource?: {
                  __typename?: "ResourceCopyConfigResource"
                  id: number
                  meta: {
                    __typename?: "NodeMeta"
                    id: string
                    type: string
                    key: string
                    title?: string | null
                    image?: {
                      __typename?: "NodeImage"
                      src?: string | null
                    } | null
                  }
                } | null
              } | null> | null
              resource?: {
                __typename?: "ResourceCopyConfigResource"
                id: number
                meta: {
                  __typename?: "NodeMeta"
                  id: string
                  type: string
                  key: string
                  title?: string | null
                  image?: {
                    __typename?: "NodeImage"
                    src?: string | null
                  } | null
                }
              } | null
            } | null> | null
            resource?: {
              __typename?: "ResourceCopyConfigResource"
              id: number
              meta: {
                __typename?: "NodeMeta"
                id: string
                type: string
                key: string
                title?: string | null
                image?: { __typename?: "NodeImage"; src?: string | null } | null
              }
            } | null
          } | null> | null
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        }
      } | null
    } | null> | null
  } | null
}

export type ResourceCopyConfigLinkFragment = {
  __typename?: "ResourceCopyConfigLink"
  id: number
  createdTime: any
  copiedTime?: any | null
  resourceId?: number | null
  cohortId?: number | null
  copierRegistrationId?: number | null
  hideFromLocations?: any | null
  resourceCopyConfig: {
    __typename?: "ResourceCopyConfig"
    id: number
    name?: string | null
    lookup_key: string
    copy_behavior: ResourceCopyConfigCopyBehavior
    allow_copy_via_link: boolean
    children?: Array<{
      __typename?: "ResourceCopyConfig"
      id: number
      name?: string | null
      lookup_key: string
      copy_behavior: ResourceCopyConfigCopyBehavior
      allow_copy_via_link: boolean
      children?: Array<{
        __typename?: "ResourceCopyConfig"
        id: number
        name?: string | null
        lookup_key: string
        copy_behavior: ResourceCopyConfigCopyBehavior
        allow_copy_via_link: boolean
        children?: Array<{
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        } | null> | null
        resource?: {
          __typename?: "ResourceCopyConfigResource"
          id: number
          meta: {
            __typename?: "NodeMeta"
            id: string
            type: string
            key: string
            title?: string | null
            image?: { __typename?: "NodeImage"; src?: string | null } | null
          }
        } | null
      } | null> | null
      resource?: {
        __typename?: "ResourceCopyConfigResource"
        id: number
        meta: {
          __typename?: "NodeMeta"
          id: string
          type: string
          key: string
          title?: string | null
          image?: { __typename?: "NodeImage"; src?: string | null } | null
        }
      } | null
    } | null> | null
    resource?: {
      __typename?: "ResourceCopyConfigResource"
      id: number
      meta: {
        __typename?: "NodeMeta"
        id: string
        type: string
        key: string
        title?: string | null
        image?: { __typename?: "NodeImage"; src?: string | null } | null
      }
    } | null
  }
}

export type ResourceCopyConfigLinkQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type ResourceCopyConfigLinkQuery = {
  __typename?: "Query"
  resourceCopyConfigLink?: {
    __typename?: "ResourceCopyConfigLink"
    id: number
    createdTime: any
    copiedTime?: any | null
    resourceId?: number | null
    cohortId?: number | null
    copierRegistrationId?: number | null
    hideFromLocations?: any | null
    resourceCopyConfig: {
      __typename?: "ResourceCopyConfig"
      id: number
      name?: string | null
      lookup_key: string
      copy_behavior: ResourceCopyConfigCopyBehavior
      allow_copy_via_link: boolean
      children?: Array<{
        __typename?: "ResourceCopyConfig"
        id: number
        name?: string | null
        lookup_key: string
        copy_behavior: ResourceCopyConfigCopyBehavior
        allow_copy_via_link: boolean
        children?: Array<{
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          children?: Array<{
            __typename?: "ResourceCopyConfig"
            id: number
            name?: string | null
            lookup_key: string
            copy_behavior: ResourceCopyConfigCopyBehavior
            allow_copy_via_link: boolean
            resource?: {
              __typename?: "ResourceCopyConfigResource"
              id: number
              meta: {
                __typename?: "NodeMeta"
                id: string
                type: string
                key: string
                title?: string | null
                image?: { __typename?: "NodeImage"; src?: string | null } | null
              }
            } | null
          } | null> | null
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        } | null> | null
        resource?: {
          __typename?: "ResourceCopyConfigResource"
          id: number
          meta: {
            __typename?: "NodeMeta"
            id: string
            type: string
            key: string
            title?: string | null
            image?: { __typename?: "NodeImage"; src?: string | null } | null
          }
        } | null
      } | null> | null
      resource?: {
        __typename?: "ResourceCopyConfigResource"
        id: number
        meta: {
          __typename?: "NodeMeta"
          id: string
          type: string
          key: string
          title?: string | null
          image?: { __typename?: "NodeImage"; src?: string | null } | null
        }
      } | null
    }
  } | null
}

export type ResourceFragment = {
  __typename?: "Resource"
  id: number
  name: string
  slug: string
  created?: any | null
  resource_type: number
  visibility?: number | null
  description?: string | null
  short_description?: string | null
  background_overlay?: string | null
  background_image?: string | null
  background_type: ResourceBackgroundType
  image_raw?: string | null
  has_certificate?: boolean | null
  discussion_enabled?: boolean | null
  lowest_public_offering_price?: number | null
  highest_public_offering_price?: number | null
  licensed_from_resource_id?: number | null
  licensed_from_school_id?: number | null
  created_by_id?: number | null
  copied_with_copy_config_id?: number | null
  image: string
  cover_image: string
}

export type ResourcePublisherQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type ResourcePublisherQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    publisher?: {
      __typename?: "Publisher"
      id?: number | null
      name?: string | null
      about?: string | null
      website?: string | null
      image?: string | null
    } | null
  } | null
}

export type ResourceQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type ResourceQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
  } | null
}

export type ShowHideResourceCopyConfigLinkMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  show?: InputMaybe<
    | Array<InputMaybe<ResourceCopyConfigLinkLocation>>
    | InputMaybe<ResourceCopyConfigLinkLocation>
  >
  hide?: InputMaybe<
    | Array<InputMaybe<ResourceCopyConfigLinkLocation>>
    | InputMaybe<ResourceCopyConfigLinkLocation>
  >
}>

export type ShowHideResourceCopyConfigLinkMutation = {
  __typename?: "Mutations"
  showHideResourceCopyConfigLink?: {
    __typename?: "ResourceCopyConfigLink"
    id: number
    createdTime: any
    copiedTime?: any | null
    resourceId?: number | null
    cohortId?: number | null
    copierRegistrationId?: number | null
    hideFromLocations?: any | null
    resourceCopyConfig: {
      __typename?: "ResourceCopyConfig"
      id: number
      name?: string | null
      lookup_key: string
      copy_behavior: ResourceCopyConfigCopyBehavior
      allow_copy_via_link: boolean
      children?: Array<{
        __typename?: "ResourceCopyConfig"
        id: number
        name?: string | null
        lookup_key: string
        copy_behavior: ResourceCopyConfigCopyBehavior
        allow_copy_via_link: boolean
        children?: Array<{
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          children?: Array<{
            __typename?: "ResourceCopyConfig"
            id: number
            name?: string | null
            lookup_key: string
            copy_behavior: ResourceCopyConfigCopyBehavior
            allow_copy_via_link: boolean
            resource?: {
              __typename?: "ResourceCopyConfigResource"
              id: number
              meta: {
                __typename?: "NodeMeta"
                id: string
                type: string
                key: string
                title?: string | null
                image?: { __typename?: "NodeImage"; src?: string | null } | null
              }
            } | null
          } | null> | null
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        } | null> | null
        resource?: {
          __typename?: "ResourceCopyConfigResource"
          id: number
          meta: {
            __typename?: "NodeMeta"
            id: string
            type: string
            key: string
            title?: string | null
            image?: { __typename?: "NodeImage"; src?: string | null } | null
          }
        } | null
      } | null> | null
      resource?: {
        __typename?: "ResourceCopyConfigResource"
        id: number
        meta: {
          __typename?: "NodeMeta"
          id: string
          type: string
          key: string
          title?: string | null
          image?: { __typename?: "NodeImage"; src?: string | null } | null
        }
      } | null
    }
  } | null
}

export type LicenseOfferingFragment = {
  __typename?: "LicenseOffering"
  id?: number | null
  description?: string | null
  cost_per_seat?: number | null
  include_creator_seat?: boolean | null
  register_creator_as?: RegistrationRoleEnum | null
  minimum_seat_count?: number | null
  minimum_license_duration?: number | null
  licensing_mode?: LicenseOfferingLicensingMode | null
  included_in_user_subscription?: boolean | null
  include_in_curriculum_plans?: {
    __typename?: "SchoolCurriculumPlanConnection"
    total: number
    edges?: Array<{
      __typename?: "SchoolCurriculumPlanEdge"
      node?: {
        __typename?: "SchoolCurriculumPlan"
        id: number
        plan_id?: number | null
      } | null
    } | null> | null
  } | null
  include_in_subscription_plans?: {
    __typename?: "SchoolSubscriptionPlanConnection"
    total: number
    edges?: Array<{
      __typename?: "SchoolSubscriptionPlanEdge"
      node?: {
        __typename?: "SchoolSubscriptionPlan"
        id?: number | null
      } | null
    } | null> | null
  } | null
  licensor?: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
  } | null
}

export type LicenseOfferingQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
  school_id: Scalars["Int"]["input"]
}>

export type LicenseOfferingQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url?: string | null
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      license_offering?: {
        __typename?: "LicenseOffering"
        id?: number | null
        description?: string | null
        cost_per_seat?: number | null
        include_creator_seat?: boolean | null
        register_creator_as?: RegistrationRoleEnum | null
        minimum_seat_count?: number | null
        minimum_license_duration?: number | null
        licensing_mode?: LicenseOfferingLicensingMode | null
        included_in_user_subscription?: boolean | null
        resource?: {
          __typename?: "Resource"
          id: number
          name: string
          slug: string
          created?: any | null
          resource_type: number
          visibility?: number | null
          description?: string | null
          short_description?: string | null
          background_overlay?: string | null
          background_image?: string | null
          background_type: ResourceBackgroundType
          image_raw?: string | null
          has_certificate?: boolean | null
          discussion_enabled?: boolean | null
          lowest_public_offering_price?: number | null
          highest_public_offering_price?: number | null
          licensed_from_resource_id?: number | null
          licensed_from_school_id?: number | null
          created_by_id?: number | null
          copied_with_copy_config_id?: number | null
          image: string
          cover_image: string
        } | null
        include_in_curriculum_plans?: {
          __typename?: "SchoolCurriculumPlanConnection"
          total: number
          edges?: Array<{
            __typename?: "SchoolCurriculumPlanEdge"
            node?: {
              __typename?: "SchoolCurriculumPlan"
              id: number
              plan_id?: number | null
            } | null
          } | null> | null
        } | null
        include_in_subscription_plans?: {
          __typename?: "SchoolSubscriptionPlanConnection"
          total: number
          edges?: Array<{
            __typename?: "SchoolSubscriptionPlanEdge"
            node?: {
              __typename?: "SchoolSubscriptionPlan"
              id?: number | null
            } | null
          } | null> | null
        } | null
        licensor?: {
          __typename?: "School"
          id: number
          url?: string | null
          name: string
          about?: string | null
          email?: string | null
          website?: string | null
          subdomain: string
          created?: any | null
          billing_model?: number | null
          platform_version?: number | null
          currency_code?: string | null
          ietf_language_tag?: string | null
          has_certificate?: boolean | null
          is_activated?: boolean | null
          is_curriculum_enabled?: boolean | null
          is_curriculum_subscriber?: boolean | null
          stripe_access_token?: string | null
          stripe_publishable_api_key?: string | null
          show_stripe_reconnect?: boolean | null
          payment_requires_zip_code?: boolean | null
          consent_description?: string | null
          image?: string | null
          grant_access_upon_authentication?: boolean | null
          pathwright_login_enabled?: boolean | null
        } | null
      } | null
    }
  } | null
}

export type LicenseResourceMutationVariables = Exact<{
  resource_id: Scalars["Int"]["input"]
  license_offering_id: Scalars["Int"]["input"]
  licensee_school_id?: InputMaybe<Scalars["Int"]["input"]>
  use_group_subscription_id?: InputMaybe<Scalars["Int"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  seat_count?: InputMaybe<Scalars["Int"]["input"]>
  role?: InputMaybe<LicenseRoleEnum>
  payment_token?: InputMaybe<Scalars["String"]["input"]>
  coupon_code?: InputMaybe<Scalars["String"]["input"]>
}>

export type LicenseResourceMutation = {
  __typename?: "Mutations"
  licenseResource?: {
    __typename?: "ResourceLicense"
    id?: number | null
    seat_count?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    expiration_dtime?: any | null
    school?: {
      __typename?: "LicenseeSchool"
      id?: number | null
      name?: string | null
    } | null
    license_offering?: {
      __typename?: "LicenseOffering"
      id?: number | null
      description?: string | null
      cost_per_seat?: number | null
      include_creator_seat?: boolean | null
      register_creator_as?: RegistrationRoleEnum | null
      minimum_seat_count?: number | null
      minimum_license_duration?: number | null
      licensing_mode?: LicenseOfferingLicensingMode | null
      included_in_user_subscription?: boolean | null
      include_in_curriculum_plans?: {
        __typename?: "SchoolCurriculumPlanConnection"
        total: number
        edges?: Array<{
          __typename?: "SchoolCurriculumPlanEdge"
          node?: {
            __typename?: "SchoolCurriculumPlan"
            id: number
            plan_id?: number | null
          } | null
        } | null> | null
      } | null
      include_in_subscription_plans?: {
        __typename?: "SchoolSubscriptionPlanConnection"
        total: number
        edges?: Array<{
          __typename?: "SchoolSubscriptionPlanEdge"
          node?: {
            __typename?: "SchoolSubscriptionPlan"
            id?: number | null
          } | null
        } | null> | null
      } | null
      licensor?: {
        __typename?: "School"
        id: number
        url?: string | null
        name: string
        about?: string | null
        email?: string | null
        website?: string | null
        subdomain: string
        created?: any | null
        billing_model?: number | null
        platform_version?: number | null
        currency_code?: string | null
        ietf_language_tag?: string | null
        has_certificate?: boolean | null
        is_activated?: boolean | null
        is_curriculum_enabled?: boolean | null
        is_curriculum_subscriber?: boolean | null
        stripe_access_token?: string | null
        stripe_publishable_api_key?: string | null
        show_stripe_reconnect?: boolean | null
        payment_requires_zip_code?: boolean | null
        consent_description?: string | null
        image?: string | null
        grant_access_upon_authentication?: boolean | null
        pathwright_login_enabled?: boolean | null
      } | null
    } | null
    group?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
      resource?: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        created?: any | null
        resource_type: number
        visibility?: number | null
        description?: string | null
        short_description?: string | null
        background_overlay?: string | null
        background_image?: string | null
        background_type: ResourceBackgroundType
        image_raw?: string | null
        has_certificate?: boolean | null
        discussion_enabled?: boolean | null
        lowest_public_offering_price?: number | null
        highest_public_offering_price?: number | null
        licensed_from_resource_id?: number | null
        licensed_from_school_id?: number | null
        created_by_id?: number | null
        copied_with_copy_config_id?: number | null
        image: string
        cover_image: string
      } | null
    } | null
  } | null
}

export type ResourceLicenseFragment = {
  __typename?: "ResourceLicense"
  id?: number | null
  seat_count?: number | null
  seats_filled?: number | null
  seats_available?: number | null
  expiration_dtime?: any | null
  school?: {
    __typename?: "LicenseeSchool"
    id?: number | null
    name?: string | null
  } | null
  license_offering?: {
    __typename?: "LicenseOffering"
    id?: number | null
    description?: string | null
    cost_per_seat?: number | null
    include_creator_seat?: boolean | null
    register_creator_as?: RegistrationRoleEnum | null
    minimum_seat_count?: number | null
    minimum_license_duration?: number | null
    licensing_mode?: LicenseOfferingLicensingMode | null
    included_in_user_subscription?: boolean | null
    include_in_curriculum_plans?: {
      __typename?: "SchoolCurriculumPlanConnection"
      total: number
      edges?: Array<{
        __typename?: "SchoolCurriculumPlanEdge"
        node?: {
          __typename?: "SchoolCurriculumPlan"
          id: number
          plan_id?: number | null
        } | null
      } | null> | null
    } | null
    include_in_subscription_plans?: {
      __typename?: "SchoolSubscriptionPlanConnection"
      total: number
      edges?: Array<{
        __typename?: "SchoolSubscriptionPlanEdge"
        node?: {
          __typename?: "SchoolSubscriptionPlan"
          id?: number | null
        } | null
      } | null> | null
    } | null
    licensor?: {
      __typename?: "School"
      id: number
      url?: string | null
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
    } | null
  } | null
  group?: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
    resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
    } | null
  } | null
}

export type ResourceLicenseQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type ResourceLicenseQuery = {
  __typename?: "Query"
  resource_license?: {
    __typename?: "ResourceLicense"
    id?: number | null
    seat_count?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    expiration_dtime?: any | null
    school?: {
      __typename?: "LicenseeSchool"
      id?: number | null
      name?: string | null
    } | null
    license_offering?: {
      __typename?: "LicenseOffering"
      id?: number | null
      description?: string | null
      cost_per_seat?: number | null
      include_creator_seat?: boolean | null
      register_creator_as?: RegistrationRoleEnum | null
      minimum_seat_count?: number | null
      minimum_license_duration?: number | null
      licensing_mode?: LicenseOfferingLicensingMode | null
      included_in_user_subscription?: boolean | null
      include_in_curriculum_plans?: {
        __typename?: "SchoolCurriculumPlanConnection"
        total: number
        edges?: Array<{
          __typename?: "SchoolCurriculumPlanEdge"
          node?: {
            __typename?: "SchoolCurriculumPlan"
            id: number
            plan_id?: number | null
          } | null
        } | null> | null
      } | null
      include_in_subscription_plans?: {
        __typename?: "SchoolSubscriptionPlanConnection"
        total: number
        edges?: Array<{
          __typename?: "SchoolSubscriptionPlanEdge"
          node?: {
            __typename?: "SchoolSubscriptionPlan"
            id?: number | null
          } | null
        } | null> | null
      } | null
      licensor?: {
        __typename?: "School"
        id: number
        url?: string | null
        name: string
        about?: string | null
        email?: string | null
        website?: string | null
        subdomain: string
        created?: any | null
        billing_model?: number | null
        platform_version?: number | null
        currency_code?: string | null
        ietf_language_tag?: string | null
        has_certificate?: boolean | null
        is_activated?: boolean | null
        is_curriculum_enabled?: boolean | null
        is_curriculum_subscriber?: boolean | null
        stripe_access_token?: string | null
        stripe_publishable_api_key?: string | null
        show_stripe_reconnect?: boolean | null
        payment_requires_zip_code?: boolean | null
        consent_description?: string | null
        image?: string | null
        grant_access_upon_authentication?: boolean | null
        pathwright_login_enabled?: boolean | null
      } | null
    } | null
    group?: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
      resource?: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        created?: any | null
        resource_type: number
        visibility?: number | null
        description?: string | null
        short_description?: string | null
        background_overlay?: string | null
        background_image?: string | null
        background_type: ResourceBackgroundType
        image_raw?: string | null
        has_certificate?: boolean | null
        discussion_enabled?: boolean | null
        lowest_public_offering_price?: number | null
        highest_public_offering_price?: number | null
        licensed_from_resource_id?: number | null
        licensed_from_school_id?: number | null
        created_by_id?: number | null
        copied_with_copy_config_id?: number | null
        image: string
        cover_image: string
      } | null
    } | null
  } | null
}

export type ScopedResourceLicenseQueryVariables = Exact<{
  schoolId: Scalars["Int"]["input"]
  resourceLicenseId: Scalars["Int"]["input"]
}>

export type ScopedResourceLicenseQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      resource_license?: {
        __typename?: "ResourceLicense"
        id?: number | null
        seat_count?: number | null
        seats_filled?: number | null
        seats_available?: number | null
        expiration_dtime?: any | null
        school?: {
          __typename?: "LicenseeSchool"
          id?: number | null
          name?: string | null
        } | null
        license_offering?: {
          __typename?: "LicenseOffering"
          id?: number | null
          description?: string | null
          cost_per_seat?: number | null
          include_creator_seat?: boolean | null
          register_creator_as?: RegistrationRoleEnum | null
          minimum_seat_count?: number | null
          minimum_license_duration?: number | null
          licensing_mode?: LicenseOfferingLicensingMode | null
          included_in_user_subscription?: boolean | null
          include_in_curriculum_plans?: {
            __typename?: "SchoolCurriculumPlanConnection"
            total: number
            edges?: Array<{
              __typename?: "SchoolCurriculumPlanEdge"
              node?: {
                __typename?: "SchoolCurriculumPlan"
                id: number
                plan_id?: number | null
              } | null
            } | null> | null
          } | null
          include_in_subscription_plans?: {
            __typename?: "SchoolSubscriptionPlanConnection"
            total: number
            edges?: Array<{
              __typename?: "SchoolSubscriptionPlanEdge"
              node?: {
                __typename?: "SchoolSubscriptionPlan"
                id?: number | null
              } | null
            } | null> | null
          } | null
          licensor?: {
            __typename?: "School"
            id: number
            url?: string | null
            name: string
            about?: string | null
            email?: string | null
            website?: string | null
            subdomain: string
            created?: any | null
            billing_model?: number | null
            platform_version?: number | null
            currency_code?: string | null
            ietf_language_tag?: string | null
            has_certificate?: boolean | null
            is_activated?: boolean | null
            is_curriculum_enabled?: boolean | null
            is_curriculum_subscriber?: boolean | null
            stripe_access_token?: string | null
            stripe_publishable_api_key?: string | null
            show_stripe_reconnect?: boolean | null
            payment_requires_zip_code?: boolean | null
            consent_description?: string | null
            image?: string | null
            grant_access_upon_authentication?: boolean | null
            pathwright_login_enabled?: boolean | null
          } | null
        } | null
        group?: {
          __typename?: "Group"
          id: number
          name: string
          created?: any | null
          description?: string | null
          price?: number | null
          seats?: number | null
          seats_filled?: number | null
          seats_available?: number | null
          registration_ends?: any | null
          registration_starts?: any | null
          registration_started?: boolean | null
          registration_ended?: boolean | null
          access_ends?: any | null
          access_starts?: any | null
          is_master?: boolean | null
          is_source_cohort?: boolean | null
          source_cohort_id?: number | null
          parent_section_id?: number | null
          resource_id?: number | null
          visibility?: number | null
          is_collection_linked?: boolean | null
          is_subscription_only?: boolean | null
          status: GroupStatus
          analytics_disabled?: boolean | null
          created_by_id?: number | null
          resource?: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
          } | null
        } | null
      } | null
    }
  } | null
}

export type CopyResourceMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  to_school?: InputMaybe<Scalars["Int"]["input"]>
  create_offering?: InputMaybe<Scalars["Boolean"]["input"]>
  create_registration_with_role?: InputMaybe<RegistrationRoleEnum>
}>

export type CopyResourceMutation = {
  __typename?: "Mutations"
  copyResource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
  } | null
}

export type ManageResourceFragment = {
  __typename?: "Resource"
  trailer_embed_code?: string | null
  visibility_level_override?: number | null
  certificate_generator_class?: string | null
  certificate_json?: any | null
  licensed_from_resource_id?: number | null
  id: number
  name: string
  slug: string
  created?: any | null
  resource_type: number
  visibility?: number | null
  description?: string | null
  short_description?: string | null
  background_overlay?: string | null
  background_image?: string | null
  background_type: ResourceBackgroundType
  image_raw?: string | null
  has_certificate?: boolean | null
  discussion_enabled?: boolean | null
  lowest_public_offering_price?: number | null
  highest_public_offering_price?: number | null
  licensed_from_school_id?: number | null
  created_by_id?: number | null
  copied_with_copy_config_id?: number | null
  image: string
  cover_image: string
  registration_meta?: {
    __typename?: "RegistrationMeta"
    editor_registration_count?: number | null
  } | null
  authors?: {
    __typename?: "AuthorConnection"
    total: number
    edges?: Array<{
      __typename?: "AuthorEdge"
      node?: {
        __typename?: "Author"
        id?: number | null
        bio?: string | null
        image?: string | null
        order?: number | null
        full_name?: string | null
      } | null
    } | null> | null
  } | null
  categories?: {
    __typename?: "CategoryConnection"
    total: number
    edges?: Array<{
      __typename?: "CategoryEdge"
      node?: {
        __typename?: "Category"
        id?: number | null
        name?: string | null
        slug?: string | null
        order?: number | null
        description?: string | null
      } | null
    } | null> | null
  } | null
  groups?: {
    __typename?: "GroupConnection"
    total: number
    edges?: Array<{
      __typename?: "GroupEdge"
      node?: {
        __typename?: "Group"
        id: number
        seats_filled?: number | null
      } | null
    } | null> | null
  } | null
}

export type ManageResourceQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type ManageResourceQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    trailer_embed_code?: string | null
    visibility_level_override?: number | null
    certificate_generator_class?: string | null
    certificate_json?: any | null
    licensed_from_resource_id?: number | null
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    registration_meta?: {
      __typename?: "RegistrationMeta"
      editor_registration_count?: number | null
    } | null
    authors?: {
      __typename?: "AuthorConnection"
      total: number
      edges?: Array<{
        __typename?: "AuthorEdge"
        node?: {
          __typename?: "Author"
          id?: number | null
          bio?: string | null
          image?: string | null
          order?: number | null
          full_name?: string | null
        } | null
      } | null> | null
    } | null
    categories?: {
      __typename?: "CategoryConnection"
      total: number
      edges?: Array<{
        __typename?: "CategoryEdge"
        node?: {
          __typename?: "Category"
          id?: number | null
          name?: string | null
          slug?: string | null
          order?: number | null
          description?: string | null
        } | null
      } | null> | null
    } | null
    groups?: {
      __typename?: "GroupConnection"
      total: number
      edges?: Array<{
        __typename?: "GroupEdge"
        node?: {
          __typename?: "Group"
          id: number
          seats_filled?: number | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type ResourceEditorsQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
}>

export type ResourceEditorsQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    registration_meta?: {
      __typename?: "RegistrationMeta"
      editor_registration_count?: number | null
    } | null
    group?: {
      __typename?: "Group"
      id: number
      registrations?: {
        __typename?: "RegistrationConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges?: Array<{
          __typename?: "RegistrationEdge"
          node?: {
            __typename?: "Registration"
            id: number
            role: number
            softArchivedTime?: any | null
            user: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            }
          } | null
        } | null> | null
      } | null
    } | null
  } | null
}

export type UpdateResourceAdvancedMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  resource_type: ResourceType
  trailer_embed_code?: InputMaybe<Scalars["String"]["input"]>
  visibility_level_override?: InputMaybe<Scalars["Int"]["input"]>
  certificate_generator_class?: InputMaybe<Scalars["String"]["input"]>
  discussion_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type UpdateResourceAdvancedMutation = {
  __typename?: "Mutations"
  updateResource?: {
    __typename?: "Resource"
    trailer_embed_code?: string | null
    visibility_level_override?: number | null
    certificate_generator_class?: string | null
    certificate_json?: any | null
    licensed_from_resource_id?: number | null
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    registration_meta?: {
      __typename?: "RegistrationMeta"
      editor_registration_count?: number | null
    } | null
    authors?: {
      __typename?: "AuthorConnection"
      total: number
      edges?: Array<{
        __typename?: "AuthorEdge"
        node?: {
          __typename?: "Author"
          id?: number | null
          bio?: string | null
          image?: string | null
          order?: number | null
          full_name?: string | null
        } | null
      } | null> | null
    } | null
    categories?: {
      __typename?: "CategoryConnection"
      total: number
      edges?: Array<{
        __typename?: "CategoryEdge"
        node?: {
          __typename?: "Category"
          id?: number | null
          name?: string | null
          slug?: string | null
          order?: number | null
          description?: string | null
        } | null
      } | null> | null
    } | null
    groups?: {
      __typename?: "GroupConnection"
      total: number
      edges?: Array<{
        __typename?: "GroupEdge"
        node?: {
          __typename?: "Group"
          id: number
          seats_filled?: number | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type UpdateResourceDetailsMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  resource_type: ResourceType
  description?: InputMaybe<Scalars["String"]["input"]>
  short_description?: InputMaybe<Scalars["String"]["input"]>
  trailer_embed_code?: InputMaybe<Scalars["String"]["input"]>
  authors?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  categories?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  visibility_level_override?: InputMaybe<Scalars["Int"]["input"]>
  cover_image?: InputMaybe<Scalars["String"]["input"]>
}>

export type UpdateResourceDetailsMutation = {
  __typename?: "Mutations"
  updateResource?: {
    __typename?: "Resource"
    trailer_embed_code?: string | null
    visibility_level_override?: number | null
    certificate_generator_class?: string | null
    certificate_json?: any | null
    licensed_from_resource_id?: number | null
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    registration_meta?: {
      __typename?: "RegistrationMeta"
      editor_registration_count?: number | null
    } | null
    authors?: {
      __typename?: "AuthorConnection"
      total: number
      edges?: Array<{
        __typename?: "AuthorEdge"
        node?: {
          __typename?: "Author"
          id?: number | null
          bio?: string | null
          image?: string | null
          order?: number | null
          full_name?: string | null
        } | null
      } | null> | null
    } | null
    categories?: {
      __typename?: "CategoryConnection"
      total: number
      edges?: Array<{
        __typename?: "CategoryEdge"
        node?: {
          __typename?: "Category"
          id?: number | null
          name?: string | null
          slug?: string | null
          order?: number | null
          description?: string | null
        } | null
      } | null> | null
    } | null
    groups?: {
      __typename?: "GroupConnection"
      total: number
      edges?: Array<{
        __typename?: "GroupEdge"
        node?: {
          __typename?: "Group"
          id: number
          seats_filled?: number | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type UpdateResourceMenuMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  resource_type: ResourceType
  cover_image?: InputMaybe<Scalars["String"]["input"]>
}>

export type UpdateResourceMenuMutation = {
  __typename?: "Mutations"
  updateResource?: {
    __typename?: "Resource"
    trailer_embed_code?: string | null
    visibility_level_override?: number | null
    certificate_generator_class?: string | null
    certificate_json?: any | null
    licensed_from_resource_id?: number | null
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    registration_meta?: {
      __typename?: "RegistrationMeta"
      editor_registration_count?: number | null
    } | null
    authors?: {
      __typename?: "AuthorConnection"
      total: number
      edges?: Array<{
        __typename?: "AuthorEdge"
        node?: {
          __typename?: "Author"
          id?: number | null
          bio?: string | null
          image?: string | null
          order?: number | null
          full_name?: string | null
        } | null
      } | null> | null
    } | null
    categories?: {
      __typename?: "CategoryConnection"
      total: number
      edges?: Array<{
        __typename?: "CategoryEdge"
        node?: {
          __typename?: "Category"
          id?: number | null
          name?: string | null
          slug?: string | null
          order?: number | null
          description?: string | null
        } | null
      } | null> | null
    } | null
    groups?: {
      __typename?: "GroupConnection"
      total: number
      edges?: Array<{
        __typename?: "GroupEdge"
        node?: {
          __typename?: "Group"
          id: number
          seats_filled?: number | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type UpdateResourceMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  resource_type: ResourceType
  cover_image?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  short_description?: InputMaybe<Scalars["String"]["input"]>
  authors?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  categories?: InputMaybe<
    | Array<InputMaybe<Scalars["Int"]["input"]>>
    | InputMaybe<Scalars["Int"]["input"]>
  >
  trailer_embed_code?: InputMaybe<Scalars["String"]["input"]>
  visibility_level_override?: InputMaybe<Scalars["Int"]["input"]>
  certificate_generator_class?: InputMaybe<Scalars["String"]["input"]>
  discussion_enabled?: InputMaybe<Scalars["Boolean"]["input"]>
  certificateJSON?: InputMaybe<Scalars["JSON"]["input"]>
}>

export type UpdateResourceMutation = {
  __typename?: "Mutations"
  updateResource?: {
    __typename?: "Resource"
    trailer_embed_code?: string | null
    visibility_level_override?: number | null
    certificate_generator_class?: string | null
    certificate_json?: any | null
    licensed_from_resource_id?: number | null
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    registration_meta?: {
      __typename?: "RegistrationMeta"
      editor_registration_count?: number | null
    } | null
    authors?: {
      __typename?: "AuthorConnection"
      total: number
      edges?: Array<{
        __typename?: "AuthorEdge"
        node?: {
          __typename?: "Author"
          id?: number | null
          bio?: string | null
          image?: string | null
          order?: number | null
          full_name?: string | null
        } | null
      } | null> | null
    } | null
    categories?: {
      __typename?: "CategoryConnection"
      total: number
      edges?: Array<{
        __typename?: "CategoryEdge"
        node?: {
          __typename?: "Category"
          id?: number | null
          name?: string | null
          slug?: string | null
          order?: number | null
          description?: string | null
        } | null
      } | null> | null
    } | null
    groups?: {
      __typename?: "GroupConnection"
      total: number
      edges?: Array<{
        __typename?: "GroupEdge"
        node?: {
          __typename?: "Group"
          id: number
          seats_filled?: number | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type CurriculumSubscriptionFragment = {
  __typename?: "CurriculumSubscription"
  id: number
  licensor: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
  }
  licensee: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
  }
  curriculum_plan?: {
    __typename?: "SchoolCurriculumPlan"
    id: number
    name?: string | null
    amount?: number | null
    fee_boundary?: number | null
    fee_per_user?: number | null
    is_visible?: boolean | null
    lower_boundary?: number | null
    plan_id?: number | null
    transaction_fee_percent?: number | null
    upper_boundary?: number | null
    visibility_code?: string | null
  } | null
  subscription?: {
    __typename?: "Subscription"
    id?: number | null
    quantity?: number | null
    canceled_dtime?: any | null
    cancellation_reason?: number | null
    card_last_4?: string | null
    cycle_end_dtime?: any | null
    cycle_start_dtime?: any | null
    is_canceled_at_cycle_end?: boolean | null
    is_delinquent?: boolean | null
    paused_until_dtime?: any | null
    trial_type?: number | null
    trial_end_dtime?: any | null
    payment_intent_needing_action_id?: string | null
    subscription_plan?: {
      __typename?: "SubscriptionPlan"
      id?: number | null
      name?: string | null
      amount?: number | null
      interval?: number | null
      trial_period_days?: number | null
      trial_type?: number | null
      plan_type?: string | null
      stripe_connected_account_url?: string | null
    } | null
    customer?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
  } | null
}

export type CurriculumSubscriptionPlansQueryVariables = Exact<{
  visibilityCode?: InputMaybe<Scalars["String"]["input"]>
  visibilityCodeFilter?: InputMaybe<StringFilter>
}>

export type CurriculumSubscriptionPlansQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    curriculum_plans?: {
      __typename?: "SchoolCurriculumPlanConnection"
      edges?: Array<{
        __typename?: "SchoolCurriculumPlanEdge"
        node?: {
          __typename?: "SchoolCurriculumPlan"
          id: number
          name?: string | null
          amount?: number | null
          fee_boundary?: number | null
          fee_per_user?: number | null
          is_visible?: boolean | null
          lower_boundary?: number | null
          plan_id?: number | null
          transaction_fee_percent?: number | null
          upper_boundary?: number | null
          visibility_code?: string | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type CurriculumSubscriptionQueryVariables = Exact<{
  schoolId: Scalars["Int"]["input"]
  curriculumSubscriptionId: Scalars["Int"]["input"]
}>

export type CurriculumSubscriptionQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      curriculum_subscription?: {
        __typename?: "CurriculumSubscription"
        id: number
        licensor: {
          __typename?: "School"
          id: number
          url?: string | null
          name: string
          about?: string | null
          email?: string | null
          website?: string | null
          subdomain: string
          created?: any | null
          billing_model?: number | null
          platform_version?: number | null
          currency_code?: string | null
          ietf_language_tag?: string | null
          has_certificate?: boolean | null
          is_activated?: boolean | null
          is_curriculum_enabled?: boolean | null
          is_curriculum_subscriber?: boolean | null
          stripe_access_token?: string | null
          stripe_publishable_api_key?: string | null
          show_stripe_reconnect?: boolean | null
          payment_requires_zip_code?: boolean | null
          consent_description?: string | null
          image?: string | null
          grant_access_upon_authentication?: boolean | null
          pathwright_login_enabled?: boolean | null
        }
        licensee: {
          __typename?: "School"
          id: number
          url?: string | null
          name: string
          about?: string | null
          email?: string | null
          website?: string | null
          subdomain: string
          created?: any | null
          billing_model?: number | null
          platform_version?: number | null
          currency_code?: string | null
          ietf_language_tag?: string | null
          has_certificate?: boolean | null
          is_activated?: boolean | null
          is_curriculum_enabled?: boolean | null
          is_curriculum_subscriber?: boolean | null
          stripe_access_token?: string | null
          stripe_publishable_api_key?: string | null
          show_stripe_reconnect?: boolean | null
          payment_requires_zip_code?: boolean | null
          consent_description?: string | null
          image?: string | null
          grant_access_upon_authentication?: boolean | null
          pathwright_login_enabled?: boolean | null
        }
        curriculum_plan?: {
          __typename?: "SchoolCurriculumPlan"
          id: number
          name?: string | null
          amount?: number | null
          fee_boundary?: number | null
          fee_per_user?: number | null
          is_visible?: boolean | null
          lower_boundary?: number | null
          plan_id?: number | null
          transaction_fee_percent?: number | null
          upper_boundary?: number | null
          visibility_code?: string | null
        } | null
        subscription?: {
          __typename?: "Subscription"
          id?: number | null
          quantity?: number | null
          canceled_dtime?: any | null
          cancellation_reason?: number | null
          card_last_4?: string | null
          cycle_end_dtime?: any | null
          cycle_start_dtime?: any | null
          is_canceled_at_cycle_end?: boolean | null
          is_delinquent?: boolean | null
          paused_until_dtime?: any | null
          trial_type?: number | null
          trial_end_dtime?: any | null
          payment_intent_needing_action_id?: string | null
          subscription_plan?: {
            __typename?: "SubscriptionPlan"
            id?: number | null
            name?: string | null
            amount?: number | null
            interval?: number | null
            trial_period_days?: number | null
            trial_type?: number | null
            plan_type?: string | null
            stripe_connected_account_url?: string | null
          } | null
          customer?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
        } | null
      } | null
    }
  } | null
}

export type CurriculumSubscriptionsQueryVariables = Exact<{
  [key: string]: never
}>

export type CurriculumSubscriptionsQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    curriculum_subscriptions?: {
      __typename?: "CurriculumSubscriptionConnection"
      edges?: Array<{
        __typename?: "CurriculumSubscriptionEdge"
        node?: {
          __typename?: "CurriculumSubscription"
          id: number
          licensor: {
            __typename?: "School"
            id: number
            url?: string | null
            name: string
            about?: string | null
            email?: string | null
            website?: string | null
            subdomain: string
            created?: any | null
            billing_model?: number | null
            platform_version?: number | null
            currency_code?: string | null
            ietf_language_tag?: string | null
            has_certificate?: boolean | null
            is_activated?: boolean | null
            is_curriculum_enabled?: boolean | null
            is_curriculum_subscriber?: boolean | null
            stripe_access_token?: string | null
            stripe_publishable_api_key?: string | null
            show_stripe_reconnect?: boolean | null
            payment_requires_zip_code?: boolean | null
            consent_description?: string | null
            image?: string | null
            grant_access_upon_authentication?: boolean | null
            pathwright_login_enabled?: boolean | null
          }
          licensee: {
            __typename?: "School"
            id: number
            url?: string | null
            name: string
            about?: string | null
            email?: string | null
            website?: string | null
            subdomain: string
            created?: any | null
            billing_model?: number | null
            platform_version?: number | null
            currency_code?: string | null
            ietf_language_tag?: string | null
            has_certificate?: boolean | null
            is_activated?: boolean | null
            is_curriculum_enabled?: boolean | null
            is_curriculum_subscriber?: boolean | null
            stripe_access_token?: string | null
            stripe_publishable_api_key?: string | null
            show_stripe_reconnect?: boolean | null
            payment_requires_zip_code?: boolean | null
            consent_description?: string | null
            image?: string | null
            grant_access_upon_authentication?: boolean | null
            pathwright_login_enabled?: boolean | null
          }
          curriculum_plan?: {
            __typename?: "SchoolCurriculumPlan"
            id: number
            name?: string | null
            amount?: number | null
            fee_boundary?: number | null
            fee_per_user?: number | null
            is_visible?: boolean | null
            lower_boundary?: number | null
            plan_id?: number | null
            transaction_fee_percent?: number | null
            upper_boundary?: number | null
            visibility_code?: string | null
          } | null
          subscription?: {
            __typename?: "Subscription"
            id?: number | null
            quantity?: number | null
            canceled_dtime?: any | null
            cancellation_reason?: number | null
            card_last_4?: string | null
            cycle_end_dtime?: any | null
            cycle_start_dtime?: any | null
            is_canceled_at_cycle_end?: boolean | null
            is_delinquent?: boolean | null
            paused_until_dtime?: any | null
            trial_type?: number | null
            trial_end_dtime?: any | null
            payment_intent_needing_action_id?: string | null
            subscription_plan?: {
              __typename?: "SubscriptionPlan"
              id?: number | null
              name?: string | null
              amount?: number | null
              interval?: number | null
              trial_period_days?: number | null
              trial_type?: number | null
              plan_type?: string | null
              stripe_connected_account_url?: string | null
            } | null
            customer?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type SchoolCurriculumPlanFragment = {
  __typename?: "SchoolCurriculumPlan"
  id: number
  name?: string | null
  amount?: number | null
  fee_boundary?: number | null
  fee_per_user?: number | null
  is_visible?: boolean | null
  lower_boundary?: number | null
  plan_id?: number | null
  transaction_fee_percent?: number | null
  upper_boundary?: number | null
  visibility_code?: string | null
}

export type SchoolFragment = {
  __typename?: "School"
  id: number
  url?: string | null
  name: string
  about?: string | null
  email?: string | null
  website?: string | null
  subdomain: string
  created?: any | null
  billing_model?: number | null
  platform_version?: number | null
  currency_code?: string | null
  ietf_language_tag?: string | null
  has_certificate?: boolean | null
  is_activated?: boolean | null
  is_curriculum_enabled?: boolean | null
  is_curriculum_subscriber?: boolean | null
  stripe_access_token?: string | null
  stripe_publishable_api_key?: string | null
  show_stripe_reconnect?: boolean | null
  payment_requires_zip_code?: boolean | null
  consent_description?: string | null
  image?: string | null
  grant_access_upon_authentication?: boolean | null
  pathwright_login_enabled?: boolean | null
}

export type ThemeFragment = {
  __typename?: "Theme"
  id?: number | null
  name?: string | null
  theme_type?: ThemeType | null
  background_image?: string | null
  background_overlay?: string | null
  background_type?: number | null
  heading_font?: string | null
  primary_color?: string | null
  typekit_id?: string | null
  custom_css?: string | null
  processed_custom_css?: string | null
  color_palette?: {
    __typename?: "NodeThemeColorPalette"
    _50?: string | null
    _100?: string | null
    _200?: string | null
    _300?: string | null
    _400?: string | null
    _500?: string | null
    _600?: string | null
    _700?: string | null
    _800?: string | null
    _900?: string | null
  } | null
}

export type BlurredThemeBackgroundImageQueryVariables = Exact<{
  url: Scalars["String"]["input"]
  width?: InputMaybe<Scalars["Int"]["input"]>
  height?: InputMaybe<Scalars["Int"]["input"]>
  blur?: InputMaybe<Scalars["Int"]["input"]>
  high?: InputMaybe<Scalars["Int"]["input"]>
  blend?: InputMaybe<Scalars["Int"]["input"]>
  balph?: InputMaybe<Scalars["Int"]["input"]>
  fm?: InputMaybe<Scalars["String"]["input"]>
  q?: InputMaybe<Scalars["Int"]["input"]>
  bm?: InputMaybe<Scalars["String"]["input"]>
}>

export type BlurredThemeBackgroundImageQuery = {
  __typename?: "Query"
  media?: { __typename?: "Media"; image?: string | null } | null
}

export type CreatedSpaceFragment = {
  __typename?: "School"
  id: number
  name: string
  sso_link?: string | null
  profile?: { __typename?: "SchoolProfile"; id?: number | null } | null
}

export type CreateSpaceMutationVariables = Exact<{
  name: Scalars["String"]["input"]
  subdomain: Scalars["String"]["input"]
  copy?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >
  utm_source?: InputMaybe<Scalars["String"]["input"]>
  utm_medium?: InputMaybe<Scalars["String"]["input"]>
  utm_campaign?: InputMaybe<Scalars["String"]["input"]>
  theme?: InputMaybe<ThemeInput>
}>

export type CreateSpaceMutation = {
  __typename?: "Mutations"
  createSchool?: {
    __typename?: "School"
    id: number
    name: string
    sso_link?: string | null
    profile?: { __typename?: "SchoolProfile"; id?: number | null } | null
  } | null
}

export type SpaceBillingPlanSetQueryVariables = Exact<{ [key: string]: never }>

export type SpaceBillingPlanSetQuery = {
  __typename?: "Query"
  account?: {
    __typename?: "SchoolAcount"
    id?: number | null
    billing_plan_set?: {
      __typename?: "SchoolBillingPlanSet"
      id?: number | null
      name?: string | null
      is_default?: boolean | null
      plans?: Array<{
        __typename?: "SchoolBillingPlan"
        id: number
        name: string
      } | null> | null
    } | null
  } | null
}

export type SpaceBillingPlanSetPlanFragment = {
  __typename?: "SchoolBillingPlan"
  id: number
  name: string
}

export type SpaceSsoLinkQueryVariables = Exact<{
  spaceId: Scalars["Int"]["input"]
  pathname: Scalars["String"]["input"]
}>

export type SpaceSsoLinkQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url?: string | null
      sso_link?: string | null
    }
  } | null
}

export type SubdomainQueryVariables = Exact<{
  subdomain?: InputMaybe<Scalars["String"]["input"]>
}>

export type SubdomainQuery = {
  __typename?: "Query"
  subdomain?: {
    __typename?: "Subdomain"
    id?: number | null
    subdomain?: string | null
  } | null
}

export type UpdateSpaceProfileMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  school_type?: InputMaybe<SchoolType>
  plan_to_sell?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type UpdateSpaceProfileMutation = {
  __typename?: "Mutations"
  updateSchoolProfile?: {
    __typename?: "SchoolProfile"
    id?: number | null
    school_type?: SchoolType | null
    plan_to_sell?: boolean | null
  } | null
}

export type UserCreatedSpaceMembershipsQueryVariables = Exact<{
  [key: string]: never
}>

export type UserCreatedSpaceMembershipsQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    memberships?: {
      __typename?: "MembershipConnection"
      edges?: Array<{
        __typename?: "MembershipEdge"
        node?: {
          __typename?: "Membership"
          id: number
          school: {
            __typename?: "School"
            subdomain: string
            id: number
            name: string
            sso_link?: string | null
            profile?: {
              __typename?: "SchoolProfile"
              id?: number | null
            } | null
          }
        } | null
      } | null> | null
    } | null
  } | null
}

export type UserSpaceMembershipFragment = {
  __typename?: "Membership"
  id: number
  role: number
  last_seen?: any | null
  school: {
    __typename?: "School"
    id: number
    name: string
    image?: string | null
    sso_link?: string | null
  }
}

export type UserSpaceMembershipsQueryVariables = Exact<{ [key: string]: never }>

export type UserSpaceMembershipsQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    memberships?: {
      __typename?: "MembershipConnection"
      edges?: Array<{
        __typename?: "MembershipEdge"
        node?: {
          __typename?: "Membership"
          id: number
          role: number
          last_seen?: any | null
          school: {
            __typename?: "School"
            id: number
            name: string
            image?: string | null
            sso_link?: string | null
          }
        } | null
      } | null> | null
    } | null
  } | null
}

export type ScheduleItemMutationVariables = Exact<{
  schedule_context: ScheduleItemContext
  starts?: InputMaybe<Scalars["DateTime"]["input"]>
  due?: InputMaybe<Scalars["DateTime"]["input"]>
  passive_starts?: InputMaybe<Scalars["Boolean"]["input"]>
  passive_due?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type ScheduleItemMutation = {
  __typename?: "Mutations"
  scheduleItem?: {
    __typename?: "PathItem"
    id: number
    order: number
    verb?: string | null
    name: string
    type: PathItemType
    path_id: number
    source_id: number
    parent_id?: number | null
    parent_source_id?: number | null
    description?: string | null
    curriculum_sync_opt_out_dtime?: any | null
    assignment_type?: PathItemAssignmentType | null
    content_id?: number | null
    content_type?: string | null
    item_content_type_id?: number | null
    is_required?: boolean | null
    is_previewable?: boolean | null
    due?: any | null
    passive_due?: boolean | null
    starts?: any | null
    passive_starts?: boolean | null
    has_started?: boolean | null
    points?: number | null
    item_needs_grading?: boolean | null
    minimum_passing_score?: number | null
    grading_type?: string | null
    time_to_complete?: number | null
    lock_password?: string | null
    is_locked?: boolean | null
    lock_unlocked_time?: any | null
    allow_resets?: number | null
    show_grading_feedback?: number | null
    completion_comment_required_status?: string | null
    last_published_dtime?: any | null
    archived_time?: any | null
    progress: number
    context?: {
      __typename?: "StepContext"
      resource_id?: number | null
      cohort_id?: number | null
    } | null
    blocks?: {
      __typename?: "BlocksContent"
      content_last_modified?: any | null
      last_published?: any | null
    } | null
    permissions?: {
      __typename?: "PathItemPermissions"
      can_complete?: boolean | null
      can_discuss?: boolean | null
      can_edit?: boolean | null
      can_edit_content?: boolean | null
      can_note?: boolean | null
      can_view?: boolean | null
      can_review?: boolean | null
      can_view_content?: boolean | null
    } | null
    completion: {
      __typename?: "Completion"
      id?: number | null
      checked_date?: any | null
      completion_attempts?: number | null
      completion_comment?: string | null
      completion_date?: any | null
      completion_due?: any | null
      last_completion_attempt_date?: any | null
      has_failed_passing_attempt?: boolean | null
      has_points?: boolean | null
      is_late?: boolean | null
      is_graded?: boolean | null
      is_skipped?: boolean | null
      is_complete?: boolean | null
      is_auto_graded?: boolean | null
      is_forced_completion?: boolean | null
      needs_grading?: boolean | null
      userpoints_earned?: number | null
      userpoints_explanation?: string | null
      userpoints_value?: number | null
      minimum_passing_score?: number | null
      grading_type?: string | null
      requires_api_completion?: boolean | null
      overridden_by_api?: boolean | null
      overridden_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      checked_by?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      submission?: {
        __typename?: "UserSubmission"
        id?: number | null
        text?: string | null
        file_url?: string | null
        file_name?: string | null
        file_image?: string | null
      } | null
      feedback_discussion_context?: {
        __typename?: "CompletionFeedbackDiscussionContext"
        id?: number | null
        discussion_id?: number | null
        num_responses?: number | null
      } | null
    }
    linked_resource?: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      curriculum_group?: { __typename?: "Group"; id: number } | null
    } | null
    linked_cohort?: {
      __typename?: "Group"
      id: number
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        completion_state?: number | null
        send_due_notifications?: boolean | null
        send_discussion_notifications?: boolean | null
        last_activity_time?: any | null
        expiration_dtime?: any | null
        created?: any | null
        path?: { __typename?: "Path"; id: number } | null
        user: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        }
      } | null
    } | null
    linked_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      path?: { __typename?: "Path"; id: number } | null
      user: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      }
    } | null
  } | null
}

export type CreateStoreLinkMutationVariables = Exact<{
  schoolId: Scalars["Int"]["input"]
  copy?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >
}>

export type CreateStoreLinkMutation = {
  __typename?: "Mutations"
  createStoreLink?: {
    __typename?: "StoreLink"
    id: number
    licensee: {
      __typename?: "School"
      sso_link?: string | null
      id: number
      url?: string | null
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
    }
    store: {
      __typename?: "Store"
      id: number
      licensor: {
        __typename?: "School"
        id: number
        url?: string | null
        name: string
        about?: string | null
        email?: string | null
        website?: string | null
        subdomain: string
        created?: any | null
        billing_model?: number | null
        platform_version?: number | null
        currency_code?: string | null
        ietf_language_tag?: string | null
        has_certificate?: boolean | null
        is_activated?: boolean | null
        is_curriculum_enabled?: boolean | null
        is_curriculum_subscriber?: boolean | null
        stripe_access_token?: string | null
        stripe_publishable_api_key?: string | null
        show_stripe_reconnect?: boolean | null
        payment_requires_zip_code?: boolean | null
        consent_description?: string | null
        image?: string | null
        grant_access_upon_authentication?: boolean | null
        pathwright_login_enabled?: boolean | null
      }
    }
  } | null
}

export type ResourceOfferingsQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  cursor?: InputMaybe<Scalars["String"]["input"]>
  school_id: Scalars["Int"]["input"]
  licensee_school_id: Scalars["Int"]["input"]
  licenseeIdFilter?: InputMaybe<IdFilter>
  include_school_license: Scalars["Boolean"]["input"]
  skip_group_offerings: Scalars["Boolean"]["input"]
  skip_license_offerings: Scalars["Boolean"]["input"]
  licensing_mode?: InputMaybe<LicenseOfferingLicensingMode>
}>

export type ResourceOfferingsQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url?: string | null
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource?: {
        __typename?: "Resource"
        id: number
        license_offerings?: {
          __typename?: "LicenseOfferingConnection"
          total: number
          edges?: Array<{
            __typename?: "LicenseOfferingEdge"
            node?: {
              __typename?: "LicenseOffering"
              id?: number | null
              description?: string | null
              cost_per_seat?: number | null
              include_creator_seat?: boolean | null
              register_creator_as?: RegistrationRoleEnum | null
              minimum_seat_count?: number | null
              minimum_license_duration?: number | null
              licensing_mode?: LicenseOfferingLicensingMode | null
              included_in_user_subscription?: boolean | null
              school_license?: {
                __typename?: "ResourceLicense"
                id?: number | null
              } | null
              include_in_school_curriculum_subscriptions?: {
                __typename?: "CurriculumSubscriptionConnection"
                total: number
              } | null
              include_in_curriculum_plans?: {
                __typename?: "SchoolCurriculumPlanConnection"
                total: number
                edges?: Array<{
                  __typename?: "SchoolCurriculumPlanEdge"
                  node?: {
                    __typename?: "SchoolCurriculumPlan"
                    id: number
                    plan_id?: number | null
                  } | null
                } | null> | null
              } | null
              include_in_subscription_plans?: {
                __typename?: "SchoolSubscriptionPlanConnection"
                total: number
                edges?: Array<{
                  __typename?: "SchoolSubscriptionPlanEdge"
                  node?: {
                    __typename?: "SchoolSubscriptionPlan"
                    id?: number | null
                  } | null
                } | null> | null
              } | null
              licensor?: {
                __typename?: "School"
                id: number
                url?: string | null
                name: string
                about?: string | null
                email?: string | null
                website?: string | null
                subdomain: string
                created?: any | null
                billing_model?: number | null
                platform_version?: number | null
                currency_code?: string | null
                ietf_language_tag?: string | null
                has_certificate?: boolean | null
                is_activated?: boolean | null
                is_curriculum_enabled?: boolean | null
                is_curriculum_subscriber?: boolean | null
                stripe_access_token?: string | null
                stripe_publishable_api_key?: string | null
                show_stripe_reconnect?: boolean | null
                payment_requires_zip_code?: boolean | null
                consent_description?: string | null
                image?: string | null
                grant_access_upon_authentication?: boolean | null
                pathwright_login_enabled?: boolean | null
              } | null
            } | null
          } | null> | null
        } | null
        group_offerings?: {
          __typename?: "GroupConnection"
          total: number
          pageInfo: {
            __typename?: "PageInfo"
            endCursor?: string | null
            hasNextPage: boolean
          }
          edges?: Array<{
            __typename?: "GroupEdge"
            node?: {
              __typename?: "Group"
              id: number
              name: string
              created?: any | null
              description?: string | null
              price?: number | null
              seats?: number | null
              seats_filled?: number | null
              seats_available?: number | null
              registration_ends?: any | null
              registration_starts?: any | null
              registration_started?: boolean | null
              registration_ended?: boolean | null
              access_ends?: any | null
              access_starts?: any | null
              is_master?: boolean | null
              is_source_cohort?: boolean | null
              source_cohort_id?: number | null
              parent_section_id?: number | null
              resource_id?: number | null
              visibility?: number | null
              is_collection_linked?: boolean | null
              is_subscription_only?: boolean | null
              status: GroupStatus
              analytics_disabled?: boolean | null
              created_by_id?: number | null
              include_in_plans?: {
                __typename?: "SchoolSubscriptionPlanConnection"
                edges?: Array<{
                  __typename?: "SchoolSubscriptionPlanEdge"
                  node?: {
                    __typename?: "SchoolSubscriptionPlan"
                    id?: number | null
                    image?: string | null
                    details_html?: string | null
                    subscribe_complete_html?: string | null
                    catalog_header?: string | null
                    is_visible?: boolean | null
                    giftable_cycles?: Array<number | null> | null
                    subscription_plan?: {
                      __typename?: "SubscriptionPlan"
                      id?: number | null
                      name?: string | null
                      amount?: number | null
                      interval?: number | null
                      trial_period_days?: number | null
                      trial_type?: number | null
                      plan_type?: string | null
                      stripe_connected_account_url?: string | null
                    } | null
                  } | null
                } | null> | null
              } | null
            } | null
          } | null> | null
        } | null
      } | null
    }
  } | null
}

export type StoreFragment = {
  __typename?: "Store"
  id: number
  licensor: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
  }
}

export type StoreLinkFragment = {
  __typename?: "StoreLink"
  id: number
  licensee: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
  }
  store: {
    __typename?: "Store"
    id: number
    licensor: {
      __typename?: "School"
      id: number
      url?: string | null
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
    }
  }
}

export type StoreLinkQueryVariables = Exact<{ [key: string]: never }>

export type StoreLinkQuery = {
  __typename?: "Query"
  storeLink?: {
    __typename?: "StoreLink"
    id: number
    licensee: {
      __typename?: "School"
      id: number
      url?: string | null
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
    }
    store: {
      __typename?: "Store"
      id: number
      licensor: {
        __typename?: "School"
        id: number
        url?: string | null
        name: string
        about?: string | null
        email?: string | null
        website?: string | null
        subdomain: string
        created?: any | null
        billing_model?: number | null
        platform_version?: number | null
        currency_code?: string | null
        ietf_language_tag?: string | null
        has_certificate?: boolean | null
        is_activated?: boolean | null
        is_curriculum_enabled?: boolean | null
        is_curriculum_subscriber?: boolean | null
        stripe_access_token?: string | null
        stripe_publishable_api_key?: string | null
        show_stripe_reconnect?: boolean | null
        payment_requires_zip_code?: boolean | null
        consent_description?: string | null
        image?: string | null
        grant_access_upon_authentication?: boolean | null
        pathwright_login_enabled?: boolean | null
      }
    }
  } | null
}

export type StoreLinksQueryVariables = Exact<{
  licensorId?: InputMaybe<IdFilter>
}>

export type StoreLinksQuery = {
  __typename?: "Query"
  storeLinks?: {
    __typename?: "StoreLinkConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges?: Array<{
      __typename?: "StoreLinkEdge"
      node?: {
        __typename?: "StoreLink"
        id: number
        licensee: {
          __typename?: "School"
          id: number
          url?: string | null
          name: string
          about?: string | null
          email?: string | null
          website?: string | null
          subdomain: string
          created?: any | null
          billing_model?: number | null
          platform_version?: number | null
          currency_code?: string | null
          ietf_language_tag?: string | null
          has_certificate?: boolean | null
          is_activated?: boolean | null
          is_curriculum_enabled?: boolean | null
          is_curriculum_subscriber?: boolean | null
          stripe_access_token?: string | null
          stripe_publishable_api_key?: string | null
          show_stripe_reconnect?: boolean | null
          payment_requires_zip_code?: boolean | null
          consent_description?: string | null
          image?: string | null
          grant_access_upon_authentication?: boolean | null
          pathwright_login_enabled?: boolean | null
        }
        store: {
          __typename?: "Store"
          id: number
          licensor: {
            __typename?: "School"
            id: number
            url?: string | null
            name: string
            about?: string | null
            email?: string | null
            website?: string | null
            subdomain: string
            created?: any | null
            billing_model?: number | null
            platform_version?: number | null
            currency_code?: string | null
            ietf_language_tag?: string | null
            has_certificate?: boolean | null
            is_activated?: boolean | null
            is_curriculum_enabled?: boolean | null
            is_curriculum_subscriber?: boolean | null
            stripe_access_token?: string | null
            stripe_publishable_api_key?: string | null
            show_stripe_reconnect?: boolean | null
            payment_requires_zip_code?: boolean | null
            consent_description?: string | null
            image?: string | null
            grant_access_upon_authentication?: boolean | null
            pathwright_login_enabled?: boolean | null
          }
        }
      } | null
    } | null> | null
  } | null
}

export type StoreQueryVariables = Exact<{ [key: string]: never }>

export type StoreQuery = {
  __typename?: "Query"
  store?: {
    __typename?: "Store"
    id: number
    licensor: {
      __typename?: "School"
      id: number
      url?: string | null
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
    }
  } | null
}

export type StoreResourceQueryVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>
  school_id: Scalars["Int"]["input"]
  include_publisher: Scalars["Boolean"]["input"]
  include_school_license: Scalars["Boolean"]["input"]
  include_license_offerings: Scalars["Boolean"]["input"]
  licensee_school_id: Scalars["Int"]["input"]
  licenseeIdFilter?: InputMaybe<IdFilter>
}>

export type StoreResourceQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url?: string | null
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resource?: {
        __typename?: "Resource"
        trailer_embed_code?: string | null
        visibility_level_override?: number | null
        certificate_generator_class?: string | null
        licensed_from_resource_id?: number | null
        id: number
        name: string
        slug: string
        created?: any | null
        resource_type: number
        visibility?: number | null
        description?: string | null
        short_description?: string | null
        background_overlay?: string | null
        background_image?: string | null
        background_type: ResourceBackgroundType
        image_raw?: string | null
        has_certificate?: boolean | null
        discussion_enabled?: boolean | null
        lowest_public_offering_price?: number | null
        highest_public_offering_price?: number | null
        licensed_from_school_id?: number | null
        created_by_id?: number | null
        copied_with_copy_config_id?: number | null
        image: string
        blurred_background?: string | null
        cover_image: string
        school?: {
          __typename?: "School"
          id: number
          url?: string | null
          name: string
          about?: string | null
          email?: string | null
          website?: string | null
          subdomain: string
          created?: any | null
          billing_model?: number | null
          platform_version?: number | null
          currency_code?: string | null
          ietf_language_tag?: string | null
          has_certificate?: boolean | null
          is_activated?: boolean | null
          is_curriculum_enabled?: boolean | null
          is_curriculum_subscriber?: boolean | null
          stripe_access_token?: string | null
          stripe_publishable_api_key?: string | null
          show_stripe_reconnect?: boolean | null
          payment_requires_zip_code?: boolean | null
          consent_description?: string | null
          image?: string | null
          grant_access_upon_authentication?: boolean | null
          pathwright_login_enabled?: boolean | null
        } | null
        publisher?: {
          __typename?: "Publisher"
          id?: number | null
          name?: string | null
          about?: string | null
          website?: string | null
          image?: string | null
          theme?: {
            __typename?: "Theme"
            id?: number | null
            name?: string | null
            theme_type?: ThemeType | null
            background_image?: string | null
            background_overlay?: string | null
            background_type?: number | null
            heading_font?: string | null
            primary_color?: string | null
            typekit_id?: string | null
            custom_css?: string | null
            processed_custom_css?: string | null
            color_palette?: {
              __typename?: "NodeThemeColorPalette"
              _50?: string | null
              _100?: string | null
              _200?: string | null
              _300?: string | null
              _400?: string | null
              _500?: string | null
              _600?: string | null
              _700?: string | null
              _800?: string | null
              _900?: string | null
            } | null
          } | null
        } | null
        registration_meta?: {
          __typename?: "RegistrationMeta"
          editor_registration_count?: number | null
        } | null
        school_licenses?: {
          __typename?: "ResourceLicenseConnection"
          edges?: Array<{
            __typename?: "ResourceLicenseEdge"
            node?: {
              __typename?: "ResourceLicense"
              id?: number | null
              group?: {
                __typename?: "Group"
                id: number
                resource_id?: number | null
              } | null
            } | null
          } | null> | null
        } | null
        authors?: {
          __typename?: "AuthorConnection"
          total: number
          pageInfo: {
            __typename?: "PageInfo"
            endCursor?: string | null
            hasNextPage: boolean
          }
          edges?: Array<{
            __typename?: "AuthorEdge"
            node?: {
              __typename?: "Author"
              id?: number | null
              bio?: string | null
              image?: string | null
              order?: number | null
              full_name?: string | null
            } | null
          } | null> | null
        } | null
        categories?: {
          __typename?: "CategoryConnection"
          total: number
          pageInfo: {
            __typename?: "PageInfo"
            endCursor?: string | null
            hasNextPage: boolean
          }
          edges?: Array<{
            __typename?: "CategoryEdge"
            node?: {
              __typename?: "Category"
              id?: number | null
              name?: string | null
              slug?: string | null
              order?: number | null
              description?: string | null
            } | null
          } | null> | null
        } | null
        groups?: {
          __typename?: "GroupConnection"
          total: number
          pageInfo: {
            __typename?: "PageInfo"
            endCursor?: string | null
            hasNextPage: boolean
          }
          edges?: Array<{
            __typename?: "GroupEdge"
            node?: {
              __typename?: "Group"
              id: number
              name: string
              created?: any | null
              description?: string | null
              price?: number | null
              seats?: number | null
              seats_filled?: number | null
              seats_available?: number | null
              registration_ends?: any | null
              registration_starts?: any | null
              registration_started?: boolean | null
              registration_ended?: boolean | null
              access_ends?: any | null
              access_starts?: any | null
              is_master?: boolean | null
              is_source_cohort?: boolean | null
              source_cohort_id?: number | null
              parent_section_id?: number | null
              resource_id?: number | null
              visibility?: number | null
              is_collection_linked?: boolean | null
              is_subscription_only?: boolean | null
              status: GroupStatus
              analytics_disabled?: boolean | null
              created_by_id?: number | null
              path: {
                __typename?: "Path"
                id: number
                items?: {
                  __typename?: "PathItemConnection"
                  total: number
                } | null
              }
            } | null
          } | null> | null
        } | null
        license_offerings?: {
          __typename?: "LicenseOfferingConnection"
          total: number
          edges?: Array<{
            __typename?: "LicenseOfferingEdge"
            node?: {
              __typename?: "LicenseOffering"
              id?: number | null
              description?: string | null
              cost_per_seat?: number | null
              include_creator_seat?: boolean | null
              register_creator_as?: RegistrationRoleEnum | null
              minimum_seat_count?: number | null
              minimum_license_duration?: number | null
              licensing_mode?: LicenseOfferingLicensingMode | null
              included_in_user_subscription?: boolean | null
              include_in_school_curriculum_subscriptions?: {
                __typename?: "CurriculumSubscriptionConnection"
                total: number
              } | null
              include_in_curriculum_plans?: {
                __typename?: "SchoolCurriculumPlanConnection"
                total: number
                edges?: Array<{
                  __typename?: "SchoolCurriculumPlanEdge"
                  node?: {
                    __typename?: "SchoolCurriculumPlan"
                    id: number
                    plan_id?: number | null
                  } | null
                } | null> | null
              } | null
              include_in_subscription_plans?: {
                __typename?: "SchoolSubscriptionPlanConnection"
                total: number
                edges?: Array<{
                  __typename?: "SchoolSubscriptionPlanEdge"
                  node?: {
                    __typename?: "SchoolSubscriptionPlan"
                    id?: number | null
                  } | null
                } | null> | null
              } | null
              licensor?: {
                __typename?: "School"
                id: number
                url?: string | null
                name: string
                about?: string | null
                email?: string | null
                website?: string | null
                subdomain: string
                created?: any | null
                billing_model?: number | null
                platform_version?: number | null
                currency_code?: string | null
                ietf_language_tag?: string | null
                has_certificate?: boolean | null
                is_activated?: boolean | null
                is_curriculum_enabled?: boolean | null
                is_curriculum_subscriber?: boolean | null
                stripe_access_token?: string | null
                stripe_publishable_api_key?: string | null
                show_stripe_reconnect?: boolean | null
                payment_requires_zip_code?: boolean | null
                consent_description?: string | null
                image?: string | null
                grant_access_upon_authentication?: boolean | null
                pathwright_login_enabled?: boolean | null
              } | null
            } | null
          } | null> | null
        } | null
        group?: {
          __typename?: "Group"
          id: number
          path: {
            __typename?: "Path"
            id: number
            items?: { __typename?: "PathItemConnection"; total: number } | null
            previewable_steps?: {
              __typename?: "PathItemConnection"
              edges?: Array<{
                __typename?: "PathItemEdge"
                node?: {
                  __typename?: "PathItem"
                  id: number
                  source_id: number
                  name: string
                  assignment_type?: PathItemAssignmentType | null
                } | null
              } | null> | null
            } | null
          }
        } | null
      } | null
    }
  } | null
}

export type StoreResourcesQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>
  first: Scalars["Int"]["input"]
  role?: InputMaybe<RoleFilter>
  search?: InputMaybe<Scalars["String"]["input"]>
  author_ids?: InputMaybe<IdFilter>
  category_ids?: InputMaybe<IdFilter>
  publisher_ids?: InputMaybe<IdFilter>
  resource_types?: InputMaybe<ResourceTypeFilter>
  visibility?: InputMaybe<ResourceVisibility>
  school_id: Scalars["Int"]["input"]
  licensee_school_id: Scalars["Int"]["input"]
  include_school_license: Scalars["Boolean"]["input"]
  user_registered?: InputMaybe<IdFilter>
}>

export type StoreResourcesQuery = {
  __typename?: "Query"
  context?: {
    __typename?: "AccountContext"
    school: {
      __typename?: "School"
      id: number
      url?: string | null
      name: string
      about?: string | null
      email?: string | null
      website?: string | null
      subdomain: string
      created?: any | null
      billing_model?: number | null
      platform_version?: number | null
      currency_code?: string | null
      ietf_language_tag?: string | null
      has_certificate?: boolean | null
      is_activated?: boolean | null
      is_curriculum_enabled?: boolean | null
      is_curriculum_subscriber?: boolean | null
      stripe_access_token?: string | null
      stripe_publishable_api_key?: string | null
      show_stripe_reconnect?: boolean | null
      payment_requires_zip_code?: boolean | null
      consent_description?: string | null
      image?: string | null
      grant_access_upon_authentication?: boolean | null
      pathwright_login_enabled?: boolean | null
      resources?: {
        __typename?: "ResourceConnection"
        total: number
        pageInfo: {
          __typename?: "PageInfo"
          endCursor?: string | null
          hasNextPage: boolean
        }
        edges?: Array<{
          __typename?: "ResourceEdge"
          node?: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
            curriculum?: { __typename?: "Group"; id: number } | null
            publisher?: {
              __typename?: "Publisher"
              id?: number | null
              name?: string | null
              about?: string | null
              website?: string | null
              image?: string | null
            } | null
            authors?: {
              __typename?: "AuthorConnection"
              total: number
              edges?: Array<{
                __typename?: "AuthorEdge"
                node?: {
                  __typename?: "Author"
                  id?: number | null
                  bio?: string | null
                  image?: string | null
                  order?: number | null
                  full_name?: string | null
                } | null
              } | null> | null
            } | null
            school_licenses?: {
              __typename?: "ResourceLicenseConnection"
              edges?: Array<{
                __typename?: "ResourceLicenseEdge"
                node?: {
                  __typename?: "ResourceLicense"
                  id?: number | null
                } | null
              } | null> | null
            } | null
            license_offerings?: {
              __typename?: "LicenseOfferingConnection"
              total: number
            } | null
          } | null
        } | null> | null
      } | null
    }
  } | null
}

export type StripePriceFragment = {
  __typename?: "StripePrice"
  id: number
  active?: boolean | null
  billing_scheme?: StripeBillingScheme | null
  currency?: string | null
  nickname?: string | null
  recurring_interval?: StripeRecurringInterval | null
  recurring_interval_count?: number | null
  stripe_price_id?: string | null
  stripe_connected_account_url?: string | null
  tiers_mode?: StripeTiersMode | null
  unit_amount_decimal?: number | null
  tiers?: Array<{
    __typename?: "StripeTier"
    up_to?: number | null
    flat_amount?: number | null
    flat_amount_decimal?: string | null
    unit_amount?: number | null
    unit_amount_decimal?: string | null
  } | null> | null
  product?: {
    __typename?: "StripeProduct"
    id: number
    min_quantity?: number | null
    max_quantity?: number | null
  } | null
}

export type StripeProductFragment = {
  __typename?: "StripeProduct"
  id: number
  active?: boolean | null
  name?: string | null
  description?: string | null
  images?: Array<string | null> | null
  unit_label?: string | null
  stripe_product_id?: string | null
  stripe_connected_account_url?: string | null
  min_quantity?: number | null
  max_quantity?: number | null
}

export type StripeProductsQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  after?: InputMaybe<Scalars["String"]["input"]>
  ids?: InputMaybe<IdFilter>
  includeInactive?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type StripeProductsQuery = {
  __typename?: "Query"
  stripeProducts?: {
    __typename?: "StripeProductConnection"
    edges?: Array<{
      __typename?: "StripeProductEdge"
      node?: {
        __typename?: "StripeProduct"
        id: number
        active?: boolean | null
        name?: string | null
        description?: string | null
        images?: Array<string | null> | null
        unit_label?: string | null
        stripe_product_id?: string | null
        stripe_connected_account_url?: string | null
        min_quantity?: number | null
        max_quantity?: number | null
        stripe_prices?: {
          __typename?: "StripePriceConnection"
          edges?: Array<{
            __typename?: "StripePriceEdge"
            node?: {
              __typename?: "StripePrice"
              id: number
              active?: boolean | null
              billing_scheme?: StripeBillingScheme | null
              currency?: string | null
              nickname?: string | null
              recurring_interval?: StripeRecurringInterval | null
              recurring_interval_count?: number | null
              stripe_price_id?: string | null
              stripe_connected_account_url?: string | null
              tiers_mode?: StripeTiersMode | null
              unit_amount_decimal?: number | null
              tiers?: Array<{
                __typename?: "StripeTier"
                up_to?: number | null
                flat_amount?: number | null
                flat_amount_decimal?: string | null
                unit_amount?: number | null
                unit_amount_decimal?: string | null
              } | null> | null
              product?: {
                __typename?: "StripeProduct"
                id: number
                min_quantity?: number | null
                max_quantity?: number | null
              } | null
            } | null
          } | null> | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type CancelSchoolSubscriptionMutationVariables = Exact<{
  for_user?: InputMaybe<Scalars["Int"]["input"]>
  cancel_immediately?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type CancelSchoolSubscriptionMutation = {
  __typename?: "Mutations"
  cancelSchoolSubscription?: {
    __typename?: "SchoolSubscription"
    id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    subscription?: {
      __typename?: "Subscription"
      id?: number | null
      quantity?: number | null
      canceled_dtime?: any | null
      cancellation_reason?: number | null
      card_last_4?: string | null
      cycle_end_dtime?: any | null
      cycle_start_dtime?: any | null
      is_canceled_at_cycle_end?: boolean | null
      is_delinquent?: boolean | null
      paused_until_dtime?: any | null
      trial_type?: number | null
      trial_end_dtime?: any | null
      payment_intent_needing_action_id?: string | null
      subscription_plan?: {
        __typename?: "SubscriptionPlan"
        id?: number | null
        name?: string | null
        amount?: number | null
        interval?: number | null
        trial_period_days?: number | null
        trial_type?: number | null
        plan_type?: string | null
        stripe_connected_account_url?: string | null
      } | null
      customer?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
    } | null
    subscription_plan?: {
      __typename?: "SubscriptionPlan"
      id?: number | null
      name?: string | null
      amount?: number | null
      interval?: number | null
      trial_period_days?: number | null
      trial_type?: number | null
      plan_type?: string | null
      stripe_connected_account_url?: string | null
    } | null
    school_subscription_plan?: {
      __typename?: "SchoolSubscriptionPlan"
      id?: number | null
      image?: string | null
      details_html?: string | null
      subscribe_complete_html?: string | null
      catalog_header?: string | null
      is_visible?: boolean | null
      giftable_cycles?: Array<number | null> | null
      subscription_plan?: {
        __typename?: "SubscriptionPlan"
        id?: number | null
        name?: string | null
        amount?: number | null
        interval?: number | null
        trial_period_days?: number | null
        trial_type?: number | null
        plan_type?: string | null
        stripe_connected_account_url?: string | null
      } | null
    } | null
  } | null
}

export type FeatureIncludedCountQueryVariables = Exact<{ [key: string]: never }>

export type FeatureIncludedCountQuery = {
  __typename?: "Query"
  account?: {
    __typename?: "SchoolAcount"
    id?: number | null
    billing_model?: number | null
    is_activated?: boolean | null
    is_activated_via_override?: boolean | null
    billing_subscription?: {
      __typename?: "SchoolBillingSubscription"
      id?: number | null
      extra_cohorts?: number | null
      extra_mentor_groups?: number | null
      plan?: {
        __typename?: "SchoolBillingPlan"
        id: number
        cohorts_included: number
        mentor_groups_included: number
      } | null
    } | null
  } | null
}

export type FeatureIncludedCountFragment = {
  __typename?: "SchoolAcount"
  id?: number | null
  billing_model?: number | null
  is_activated?: boolean | null
  is_activated_via_override?: boolean | null
  billing_subscription?: {
    __typename?: "SchoolBillingSubscription"
    id?: number | null
    extra_cohorts?: number | null
    extra_mentor_groups?: number | null
    plan?: {
      __typename?: "SchoolBillingPlan"
      id: number
      cohorts_included: number
      mentor_groups_included: number
    } | null
  } | null
}

export type RedeemSchoolGiftSubscriptionMutationVariables = Exact<{
  school_subscription_plan_id: Scalars["Int"]["input"]
  code: Scalars["String"]["input"]
}>

export type RedeemSchoolGiftSubscriptionMutation = {
  __typename?: "Mutations"
  redeemSchoolGiftSubscription?: {
    __typename?: "SchoolSubscription"
    id?: number | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    subscription?: {
      __typename?: "Subscription"
      id?: number | null
      quantity?: number | null
      canceled_dtime?: any | null
      cancellation_reason?: number | null
      card_last_4?: string | null
      cycle_end_dtime?: any | null
      cycle_start_dtime?: any | null
      is_canceled_at_cycle_end?: boolean | null
      is_delinquent?: boolean | null
      paused_until_dtime?: any | null
      trial_type?: number | null
      trial_end_dtime?: any | null
      payment_intent_needing_action_id?: string | null
      subscription_plan?: {
        __typename?: "SubscriptionPlan"
        id?: number | null
        name?: string | null
        amount?: number | null
        interval?: number | null
        trial_period_days?: number | null
        trial_type?: number | null
        plan_type?: string | null
        stripe_connected_account_url?: string | null
      } | null
      customer?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
    } | null
    subscription_plan?: {
      __typename?: "SubscriptionPlan"
      id?: number | null
      name?: string | null
      amount?: number | null
      interval?: number | null
      trial_period_days?: number | null
      trial_type?: number | null
      plan_type?: string | null
      stripe_connected_account_url?: string | null
    } | null
    school_subscription_plan?: {
      __typename?: "SchoolSubscriptionPlan"
      id?: number | null
      image?: string | null
      details_html?: string | null
      subscribe_complete_html?: string | null
      catalog_header?: string | null
      is_visible?: boolean | null
      giftable_cycles?: Array<number | null> | null
      subscription_plan?: {
        __typename?: "SubscriptionPlan"
        id?: number | null
        name?: string | null
        amount?: number | null
        interval?: number | null
        trial_period_days?: number | null
        trial_type?: number | null
        plan_type?: string | null
        stripe_connected_account_url?: string | null
      } | null
    } | null
  } | null
}

export type SchoolGiftSubscriptionFragment = {
  __typename?: "SchoolGiftSubscription"
  id?: number | null
  redeemed?: boolean | null
  recipient_email?: string | null
  recipient_email_sent_time?: any | null
  recipient_first_name?: string | null
  recipient_last_name?: string | null
  gifted_subscription_cycles?: number | null
  gift_message?: string | null
  gift_code?: string | null
  redemption_link?: string | null
  sender?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  school_subscription_plan?: {
    __typename?: "SchoolSubscriptionPlan"
    id?: number | null
    image?: string | null
    details_html?: string | null
    subscribe_complete_html?: string | null
    catalog_header?: string | null
    is_visible?: boolean | null
    giftable_cycles?: Array<number | null> | null
    subscription_plan?: {
      __typename?: "SubscriptionPlan"
      id?: number | null
      name?: string | null
      amount?: number | null
      interval?: number | null
      trial_period_days?: number | null
      trial_type?: number | null
      plan_type?: string | null
      stripe_connected_account_url?: string | null
    } | null
  } | null
}

export type SchoolGiftSubscriptionQueryVariables = Exact<{
  code?: InputMaybe<Scalars["String"]["input"]>
  id?: InputMaybe<Scalars["Int"]["input"]>
}>

export type SchoolGiftSubscriptionQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    gift_subscription?: {
      __typename?: "SchoolGiftSubscription"
      id?: number | null
      redeemed?: boolean | null
      recipient_email?: string | null
      recipient_email_sent_time?: any | null
      recipient_first_name?: string | null
      recipient_last_name?: string | null
      gifted_subscription_cycles?: number | null
      gift_message?: string | null
      gift_code?: string | null
      redemption_link?: string | null
      sender?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      school_subscription_plan?: {
        __typename?: "SchoolSubscriptionPlan"
        id?: number | null
        image?: string | null
        details_html?: string | null
        subscribe_complete_html?: string | null
        catalog_header?: string | null
        is_visible?: boolean | null
        giftable_cycles?: Array<number | null> | null
        subscription_plan?: {
          __typename?: "SubscriptionPlan"
          id?: number | null
          name?: string | null
          amount?: number | null
          interval?: number | null
          trial_period_days?: number | null
          trial_type?: number | null
          plan_type?: string | null
          stripe_connected_account_url?: string | null
        } | null
      } | null
    } | null
  } | null
}

export type SchoolGroupSubscriptionFragment = {
  __typename?: "SchoolGroupSubscription"
  id?: number | null
  price?: {
    __typename?: "StripePrice"
    id: number
    active?: boolean | null
    billing_scheme?: StripeBillingScheme | null
    currency?: string | null
    nickname?: string | null
    recurring_interval?: StripeRecurringInterval | null
    recurring_interval_count?: number | null
    stripe_price_id?: string | null
    stripe_connected_account_url?: string | null
    tiers_mode?: StripeTiersMode | null
    unit_amount_decimal?: number | null
    product?: {
      __typename?: "StripeProduct"
      id: number
      min_quantity?: number | null
      max_quantity?: number | null
      active?: boolean | null
      name?: string | null
      description?: string | null
      images?: Array<string | null> | null
      unit_label?: string | null
      stripe_product_id?: string | null
      stripe_connected_account_url?: string | null
    } | null
    tiers?: Array<{
      __typename?: "StripeTier"
      up_to?: number | null
      flat_amount?: number | null
      flat_amount_decimal?: string | null
      unit_amount?: number | null
      unit_amount_decimal?: string | null
    } | null> | null
  } | null
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  subscription?: {
    __typename?: "Subscription"
    id?: number | null
    quantity?: number | null
    canceled_dtime?: any | null
    cancellation_reason?: number | null
    card_last_4?: string | null
    cycle_end_dtime?: any | null
    cycle_start_dtime?: any | null
    is_canceled_at_cycle_end?: boolean | null
    is_delinquent?: boolean | null
    paused_until_dtime?: any | null
    trial_type?: number | null
    trial_end_dtime?: any | null
    payment_intent_needing_action_id?: string | null
    subscription_plan?: {
      __typename?: "SubscriptionPlan"
      id?: number | null
      name?: string | null
      amount?: number | null
      interval?: number | null
      trial_period_days?: number | null
      trial_type?: number | null
      plan_type?: string | null
      stripe_connected_account_url?: string | null
    } | null
    customer?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
  } | null
  community_group?: {
    __typename?: "MentorGroup"
    id?: number | null
    type?: number | null
    slug?: string | null
    name?: string | null
    description?: string | null
    created?: any | null
    modified?: any | null
    parent_id?: number | null
    has_child_groups?: boolean | null
    seat_limit?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    owner?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    permissions?: {
      __typename?: "MentorGroupPermissions"
      can_add_member?: boolean | null
      can_add_moderator?: boolean | null
      can_add_admin?: boolean | null
      can_add_group?: boolean | null
      can_edit_group?: boolean | null
      can_change_parent?: boolean | null
      can_edit_subscription?: boolean | null
      can_delete_group?: boolean | null
      can_update_member_review_permission?: boolean | null
      can_update_moderator_review_permission?: boolean | null
      can_update_admin_review_permission?: boolean | null
    } | null
  } | null
}

export type SchoolGroupSubscriptionQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type SchoolGroupSubscriptionQuery = {
  __typename?: "Query"
  schoolGroupSubscription?: {
    __typename?: "SchoolGroupSubscription"
    id?: number | null
    price?: {
      __typename?: "StripePrice"
      id: number
      active?: boolean | null
      billing_scheme?: StripeBillingScheme | null
      currency?: string | null
      nickname?: string | null
      recurring_interval?: StripeRecurringInterval | null
      recurring_interval_count?: number | null
      stripe_price_id?: string | null
      stripe_connected_account_url?: string | null
      tiers_mode?: StripeTiersMode | null
      unit_amount_decimal?: number | null
      product?: {
        __typename?: "StripeProduct"
        id: number
        min_quantity?: number | null
        max_quantity?: number | null
        active?: boolean | null
        name?: string | null
        description?: string | null
        images?: Array<string | null> | null
        unit_label?: string | null
        stripe_product_id?: string | null
        stripe_connected_account_url?: string | null
      } | null
      tiers?: Array<{
        __typename?: "StripeTier"
        up_to?: number | null
        flat_amount?: number | null
        flat_amount_decimal?: string | null
        unit_amount?: number | null
        unit_amount_decimal?: string | null
      } | null> | null
    } | null
    user?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    subscription?: {
      __typename?: "Subscription"
      id?: number | null
      quantity?: number | null
      canceled_dtime?: any | null
      cancellation_reason?: number | null
      card_last_4?: string | null
      cycle_end_dtime?: any | null
      cycle_start_dtime?: any | null
      is_canceled_at_cycle_end?: boolean | null
      is_delinquent?: boolean | null
      paused_until_dtime?: any | null
      trial_type?: number | null
      trial_end_dtime?: any | null
      payment_intent_needing_action_id?: string | null
      subscription_plan?: {
        __typename?: "SubscriptionPlan"
        id?: number | null
        name?: string | null
        amount?: number | null
        interval?: number | null
        trial_period_days?: number | null
        trial_type?: number | null
        plan_type?: string | null
        stripe_connected_account_url?: string | null
      } | null
      customer?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
    } | null
    community_group?: {
      __typename?: "MentorGroup"
      id?: number | null
      type?: number | null
      slug?: string | null
      name?: string | null
      description?: string | null
      created?: any | null
      modified?: any | null
      parent_id?: number | null
      has_child_groups?: boolean | null
      seat_limit?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      owner?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      permissions?: {
        __typename?: "MentorGroupPermissions"
        can_add_member?: boolean | null
        can_add_moderator?: boolean | null
        can_add_admin?: boolean | null
        can_add_group?: boolean | null
        can_edit_group?: boolean | null
        can_change_parent?: boolean | null
        can_edit_subscription?: boolean | null
        can_delete_group?: boolean | null
        can_update_member_review_permission?: boolean | null
        can_update_moderator_review_permission?: boolean | null
        can_update_admin_review_permission?: boolean | null
      } | null
    } | null
  } | null
}

export type SchoolGroupSubscriptionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars["Int"]["input"]>
  licenseOfferingId?: InputMaybe<Scalars["Int"]["input"]>
}>

export type SchoolGroupSubscriptionsQuery = {
  __typename?: "Query"
  schoolGroupSubscriptions?: {
    __typename?: "SchoolGroupSubscriptionConnection"
    edges?: Array<{
      __typename?: "SchoolGroupSubscriptionEdge"
      node?: {
        __typename?: "SchoolGroupSubscription"
        id?: number | null
        price?: {
          __typename?: "StripePrice"
          id: number
          active?: boolean | null
          billing_scheme?: StripeBillingScheme | null
          currency?: string | null
          nickname?: string | null
          recurring_interval?: StripeRecurringInterval | null
          recurring_interval_count?: number | null
          stripe_price_id?: string | null
          stripe_connected_account_url?: string | null
          tiers_mode?: StripeTiersMode | null
          unit_amount_decimal?: number | null
          product?: {
            __typename?: "StripeProduct"
            id: number
            min_quantity?: number | null
            max_quantity?: number | null
            active?: boolean | null
            name?: string | null
            description?: string | null
            images?: Array<string | null> | null
            unit_label?: string | null
            stripe_product_id?: string | null
            stripe_connected_account_url?: string | null
          } | null
          tiers?: Array<{
            __typename?: "StripeTier"
            up_to?: number | null
            flat_amount?: number | null
            flat_amount_decimal?: string | null
            unit_amount?: number | null
            unit_amount_decimal?: string | null
          } | null> | null
        } | null
        user?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
        subscription?: {
          __typename?: "Subscription"
          id?: number | null
          quantity?: number | null
          canceled_dtime?: any | null
          cancellation_reason?: number | null
          card_last_4?: string | null
          cycle_end_dtime?: any | null
          cycle_start_dtime?: any | null
          is_canceled_at_cycle_end?: boolean | null
          is_delinquent?: boolean | null
          paused_until_dtime?: any | null
          trial_type?: number | null
          trial_end_dtime?: any | null
          payment_intent_needing_action_id?: string | null
          subscription_plan?: {
            __typename?: "SubscriptionPlan"
            id?: number | null
            name?: string | null
            amount?: number | null
            interval?: number | null
            trial_period_days?: number | null
            trial_type?: number | null
            plan_type?: string | null
            stripe_connected_account_url?: string | null
          } | null
          customer?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
        } | null
        community_group?: {
          __typename?: "MentorGroup"
          id?: number | null
          type?: number | null
          slug?: string | null
          name?: string | null
          description?: string | null
          created?: any | null
          modified?: any | null
          parent_id?: number | null
          has_child_groups?: boolean | null
          seat_limit?: number | null
          seats_filled?: number | null
          seats_available?: number | null
          owner?: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          } | null
          permissions?: {
            __typename?: "MentorGroupPermissions"
            can_add_member?: boolean | null
            can_add_moderator?: boolean | null
            can_add_admin?: boolean | null
            can_add_group?: boolean | null
            can_edit_group?: boolean | null
            can_change_parent?: boolean | null
            can_edit_subscription?: boolean | null
            can_delete_group?: boolean | null
            can_update_member_review_permission?: boolean | null
            can_update_moderator_review_permission?: boolean | null
            can_update_admin_review_permission?: boolean | null
          } | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type SchoolSubscriptionFragment = {
  __typename?: "SchoolSubscription"
  id?: number | null
  user?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
  subscription?: {
    __typename?: "Subscription"
    id?: number | null
    quantity?: number | null
    canceled_dtime?: any | null
    cancellation_reason?: number | null
    card_last_4?: string | null
    cycle_end_dtime?: any | null
    cycle_start_dtime?: any | null
    is_canceled_at_cycle_end?: boolean | null
    is_delinquent?: boolean | null
    paused_until_dtime?: any | null
    trial_type?: number | null
    trial_end_dtime?: any | null
    payment_intent_needing_action_id?: string | null
    subscription_plan?: {
      __typename?: "SubscriptionPlan"
      id?: number | null
      name?: string | null
      amount?: number | null
      interval?: number | null
      trial_period_days?: number | null
      trial_type?: number | null
      plan_type?: string | null
      stripe_connected_account_url?: string | null
    } | null
    customer?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
  } | null
  subscription_plan?: {
    __typename?: "SubscriptionPlan"
    id?: number | null
    name?: string | null
    amount?: number | null
    interval?: number | null
    trial_period_days?: number | null
    trial_type?: number | null
    plan_type?: string | null
    stripe_connected_account_url?: string | null
  } | null
  school_subscription_plan?: {
    __typename?: "SchoolSubscriptionPlan"
    id?: number | null
    image?: string | null
    details_html?: string | null
    subscribe_complete_html?: string | null
    catalog_header?: string | null
    is_visible?: boolean | null
    giftable_cycles?: Array<number | null> | null
    subscription_plan?: {
      __typename?: "SubscriptionPlan"
      id?: number | null
      name?: string | null
      amount?: number | null
      interval?: number | null
      trial_period_days?: number | null
      trial_type?: number | null
      plan_type?: string | null
      stripe_connected_account_url?: string | null
    } | null
  } | null
}

export type SchoolSubscriptionPlanFragment = {
  __typename?: "SchoolSubscriptionPlan"
  id?: number | null
  image?: string | null
  details_html?: string | null
  subscribe_complete_html?: string | null
  catalog_header?: string | null
  is_visible?: boolean | null
  giftable_cycles?: Array<number | null> | null
  subscription_plan?: {
    __typename?: "SubscriptionPlan"
    id?: number | null
    name?: string | null
    amount?: number | null
    interval?: number | null
    trial_period_days?: number | null
    trial_type?: number | null
    plan_type?: string | null
    stripe_connected_account_url?: string | null
  } | null
}

export type SchoolSubscriptionPlansQueryVariables = Exact<{
  ids?: InputMaybe<IdFilter>
  visibility_code?: InputMaybe<Scalars["String"]["input"]>
  visibility_code_filter?: InputMaybe<StringFilter>
  ignore_visibility?: InputMaybe<Scalars["Boolean"]["input"]>
  giftable?: InputMaybe<Scalars["Boolean"]["input"]>
  interval?: InputMaybe<SubscriptionIntervalType>
  intervalFilter?: InputMaybe<SubscriptionIntervalFilter>
  positioningContext?: InputMaybe<PositioningContextInput>
  orderBy?: InputMaybe<
    | Array<InputMaybe<SchoolSubscriptionPlanOrderByInput>>
    | InputMaybe<SchoolSubscriptionPlanOrderByInput>
  >
}>

export type SchoolSubscriptionPlansQuery = {
  __typename?: "Query"
  school?: {
    __typename?: "School"
    id: number
    url?: string | null
    name: string
    about?: string | null
    email?: string | null
    website?: string | null
    subdomain: string
    created?: any | null
    billing_model?: number | null
    platform_version?: number | null
    currency_code?: string | null
    ietf_language_tag?: string | null
    has_certificate?: boolean | null
    is_activated?: boolean | null
    is_curriculum_enabled?: boolean | null
    is_curriculum_subscriber?: boolean | null
    stripe_access_token?: string | null
    stripe_publishable_api_key?: string | null
    show_stripe_reconnect?: boolean | null
    payment_requires_zip_code?: boolean | null
    consent_description?: string | null
    image?: string | null
    grant_access_upon_authentication?: boolean | null
    pathwright_login_enabled?: boolean | null
    subscription_plans?: {
      __typename?: "SchoolSubscriptionPlanConnection"
      total: number
      pageInfo: {
        __typename?: "PageInfo"
        endCursor?: string | null
        hasNextPage: boolean
      }
      edges?: Array<{
        __typename?: "SchoolSubscriptionPlanEdge"
        node?: {
          __typename?: "SchoolSubscriptionPlan"
          position: string
          id?: number | null
          image?: string | null
          details_html?: string | null
          subscribe_complete_html?: string | null
          catalog_header?: string | null
          is_visible?: boolean | null
          giftable_cycles?: Array<number | null> | null
          subscription_plan?: {
            __typename?: "SubscriptionPlan"
            id?: number | null
            name?: string | null
            amount?: number | null
            interval?: number | null
            trial_period_days?: number | null
            trial_type?: number | null
            plan_type?: string | null
            stripe_connected_account_url?: string | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type PositionedSchoolSubscriptionPlanFragment = {
  __typename?: "SchoolSubscriptionPlan"
  position: string
  id?: number | null
  image?: string | null
  details_html?: string | null
  subscribe_complete_html?: string | null
  catalog_header?: string | null
  is_visible?: boolean | null
  giftable_cycles?: Array<number | null> | null
  subscription_plan?: {
    __typename?: "SubscriptionPlan"
    id?: number | null
    name?: string | null
    amount?: number | null
    interval?: number | null
    trial_period_days?: number | null
    trial_type?: number | null
    plan_type?: string | null
    stripe_connected_account_url?: string | null
  } | null
}

export type SendGiftSubscriptionEmailMutationVariables = Exact<{
  gift_id: Scalars["Int"]["input"]
  recipient_email: Scalars["String"]["input"]
}>

export type SendGiftSubscriptionEmailMutation = {
  __typename?: "Mutations"
  sendGiftSubscriptionEmail?: boolean | null
}

export type SubscriptionDiscountQueryVariables = Exact<{
  discount_code: Scalars["String"]["input"]
  school_plan_id: Scalars["Int"]["input"]
}>

export type SubscriptionDiscountQuery = {
  __typename?: "Query"
  schoolSubscriptionDiscount?: {
    __typename?: "SchoolSubscriptionDiscount"
    discount_percent?: number | null
    discounted_price?: number | null
    discounted_subscription_cycles?: number | null
    currency_display_discount_price?: string | null
    currency_display_discount_amount?: string | null
  } | null
}

export type SubscriptionFragment = {
  __typename?: "Subscription"
  id?: number | null
  quantity?: number | null
  canceled_dtime?: any | null
  cancellation_reason?: number | null
  card_last_4?: string | null
  cycle_end_dtime?: any | null
  cycle_start_dtime?: any | null
  is_canceled_at_cycle_end?: boolean | null
  is_delinquent?: boolean | null
  paused_until_dtime?: any | null
  trial_type?: number | null
  trial_end_dtime?: any | null
  payment_intent_needing_action_id?: string | null
  subscription_plan?: {
    __typename?: "SubscriptionPlan"
    id?: number | null
    name?: string | null
    amount?: number | null
    interval?: number | null
    trial_period_days?: number | null
    trial_type?: number | null
    plan_type?: string | null
    stripe_connected_account_url?: string | null
  } | null
  customer?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type SubscriptionPlanFragment = {
  __typename?: "SubscriptionPlan"
  id?: number | null
  name?: string | null
  amount?: number | null
  interval?: number | null
  trial_period_days?: number | null
  trial_type?: number | null
  plan_type?: string | null
  stripe_connected_account_url?: string | null
}

export type SubscriptionQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type SubscriptionQuery = {
  __typename?: "Query"
  subscription?: {
    __typename?: "Subscription"
    payment_intent_client_secret?: string | null
    stripe_publishable_api_key?: string | null
    id?: number | null
    quantity?: number | null
    canceled_dtime?: any | null
    cancellation_reason?: number | null
    card_last_4?: string | null
    cycle_end_dtime?: any | null
    cycle_start_dtime?: any | null
    is_canceled_at_cycle_end?: boolean | null
    is_delinquent?: boolean | null
    paused_until_dtime?: any | null
    trial_type?: number | null
    trial_end_dtime?: any | null
    payment_intent_needing_action_id?: string | null
    subscription_plan?: {
      __typename?: "SubscriptionPlan"
      id?: number | null
      name?: string | null
      amount?: number | null
      interval?: number | null
      trial_period_days?: number | null
      trial_type?: number | null
      plan_type?: string | null
      stripe_connected_account_url?: string | null
    } | null
    customer?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
  } | null
}

export type SubscriptionsQueryVariables = Exact<{
  paymentIntentNeedingActionIdFilter?: InputMaybe<IdFilter>
}>

export type SubscriptionsQuery = {
  __typename?: "Query"
  subscriptions?: {
    __typename?: "SubscriptionConnection"
    total: number
    pageInfo: {
      __typename?: "PageInfo"
      endCursor?: string | null
      hasNextPage: boolean
    }
    edges?: Array<{
      __typename?: "SubscriptionEdge"
      node?: {
        __typename?: "Subscription"
        id?: number | null
        quantity?: number | null
        canceled_dtime?: any | null
        cancellation_reason?: number | null
        card_last_4?: string | null
        cycle_end_dtime?: any | null
        cycle_start_dtime?: any | null
        is_canceled_at_cycle_end?: boolean | null
        is_delinquent?: boolean | null
        paused_until_dtime?: any | null
        trial_type?: number | null
        trial_end_dtime?: any | null
        payment_intent_needing_action_id?: string | null
        subscription_plan?: {
          __typename?: "SubscriptionPlan"
          id?: number | null
          name?: string | null
          amount?: number | null
          interval?: number | null
          trial_period_days?: number | null
          trial_type?: number | null
          plan_type?: string | null
          stripe_connected_account_url?: string | null
        } | null
        customer?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
      } | null
    } | null> | null
  } | null
}

export type TagAttachmentFragment = {
  __typename?: "TagAttachment"
  id?: number | null
  position?: string | null
  resource_id?: number | null
}

export type TagFragment = {
  __typename?: "Tag"
  id?: number | null
  name?: string | null
  slug?: string | null
  description?: string | null
  color?: string | null
}

export type TagLinkFragment = {
  __typename?: "TagLink"
  id?: number | null
  tag_id?: number | null
  discussion_context_id?: number | null
}

export type TranslationFragment = {
  __typename?: "Translation"
  id?: number | null
  name?: string | null
  language?: string | null
  translation?: any | null
  master_translation?: any | null
  is_default?: boolean | null
}

export type HomeCohortMembersFragment = {
  __typename?: "Group"
  id: number
  name: string
  user_registration?: {
    __typename?: "Registration"
    id: number
    user: {
      __typename?: "User"
      id: number
      first_name: string
      last_name: string
      full_name: string
      profile?: {
        __typename?: "Profile"
        id?: number | null
        image?: string | null
      } | null
    }
  } | null
  registrations?: {
    __typename?: "RegistrationConnection"
    total: number
    edges?: Array<{
      __typename?: "RegistrationEdge"
      node?: {
        __typename?: "Registration"
        id: number
        user: {
          __typename?: "User"
          id: number
          first_name: string
          last_name: string
          full_name: string
          profile?: {
            __typename?: "Profile"
            id?: number | null
            image?: string | null
          } | null
        }
      } | null
    } | null> | null
  } | null
}

export type HomeCohortMembersQueryVariables = Exact<{
  groupId: Scalars["Int"]["input"]
}>

export type HomeCohortMembersQuery = {
  __typename?: "Query"
  group?: {
    __typename?: "Group"
    id: number
    name: string
    user_registration?: {
      __typename?: "Registration"
      id: number
      user: {
        __typename?: "User"
        id: number
        first_name: string
        last_name: string
        full_name: string
        profile?: {
          __typename?: "Profile"
          id?: number | null
          image?: string | null
        } | null
      }
    } | null
    registrations?: {
      __typename?: "RegistrationConnection"
      total: number
      edges?: Array<{
        __typename?: "RegistrationEdge"
        node?: {
          __typename?: "Registration"
          id: number
          user: {
            __typename?: "User"
            id: number
            first_name: string
            last_name: string
            full_name: string
            profile?: {
              __typename?: "Profile"
              id?: number | null
              image?: string | null
            } | null
          }
        } | null
      } | null> | null
    } | null
  } | null
}

export type HomeMentorGroupsMembershipsQueryVariables = Exact<{
  [key: string]: never
}>

export type HomeMentorGroupsMembershipsQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    mentorGroupMemberships?: {
      __typename?: "MentorGroupMembershipConnection"
      total: number
      edges?: Array<{
        __typename?: "MentorGroupMembershipEdge"
        node?: {
          __typename?: "MentorGroupMembership"
          id: number
          role: number
          group_id: number
        } | null
      } | null> | null
    } | null
  } | null
}

export type HomeRegistrationsQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  positioningContext?: InputMaybe<PositioningContextInput>
  orderBy?: InputMaybe<
    | Array<InputMaybe<RegistrationOrderByInput>>
    | InputMaybe<RegistrationOrderByInput>
  >
  softArchived?: InputMaybe<DateFilter>
  progressFilter?: InputMaybe<ProgressFilter>
  lastSeen?: InputMaybe<DateFilter>
}>

export type HomeRegistrationsQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    registrations?: {
      __typename?: "RegistrationConnection"
      edges?: Array<{
        __typename?: "RegistrationEdge"
        node?: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          softArchivedTime?: any | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          position: string
          user: {
            __typename?: "User"
            id: number
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              image?: string | null
            } | null
          }
          resource: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
            groups?: { __typename?: "GroupConnection"; total: number } | null
          }
          group: {
            __typename?: "Group"
            id: number
            name: string
            created?: any | null
            description?: string | null
            price?: number | null
            seats?: number | null
            seats_filled?: number | null
            seats_available?: number | null
            registration_ends?: any | null
            registration_starts?: any | null
            registration_started?: boolean | null
            registration_ended?: boolean | null
            access_ends?: any | null
            access_starts?: any | null
            is_master?: boolean | null
            is_source_cohort?: boolean | null
            source_cohort_id?: number | null
            parent_section_id?: number | null
            resource_id?: number | null
            visibility?: number | null
            is_collection_linked?: boolean | null
            is_subscription_only?: boolean | null
            status: GroupStatus
            analytics_disabled?: boolean | null
            created_by_id?: number | null
            user_registration?: {
              __typename?: "Registration"
              id: number
              role: number
              path_id?: number | null
            } | null
            user_source_registration?: {
              __typename?: "Registration"
              id: number
              role: number
            } | null
          }
          path?: {
            __typename?: "Path"
            id: number
            progress?: number | null
            completion_date?: any | null
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type HomeResourceCopyConfigLinkConnectionsQueryVariables = Exact<{
  first: Scalars["Int"]["input"]
  copiedTimeDateFilter?: InputMaybe<DateFilter>
  hideFromLocationsFilter?: InputMaybe<
    | Array<InputMaybe<ResourceCopyConfigLinkLocationFilter>>
    | InputMaybe<ResourceCopyConfigLinkLocationFilter>
  >
}>

export type HomeResourceCopyConfigLinkConnectionsQuery = {
  __typename?: "Query"
  resourceCopyConfigLinkConnections?: {
    __typename?: "ResourceCopyConfigLinkConnection"
    edges?: Array<{
      __typename?: "ResourceCopyConfigLinkEdge"
      node?: {
        __typename?: "ResourceCopyConfigLink"
        id: number
        createdTime: any
        copiedTime?: any | null
        resourceId?: number | null
        cohortId?: number | null
        copierRegistrationId?: number | null
        hideFromLocations?: any | null
        copierRegistration?: {
          __typename?: "Registration"
          id: number
          role: number
          completion_state?: number | null
          send_due_notifications?: boolean | null
          send_discussion_notifications?: boolean | null
          softArchivedTime?: any | null
          last_activity_time?: any | null
          expiration_dtime?: any | null
          created?: any | null
          position: string
          user: {
            __typename?: "User"
            id: number
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              image?: string | null
            } | null
          }
          resource: {
            __typename?: "Resource"
            id: number
            name: string
            slug: string
            created?: any | null
            resource_type: number
            visibility?: number | null
            description?: string | null
            short_description?: string | null
            background_overlay?: string | null
            background_image?: string | null
            background_type: ResourceBackgroundType
            image_raw?: string | null
            has_certificate?: boolean | null
            discussion_enabled?: boolean | null
            lowest_public_offering_price?: number | null
            highest_public_offering_price?: number | null
            licensed_from_resource_id?: number | null
            licensed_from_school_id?: number | null
            created_by_id?: number | null
            copied_with_copy_config_id?: number | null
            image: string
            cover_image: string
            groups?: { __typename?: "GroupConnection"; total: number } | null
          }
          group: {
            __typename?: "Group"
            id: number
            name: string
            created?: any | null
            description?: string | null
            price?: number | null
            seats?: number | null
            seats_filled?: number | null
            seats_available?: number | null
            registration_ends?: any | null
            registration_starts?: any | null
            registration_started?: boolean | null
            registration_ended?: boolean | null
            access_ends?: any | null
            access_starts?: any | null
            is_master?: boolean | null
            is_source_cohort?: boolean | null
            source_cohort_id?: number | null
            parent_section_id?: number | null
            resource_id?: number | null
            visibility?: number | null
            is_collection_linked?: boolean | null
            is_subscription_only?: boolean | null
            status: GroupStatus
            analytics_disabled?: boolean | null
            created_by_id?: number | null
            user_registration?: {
              __typename?: "Registration"
              id: number
              role: number
              path_id?: number | null
            } | null
            user_source_registration?: {
              __typename?: "Registration"
              id: number
              role: number
            } | null
          }
          path?: {
            __typename?: "Path"
            id: number
            progress?: number | null
            completion_date?: any | null
          } | null
        } | null
        resourceCopyConfig: {
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          children?: Array<{
            __typename?: "ResourceCopyConfig"
            id: number
            name?: string | null
            lookup_key: string
            copy_behavior: ResourceCopyConfigCopyBehavior
            allow_copy_via_link: boolean
            children?: Array<{
              __typename?: "ResourceCopyConfig"
              id: number
              name?: string | null
              lookup_key: string
              copy_behavior: ResourceCopyConfigCopyBehavior
              allow_copy_via_link: boolean
              children?: Array<{
                __typename?: "ResourceCopyConfig"
                id: number
                name?: string | null
                lookup_key: string
                copy_behavior: ResourceCopyConfigCopyBehavior
                allow_copy_via_link: boolean
                resource?: {
                  __typename?: "ResourceCopyConfigResource"
                  id: number
                  meta: {
                    __typename?: "NodeMeta"
                    id: string
                    type: string
                    key: string
                    title?: string | null
                    image?: {
                      __typename?: "NodeImage"
                      src?: string | null
                    } | null
                  }
                } | null
              } | null> | null
              resource?: {
                __typename?: "ResourceCopyConfigResource"
                id: number
                meta: {
                  __typename?: "NodeMeta"
                  id: string
                  type: string
                  key: string
                  title?: string | null
                  image?: {
                    __typename?: "NodeImage"
                    src?: string | null
                  } | null
                }
              } | null
            } | null> | null
            resource?: {
              __typename?: "ResourceCopyConfigResource"
              id: number
              meta: {
                __typename?: "NodeMeta"
                id: string
                type: string
                key: string
                title?: string | null
                image?: { __typename?: "NodeImage"; src?: string | null } | null
              }
            } | null
          } | null> | null
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        }
      } | null
    } | null> | null
  } | null
}

export type HomeResourceCopyConfigLinkRegistrationQueryVariables = Exact<{
  id: Scalars["Int"]["input"]
}>

export type HomeResourceCopyConfigLinkRegistrationQuery = {
  __typename?: "Query"
  resourceCopyConfigLink?: {
    __typename?: "ResourceCopyConfigLink"
    id: number
    createdTime: any
    copiedTime?: any | null
    resourceId?: number | null
    cohortId?: number | null
    copierRegistrationId?: number | null
    hideFromLocations?: any | null
    copierRegistration?: {
      __typename?: "Registration"
      id: number
      role: number
      completion_state?: number | null
      send_due_notifications?: boolean | null
      send_discussion_notifications?: boolean | null
      softArchivedTime?: any | null
      last_activity_time?: any | null
      expiration_dtime?: any | null
      created?: any | null
      position: string
      user: {
        __typename?: "User"
        id: number
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          image?: string | null
        } | null
      }
      resource: {
        __typename?: "Resource"
        id: number
        name: string
        slug: string
        created?: any | null
        resource_type: number
        visibility?: number | null
        description?: string | null
        short_description?: string | null
        background_overlay?: string | null
        background_image?: string | null
        background_type: ResourceBackgroundType
        image_raw?: string | null
        has_certificate?: boolean | null
        discussion_enabled?: boolean | null
        lowest_public_offering_price?: number | null
        highest_public_offering_price?: number | null
        licensed_from_resource_id?: number | null
        licensed_from_school_id?: number | null
        created_by_id?: number | null
        copied_with_copy_config_id?: number | null
        image: string
        cover_image: string
        groups?: { __typename?: "GroupConnection"; total: number } | null
      }
      group: {
        __typename?: "Group"
        id: number
        name: string
        created?: any | null
        description?: string | null
        price?: number | null
        seats?: number | null
        seats_filled?: number | null
        seats_available?: number | null
        registration_ends?: any | null
        registration_starts?: any | null
        registration_started?: boolean | null
        registration_ended?: boolean | null
        access_ends?: any | null
        access_starts?: any | null
        is_master?: boolean | null
        is_source_cohort?: boolean | null
        source_cohort_id?: number | null
        parent_section_id?: number | null
        resource_id?: number | null
        visibility?: number | null
        is_collection_linked?: boolean | null
        is_subscription_only?: boolean | null
        status: GroupStatus
        analytics_disabled?: boolean | null
        created_by_id?: number | null
        user_registration?: {
          __typename?: "Registration"
          id: number
          role: number
          path_id?: number | null
        } | null
        user_source_registration?: {
          __typename?: "Registration"
          id: number
          role: number
        } | null
      }
      path?: {
        __typename?: "Path"
        id: number
        progress?: number | null
        completion_date?: any | null
      } | null
    } | null
    resourceCopyConfig: {
      __typename?: "ResourceCopyConfig"
      id: number
      name?: string | null
      lookup_key: string
      copy_behavior: ResourceCopyConfigCopyBehavior
      allow_copy_via_link: boolean
      children?: Array<{
        __typename?: "ResourceCopyConfig"
        id: number
        name?: string | null
        lookup_key: string
        copy_behavior: ResourceCopyConfigCopyBehavior
        allow_copy_via_link: boolean
        children?: Array<{
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          children?: Array<{
            __typename?: "ResourceCopyConfig"
            id: number
            name?: string | null
            lookup_key: string
            copy_behavior: ResourceCopyConfigCopyBehavior
            allow_copy_via_link: boolean
            resource?: {
              __typename?: "ResourceCopyConfigResource"
              id: number
              meta: {
                __typename?: "NodeMeta"
                id: string
                type: string
                key: string
                title?: string | null
                image?: { __typename?: "NodeImage"; src?: string | null } | null
              }
            } | null
          } | null> | null
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        } | null> | null
        resource?: {
          __typename?: "ResourceCopyConfigResource"
          id: number
          meta: {
            __typename?: "NodeMeta"
            id: string
            type: string
            key: string
            title?: string | null
            image?: { __typename?: "NodeImage"; src?: string | null } | null
          }
        } | null
      } | null> | null
      resource?: {
        __typename?: "ResourceCopyConfigResource"
        id: number
        meta: {
          __typename?: "NodeMeta"
          id: string
          type: string
          key: string
          title?: string | null
          image?: { __typename?: "NodeImage"; src?: string | null } | null
        }
      } | null
    }
  } | null
}

export type HomeResourceGroupsQueryVariables = Exact<{
  resourceId?: InputMaybe<Scalars["Int"]["input"]>
}>

export type HomeResourceGroupsQuery = {
  __typename?: "Query"
  resource?: {
    __typename?: "Resource"
    groups?: {
      __typename?: "GroupConnection"
      total: number
      edges?: Array<{
        __typename?: "GroupEdge"
        group?: {
          __typename?: "Group"
          id: number
          name: string
          created?: any | null
          description?: string | null
          price?: number | null
          seats?: number | null
          seats_filled?: number | null
          seats_available?: number | null
          registration_ends?: any | null
          registration_starts?: any | null
          registration_started?: boolean | null
          registration_ended?: boolean | null
          access_ends?: any | null
          access_starts?: any | null
          is_master?: boolean | null
          is_source_cohort?: boolean | null
          source_cohort_id?: number | null
          parent_section_id?: number | null
          resource_id?: number | null
          visibility?: number | null
          is_collection_linked?: boolean | null
          is_subscription_only?: boolean | null
          status: GroupStatus
          analytics_disabled?: boolean | null
          created_by_id?: number | null
          user_registration?: {
            __typename?: "Registration"
            id: number
            role: number
            path_id?: number | null
          } | null
          user_source_registration?: {
            __typename?: "Registration"
            id: number
            role: number
          } | null
        } | null
      } | null> | null
    } | null
  } | null
}

export type InboxPendingReviewCountsQueryVariables = Exact<{
  targetIds: IntFilter
  targetType: InboxPendingReviewTarget
}>

export type InboxPendingReviewCountsQuery = {
  __typename?: "Query"
  inboxPendingReviewConnections?: {
    __typename?: "InboxPendingReviewConnection"
    edges?: Array<{
      __typename?: "InboxPendingReviewEdge"
      node?: {
        __typename?: "InboxPendingReview"
        id?: number | null
        count?: number | null
      } | null
    } | null> | null
  } | null
}

export type PathwrightIntercomGuidanceTeamMembersQueryVariables = Exact<{
  [key: string]: never
}>

export type PathwrightIntercomGuidanceTeamMembersQuery = {
  __typename?: "Query"
  integrations?: {
    __typename?: "Integrations"
    intercom?: {
      __typename?: "IntercomIntegration"
      team?: Array<{
        __typename?: "IntercomTeamMember"
        id: number
        name: string
        avatar?: string | null
      }> | null
    } | null
  } | null
}

export type SoftArchiveRegistrationMutationVariables = Exact<{
  id: Scalars["Int"]["input"]
  softArchive?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type SoftArchiveRegistrationMutation = {
  __typename?: "Mutations"
  softArchiveRegistration?: {
    __typename?: "Registration"
    id: number
    role: number
    completion_state?: number | null
    send_due_notifications?: boolean | null
    send_discussion_notifications?: boolean | null
    softArchivedTime?: any | null
    last_activity_time?: any | null
    expiration_dtime?: any | null
    created?: any | null
    position: string
    user: {
      __typename?: "User"
      id: number
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        image?: string | null
      } | null
    }
    resource: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      groups?: { __typename?: "GroupConnection"; total: number } | null
    }
    group: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        path_id?: number | null
      } | null
      user_source_registration?: {
        __typename?: "Registration"
        id: number
        role: number
      } | null
    }
    path?: {
      __typename?: "Path"
      id: number
      progress?: number | null
      completion_date?: any | null
    } | null
  } | null
}

export type UpdateUserMutationVariables = Exact<{
  user: UserInput
  profile: UserProfileInput
}>

export type UpdateUserMutation = {
  __typename?: "Mutations"
  updateUser?: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  } | null
}

export type GroupListItemRegistrationFragment = {
  __typename?: "Registration"
  id: number
  user: {
    __typename?: "User"
    id: number
    first_name: string
    last_name: string
    full_name: string
    profile?: {
      __typename?: "Profile"
      id?: number | null
      image?: string | null
    } | null
  }
}

export type GroupListItemFragment = {
  __typename?: "Group"
  id: number
  name: string
  registrations?: {
    __typename?: "RegistrationConnection"
    total: number
    edges?: Array<{
      __typename?: "RegistrationEdge"
      node?: {
        __typename?: "Registration"
        id: number
        user: {
          __typename?: "User"
          id: number
          first_name: string
          last_name: string
          full_name: string
          profile?: {
            __typename?: "Profile"
            id?: number | null
            image?: string | null
          } | null
        }
      } | null
    } | null> | null
  } | null
}

export type HomeGroupFragment = {
  __typename?: "Group"
  id: number
  name: string
  created?: any | null
  description?: string | null
  price?: number | null
  seats?: number | null
  seats_filled?: number | null
  seats_available?: number | null
  registration_ends?: any | null
  registration_starts?: any | null
  registration_started?: boolean | null
  registration_ended?: boolean | null
  access_ends?: any | null
  access_starts?: any | null
  is_master?: boolean | null
  is_source_cohort?: boolean | null
  source_cohort_id?: number | null
  parent_section_id?: number | null
  resource_id?: number | null
  visibility?: number | null
  is_collection_linked?: boolean | null
  is_subscription_only?: boolean | null
  status: GroupStatus
  analytics_disabled?: boolean | null
  created_by_id?: number | null
  user_registration?: {
    __typename?: "Registration"
    id: number
    role: number
    path_id?: number | null
  } | null
  user_source_registration?: {
    __typename?: "Registration"
    id: number
    role: number
  } | null
}

export type HomeRegistrationFragment = {
  __typename?: "Registration"
  id: number
  role: number
  completion_state?: number | null
  send_due_notifications?: boolean | null
  send_discussion_notifications?: boolean | null
  softArchivedTime?: any | null
  last_activity_time?: any | null
  expiration_dtime?: any | null
  created?: any | null
  position: string
  user: {
    __typename?: "User"
    id: number
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      image?: string | null
    } | null
  }
  resource: {
    __typename?: "Resource"
    id: number
    name: string
    slug: string
    created?: any | null
    resource_type: number
    visibility?: number | null
    description?: string | null
    short_description?: string | null
    background_overlay?: string | null
    background_image?: string | null
    background_type: ResourceBackgroundType
    image_raw?: string | null
    has_certificate?: boolean | null
    discussion_enabled?: boolean | null
    lowest_public_offering_price?: number | null
    highest_public_offering_price?: number | null
    licensed_from_resource_id?: number | null
    licensed_from_school_id?: number | null
    created_by_id?: number | null
    copied_with_copy_config_id?: number | null
    image: string
    cover_image: string
    groups?: { __typename?: "GroupConnection"; total: number } | null
  }
  group: {
    __typename?: "Group"
    id: number
    name: string
    created?: any | null
    description?: string | null
    price?: number | null
    seats?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    registration_ends?: any | null
    registration_starts?: any | null
    registration_started?: boolean | null
    registration_ended?: boolean | null
    access_ends?: any | null
    access_starts?: any | null
    is_master?: boolean | null
    is_source_cohort?: boolean | null
    source_cohort_id?: number | null
    parent_section_id?: number | null
    resource_id?: number | null
    visibility?: number | null
    is_collection_linked?: boolean | null
    is_subscription_only?: boolean | null
    status: GroupStatus
    analytics_disabled?: boolean | null
    created_by_id?: number | null
    user_registration?: {
      __typename?: "Registration"
      id: number
      role: number
      path_id?: number | null
    } | null
    user_source_registration?: {
      __typename?: "Registration"
      id: number
      role: number
    } | null
  }
  path?: {
    __typename?: "Path"
    id: number
    progress?: number | null
    completion_date?: any | null
  } | null
}

export type HomeResourceCopyConfigLinkFragment = {
  __typename?: "ResourceCopyConfigLink"
  id: number
  createdTime: any
  copiedTime?: any | null
  resourceId?: number | null
  cohortId?: number | null
  copierRegistrationId?: number | null
  hideFromLocations?: any | null
  copierRegistration?: {
    __typename?: "Registration"
    id: number
    role: number
    completion_state?: number | null
    send_due_notifications?: boolean | null
    send_discussion_notifications?: boolean | null
    softArchivedTime?: any | null
    last_activity_time?: any | null
    expiration_dtime?: any | null
    created?: any | null
    position: string
    user: {
      __typename?: "User"
      id: number
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        image?: string | null
      } | null
    }
    resource: {
      __typename?: "Resource"
      id: number
      name: string
      slug: string
      created?: any | null
      resource_type: number
      visibility?: number | null
      description?: string | null
      short_description?: string | null
      background_overlay?: string | null
      background_image?: string | null
      background_type: ResourceBackgroundType
      image_raw?: string | null
      has_certificate?: boolean | null
      discussion_enabled?: boolean | null
      lowest_public_offering_price?: number | null
      highest_public_offering_price?: number | null
      licensed_from_resource_id?: number | null
      licensed_from_school_id?: number | null
      created_by_id?: number | null
      copied_with_copy_config_id?: number | null
      image: string
      cover_image: string
      groups?: { __typename?: "GroupConnection"; total: number } | null
    }
    group: {
      __typename?: "Group"
      id: number
      name: string
      created?: any | null
      description?: string | null
      price?: number | null
      seats?: number | null
      seats_filled?: number | null
      seats_available?: number | null
      registration_ends?: any | null
      registration_starts?: any | null
      registration_started?: boolean | null
      registration_ended?: boolean | null
      access_ends?: any | null
      access_starts?: any | null
      is_master?: boolean | null
      is_source_cohort?: boolean | null
      source_cohort_id?: number | null
      parent_section_id?: number | null
      resource_id?: number | null
      visibility?: number | null
      is_collection_linked?: boolean | null
      is_subscription_only?: boolean | null
      status: GroupStatus
      analytics_disabled?: boolean | null
      created_by_id?: number | null
      user_registration?: {
        __typename?: "Registration"
        id: number
        role: number
        path_id?: number | null
      } | null
      user_source_registration?: {
        __typename?: "Registration"
        id: number
        role: number
      } | null
    }
    path?: {
      __typename?: "Path"
      id: number
      progress?: number | null
      completion_date?: any | null
    } | null
  } | null
  resourceCopyConfig: {
    __typename?: "ResourceCopyConfig"
    id: number
    name?: string | null
    lookup_key: string
    copy_behavior: ResourceCopyConfigCopyBehavior
    allow_copy_via_link: boolean
    children?: Array<{
      __typename?: "ResourceCopyConfig"
      id: number
      name?: string | null
      lookup_key: string
      copy_behavior: ResourceCopyConfigCopyBehavior
      allow_copy_via_link: boolean
      children?: Array<{
        __typename?: "ResourceCopyConfig"
        id: number
        name?: string | null
        lookup_key: string
        copy_behavior: ResourceCopyConfigCopyBehavior
        allow_copy_via_link: boolean
        children?: Array<{
          __typename?: "ResourceCopyConfig"
          id: number
          name?: string | null
          lookup_key: string
          copy_behavior: ResourceCopyConfigCopyBehavior
          allow_copy_via_link: boolean
          resource?: {
            __typename?: "ResourceCopyConfigResource"
            id: number
            meta: {
              __typename?: "NodeMeta"
              id: string
              type: string
              key: string
              title?: string | null
              image?: { __typename?: "NodeImage"; src?: string | null } | null
            }
          } | null
        } | null> | null
        resource?: {
          __typename?: "ResourceCopyConfigResource"
          id: number
          meta: {
            __typename?: "NodeMeta"
            id: string
            type: string
            key: string
            title?: string | null
            image?: { __typename?: "NodeImage"; src?: string | null } | null
          }
        } | null
      } | null> | null
      resource?: {
        __typename?: "ResourceCopyConfigResource"
        id: number
        meta: {
          __typename?: "NodeMeta"
          id: string
          type: string
          key: string
          title?: string | null
          image?: { __typename?: "NodeImage"; src?: string | null } | null
        }
      } | null
    } | null> | null
    resource?: {
      __typename?: "ResourceCopyConfigResource"
      id: number
      meta: {
        __typename?: "NodeMeta"
        id: string
        type: string
        key: string
        title?: string | null
        image?: { __typename?: "NodeImage"; src?: string | null } | null
      }
    } | null
  }
}

export type HomeResourceFragment = {
  __typename?: "Resource"
  id: number
  name: string
  slug: string
  created?: any | null
  resource_type: number
  visibility?: number | null
  description?: string | null
  short_description?: string | null
  background_overlay?: string | null
  background_image?: string | null
  background_type: ResourceBackgroundType
  image_raw?: string | null
  has_certificate?: boolean | null
  discussion_enabled?: boolean | null
  lowest_public_offering_price?: number | null
  highest_public_offering_price?: number | null
  licensed_from_resource_id?: number | null
  licensed_from_school_id?: number | null
  created_by_id?: number | null
  copied_with_copy_config_id?: number | null
  image: string
  cover_image: string
  groups?: { __typename?: "GroupConnection"; total: number } | null
}

export type ProfileFragment = {
  __typename?: "Profile"
  id?: number | null
  bio?: string | null
  image?: string | null
  imageRaw?: string | null
  location?: string | null
  last_activity?: any | null
  rewardful_referral_id?: string | null
}

export type UserFragment = {
  __typename?: "User"
  id: number
  email?: string | null
  first_name: string
  last_name: string
  full_name: string
  display_name?: string | null
  profile?: {
    __typename?: "Profile"
    id?: number | null
    bio?: string | null
    image?: string | null
    imageRaw?: string | null
    location?: string | null
    last_activity?: any | null
    rewardful_referral_id?: string | null
  } | null
}

export type UserMentorGroupMembershipsQueryVariables = Exact<{
  role?: InputMaybe<MentorGroupMembershipRoleFilter>
  mentorGroupSeatLimit?: InputMaybe<Scalars["Int"]["input"]>
  mentorGroupSeatLimitFilter?: InputMaybe<IntFilter>
  mentorGroupSeatsFilled?: InputMaybe<Scalars["Int"]["input"]>
  mentorGroupSeatsFilledFilter?: InputMaybe<IntFilter>
  include_group: Scalars["Boolean"]["input"]
  or?: InputMaybe<MentorGroupMembershipOr>
}>

export type UserMentorGroupMembershipsQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    mentorGroupMemberships?: {
      __typename?: "MentorGroupMembershipConnection"
      edges?: Array<{
        __typename?: "MentorGroupMembershipEdge"
        node?: {
          __typename?: "MentorGroupMembership"
          id: number
          role: number
          created: any
          group_id: number
          group?: {
            __typename?: "MentorGroup"
            id?: number | null
            type?: number | null
            slug?: string | null
            name?: string | null
            description?: string | null
            created?: any | null
            modified?: any | null
            parent_id?: number | null
            has_child_groups?: boolean | null
            seat_limit?: number | null
            seats_filled?: number | null
            seats_available?: number | null
            memberships?: {
              __typename?: "MentorGroupMembershipConnection"
              total: number
              edges?: Array<{
                __typename?: "MentorGroupMembershipEdge"
                node?: {
                  __typename?: "MentorGroupMembership"
                  id: number
                  user: {
                    __typename?: "User"
                    id: number
                    email?: string | null
                    first_name: string
                    last_name: string
                    full_name: string
                    display_name?: string | null
                    profile?: {
                      __typename?: "Profile"
                      id?: number | null
                      bio?: string | null
                      image?: string | null
                      imageRaw?: string | null
                      location?: string | null
                      last_activity?: any | null
                      rewardful_referral_id?: string | null
                    } | null
                  }
                } | null
              } | null> | null
            } | null
            owner?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            permissions?: {
              __typename?: "MentorGroupPermissions"
              can_add_member?: boolean | null
              can_add_moderator?: boolean | null
              can_add_admin?: boolean | null
              can_add_group?: boolean | null
              can_edit_group?: boolean | null
              can_change_parent?: boolean | null
              can_edit_subscription?: boolean | null
              can_delete_group?: boolean | null
              can_update_member_review_permission?: boolean | null
              can_update_moderator_review_permission?: boolean | null
              can_update_admin_review_permission?: boolean | null
            } | null
          }
        } | null
      } | null> | null
    } | null
  } | null
}

export type UserMentorGroupSubscriptionMembershipFragment = {
  __typename?: "MentorGroupMembership"
  id: number
  role: number
  created: any
  access_revoked_time?: any | null
  group_id: number
  send_mentor_digest?: boolean | null
  can_review: boolean
  group: {
    __typename?: "MentorGroup"
    id?: number | null
    type?: number | null
    slug?: string | null
    name?: string | null
    description?: string | null
    created?: any | null
    modified?: any | null
    parent_id?: number | null
    has_child_groups?: boolean | null
    seat_limit?: number | null
    seats_filled?: number | null
    seats_available?: number | null
    memberships?: {
      __typename?: "MentorGroupMembershipConnection"
      total: number
      edges?: Array<{
        __typename?: "MentorGroupMembershipEdge"
        node?: {
          __typename?: "MentorGroupMembership"
          id: number
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
      } | null> | null
    } | null
    group_subscription?: {
      __typename?: "SchoolGroupSubscription"
      id?: number | null
      price?: {
        __typename?: "StripePrice"
        id: number
        active?: boolean | null
        billing_scheme?: StripeBillingScheme | null
        currency?: string | null
        nickname?: string | null
        recurring_interval?: StripeRecurringInterval | null
        recurring_interval_count?: number | null
        stripe_price_id?: string | null
        stripe_connected_account_url?: string | null
        tiers_mode?: StripeTiersMode | null
        unit_amount_decimal?: number | null
        product?: {
          __typename?: "StripeProduct"
          id: number
          min_quantity?: number | null
          max_quantity?: number | null
          active?: boolean | null
          name?: string | null
          description?: string | null
          images?: Array<string | null> | null
          unit_label?: string | null
          stripe_product_id?: string | null
          stripe_connected_account_url?: string | null
        } | null
        tiers?: Array<{
          __typename?: "StripeTier"
          up_to?: number | null
          flat_amount?: number | null
          flat_amount_decimal?: string | null
          unit_amount?: number | null
          unit_amount_decimal?: string | null
        } | null> | null
      } | null
      user?: {
        __typename?: "User"
        id: number
        email?: string | null
        first_name: string
        last_name: string
        full_name: string
        display_name?: string | null
        profile?: {
          __typename?: "Profile"
          id?: number | null
          bio?: string | null
          image?: string | null
          imageRaw?: string | null
          location?: string | null
          last_activity?: any | null
          rewardful_referral_id?: string | null
        } | null
      } | null
      subscription?: {
        __typename?: "Subscription"
        id?: number | null
        quantity?: number | null
        canceled_dtime?: any | null
        cancellation_reason?: number | null
        card_last_4?: string | null
        cycle_end_dtime?: any | null
        cycle_start_dtime?: any | null
        is_canceled_at_cycle_end?: boolean | null
        is_delinquent?: boolean | null
        paused_until_dtime?: any | null
        trial_type?: number | null
        trial_end_dtime?: any | null
        payment_intent_needing_action_id?: string | null
        subscription_plan?: {
          __typename?: "SubscriptionPlan"
          id?: number | null
          name?: string | null
          amount?: number | null
          interval?: number | null
          trial_period_days?: number | null
          trial_type?: number | null
          plan_type?: string | null
          stripe_connected_account_url?: string | null
        } | null
        customer?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
      } | null
      community_group?: {
        __typename?: "MentorGroup"
        id?: number | null
        type?: number | null
        slug?: string | null
        name?: string | null
        description?: string | null
        created?: any | null
        modified?: any | null
        parent_id?: number | null
        has_child_groups?: boolean | null
        seat_limit?: number | null
        seats_filled?: number | null
        seats_available?: number | null
        owner?: {
          __typename?: "User"
          id: number
          email?: string | null
          first_name: string
          last_name: string
          full_name: string
          display_name?: string | null
          profile?: {
            __typename?: "Profile"
            id?: number | null
            bio?: string | null
            image?: string | null
            imageRaw?: string | null
            location?: string | null
            last_activity?: any | null
            rewardful_referral_id?: string | null
          } | null
        } | null
        permissions?: {
          __typename?: "MentorGroupPermissions"
          can_add_member?: boolean | null
          can_add_moderator?: boolean | null
          can_add_admin?: boolean | null
          can_add_group?: boolean | null
          can_edit_group?: boolean | null
          can_change_parent?: boolean | null
          can_edit_subscription?: boolean | null
          can_delete_group?: boolean | null
          can_update_member_review_permission?: boolean | null
          can_update_moderator_review_permission?: boolean | null
          can_update_admin_review_permission?: boolean | null
        } | null
      } | null
    } | null
    owner?: {
      __typename?: "User"
      id: number
      email?: string | null
      first_name: string
      last_name: string
      full_name: string
      display_name?: string | null
      profile?: {
        __typename?: "Profile"
        id?: number | null
        bio?: string | null
        image?: string | null
        imageRaw?: string | null
        location?: string | null
        last_activity?: any | null
        rewardful_referral_id?: string | null
      } | null
    } | null
    permissions?: {
      __typename?: "MentorGroupPermissions"
      can_add_member?: boolean | null
      can_add_moderator?: boolean | null
      can_add_admin?: boolean | null
      can_add_group?: boolean | null
      can_edit_group?: boolean | null
      can_change_parent?: boolean | null
      can_edit_subscription?: boolean | null
      can_delete_group?: boolean | null
      can_update_member_review_permission?: boolean | null
      can_update_moderator_review_permission?: boolean | null
      can_update_admin_review_permission?: boolean | null
    } | null
  }
  user: {
    __typename?: "User"
    id: number
    email?: string | null
    first_name: string
    last_name: string
    full_name: string
    display_name?: string | null
    profile?: {
      __typename?: "Profile"
      id?: number | null
      bio?: string | null
      image?: string | null
      imageRaw?: string | null
      location?: string | null
      last_activity?: any | null
      rewardful_referral_id?: string | null
    } | null
  }
}

export type UserMentorGroupSubscriptionsQueryVariables = Exact<{
  [key: string]: never
}>

export type UserMentorGroupSubscriptionsQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    mentorGroupMemberships?: {
      __typename?: "MentorGroupMembershipConnection"
      edges?: Array<{
        __typename?: "MentorGroupMembershipEdge"
        node?: {
          __typename?: "MentorGroupMembership"
          id: number
          role: number
          created: any
          access_revoked_time?: any | null
          group_id: number
          send_mentor_digest?: boolean | null
          can_review: boolean
          group: {
            __typename?: "MentorGroup"
            id?: number | null
            type?: number | null
            slug?: string | null
            name?: string | null
            description?: string | null
            created?: any | null
            modified?: any | null
            parent_id?: number | null
            has_child_groups?: boolean | null
            seat_limit?: number | null
            seats_filled?: number | null
            seats_available?: number | null
            memberships?: {
              __typename?: "MentorGroupMembershipConnection"
              total: number
              edges?: Array<{
                __typename?: "MentorGroupMembershipEdge"
                node?: {
                  __typename?: "MentorGroupMembership"
                  id: number
                  user: {
                    __typename?: "User"
                    id: number
                    email?: string | null
                    first_name: string
                    last_name: string
                    full_name: string
                    display_name?: string | null
                    profile?: {
                      __typename?: "Profile"
                      id?: number | null
                      bio?: string | null
                      image?: string | null
                      imageRaw?: string | null
                      location?: string | null
                      last_activity?: any | null
                      rewardful_referral_id?: string | null
                    } | null
                  }
                } | null
              } | null> | null
            } | null
            group_subscription?: {
              __typename?: "SchoolGroupSubscription"
              id?: number | null
              price?: {
                __typename?: "StripePrice"
                id: number
                active?: boolean | null
                billing_scheme?: StripeBillingScheme | null
                currency?: string | null
                nickname?: string | null
                recurring_interval?: StripeRecurringInterval | null
                recurring_interval_count?: number | null
                stripe_price_id?: string | null
                stripe_connected_account_url?: string | null
                tiers_mode?: StripeTiersMode | null
                unit_amount_decimal?: number | null
                product?: {
                  __typename?: "StripeProduct"
                  id: number
                  min_quantity?: number | null
                  max_quantity?: number | null
                  active?: boolean | null
                  name?: string | null
                  description?: string | null
                  images?: Array<string | null> | null
                  unit_label?: string | null
                  stripe_product_id?: string | null
                  stripe_connected_account_url?: string | null
                } | null
                tiers?: Array<{
                  __typename?: "StripeTier"
                  up_to?: number | null
                  flat_amount?: number | null
                  flat_amount_decimal?: string | null
                  unit_amount?: number | null
                  unit_amount_decimal?: string | null
                } | null> | null
              } | null
              user?: {
                __typename?: "User"
                id: number
                email?: string | null
                first_name: string
                last_name: string
                full_name: string
                display_name?: string | null
                profile?: {
                  __typename?: "Profile"
                  id?: number | null
                  bio?: string | null
                  image?: string | null
                  imageRaw?: string | null
                  location?: string | null
                  last_activity?: any | null
                  rewardful_referral_id?: string | null
                } | null
              } | null
              subscription?: {
                __typename?: "Subscription"
                id?: number | null
                quantity?: number | null
                canceled_dtime?: any | null
                cancellation_reason?: number | null
                card_last_4?: string | null
                cycle_end_dtime?: any | null
                cycle_start_dtime?: any | null
                is_canceled_at_cycle_end?: boolean | null
                is_delinquent?: boolean | null
                paused_until_dtime?: any | null
                trial_type?: number | null
                trial_end_dtime?: any | null
                payment_intent_needing_action_id?: string | null
                subscription_plan?: {
                  __typename?: "SubscriptionPlan"
                  id?: number | null
                  name?: string | null
                  amount?: number | null
                  interval?: number | null
                  trial_period_days?: number | null
                  trial_type?: number | null
                  plan_type?: string | null
                  stripe_connected_account_url?: string | null
                } | null
                customer?: {
                  __typename?: "User"
                  id: number
                  email?: string | null
                  first_name: string
                  last_name: string
                  full_name: string
                  display_name?: string | null
                  profile?: {
                    __typename?: "Profile"
                    id?: number | null
                    bio?: string | null
                    image?: string | null
                    imageRaw?: string | null
                    location?: string | null
                    last_activity?: any | null
                    rewardful_referral_id?: string | null
                  } | null
                } | null
              } | null
              community_group?: {
                __typename?: "MentorGroup"
                id?: number | null
                type?: number | null
                slug?: string | null
                name?: string | null
                description?: string | null
                created?: any | null
                modified?: any | null
                parent_id?: number | null
                has_child_groups?: boolean | null
                seat_limit?: number | null
                seats_filled?: number | null
                seats_available?: number | null
                owner?: {
                  __typename?: "User"
                  id: number
                  email?: string | null
                  first_name: string
                  last_name: string
                  full_name: string
                  display_name?: string | null
                  profile?: {
                    __typename?: "Profile"
                    id?: number | null
                    bio?: string | null
                    image?: string | null
                    imageRaw?: string | null
                    location?: string | null
                    last_activity?: any | null
                    rewardful_referral_id?: string | null
                  } | null
                } | null
                permissions?: {
                  __typename?: "MentorGroupPermissions"
                  can_add_member?: boolean | null
                  can_add_moderator?: boolean | null
                  can_add_admin?: boolean | null
                  can_add_group?: boolean | null
                  can_edit_group?: boolean | null
                  can_change_parent?: boolean | null
                  can_edit_subscription?: boolean | null
                  can_delete_group?: boolean | null
                  can_update_member_review_permission?: boolean | null
                  can_update_moderator_review_permission?: boolean | null
                  can_update_admin_review_permission?: boolean | null
                } | null
              } | null
            } | null
            owner?: {
              __typename?: "User"
              id: number
              email?: string | null
              first_name: string
              last_name: string
              full_name: string
              display_name?: string | null
              profile?: {
                __typename?: "Profile"
                id?: number | null
                bio?: string | null
                image?: string | null
                imageRaw?: string | null
                location?: string | null
                last_activity?: any | null
                rewardful_referral_id?: string | null
              } | null
            } | null
            permissions?: {
              __typename?: "MentorGroupPermissions"
              can_add_member?: boolean | null
              can_add_moderator?: boolean | null
              can_add_admin?: boolean | null
              can_add_group?: boolean | null
              can_edit_group?: boolean | null
              can_change_parent?: boolean | null
              can_edit_subscription?: boolean | null
              can_delete_group?: boolean | null
              can_update_member_review_permission?: boolean | null
              can_update_moderator_review_permission?: boolean | null
              can_update_admin_review_permission?: boolean | null
            } | null
          }
          user: {
            __typename?: "User"
            id: number
            email?: string | null
            first_name: string
            last_name: string
            full_name: string
            display_name?: string | null
            profile?: {
              __typename?: "Profile"
              id?: number | null
              bio?: string | null
              image?: string | null
              imageRaw?: string | null
              location?: string | null
              last_activity?: any | null
              rewardful_referral_id?: string | null
            } | null
          }
        } | null
      } | null> | null
    } | null
  } | null
}

export type UserPaymentHistoryQueryVariables = Exact<{ [key: string]: never }>

export type UserPaymentHistoryQuery = {
  __typename?: "Query"
  me?: {
    __typename?: "User"
    id: number
    payment_history: {
      __typename?: "PaymentHistory"
      download_url: string
      payments: Array<{
        __typename?: "PaymentHistoryItem"
        item: string
        total: number
        currency_display: string
        date: any
        is_failed: string
      }>
    }
  } | null
}

export const PageFragmentDoc = gql`
  fragment Page on Page {
    id
    name
    order
    page_type
    title
    description
    url
    external_url
    iframe_url
    template_content
    scripts
    slug
    show_in_nav
    mode
    is_live
    content_type
  }
`
export const BannerFragmentDoc = gql`
  fragment Banner on Banner {
    id
    order
    heading
    subhead
    font_color
    background_image_raw
    background_image(width: 1600, fit: crop)
    background_type
    background_overlay
    button_func
    button_url
    button_text
    is_visible
    hide_for_subscription_plans
    show_for_subscription_plans
    hide_for_products
    show_for_products
  }
`
export const BackgroundTaskFragmentDoc = gql`
  fragment BackgroundTask on BackgroundTask {
    id
    status
    result
  }
`
export const CertificateFragmentDoc = gql`
  fragment Certificate on Certificate {
    id
    name
    template
    text_objects
  }
`
export const CohortFragmentDoc = gql`
  fragment Cohort on Group {
    id
    name
    created
    created_by_id
    status
    is_collection_linked
    is_master
    access_starts
    parent_section_id
    registration {
      id
      role
      send_due_notifications
      send_discussion_notifications
    }
    path(type: source) {
      id
    }
    access_ends
    resource {
      id
      name
      image
      slug
      background_image
      background_overlay
      resource_type
    }
    resource_license {
      id
      expiration_dtime
    }
  }
`
export const ProfileFragmentDoc = gql`
  fragment Profile on Profile {
    id
    bio
    image(width: 250, height: 250, crop: faces)
    imageRaw
    location
    last_activity
    rewardful_referral_id
  }
`
export const UserFragmentDoc = gql`
  fragment User on User {
    id
    email
    first_name
    last_name
    full_name
    display_name
    profile {
      ...Profile
    }
  }
  ${ProfileFragmentDoc}
`
export const CompletionFragmentDoc = gql`
  fragment Completion on Completion {
    id
    checked_date
    completion_attempts
    completion_comment
    completion_date
    completion_due
    last_completion_attempt_date
    has_failed_passing_attempt
    has_points
    is_late
    is_graded
    is_skipped
    is_complete
    is_auto_graded
    is_forced_completion
    needs_grading
    userpoints_earned
    userpoints_explanation
    userpoints_value
    minimum_passing_score
    grading_type
    requires_api_completion
    overridden_by_api
    overridden_by {
      ...User
    }
    checked_by {
      ...User
    }
    user {
      ...User
    }
    submission {
      id
      text
      file_url
      file_name
      file_image
    }
    feedback_discussion_context {
      id
      discussion_id
      num_responses
    }
  }
  ${UserFragmentDoc}
`
export const ResourceFragmentDoc = gql`
  fragment Resource on Resource {
    id
    name
    slug
    created
    resource_type
    visibility
    description
    short_description
    background_overlay
    background_image
    background_type
    image_raw
    has_certificate
    discussion_enabled
    lowest_public_offering_price
    highest_public_offering_price
    licensed_from_resource_id
    licensed_from_school_id
    created_by_id
    copied_with_copy_config_id
    image(width: 500, height: 375, fit: crop)
    cover_image: image(width: 240, height: 180, fit: crop)
  }
`
export const RegistrationFragmentDoc = gql`
  fragment Registration on Registration {
    id
    role
    completion_state
    send_due_notifications
    send_discussion_notifications
    last_activity_time
    expiration_dtime
    created
    user {
      ...User
    }
  }
  ${UserFragmentDoc}
`
export const PathItemFragmentDoc = gql`
  fragment PathItem on PathItem {
    id
    order
    verb
    name
    type
    verb
    path_id
    source_id
    parent_id
    parent_source_id
    description
    curriculum_sync_opt_out_dtime
    assignment_type
    content_id
    content_type
    item_content_type_id
    is_required
    is_previewable
    due
    passive_due
    starts
    passive_starts
    has_started
    points
    item_needs_grading
    minimum_passing_score
    grading_type
    time_to_complete
    lock_password
    is_locked
    lock_unlocked_time
    allow_resets
    show_grading_feedback
    completion_comment_required_status
    last_published_dtime
    archived_time
    progress
    context {
      resource_id
      cohort_id
    }
    blocks {
      content_last_modified
      last_published
    }
    permissions {
      can_complete
      can_discuss
      can_edit
      can_edit_content
      can_note
      can_view
      can_review
      can_view_content
    }
    completion {
      ...Completion
    }
    linked_resource {
      ...Resource
      curriculum_group {
        id
      }
    }
    linked_cohort {
      id
      user_registration {
        ...Registration
        path {
          id
        }
      }
    }
    linked_registration {
      ...Registration
      path {
        id
      }
    }
  }
  ${CompletionFragmentDoc}
  ${ResourceFragmentDoc}
  ${RegistrationFragmentDoc}
`
export const CompletionsItemFragmentDoc = gql`
  fragment CompletionsItem on PathItem {
    ...PathItem
    cohort {
      id
      name
    }
    resource {
      id
      name
      image(width: 100, height: 100, fit: crop)
      blurred_background: background_image(blur: 500, width: 250, height: 250)
      background_overlay
      background_image
      image_raw
    }
    parent {
      id
      source_id
      order
      name
    }
    analytics {
      need_feedback
      total_users
    }
  }
  ${PathItemFragmentDoc}
`
export const CoverPageOfferFragmentDoc = gql`
  fragment CoverPageOffer on Offer {
    id
    source
    title
    description
    access {
      meta
      state
    }
    price_options {
      option_label
      button_label
      price_description
    }
  }
`
export const CoverPagePathItemFragmentDoc = gql`
  fragment CoverPagePathItem on PathItem {
    id
    order
    name
    type
    path_id
    source_id
    parent_id
    description
    content_id
    assignment_type
    is_previewable
    item_content_type_id
    step_verb: verb
    verb
    userpoints_value: points
    points
    is_required
    time_to_complete
    context {
      school_id
    }
  }
`
export const CoverPageResourceFragmentDoc = gql`
  fragment CoverPageResource on Resource {
    id
    name
    slug
    resource_type
    is_ambient_background
    created
    curriculum_group {
      id
    }
    contributors: authors(first: 20) {
      total
      edges {
        node {
          id
          order
          display_name
          full_name
          first_name
          last_name
          title
          image
          bio
          avatar
          salutation
          slug
        }
      }
    }
    categories(first: 20) {
      total
      edges {
        node {
          id
          name
          slug
          order
          description
        }
      }
    }
    visibility
    description
    short_description
    background_overlay
    background_image(width: 1400, height: -1, fit: max)
    blurred_background: background_image(
      blur: 500
      width: 1400
      height: 780
      fit: max
    )
    image_raw
    has_certificate
    discussion_enabled
    lowest_public_offering_price
    highest_public_offering_price
    licensed_from_resource_id
    licensed_from_school_id
    created_by_id
    trailer_embed_code
    cover_image: image(width: 450, height: 350, fit: crop)
    image: image(width: 450, height: 350, fit: crop)
    previewable_cohorts: groups(
      first: 1
      status: in_progress
      visibility: public
      is_master: false
    ) {
      total
      edges {
        node {
          id
        }
      }
    }
    group(type: curriculum) {
      id
      path(type: source) {
        id
        items(first: 1000, flatten: true) {
          total
          edges {
            node {
              ...CoverPagePathItem
            }
          }
        }
      }
    }
  }
  ${CoverPagePathItemFragmentDoc}
`
export const DiscussionParticipantFragmentDoc = gql`
  fragment DiscussionParticipant on DiscussionParticipant {
    id
    email
    first_name
    last_name
    full_name
    display_name
    profile {
      id
      bio
      image(width: 250, height: 250, crop: faces)
      location
      last_activity
      rewardful_referral_id
    }
  }
`
export const GroupFragmentDoc = gql`
  fragment Group on Group {
    id
    name
    created
    description
    price
    seats
    seats_filled
    seats_available
    registration_ends
    registration_starts
    registration_started
    registration_ended
    access_ends
    access_starts
    is_master
    is_source_cohort
    source_cohort_id
    parent_section_id
    resource_id
    visibility
    is_collection_linked
    is_subscription_only
    status
    analytics_disabled
    created_by_id
  }
`
export const TagLinkFragmentDoc = gql`
  fragment TagLink on TagLink {
    id
    tag_id
    discussion_context_id
  }
`
export const TagFragmentDoc = gql`
  fragment Tag on Tag {
    id
    name
    slug
    description
    color
  }
`
export const DiscussionPostFragmentDoc = gql`
  fragment DiscussionPost on Discussion {
    id
    title
    body
    type
    likes
    total_responses
    created_time
    is_discussion_question
    allow_replies
    path_item_name
    last_activity_time
    user_last_viewed_time
    user_last_responded_time
    user_has_viewed_recent
    user_is_subscribed
    user_liked
    context_id
    resource_id
    cohort_id
    step_id
    user {
      ...User
    }
    cohort {
      ...Group
    }
    resource {
      ...Resource
    }
    tagLinks(first: 50) {
      edges {
        node {
          ...TagLink
          tag {
            ...Tag
          }
        }
      }
    }
  }
  ${UserFragmentDoc}
  ${GroupFragmentDoc}
  ${ResourceFragmentDoc}
  ${TagLinkFragmentDoc}
  ${TagFragmentDoc}
`
export const DiscussionResponseFragmentDoc = gql`
  fragment DiscussionResponse on Response {
    id
    parent_id
    body
    attachments
    likes
    user_liked
    created_time
    user {
      ...User
    }
  }
  ${UserFragmentDoc}
`
export const ContextualFeaturePermissionFragmentDoc = gql`
  fragment ContextualFeaturePermission on ContextualFeaturePermission {
    id
    feature_key
    feature_action
    permission_in_context
    school_id
    resource_id
    cohort_id
  }
`
export const GroupContextFragmentDoc = gql`
  fragment GroupContext on Group {
    ...Group
    resource {
      ...Resource
      blurred_background: background_image(blur: 500, width: 250, height: 250)
    }
    user_registration {
      id
      role
    }
    user_source_registration {
      id
      role
    }
  }
  ${GroupFragmentDoc}
  ${ResourceFragmentDoc}
`
export const CreatedResourceFragmentDoc = gql`
  fragment CreatedResource on Resource {
    ...Resource
    blurred_background: background_image(blur: 500, width: 250, height: 250)
    curriculum: curriculum_group {
      id
    }
    cohort: group(is_source: false) {
      id
      source_cohort_id
    }
  }
  ${ResourceFragmentDoc}
`
export const InboxGroupConnectionFragmentDoc = gql`
  fragment InboxGroupConnection on InboxGroupConnection {
    mentor_group {
      id
      name
      memberships(first: 3, order_by: "-role") {
        edges {
          node {
            id
            role
            user {
              ...User
            }
          }
        }
      }
    }
    cohort {
      id
      name
      resource {
        id
        name
      }
      registrations(first: 3, orderBy: { role: DESC }) {
        edges {
          node {
            id
            role
            user {
              ...User
            }
          }
        }
      }
    }
  }
  ${UserFragmentDoc}
`
export const InboxPeopleCompletionCountsFragmentDoc = gql`
  fragment InboxPeopleCompletionCounts on InboxPeopleCompletionCounts {
    id
    count
    user {
      ...User
    }
  }
  ${UserFragmentDoc}
`
export const InboxReviewerFragmentDoc = gql`
  fragment InboxReviewer on InboxReviewer {
    id
    group_or_cohort_id
    group_role
    cohort_role
    can_review
    user {
      ...User
    }
  }
  ${UserFragmentDoc}
`
export const InvitationFragmentDoc = gql`
  fragment Invitation on Invitation {
    id
    created_dtime
    invitation_role
    invitation_type
    invitation_subject
    invitation_status
    invitation_url
    invitation_message
    invitation_accepted_dtime
    invitation_hash
    to_email
    to_first_name
    to_last_name
    invitation_email {
      id
      created_dtime
      delivery_status
      delivery_status_updated
    }
  }
`
export const FeatureLockSchoolBillingPlanFragmentDoc = gql`
  fragment FeatureLockSchoolBillingPlan on SchoolBillingPlan {
    id
    order
    name
    features {
      id
      key
    }
    plan_derived_from {
      id
    }
  }
`
export const SubscriptionPlanFragmentDoc = gql`
  fragment SubscriptionPlan on SubscriptionPlan {
    id
    name
    amount
    interval
    trial_period_days
    trial_type
    plan_type
    stripe_connected_account_url
  }
`
export const SubscriptionFragmentDoc = gql`
  fragment Subscription on Subscription {
    id
    quantity
    canceled_dtime
    cancellation_reason
    card_last_4
    cycle_end_dtime
    cycle_start_dtime
    is_canceled_at_cycle_end
    is_delinquent
    paused_until_dtime
    trial_type
    trial_end_dtime
    payment_intent_needing_action_id
    subscription_plan {
      ...SubscriptionPlan
    }
    customer {
      ...User
    }
  }
  ${SubscriptionPlanFragmentDoc}
  ${UserFragmentDoc}
`
export const SchoolSubscriptionPlanFragmentDoc = gql`
  fragment SchoolSubscriptionPlan on SchoolSubscriptionPlan {
    id
    image
    details_html
    subscribe_complete_html
    catalog_header
    is_visible
    giftable_cycles
    subscription_plan {
      ...SubscriptionPlan
    }
  }
  ${SubscriptionPlanFragmentDoc}
`
export const SchoolSubscriptionFragmentDoc = gql`
  fragment SchoolSubscription on SchoolSubscription {
    id
    user {
      ...User
    }
    subscription {
      ...Subscription
    }
    subscription_plan {
      ...SubscriptionPlan
    }
    school_subscription_plan {
      ...SchoolSubscriptionPlan
    }
  }
  ${UserFragmentDoc}
  ${SubscriptionFragmentDoc}
  ${SubscriptionPlanFragmentDoc}
  ${SchoolSubscriptionPlanFragmentDoc}
`
export const MembershipFragmentDoc = gql`
  fragment Membership on Membership {
    id
    created
    last_seen
    last_active
    has_access
    access_revoked_time
    archived_time
    role
    consent_dtime
    consent_snapshot
    user {
      ...User
      school_subscription {
        ...SchoolSubscription
      }
    }
  }
  ${UserFragmentDoc}
  ${SchoolSubscriptionFragmentDoc}
`
export const NoteFragmentDoc = gql`
  fragment Note on Note {
    id
    title
    body
    visibility
    created_time
    modified_time
    context_id
    resource_id
    cohort_id
    step_id
    user {
      ...User
    }
  }
  ${UserFragmentDoc}
`
export const GroupListItemRegistrationFragmentDoc = gql`
  fragment GroupListItemRegistration on Registration {
    id
    user {
      id
      first_name
      last_name
      full_name
      profile {
        id
        image
      }
    }
  }
`
export const GroupListItemFragmentDoc = gql`
  fragment GroupListItem on Group {
    id
    name
    registrations(
      first: 4
      role_filter: { in: [teacher, moderator, student] }
      orderBy: [{ role: DESC }, { last_activity_time: DESC }]
    ) {
      total
      edges {
        node {
          ...GroupListItemRegistration
        }
      }
    }
  }
  ${GroupListItemRegistrationFragmentDoc}
`
export const PathCreatorCohortFragmentDoc = gql`
  fragment PathCreatorCohort on Group {
    ...GroupListItem
  }
  ${GroupListItemFragmentDoc}
`
export const PathCreatorCohortWithRegistrationFragmentDoc = gql`
  fragment PathCreatorCohortWithRegistration on Group {
    ...PathCreatorCohort
    user_registration(user_id: $targetUserId) {
      id
      role
    }
  }
  ${PathCreatorCohortFragmentDoc}
`
export const PathCreatorResourceFragmentDoc = gql`
  fragment PathCreatorResource on Resource {
    id
    name
    background_image(
      width: 250
      height: 250
      blur: 500
      high: -80
      blend: 666666
      balph: 40
      fm: "jpg"
      q: 100
      bm: "screen"
    )
    image(width: 500, height: 375, fit: crop)
    source_cohort: curriculum_group {
      id
      registration {
        id
        role
      }
    }
  }
`
export const PathCreatorCreatePathFragmentDoc = gql`
  fragment PathCreatorCreatePath on Resource {
    ...PathCreatorResource
    cohort: group(is_source: false) {
      ...PathCreatorCohort
    }
  }
  ${PathCreatorResourceFragmentDoc}
  ${PathCreatorCohortFragmentDoc}
`
export const CohortSyncPathCohortFragmentDoc = gql`
  fragment CohortSyncPathCohort on Group {
    id
    name
    is_master
    user_registration {
      id
      role
    }
    visibility
    path(type: source) {
      id
    }
    source {
      id
      name
      is_master
      user_registration {
        id
        role
      }
      path(type: source) {
        id
      }
    }
    resource {
      id
      slug
      background_overlay
      background_image
      blurred_background: background_image(blur: 500, width: 400, height: 500)
      cohorts: groups(first: 20, status: in_progress) {
        total
        edges {
          node {
            id
            name
            is_master
            path(type: source) {
              id
            }
          }
        }
      }
      license_offerings(first: 1) {
        total
      }
      description
      short_description
      name
      licensing_enabled
      resource_type
    }
    registrations(first: 1, role_filter: { eq: student }) {
      edges {
        node {
          id
          role
        }
      }
      total
    }
  }
`
export const PathSyncPlanChangeFragmentDoc = gql`
  fragment PathSyncPlanChange on PathSyncPlanChange {
    item_source_id
    parent_source_id
    item_name
    parent_name
    item_type
    assignment_type
    forced
    forced_reasons
    change_details
    last_changed
  }
`
export const SingleCohortPathFragmentDoc = gql`
  fragment SingleCohortPath on Path {
    id
    items(flatten: true, first: 10) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          type
          blocks {
            content_last_modified
            last_published
          }
        }
      }
    }
  }
`
export const PathSyncFragmentDoc = gql`
  fragment PathSync on PathSync {
    path_id
    synced
    last_synced_date
    sync_source_path_id
    user_id
  }
`
export const PathPublishFragmentDoc = gql`
  fragment PathPublish on PathPublish {
    path_id
    published
    last_published_date
  }
`
export const PathSyncPublishFragmentDoc = gql`
  fragment PathSyncPublish on Path {
    id
    sync {
      ...PathSync
    }
    publish {
      ...PathPublish
    }
  }
  ${PathSyncFragmentDoc}
  ${PathPublishFragmentDoc}
`
export const PathFragmentDoc = gql`
  fragment Path on Path {
    id
    progress
    points {
      path_id
      total
      earned
      total_points_possible
      percentage
      has_points
    }
    next_step_id
    completion_date
    created_date
    user {
      ...User
    }
    ...PathSyncPublish
  }
  ${UserFragmentDoc}
  ${PathSyncPublishFragmentDoc}
`
export const PathItemsFragmentDoc = gql`
  fragment PathItems on Path {
    ...Path
    items(first: 1042, flatten: true) {
      edges {
        node {
          ...PathItem
        }
      }
    }
  }
  ${PathFragmentDoc}
  ${PathItemFragmentDoc}
`
export const PathPerformanceFragmentDoc = gql`
  fragment PathPerformance on PathPerformance {
    id
    points {
      total
      earned
      possible
      percentage
      applicable_score
      applicable_score_percentage
    }
    progress {
      steps_completed
      required_steps_completed
      total_steps
      total_required_steps
      percentage
    }
  }
`
export const UserPathReportCardFragmentDoc = gql`
  fragment UserPathReportCard on Path {
    ...PathItems
    performance {
      ...PathPerformance
    }
    user {
      ...User
    }
    cohort {
      id
      name
    }
  }
  ${PathItemsFragmentDoc}
  ${PathPerformanceFragmentDoc}
  ${UserFragmentDoc}
`
export const MissingPathItemFragmentDoc = gql`
  fragment MissingPathItem on PathItem {
    id
    source_id
    name
    archived_time
  }
`
export const SchoolFragmentDoc = gql`
  fragment School on School {
    id
    url
    name
    about
    email
    website
    subdomain
    created
    billing_model
    platform_version
    currency_code
    ietf_language_tag
    has_certificate
    is_activated
    is_curriculum_enabled
    is_curriculum_subscriber
    stripe_access_token
    stripe_publishable_api_key
    show_stripe_reconnect
    payment_requires_zip_code
    consent_description
    image(width: 150, height: 150)
    grant_access_upon_authentication
    pathwright_login_enabled
  }
`
export const ThemeFragmentDoc = gql`
  fragment Theme on Theme {
    id
    name
    theme_type
    background_image
    background_overlay
    background_type
    heading_font
    primary_color
    typekit_id
    custom_css
    processed_custom_css
    color_palette {
      _50
      _100
      _200
      _300
      _400
      _500
      _600
      _700
      _800
      _900
    }
  }
`
export const MeFragmentDoc = gql`
  fragment Me on User {
    ...User
    username
    no_password_set
    group_role_stats {
      type
      total
      role
    }
    permissions {
      is_school_owner
      can_administrate
      can_edit_library
      has_member_access
      has_pathwright_staff_access
    }
    membership {
      id
      created
      last_seen
      last_active
      has_access
      role
      consent_snapshot
      consent_dtime
    }
    profile {
      id
      notification_digest_interval
    }
  }
  ${UserFragmentDoc}
`
export const TranslationFragmentDoc = gql`
  fragment Translation on Translation {
    id
    name
    language
    translation
    master_translation
    is_default
  }
`
export const ContextFragmentDoc = gql`
  fragment Context on Query {
    school {
      ...School
      theme {
        ...Theme
      }
      features {
        auth__platform
        media__downloadable_videos
        library__cover_pages
      }
    }
    me {
      ...Me
    }
    translation {
      ...Translation
    }
    platformConfig {
      id
      payments_maintenance_mode
    }
    integrations {
      firebase {
        auth_token
        url
        client_api_key
      }
      intercom {
        app_id
        pathwright_app_id
        school_app_id
        user_hash
      }
    }
  }
  ${SchoolFragmentDoc}
  ${ThemeFragmentDoc}
  ${MeFragmentDoc}
  ${TranslationFragmentDoc}
`
export const __TestRegistrationFragmentDoc = gql`
  fragment __TestRegistration on Registration {
    id
    position
  }
`
export const PublisherFragmentDoc = gql`
  fragment Publisher on Publisher {
    id
    name
    about
    website
    image(width: 150, height: 150)
  }
`
export const UserProfileRegistrationFragmentDoc = gql`
  fragment UserProfileRegistration on Registration {
    ...Registration
    resource {
      ...Resource
    }
    group {
      ...Group
    }
    path {
      id
      progress
      completion_date
    }
  }
  ${RegistrationFragmentDoc}
  ${ResourceFragmentDoc}
  ${GroupFragmentDoc}
`
export const LicenseOfferingFragmentDoc = gql`
  fragment LicenseOffering on LicenseOffering {
    id
    description
    cost_per_seat
    include_creator_seat
    register_creator_as
    minimum_seat_count
    minimum_license_duration
    licensing_mode
    included_in_user_subscription
    include_in_curriculum_plans(first: 50) {
      total
      edges {
        node {
          id
          plan_id
        }
      }
    }
    include_in_subscription_plans(first: 50) {
      total
      edges {
        node {
          id
        }
      }
    }
    licensor {
      ...School
    }
  }
  ${SchoolFragmentDoc}
`
export const ResourceLicenseFragmentDoc = gql`
  fragment ResourceLicense on ResourceLicense {
    id
    seat_count
    seats_filled
    seats_available
    expiration_dtime
    school {
      id
      name
    }
    license_offering {
      ...LicenseOffering
    }
    group {
      ...Group
      resource {
        ...Resource
      }
    }
  }
  ${LicenseOfferingFragmentDoc}
  ${GroupFragmentDoc}
  ${ResourceFragmentDoc}
`
export const AuthorFragmentDoc = gql`
  fragment Author on Author {
    id
    bio
    image
    order
    full_name
  }
`
export const CategoryFragmentDoc = gql`
  fragment Category on Category {
    id
    name
    slug
    order
    description
  }
`
export const ManageResourceFragmentDoc = gql`
  fragment ManageResource on Resource {
    ...Resource
    trailer_embed_code
    visibility_level_override
    certificate_generator_class
    certificate_json
    licensed_from_resource_id
    registration_meta {
      editor_registration_count
    }
    authors(first: 10) {
      total
      edges {
        node {
          ...Author
        }
      }
    }
    categories(first: 10) {
      total
      edges {
        node {
          ...Category
        }
      }
    }
    groups(first: 1) {
      total
      edges {
        node {
          id
          seats_filled
        }
      }
    }
  }
  ${ResourceFragmentDoc}
  ${AuthorFragmentDoc}
  ${CategoryFragmentDoc}
`
export const SchoolCurriculumPlanFragmentDoc = gql`
  fragment SchoolCurriculumPlan on SchoolCurriculumPlan {
    id
    name
    amount
    fee_boundary
    fee_per_user
    is_visible
    lower_boundary
    plan_id
    transaction_fee_percent
    upper_boundary
    visibility_code
  }
`
export const CurriculumSubscriptionFragmentDoc = gql`
  fragment CurriculumSubscription on CurriculumSubscription {
    id
    licensor {
      ...School
    }
    licensee {
      ...School
    }
    curriculum_plan {
      ...SchoolCurriculumPlan
    }
    subscription {
      ...Subscription
    }
  }
  ${SchoolFragmentDoc}
  ${SchoolCurriculumPlanFragmentDoc}
  ${SubscriptionFragmentDoc}
`
export const CreatedSpaceFragmentDoc = gql`
  fragment CreatedSpace on School {
    id
    name
    sso_link(pathname: "/home/teach/")
    profile {
      id
    }
  }
`
export const SpaceBillingPlanSetPlanFragmentDoc = gql`
  fragment SpaceBillingPlanSetPlan on SchoolBillingPlan {
    id
    name
  }
`
export const UserSpaceMembershipFragmentDoc = gql`
  fragment UserSpaceMembership on Membership {
    id
    role
    last_seen
    school {
      id
      name
      image(width: 150, height: 150)
      sso_link(pathname: "/home/")
    }
  }
`
export const StoreFragmentDoc = gql`
  fragment Store on Store {
    id
    licensor {
      ...School
    }
  }
  ${SchoolFragmentDoc}
`
export const StoreLinkFragmentDoc = gql`
  fragment StoreLink on StoreLink {
    id
    licensee {
      ...School
    }
    store {
      ...Store
    }
  }
  ${SchoolFragmentDoc}
  ${StoreFragmentDoc}
`
export const FeatureIncludedCountFragmentDoc = gql`
  fragment FeatureIncludedCount on SchoolAcount {
    id
    billing_model
    is_activated
    is_activated_via_override
    billing_subscription {
      id
      extra_cohorts
      extra_mentor_groups
      plan {
        id
        cohorts_included
        mentor_groups_included
      }
    }
  }
`
export const SchoolGiftSubscriptionFragmentDoc = gql`
  fragment SchoolGiftSubscription on SchoolGiftSubscription {
    id
    redeemed
    recipient_email
    recipient_email_sent_time
    recipient_first_name
    recipient_last_name
    gifted_subscription_cycles
    gift_message
    gift_code
    redemption_link
    sender {
      ...User
    }
    school_subscription_plan {
      ...SchoolSubscriptionPlan
    }
  }
  ${UserFragmentDoc}
  ${SchoolSubscriptionPlanFragmentDoc}
`
export const PositionedSchoolSubscriptionPlanFragmentDoc = gql`
  fragment PositionedSchoolSubscriptionPlan on SchoolSubscriptionPlan {
    ...SchoolSubscriptionPlan
    position
  }
  ${SchoolSubscriptionPlanFragmentDoc}
`
export const TagAttachmentFragmentDoc = gql`
  fragment TagAttachment on TagAttachment {
    id
    position
    resource_id
  }
`
export const HomeCohortMembersFragmentDoc = gql`
  fragment HomeCohortMembers on Group {
    ...GroupListItem
    user_registration {
      ...GroupListItemRegistration
    }
  }
  ${GroupListItemFragmentDoc}
  ${GroupListItemRegistrationFragmentDoc}
`
export const ResourceCopyConfigPartialFragmentDoc = gql`
  fragment ResourceCopyConfigPartial on ResourceCopyConfig {
    id
    name
    lookup_key
    copy_behavior
    allow_copy_via_link
    resource {
      id
      meta {
        id
        type
        key
        title
        image(height: 150, width: 150, fit: fill) {
          src
        }
      }
    }
  }
`
export const ResourceCopyConfigFragmentDoc = gql`
  fragment ResourceCopyConfig on ResourceCopyConfig {
    ...ResourceCopyConfigPartial
    children {
      ...ResourceCopyConfigPartial
      children {
        ...ResourceCopyConfigPartial
        children {
          ...ResourceCopyConfigPartial
        }
      }
    }
  }
  ${ResourceCopyConfigPartialFragmentDoc}
`
export const ResourceCopyConfigLinkFragmentDoc = gql`
  fragment ResourceCopyConfigLink on ResourceCopyConfigLink {
    id
    createdTime
    copiedTime
    resourceId
    cohortId
    copierRegistrationId
    hideFromLocations
    resourceCopyConfig {
      ...ResourceCopyConfig
    }
  }
  ${ResourceCopyConfigFragmentDoc}
`
export const HomeResourceFragmentDoc = gql`
  fragment HomeResource on Resource {
    ...Resource
    groups(first: 1, status: in_progress) {
      total
    }
  }
  ${ResourceFragmentDoc}
`
export const HomeGroupFragmentDoc = gql`
  fragment HomeGroup on Group {
    ...Group
    user_registration {
      id
      role
      path_id
    }
    user_source_registration {
      id
      role
    }
  }
  ${GroupFragmentDoc}
`
export const HomeRegistrationFragmentDoc = gql`
  fragment HomeRegistration on Registration {
    id
    role
    completion_state
    send_due_notifications
    send_discussion_notifications
    softArchivedTime
    last_activity_time
    expiration_dtime
    created
    position
    user {
      id
      display_name
      profile {
        id
        image
      }
    }
    resource {
      ...HomeResource
    }
    group {
      ...HomeGroup
    }
    path {
      id
      progress
      completion_date
    }
  }
  ${HomeResourceFragmentDoc}
  ${HomeGroupFragmentDoc}
`
export const HomeResourceCopyConfigLinkFragmentDoc = gql`
  fragment HomeResourceCopyConfigLink on ResourceCopyConfigLink {
    ...ResourceCopyConfigLink
    copierRegistration {
      ...HomeRegistration
    }
  }
  ${ResourceCopyConfigLinkFragmentDoc}
  ${HomeRegistrationFragmentDoc}
`
export const MentorGroupMembershipFragmentDoc = gql`
  fragment MentorGroupMembership on MentorGroupMembership {
    id
    role
    created
    access_revoked_time
    group_id
    send_mentor_digest
    can_review
    user {
      ...User
    }
  }
  ${UserFragmentDoc}
`
export const MentorGroupFragmentDoc = gql`
  fragment MentorGroup on MentorGroup {
    id
    type
    slug
    name
    description
    created
    modified
    parent_id
    has_child_groups
    seat_limit
    seats_filled
    seats_available
    owner {
      ...User
    }
    permissions {
      can_add_member
      can_add_moderator
      can_add_admin
      can_add_group
      can_edit_group
      can_change_parent
      can_edit_subscription
      can_delete_group
      can_update_member_review_permission
      can_update_moderator_review_permission
      can_update_admin_review_permission
    }
  }
  ${UserFragmentDoc}
`
export const StripePriceFragmentDoc = gql`
  fragment StripePrice on StripePrice {
    id
    active
    billing_scheme
    currency
    nickname
    recurring_interval
    recurring_interval_count
    stripe_price_id
    stripe_connected_account_url
    tiers_mode
    unit_amount_decimal
    tiers {
      up_to
      flat_amount
      flat_amount_decimal
      unit_amount
      unit_amount_decimal
    }
    product {
      id
      min_quantity
      max_quantity
    }
  }
`
export const StripeProductFragmentDoc = gql`
  fragment StripeProduct on StripeProduct {
    id
    active
    name
    description
    images
    unit_label
    stripe_product_id
    stripe_connected_account_url
    min_quantity
    max_quantity
  }
`
export const SchoolGroupSubscriptionFragmentDoc = gql`
  fragment SchoolGroupSubscription on SchoolGroupSubscription {
    id
    price {
      ...StripePrice
      product {
        ...StripeProduct
      }
    }
    user {
      ...User
    }
    subscription {
      ...Subscription
    }
    community_group {
      ...MentorGroup
    }
  }
  ${StripePriceFragmentDoc}
  ${StripeProductFragmentDoc}
  ${UserFragmentDoc}
  ${SubscriptionFragmentDoc}
  ${MentorGroupFragmentDoc}
`
export const MentorGroupSubscriptionFragmentDoc = gql`
  fragment MentorGroupSubscription on MentorGroup {
    ...MentorGroup
    memberships(first: 5) {
      total
      edges {
        node {
          id
          user {
            ...User
          }
        }
      }
    }
    group_subscription {
      ...SchoolGroupSubscription
    }
  }
  ${MentorGroupFragmentDoc}
  ${UserFragmentDoc}
  ${SchoolGroupSubscriptionFragmentDoc}
`
export const UserMentorGroupSubscriptionMembershipFragmentDoc = gql`
  fragment UserMentorGroupSubscriptionMembership on MentorGroupMembership {
    ...MentorGroupMembership
    group {
      ...MentorGroupSubscription
    }
  }
  ${MentorGroupMembershipFragmentDoc}
  ${MentorGroupSubscriptionFragmentDoc}
`
export const CreatePageDocument = gql`
  mutation CreatePage(
    $name: String!
    $title: String
    $page_type: Int
    $show_in_nav: Boolean = false
    $mode: String
  ) {
    createPage(
      name: $name
      title: $title
      page_type: $page_type
      show_in_nav: $show_in_nav
      mode: $mode
    ) {
      ...Page
    }
  }
  ${PageFragmentDoc}
`
export type CreatePageMutationFn = Apollo.MutationFunction<
  CreatePageMutation,
  CreatePageMutationVariables
>

/**
 * __useCreatePageMutation__
 *
 * To run a mutation, you first call `useCreatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageMutation, { data, loading, error }] = useCreatePageMutation({
 *   variables: {
 *      name: // value for 'name'
 *      title: // value for 'title'
 *      page_type: // value for 'page_type'
 *      show_in_nav: // value for 'show_in_nav'
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useCreatePageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePageMutation,
    CreatePageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreatePageMutation, CreatePageMutationVariables>(
    CreatePageDocument,
    options
  )
}
export type CreatePageMutationHookResult = ReturnType<
  typeof useCreatePageMutation
>
export type CreatePageMutationResult = Apollo.MutationResult<CreatePageMutation>
export type CreatePageMutationOptions = Apollo.BaseMutationOptions<
  CreatePageMutation,
  CreatePageMutationVariables
>
export const PageDocument = gql`
  query Page($id: Int, $page_type: Int, $slug: String, $is_live: Boolean) {
    school {
      ...School
      page(id: $id, page_type: $page_type, slug: $slug, is_live: $is_live) {
        ...Page
      }
    }
  }
  ${SchoolFragmentDoc}
  ${PageFragmentDoc}
`

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      page_type: // value for 'page_type'
 *      slug: // value for 'slug'
 *      is_live: // value for 'is_live'
 *   },
 * });
 */
export function usePageQuery(
  baseOptions?: Apollo.QueryHookOptions<PageQuery, PageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PageQuery, PageQueryVariables>(PageDocument, options)
}
export function usePageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PageQuery, PageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PageQuery, PageQueryVariables>(
    PageDocument,
    options
  )
}
export function usePageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PageQuery, PageQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PageQuery, PageQueryVariables>(
    PageDocument,
    options
  )
}
export type PageQueryHookResult = ReturnType<typeof usePageQuery>
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>
export type PageSuspenseQueryHookResult = ReturnType<
  typeof usePageSuspenseQuery
>
export type PageQueryResult = Apollo.QueryResult<PageQuery, PageQueryVariables>
export const PagesDocument = gql`
  query Pages($first: Int = 10, $isLive: Boolean, $showInNav: Boolean) {
    school {
      ...School
      pages(first: $first, is_live: $isLive, show_in_nav: $showInNav) {
        edges {
          node {
            ...Page
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${PageFragmentDoc}
`

/**
 * __usePagesQuery__
 *
 * To run a query within a React component, call `usePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      isLive: // value for 'isLive'
 *      showInNav: // value for 'showInNav'
 *   },
 * });
 */
export function usePagesQuery(
  baseOptions?: Apollo.QueryHookOptions<PagesQuery, PagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PagesQuery, PagesQueryVariables>(
    PagesDocument,
    options
  )
}
export function usePagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PagesQuery, PagesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PagesQuery, PagesQueryVariables>(
    PagesDocument,
    options
  )
}
export function usePagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PagesQuery, PagesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PagesQuery, PagesQueryVariables>(
    PagesDocument,
    options
  )
}
export type PagesQueryHookResult = ReturnType<typeof usePagesQuery>
export type PagesLazyQueryHookResult = ReturnType<typeof usePagesLazyQuery>
export type PagesSuspenseQueryHookResult = ReturnType<
  typeof usePagesSuspenseQuery
>
export type PagesQueryResult = Apollo.QueryResult<
  PagesQuery,
  PagesQueryVariables
>
export const UpdatePageDocument = gql`
  mutation UpdatePage(
    $id: Int!
    $name: String
    $page_type: Int
    $title: String
    $description: String
    $slug: String
    $show_in_nav: Boolean
    $external_url: String
    $iframe_url: String
    $template_content: String
    $scripts: String
    $mode: String
    $is_live: Boolean
    $content_type: Int
  ) {
    updatePage(
      id: $id
      name: $name
      page_type: $page_type
      title: $title
      description: $description
      slug: $slug
      show_in_nav: $show_in_nav
      external_url: $external_url
      iframe_url: $iframe_url
      template_content: $template_content
      scripts: $scripts
      mode: $mode
      is_live: $is_live
      content_type: $content_type
    ) {
      ...Page
    }
  }
  ${PageFragmentDoc}
`
export type UpdatePageMutationFn = Apollo.MutationFunction<
  UpdatePageMutation,
  UpdatePageMutationVariables
>

/**
 * __useUpdatePageMutation__
 *
 * To run a mutation, you first call `useUpdatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageMutation, { data, loading, error }] = useUpdatePageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      page_type: // value for 'page_type'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      slug: // value for 'slug'
 *      show_in_nav: // value for 'show_in_nav'
 *      external_url: // value for 'external_url'
 *      iframe_url: // value for 'iframe_url'
 *      template_content: // value for 'template_content'
 *      scripts: // value for 'scripts'
 *      mode: // value for 'mode'
 *      is_live: // value for 'is_live'
 *      content_type: // value for 'content_type'
 *   },
 * });
 */
export function useUpdatePageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePageMutation,
    UpdatePageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdatePageMutation, UpdatePageMutationVariables>(
    UpdatePageDocument,
    options
  )
}
export type UpdatePageMutationHookResult = ReturnType<
  typeof useUpdatePageMutation
>
export type UpdatePageMutationResult = Apollo.MutationResult<UpdatePageMutation>
export type UpdatePageMutationOptions = Apollo.BaseMutationOptions<
  UpdatePageMutation,
  UpdatePageMutationVariables
>
export const UpdatePageOrdersDocument = gql`
  mutation UpdatePageOrders($page_orders: [ListOrderInput!]!) {
    updatePageOrders(page_orders: $page_orders)
  }
`
export type UpdatePageOrdersMutationFn = Apollo.MutationFunction<
  UpdatePageOrdersMutation,
  UpdatePageOrdersMutationVariables
>

/**
 * __useUpdatePageOrdersMutation__
 *
 * To run a mutation, you first call `useUpdatePageOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageOrdersMutation, { data, loading, error }] = useUpdatePageOrdersMutation({
 *   variables: {
 *      page_orders: // value for 'page_orders'
 *   },
 * });
 */
export function useUpdatePageOrdersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePageOrdersMutation,
    UpdatePageOrdersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdatePageOrdersMutation,
    UpdatePageOrdersMutationVariables
  >(UpdatePageOrdersDocument, options)
}
export type UpdatePageOrdersMutationHookResult = ReturnType<
  typeof useUpdatePageOrdersMutation
>
export type UpdatePageOrdersMutationResult =
  Apollo.MutationResult<UpdatePageOrdersMutation>
export type UpdatePageOrdersMutationOptions = Apollo.BaseMutationOptions<
  UpdatePageOrdersMutation,
  UpdatePageOrdersMutationVariables
>
export const CreateSchoolThemeDocument = gql`
  mutation CreateSchoolTheme($theme: ThemeInput!) {
    createSchoolTheme(theme: $theme) {
      ...Theme
    }
  }
  ${ThemeFragmentDoc}
`
export type CreateSchoolThemeMutationFn = Apollo.MutationFunction<
  CreateSchoolThemeMutation,
  CreateSchoolThemeMutationVariables
>

/**
 * __useCreateSchoolThemeMutation__
 *
 * To run a mutation, you first call `useCreateSchoolThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchoolThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchoolThemeMutation, { data, loading, error }] = useCreateSchoolThemeMutation({
 *   variables: {
 *      theme: // value for 'theme'
 *   },
 * });
 */
export function useCreateSchoolThemeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSchoolThemeMutation,
    CreateSchoolThemeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateSchoolThemeMutation,
    CreateSchoolThemeMutationVariables
  >(CreateSchoolThemeDocument, options)
}
export type CreateSchoolThemeMutationHookResult = ReturnType<
  typeof useCreateSchoolThemeMutation
>
export type CreateSchoolThemeMutationResult =
  Apollo.MutationResult<CreateSchoolThemeMutation>
export type CreateSchoolThemeMutationOptions = Apollo.BaseMutationOptions<
  CreateSchoolThemeMutation,
  CreateSchoolThemeMutationVariables
>
export const UpdateSchoolThemeDocument = gql`
  mutation UpdateSchoolTheme($id: Int!, $theme: ThemeInput!) {
    updateSchoolTheme(id: $id, theme: $theme) {
      ...Theme
    }
  }
  ${ThemeFragmentDoc}
`
export type UpdateSchoolThemeMutationFn = Apollo.MutationFunction<
  UpdateSchoolThemeMutation,
  UpdateSchoolThemeMutationVariables
>

/**
 * __useUpdateSchoolThemeMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchoolThemeMutation, { data, loading, error }] = useUpdateSchoolThemeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      theme: // value for 'theme'
 *   },
 * });
 */
export function useUpdateSchoolThemeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSchoolThemeMutation,
    UpdateSchoolThemeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateSchoolThemeMutation,
    UpdateSchoolThemeMutationVariables
  >(UpdateSchoolThemeDocument, options)
}
export type UpdateSchoolThemeMutationHookResult = ReturnType<
  typeof useUpdateSchoolThemeMutation
>
export type UpdateSchoolThemeMutationResult =
  Apollo.MutationResult<UpdateSchoolThemeMutation>
export type UpdateSchoolThemeMutationOptions = Apollo.BaseMutationOptions<
  UpdateSchoolThemeMutation,
  UpdateSchoolThemeMutationVariables
>
export const AssignResourceDocument = gql`
  query AssignResource(
    $id: Int
    $assignConfig: AssignConfig
    $search: String
    $cursor: String
  ) {
    resource(id: $id) {
      ...Resource
      cohorts: groups(
        first: 10
        assign_config: $assignConfig
        search: $search
        after: $cursor
      ) {
        total
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...Group
          }
        }
      }
    }
  }
  ${ResourceFragmentDoc}
  ${GroupFragmentDoc}
`

/**
 * __useAssignResourceQuery__
 *
 * To run a query within a React component, call `useAssignResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      assignConfig: // value for 'assignConfig'
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useAssignResourceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AssignResourceQuery,
    AssignResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AssignResourceQuery, AssignResourceQueryVariables>(
    AssignResourceDocument,
    options
  )
}
export function useAssignResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignResourceQuery,
    AssignResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AssignResourceQuery, AssignResourceQueryVariables>(
    AssignResourceDocument,
    options
  )
}
export function useAssignResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignResourceQuery,
        AssignResourceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AssignResourceQuery,
    AssignResourceQueryVariables
  >(AssignResourceDocument, options)
}
export type AssignResourceQueryHookResult = ReturnType<
  typeof useAssignResourceQuery
>
export type AssignResourceLazyQueryHookResult = ReturnType<
  typeof useAssignResourceLazyQuery
>
export type AssignResourceSuspenseQueryHookResult = ReturnType<
  typeof useAssignResourceSuspenseQuery
>
export type AssignResourceQueryResult = Apollo.QueryResult<
  AssignResourceQuery,
  AssignResourceQueryVariables
>
export const GetTokenViaSsoDocument = gql`
  mutation GetTokenViaSSO($ssoToken: String!) {
    getTokenViaSSO(sso_token: $ssoToken) {
      token
    }
  }
`
export type GetTokenViaSsoMutationFn = Apollo.MutationFunction<
  GetTokenViaSsoMutation,
  GetTokenViaSsoMutationVariables
>

/**
 * __useGetTokenViaSsoMutation__
 *
 * To run a mutation, you first call `useGetTokenViaSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetTokenViaSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getTokenViaSsoMutation, { data, loading, error }] = useGetTokenViaSsoMutation({
 *   variables: {
 *      ssoToken: // value for 'ssoToken'
 *   },
 * });
 */
export function useGetTokenViaSsoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetTokenViaSsoMutation,
    GetTokenViaSsoMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GetTokenViaSsoMutation,
    GetTokenViaSsoMutationVariables
  >(GetTokenViaSsoDocument, options)
}
export type GetTokenViaSsoMutationHookResult = ReturnType<
  typeof useGetTokenViaSsoMutation
>
export type GetTokenViaSsoMutationResult =
  Apollo.MutationResult<GetTokenViaSsoMutation>
export type GetTokenViaSsoMutationOptions = Apollo.BaseMutationOptions<
  GetTokenViaSsoMutation,
  GetTokenViaSsoMutationVariables
>
export const RefreshTokenDocument = gql`
  mutation RefreshToken($school_id: ID) {
    refreshToken(school_id: $school_id)
  }
`
export type RefreshTokenMutationFn = Apollo.MutationFunction<
  RefreshTokenMutation,
  RefreshTokenMutationVariables
>

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      school_id: // value for 'school_id'
 *   },
 * });
 */
export function useRefreshTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshTokenMutation,
    RefreshTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RefreshTokenMutation,
    RefreshTokenMutationVariables
  >(RefreshTokenDocument, options)
}
export type RefreshTokenMutationHookResult = ReturnType<
  typeof useRefreshTokenMutation
>
export type RefreshTokenMutationResult =
  Apollo.MutationResult<RefreshTokenMutation>
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<
  RefreshTokenMutation,
  RefreshTokenMutationVariables
>
export const AuthorDocument = gql`
  query Author($id: Int, $slug: String) {
    school {
      ...School
      author(id: $id, slug: $slug) {
        ...Author
      }
    }
  }
  ${SchoolFragmentDoc}
  ${AuthorFragmentDoc}
`

/**
 * __useAuthorQuery__
 *
 * To run a query within a React component, call `useAuthorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useAuthorQuery(
  baseOptions?: Apollo.QueryHookOptions<AuthorQuery, AuthorQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AuthorQuery, AuthorQueryVariables>(
    AuthorDocument,
    options
  )
}
export function useAuthorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AuthorQuery, AuthorQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AuthorQuery, AuthorQueryVariables>(
    AuthorDocument,
    options
  )
}
export function useAuthorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AuthorQuery, AuthorQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<AuthorQuery, AuthorQueryVariables>(
    AuthorDocument,
    options
  )
}
export type AuthorQueryHookResult = ReturnType<typeof useAuthorQuery>
export type AuthorLazyQueryHookResult = ReturnType<typeof useAuthorLazyQuery>
export type AuthorSuspenseQueryHookResult = ReturnType<
  typeof useAuthorSuspenseQuery
>
export type AuthorQueryResult = Apollo.QueryResult<
  AuthorQuery,
  AuthorQueryVariables
>
export const AuthorsDocument = gql`
  query Authors(
    $first: Int!
    $cursor: String
    $school_id: Int!
    $search: String
    $ids: IDFilter
    $manage: Boolean
  ) {
    context(school_id: $school_id) {
      school {
        ...School
        authors(
          first: $first
          after: $cursor
          search: $search
          ids: $ids
          manage: $manage
        ) {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...Author
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${AuthorFragmentDoc}
`

/**
 * __useAuthorsQuery__
 *
 * To run a query within a React component, call `useAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      school_id: // value for 'school_id'
 *      search: // value for 'search'
 *      ids: // value for 'ids'
 *      manage: // value for 'manage'
 *   },
 * });
 */
export function useAuthorsQuery(
  baseOptions: Apollo.QueryHookOptions<AuthorsQuery, AuthorsQueryVariables> &
    ({ variables: AuthorsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AuthorsQuery, AuthorsQueryVariables>(
    AuthorsDocument,
    options
  )
}
export function useAuthorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<AuthorsQuery, AuthorsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<AuthorsQuery, AuthorsQueryVariables>(
    AuthorsDocument,
    options
  )
}
export function useAuthorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<AuthorsQuery, AuthorsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<AuthorsQuery, AuthorsQueryVariables>(
    AuthorsDocument,
    options
  )
}
export type AuthorsQueryHookResult = ReturnType<typeof useAuthorsQuery>
export type AuthorsLazyQueryHookResult = ReturnType<typeof useAuthorsLazyQuery>
export type AuthorsSuspenseQueryHookResult = ReturnType<
  typeof useAuthorsSuspenseQuery
>
export type AuthorsQueryResult = Apollo.QueryResult<
  AuthorsQuery,
  AuthorsQueryVariables
>
export const BannerDocument = gql`
  query Banner($school_id: Int!, $id: Int!) {
    context(school_id: $school_id) {
      school {
        ...School
        banner(id: $id) {
          ...Banner
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${BannerFragmentDoc}
`

/**
 * __useBannerQuery__
 *
 * To run a query within a React component, call `useBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBannerQuery({
 *   variables: {
 *      school_id: // value for 'school_id'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBannerQuery(
  baseOptions: Apollo.QueryHookOptions<BannerQuery, BannerQueryVariables> &
    ({ variables: BannerQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<BannerQuery, BannerQueryVariables>(
    BannerDocument,
    options
  )
}
export function useBannerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<BannerQuery, BannerQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<BannerQuery, BannerQueryVariables>(
    BannerDocument,
    options
  )
}
export function useBannerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<BannerQuery, BannerQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<BannerQuery, BannerQueryVariables>(
    BannerDocument,
    options
  )
}
export type BannerQueryHookResult = ReturnType<typeof useBannerQuery>
export type BannerLazyQueryHookResult = ReturnType<typeof useBannerLazyQuery>
export type BannerSuspenseQueryHookResult = ReturnType<
  typeof useBannerSuspenseQuery
>
export type BannerQueryResult = Apollo.QueryResult<
  BannerQuery,
  BannerQueryVariables
>
export const BannersDocument = gql`
  query Banners(
    $cursor: String
    $school_id: Int!
    $first: Int!
    $manage: Boolean = false
  ) {
    context(school_id: $school_id) {
      school {
        ...School
        banners(first: $first, after: $cursor, manage: $manage) {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...Banner
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${BannerFragmentDoc}
`

/**
 * __useBannersQuery__
 *
 * To run a query within a React component, call `useBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBannersQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      school_id: // value for 'school_id'
 *      first: // value for 'first'
 *      manage: // value for 'manage'
 *   },
 * });
 */
export function useBannersQuery(
  baseOptions: Apollo.QueryHookOptions<BannersQuery, BannersQueryVariables> &
    ({ variables: BannersQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<BannersQuery, BannersQueryVariables>(
    BannersDocument,
    options
  )
}
export function useBannersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<BannersQuery, BannersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<BannersQuery, BannersQueryVariables>(
    BannersDocument,
    options
  )
}
export function useBannersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<BannersQuery, BannersQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<BannersQuery, BannersQueryVariables>(
    BannersDocument,
    options
  )
}
export type BannersQueryHookResult = ReturnType<typeof useBannersQuery>
export type BannersLazyQueryHookResult = ReturnType<typeof useBannersLazyQuery>
export type BannersSuspenseQueryHookResult = ReturnType<
  typeof useBannersSuspenseQuery
>
export type BannersQueryResult = Apollo.QueryResult<
  BannersQuery,
  BannersQueryVariables
>
export const CreateBannerDocument = gql`
  mutation CreateBanner(
    $heading: String
    $subhead: String
    $font_color: String
    $background_image: String
    $background_type: Int
    $background_overlay: String
    $button_func: String
    $button_url: String
    $button_text: String
    $is_visible: Boolean
    $hide_for_subscription_plans: [Int]
    $show_for_subscription_plans: [Int]
    $hide_for_products: [Int]
    $show_for_products: [Int]
  ) {
    createBanner(
      heading: $heading
      subhead: $subhead
      font_color: $font_color
      background_image: $background_image
      background_type: $background_type
      background_overlay: $background_overlay
      button_func: $button_func
      button_url: $button_url
      button_text: $button_text
      is_visible: $is_visible
      hide_for_subscription_plans: $hide_for_subscription_plans
      show_for_subscription_plans: $show_for_subscription_plans
      hide_for_products: $hide_for_products
      show_for_products: $show_for_products
    ) {
      ...Banner
    }
  }
  ${BannerFragmentDoc}
`
export type CreateBannerMutationFn = Apollo.MutationFunction<
  CreateBannerMutation,
  CreateBannerMutationVariables
>

/**
 * __useCreateBannerMutation__
 *
 * To run a mutation, you first call `useCreateBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBannerMutation, { data, loading, error }] = useCreateBannerMutation({
 *   variables: {
 *      heading: // value for 'heading'
 *      subhead: // value for 'subhead'
 *      font_color: // value for 'font_color'
 *      background_image: // value for 'background_image'
 *      background_type: // value for 'background_type'
 *      background_overlay: // value for 'background_overlay'
 *      button_func: // value for 'button_func'
 *      button_url: // value for 'button_url'
 *      button_text: // value for 'button_text'
 *      is_visible: // value for 'is_visible'
 *      hide_for_subscription_plans: // value for 'hide_for_subscription_plans'
 *      show_for_subscription_plans: // value for 'show_for_subscription_plans'
 *      hide_for_products: // value for 'hide_for_products'
 *      show_for_products: // value for 'show_for_products'
 *   },
 * });
 */
export function useCreateBannerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateBannerMutation,
    CreateBannerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateBannerMutation,
    CreateBannerMutationVariables
  >(CreateBannerDocument, options)
}
export type CreateBannerMutationHookResult = ReturnType<
  typeof useCreateBannerMutation
>
export type CreateBannerMutationResult =
  Apollo.MutationResult<CreateBannerMutation>
export type CreateBannerMutationOptions = Apollo.BaseMutationOptions<
  CreateBannerMutation,
  CreateBannerMutationVariables
>
export const DeleteBannerDocument = gql`
  mutation DeleteBanner($id: Int!) {
    deleteBanner(id: $id)
  }
`
export type DeleteBannerMutationFn = Apollo.MutationFunction<
  DeleteBannerMutation,
  DeleteBannerMutationVariables
>

/**
 * __useDeleteBannerMutation__
 *
 * To run a mutation, you first call `useDeleteBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBannerMutation, { data, loading, error }] = useDeleteBannerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBannerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteBannerMutation,
    DeleteBannerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteBannerMutation,
    DeleteBannerMutationVariables
  >(DeleteBannerDocument, options)
}
export type DeleteBannerMutationHookResult = ReturnType<
  typeof useDeleteBannerMutation
>
export type DeleteBannerMutationResult =
  Apollo.MutationResult<DeleteBannerMutation>
export type DeleteBannerMutationOptions = Apollo.BaseMutationOptions<
  DeleteBannerMutation,
  DeleteBannerMutationVariables
>
export const UpdateBannerDocument = gql`
  mutation UpdateBanner(
    $id: Int!
    $heading: String
    $subhead: String
    $font_color: String
    $background_image: String
    $background_type: Int
    $background_overlay: String
    $button_func: String
    $button_url: String
    $button_text: String
    $is_visible: Boolean
    $hide_for_subscription_plans: [Int]
    $show_for_subscription_plans: [Int]
    $hide_for_products: [Int]
    $show_for_products: [Int]
  ) {
    updateBanner(
      id: $id
      heading: $heading
      subhead: $subhead
      font_color: $font_color
      background_image: $background_image
      background_type: $background_type
      background_overlay: $background_overlay
      button_func: $button_func
      button_url: $button_url
      button_text: $button_text
      is_visible: $is_visible
      hide_for_subscription_plans: $hide_for_subscription_plans
      show_for_subscription_plans: $show_for_subscription_plans
      hide_for_products: $hide_for_products
      show_for_products: $show_for_products
    ) {
      ...Banner
    }
  }
  ${BannerFragmentDoc}
`
export type UpdateBannerMutationFn = Apollo.MutationFunction<
  UpdateBannerMutation,
  UpdateBannerMutationVariables
>

/**
 * __useUpdateBannerMutation__
 *
 * To run a mutation, you first call `useUpdateBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBannerMutation, { data, loading, error }] = useUpdateBannerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      heading: // value for 'heading'
 *      subhead: // value for 'subhead'
 *      font_color: // value for 'font_color'
 *      background_image: // value for 'background_image'
 *      background_type: // value for 'background_type'
 *      background_overlay: // value for 'background_overlay'
 *      button_func: // value for 'button_func'
 *      button_url: // value for 'button_url'
 *      button_text: // value for 'button_text'
 *      is_visible: // value for 'is_visible'
 *      hide_for_subscription_plans: // value for 'hide_for_subscription_plans'
 *      show_for_subscription_plans: // value for 'show_for_subscription_plans'
 *      hide_for_products: // value for 'hide_for_products'
 *      show_for_products: // value for 'show_for_products'
 *   },
 * });
 */
export function useUpdateBannerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateBannerMutation,
    UpdateBannerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateBannerMutation,
    UpdateBannerMutationVariables
  >(UpdateBannerDocument, options)
}
export type UpdateBannerMutationHookResult = ReturnType<
  typeof useUpdateBannerMutation
>
export type UpdateBannerMutationResult =
  Apollo.MutationResult<UpdateBannerMutation>
export type UpdateBannerMutationOptions = Apollo.BaseMutationOptions<
  UpdateBannerMutation,
  UpdateBannerMutationVariables
>
export const UpdateBannerOrderDocument = gql`
  mutation UpdateBannerOrder($banner_orders: [ListOrderInput]!) {
    updateBannerOrder(banner_orders: $banner_orders)
  }
`
export type UpdateBannerOrderMutationFn = Apollo.MutationFunction<
  UpdateBannerOrderMutation,
  UpdateBannerOrderMutationVariables
>

/**
 * __useUpdateBannerOrderMutation__
 *
 * To run a mutation, you first call `useUpdateBannerOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBannerOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBannerOrderMutation, { data, loading, error }] = useUpdateBannerOrderMutation({
 *   variables: {
 *      banner_orders: // value for 'banner_orders'
 *   },
 * });
 */
export function useUpdateBannerOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateBannerOrderMutation,
    UpdateBannerOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateBannerOrderMutation,
    UpdateBannerOrderMutationVariables
  >(UpdateBannerOrderDocument, options)
}
export type UpdateBannerOrderMutationHookResult = ReturnType<
  typeof useUpdateBannerOrderMutation
>
export type UpdateBannerOrderMutationResult =
  Apollo.MutationResult<UpdateBannerOrderMutation>
export type UpdateBannerOrderMutationOptions = Apollo.BaseMutationOptions<
  UpdateBannerOrderMutation,
  UpdateBannerOrderMutationVariables
>
export const BackgroundTaskDocument = gql`
  query BackgroundTask($id: String!) {
    backgroundTask(id: $id) {
      ...BackgroundTask
    }
  }
  ${BackgroundTaskFragmentDoc}
`

/**
 * __useBackgroundTaskQuery__
 *
 * To run a query within a React component, call `useBackgroundTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackgroundTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackgroundTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBackgroundTaskQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackgroundTaskQuery,
    BackgroundTaskQueryVariables
  > &
    (
      | { variables: BackgroundTaskQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<BackgroundTaskQuery, BackgroundTaskQueryVariables>(
    BackgroundTaskDocument,
    options
  )
}
export function useBackgroundTaskLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackgroundTaskQuery,
    BackgroundTaskQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<BackgroundTaskQuery, BackgroundTaskQueryVariables>(
    BackgroundTaskDocument,
    options
  )
}
export function useBackgroundTaskSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackgroundTaskQuery,
        BackgroundTaskQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BackgroundTaskQuery,
    BackgroundTaskQueryVariables
  >(BackgroundTaskDocument, options)
}
export type BackgroundTaskQueryHookResult = ReturnType<
  typeof useBackgroundTaskQuery
>
export type BackgroundTaskLazyQueryHookResult = ReturnType<
  typeof useBackgroundTaskLazyQuery
>
export type BackgroundTaskSuspenseQueryHookResult = ReturnType<
  typeof useBackgroundTaskSuspenseQuery
>
export type BackgroundTaskQueryResult = Apollo.QueryResult<
  BackgroundTaskQuery,
  BackgroundTaskQueryVariables
>
export const BackgroundTasksDocument = gql`
  query BackgroundTasks($ids: [String]!) {
    backgroundTasks(ids: $ids) {
      ...BackgroundTask
    }
  }
  ${BackgroundTaskFragmentDoc}
`

/**
 * __useBackgroundTasksQuery__
 *
 * To run a query within a React component, call `useBackgroundTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackgroundTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackgroundTasksQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBackgroundTasksQuery(
  baseOptions: Apollo.QueryHookOptions<
    BackgroundTasksQuery,
    BackgroundTasksQueryVariables
  > &
    (
      | { variables: BackgroundTasksQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<BackgroundTasksQuery, BackgroundTasksQueryVariables>(
    BackgroundTasksDocument,
    options
  )
}
export function useBackgroundTasksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackgroundTasksQuery,
    BackgroundTasksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackgroundTasksQuery,
    BackgroundTasksQueryVariables
  >(BackgroundTasksDocument, options)
}
export function useBackgroundTasksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackgroundTasksQuery,
        BackgroundTasksQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BackgroundTasksQuery,
    BackgroundTasksQueryVariables
  >(BackgroundTasksDocument, options)
}
export type BackgroundTasksQueryHookResult = ReturnType<
  typeof useBackgroundTasksQuery
>
export type BackgroundTasksLazyQueryHookResult = ReturnType<
  typeof useBackgroundTasksLazyQuery
>
export type BackgroundTasksSuspenseQueryHookResult = ReturnType<
  typeof useBackgroundTasksSuspenseQuery
>
export type BackgroundTasksQueryResult = Apollo.QueryResult<
  BackgroundTasksQuery,
  BackgroundTasksQueryVariables
>
export const CategoriesDocument = gql`
  query Categories(
    $first: Int!
    $cursor: String
    $school_id: Int!
    $search: String
    $ids: IDFilter
    $manage: Boolean
  ) {
    context(school_id: $school_id) {
      school {
        ...School
        categories(
          first: $first
          after: $cursor
          search: $search
          ids: $ids
          manage: $manage
        ) {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...Category
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${CategoryFragmentDoc}
`

/**
 * __useCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      school_id: // value for 'school_id'
 *      search: // value for 'search'
 *      ids: // value for 'ids'
 *      manage: // value for 'manage'
 *   },
 * });
 */
export function useCategoriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    CategoriesQuery,
    CategoriesQueryVariables
  > &
    (
      | { variables: CategoriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CategoriesQuery, CategoriesQueryVariables>(
    CategoriesDocument,
    options
  )
}
export function useCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoriesQuery,
    CategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(
    CategoriesDocument,
    options
  )
}
export function useCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CategoriesQuery, CategoriesQueryVariables>(
    CategoriesDocument,
    options
  )
}
export type CategoriesQueryHookResult = ReturnType<typeof useCategoriesQuery>
export type CategoriesLazyQueryHookResult = ReturnType<
  typeof useCategoriesLazyQuery
>
export type CategoriesSuspenseQueryHookResult = ReturnType<
  typeof useCategoriesSuspenseQuery
>
export type CategoriesQueryResult = Apollo.QueryResult<
  CategoriesQuery,
  CategoriesQueryVariables
>
export const CategoryDocument = gql`
  query Category($id: Int, $slug: String) {
    school {
      ...School
      category(id: $id, slug: $slug) {
        ...Category
      }
    }
  }
  ${SchoolFragmentDoc}
  ${CategoryFragmentDoc}
`

/**
 * __useCategoryQuery__
 *
 * To run a query within a React component, call `useCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCategoryQuery(
  baseOptions?: Apollo.QueryHookOptions<CategoryQuery, CategoryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CategoryQuery, CategoryQueryVariables>(
    CategoryDocument,
    options
  )
}
export function useCategoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CategoryQuery,
    CategoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CategoryQuery, CategoryQueryVariables>(
    CategoryDocument,
    options
  )
}
export function useCategorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CategoryQuery, CategoryQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CategoryQuery, CategoryQueryVariables>(
    CategoryDocument,
    options
  )
}
export type CategoryQueryHookResult = ReturnType<typeof useCategoryQuery>
export type CategoryLazyQueryHookResult = ReturnType<
  typeof useCategoryLazyQuery
>
export type CategorySuspenseQueryHookResult = ReturnType<
  typeof useCategorySuspenseQuery
>
export type CategoryQueryResult = Apollo.QueryResult<
  CategoryQuery,
  CategoryQueryVariables
>
export const CertificatePreviewDocument = gql`
  query CertificatePreview(
    $template: String!
    $textObjects: [TextObject]!
    $variables: JSON
  ) {
    certificatePreview(
      template: $template
      text_objects: $textObjects
      variables: $variables
    )
  }
`

/**
 * __useCertificatePreviewQuery__
 *
 * To run a query within a React component, call `useCertificatePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificatePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificatePreviewQuery({
 *   variables: {
 *      template: // value for 'template'
 *      textObjects: // value for 'textObjects'
 *      variables: // value for 'variables'
 *   },
 * });
 */
export function useCertificatePreviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    CertificatePreviewQuery,
    CertificatePreviewQueryVariables
  > &
    (
      | { variables: CertificatePreviewQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CertificatePreviewQuery,
    CertificatePreviewQueryVariables
  >(CertificatePreviewDocument, options)
}
export function useCertificatePreviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CertificatePreviewQuery,
    CertificatePreviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CertificatePreviewQuery,
    CertificatePreviewQueryVariables
  >(CertificatePreviewDocument, options)
}
export function useCertificatePreviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CertificatePreviewQuery,
        CertificatePreviewQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CertificatePreviewQuery,
    CertificatePreviewQueryVariables
  >(CertificatePreviewDocument, options)
}
export type CertificatePreviewQueryHookResult = ReturnType<
  typeof useCertificatePreviewQuery
>
export type CertificatePreviewLazyQueryHookResult = ReturnType<
  typeof useCertificatePreviewLazyQuery
>
export type CertificatePreviewSuspenseQueryHookResult = ReturnType<
  typeof useCertificatePreviewSuspenseQuery
>
export type CertificatePreviewQueryResult = Apollo.QueryResult<
  CertificatePreviewQuery,
  CertificatePreviewQueryVariables
>
export const CertificateDocument = gql`
  query Certificate {
    certificate {
      ...Certificate
    }
  }
  ${CertificateFragmentDoc}
`

/**
 * __useCertificateQuery__
 *
 * To run a query within a React component, call `useCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificateQuery({
 *   variables: {
 *   },
 * });
 */
export function useCertificateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CertificateQuery,
    CertificateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CertificateQuery, CertificateQueryVariables>(
    CertificateDocument,
    options
  )
}
export function useCertificateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CertificateQuery,
    CertificateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CertificateQuery, CertificateQueryVariables>(
    CertificateDocument,
    options
  )
}
export function useCertificateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CertificateQuery,
        CertificateQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CertificateQuery, CertificateQueryVariables>(
    CertificateDocument,
    options
  )
}
export type CertificateQueryHookResult = ReturnType<typeof useCertificateQuery>
export type CertificateLazyQueryHookResult = ReturnType<
  typeof useCertificateLazyQuery
>
export type CertificateSuspenseQueryHookResult = ReturnType<
  typeof useCertificateSuspenseQuery
>
export type CertificateQueryResult = Apollo.QueryResult<
  CertificateQuery,
  CertificateQueryVariables
>
export const CertificateResourcesDocument = gql`
  query CertificateResources(
    $first: Int!
    $hasCertificate: Boolean
    $search: String
  ) {
    resources(
      first: $first
      has_certificate: $hasCertificate
      search: $search
    ) {
      total
      edges {
        node {
          ...ManageResource
        }
      }
    }
  }
  ${ManageResourceFragmentDoc}
`

/**
 * __useCertificateResourcesQuery__
 *
 * To run a query within a React component, call `useCertificateResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificateResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificateResourcesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      hasCertificate: // value for 'hasCertificate'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCertificateResourcesQuery(
  baseOptions: Apollo.QueryHookOptions<
    CertificateResourcesQuery,
    CertificateResourcesQueryVariables
  > &
    (
      | { variables: CertificateResourcesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CertificateResourcesQuery,
    CertificateResourcesQueryVariables
  >(CertificateResourcesDocument, options)
}
export function useCertificateResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CertificateResourcesQuery,
    CertificateResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CertificateResourcesQuery,
    CertificateResourcesQueryVariables
  >(CertificateResourcesDocument, options)
}
export function useCertificateResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CertificateResourcesQuery,
        CertificateResourcesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CertificateResourcesQuery,
    CertificateResourcesQueryVariables
  >(CertificateResourcesDocument, options)
}
export type CertificateResourcesQueryHookResult = ReturnType<
  typeof useCertificateResourcesQuery
>
export type CertificateResourcesLazyQueryHookResult = ReturnType<
  typeof useCertificateResourcesLazyQuery
>
export type CertificateResourcesSuspenseQueryHookResult = ReturnType<
  typeof useCertificateResourcesSuspenseQuery
>
export type CertificateResourcesQueryResult = Apollo.QueryResult<
  CertificateResourcesQuery,
  CertificateResourcesQueryVariables
>
export const CertificateVariablesDocument = gql`
  query CertificateVariables($context: CertificateVariablesContextInput) {
    certificateVariables(context: $context) {
      id
      stats
      variables
    }
  }
`

/**
 * __useCertificateVariablesQuery__
 *
 * To run a query within a React component, call `useCertificateVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificateVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificateVariablesQuery({
 *   variables: {
 *      context: // value for 'context'
 *   },
 * });
 */
export function useCertificateVariablesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CertificateVariablesQuery,
    CertificateVariablesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CertificateVariablesQuery,
    CertificateVariablesQueryVariables
  >(CertificateVariablesDocument, options)
}
export function useCertificateVariablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CertificateVariablesQuery,
    CertificateVariablesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CertificateVariablesQuery,
    CertificateVariablesQueryVariables
  >(CertificateVariablesDocument, options)
}
export function useCertificateVariablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CertificateVariablesQuery,
        CertificateVariablesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CertificateVariablesQuery,
    CertificateVariablesQueryVariables
  >(CertificateVariablesDocument, options)
}
export type CertificateVariablesQueryHookResult = ReturnType<
  typeof useCertificateVariablesQuery
>
export type CertificateVariablesLazyQueryHookResult = ReturnType<
  typeof useCertificateVariablesLazyQuery
>
export type CertificateVariablesSuspenseQueryHookResult = ReturnType<
  typeof useCertificateVariablesSuspenseQuery
>
export type CertificateVariablesQueryResult = Apollo.QueryResult<
  CertificateVariablesQuery,
  CertificateVariablesQueryVariables
>
export const CreateCertificateDocument = gql`
  mutation CreateCertificate(
    $name: String
    $template: String!
    $textObjects: [TextObject]
    $isActive: Boolean = true
  ) {
    createCertificate(
      name: $name
      template: $template
      text_objects: $textObjects
      is_active: $isActive
    ) {
      ...Certificate
    }
  }
  ${CertificateFragmentDoc}
`
export type CreateCertificateMutationFn = Apollo.MutationFunction<
  CreateCertificateMutation,
  CreateCertificateMutationVariables
>

/**
 * __useCreateCertificateMutation__
 *
 * To run a mutation, you first call `useCreateCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCertificateMutation, { data, loading, error }] = useCreateCertificateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      template: // value for 'template'
 *      textObjects: // value for 'textObjects'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCreateCertificateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCertificateMutation,
    CreateCertificateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateCertificateMutation,
    CreateCertificateMutationVariables
  >(CreateCertificateDocument, options)
}
export type CreateCertificateMutationHookResult = ReturnType<
  typeof useCreateCertificateMutation
>
export type CreateCertificateMutationResult =
  Apollo.MutationResult<CreateCertificateMutation>
export type CreateCertificateMutationOptions = Apollo.BaseMutationOptions<
  CreateCertificateMutation,
  CreateCertificateMutationVariables
>
export const DeleteCertificateDocument = gql`
  mutation DeleteCertificate($id: Int!) {
    deleteCertificate(id: $id)
  }
`
export type DeleteCertificateMutationFn = Apollo.MutationFunction<
  DeleteCertificateMutation,
  DeleteCertificateMutationVariables
>

/**
 * __useDeleteCertificateMutation__
 *
 * To run a mutation, you first call `useDeleteCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCertificateMutation, { data, loading, error }] = useDeleteCertificateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCertificateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCertificateMutation,
    DeleteCertificateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteCertificateMutation,
    DeleteCertificateMutationVariables
  >(DeleteCertificateDocument, options)
}
export type DeleteCertificateMutationHookResult = ReturnType<
  typeof useDeleteCertificateMutation
>
export type DeleteCertificateMutationResult =
  Apollo.MutationResult<DeleteCertificateMutation>
export type DeleteCertificateMutationOptions = Apollo.BaseMutationOptions<
  DeleteCertificateMutation,
  DeleteCertificateMutationVariables
>
export const ResourceCertificateContextDocument = gql`
  query ResourceCertificateContext($id: Int!) {
    resource(id: $id) {
      ...ManageResource
    }
  }
  ${ManageResourceFragmentDoc}
`

/**
 * __useResourceCertificateContextQuery__
 *
 * To run a query within a React component, call `useResourceCertificateContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceCertificateContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceCertificateContextQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourceCertificateContextQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceCertificateContextQuery,
    ResourceCertificateContextQueryVariables
  > &
    (
      | { variables: ResourceCertificateContextQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ResourceCertificateContextQuery,
    ResourceCertificateContextQueryVariables
  >(ResourceCertificateContextDocument, options)
}
export function useResourceCertificateContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceCertificateContextQuery,
    ResourceCertificateContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceCertificateContextQuery,
    ResourceCertificateContextQueryVariables
  >(ResourceCertificateContextDocument, options)
}
export function useResourceCertificateContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceCertificateContextQuery,
        ResourceCertificateContextQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceCertificateContextQuery,
    ResourceCertificateContextQueryVariables
  >(ResourceCertificateContextDocument, options)
}
export type ResourceCertificateContextQueryHookResult = ReturnType<
  typeof useResourceCertificateContextQuery
>
export type ResourceCertificateContextLazyQueryHookResult = ReturnType<
  typeof useResourceCertificateContextLazyQuery
>
export type ResourceCertificateContextSuspenseQueryHookResult = ReturnType<
  typeof useResourceCertificateContextSuspenseQuery
>
export type ResourceCertificateContextQueryResult = Apollo.QueryResult<
  ResourceCertificateContextQuery,
  ResourceCertificateContextQueryVariables
>
export const UpdateCertificateDocument = gql`
  mutation UpdateCertificate(
    $id: Int!
    $name: String
    $template: String
    $textObjects: [TextObject]
  ) {
    updateCertificate(
      id: $id
      name: $name
      template: $template
      text_objects: $textObjects
    ) {
      ...Certificate
    }
  }
  ${CertificateFragmentDoc}
`
export type UpdateCertificateMutationFn = Apollo.MutationFunction<
  UpdateCertificateMutation,
  UpdateCertificateMutationVariables
>

/**
 * __useUpdateCertificateMutation__
 *
 * To run a mutation, you first call `useUpdateCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCertificateMutation, { data, loading, error }] = useUpdateCertificateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      template: // value for 'template'
 *      textObjects: // value for 'textObjects'
 *   },
 * });
 */
export function useUpdateCertificateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCertificateMutation,
    UpdateCertificateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCertificateMutation,
    UpdateCertificateMutationVariables
  >(UpdateCertificateDocument, options)
}
export type UpdateCertificateMutationHookResult = ReturnType<
  typeof useUpdateCertificateMutation
>
export type UpdateCertificateMutationResult =
  Apollo.MutationResult<UpdateCertificateMutation>
export type UpdateCertificateMutationOptions = Apollo.BaseMutationOptions<
  UpdateCertificateMutation,
  UpdateCertificateMutationVariables
>
export const UpdateCertificateVariablesDocument = gql`
  mutation UpdateCertificateVariables(
    $merge: [CertificateVariablesMergeInput]!
    $context: CertificateVariablesContextInput
  ) {
    updateCertificateVariables(merge: $merge, context: $context) {
      id
      stats
      variables
    }
  }
`
export type UpdateCertificateVariablesMutationFn = Apollo.MutationFunction<
  UpdateCertificateVariablesMutation,
  UpdateCertificateVariablesMutationVariables
>

/**
 * __useUpdateCertificateVariablesMutation__
 *
 * To run a mutation, you first call `useUpdateCertificateVariablesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCertificateVariablesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCertificateVariablesMutation, { data, loading, error }] = useUpdateCertificateVariablesMutation({
 *   variables: {
 *      merge: // value for 'merge'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useUpdateCertificateVariablesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCertificateVariablesMutation,
    UpdateCertificateVariablesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCertificateVariablesMutation,
    UpdateCertificateVariablesMutationVariables
  >(UpdateCertificateVariablesDocument, options)
}
export type UpdateCertificateVariablesMutationHookResult = ReturnType<
  typeof useUpdateCertificateVariablesMutation
>
export type UpdateCertificateVariablesMutationResult =
  Apollo.MutationResult<UpdateCertificateVariablesMutation>
export type UpdateCertificateVariablesMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateCertificateVariablesMutation,
    UpdateCertificateVariablesMutationVariables
  >
export const CohortPermissionsDocument = gql`
  query CohortPermissions($cohortId: Int!) {
    cohort: group(id: $cohortId) {
      id
      is_source_cohort
      user_registration {
        id
        role
      }
      source {
        id
        is_source_cohort
        user_registration {
          id
          role
        }
      }
    }
  }
`

/**
 * __useCohortPermissionsQuery__
 *
 * To run a query within a React component, call `useCohortPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortPermissionsQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useCohortPermissionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CohortPermissionsQuery,
    CohortPermissionsQueryVariables
  > &
    (
      | { variables: CohortPermissionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CohortPermissionsQuery,
    CohortPermissionsQueryVariables
  >(CohortPermissionsDocument, options)
}
export function useCohortPermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CohortPermissionsQuery,
    CohortPermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CohortPermissionsQuery,
    CohortPermissionsQueryVariables
  >(CohortPermissionsDocument, options)
}
export function useCohortPermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CohortPermissionsQuery,
        CohortPermissionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CohortPermissionsQuery,
    CohortPermissionsQueryVariables
  >(CohortPermissionsDocument, options)
}
export type CohortPermissionsQueryHookResult = ReturnType<
  typeof useCohortPermissionsQuery
>
export type CohortPermissionsLazyQueryHookResult = ReturnType<
  typeof useCohortPermissionsLazyQuery
>
export type CohortPermissionsSuspenseQueryHookResult = ReturnType<
  typeof useCohortPermissionsSuspenseQuery
>
export type CohortPermissionsQueryResult = Apollo.QueryResult<
  CohortPermissionsQuery,
  CohortPermissionsQueryVariables
>
export const CohortDocument = gql`
  query Cohort($id: Int!) {
    cohort: group(id: $id) {
      ...Cohort
    }
  }
  ${CohortFragmentDoc}
`

/**
 * __useCohortQuery__
 *
 * To run a query within a React component, call `useCohortQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCohortQuery(
  baseOptions: Apollo.QueryHookOptions<CohortQuery, CohortQueryVariables> &
    ({ variables: CohortQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CohortQuery, CohortQueryVariables>(
    CohortDocument,
    options
  )
}
export function useCohortLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CohortQuery, CohortQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CohortQuery, CohortQueryVariables>(
    CohortDocument,
    options
  )
}
export function useCohortSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CohortQuery, CohortQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CohortQuery, CohortQueryVariables>(
    CohortDocument,
    options
  )
}
export type CohortQueryHookResult = ReturnType<typeof useCohortQuery>
export type CohortLazyQueryHookResult = ReturnType<typeof useCohortLazyQuery>
export type CohortSuspenseQueryHookResult = ReturnType<
  typeof useCohortSuspenseQuery
>
export type CohortQueryResult = Apollo.QueryResult<
  CohortQuery,
  CohortQueryVariables
>
export const CohortSwitcherCohortsDocument = gql`
  query CohortSwitcherCohorts(
    $first: Int = 25
    $cursor: String
    $resourceId: Int!
    $role: RoleFilter
    $search: String
  ) {
    cohorts: groups(
      first: $first
      after: $cursor
      resource_id: $resourceId
      role: $role
      search: $search
      include_curriculum: false
      status: in_progress
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...Cohort
        }
      }
    }
  }
  ${CohortFragmentDoc}
`

/**
 * __useCohortSwitcherCohortsQuery__
 *
 * To run a query within a React component, call `useCohortSwitcherCohortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortSwitcherCohortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortSwitcherCohortsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      resourceId: // value for 'resourceId'
 *      role: // value for 'role'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useCohortSwitcherCohortsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CohortSwitcherCohortsQuery,
    CohortSwitcherCohortsQueryVariables
  > &
    (
      | { variables: CohortSwitcherCohortsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CohortSwitcherCohortsQuery,
    CohortSwitcherCohortsQueryVariables
  >(CohortSwitcherCohortsDocument, options)
}
export function useCohortSwitcherCohortsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CohortSwitcherCohortsQuery,
    CohortSwitcherCohortsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CohortSwitcherCohortsQuery,
    CohortSwitcherCohortsQueryVariables
  >(CohortSwitcherCohortsDocument, options)
}
export function useCohortSwitcherCohortsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CohortSwitcherCohortsQuery,
        CohortSwitcherCohortsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CohortSwitcherCohortsQuery,
    CohortSwitcherCohortsQueryVariables
  >(CohortSwitcherCohortsDocument, options)
}
export type CohortSwitcherCohortsQueryHookResult = ReturnType<
  typeof useCohortSwitcherCohortsQuery
>
export type CohortSwitcherCohortsLazyQueryHookResult = ReturnType<
  typeof useCohortSwitcherCohortsLazyQuery
>
export type CohortSwitcherCohortsSuspenseQueryHookResult = ReturnType<
  typeof useCohortSwitcherCohortsSuspenseQuery
>
export type CohortSwitcherCohortsQueryResult = Apollo.QueryResult<
  CohortSwitcherCohortsQuery,
  CohortSwitcherCohortsQueryVariables
>
export const CohortsDocument = gql`
  query Cohorts($cursor: String) {
    groups(
      first: 1042
      after: $cursor
      role: { in: [teacher, moderator] }
      include_curriculum: false
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...Cohort
        }
      }
    }
  }
  ${CohortFragmentDoc}
`

/**
 * __useCohortsQuery__
 *
 * To run a query within a React component, call `useCohortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useCohortsQuery(
  baseOptions?: Apollo.QueryHookOptions<CohortsQuery, CohortsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CohortsQuery, CohortsQueryVariables>(
    CohortsDocument,
    options
  )
}
export function useCohortsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<CohortsQuery, CohortsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CohortsQuery, CohortsQueryVariables>(
    CohortsDocument,
    options
  )
}
export function useCohortsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CohortsQuery, CohortsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CohortsQuery, CohortsQueryVariables>(
    CohortsDocument,
    options
  )
}
export type CohortsQueryHookResult = ReturnType<typeof useCohortsQuery>
export type CohortsLazyQueryHookResult = ReturnType<typeof useCohortsLazyQuery>
export type CohortsSuspenseQueryHookResult = ReturnType<
  typeof useCohortsSuspenseQuery
>
export type CohortsQueryResult = Apollo.QueryResult<
  CohortsQuery,
  CohortsQueryVariables
>
export const CohortsStatusDocument = gql`
  query CohortsStatus($resourceId: Int!) {
    resource(id: $resourceId) {
      id
      licensed_from_school_id
      cohorts_status_meta {
        in_progress
      }
    }
  }
`

/**
 * __useCohortsStatusQuery__
 *
 * To run a query within a React component, call `useCohortsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortsStatusQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useCohortsStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    CohortsStatusQuery,
    CohortsStatusQueryVariables
  > &
    (
      | { variables: CohortsStatusQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CohortsStatusQuery, CohortsStatusQueryVariables>(
    CohortsStatusDocument,
    options
  )
}
export function useCohortsStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CohortsStatusQuery,
    CohortsStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CohortsStatusQuery, CohortsStatusQueryVariables>(
    CohortsStatusDocument,
    options
  )
}
export function useCohortsStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CohortsStatusQuery,
        CohortsStatusQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CohortsStatusQuery,
    CohortsStatusQueryVariables
  >(CohortsStatusDocument, options)
}
export type CohortsStatusQueryHookResult = ReturnType<
  typeof useCohortsStatusQuery
>
export type CohortsStatusLazyQueryHookResult = ReturnType<
  typeof useCohortsStatusLazyQuery
>
export type CohortsStatusSuspenseQueryHookResult = ReturnType<
  typeof useCohortsStatusSuspenseQuery
>
export type CohortsStatusQueryResult = Apollo.QueryResult<
  CohortsStatusQuery,
  CohortsStatusQueryVariables
>
export const CreateCohortResourceDocument = gql`
  query CreateCohortResource($id: Int!) {
    resource(id: $id) {
      id
      name
      resource_type
      image(width: 100, height: 75, fit: crop)
      background_overlay
      background_image
      source_cohort: curriculum_group {
        id
        path(type: source) {
          id
          last_synced_dtime
        }
      }
      cohorts: groups(first: 1) {
        total
        edges {
          node {
            id
            path(type: source) {
              id
              last_synced_dtime
            }
          }
        }
      }
    }
  }
`

/**
 * __useCreateCohortResourceQuery__
 *
 * To run a query within a React component, call `useCreateCohortResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateCohortResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateCohortResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateCohortResourceQuery(
  baseOptions: Apollo.QueryHookOptions<
    CreateCohortResourceQuery,
    CreateCohortResourceQueryVariables
  > &
    (
      | { variables: CreateCohortResourceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CreateCohortResourceQuery,
    CreateCohortResourceQueryVariables
  >(CreateCohortResourceDocument, options)
}
export function useCreateCohortResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CreateCohortResourceQuery,
    CreateCohortResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CreateCohortResourceQuery,
    CreateCohortResourceQueryVariables
  >(CreateCohortResourceDocument, options)
}
export function useCreateCohortResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CreateCohortResourceQuery,
        CreateCohortResourceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CreateCohortResourceQuery,
    CreateCohortResourceQueryVariables
  >(CreateCohortResourceDocument, options)
}
export type CreateCohortResourceQueryHookResult = ReturnType<
  typeof useCreateCohortResourceQuery
>
export type CreateCohortResourceLazyQueryHookResult = ReturnType<
  typeof useCreateCohortResourceLazyQuery
>
export type CreateCohortResourceSuspenseQueryHookResult = ReturnType<
  typeof useCreateCohortResourceSuspenseQuery
>
export type CreateCohortResourceQueryResult = Apollo.QueryResult<
  CreateCohortResourceQuery,
  CreateCohortResourceQueryVariables
>
export const ResourcesDocument = gql`
  query Resources(
    $cursor: String
    $resourceTypes: ResourceTypeFilter
    $search: String
  ) {
    resources(
      first: 25
      after: $cursor
      resource_types: $resourceTypes
      search: $search
      licensed_from_school: { eq: null }
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...Resource
        }
      }
    }
  }
  ${ResourceFragmentDoc}
`

/**
 * __useResourcesQuery__
 *
 * To run a query within a React component, call `useResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      resourceTypes: // value for 'resourceTypes'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useResourcesQuery(
  baseOptions?: Apollo.QueryHookOptions<ResourcesQuery, ResourcesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ResourcesQuery, ResourcesQueryVariables>(
    ResourcesDocument,
    options
  )
}
export function useResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourcesQuery,
    ResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ResourcesQuery, ResourcesQueryVariables>(
    ResourcesDocument,
    options
  )
}
export function useResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ResourcesQuery, ResourcesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ResourcesQuery, ResourcesQueryVariables>(
    ResourcesDocument,
    options
  )
}
export type ResourcesQueryHookResult = ReturnType<typeof useResourcesQuery>
export type ResourcesLazyQueryHookResult = ReturnType<
  typeof useResourcesLazyQuery
>
export type ResourcesSuspenseQueryHookResult = ReturnType<
  typeof useResourcesSuspenseQuery
>
export type ResourcesQueryResult = Apollo.QueryResult<
  ResourcesQuery,
  ResourcesQueryVariables
>
export const UpdateCohortStatusDocument = gql`
  mutation UpdateCohortStatus($id: Int!, $status: GroupStatus!) {
    updateGroupStatus(id: $id, status: $status) {
      id
      status
    }
  }
`
export type UpdateCohortStatusMutationFn = Apollo.MutationFunction<
  UpdateCohortStatusMutation,
  UpdateCohortStatusMutationVariables
>

/**
 * __useUpdateCohortStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCohortStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCohortStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCohortStatusMutation, { data, loading, error }] = useUpdateCohortStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateCohortStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCohortStatusMutation,
    UpdateCohortStatusMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateCohortStatusMutation,
    UpdateCohortStatusMutationVariables
  >(UpdateCohortStatusDocument, options)
}
export type UpdateCohortStatusMutationHookResult = ReturnType<
  typeof useUpdateCohortStatusMutation
>
export type UpdateCohortStatusMutationResult =
  Apollo.MutationResult<UpdateCohortStatusMutation>
export type UpdateCohortStatusMutationOptions = Apollo.BaseMutationOptions<
  UpdateCohortStatusMutation,
  UpdateCohortStatusMutationVariables
>
export const CompletionDocument = gql`
  query Completion($id: Int) {
    pathItem(id: $id) {
      ...PathItem
      parent {
        id
        name
      }
      path {
        id
        progress
        points {
          path_id
          total
          earned
          percentage
          total_points_possible
          has_points
        }
      }
      resource {
        id
        name
        image(width: 150, height: 150)
      }
    }
  }
  ${PathItemFragmentDoc}
`

/**
 * __useCompletionQuery__
 *
 * To run a query within a React component, call `useCompletionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompletionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CompletionQuery,
    CompletionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CompletionQuery, CompletionQueryVariables>(
    CompletionDocument,
    options
  )
}
export function useCompletionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompletionQuery,
    CompletionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CompletionQuery, CompletionQueryVariables>(
    CompletionDocument,
    options
  )
}
export function useCompletionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<CompletionQuery, CompletionQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CompletionQuery, CompletionQueryVariables>(
    CompletionDocument,
    options
  )
}
export type CompletionQueryHookResult = ReturnType<typeof useCompletionQuery>
export type CompletionLazyQueryHookResult = ReturnType<
  typeof useCompletionLazyQuery
>
export type CompletionSuspenseQueryHookResult = ReturnType<
  typeof useCompletionSuspenseQuery
>
export type CompletionQueryResult = Apollo.QueryResult<
  CompletionQuery,
  CompletionQueryVariables
>
export const CompletionsDocument = gql`
  query Completions(
    $first: Int = 50
    $user_id: Int
    $cohort_id: Int
    $group_id: Int
    $path_id: Int
    $step_id: Int
    $lesson_source_id: Int
    $source_id: Int
    $needs_review: Boolean
    $is_reviewed: Boolean
    $is_complete: Boolean
    $archivedDateFilter: [DateFilter]
    $order_by: [String]
    $cursor: String
  ) {
    pathItems(
      first: $first
      type: step
      after: $cursor
      user_id: $user_id
      cohort_id: $cohort_id
      group_id: $group_id
      step_id: $step_id
      path_id: $path_id
      lesson_source_id: $lesson_source_id
      source_id: $source_id
      needs_review: $needs_review
      is_reviewed: $is_reviewed
      is_complete: $is_complete
      reviewable: true
      archivedDateFilter: $archivedDateFilter
      order_by: $order_by
      registration_role_filter: { in: [student, moderator] }
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...CompletionsItem
        }
      }
    }
  }
  ${CompletionsItemFragmentDoc}
`

/**
 * __useCompletionsQuery__
 *
 * To run a query within a React component, call `useCompletionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      user_id: // value for 'user_id'
 *      cohort_id: // value for 'cohort_id'
 *      group_id: // value for 'group_id'
 *      path_id: // value for 'path_id'
 *      step_id: // value for 'step_id'
 *      lesson_source_id: // value for 'lesson_source_id'
 *      source_id: // value for 'source_id'
 *      needs_review: // value for 'needs_review'
 *      is_reviewed: // value for 'is_reviewed'
 *      is_complete: // value for 'is_complete'
 *      archivedDateFilter: // value for 'archivedDateFilter'
 *      order_by: // value for 'order_by'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useCompletionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CompletionsQuery,
    CompletionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CompletionsQuery, CompletionsQueryVariables>(
    CompletionsDocument,
    options
  )
}
export function useCompletionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompletionsQuery,
    CompletionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CompletionsQuery, CompletionsQueryVariables>(
    CompletionsDocument,
    options
  )
}
export function useCompletionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CompletionsQuery,
        CompletionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CompletionsQuery, CompletionsQueryVariables>(
    CompletionsDocument,
    options
  )
}
export type CompletionsQueryHookResult = ReturnType<typeof useCompletionsQuery>
export type CompletionsLazyQueryHookResult = ReturnType<
  typeof useCompletionsLazyQuery
>
export type CompletionsSuspenseQueryHookResult = ReturnType<
  typeof useCompletionsSuspenseQuery
>
export type CompletionsQueryResult = Apollo.QueryResult<
  CompletionsQuery,
  CompletionsQueryVariables
>
export const ResetCompletionFeedbackDocument = gql`
  mutation ResetCompletionFeedback($id: Int!, $pathId: Int!) {
    resetCompletionFeedback(id: $id, path_id: $pathId) {
      ...Completion
    }
  }
  ${CompletionFragmentDoc}
`
export type ResetCompletionFeedbackMutationFn = Apollo.MutationFunction<
  ResetCompletionFeedbackMutation,
  ResetCompletionFeedbackMutationVariables
>

/**
 * __useResetCompletionFeedbackMutation__
 *
 * To run a mutation, you first call `useResetCompletionFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetCompletionFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetCompletionFeedbackMutation, { data, loading, error }] = useResetCompletionFeedbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useResetCompletionFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetCompletionFeedbackMutation,
    ResetCompletionFeedbackMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ResetCompletionFeedbackMutation,
    ResetCompletionFeedbackMutationVariables
  >(ResetCompletionFeedbackDocument, options)
}
export type ResetCompletionFeedbackMutationHookResult = ReturnType<
  typeof useResetCompletionFeedbackMutation
>
export type ResetCompletionFeedbackMutationResult =
  Apollo.MutationResult<ResetCompletionFeedbackMutation>
export type ResetCompletionFeedbackMutationOptions = Apollo.BaseMutationOptions<
  ResetCompletionFeedbackMutation,
  ResetCompletionFeedbackMutationVariables
>
export const SaveCompletionFeedbackDocument = gql`
  mutation SaveCompletionFeedback(
    $id: Int!
    $pathId: Int!
    $userpointsEarned: Int!
    $userpointsExplanation: String
    $notify: Boolean
  ) {
    saveCompletionFeedback(
      id: $id
      path_id: $pathId
      userpoints_earned: $userpointsEarned
      userpoints_explanation: $userpointsExplanation
      notify: $notify
    ) {
      ...Completion
    }
  }
  ${CompletionFragmentDoc}
`
export type SaveCompletionFeedbackMutationFn = Apollo.MutationFunction<
  SaveCompletionFeedbackMutation,
  SaveCompletionFeedbackMutationVariables
>

/**
 * __useSaveCompletionFeedbackMutation__
 *
 * To run a mutation, you first call `useSaveCompletionFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCompletionFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCompletionFeedbackMutation, { data, loading, error }] = useSaveCompletionFeedbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pathId: // value for 'pathId'
 *      userpointsEarned: // value for 'userpointsEarned'
 *      userpointsExplanation: // value for 'userpointsExplanation'
 *      notify: // value for 'notify'
 *   },
 * });
 */
export function useSaveCompletionFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveCompletionFeedbackMutation,
    SaveCompletionFeedbackMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SaveCompletionFeedbackMutation,
    SaveCompletionFeedbackMutationVariables
  >(SaveCompletionFeedbackDocument, options)
}
export type SaveCompletionFeedbackMutationHookResult = ReturnType<
  typeof useSaveCompletionFeedbackMutation
>
export type SaveCompletionFeedbackMutationResult =
  Apollo.MutationResult<SaveCompletionFeedbackMutation>
export type SaveCompletionFeedbackMutationOptions = Apollo.BaseMutationOptions<
  SaveCompletionFeedbackMutation,
  SaveCompletionFeedbackMutationVariables
>
export const UserCompletionsNeedingReviewDocument = gql`
  query UserCompletionsNeedingReview($user_id: Int!) {
    pathItemStats(user_id: $user_id) {
      path_items_needing_review
    }
  }
`

/**
 * __useUserCompletionsNeedingReviewQuery__
 *
 * To run a query within a React component, call `useUserCompletionsNeedingReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCompletionsNeedingReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCompletionsNeedingReviewQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useUserCompletionsNeedingReviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserCompletionsNeedingReviewQuery,
    UserCompletionsNeedingReviewQueryVariables
  > &
    (
      | {
          variables: UserCompletionsNeedingReviewQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserCompletionsNeedingReviewQuery,
    UserCompletionsNeedingReviewQueryVariables
  >(UserCompletionsNeedingReviewDocument, options)
}
export function useUserCompletionsNeedingReviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserCompletionsNeedingReviewQuery,
    UserCompletionsNeedingReviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserCompletionsNeedingReviewQuery,
    UserCompletionsNeedingReviewQueryVariables
  >(UserCompletionsNeedingReviewDocument, options)
}
export function useUserCompletionsNeedingReviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserCompletionsNeedingReviewQuery,
        UserCompletionsNeedingReviewQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserCompletionsNeedingReviewQuery,
    UserCompletionsNeedingReviewQueryVariables
  >(UserCompletionsNeedingReviewDocument, options)
}
export type UserCompletionsNeedingReviewQueryHookResult = ReturnType<
  typeof useUserCompletionsNeedingReviewQuery
>
export type UserCompletionsNeedingReviewLazyQueryHookResult = ReturnType<
  typeof useUserCompletionsNeedingReviewLazyQuery
>
export type UserCompletionsNeedingReviewSuspenseQueryHookResult = ReturnType<
  typeof useUserCompletionsNeedingReviewSuspenseQuery
>
export type UserCompletionsNeedingReviewQueryResult = Apollo.QueryResult<
  UserCompletionsNeedingReviewQuery,
  UserCompletionsNeedingReviewQueryVariables
>
export const CoverPageOffersDocument = gql`
  query CoverPageOffers($resourceId: Int!, $first: Int = 50) {
    offerConnections(resource_id: $resourceId, first: $first) {
      edges {
        node {
          ...CoverPageOffer
        }
      }
    }
  }
  ${CoverPageOfferFragmentDoc}
`

/**
 * __useCoverPageOffersQuery__
 *
 * To run a query within a React component, call `useCoverPageOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoverPageOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoverPageOffersQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useCoverPageOffersQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoverPageOffersQuery,
    CoverPageOffersQueryVariables
  > &
    (
      | { variables: CoverPageOffersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CoverPageOffersQuery, CoverPageOffersQueryVariables>(
    CoverPageOffersDocument,
    options
  )
}
export function useCoverPageOffersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoverPageOffersQuery,
    CoverPageOffersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CoverPageOffersQuery,
    CoverPageOffersQueryVariables
  >(CoverPageOffersDocument, options)
}
export function useCoverPageOffersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoverPageOffersQuery,
        CoverPageOffersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CoverPageOffersQuery,
    CoverPageOffersQueryVariables
  >(CoverPageOffersDocument, options)
}
export type CoverPageOffersQueryHookResult = ReturnType<
  typeof useCoverPageOffersQuery
>
export type CoverPageOffersLazyQueryHookResult = ReturnType<
  typeof useCoverPageOffersLazyQuery
>
export type CoverPageOffersSuspenseQueryHookResult = ReturnType<
  typeof useCoverPageOffersSuspenseQuery
>
export type CoverPageOffersQueryResult = Apollo.QueryResult<
  CoverPageOffersQuery,
  CoverPageOffersQueryVariables
>
export const CoverPageRelatedResourcesDocument = gql`
  query CoverPageRelatedResources(
    $idFilter: IDFilter
    $categoryIdFilter: IDFilter
    $resourceTypeFilter: ResourceTypeFilter
    $first: Int!
    $orderBy: String
    $cursor: String
  ) {
    resources(
      id: $idFilter
      category_ids: $categoryIdFilter
      resource_types: $resourceTypeFilter
      first: $first
      orderBy: $orderBy
      after: $cursor
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          publisher {
            name
          }
          ...CoverPageResource
        }
      }
    }
  }
  ${CoverPageResourceFragmentDoc}
`

/**
 * __useCoverPageRelatedResourcesQuery__
 *
 * To run a query within a React component, call `useCoverPageRelatedResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoverPageRelatedResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoverPageRelatedResourcesQuery({
 *   variables: {
 *      idFilter: // value for 'idFilter'
 *      categoryIdFilter: // value for 'categoryIdFilter'
 *      resourceTypeFilter: // value for 'resourceTypeFilter'
 *      first: // value for 'first'
 *      orderBy: // value for 'orderBy'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useCoverPageRelatedResourcesQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoverPageRelatedResourcesQuery,
    CoverPageRelatedResourcesQueryVariables
  > &
    (
      | { variables: CoverPageRelatedResourcesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CoverPageRelatedResourcesQuery,
    CoverPageRelatedResourcesQueryVariables
  >(CoverPageRelatedResourcesDocument, options)
}
export function useCoverPageRelatedResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoverPageRelatedResourcesQuery,
    CoverPageRelatedResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CoverPageRelatedResourcesQuery,
    CoverPageRelatedResourcesQueryVariables
  >(CoverPageRelatedResourcesDocument, options)
}
export function useCoverPageRelatedResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoverPageRelatedResourcesQuery,
        CoverPageRelatedResourcesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CoverPageRelatedResourcesQuery,
    CoverPageRelatedResourcesQueryVariables
  >(CoverPageRelatedResourcesDocument, options)
}
export type CoverPageRelatedResourcesQueryHookResult = ReturnType<
  typeof useCoverPageRelatedResourcesQuery
>
export type CoverPageRelatedResourcesLazyQueryHookResult = ReturnType<
  typeof useCoverPageRelatedResourcesLazyQuery
>
export type CoverPageRelatedResourcesSuspenseQueryHookResult = ReturnType<
  typeof useCoverPageRelatedResourcesSuspenseQuery
>
export type CoverPageRelatedResourcesQueryResult = Apollo.QueryResult<
  CoverPageRelatedResourcesQuery,
  CoverPageRelatedResourcesQueryVariables
>
export const CoverPageResourceDocument = gql`
  query CoverPageResource($id: Int) {
    resource(id: $id) {
      ...CoverPageResource
    }
  }
  ${CoverPageResourceFragmentDoc}
`

/**
 * __useCoverPageResourceQuery__
 *
 * To run a query within a React component, call `useCoverPageResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoverPageResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoverPageResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCoverPageResourceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CoverPageResourceQuery,
    CoverPageResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CoverPageResourceQuery,
    CoverPageResourceQueryVariables
  >(CoverPageResourceDocument, options)
}
export function useCoverPageResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoverPageResourceQuery,
    CoverPageResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CoverPageResourceQuery,
    CoverPageResourceQueryVariables
  >(CoverPageResourceDocument, options)
}
export function useCoverPageResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoverPageResourceQuery,
        CoverPageResourceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CoverPageResourceQuery,
    CoverPageResourceQueryVariables
  >(CoverPageResourceDocument, options)
}
export type CoverPageResourceQueryHookResult = ReturnType<
  typeof useCoverPageResourceQuery
>
export type CoverPageResourceLazyQueryHookResult = ReturnType<
  typeof useCoverPageResourceLazyQuery
>
export type CoverPageResourceSuspenseQueryHookResult = ReturnType<
  typeof useCoverPageResourceSuspenseQuery
>
export type CoverPageResourceQueryResult = Apollo.QueryResult<
  CoverPageResourceQuery,
  CoverPageResourceQueryVariables
>
export const CreateDiscussionLikeDocument = gql`
  mutation CreateDiscussionLike(
    $context: DiscussionContextInput!
    $discussion_id: Int!
  ) {
    createDiscussionLike(context: $context, discussion_id: $discussion_id) {
      ...DiscussionPost
    }
  }
  ${DiscussionPostFragmentDoc}
`
export type CreateDiscussionLikeMutationFn = Apollo.MutationFunction<
  CreateDiscussionLikeMutation,
  CreateDiscussionLikeMutationVariables
>

/**
 * __useCreateDiscussionLikeMutation__
 *
 * To run a mutation, you first call `useCreateDiscussionLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscussionLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscussionLikeMutation, { data, loading, error }] = useCreateDiscussionLikeMutation({
 *   variables: {
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *   },
 * });
 */
export function useCreateDiscussionLikeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDiscussionLikeMutation,
    CreateDiscussionLikeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateDiscussionLikeMutation,
    CreateDiscussionLikeMutationVariables
  >(CreateDiscussionLikeDocument, options)
}
export type CreateDiscussionLikeMutationHookResult = ReturnType<
  typeof useCreateDiscussionLikeMutation
>
export type CreateDiscussionLikeMutationResult =
  Apollo.MutationResult<CreateDiscussionLikeMutation>
export type CreateDiscussionLikeMutationOptions = Apollo.BaseMutationOptions<
  CreateDiscussionLikeMutation,
  CreateDiscussionLikeMutationVariables
>
export const CreateDiscussionDocument = gql`
  mutation CreateDiscussion(
    $context: DiscussionContextInput!
    $post: DiscussionPostInput!
    $initialResponse: DiscussionResponseInput
    $notify: Boolean = false
  ) {
    createDiscussion(
      context: $context
      post: $post
      initialResponse: $initialResponse
      notify: $notify
    ) {
      ...DiscussionPost
    }
  }
  ${DiscussionPostFragmentDoc}
`
export type CreateDiscussionMutationFn = Apollo.MutationFunction<
  CreateDiscussionMutation,
  CreateDiscussionMutationVariables
>

/**
 * __useCreateDiscussionMutation__
 *
 * To run a mutation, you first call `useCreateDiscussionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscussionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscussionMutation, { data, loading, error }] = useCreateDiscussionMutation({
 *   variables: {
 *      context: // value for 'context'
 *      post: // value for 'post'
 *      initialResponse: // value for 'initialResponse'
 *      notify: // value for 'notify'
 *   },
 * });
 */
export function useCreateDiscussionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDiscussionMutation,
    CreateDiscussionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateDiscussionMutation,
    CreateDiscussionMutationVariables
  >(CreateDiscussionDocument, options)
}
export type CreateDiscussionMutationHookResult = ReturnType<
  typeof useCreateDiscussionMutation
>
export type CreateDiscussionMutationResult =
  Apollo.MutationResult<CreateDiscussionMutation>
export type CreateDiscussionMutationOptions = Apollo.BaseMutationOptions<
  CreateDiscussionMutation,
  CreateDiscussionMutationVariables
>
export const CreateDiscussionResponseLikeDocument = gql`
  mutation CreateDiscussionResponseLike(
    $context: DiscussionContextInput!
    $discussion_id: Int!
    $response_id: Int!
  ) {
    createDiscussionResponseLike(
      context: $context
      discussion_id: $discussion_id
      response_id: $response_id
    ) {
      ...DiscussionResponse
    }
  }
  ${DiscussionResponseFragmentDoc}
`
export type CreateDiscussionResponseLikeMutationFn = Apollo.MutationFunction<
  CreateDiscussionResponseLikeMutation,
  CreateDiscussionResponseLikeMutationVariables
>

/**
 * __useCreateDiscussionResponseLikeMutation__
 *
 * To run a mutation, you first call `useCreateDiscussionResponseLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscussionResponseLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscussionResponseLikeMutation, { data, loading, error }] = useCreateDiscussionResponseLikeMutation({
 *   variables: {
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *      response_id: // value for 'response_id'
 *   },
 * });
 */
export function useCreateDiscussionResponseLikeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDiscussionResponseLikeMutation,
    CreateDiscussionResponseLikeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateDiscussionResponseLikeMutation,
    CreateDiscussionResponseLikeMutationVariables
  >(CreateDiscussionResponseLikeDocument, options)
}
export type CreateDiscussionResponseLikeMutationHookResult = ReturnType<
  typeof useCreateDiscussionResponseLikeMutation
>
export type CreateDiscussionResponseLikeMutationResult =
  Apollo.MutationResult<CreateDiscussionResponseLikeMutation>
export type CreateDiscussionResponseLikeMutationOptions =
  Apollo.BaseMutationOptions<
    CreateDiscussionResponseLikeMutation,
    CreateDiscussionResponseLikeMutationVariables
  >
export const CreateDiscussionResponseDocument = gql`
  mutation CreateDiscussionResponse(
    $context: DiscussionContextInput!
    $response: DiscussionResponseInput!
  ) {
    createDiscussionResponse(context: $context, response: $response) {
      ...DiscussionResponse
    }
  }
  ${DiscussionResponseFragmentDoc}
`
export type CreateDiscussionResponseMutationFn = Apollo.MutationFunction<
  CreateDiscussionResponseMutation,
  CreateDiscussionResponseMutationVariables
>

/**
 * __useCreateDiscussionResponseMutation__
 *
 * To run a mutation, you first call `useCreateDiscussionResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscussionResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscussionResponseMutation, { data, loading, error }] = useCreateDiscussionResponseMutation({
 *   variables: {
 *      context: // value for 'context'
 *      response: // value for 'response'
 *   },
 * });
 */
export function useCreateDiscussionResponseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDiscussionResponseMutation,
    CreateDiscussionResponseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateDiscussionResponseMutation,
    CreateDiscussionResponseMutationVariables
  >(CreateDiscussionResponseDocument, options)
}
export type CreateDiscussionResponseMutationHookResult = ReturnType<
  typeof useCreateDiscussionResponseMutation
>
export type CreateDiscussionResponseMutationResult =
  Apollo.MutationResult<CreateDiscussionResponseMutation>
export type CreateDiscussionResponseMutationOptions =
  Apollo.BaseMutationOptions<
    CreateDiscussionResponseMutation,
    CreateDiscussionResponseMutationVariables
  >
export const CreateDiscussionSubscriptionDocument = gql`
  mutation CreateDiscussionSubscription(
    $context: DiscussionContextInput!
    $discussion_id: Int!
  ) {
    createDiscussionSubscription(
      context: $context
      discussion_id: $discussion_id
    ) {
      ...DiscussionPost
    }
  }
  ${DiscussionPostFragmentDoc}
`
export type CreateDiscussionSubscriptionMutationFn = Apollo.MutationFunction<
  CreateDiscussionSubscriptionMutation,
  CreateDiscussionSubscriptionMutationVariables
>

/**
 * __useCreateDiscussionSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateDiscussionSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscussionSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscussionSubscriptionMutation, { data, loading, error }] = useCreateDiscussionSubscriptionMutation({
 *   variables: {
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *   },
 * });
 */
export function useCreateDiscussionSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDiscussionSubscriptionMutation,
    CreateDiscussionSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateDiscussionSubscriptionMutation,
    CreateDiscussionSubscriptionMutationVariables
  >(CreateDiscussionSubscriptionDocument, options)
}
export type CreateDiscussionSubscriptionMutationHookResult = ReturnType<
  typeof useCreateDiscussionSubscriptionMutation
>
export type CreateDiscussionSubscriptionMutationResult =
  Apollo.MutationResult<CreateDiscussionSubscriptionMutation>
export type CreateDiscussionSubscriptionMutationOptions =
  Apollo.BaseMutationOptions<
    CreateDiscussionSubscriptionMutation,
    CreateDiscussionSubscriptionMutationVariables
  >
export const DeleteDiscussionLikeDocument = gql`
  mutation DeleteDiscussionLike(
    $context: DiscussionContextInput!
    $discussion_id: Int!
  ) {
    deleteDiscussionLike(context: $context, discussion_id: $discussion_id) {
      ...DiscussionPost
    }
  }
  ${DiscussionPostFragmentDoc}
`
export type DeleteDiscussionLikeMutationFn = Apollo.MutationFunction<
  DeleteDiscussionLikeMutation,
  DeleteDiscussionLikeMutationVariables
>

/**
 * __useDeleteDiscussionLikeMutation__
 *
 * To run a mutation, you first call `useDeleteDiscussionLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscussionLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscussionLikeMutation, { data, loading, error }] = useDeleteDiscussionLikeMutation({
 *   variables: {
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *   },
 * });
 */
export function useDeleteDiscussionLikeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDiscussionLikeMutation,
    DeleteDiscussionLikeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteDiscussionLikeMutation,
    DeleteDiscussionLikeMutationVariables
  >(DeleteDiscussionLikeDocument, options)
}
export type DeleteDiscussionLikeMutationHookResult = ReturnType<
  typeof useDeleteDiscussionLikeMutation
>
export type DeleteDiscussionLikeMutationResult =
  Apollo.MutationResult<DeleteDiscussionLikeMutation>
export type DeleteDiscussionLikeMutationOptions = Apollo.BaseMutationOptions<
  DeleteDiscussionLikeMutation,
  DeleteDiscussionLikeMutationVariables
>
export const DeleteDiscussionDocument = gql`
  mutation DeleteDiscussion($context: DiscussionContextInput!, $id: Int!) {
    deleteDiscussion(context: $context, id: $id)
  }
`
export type DeleteDiscussionMutationFn = Apollo.MutationFunction<
  DeleteDiscussionMutation,
  DeleteDiscussionMutationVariables
>

/**
 * __useDeleteDiscussionMutation__
 *
 * To run a mutation, you first call `useDeleteDiscussionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscussionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscussionMutation, { data, loading, error }] = useDeleteDiscussionMutation({
 *   variables: {
 *      context: // value for 'context'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDiscussionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDiscussionMutation,
    DeleteDiscussionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteDiscussionMutation,
    DeleteDiscussionMutationVariables
  >(DeleteDiscussionDocument, options)
}
export type DeleteDiscussionMutationHookResult = ReturnType<
  typeof useDeleteDiscussionMutation
>
export type DeleteDiscussionMutationResult =
  Apollo.MutationResult<DeleteDiscussionMutation>
export type DeleteDiscussionMutationOptions = Apollo.BaseMutationOptions<
  DeleteDiscussionMutation,
  DeleteDiscussionMutationVariables
>
export const DeleteDiscussionResponseLikeDocument = gql`
  mutation DeleteDiscussionResponseLike(
    $context: DiscussionContextInput!
    $discussion_id: Int!
    $response_id: Int!
  ) {
    deleteDiscussionResponseLike(
      context: $context
      discussion_id: $discussion_id
      response_id: $response_id
    )
  }
`
export type DeleteDiscussionResponseLikeMutationFn = Apollo.MutationFunction<
  DeleteDiscussionResponseLikeMutation,
  DeleteDiscussionResponseLikeMutationVariables
>

/**
 * __useDeleteDiscussionResponseLikeMutation__
 *
 * To run a mutation, you first call `useDeleteDiscussionResponseLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscussionResponseLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscussionResponseLikeMutation, { data, loading, error }] = useDeleteDiscussionResponseLikeMutation({
 *   variables: {
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *      response_id: // value for 'response_id'
 *   },
 * });
 */
export function useDeleteDiscussionResponseLikeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDiscussionResponseLikeMutation,
    DeleteDiscussionResponseLikeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteDiscussionResponseLikeMutation,
    DeleteDiscussionResponseLikeMutationVariables
  >(DeleteDiscussionResponseLikeDocument, options)
}
export type DeleteDiscussionResponseLikeMutationHookResult = ReturnType<
  typeof useDeleteDiscussionResponseLikeMutation
>
export type DeleteDiscussionResponseLikeMutationResult =
  Apollo.MutationResult<DeleteDiscussionResponseLikeMutation>
export type DeleteDiscussionResponseLikeMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteDiscussionResponseLikeMutation,
    DeleteDiscussionResponseLikeMutationVariables
  >
export const DeleteDiscussionResponseDocument = gql`
  mutation DeleteDiscussionResponse(
    $context: DiscussionContextInput!
    $discussion_id: Int!
    $response_id: Int!
  ) {
    deleteDiscussionResponse(
      context: $context
      discussion_id: $discussion_id
      response_id: $response_id
    )
  }
`
export type DeleteDiscussionResponseMutationFn = Apollo.MutationFunction<
  DeleteDiscussionResponseMutation,
  DeleteDiscussionResponseMutationVariables
>

/**
 * __useDeleteDiscussionResponseMutation__
 *
 * To run a mutation, you first call `useDeleteDiscussionResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscussionResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscussionResponseMutation, { data, loading, error }] = useDeleteDiscussionResponseMutation({
 *   variables: {
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *      response_id: // value for 'response_id'
 *   },
 * });
 */
export function useDeleteDiscussionResponseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDiscussionResponseMutation,
    DeleteDiscussionResponseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteDiscussionResponseMutation,
    DeleteDiscussionResponseMutationVariables
  >(DeleteDiscussionResponseDocument, options)
}
export type DeleteDiscussionResponseMutationHookResult = ReturnType<
  typeof useDeleteDiscussionResponseMutation
>
export type DeleteDiscussionResponseMutationResult =
  Apollo.MutationResult<DeleteDiscussionResponseMutation>
export type DeleteDiscussionResponseMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteDiscussionResponseMutation,
    DeleteDiscussionResponseMutationVariables
  >
export const DeleteDiscussionSubscriptionDocument = gql`
  mutation DeleteDiscussionSubscription(
    $context: DiscussionContextInput!
    $discussion_id: Int!
  ) {
    deleteDiscussionSubscription(
      context: $context
      discussion_id: $discussion_id
    ) {
      ...DiscussionPost
    }
  }
  ${DiscussionPostFragmentDoc}
`
export type DeleteDiscussionSubscriptionMutationFn = Apollo.MutationFunction<
  DeleteDiscussionSubscriptionMutation,
  DeleteDiscussionSubscriptionMutationVariables
>

/**
 * __useDeleteDiscussionSubscriptionMutation__
 *
 * To run a mutation, you first call `useDeleteDiscussionSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscussionSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscussionSubscriptionMutation, { data, loading, error }] = useDeleteDiscussionSubscriptionMutation({
 *   variables: {
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *   },
 * });
 */
export function useDeleteDiscussionSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDiscussionSubscriptionMutation,
    DeleteDiscussionSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteDiscussionSubscriptionMutation,
    DeleteDiscussionSubscriptionMutationVariables
  >(DeleteDiscussionSubscriptionDocument, options)
}
export type DeleteDiscussionSubscriptionMutationHookResult = ReturnType<
  typeof useDeleteDiscussionSubscriptionMutation
>
export type DeleteDiscussionSubscriptionMutationResult =
  Apollo.MutationResult<DeleteDiscussionSubscriptionMutation>
export type DeleteDiscussionSubscriptionMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteDiscussionSubscriptionMutation,
    DeleteDiscussionSubscriptionMutationVariables
  >
export const DiscussionParticipantsDocument = gql`
  query DiscussionParticipants(
    $first: Int = 3
    $context: DiscussionContextInput!
    $discussion_id: Int!
  ) {
    discussionParticipants(
      first: $first
      context: $context
      discussion_id: $discussion_id
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...DiscussionParticipant
        }
      }
    }
  }
  ${DiscussionParticipantFragmentDoc}
`

/**
 * __useDiscussionParticipantsQuery__
 *
 * To run a query within a React component, call `useDiscussionParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscussionParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscussionParticipantsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *   },
 * });
 */
export function useDiscussionParticipantsQuery(
  baseOptions: Apollo.QueryHookOptions<
    DiscussionParticipantsQuery,
    DiscussionParticipantsQueryVariables
  > &
    (
      | { variables: DiscussionParticipantsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    DiscussionParticipantsQuery,
    DiscussionParticipantsQueryVariables
  >(DiscussionParticipantsDocument, options)
}
export function useDiscussionParticipantsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DiscussionParticipantsQuery,
    DiscussionParticipantsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    DiscussionParticipantsQuery,
    DiscussionParticipantsQueryVariables
  >(DiscussionParticipantsDocument, options)
}
export function useDiscussionParticipantsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DiscussionParticipantsQuery,
        DiscussionParticipantsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    DiscussionParticipantsQuery,
    DiscussionParticipantsQueryVariables
  >(DiscussionParticipantsDocument, options)
}
export type DiscussionParticipantsQueryHookResult = ReturnType<
  typeof useDiscussionParticipantsQuery
>
export type DiscussionParticipantsLazyQueryHookResult = ReturnType<
  typeof useDiscussionParticipantsLazyQuery
>
export type DiscussionParticipantsSuspenseQueryHookResult = ReturnType<
  typeof useDiscussionParticipantsSuspenseQuery
>
export type DiscussionParticipantsQueryResult = Apollo.QueryResult<
  DiscussionParticipantsQuery,
  DiscussionParticipantsQueryVariables
>
export const DiscussionPostDocument = gql`
  query DiscussionPost($id: Int, $context: DiscussionContextInput!) {
    discussion(id: $id, context: $context) {
      ...DiscussionPost
    }
  }
  ${DiscussionPostFragmentDoc}
`

/**
 * __useDiscussionPostQuery__
 *
 * To run a query within a React component, call `useDiscussionPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscussionPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscussionPostQuery({
 *   variables: {
 *      id: // value for 'id'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useDiscussionPostQuery(
  baseOptions: Apollo.QueryHookOptions<
    DiscussionPostQuery,
    DiscussionPostQueryVariables
  > &
    (
      | { variables: DiscussionPostQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DiscussionPostQuery, DiscussionPostQueryVariables>(
    DiscussionPostDocument,
    options
  )
}
export function useDiscussionPostLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DiscussionPostQuery,
    DiscussionPostQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DiscussionPostQuery, DiscussionPostQueryVariables>(
    DiscussionPostDocument,
    options
  )
}
export function useDiscussionPostSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DiscussionPostQuery,
        DiscussionPostQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    DiscussionPostQuery,
    DiscussionPostQueryVariables
  >(DiscussionPostDocument, options)
}
export type DiscussionPostQueryHookResult = ReturnType<
  typeof useDiscussionPostQuery
>
export type DiscussionPostLazyQueryHookResult = ReturnType<
  typeof useDiscussionPostLazyQuery
>
export type DiscussionPostSuspenseQueryHookResult = ReturnType<
  typeof useDiscussionPostSuspenseQuery
>
export type DiscussionPostQueryResult = Apollo.QueryResult<
  DiscussionPostQuery,
  DiscussionPostQueryVariables
>
export const DiscussionDocument = gql`
  query Discussion(
    $id: Int
    $context: DiscussionContextInput!
    $orderResponsesBy: [String]
    $cursor: String
    $first: Int = 25
  ) {
    discussion(id: $id, context: $context) {
      ...DiscussionPost
      responses(first: $first, after: $cursor, order_by: $orderResponsesBy) {
        total
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...DiscussionResponse
          }
        }
      }
    }
  }
  ${DiscussionPostFragmentDoc}
  ${DiscussionResponseFragmentDoc}
`

/**
 * __useDiscussionQuery__
 *
 * To run a query within a React component, call `useDiscussionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscussionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscussionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      context: // value for 'context'
 *      orderResponsesBy: // value for 'orderResponsesBy'
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useDiscussionQuery(
  baseOptions: Apollo.QueryHookOptions<
    DiscussionQuery,
    DiscussionQueryVariables
  > &
    (
      | { variables: DiscussionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DiscussionQuery, DiscussionQueryVariables>(
    DiscussionDocument,
    options
  )
}
export function useDiscussionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DiscussionQuery,
    DiscussionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DiscussionQuery, DiscussionQueryVariables>(
    DiscussionDocument,
    options
  )
}
export function useDiscussionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<DiscussionQuery, DiscussionQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<DiscussionQuery, DiscussionQueryVariables>(
    DiscussionDocument,
    options
  )
}
export type DiscussionQueryHookResult = ReturnType<typeof useDiscussionQuery>
export type DiscussionLazyQueryHookResult = ReturnType<
  typeof useDiscussionLazyQuery
>
export type DiscussionSuspenseQueryHookResult = ReturnType<
  typeof useDiscussionSuspenseQuery
>
export type DiscussionQueryResult = Apollo.QueryResult<
  DiscussionQuery,
  DiscussionQueryVariables
>
export const DiscussionResponseDocument = gql`
  query DiscussionResponse(
    $id: Int
    $context: DiscussionContextInput!
    $response_id: Int!
  ) {
    discussion(id: $id, context: $context) {
      ...DiscussionPost
      response(response_id: $response_id) {
        ...DiscussionResponse
      }
    }
  }
  ${DiscussionPostFragmentDoc}
  ${DiscussionResponseFragmentDoc}
`

/**
 * __useDiscussionResponseQuery__
 *
 * To run a query within a React component, call `useDiscussionResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscussionResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscussionResponseQuery({
 *   variables: {
 *      id: // value for 'id'
 *      context: // value for 'context'
 *      response_id: // value for 'response_id'
 *   },
 * });
 */
export function useDiscussionResponseQuery(
  baseOptions: Apollo.QueryHookOptions<
    DiscussionResponseQuery,
    DiscussionResponseQueryVariables
  > &
    (
      | { variables: DiscussionResponseQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    DiscussionResponseQuery,
    DiscussionResponseQueryVariables
  >(DiscussionResponseDocument, options)
}
export function useDiscussionResponseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DiscussionResponseQuery,
    DiscussionResponseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    DiscussionResponseQuery,
    DiscussionResponseQueryVariables
  >(DiscussionResponseDocument, options)
}
export function useDiscussionResponseSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DiscussionResponseQuery,
        DiscussionResponseQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    DiscussionResponseQuery,
    DiscussionResponseQueryVariables
  >(DiscussionResponseDocument, options)
}
export type DiscussionResponseQueryHookResult = ReturnType<
  typeof useDiscussionResponseQuery
>
export type DiscussionResponseLazyQueryHookResult = ReturnType<
  typeof useDiscussionResponseLazyQuery
>
export type DiscussionResponseSuspenseQueryHookResult = ReturnType<
  typeof useDiscussionResponseSuspenseQuery
>
export type DiscussionResponseQueryResult = Apollo.QueryResult<
  DiscussionResponseQuery,
  DiscussionResponseQueryVariables
>
export const DiscussionsDocument = gql`
  query Discussions(
    $context: DiscussionContextInput!
    $type: DiscussionTypeInput
    $is_discussion_question: Boolean
    $total_responses: IntFilter
    $tagIdFilter: IntFilter
    $order_by: [String]
    $first: Int = 15
    $cursor: String
  ) {
    discussions(
      context: $context
      type: $type
      is_discussion_question: $is_discussion_question
      total_responses: $total_responses
      tag_id_filter: $tagIdFilter
      order_by: $order_by
      first: $first
      after: $cursor
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...DiscussionPost
        }
      }
    }
  }
  ${DiscussionPostFragmentDoc}
`

/**
 * __useDiscussionsQuery__
 *
 * To run a query within a React component, call `useDiscussionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscussionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscussionsQuery({
 *   variables: {
 *      context: // value for 'context'
 *      type: // value for 'type'
 *      is_discussion_question: // value for 'is_discussion_question'
 *      total_responses: // value for 'total_responses'
 *      tagIdFilter: // value for 'tagIdFilter'
 *      order_by: // value for 'order_by'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useDiscussionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    DiscussionsQuery,
    DiscussionsQueryVariables
  > &
    (
      | { variables: DiscussionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<DiscussionsQuery, DiscussionsQueryVariables>(
    DiscussionsDocument,
    options
  )
}
export function useDiscussionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DiscussionsQuery,
    DiscussionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<DiscussionsQuery, DiscussionsQueryVariables>(
    DiscussionsDocument,
    options
  )
}
export function useDiscussionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DiscussionsQuery,
        DiscussionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<DiscussionsQuery, DiscussionsQueryVariables>(
    DiscussionsDocument,
    options
  )
}
export type DiscussionsQueryHookResult = ReturnType<typeof useDiscussionsQuery>
export type DiscussionsLazyQueryHookResult = ReturnType<
  typeof useDiscussionsLazyQuery
>
export type DiscussionsSuspenseQueryHookResult = ReturnType<
  typeof useDiscussionsSuspenseQuery
>
export type DiscussionsQueryResult = Apollo.QueryResult<
  DiscussionsQuery,
  DiscussionsQueryVariables
>
export const UpdateDiscussionDocument = gql`
  mutation UpdateDiscussion(
    $id: Int!
    $context: DiscussionContextInput!
    $post: DiscussionPostInput!
  ) {
    updateDiscussion(id: $id, context: $context, post: $post) {
      ...DiscussionPost
    }
  }
  ${DiscussionPostFragmentDoc}
`
export type UpdateDiscussionMutationFn = Apollo.MutationFunction<
  UpdateDiscussionMutation,
  UpdateDiscussionMutationVariables
>

/**
 * __useUpdateDiscussionMutation__
 *
 * To run a mutation, you first call `useUpdateDiscussionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscussionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscussionMutation, { data, loading, error }] = useUpdateDiscussionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      context: // value for 'context'
 *      post: // value for 'post'
 *   },
 * });
 */
export function useUpdateDiscussionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDiscussionMutation,
    UpdateDiscussionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateDiscussionMutation,
    UpdateDiscussionMutationVariables
  >(UpdateDiscussionDocument, options)
}
export type UpdateDiscussionMutationHookResult = ReturnType<
  typeof useUpdateDiscussionMutation
>
export type UpdateDiscussionMutationResult =
  Apollo.MutationResult<UpdateDiscussionMutation>
export type UpdateDiscussionMutationOptions = Apollo.BaseMutationOptions<
  UpdateDiscussionMutation,
  UpdateDiscussionMutationVariables
>
export const UpdateDiscussionResponseDocument = gql`
  mutation UpdateDiscussionResponse(
    $context: DiscussionContextInput!
    $response: DiscussionResponseInput!
    $response_id: Int!
  ) {
    updateDiscussionResponse(
      context: $context
      response: $response
      response_id: $response_id
    ) {
      ...DiscussionResponse
    }
  }
  ${DiscussionResponseFragmentDoc}
`
export type UpdateDiscussionResponseMutationFn = Apollo.MutationFunction<
  UpdateDiscussionResponseMutation,
  UpdateDiscussionResponseMutationVariables
>

/**
 * __useUpdateDiscussionResponseMutation__
 *
 * To run a mutation, you first call `useUpdateDiscussionResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscussionResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscussionResponseMutation, { data, loading, error }] = useUpdateDiscussionResponseMutation({
 *   variables: {
 *      context: // value for 'context'
 *      response: // value for 'response'
 *      response_id: // value for 'response_id'
 *   },
 * });
 */
export function useUpdateDiscussionResponseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDiscussionResponseMutation,
    UpdateDiscussionResponseMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateDiscussionResponseMutation,
    UpdateDiscussionResponseMutationVariables
  >(UpdateDiscussionResponseDocument, options)
}
export type UpdateDiscussionResponseMutationHookResult = ReturnType<
  typeof useUpdateDiscussionResponseMutation
>
export type UpdateDiscussionResponseMutationResult =
  Apollo.MutationResult<UpdateDiscussionResponseMutation>
export type UpdateDiscussionResponseMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateDiscussionResponseMutation,
    UpdateDiscussionResponseMutationVariables
  >
export const UpdateUserDiscussionHistoryDocument = gql`
  mutation UpdateUserDiscussionHistory(
    $context: DiscussionContextInput!
    $discussion_id: Int!
  ) {
    updateUserDiscussionHistory(
      context: $context
      discussion_id: $discussion_id
    ) {
      ...DiscussionPost
    }
  }
  ${DiscussionPostFragmentDoc}
`
export type UpdateUserDiscussionHistoryMutationFn = Apollo.MutationFunction<
  UpdateUserDiscussionHistoryMutation,
  UpdateUserDiscussionHistoryMutationVariables
>

/**
 * __useUpdateUserDiscussionHistoryMutation__
 *
 * To run a mutation, you first call `useUpdateUserDiscussionHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDiscussionHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDiscussionHistoryMutation, { data, loading, error }] = useUpdateUserDiscussionHistoryMutation({
 *   variables: {
 *      context: // value for 'context'
 *      discussion_id: // value for 'discussion_id'
 *   },
 * });
 */
export function useUpdateUserDiscussionHistoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserDiscussionHistoryMutation,
    UpdateUserDiscussionHistoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateUserDiscussionHistoryMutation,
    UpdateUserDiscussionHistoryMutationVariables
  >(UpdateUserDiscussionHistoryDocument, options)
}
export type UpdateUserDiscussionHistoryMutationHookResult = ReturnType<
  typeof useUpdateUserDiscussionHistoryMutation
>
export type UpdateUserDiscussionHistoryMutationResult =
  Apollo.MutationResult<UpdateUserDiscussionHistoryMutation>
export type UpdateUserDiscussionHistoryMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateUserDiscussionHistoryMutation,
    UpdateUserDiscussionHistoryMutationVariables
  >
export const CommunityEnableDocument = gql`
  mutation CommunityEnable($cohortId: Int!, $communityEnabled: Boolean!) {
    updateGroupDiscussionEnabled(
      id: $cohortId
      discussion_enabled: $communityEnabled
    ) {
      id
      discussion_enabled
    }
  }
`
export type CommunityEnableMutationFn = Apollo.MutationFunction<
  CommunityEnableMutation,
  CommunityEnableMutationVariables
>

/**
 * __useCommunityEnableMutation__
 *
 * To run a mutation, you first call `useCommunityEnableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommunityEnableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [communityEnableMutation, { data, loading, error }] = useCommunityEnableMutation({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *      communityEnabled: // value for 'communityEnabled'
 *   },
 * });
 */
export function useCommunityEnableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CommunityEnableMutation,
    CommunityEnableMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CommunityEnableMutation,
    CommunityEnableMutationVariables
  >(CommunityEnableDocument, options)
}
export type CommunityEnableMutationHookResult = ReturnType<
  typeof useCommunityEnableMutation
>
export type CommunityEnableMutationResult =
  Apollo.MutationResult<CommunityEnableMutation>
export type CommunityEnableMutationOptions = Apollo.BaseMutationOptions<
  CommunityEnableMutation,
  CommunityEnableMutationVariables
>
export const ContextualFeaturePermissionDocument = gql`
  query ContextualFeaturePermission(
    $featureKey: FeatureKey!
    $featureAction: FeatureAction!
    $context: FeatureContextInput
  ) {
    contextualFeaturePermission(
      feature_action: $featureAction
      feature_key: $featureKey
      context: $context
    ) {
      ...ContextualFeaturePermission
    }
  }
  ${ContextualFeaturePermissionFragmentDoc}
`

/**
 * __useContextualFeaturePermissionQuery__
 *
 * To run a query within a React component, call `useContextualFeaturePermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useContextualFeaturePermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContextualFeaturePermissionQuery({
 *   variables: {
 *      featureKey: // value for 'featureKey'
 *      featureAction: // value for 'featureAction'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useContextualFeaturePermissionQuery(
  baseOptions: Apollo.QueryHookOptions<
    ContextualFeaturePermissionQuery,
    ContextualFeaturePermissionQueryVariables
  > &
    (
      | { variables: ContextualFeaturePermissionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContextualFeaturePermissionQuery,
    ContextualFeaturePermissionQueryVariables
  >(ContextualFeaturePermissionDocument, options)
}
export function useContextualFeaturePermissionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContextualFeaturePermissionQuery,
    ContextualFeaturePermissionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContextualFeaturePermissionQuery,
    ContextualFeaturePermissionQueryVariables
  >(ContextualFeaturePermissionDocument, options)
}
export function useContextualFeaturePermissionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ContextualFeaturePermissionQuery,
        ContextualFeaturePermissionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ContextualFeaturePermissionQuery,
    ContextualFeaturePermissionQueryVariables
  >(ContextualFeaturePermissionDocument, options)
}
export type ContextualFeaturePermissionQueryHookResult = ReturnType<
  typeof useContextualFeaturePermissionQuery
>
export type ContextualFeaturePermissionLazyQueryHookResult = ReturnType<
  typeof useContextualFeaturePermissionLazyQuery
>
export type ContextualFeaturePermissionSuspenseQueryHookResult = ReturnType<
  typeof useContextualFeaturePermissionSuspenseQuery
>
export type ContextualFeaturePermissionQueryResult = Apollo.QueryResult<
  ContextualFeaturePermissionQuery,
  ContextualFeaturePermissionQueryVariables
>
export const ContextualFeaturePermissionsDocument = gql`
  query ContextualFeaturePermissions(
    $featureKeys: FeatureKeyFilter
    $featureAction: FeatureAction
    $context: FeatureContextInput
  ) {
    contextualFeaturePermissions(
      feature_action: $featureAction
      feature_keys: $featureKeys
      context: $context
    ) {
      ...ContextualFeaturePermission
    }
  }
  ${ContextualFeaturePermissionFragmentDoc}
`

/**
 * __useContextualFeaturePermissionsQuery__
 *
 * To run a query within a React component, call `useContextualFeaturePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContextualFeaturePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContextualFeaturePermissionsQuery({
 *   variables: {
 *      featureKeys: // value for 'featureKeys'
 *      featureAction: // value for 'featureAction'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useContextualFeaturePermissionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ContextualFeaturePermissionsQuery,
    ContextualFeaturePermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ContextualFeaturePermissionsQuery,
    ContextualFeaturePermissionsQueryVariables
  >(ContextualFeaturePermissionsDocument, options)
}
export function useContextualFeaturePermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ContextualFeaturePermissionsQuery,
    ContextualFeaturePermissionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ContextualFeaturePermissionsQuery,
    ContextualFeaturePermissionsQueryVariables
  >(ContextualFeaturePermissionsDocument, options)
}
export function useContextualFeaturePermissionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ContextualFeaturePermissionsQuery,
        ContextualFeaturePermissionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ContextualFeaturePermissionsQuery,
    ContextualFeaturePermissionsQueryVariables
  >(ContextualFeaturePermissionsDocument, options)
}
export type ContextualFeaturePermissionsQueryHookResult = ReturnType<
  typeof useContextualFeaturePermissionsQuery
>
export type ContextualFeaturePermissionsLazyQueryHookResult = ReturnType<
  typeof useContextualFeaturePermissionsLazyQuery
>
export type ContextualFeaturePermissionsSuspenseQueryHookResult = ReturnType<
  typeof useContextualFeaturePermissionsSuspenseQuery
>
export type ContextualFeaturePermissionsQueryResult = Apollo.QueryResult<
  ContextualFeaturePermissionsQuery,
  ContextualFeaturePermissionsQueryVariables
>
export const CreateContextualFeaturePermissionDocument = gql`
  mutation CreateContextualFeaturePermission(
    $featureKey: FeatureKey!
    $featureAction: FeatureAction!
    $permissionInContext: FeaturePermission!
    $context: FeatureContextInput
  ) {
    createContextualFeaturePermission(
      feature_action: $featureAction
      feature_key: $featureKey
      permission_in_context: $permissionInContext
      context: $context
    ) {
      ...ContextualFeaturePermission
    }
  }
  ${ContextualFeaturePermissionFragmentDoc}
`
export type CreateContextualFeaturePermissionMutationFn =
  Apollo.MutationFunction<
    CreateContextualFeaturePermissionMutation,
    CreateContextualFeaturePermissionMutationVariables
  >

/**
 * __useCreateContextualFeaturePermissionMutation__
 *
 * To run a mutation, you first call `useCreateContextualFeaturePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContextualFeaturePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContextualFeaturePermissionMutation, { data, loading, error }] = useCreateContextualFeaturePermissionMutation({
 *   variables: {
 *      featureKey: // value for 'featureKey'
 *      featureAction: // value for 'featureAction'
 *      permissionInContext: // value for 'permissionInContext'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useCreateContextualFeaturePermissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateContextualFeaturePermissionMutation,
    CreateContextualFeaturePermissionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateContextualFeaturePermissionMutation,
    CreateContextualFeaturePermissionMutationVariables
  >(CreateContextualFeaturePermissionDocument, options)
}
export type CreateContextualFeaturePermissionMutationHookResult = ReturnType<
  typeof useCreateContextualFeaturePermissionMutation
>
export type CreateContextualFeaturePermissionMutationResult =
  Apollo.MutationResult<CreateContextualFeaturePermissionMutation>
export type CreateContextualFeaturePermissionMutationOptions =
  Apollo.BaseMutationOptions<
    CreateContextualFeaturePermissionMutation,
    CreateContextualFeaturePermissionMutationVariables
  >
export const DeleteContextualFeaturePermissionMutationDocument = gql`
  mutation DeleteContextualFeaturePermissionMutation(
    $featureKey: FeatureKey!
    $featureAction: FeatureAction!
    $context: FeatureContextInput
  ) {
    deleteContextualFeaturePermission(
      feature_action: $featureAction
      feature_key: $featureKey
      context: $context
    )
  }
`
export type DeleteContextualFeaturePermissionMutationMutationFn =
  Apollo.MutationFunction<
    DeleteContextualFeaturePermissionMutationMutation,
    DeleteContextualFeaturePermissionMutationMutationVariables
  >

/**
 * __useDeleteContextualFeaturePermissionMutationMutation__
 *
 * To run a mutation, you first call `useDeleteContextualFeaturePermissionMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContextualFeaturePermissionMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContextualFeaturePermissionMutationMutation, { data, loading, error }] = useDeleteContextualFeaturePermissionMutationMutation({
 *   variables: {
 *      featureKey: // value for 'featureKey'
 *      featureAction: // value for 'featureAction'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useDeleteContextualFeaturePermissionMutationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteContextualFeaturePermissionMutationMutation,
    DeleteContextualFeaturePermissionMutationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteContextualFeaturePermissionMutationMutation,
    DeleteContextualFeaturePermissionMutationMutationVariables
  >(DeleteContextualFeaturePermissionMutationDocument, options)
}
export type DeleteContextualFeaturePermissionMutationMutationHookResult =
  ReturnType<typeof useDeleteContextualFeaturePermissionMutationMutation>
export type DeleteContextualFeaturePermissionMutationMutationResult =
  Apollo.MutationResult<DeleteContextualFeaturePermissionMutationMutation>
export type DeleteContextualFeaturePermissionMutationMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteContextualFeaturePermissionMutationMutation,
    DeleteContextualFeaturePermissionMutationMutationVariables
  >
export const FeatureContextDocument = gql`
  query FeatureContext($cohortId: Int!) {
    cohort: group(id: $cohortId) {
      id
      name
      discussion_enabled
      resource {
        id
        discussion_enabled
      }
    }
  }
`

/**
 * __useFeatureContextQuery__
 *
 * To run a query within a React component, call `useFeatureContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureContextQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useFeatureContextQuery(
  baseOptions: Apollo.QueryHookOptions<
    FeatureContextQuery,
    FeatureContextQueryVariables
  > &
    (
      | { variables: FeatureContextQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FeatureContextQuery, FeatureContextQueryVariables>(
    FeatureContextDocument,
    options
  )
}
export function useFeatureContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FeatureContextQuery,
    FeatureContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FeatureContextQuery, FeatureContextQueryVariables>(
    FeatureContextDocument,
    options
  )
}
export function useFeatureContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FeatureContextQuery,
        FeatureContextQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    FeatureContextQuery,
    FeatureContextQueryVariables
  >(FeatureContextDocument, options)
}
export type FeatureContextQueryHookResult = ReturnType<
  typeof useFeatureContextQuery
>
export type FeatureContextLazyQueryHookResult = ReturnType<
  typeof useFeatureContextLazyQuery
>
export type FeatureContextSuspenseQueryHookResult = ReturnType<
  typeof useFeatureContextSuspenseQuery
>
export type FeatureContextQueryResult = Apollo.QueryResult<
  FeatureContextQuery,
  FeatureContextQueryVariables
>
export const SpaceAuthSettingsDocument = gql`
  query SpaceAuthSettings {
    space {
      id
      pathwright_login_enabled
      allow_public_signup
      always_prompt_for_password
      authMethods {
        id
        enabled
        meta {
          id
          key
          type
          url
          title
          icon
        }
      }
    }
  }
`

/**
 * __useSpaceAuthSettingsQuery__
 *
 * To run a query within a React component, call `useSpaceAuthSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpaceAuthSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceAuthSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpaceAuthSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SpaceAuthSettingsQuery,
    SpaceAuthSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SpaceAuthSettingsQuery,
    SpaceAuthSettingsQueryVariables
  >(SpaceAuthSettingsDocument, options)
}
export function useSpaceAuthSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SpaceAuthSettingsQuery,
    SpaceAuthSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SpaceAuthSettingsQuery,
    SpaceAuthSettingsQueryVariables
  >(SpaceAuthSettingsDocument, options)
}
export function useSpaceAuthSettingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SpaceAuthSettingsQuery,
        SpaceAuthSettingsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SpaceAuthSettingsQuery,
    SpaceAuthSettingsQueryVariables
  >(SpaceAuthSettingsDocument, options)
}
export type SpaceAuthSettingsQueryHookResult = ReturnType<
  typeof useSpaceAuthSettingsQuery
>
export type SpaceAuthSettingsLazyQueryHookResult = ReturnType<
  typeof useSpaceAuthSettingsLazyQuery
>
export type SpaceAuthSettingsSuspenseQueryHookResult = ReturnType<
  typeof useSpaceAuthSettingsSuspenseQuery
>
export type SpaceAuthSettingsQueryResult = Apollo.QueryResult<
  SpaceAuthSettingsQuery,
  SpaceAuthSettingsQueryVariables
>
export const UpdateContextualFeaturePermissionDocument = gql`
  mutation UpdateContextualFeaturePermission(
    $featureKey: FeatureKey!
    $featureAction: FeatureAction!
    $permissionInContext: FeaturePermission!
    $context: FeatureContextInput
  ) {
    updateContextualFeaturePermission(
      feature_action: $featureAction
      feature_key: $featureKey
      permission_in_context: $permissionInContext
      context: $context
    ) {
      ...ContextualFeaturePermission
    }
  }
  ${ContextualFeaturePermissionFragmentDoc}
`
export type UpdateContextualFeaturePermissionMutationFn =
  Apollo.MutationFunction<
    UpdateContextualFeaturePermissionMutation,
    UpdateContextualFeaturePermissionMutationVariables
  >

/**
 * __useUpdateContextualFeaturePermissionMutation__
 *
 * To run a mutation, you first call `useUpdateContextualFeaturePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContextualFeaturePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContextualFeaturePermissionMutation, { data, loading, error }] = useUpdateContextualFeaturePermissionMutation({
 *   variables: {
 *      featureKey: // value for 'featureKey'
 *      featureAction: // value for 'featureAction'
 *      permissionInContext: // value for 'permissionInContext'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useUpdateContextualFeaturePermissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateContextualFeaturePermissionMutation,
    UpdateContextualFeaturePermissionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateContextualFeaturePermissionMutation,
    UpdateContextualFeaturePermissionMutationVariables
  >(UpdateContextualFeaturePermissionDocument, options)
}
export type UpdateContextualFeaturePermissionMutationHookResult = ReturnType<
  typeof useUpdateContextualFeaturePermissionMutation
>
export type UpdateContextualFeaturePermissionMutationResult =
  Apollo.MutationResult<UpdateContextualFeaturePermissionMutation>
export type UpdateContextualFeaturePermissionMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateContextualFeaturePermissionMutation,
    UpdateContextualFeaturePermissionMutationVariables
  >
export const UpdateSpaceAuthSettingsDocument = gql`
  mutation UpdateSpaceAuthSettings(
    $pathwrightLoginEnabled: Boolean!
    $allowPublicSignup: Boolean!
    $alwaysPromptForPassword: Boolean!
  ) {
    updatePathwrightAuth(
      pathwright_login_enabled: $pathwrightLoginEnabled
      allow_public_signup: $allowPublicSignup
      always_prompt_for_password: $alwaysPromptForPassword
    ) {
      id
      pathwright_login_enabled
      allow_public_signup
      always_prompt_for_password
    }
  }
`
export type UpdateSpaceAuthSettingsMutationFn = Apollo.MutationFunction<
  UpdateSpaceAuthSettingsMutation,
  UpdateSpaceAuthSettingsMutationVariables
>

/**
 * __useUpdateSpaceAuthSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSpaceAuthSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpaceAuthSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpaceAuthSettingsMutation, { data, loading, error }] = useUpdateSpaceAuthSettingsMutation({
 *   variables: {
 *      pathwrightLoginEnabled: // value for 'pathwrightLoginEnabled'
 *      allowPublicSignup: // value for 'allowPublicSignup'
 *      alwaysPromptForPassword: // value for 'alwaysPromptForPassword'
 *   },
 * });
 */
export function useUpdateSpaceAuthSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSpaceAuthSettingsMutation,
    UpdateSpaceAuthSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateSpaceAuthSettingsMutation,
    UpdateSpaceAuthSettingsMutationVariables
  >(UpdateSpaceAuthSettingsDocument, options)
}
export type UpdateSpaceAuthSettingsMutationHookResult = ReturnType<
  typeof useUpdateSpaceAuthSettingsMutation
>
export type UpdateSpaceAuthSettingsMutationResult =
  Apollo.MutationResult<UpdateSpaceAuthSettingsMutation>
export type UpdateSpaceAuthSettingsMutationOptions = Apollo.BaseMutationOptions<
  UpdateSpaceAuthSettingsMutation,
  UpdateSpaceAuthSettingsMutationVariables
>
export const CreateGroupDocument = gql`
  mutation CreateGroup(
    $base_resource_id: Int!
    $parent_offering_id: Int
    $visibility: Int!
    $name: String!
    $role: RegistrationRoleEnum
  ) {
    createGroup(
      base_resource_id: $base_resource_id
      parent_offering_id: $parent_offering_id
      visibility: $visibility
      name: $name
      role: $role
    ) {
      ...Group
      resource {
        ...Resource
        blurred_background: background_image(blur: 500, width: 250, height: 250)
      }
    }
  }
  ${GroupFragmentDoc}
  ${ResourceFragmentDoc}
`
export type CreateGroupMutationFn = Apollo.MutationFunction<
  CreateGroupMutation,
  CreateGroupMutationVariables
>

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      base_resource_id: // value for 'base_resource_id'
 *      parent_offering_id: // value for 'parent_offering_id'
 *      visibility: // value for 'visibility'
 *      name: // value for 'name'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useCreateGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateGroupMutation,
    CreateGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(
    CreateGroupDocument,
    options
  )
}
export type CreateGroupMutationHookResult = ReturnType<
  typeof useCreateGroupMutation
>
export type CreateGroupMutationResult =
  Apollo.MutationResult<CreateGroupMutation>
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateGroupMutation,
  CreateGroupMutationVariables
>
export const GroupDocument = gql`
  query Group($id: Int!) {
    group(id: $id) {
      ...GroupContext
    }
  }
  ${GroupContextFragmentDoc}
`

/**
 * __useGroupQuery__
 *
 * To run a query within a React component, call `useGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupQuery(
  baseOptions: Apollo.QueryHookOptions<GroupQuery, GroupQueryVariables> &
    ({ variables: GroupQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GroupQuery, GroupQueryVariables>(
    GroupDocument,
    options
  )
}
export function useGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GroupQuery, GroupQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GroupQuery, GroupQueryVariables>(
    GroupDocument,
    options
  )
}
export function useGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GroupQuery, GroupQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GroupQuery, GroupQueryVariables>(
    GroupDocument,
    options
  )
}
export type GroupQueryHookResult = ReturnType<typeof useGroupQuery>
export type GroupLazyQueryHookResult = ReturnType<typeof useGroupLazyQuery>
export type GroupSuspenseQueryHookResult = ReturnType<
  typeof useGroupSuspenseQuery
>
export type GroupQueryResult = Apollo.QueryResult<
  GroupQuery,
  GroupQueryVariables
>
export const CreateResourceDocument = gql`
  mutation CreateResource(
    $name: String!
    $cover_image: String!
    $resource_type: ResourceType
    $group_name: String
    $group_role: RegistrationRoleEnum
  ) {
    createResource(
      name: $name
      cover_image: $cover_image
      resource_type: $resource_type
      group_name: $group_name
      group_role: $group_role
    ) {
      ...CreatedResource
    }
  }
  ${CreatedResourceFragmentDoc}
`
export type CreateResourceMutationFn = Apollo.MutationFunction<
  CreateResourceMutation,
  CreateResourceMutationVariables
>

/**
 * __useCreateResourceMutation__
 *
 * To run a mutation, you first call `useCreateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResourceMutation, { data, loading, error }] = useCreateResourceMutation({
 *   variables: {
 *      name: // value for 'name'
 *      cover_image: // value for 'cover_image'
 *      resource_type: // value for 'resource_type'
 *      group_name: // value for 'group_name'
 *      group_role: // value for 'group_role'
 *   },
 * });
 */
export function useCreateResourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateResourceMutation,
    CreateResourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateResourceMutation,
    CreateResourceMutationVariables
  >(CreateResourceDocument, options)
}
export type CreateResourceMutationHookResult = ReturnType<
  typeof useCreateResourceMutation
>
export type CreateResourceMutationResult =
  Apollo.MutationResult<CreateResourceMutation>
export type CreateResourceMutationOptions = Apollo.BaseMutationOptions<
  CreateResourceMutation,
  CreateResourceMutationVariables
>
export const ManageMentorGroupMembershipsDocument = gql`
  query ManageMentorGroupMemberships {
    me {
      id
      mentorGroupMemberships(
        first: 1
        role: { gte: moderator }
        mentor_group_seat_limit_filter: { neq: 1 }
      ) {
        total
        edges {
          node {
            id
            role
            group_id
          }
        }
      }
    }
  }
`

/**
 * __useManageMentorGroupMembershipsQuery__
 *
 * To run a query within a React component, call `useManageMentorGroupMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageMentorGroupMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageMentorGroupMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useManageMentorGroupMembershipsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManageMentorGroupMembershipsQuery,
    ManageMentorGroupMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ManageMentorGroupMembershipsQuery,
    ManageMentorGroupMembershipsQueryVariables
  >(ManageMentorGroupMembershipsDocument, options)
}
export function useManageMentorGroupMembershipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManageMentorGroupMembershipsQuery,
    ManageMentorGroupMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ManageMentorGroupMembershipsQuery,
    ManageMentorGroupMembershipsQueryVariables
  >(ManageMentorGroupMembershipsDocument, options)
}
export function useManageMentorGroupMembershipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ManageMentorGroupMembershipsQuery,
        ManageMentorGroupMembershipsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ManageMentorGroupMembershipsQuery,
    ManageMentorGroupMembershipsQueryVariables
  >(ManageMentorGroupMembershipsDocument, options)
}
export type ManageMentorGroupMembershipsQueryHookResult = ReturnType<
  typeof useManageMentorGroupMembershipsQuery
>
export type ManageMentorGroupMembershipsLazyQueryHookResult = ReturnType<
  typeof useManageMentorGroupMembershipsLazyQuery
>
export type ManageMentorGroupMembershipsSuspenseQueryHookResult = ReturnType<
  typeof useManageMentorGroupMembershipsSuspenseQuery
>
export type ManageMentorGroupMembershipsQueryResult = Apollo.QueryResult<
  ManageMentorGroupMembershipsQuery,
  ManageMentorGroupMembershipsQueryVariables
>
export const UserRegistrationsDocument = gql`
  query UserRegistrations($first: Int = 1042, $cursor: String) {
    me {
      ...User
      registrations(
        first: $first
        after: $cursor
        role_filter: { lte: student }
      ) {
        total
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...Registration
            resource {
              ...Resource
            }
            group {
              ...Group
            }
            path {
              id
              progress
              completion_date
            }
            school_sub_used {
              id
              subscription {
                id
                is_delinquent
                canceled_dtime
              }
            }
            group_sub_used {
              id
            }
            group_sub_community_membership {
              id
              access_revoked_time
            }
          }
        }
      }
    }
  }
  ${UserFragmentDoc}
  ${RegistrationFragmentDoc}
  ${ResourceFragmentDoc}
  ${GroupFragmentDoc}
`

/**
 * __useUserRegistrationsQuery__
 *
 * To run a query within a React component, call `useUserRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRegistrationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useUserRegistrationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserRegistrationsQuery,
    UserRegistrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserRegistrationsQuery,
    UserRegistrationsQueryVariables
  >(UserRegistrationsDocument, options)
}
export function useUserRegistrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserRegistrationsQuery,
    UserRegistrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserRegistrationsQuery,
    UserRegistrationsQueryVariables
  >(UserRegistrationsDocument, options)
}
export function useUserRegistrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserRegistrationsQuery,
        UserRegistrationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserRegistrationsQuery,
    UserRegistrationsQueryVariables
  >(UserRegistrationsDocument, options)
}
export type UserRegistrationsQueryHookResult = ReturnType<
  typeof useUserRegistrationsQuery
>
export type UserRegistrationsLazyQueryHookResult = ReturnType<
  typeof useUserRegistrationsLazyQuery
>
export type UserRegistrationsSuspenseQueryHookResult = ReturnType<
  typeof useUserRegistrationsSuspenseQuery
>
export type UserRegistrationsQueryResult = Apollo.QueryResult<
  UserRegistrationsQuery,
  UserRegistrationsQueryVariables
>
export const RandomResourceImageDocument = gql`
  query RandomResourceImage($themeType: ThemeType) {
    resourceImage(theme_type: $themeType)
  }
`

/**
 * __useRandomResourceImageQuery__
 *
 * To run a query within a React component, call `useRandomResourceImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRandomResourceImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRandomResourceImageQuery({
 *   variables: {
 *      themeType: // value for 'themeType'
 *   },
 * });
 */
export function useRandomResourceImageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RandomResourceImageQuery,
    RandomResourceImageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RandomResourceImageQuery,
    RandomResourceImageQueryVariables
  >(RandomResourceImageDocument, options)
}
export function useRandomResourceImageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RandomResourceImageQuery,
    RandomResourceImageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RandomResourceImageQuery,
    RandomResourceImageQueryVariables
  >(RandomResourceImageDocument, options)
}
export function useRandomResourceImageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RandomResourceImageQuery,
        RandomResourceImageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RandomResourceImageQuery,
    RandomResourceImageQueryVariables
  >(RandomResourceImageDocument, options)
}
export type RandomResourceImageQueryHookResult = ReturnType<
  typeof useRandomResourceImageQuery
>
export type RandomResourceImageLazyQueryHookResult = ReturnType<
  typeof useRandomResourceImageLazyQuery
>
export type RandomResourceImageSuspenseQueryHookResult = ReturnType<
  typeof useRandomResourceImageSuspenseQuery
>
export type RandomResourceImageQueryResult = Apollo.QueryResult<
  RandomResourceImageQuery,
  RandomResourceImageQueryVariables
>
export const FeedbackReviewersDocument = gql`
  query FeedbackReviewers($completionId: Int!) {
    feedbackReviewers(completion_id: $completionId) {
      id
      reviewers
    }
  }
`

/**
 * __useFeedbackReviewersQuery__
 *
 * To run a query within a React component, call `useFeedbackReviewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedbackReviewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedbackReviewersQuery({
 *   variables: {
 *      completionId: // value for 'completionId'
 *   },
 * });
 */
export function useFeedbackReviewersQuery(
  baseOptions: Apollo.QueryHookOptions<
    FeedbackReviewersQuery,
    FeedbackReviewersQueryVariables
  > &
    (
      | { variables: FeedbackReviewersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FeedbackReviewersQuery,
    FeedbackReviewersQueryVariables
  >(FeedbackReviewersDocument, options)
}
export function useFeedbackReviewersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FeedbackReviewersQuery,
    FeedbackReviewersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FeedbackReviewersQuery,
    FeedbackReviewersQueryVariables
  >(FeedbackReviewersDocument, options)
}
export function useFeedbackReviewersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FeedbackReviewersQuery,
        FeedbackReviewersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    FeedbackReviewersQuery,
    FeedbackReviewersQueryVariables
  >(FeedbackReviewersDocument, options)
}
export type FeedbackReviewersQueryHookResult = ReturnType<
  typeof useFeedbackReviewersQuery
>
export type FeedbackReviewersLazyQueryHookResult = ReturnType<
  typeof useFeedbackReviewersLazyQuery
>
export type FeedbackReviewersSuspenseQueryHookResult = ReturnType<
  typeof useFeedbackReviewersSuspenseQuery
>
export type FeedbackReviewersQueryResult = Apollo.QueryResult<
  FeedbackReviewersQuery,
  FeedbackReviewersQueryVariables
>
export const InboxContextDocument = gql`
  query InboxContext($cohort_id: Int, $group_id: Int) {
    inboxContext(cohort_id: $cohort_id, group_id: $group_id) {
      id
      cohort {
        id
        name
        resource {
          id
          name
        }
      }
      group {
        id
        name
      }
    }
  }
`

/**
 * __useInboxContextQuery__
 *
 * To run a query within a React component, call `useInboxContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxContextQuery({
 *   variables: {
 *      cohort_id: // value for 'cohort_id'
 *      group_id: // value for 'group_id'
 *   },
 * });
 */
export function useInboxContextQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InboxContextQuery,
    InboxContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<InboxContextQuery, InboxContextQueryVariables>(
    InboxContextDocument,
    options
  )
}
export function useInboxContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboxContextQuery,
    InboxContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<InboxContextQuery, InboxContextQueryVariables>(
    InboxContextDocument,
    options
  )
}
export function useInboxContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InboxContextQuery,
        InboxContextQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<InboxContextQuery, InboxContextQueryVariables>(
    InboxContextDocument,
    options
  )
}
export type InboxContextQueryHookResult = ReturnType<
  typeof useInboxContextQuery
>
export type InboxContextLazyQueryHookResult = ReturnType<
  typeof useInboxContextLazyQuery
>
export type InboxContextSuspenseQueryHookResult = ReturnType<
  typeof useInboxContextSuspenseQuery
>
export type InboxContextQueryResult = Apollo.QueryResult<
  InboxContextQuery,
  InboxContextQueryVariables
>
export const InboxGroupConnectionsDocument = gql`
  query InboxGroupConnections($search: String, $cursor: String) {
    inboxGroupConnections(first: 10, after: $cursor, search: $search) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...InboxGroupConnection
        }
      }
    }
  }
  ${InboxGroupConnectionFragmentDoc}
`

/**
 * __useInboxGroupConnectionsQuery__
 *
 * To run a query within a React component, call `useInboxGroupConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxGroupConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxGroupConnectionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useInboxGroupConnectionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InboxGroupConnectionsQuery,
    InboxGroupConnectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    InboxGroupConnectionsQuery,
    InboxGroupConnectionsQueryVariables
  >(InboxGroupConnectionsDocument, options)
}
export function useInboxGroupConnectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboxGroupConnectionsQuery,
    InboxGroupConnectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    InboxGroupConnectionsQuery,
    InboxGroupConnectionsQueryVariables
  >(InboxGroupConnectionsDocument, options)
}
export function useInboxGroupConnectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InboxGroupConnectionsQuery,
        InboxGroupConnectionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    InboxGroupConnectionsQuery,
    InboxGroupConnectionsQueryVariables
  >(InboxGroupConnectionsDocument, options)
}
export type InboxGroupConnectionsQueryHookResult = ReturnType<
  typeof useInboxGroupConnectionsQuery
>
export type InboxGroupConnectionsLazyQueryHookResult = ReturnType<
  typeof useInboxGroupConnectionsLazyQuery
>
export type InboxGroupConnectionsSuspenseQueryHookResult = ReturnType<
  typeof useInboxGroupConnectionsSuspenseQuery
>
export type InboxGroupConnectionsQueryResult = Apollo.QueryResult<
  InboxGroupConnectionsQuery,
  InboxGroupConnectionsQueryVariables
>
export const InboxPendingReviewCountDocument = gql`
  query InboxPendingReviewCount(
    $targetId: Int!
    $targetType: InboxPendingReviewTarget!
  ) {
    inboxPendingReview(target_id: $targetId, target_type: $targetType) {
      id
      count
    }
  }
`

/**
 * __useInboxPendingReviewCountQuery__
 *
 * To run a query within a React component, call `useInboxPendingReviewCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxPendingReviewCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxPendingReviewCountQuery({
 *   variables: {
 *      targetId: // value for 'targetId'
 *      targetType: // value for 'targetType'
 *   },
 * });
 */
export function useInboxPendingReviewCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    InboxPendingReviewCountQuery,
    InboxPendingReviewCountQueryVariables
  > &
    (
      | { variables: InboxPendingReviewCountQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    InboxPendingReviewCountQuery,
    InboxPendingReviewCountQueryVariables
  >(InboxPendingReviewCountDocument, options)
}
export function useInboxPendingReviewCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboxPendingReviewCountQuery,
    InboxPendingReviewCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    InboxPendingReviewCountQuery,
    InboxPendingReviewCountQueryVariables
  >(InboxPendingReviewCountDocument, options)
}
export function useInboxPendingReviewCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InboxPendingReviewCountQuery,
        InboxPendingReviewCountQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    InboxPendingReviewCountQuery,
    InboxPendingReviewCountQueryVariables
  >(InboxPendingReviewCountDocument, options)
}
export type InboxPendingReviewCountQueryHookResult = ReturnType<
  typeof useInboxPendingReviewCountQuery
>
export type InboxPendingReviewCountLazyQueryHookResult = ReturnType<
  typeof useInboxPendingReviewCountLazyQuery
>
export type InboxPendingReviewCountSuspenseQueryHookResult = ReturnType<
  typeof useInboxPendingReviewCountSuspenseQuery
>
export type InboxPendingReviewCountQueryResult = Apollo.QueryResult<
  InboxPendingReviewCountQuery,
  InboxPendingReviewCountQueryVariables
>
export const InboxPeopleCompletionCountsDocument = gql`
  query InboxPeopleCompletionCounts(
    $targetType: InboxPeopleCompletionCountsTarget!
    $targetId: Int!
    $first: Int!
    $cursor: String
    $isComplete: Boolean
    $needsReview: Boolean
    $stepSourceId: Int
    $parentSourceId: Int
    $archivedDateFilter: [DateFilter]
  ) {
    inboxPeopleCompletionCounts(
      target_type: $targetType
      target_id: $targetId
      first: $first
      after: $cursor
      is_complete: $isComplete
      needs_review: $needsReview
      step_source_id: $stepSourceId
      parent_source_id: $parentSourceId
      archivedDateFilter: $archivedDateFilter
    ) {
      total
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...InboxPeopleCompletionCounts
        }
      }
    }
  }
  ${InboxPeopleCompletionCountsFragmentDoc}
`

/**
 * __useInboxPeopleCompletionCountsQuery__
 *
 * To run a query within a React component, call `useInboxPeopleCompletionCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxPeopleCompletionCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxPeopleCompletionCountsQuery({
 *   variables: {
 *      targetType: // value for 'targetType'
 *      targetId: // value for 'targetId'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      isComplete: // value for 'isComplete'
 *      needsReview: // value for 'needsReview'
 *      stepSourceId: // value for 'stepSourceId'
 *      parentSourceId: // value for 'parentSourceId'
 *      archivedDateFilter: // value for 'archivedDateFilter'
 *   },
 * });
 */
export function useInboxPeopleCompletionCountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    InboxPeopleCompletionCountsQuery,
    InboxPeopleCompletionCountsQueryVariables
  > &
    (
      | { variables: InboxPeopleCompletionCountsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    InboxPeopleCompletionCountsQuery,
    InboxPeopleCompletionCountsQueryVariables
  >(InboxPeopleCompletionCountsDocument, options)
}
export function useInboxPeopleCompletionCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboxPeopleCompletionCountsQuery,
    InboxPeopleCompletionCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    InboxPeopleCompletionCountsQuery,
    InboxPeopleCompletionCountsQueryVariables
  >(InboxPeopleCompletionCountsDocument, options)
}
export function useInboxPeopleCompletionCountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InboxPeopleCompletionCountsQuery,
        InboxPeopleCompletionCountsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    InboxPeopleCompletionCountsQuery,
    InboxPeopleCompletionCountsQueryVariables
  >(InboxPeopleCompletionCountsDocument, options)
}
export type InboxPeopleCompletionCountsQueryHookResult = ReturnType<
  typeof useInboxPeopleCompletionCountsQuery
>
export type InboxPeopleCompletionCountsLazyQueryHookResult = ReturnType<
  typeof useInboxPeopleCompletionCountsLazyQuery
>
export type InboxPeopleCompletionCountsSuspenseQueryHookResult = ReturnType<
  typeof useInboxPeopleCompletionCountsSuspenseQuery
>
export type InboxPeopleCompletionCountsQueryResult = Apollo.QueryResult<
  InboxPeopleCompletionCountsQuery,
  InboxPeopleCompletionCountsQueryVariables
>
export const InboxReviewersDocument = gql`
  query InboxReviewers($pathId: Int!) {
    inboxReviewers(first: 50, path_id: $pathId) {
      edges {
        node {
          ...InboxReviewer
        }
      }
    }
  }
  ${InboxReviewerFragmentDoc}
`

/**
 * __useInboxReviewersQuery__
 *
 * To run a query within a React component, call `useInboxReviewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxReviewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxReviewersQuery({
 *   variables: {
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useInboxReviewersQuery(
  baseOptions: Apollo.QueryHookOptions<
    InboxReviewersQuery,
    InboxReviewersQueryVariables
  > &
    (
      | { variables: InboxReviewersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<InboxReviewersQuery, InboxReviewersQueryVariables>(
    InboxReviewersDocument,
    options
  )
}
export function useInboxReviewersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboxReviewersQuery,
    InboxReviewersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<InboxReviewersQuery, InboxReviewersQueryVariables>(
    InboxReviewersDocument,
    options
  )
}
export function useInboxReviewersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InboxReviewersQuery,
        InboxReviewersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    InboxReviewersQuery,
    InboxReviewersQueryVariables
  >(InboxReviewersDocument, options)
}
export type InboxReviewersQueryHookResult = ReturnType<
  typeof useInboxReviewersQuery
>
export type InboxReviewersLazyQueryHookResult = ReturnType<
  typeof useInboxReviewersLazyQuery
>
export type InboxReviewersSuspenseQueryHookResult = ReturnType<
  typeof useInboxReviewersSuspenseQuery
>
export type InboxReviewersQueryResult = Apollo.QueryResult<
  InboxReviewersQuery,
  InboxReviewersQueryVariables
>
export const AcceptCommunityGroupInvitationDocument = gql`
  mutation AcceptCommunityGroupInvitation($token: String!) {
    acceptCommunityGroupInvitation(token: $token)
  }
`
export type AcceptCommunityGroupInvitationMutationFn = Apollo.MutationFunction<
  AcceptCommunityGroupInvitationMutation,
  AcceptCommunityGroupInvitationMutationVariables
>

/**
 * __useAcceptCommunityGroupInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptCommunityGroupInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCommunityGroupInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCommunityGroupInvitationMutation, { data, loading, error }] = useAcceptCommunityGroupInvitationMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAcceptCommunityGroupInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptCommunityGroupInvitationMutation,
    AcceptCommunityGroupInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    AcceptCommunityGroupInvitationMutation,
    AcceptCommunityGroupInvitationMutationVariables
  >(AcceptCommunityGroupInvitationDocument, options)
}
export type AcceptCommunityGroupInvitationMutationHookResult = ReturnType<
  typeof useAcceptCommunityGroupInvitationMutation
>
export type AcceptCommunityGroupInvitationMutationResult =
  Apollo.MutationResult<AcceptCommunityGroupInvitationMutation>
export type AcceptCommunityGroupInvitationMutationOptions =
  Apollo.BaseMutationOptions<
    AcceptCommunityGroupInvitationMutation,
    AcceptCommunityGroupInvitationMutationVariables
  >
export const CreateInvitationsDocument = gql`
  mutation CreateInvitations(
    $context: InvitationContext
    $type: InvitationType
    $invite_emails: [String]!
    $invite_to_community_group_role: MentorGroupMembershipRole!
  ) {
    createInvitations(
      context: $context
      type: $type
      invite_emails: $invite_emails
      invite_to_community_group_role: $invite_to_community_group_role
    ) {
      invitations_attempted_count
      invitations_sent_count
      unsuccessful_invitations
    }
  }
`
export type CreateInvitationsMutationFn = Apollo.MutationFunction<
  CreateInvitationsMutation,
  CreateInvitationsMutationVariables
>

/**
 * __useCreateInvitationsMutation__
 *
 * To run a mutation, you first call `useCreateInvitationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvitationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvitationsMutation, { data, loading, error }] = useCreateInvitationsMutation({
 *   variables: {
 *      context: // value for 'context'
 *      type: // value for 'type'
 *      invite_emails: // value for 'invite_emails'
 *      invite_to_community_group_role: // value for 'invite_to_community_group_role'
 *   },
 * });
 */
export function useCreateInvitationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateInvitationsMutation,
    CreateInvitationsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateInvitationsMutation,
    CreateInvitationsMutationVariables
  >(CreateInvitationsDocument, options)
}
export type CreateInvitationsMutationHookResult = ReturnType<
  typeof useCreateInvitationsMutation
>
export type CreateInvitationsMutationResult =
  Apollo.MutationResult<CreateInvitationsMutation>
export type CreateInvitationsMutationOptions = Apollo.BaseMutationOptions<
  CreateInvitationsMutation,
  CreateInvitationsMutationVariables
>
export const DeleteInvitationDocument = gql`
  mutation DeleteInvitation($deleteInvitationId: Int!) {
    deleteInvitation(id: $deleteInvitationId)
  }
`
export type DeleteInvitationMutationFn = Apollo.MutationFunction<
  DeleteInvitationMutation,
  DeleteInvitationMutationVariables
>

/**
 * __useDeleteInvitationMutation__
 *
 * To run a mutation, you first call `useDeleteInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvitationMutation, { data, loading, error }] = useDeleteInvitationMutation({
 *   variables: {
 *      deleteInvitationId: // value for 'deleteInvitationId'
 *   },
 * });
 */
export function useDeleteInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteInvitationMutation,
    DeleteInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteInvitationMutation,
    DeleteInvitationMutationVariables
  >(DeleteInvitationDocument, options)
}
export type DeleteInvitationMutationHookResult = ReturnType<
  typeof useDeleteInvitationMutation
>
export type DeleteInvitationMutationResult =
  Apollo.MutationResult<DeleteInvitationMutation>
export type DeleteInvitationMutationOptions = Apollo.BaseMutationOptions<
  DeleteInvitationMutation,
  DeleteInvitationMutationVariables
>
export const InvitationsDocument = gql`
  query Invitations(
    $first: Int!
    $cursor: String
    $context: InvitationContext
    $deliveryStatus: EmailDeliveryStatus
    $status: InvitationStatus
    $orderBy: [String]
  ) {
    invitations(
      first: $first
      after: $cursor
      context: $context
      delivery_status: $deliveryStatus
      status: $status
      order_by: $orderBy
    ) {
      edges {
        node {
          ...Invitation
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${InvitationFragmentDoc}
`

/**
 * __useInvitationsQuery__
 *
 * To run a query within a React component, call `useInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      context: // value for 'context'
 *      deliveryStatus: // value for 'deliveryStatus'
 *      status: // value for 'status'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useInvitationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    InvitationsQuery,
    InvitationsQueryVariables
  > &
    (
      | { variables: InvitationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<InvitationsQuery, InvitationsQueryVariables>(
    InvitationsDocument,
    options
  )
}
export function useInvitationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InvitationsQuery,
    InvitationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<InvitationsQuery, InvitationsQueryVariables>(
    InvitationsDocument,
    options
  )
}
export function useInvitationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InvitationsQuery,
        InvitationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<InvitationsQuery, InvitationsQueryVariables>(
    InvitationsDocument,
    options
  )
}
export type InvitationsQueryHookResult = ReturnType<typeof useInvitationsQuery>
export type InvitationsLazyQueryHookResult = ReturnType<
  typeof useInvitationsLazyQuery
>
export type InvitationsSuspenseQueryHookResult = ReturnType<
  typeof useInvitationsSuspenseQuery
>
export type InvitationsQueryResult = Apollo.QueryResult<
  InvitationsQuery,
  InvitationsQueryVariables
>
export const ResendInvitationDocument = gql`
  mutation ResendInvitation($resendInvitationId: Int!) {
    resendInvitation(id: $resendInvitationId) {
      ...Invitation
    }
  }
  ${InvitationFragmentDoc}
`
export type ResendInvitationMutationFn = Apollo.MutationFunction<
  ResendInvitationMutation,
  ResendInvitationMutationVariables
>

/**
 * __useResendInvitationMutation__
 *
 * To run a mutation, you first call `useResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendInvitationMutation, { data, loading, error }] = useResendInvitationMutation({
 *   variables: {
 *      resendInvitationId: // value for 'resendInvitationId'
 *   },
 * });
 */
export function useResendInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResendInvitationMutation,
    ResendInvitationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ResendInvitationMutation,
    ResendInvitationMutationVariables
  >(ResendInvitationDocument, options)
}
export type ResendInvitationMutationHookResult = ReturnType<
  typeof useResendInvitationMutation
>
export type ResendInvitationMutationResult =
  Apollo.MutationResult<ResendInvitationMutation>
export type ResendInvitationMutationOptions = Apollo.BaseMutationOptions<
  ResendInvitationMutation,
  ResendInvitationMutationVariables
>
export const FeatureLockDocument = gql`
  query FeatureLock($default_billing_plan_set: Boolean = true) {
    account {
      id
      is_activated
      is_activated_via_override
      is_on_legacy_plan
      billing_subscription {
        id
        plan {
          ...FeatureLockSchoolBillingPlan
        }
      }
      billing_plan_set(default: $default_billing_plan_set) {
        id
        plans {
          ...FeatureLockSchoolBillingPlan
        }
      }
    }
  }
  ${FeatureLockSchoolBillingPlanFragmentDoc}
`

/**
 * __useFeatureLockQuery__
 *
 * To run a query within a React component, call `useFeatureLockQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureLockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureLockQuery({
 *   variables: {
 *      default_billing_plan_set: // value for 'default_billing_plan_set'
 *   },
 * });
 */
export function useFeatureLockQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FeatureLockQuery,
    FeatureLockQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FeatureLockQuery, FeatureLockQueryVariables>(
    FeatureLockDocument,
    options
  )
}
export function useFeatureLockLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FeatureLockQuery,
    FeatureLockQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FeatureLockQuery, FeatureLockQueryVariables>(
    FeatureLockDocument,
    options
  )
}
export function useFeatureLockSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FeatureLockQuery,
        FeatureLockQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FeatureLockQuery, FeatureLockQueryVariables>(
    FeatureLockDocument,
    options
  )
}
export type FeatureLockQueryHookResult = ReturnType<typeof useFeatureLockQuery>
export type FeatureLockLazyQueryHookResult = ReturnType<
  typeof useFeatureLockLazyQuery
>
export type FeatureLockSuspenseQueryHookResult = ReturnType<
  typeof useFeatureLockSuspenseQuery
>
export type FeatureLockQueryResult = Apollo.QueryResult<
  FeatureLockQuery,
  FeatureLockQueryVariables
>
export const LibraryAuthorsDocument = gql`
  query LibraryAuthors(
    $search: String
    $resourceSearch: String
    $resourceAuthorNameFilter: StringFilter
    $resourceCategoryNameFilter: StringFilter
    $cursor: String
  ) {
    authors(
      first: 15
      after: $cursor
      search: $search
      resource_search: $resourceSearch
      resource_author_names: $resourceAuthorNameFilter
      resource_category_names: $resourceCategoryNameFilter
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...Author
        }
      }
    }
  }
  ${AuthorFragmentDoc}
`

/**
 * __useLibraryAuthorsQuery__
 *
 * To run a query within a React component, call `useLibraryAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryAuthorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryAuthorsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      resourceSearch: // value for 'resourceSearch'
 *      resourceAuthorNameFilter: // value for 'resourceAuthorNameFilter'
 *      resourceCategoryNameFilter: // value for 'resourceCategoryNameFilter'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useLibraryAuthorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LibraryAuthorsQuery,
    LibraryAuthorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<LibraryAuthorsQuery, LibraryAuthorsQueryVariables>(
    LibraryAuthorsDocument,
    options
  )
}
export function useLibraryAuthorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LibraryAuthorsQuery,
    LibraryAuthorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<LibraryAuthorsQuery, LibraryAuthorsQueryVariables>(
    LibraryAuthorsDocument,
    options
  )
}
export function useLibraryAuthorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LibraryAuthorsQuery,
        LibraryAuthorsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    LibraryAuthorsQuery,
    LibraryAuthorsQueryVariables
  >(LibraryAuthorsDocument, options)
}
export type LibraryAuthorsQueryHookResult = ReturnType<
  typeof useLibraryAuthorsQuery
>
export type LibraryAuthorsLazyQueryHookResult = ReturnType<
  typeof useLibraryAuthorsLazyQuery
>
export type LibraryAuthorsSuspenseQueryHookResult = ReturnType<
  typeof useLibraryAuthorsSuspenseQuery
>
export type LibraryAuthorsQueryResult = Apollo.QueryResult<
  LibraryAuthorsQuery,
  LibraryAuthorsQueryVariables
>
export const LibraryCategoriesDocument = gql`
  query LibraryCategories(
    $search: String
    $resourceSearch: String
    $resourceCategoryNameFilter: StringFilter
    $resourceAuthorNameFilter: StringFilter
    $cursor: String
  ) {
    categories(
      first: 15
      after: $cursor
      search: $search
      resource_search: $resourceSearch
      resource_category_names: $resourceCategoryNameFilter
      resource_author_names: $resourceAuthorNameFilter
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...Category
        }
      }
    }
  }
  ${CategoryFragmentDoc}
`

/**
 * __useLibraryCategoriesQuery__
 *
 * To run a query within a React component, call `useLibraryCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryCategoriesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      resourceSearch: // value for 'resourceSearch'
 *      resourceCategoryNameFilter: // value for 'resourceCategoryNameFilter'
 *      resourceAuthorNameFilter: // value for 'resourceAuthorNameFilter'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useLibraryCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LibraryCategoriesQuery,
    LibraryCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    LibraryCategoriesQuery,
    LibraryCategoriesQueryVariables
  >(LibraryCategoriesDocument, options)
}
export function useLibraryCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LibraryCategoriesQuery,
    LibraryCategoriesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    LibraryCategoriesQuery,
    LibraryCategoriesQueryVariables
  >(LibraryCategoriesDocument, options)
}
export function useLibraryCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LibraryCategoriesQuery,
        LibraryCategoriesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    LibraryCategoriesQuery,
    LibraryCategoriesQueryVariables
  >(LibraryCategoriesDocument, options)
}
export type LibraryCategoriesQueryHookResult = ReturnType<
  typeof useLibraryCategoriesQuery
>
export type LibraryCategoriesLazyQueryHookResult = ReturnType<
  typeof useLibraryCategoriesLazyQuery
>
export type LibraryCategoriesSuspenseQueryHookResult = ReturnType<
  typeof useLibraryCategoriesSuspenseQuery
>
export type LibraryCategoriesQueryResult = Apollo.QueryResult<
  LibraryCategoriesQuery,
  LibraryCategoriesQueryVariables
>
export const LibraryResourcesDocument = gql`
  query LibraryResources(
    $idFilter: IDFilter
    $categoryIdFilter: IDFilter
    $authorIdFilter: IDFilter
    $categoryNameFilter: StringFilter
    $authorNameFilter: StringFilter
    $resourceTypeFilter: ResourceTypeFilter
    $licensedFromSchoolIdFilter: IDFilter
    $roleFilter: RoleFilter
    $assignConfig: AssignConfig
    $search: String
    $categorySearch: String
    $authorSearch: String
    $first: Int!
    $cursor: String
    $orderBy: String
  ) {
    resources(
      id: $idFilter
      author_ids: $authorIdFilter
      category_ids: $categoryIdFilter
      author_names: $authorNameFilter
      category_names: $categoryNameFilter
      resource_types: $resourceTypeFilter
      licensed_from_school: $licensedFromSchoolIdFilter
      role: $roleFilter
      assign_config: $assignConfig
      search: $search
      category_search: $categorySearch
      author_search: $authorSearch
      first: $first
      after: $cursor
      orderBy: $orderBy
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...Resource
          authors(first: 5) {
            edges {
              node {
                ...Author
              }
            }
          }
          groups(
            first: 1
            assign_config: $assignConfig
            include_curriculum: false
          ) {
            total
          }
          curriculum: group(type: curriculum) {
            id
          }
          license_offerings(first: 10, licensing_mode: private_cohorts) {
            edges {
              node {
                id
                cost_per_seat
              }
            }
          }
        }
      }
    }
  }
  ${ResourceFragmentDoc}
  ${AuthorFragmentDoc}
`

/**
 * __useLibraryResourcesQuery__
 *
 * To run a query within a React component, call `useLibraryResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLibraryResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLibraryResourcesQuery({
 *   variables: {
 *      idFilter: // value for 'idFilter'
 *      categoryIdFilter: // value for 'categoryIdFilter'
 *      authorIdFilter: // value for 'authorIdFilter'
 *      categoryNameFilter: // value for 'categoryNameFilter'
 *      authorNameFilter: // value for 'authorNameFilter'
 *      resourceTypeFilter: // value for 'resourceTypeFilter'
 *      licensedFromSchoolIdFilter: // value for 'licensedFromSchoolIdFilter'
 *      roleFilter: // value for 'roleFilter'
 *      assignConfig: // value for 'assignConfig'
 *      search: // value for 'search'
 *      categorySearch: // value for 'categorySearch'
 *      authorSearch: // value for 'authorSearch'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useLibraryResourcesQuery(
  baseOptions: Apollo.QueryHookOptions<
    LibraryResourcesQuery,
    LibraryResourcesQueryVariables
  > &
    (
      | { variables: LibraryResourcesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<LibraryResourcesQuery, LibraryResourcesQueryVariables>(
    LibraryResourcesDocument,
    options
  )
}
export function useLibraryResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LibraryResourcesQuery,
    LibraryResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    LibraryResourcesQuery,
    LibraryResourcesQueryVariables
  >(LibraryResourcesDocument, options)
}
export function useLibraryResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LibraryResourcesQuery,
        LibraryResourcesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    LibraryResourcesQuery,
    LibraryResourcesQueryVariables
  >(LibraryResourcesDocument, options)
}
export type LibraryResourcesQueryHookResult = ReturnType<
  typeof useLibraryResourcesQuery
>
export type LibraryResourcesLazyQueryHookResult = ReturnType<
  typeof useLibraryResourcesLazyQuery
>
export type LibraryResourcesSuspenseQueryHookResult = ReturnType<
  typeof useLibraryResourcesSuspenseQuery
>
export type LibraryResourcesQueryResult = Apollo.QueryResult<
  LibraryResourcesQuery,
  LibraryResourcesQueryVariables
>
export const UpdateLocalTranslationDocument = gql`
  mutation UpdateLocalTranslation($translation: JSON!) {
    updateLocalTranslation(translation: $translation)
  }
`
export type UpdateLocalTranslationMutationFn = Apollo.MutationFunction<
  UpdateLocalTranslationMutation,
  UpdateLocalTranslationMutationVariables
>

/**
 * __useUpdateLocalTranslationMutation__
 *
 * To run a mutation, you first call `useUpdateLocalTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocalTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocalTranslationMutation, { data, loading, error }] = useUpdateLocalTranslationMutation({
 *   variables: {
 *      translation: // value for 'translation'
 *   },
 * });
 */
export function useUpdateLocalTranslationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLocalTranslationMutation,
    UpdateLocalTranslationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateLocalTranslationMutation,
    UpdateLocalTranslationMutationVariables
  >(UpdateLocalTranslationDocument, options)
}
export type UpdateLocalTranslationMutationHookResult = ReturnType<
  typeof useUpdateLocalTranslationMutation
>
export type UpdateLocalTranslationMutationResult =
  Apollo.MutationResult<UpdateLocalTranslationMutation>
export type UpdateLocalTranslationMutationOptions = Apollo.BaseMutationOptions<
  UpdateLocalTranslationMutation,
  UpdateLocalTranslationMutationVariables
>
export const TranslationDocument = gql`
  query Translation($language: String, $isDefault: Boolean) {
    translation(language: $language, is_default: $isDefault) {
      id
      name
      language
      translation
      master_translation
      is_default
    }
  }
`

/**
 * __useTranslationQuery__
 *
 * To run a query within a React component, call `useTranslationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranslationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranslationQuery({
 *   variables: {
 *      language: // value for 'language'
 *      isDefault: // value for 'isDefault'
 *   },
 * });
 */
export function useTranslationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TranslationQuery,
    TranslationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TranslationQuery, TranslationQueryVariables>(
    TranslationDocument,
    options
  )
}
export function useTranslationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TranslationQuery,
    TranslationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TranslationQuery, TranslationQueryVariables>(
    TranslationDocument,
    options
  )
}
export function useTranslationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TranslationQuery,
        TranslationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<TranslationQuery, TranslationQueryVariables>(
    TranslationDocument,
    options
  )
}
export type TranslationQueryHookResult = ReturnType<typeof useTranslationQuery>
export type TranslationLazyQueryHookResult = ReturnType<
  typeof useTranslationLazyQuery
>
export type TranslationSuspenseQueryHookResult = ReturnType<
  typeof useTranslationSuspenseQuery
>
export type TranslationQueryResult = Apollo.QueryResult<
  TranslationQuery,
  TranslationQueryVariables
>
export const BatchCreateMentorGroupMembershipDocument = gql`
  mutation BatchCreateMentorGroupMembership(
    $user_ids: [Int!]
    $group: Int!
    $role: MentorGroupMembershipRole!
  ) {
    batchCreateMentorGroupMembership(
      user_ids: $user_ids
      group: $group
      role: $role
    ) {
      success
      group_memberships_created_count
    }
  }
`
export type BatchCreateMentorGroupMembershipMutationFn =
  Apollo.MutationFunction<
    BatchCreateMentorGroupMembershipMutation,
    BatchCreateMentorGroupMembershipMutationVariables
  >

/**
 * __useBatchCreateMentorGroupMembershipMutation__
 *
 * To run a mutation, you first call `useBatchCreateMentorGroupMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateMentorGroupMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateMentorGroupMembershipMutation, { data, loading, error }] = useBatchCreateMentorGroupMembershipMutation({
 *   variables: {
 *      user_ids: // value for 'user_ids'
 *      group: // value for 'group'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useBatchCreateMentorGroupMembershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BatchCreateMentorGroupMembershipMutation,
    BatchCreateMentorGroupMembershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BatchCreateMentorGroupMembershipMutation,
    BatchCreateMentorGroupMembershipMutationVariables
  >(BatchCreateMentorGroupMembershipDocument, options)
}
export type BatchCreateMentorGroupMembershipMutationHookResult = ReturnType<
  typeof useBatchCreateMentorGroupMembershipMutation
>
export type BatchCreateMentorGroupMembershipMutationResult =
  Apollo.MutationResult<BatchCreateMentorGroupMembershipMutation>
export type BatchCreateMentorGroupMembershipMutationOptions =
  Apollo.BaseMutationOptions<
    BatchCreateMentorGroupMembershipMutation,
    BatchCreateMentorGroupMembershipMutationVariables
  >
export const CreateMentorGroupDocument = gql`
  mutation CreateMentorGroup(
    $name: String!
    $parent: Int
    $type: MentorGroupType
  ) {
    createMentorGroup(name: $name, parent: $parent, type: $type) {
      ...MentorGroup
      memberships(first: 5) {
        total
        edges {
          node {
            id
            user {
              ...User
            }
          }
        }
      }
    }
  }
  ${MentorGroupFragmentDoc}
  ${UserFragmentDoc}
`
export type CreateMentorGroupMutationFn = Apollo.MutationFunction<
  CreateMentorGroupMutation,
  CreateMentorGroupMutationVariables
>

/**
 * __useCreateMentorGroupMutation__
 *
 * To run a mutation, you first call `useCreateMentorGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMentorGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMentorGroupMutation, { data, loading, error }] = useCreateMentorGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *      parent: // value for 'parent'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateMentorGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMentorGroupMutation,
    CreateMentorGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateMentorGroupMutation,
    CreateMentorGroupMutationVariables
  >(CreateMentorGroupDocument, options)
}
export type CreateMentorGroupMutationHookResult = ReturnType<
  typeof useCreateMentorGroupMutation
>
export type CreateMentorGroupMutationResult =
  Apollo.MutationResult<CreateMentorGroupMutation>
export type CreateMentorGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateMentorGroupMutation,
  CreateMentorGroupMutationVariables
>
export const DeleteMentorGroupMembershipDocument = gql`
  mutation DeleteMentorGroupMembership($id: Int!, $group: Int!) {
    deleteMentorGroupMembership(id: $id, group: $group)
  }
`
export type DeleteMentorGroupMembershipMutationFn = Apollo.MutationFunction<
  DeleteMentorGroupMembershipMutation,
  DeleteMentorGroupMembershipMutationVariables
>

/**
 * __useDeleteMentorGroupMembershipMutation__
 *
 * To run a mutation, you first call `useDeleteMentorGroupMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMentorGroupMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMentorGroupMembershipMutation, { data, loading, error }] = useDeleteMentorGroupMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      group: // value for 'group'
 *   },
 * });
 */
export function useDeleteMentorGroupMembershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMentorGroupMembershipMutation,
    DeleteMentorGroupMembershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteMentorGroupMembershipMutation,
    DeleteMentorGroupMembershipMutationVariables
  >(DeleteMentorGroupMembershipDocument, options)
}
export type DeleteMentorGroupMembershipMutationHookResult = ReturnType<
  typeof useDeleteMentorGroupMembershipMutation
>
export type DeleteMentorGroupMembershipMutationResult =
  Apollo.MutationResult<DeleteMentorGroupMembershipMutation>
export type DeleteMentorGroupMembershipMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteMentorGroupMembershipMutation,
    DeleteMentorGroupMembershipMutationVariables
  >
export const DeleteMentorGroupDocument = gql`
  mutation DeleteMentorGroup($id: Int!) {
    deleteMentorGroup(id: $id)
  }
`
export type DeleteMentorGroupMutationFn = Apollo.MutationFunction<
  DeleteMentorGroupMutation,
  DeleteMentorGroupMutationVariables
>

/**
 * __useDeleteMentorGroupMutation__
 *
 * To run a mutation, you first call `useDeleteMentorGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMentorGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMentorGroupMutation, { data, loading, error }] = useDeleteMentorGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMentorGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteMentorGroupMutation,
    DeleteMentorGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteMentorGroupMutation,
    DeleteMentorGroupMutationVariables
  >(DeleteMentorGroupDocument, options)
}
export type DeleteMentorGroupMutationHookResult = ReturnType<
  typeof useDeleteMentorGroupMutation
>
export type DeleteMentorGroupMutationResult =
  Apollo.MutationResult<DeleteMentorGroupMutation>
export type DeleteMentorGroupMutationOptions = Apollo.BaseMutationOptions<
  DeleteMentorGroupMutation,
  DeleteMentorGroupMutationVariables
>
export const MentorGroupInvitationsDocument = gql`
  query MentorGroupInvitations(
    $group_id: Int!
    $search: String
    $cursor: String
  ) {
    school {
      id
      mentor_group(id: $group_id) {
        id
        invitations(
          first: 50
          after: $cursor
          status: not_accepted
          search: $search
        ) {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...Invitation
            }
          }
        }
      }
    }
  }
  ${InvitationFragmentDoc}
`

/**
 * __useMentorGroupInvitationsQuery__
 *
 * To run a query within a React component, call `useMentorGroupInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorGroupInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorGroupInvitationsQuery({
 *   variables: {
 *      group_id: // value for 'group_id'
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useMentorGroupInvitationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MentorGroupInvitationsQuery,
    MentorGroupInvitationsQueryVariables
  > &
    (
      | { variables: MentorGroupInvitationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MentorGroupInvitationsQuery,
    MentorGroupInvitationsQueryVariables
  >(MentorGroupInvitationsDocument, options)
}
export function useMentorGroupInvitationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentorGroupInvitationsQuery,
    MentorGroupInvitationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MentorGroupInvitationsQuery,
    MentorGroupInvitationsQueryVariables
  >(MentorGroupInvitationsDocument, options)
}
export function useMentorGroupInvitationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MentorGroupInvitationsQuery,
        MentorGroupInvitationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MentorGroupInvitationsQuery,
    MentorGroupInvitationsQueryVariables
  >(MentorGroupInvitationsDocument, options)
}
export type MentorGroupInvitationsQueryHookResult = ReturnType<
  typeof useMentorGroupInvitationsQuery
>
export type MentorGroupInvitationsLazyQueryHookResult = ReturnType<
  typeof useMentorGroupInvitationsLazyQuery
>
export type MentorGroupInvitationsSuspenseQueryHookResult = ReturnType<
  typeof useMentorGroupInvitationsSuspenseQuery
>
export type MentorGroupInvitationsQueryResult = Apollo.QueryResult<
  MentorGroupInvitationsQuery,
  MentorGroupInvitationsQueryVariables
>
export const MentorGroupMembershipDocument = gql`
  query MentorGroupMembership($id: Int!) {
    mentorGroupMembership(id: $id) {
      ...MentorGroupMembership
    }
  }
  ${MentorGroupMembershipFragmentDoc}
`

/**
 * __useMentorGroupMembershipQuery__
 *
 * To run a query within a React component, call `useMentorGroupMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorGroupMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorGroupMembershipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMentorGroupMembershipQuery(
  baseOptions: Apollo.QueryHookOptions<
    MentorGroupMembershipQuery,
    MentorGroupMembershipQueryVariables
  > &
    (
      | { variables: MentorGroupMembershipQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MentorGroupMembershipQuery,
    MentorGroupMembershipQueryVariables
  >(MentorGroupMembershipDocument, options)
}
export function useMentorGroupMembershipLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentorGroupMembershipQuery,
    MentorGroupMembershipQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MentorGroupMembershipQuery,
    MentorGroupMembershipQueryVariables
  >(MentorGroupMembershipDocument, options)
}
export function useMentorGroupMembershipSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MentorGroupMembershipQuery,
        MentorGroupMembershipQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MentorGroupMembershipQuery,
    MentorGroupMembershipQueryVariables
  >(MentorGroupMembershipDocument, options)
}
export type MentorGroupMembershipQueryHookResult = ReturnType<
  typeof useMentorGroupMembershipQuery
>
export type MentorGroupMembershipLazyQueryHookResult = ReturnType<
  typeof useMentorGroupMembershipLazyQuery
>
export type MentorGroupMembershipSuspenseQueryHookResult = ReturnType<
  typeof useMentorGroupMembershipSuspenseQuery
>
export type MentorGroupMembershipQueryResult = Apollo.QueryResult<
  MentorGroupMembershipQuery,
  MentorGroupMembershipQueryVariables
>
export const MentorGroupMembershipsDocument = gql`
  query MentorGroupMemberships(
    $group_id: Int!
    $search: String
    $cursor: String
  ) {
    school {
      ...School
      mentor_group(id: $group_id) {
        id
        memberships(
          first: 50
          after: $cursor
          search: $search
          role: { eq: member }
        ) {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...MentorGroupMembership
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${MentorGroupMembershipFragmentDoc}
`

/**
 * __useMentorGroupMembershipsQuery__
 *
 * To run a query within a React component, call `useMentorGroupMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorGroupMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorGroupMembershipsQuery({
 *   variables: {
 *      group_id: // value for 'group_id'
 *      search: // value for 'search'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useMentorGroupMembershipsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MentorGroupMembershipsQuery,
    MentorGroupMembershipsQueryVariables
  > &
    (
      | { variables: MentorGroupMembershipsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MentorGroupMembershipsQuery,
    MentorGroupMembershipsQueryVariables
  >(MentorGroupMembershipsDocument, options)
}
export function useMentorGroupMembershipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentorGroupMembershipsQuery,
    MentorGroupMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MentorGroupMembershipsQuery,
    MentorGroupMembershipsQueryVariables
  >(MentorGroupMembershipsDocument, options)
}
export function useMentorGroupMembershipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MentorGroupMembershipsQuery,
        MentorGroupMembershipsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MentorGroupMembershipsQuery,
    MentorGroupMembershipsQueryVariables
  >(MentorGroupMembershipsDocument, options)
}
export type MentorGroupMembershipsQueryHookResult = ReturnType<
  typeof useMentorGroupMembershipsQuery
>
export type MentorGroupMembershipsLazyQueryHookResult = ReturnType<
  typeof useMentorGroupMembershipsLazyQuery
>
export type MentorGroupMembershipsSuspenseQueryHookResult = ReturnType<
  typeof useMentorGroupMembershipsSuspenseQuery
>
export type MentorGroupMembershipsQueryResult = Apollo.QueryResult<
  MentorGroupMembershipsQuery,
  MentorGroupMembershipsQueryVariables
>
export const MentorGroupDocument = gql`
  query MentorGroup($id: Int!) {
    school {
      ...School
      mentor_group(id: $id) {
        ...MentorGroup
        user_membership {
          ...MentorGroupMembership
        }
        parent {
          ...MentorGroup
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${MentorGroupFragmentDoc}
  ${MentorGroupMembershipFragmentDoc}
`

/**
 * __useMentorGroupQuery__
 *
 * To run a query within a React component, call `useMentorGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMentorGroupQuery(
  baseOptions: Apollo.QueryHookOptions<
    MentorGroupQuery,
    MentorGroupQueryVariables
  > &
    (
      | { variables: MentorGroupQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MentorGroupQuery, MentorGroupQueryVariables>(
    MentorGroupDocument,
    options
  )
}
export function useMentorGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentorGroupQuery,
    MentorGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MentorGroupQuery, MentorGroupQueryVariables>(
    MentorGroupDocument,
    options
  )
}
export function useMentorGroupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MentorGroupQuery,
        MentorGroupQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<MentorGroupQuery, MentorGroupQueryVariables>(
    MentorGroupDocument,
    options
  )
}
export type MentorGroupQueryHookResult = ReturnType<typeof useMentorGroupQuery>
export type MentorGroupLazyQueryHookResult = ReturnType<
  typeof useMentorGroupLazyQuery
>
export type MentorGroupSuspenseQueryHookResult = ReturnType<
  typeof useMentorGroupSuspenseQuery
>
export type MentorGroupQueryResult = Apollo.QueryResult<
  MentorGroupQuery,
  MentorGroupQueryVariables
>
export const MentorGroupStaffMembershipsDocument = gql`
  query MentorGroupStaffMemberships($group_id: Int!) {
    school {
      ...School
      mentor_group(id: $group_id) {
        id
        memberships(first: 1042, role: { gte: moderator }, order_by: "-role") {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...MentorGroupMembership
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${MentorGroupMembershipFragmentDoc}
`

/**
 * __useMentorGroupStaffMembershipsQuery__
 *
 * To run a query within a React component, call `useMentorGroupStaffMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorGroupStaffMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorGroupStaffMembershipsQuery({
 *   variables: {
 *      group_id: // value for 'group_id'
 *   },
 * });
 */
export function useMentorGroupStaffMembershipsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MentorGroupStaffMembershipsQuery,
    MentorGroupStaffMembershipsQueryVariables
  > &
    (
      | { variables: MentorGroupStaffMembershipsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MentorGroupStaffMembershipsQuery,
    MentorGroupStaffMembershipsQueryVariables
  >(MentorGroupStaffMembershipsDocument, options)
}
export function useMentorGroupStaffMembershipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentorGroupStaffMembershipsQuery,
    MentorGroupStaffMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MentorGroupStaffMembershipsQuery,
    MentorGroupStaffMembershipsQueryVariables
  >(MentorGroupStaffMembershipsDocument, options)
}
export function useMentorGroupStaffMembershipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MentorGroupStaffMembershipsQuery,
        MentorGroupStaffMembershipsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MentorGroupStaffMembershipsQuery,
    MentorGroupStaffMembershipsQueryVariables
  >(MentorGroupStaffMembershipsDocument, options)
}
export type MentorGroupStaffMembershipsQueryHookResult = ReturnType<
  typeof useMentorGroupStaffMembershipsQuery
>
export type MentorGroupStaffMembershipsLazyQueryHookResult = ReturnType<
  typeof useMentorGroupStaffMembershipsLazyQuery
>
export type MentorGroupStaffMembershipsSuspenseQueryHookResult = ReturnType<
  typeof useMentorGroupStaffMembershipsSuspenseQuery
>
export type MentorGroupStaffMembershipsQueryResult = Apollo.QueryResult<
  MentorGroupStaffMembershipsQuery,
  MentorGroupStaffMembershipsQueryVariables
>
export const MentorGroupSubscriptionDocument = gql`
  query MentorGroupSubscription($group_id: Int!) {
    school {
      id
      mentor_group(id: $group_id) {
        ...MentorGroupSubscription
      }
    }
  }
  ${MentorGroupSubscriptionFragmentDoc}
`

/**
 * __useMentorGroupSubscriptionQuery__
 *
 * To run a query within a React component, call `useMentorGroupSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorGroupSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorGroupSubscriptionQuery({
 *   variables: {
 *      group_id: // value for 'group_id'
 *   },
 * });
 */
export function useMentorGroupSubscriptionQuery(
  baseOptions: Apollo.QueryHookOptions<
    MentorGroupSubscriptionQuery,
    MentorGroupSubscriptionQueryVariables
  > &
    (
      | { variables: MentorGroupSubscriptionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    MentorGroupSubscriptionQuery,
    MentorGroupSubscriptionQueryVariables
  >(MentorGroupSubscriptionDocument, options)
}
export function useMentorGroupSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentorGroupSubscriptionQuery,
    MentorGroupSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MentorGroupSubscriptionQuery,
    MentorGroupSubscriptionQueryVariables
  >(MentorGroupSubscriptionDocument, options)
}
export function useMentorGroupSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MentorGroupSubscriptionQuery,
        MentorGroupSubscriptionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MentorGroupSubscriptionQuery,
    MentorGroupSubscriptionQueryVariables
  >(MentorGroupSubscriptionDocument, options)
}
export type MentorGroupSubscriptionQueryHookResult = ReturnType<
  typeof useMentorGroupSubscriptionQuery
>
export type MentorGroupSubscriptionLazyQueryHookResult = ReturnType<
  typeof useMentorGroupSubscriptionLazyQuery
>
export type MentorGroupSubscriptionSuspenseQueryHookResult = ReturnType<
  typeof useMentorGroupSubscriptionSuspenseQuery
>
export type MentorGroupSubscriptionQueryResult = Apollo.QueryResult<
  MentorGroupSubscriptionQuery,
  MentorGroupSubscriptionQueryVariables
>
export const MentorGroupsDocument = gql`
  query MentorGroups(
    $cursor: String
    $id: IDFilter
    $topLevelOnly: Boolean
    $parentId: IDFilter
    $descendentOfParentId: EquivalenceIDFilter
    $seatLimitFilter: IntFilter
    $search: String
  ) {
    school {
      ...School
      mentor_groups(
        after: $cursor
        first: 25
        id: $id
        top_level_only: $topLevelOnly
        parent_id: $parentId
        descendant_of_parent_id: $descendentOfParentId
        seat_limit_filter: $seatLimitFilter
        search: $search
      ) {
        total
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...MentorGroup
            memberships(first: 5) {
              total
              edges {
                node {
                  id
                  user {
                    ...User
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${MentorGroupFragmentDoc}
  ${UserFragmentDoc}
`

/**
 * __useMentorGroupsQuery__
 *
 * To run a query within a React component, call `useMentorGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentorGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentorGroupsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      id: // value for 'id'
 *      topLevelOnly: // value for 'topLevelOnly'
 *      parentId: // value for 'parentId'
 *      descendentOfParentId: // value for 'descendentOfParentId'
 *      seatLimitFilter: // value for 'seatLimitFilter'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMentorGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MentorGroupsQuery,
    MentorGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MentorGroupsQuery, MentorGroupsQueryVariables>(
    MentorGroupsDocument,
    options
  )
}
export function useMentorGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MentorGroupsQuery,
    MentorGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<MentorGroupsQuery, MentorGroupsQueryVariables>(
    MentorGroupsDocument,
    options
  )
}
export function useMentorGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MentorGroupsQuery,
        MentorGroupsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<MentorGroupsQuery, MentorGroupsQueryVariables>(
    MentorGroupsDocument,
    options
  )
}
export type MentorGroupsQueryHookResult = ReturnType<
  typeof useMentorGroupsQuery
>
export type MentorGroupsLazyQueryHookResult = ReturnType<
  typeof useMentorGroupsLazyQuery
>
export type MentorGroupsSuspenseQueryHookResult = ReturnType<
  typeof useMentorGroupsSuspenseQuery
>
export type MentorGroupsQueryResult = Apollo.QueryResult<
  MentorGroupsQuery,
  MentorGroupsQueryVariables
>
export const UpdateMentorGroupMembershipDocument = gql`
  mutation UpdateMentorGroupMembership(
    $id: Int!
    $group: Int!
    $role: MentorGroupMembershipRole
    $canReview: Boolean
    $hasAccess: Boolean
    $sendMentorDigest: Boolean
  ) {
    updateMentorGroupMembership(
      id: $id
      group: $group
      role: $role
      can_review: $canReview
      has_access: $hasAccess
      send_mentor_digest: $sendMentorDigest
    ) {
      ...MentorGroupMembership
    }
  }
  ${MentorGroupMembershipFragmentDoc}
`
export type UpdateMentorGroupMembershipMutationFn = Apollo.MutationFunction<
  UpdateMentorGroupMembershipMutation,
  UpdateMentorGroupMembershipMutationVariables
>

/**
 * __useUpdateMentorGroupMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateMentorGroupMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMentorGroupMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMentorGroupMembershipMutation, { data, loading, error }] = useUpdateMentorGroupMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      group: // value for 'group'
 *      role: // value for 'role'
 *      canReview: // value for 'canReview'
 *      hasAccess: // value for 'hasAccess'
 *      sendMentorDigest: // value for 'sendMentorDigest'
 *   },
 * });
 */
export function useUpdateMentorGroupMembershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMentorGroupMembershipMutation,
    UpdateMentorGroupMembershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateMentorGroupMembershipMutation,
    UpdateMentorGroupMembershipMutationVariables
  >(UpdateMentorGroupMembershipDocument, options)
}
export type UpdateMentorGroupMembershipMutationHookResult = ReturnType<
  typeof useUpdateMentorGroupMembershipMutation
>
export type UpdateMentorGroupMembershipMutationResult =
  Apollo.MutationResult<UpdateMentorGroupMembershipMutation>
export type UpdateMentorGroupMembershipMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateMentorGroupMembershipMutation,
    UpdateMentorGroupMembershipMutationVariables
  >
export const UpdateMentorGroupDocument = gql`
  mutation UpdateMentorGroup(
    $id: Int!
    $name: String
    $parent: Int
    $description: String
    $type: MentorGroupType
  ) {
    updateMentorGroup(
      id: $id
      name: $name
      parent: $parent
      description: $description
      type: $type
    ) {
      ...MentorGroup
    }
  }
  ${MentorGroupFragmentDoc}
`
export type UpdateMentorGroupMutationFn = Apollo.MutationFunction<
  UpdateMentorGroupMutation,
  UpdateMentorGroupMutationVariables
>

/**
 * __useUpdateMentorGroupMutation__
 *
 * To run a mutation, you first call `useUpdateMentorGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMentorGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMentorGroupMutation, { data, loading, error }] = useUpdateMentorGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      parent: // value for 'parent'
 *      description: // value for 'description'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateMentorGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMentorGroupMutation,
    UpdateMentorGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateMentorGroupMutation,
    UpdateMentorGroupMutationVariables
  >(UpdateMentorGroupDocument, options)
}
export type UpdateMentorGroupMutationHookResult = ReturnType<
  typeof useUpdateMentorGroupMutation
>
export type UpdateMentorGroupMutationResult =
  Apollo.MutationResult<UpdateMentorGroupMutation>
export type UpdateMentorGroupMutationOptions = Apollo.BaseMutationOptions<
  UpdateMentorGroupMutation,
  UpdateMentorGroupMutationVariables
>
export const NotesDocument = gql`
  query Notes(
    $first: Int = 50
    $cursor: String
    $context: ContextModelInput!
    $visibility: NoteVisibility
  ) {
    notes(
      first: $first
      after: $cursor
      context: $context
      visibility: $visibility
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...Note
        }
      }
    }
  }
  ${NoteFragmentDoc}
`

/**
 * __useNotesQuery__
 *
 * To run a query within a React component, call `useNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      context: // value for 'context'
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function useNotesQuery(
  baseOptions: Apollo.QueryHookOptions<NotesQuery, NotesQueryVariables> &
    ({ variables: NotesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<NotesQuery, NotesQueryVariables>(
    NotesDocument,
    options
  )
}
export function useNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<NotesQuery, NotesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<NotesQuery, NotesQueryVariables>(
    NotesDocument,
    options
  )
}
export function useNotesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<NotesQuery, NotesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<NotesQuery, NotesQueryVariables>(
    NotesDocument,
    options
  )
}
export type NotesQueryHookResult = ReturnType<typeof useNotesQuery>
export type NotesLazyQueryHookResult = ReturnType<typeof useNotesLazyQuery>
export type NotesSuspenseQueryHookResult = ReturnType<
  typeof useNotesSuspenseQuery
>
export type NotesQueryResult = Apollo.QueryResult<
  NotesQuery,
  NotesQueryVariables
>
export const UpdateNotificationDigestIntervalDocument = gql`
  mutation UpdateNotificationDigestInterval(
    $interval: NotificationDigestInterval
  ) {
    updateNotificationDigestInterval(interval: $interval) {
      id
      notification_digest_interval
    }
  }
`
export type UpdateNotificationDigestIntervalMutationFn =
  Apollo.MutationFunction<
    UpdateNotificationDigestIntervalMutation,
    UpdateNotificationDigestIntervalMutationVariables
  >

/**
 * __useUpdateNotificationDigestIntervalMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationDigestIntervalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationDigestIntervalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationDigestIntervalMutation, { data, loading, error }] = useUpdateNotificationDigestIntervalMutation({
 *   variables: {
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function useUpdateNotificationDigestIntervalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateNotificationDigestIntervalMutation,
    UpdateNotificationDigestIntervalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateNotificationDigestIntervalMutation,
    UpdateNotificationDigestIntervalMutationVariables
  >(UpdateNotificationDigestIntervalDocument, options)
}
export type UpdateNotificationDigestIntervalMutationHookResult = ReturnType<
  typeof useUpdateNotificationDigestIntervalMutation
>
export type UpdateNotificationDigestIntervalMutationResult =
  Apollo.MutationResult<UpdateNotificationDigestIntervalMutation>
export type UpdateNotificationDigestIntervalMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateNotificationDigestIntervalMutation,
    UpdateNotificationDigestIntervalMutationVariables
  >
export const CouponExistsDocument = gql`
  query CouponExists($input: CouponExistsInput) {
    couponExists(input: $input)
  }
`

/**
 * __useCouponExistsQuery__
 *
 * To run a query within a React component, call `useCouponExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponExistsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCouponExistsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CouponExistsQuery,
    CouponExistsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CouponExistsQuery, CouponExistsQueryVariables>(
    CouponExistsDocument,
    options
  )
}
export function useCouponExistsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CouponExistsQuery,
    CouponExistsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CouponExistsQuery, CouponExistsQueryVariables>(
    CouponExistsDocument,
    options
  )
}
export function useCouponExistsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CouponExistsQuery,
        CouponExistsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CouponExistsQuery, CouponExistsQueryVariables>(
    CouponExistsDocument,
    options
  )
}
export type CouponExistsQueryHookResult = ReturnType<
  typeof useCouponExistsQuery
>
export type CouponExistsLazyQueryHookResult = ReturnType<
  typeof useCouponExistsLazyQuery
>
export type CouponExistsSuspenseQueryHookResult = ReturnType<
  typeof useCouponExistsSuspenseQuery
>
export type CouponExistsQueryResult = Apollo.QueryResult<
  CouponExistsQuery,
  CouponExistsQueryVariables
>
export const PathCreatorAssignRoleDocument = gql`
  mutation PathCreatorAssignRole(
    $cohorts: [Int]!
    $user: Int!
    $role: RegistrationRoleEnum!
    $sendNotification: Boolean = false
    $message: String
  ) {
    assign(
      offerings: $cohorts
      assign_to_user: $user
      role: $role
      send_notification: $sendNotification
      assignment_message: $message
    )
  }
`
export type PathCreatorAssignRoleMutationFn = Apollo.MutationFunction<
  PathCreatorAssignRoleMutation,
  PathCreatorAssignRoleMutationVariables
>

/**
 * __usePathCreatorAssignRoleMutation__
 *
 * To run a mutation, you first call `usePathCreatorAssignRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePathCreatorAssignRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pathCreatorAssignRoleMutation, { data, loading, error }] = usePathCreatorAssignRoleMutation({
 *   variables: {
 *      cohorts: // value for 'cohorts'
 *      user: // value for 'user'
 *      role: // value for 'role'
 *      sendNotification: // value for 'sendNotification'
 *      message: // value for 'message'
 *   },
 * });
 */
export function usePathCreatorAssignRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PathCreatorAssignRoleMutation,
    PathCreatorAssignRoleMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PathCreatorAssignRoleMutation,
    PathCreatorAssignRoleMutationVariables
  >(PathCreatorAssignRoleDocument, options)
}
export type PathCreatorAssignRoleMutationHookResult = ReturnType<
  typeof usePathCreatorAssignRoleMutation
>
export type PathCreatorAssignRoleMutationResult =
  Apollo.MutationResult<PathCreatorAssignRoleMutation>
export type PathCreatorAssignRoleMutationOptions = Apollo.BaseMutationOptions<
  PathCreatorAssignRoleMutation,
  PathCreatorAssignRoleMutationVariables
>
export const PathCreatorCohortsDocument = gql`
  query PathCreatorCohorts($resourceId: Int!, $targetUserId: Int!) {
    cohorts: groups(first: 1042, resource_id: $resourceId) {
      edges {
        node {
          ...PathCreatorCohortWithRegistration
        }
      }
    }
  }
  ${PathCreatorCohortWithRegistrationFragmentDoc}
`

/**
 * __usePathCreatorCohortsQuery__
 *
 * To run a query within a React component, call `usePathCreatorCohortsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathCreatorCohortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathCreatorCohortsQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      targetUserId: // value for 'targetUserId'
 *   },
 * });
 */
export function usePathCreatorCohortsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PathCreatorCohortsQuery,
    PathCreatorCohortsQueryVariables
  > &
    (
      | { variables: PathCreatorCohortsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PathCreatorCohortsQuery,
    PathCreatorCohortsQueryVariables
  >(PathCreatorCohortsDocument, options)
}
export function usePathCreatorCohortsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathCreatorCohortsQuery,
    PathCreatorCohortsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PathCreatorCohortsQuery,
    PathCreatorCohortsQueryVariables
  >(PathCreatorCohortsDocument, options)
}
export function usePathCreatorCohortsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PathCreatorCohortsQuery,
        PathCreatorCohortsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PathCreatorCohortsQuery,
    PathCreatorCohortsQueryVariables
  >(PathCreatorCohortsDocument, options)
}
export type PathCreatorCohortsQueryHookResult = ReturnType<
  typeof usePathCreatorCohortsQuery
>
export type PathCreatorCohortsLazyQueryHookResult = ReturnType<
  typeof usePathCreatorCohortsLazyQuery
>
export type PathCreatorCohortsSuspenseQueryHookResult = ReturnType<
  typeof usePathCreatorCohortsSuspenseQuery
>
export type PathCreatorCohortsQueryResult = Apollo.QueryResult<
  PathCreatorCohortsQuery,
  PathCreatorCohortsQueryVariables
>
export const PathCreatorCreateCohortDocument = gql`
  mutation PathCreatorCreateCohort($resourceId: Int!, $name: String!) {
    createCohort: createGroup(
      base_resource_id: $resourceId
      visibility: 5
      name: $name
    ) {
      ...PathCreatorCohort
    }
  }
  ${PathCreatorCohortFragmentDoc}
`
export type PathCreatorCreateCohortMutationFn = Apollo.MutationFunction<
  PathCreatorCreateCohortMutation,
  PathCreatorCreateCohortMutationVariables
>

/**
 * __usePathCreatorCreateCohortMutation__
 *
 * To run a mutation, you first call `usePathCreatorCreateCohortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePathCreatorCreateCohortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pathCreatorCreateCohortMutation, { data, loading, error }] = usePathCreatorCreateCohortMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function usePathCreatorCreateCohortMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PathCreatorCreateCohortMutation,
    PathCreatorCreateCohortMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PathCreatorCreateCohortMutation,
    PathCreatorCreateCohortMutationVariables
  >(PathCreatorCreateCohortDocument, options)
}
export type PathCreatorCreateCohortMutationHookResult = ReturnType<
  typeof usePathCreatorCreateCohortMutation
>
export type PathCreatorCreateCohortMutationResult =
  Apollo.MutationResult<PathCreatorCreateCohortMutation>
export type PathCreatorCreateCohortMutationOptions = Apollo.BaseMutationOptions<
  PathCreatorCreateCohortMutation,
  PathCreatorCreateCohortMutationVariables
>
export const PathCreatorCreatePathDocument = gql`
  mutation PathCreatorCreatePath(
    $name: String!
    $image: String!
    $resourceType: ResourceType
    $cohortName: String
  ) {
    createResource(
      name: $name
      cover_image: $image
      resource_type: $resourceType
      group_name: $cohortName
    ) {
      ...PathCreatorCreatePath
    }
  }
  ${PathCreatorCreatePathFragmentDoc}
`
export type PathCreatorCreatePathMutationFn = Apollo.MutationFunction<
  PathCreatorCreatePathMutation,
  PathCreatorCreatePathMutationVariables
>

/**
 * __usePathCreatorCreatePathMutation__
 *
 * To run a mutation, you first call `usePathCreatorCreatePathMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePathCreatorCreatePathMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pathCreatorCreatePathMutation, { data, loading, error }] = usePathCreatorCreatePathMutation({
 *   variables: {
 *      name: // value for 'name'
 *      image: // value for 'image'
 *      resourceType: // value for 'resourceType'
 *      cohortName: // value for 'cohortName'
 *   },
 * });
 */
export function usePathCreatorCreatePathMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PathCreatorCreatePathMutation,
    PathCreatorCreatePathMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PathCreatorCreatePathMutation,
    PathCreatorCreatePathMutationVariables
  >(PathCreatorCreatePathDocument, options)
}
export type PathCreatorCreatePathMutationHookResult = ReturnType<
  typeof usePathCreatorCreatePathMutation
>
export type PathCreatorCreatePathMutationResult =
  Apollo.MutationResult<PathCreatorCreatePathMutation>
export type PathCreatorCreatePathMutationOptions = Apollo.BaseMutationOptions<
  PathCreatorCreatePathMutation,
  PathCreatorCreatePathMutationVariables
>
export const PathCreatorRandomResourceImageDocument = gql`
  query PathCreatorRandomResourceImage($themeType: ThemeType) {
    resourceImage(
      theme_type: $themeType
      image: [
        { width: 240, height: 180, fit: crop }
        {
          width: 250
          height: 250
          blur: 500
          high: -80
          blend: 666666
          balph: 40
          fm: "jpg"
          q: 100
          bm: "screen"
        }
      ]
    )
  }
`

/**
 * __usePathCreatorRandomResourceImageQuery__
 *
 * To run a query within a React component, call `usePathCreatorRandomResourceImageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathCreatorRandomResourceImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathCreatorRandomResourceImageQuery({
 *   variables: {
 *      themeType: // value for 'themeType'
 *   },
 * });
 */
export function usePathCreatorRandomResourceImageQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PathCreatorRandomResourceImageQuery,
    PathCreatorRandomResourceImageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PathCreatorRandomResourceImageQuery,
    PathCreatorRandomResourceImageQueryVariables
  >(PathCreatorRandomResourceImageDocument, options)
}
export function usePathCreatorRandomResourceImageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathCreatorRandomResourceImageQuery,
    PathCreatorRandomResourceImageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PathCreatorRandomResourceImageQuery,
    PathCreatorRandomResourceImageQueryVariables
  >(PathCreatorRandomResourceImageDocument, options)
}
export function usePathCreatorRandomResourceImageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PathCreatorRandomResourceImageQuery,
        PathCreatorRandomResourceImageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PathCreatorRandomResourceImageQuery,
    PathCreatorRandomResourceImageQueryVariables
  >(PathCreatorRandomResourceImageDocument, options)
}
export type PathCreatorRandomResourceImageQueryHookResult = ReturnType<
  typeof usePathCreatorRandomResourceImageQuery
>
export type PathCreatorRandomResourceImageLazyQueryHookResult = ReturnType<
  typeof usePathCreatorRandomResourceImageLazyQuery
>
export type PathCreatorRandomResourceImageSuspenseQueryHookResult = ReturnType<
  typeof usePathCreatorRandomResourceImageSuspenseQuery
>
export type PathCreatorRandomResourceImageQueryResult = Apollo.QueryResult<
  PathCreatorRandomResourceImageQuery,
  PathCreatorRandomResourceImageQueryVariables
>
export const PathCreatorResourcesDocument = gql`
  query PathCreatorResources {
    resources(first: 1042) {
      edges {
        node {
          ...PathCreatorResource
        }
      }
    }
  }
  ${PathCreatorResourceFragmentDoc}
`

/**
 * __usePathCreatorResourcesQuery__
 *
 * To run a query within a React component, call `usePathCreatorResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathCreatorResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathCreatorResourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePathCreatorResourcesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PathCreatorResourcesQuery,
    PathCreatorResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PathCreatorResourcesQuery,
    PathCreatorResourcesQueryVariables
  >(PathCreatorResourcesDocument, options)
}
export function usePathCreatorResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathCreatorResourcesQuery,
    PathCreatorResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PathCreatorResourcesQuery,
    PathCreatorResourcesQueryVariables
  >(PathCreatorResourcesDocument, options)
}
export function usePathCreatorResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PathCreatorResourcesQuery,
        PathCreatorResourcesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PathCreatorResourcesQuery,
    PathCreatorResourcesQueryVariables
  >(PathCreatorResourcesDocument, options)
}
export type PathCreatorResourcesQueryHookResult = ReturnType<
  typeof usePathCreatorResourcesQuery
>
export type PathCreatorResourcesLazyQueryHookResult = ReturnType<
  typeof usePathCreatorResourcesLazyQuery
>
export type PathCreatorResourcesSuspenseQueryHookResult = ReturnType<
  typeof usePathCreatorResourcesSuspenseQuery
>
export type PathCreatorResourcesQueryResult = Apollo.QueryResult<
  PathCreatorResourcesQuery,
  PathCreatorResourcesQueryVariables
>
export const CohortSyncPathDocument = gql`
  query CohortSyncPath($cohortId: Int!) {
    cohort: group(id: $cohortId) {
      ...CohortSyncPathCohort
    }
  }
  ${CohortSyncPathCohortFragmentDoc}
`

/**
 * __useCohortSyncPathQuery__
 *
 * To run a query within a React component, call `useCohortSyncPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useCohortSyncPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCohortSyncPathQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useCohortSyncPathQuery(
  baseOptions: Apollo.QueryHookOptions<
    CohortSyncPathQuery,
    CohortSyncPathQueryVariables
  > &
    (
      | { variables: CohortSyncPathQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CohortSyncPathQuery, CohortSyncPathQueryVariables>(
    CohortSyncPathDocument,
    options
  )
}
export function useCohortSyncPathLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CohortSyncPathQuery,
    CohortSyncPathQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CohortSyncPathQuery, CohortSyncPathQueryVariables>(
    CohortSyncPathDocument,
    options
  )
}
export function useCohortSyncPathSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CohortSyncPathQuery,
        CohortSyncPathQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CohortSyncPathQuery,
    CohortSyncPathQueryVariables
  >(CohortSyncPathDocument, options)
}
export type CohortSyncPathQueryHookResult = ReturnType<
  typeof useCohortSyncPathQuery
>
export type CohortSyncPathLazyQueryHookResult = ReturnType<
  typeof useCohortSyncPathLazyQuery
>
export type CohortSyncPathSuspenseQueryHookResult = ReturnType<
  typeof useCohortSyncPathSuspenseQuery
>
export type CohortSyncPathQueryResult = Apollo.QueryResult<
  CohortSyncPathQuery,
  CohortSyncPathQueryVariables
>
export const CompletePathItemDocument = gql`
  mutation CompletePathItem(
    $id: Int!
    $path_id: Int!
    $skip: Boolean
    $completion_data: JSON
  ) {
    completePathItem(
      id: $id
      path_id: $path_id
      skip: $skip
      completion_data: $completion_data
    ) {
      ...PathItem
      path {
        id
        progress
        points {
          path_id
          total
          earned
          total_points_possible
          percentage
          has_points
        }
        next_step_id
        completion_date
      }
    }
  }
  ${PathItemFragmentDoc}
`
export type CompletePathItemMutationFn = Apollo.MutationFunction<
  CompletePathItemMutation,
  CompletePathItemMutationVariables
>

/**
 * __useCompletePathItemMutation__
 *
 * To run a mutation, you first call `useCompletePathItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletePathItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completePathItemMutation, { data, loading, error }] = useCompletePathItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      path_id: // value for 'path_id'
 *      skip: // value for 'skip'
 *      completion_data: // value for 'completion_data'
 *   },
 * });
 */
export function useCompletePathItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompletePathItemMutation,
    CompletePathItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CompletePathItemMutation,
    CompletePathItemMutationVariables
  >(CompletePathItemDocument, options)
}
export type CompletePathItemMutationHookResult = ReturnType<
  typeof useCompletePathItemMutation
>
export type CompletePathItemMutationResult =
  Apollo.MutationResult<CompletePathItemMutation>
export type CompletePathItemMutationOptions = Apollo.BaseMutationOptions<
  CompletePathItemMutation,
  CompletePathItemMutationVariables
>
export const CreatePathItemDocument = gql`
  mutation CreatePathItem(
    $path_id: Int!
    $order: Int!
    $name: String!
    $type: PathItemType!
    $assignment_type: PathItemAssignmentType
    $parent: Int
    $description: String
    $content_type: String
    $content_resource: Int
  ) {
    createPathItem(
      path_id: $path_id
      order: $order
      name: $name
      type: $type
      assignment_type: $assignment_type
      parent: $parent
      description: $description
      content_type: $content_type
      content_resource: $content_resource
    ) {
      ...PathItem
      items(first: 50) {
        edges {
          node {
            ...PathItem
          }
        }
      }
    }
  }
  ${PathItemFragmentDoc}
`
export type CreatePathItemMutationFn = Apollo.MutationFunction<
  CreatePathItemMutation,
  CreatePathItemMutationVariables
>

/**
 * __useCreatePathItemMutation__
 *
 * To run a mutation, you first call `useCreatePathItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePathItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPathItemMutation, { data, loading, error }] = useCreatePathItemMutation({
 *   variables: {
 *      path_id: // value for 'path_id'
 *      order: // value for 'order'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      assignment_type: // value for 'assignment_type'
 *      parent: // value for 'parent'
 *      description: // value for 'description'
 *      content_type: // value for 'content_type'
 *      content_resource: // value for 'content_resource'
 *   },
 * });
 */
export function useCreatePathItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePathItemMutation,
    CreatePathItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreatePathItemMutation,
    CreatePathItemMutationVariables
  >(CreatePathItemDocument, options)
}
export type CreatePathItemMutationHookResult = ReturnType<
  typeof useCreatePathItemMutation
>
export type CreatePathItemMutationResult =
  Apollo.MutationResult<CreatePathItemMutation>
export type CreatePathItemMutationOptions = Apollo.BaseMutationOptions<
  CreatePathItemMutation,
  CreatePathItemMutationVariables
>
export const CreateRegistrationUpsertGroupDocument = gql`
  mutation CreateRegistrationUpsertGroup(
    $resource_id: Int!
    $parent_offering_id: Int!
    $step_source_id: Int!
    $createrRegistration: Boolean = false
  ) {
    createRegistrationUpsertGroup(
      resource_id: $resource_id
      parent_offering_id: $parent_offering_id
      step_source_id: $step_source_id
      create_registration: $createrRegistration
    ) {
      ...Group
      user_registration {
        ...Registration
        path {
          id
        }
      }
    }
  }
  ${GroupFragmentDoc}
  ${RegistrationFragmentDoc}
`
export type CreateRegistrationUpsertGroupMutationFn = Apollo.MutationFunction<
  CreateRegistrationUpsertGroupMutation,
  CreateRegistrationUpsertGroupMutationVariables
>

/**
 * __useCreateRegistrationUpsertGroupMutation__
 *
 * To run a mutation, you first call `useCreateRegistrationUpsertGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegistrationUpsertGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegistrationUpsertGroupMutation, { data, loading, error }] = useCreateRegistrationUpsertGroupMutation({
 *   variables: {
 *      resource_id: // value for 'resource_id'
 *      parent_offering_id: // value for 'parent_offering_id'
 *      step_source_id: // value for 'step_source_id'
 *      createrRegistration: // value for 'createrRegistration'
 *   },
 * });
 */
export function useCreateRegistrationUpsertGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRegistrationUpsertGroupMutation,
    CreateRegistrationUpsertGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateRegistrationUpsertGroupMutation,
    CreateRegistrationUpsertGroupMutationVariables
  >(CreateRegistrationUpsertGroupDocument, options)
}
export type CreateRegistrationUpsertGroupMutationHookResult = ReturnType<
  typeof useCreateRegistrationUpsertGroupMutation
>
export type CreateRegistrationUpsertGroupMutationResult =
  Apollo.MutationResult<CreateRegistrationUpsertGroupMutation>
export type CreateRegistrationUpsertGroupMutationOptions =
  Apollo.BaseMutationOptions<
    CreateRegistrationUpsertGroupMutation,
    CreateRegistrationUpsertGroupMutationVariables
  >
export const DeletePathItemDocument = gql`
  mutation DeletePathItem($path_id: Int!, $id: Int!) {
    deletePathItem(path_id: $path_id, id: $id) {
      ...PathItem
    }
  }
  ${PathItemFragmentDoc}
`
export type DeletePathItemMutationFn = Apollo.MutationFunction<
  DeletePathItemMutation,
  DeletePathItemMutationVariables
>

/**
 * __useDeletePathItemMutation__
 *
 * To run a mutation, you first call `useDeletePathItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePathItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePathItemMutation, { data, loading, error }] = useDeletePathItemMutation({
 *   variables: {
 *      path_id: // value for 'path_id'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePathItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePathItemMutation,
    DeletePathItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeletePathItemMutation,
    DeletePathItemMutationVariables
  >(DeletePathItemDocument, options)
}
export type DeletePathItemMutationHookResult = ReturnType<
  typeof useDeletePathItemMutation
>
export type DeletePathItemMutationResult =
  Apollo.MutationResult<DeletePathItemMutation>
export type DeletePathItemMutationOptions = Apollo.BaseMutationOptions<
  DeletePathItemMutation,
  DeletePathItemMutationVariables
>
export const ExecuteSyncPlanDocument = gql`
  mutation ExecuteSyncPlan($sync_plan: PathSyncPlanInput!) {
    executePathSyncPlan(sync_plan: $sync_plan)
  }
`
export type ExecuteSyncPlanMutationFn = Apollo.MutationFunction<
  ExecuteSyncPlanMutation,
  ExecuteSyncPlanMutationVariables
>

/**
 * __useExecuteSyncPlanMutation__
 *
 * To run a mutation, you first call `useExecuteSyncPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteSyncPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeSyncPlanMutation, { data, loading, error }] = useExecuteSyncPlanMutation({
 *   variables: {
 *      sync_plan: // value for 'sync_plan'
 *   },
 * });
 */
export function useExecuteSyncPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExecuteSyncPlanMutation,
    ExecuteSyncPlanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ExecuteSyncPlanMutation,
    ExecuteSyncPlanMutationVariables
  >(ExecuteSyncPlanDocument, options)
}
export type ExecuteSyncPlanMutationHookResult = ReturnType<
  typeof useExecuteSyncPlanMutation
>
export type ExecuteSyncPlanMutationResult =
  Apollo.MutationResult<ExecuteSyncPlanMutation>
export type ExecuteSyncPlanMutationOptions = Apollo.BaseMutationOptions<
  ExecuteSyncPlanMutation,
  ExecuteSyncPlanMutationVariables
>
export const PastePathItemDocument = gql`
  mutation PastePathItem(
    $pathId: Int!
    $itemId: Int!
    $parentId: Int
    $order: Int!
  ) {
    pastePathItem(
      path_id: $pathId
      item_id: $itemId
      parent_id: $parentId
      order: $order
    ) {
      ...PathItem
      items(first: 50) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...PathItem
          }
        }
      }
    }
  }
  ${PathItemFragmentDoc}
`
export type PastePathItemMutationFn = Apollo.MutationFunction<
  PastePathItemMutation,
  PastePathItemMutationVariables
>

/**
 * __usePastePathItemMutation__
 *
 * To run a mutation, you first call `usePastePathItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePastePathItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pastePathItemMutation, { data, loading, error }] = usePastePathItemMutation({
 *   variables: {
 *      pathId: // value for 'pathId'
 *      itemId: // value for 'itemId'
 *      parentId: // value for 'parentId'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePastePathItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PastePathItemMutation,
    PastePathItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PastePathItemMutation,
    PastePathItemMutationVariables
  >(PastePathItemDocument, options)
}
export type PastePathItemMutationHookResult = ReturnType<
  typeof usePastePathItemMutation
>
export type PastePathItemMutationResult =
  Apollo.MutationResult<PastePathItemMutation>
export type PastePathItemMutationOptions = Apollo.BaseMutationOptions<
  PastePathItemMutation,
  PastePathItemMutationVariables
>
export const PathItemDocument = gql`
  query PathItem(
    $id: Int
    $path_id: Int
    $cohort_id: Int
    $user_id: Int
    $source_id: Int
    $archivedDateFilter: [DateFilter]
  ) {
    pathItem(
      id: $id
      path_id: $path_id
      cohort_id: $cohort_id
      user_id: $user_id
      source_id: $source_id
      archivedDateFilter: $archivedDateFilter
    ) {
      ...PathItem
    }
  }
  ${PathItemFragmentDoc}
`

/**
 * __usePathItemQuery__
 *
 * To run a query within a React component, call `usePathItemQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *      path_id: // value for 'path_id'
 *      cohort_id: // value for 'cohort_id'
 *      user_id: // value for 'user_id'
 *      source_id: // value for 'source_id'
 *      archivedDateFilter: // value for 'archivedDateFilter'
 *   },
 * });
 */
export function usePathItemQuery(
  baseOptions?: Apollo.QueryHookOptions<PathItemQuery, PathItemQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PathItemQuery, PathItemQueryVariables>(
    PathItemDocument,
    options
  )
}
export function usePathItemLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathItemQuery,
    PathItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PathItemQuery, PathItemQueryVariables>(
    PathItemDocument,
    options
  )
}
export function usePathItemSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PathItemQuery, PathItemQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PathItemQuery, PathItemQueryVariables>(
    PathItemDocument,
    options
  )
}
export type PathItemQueryHookResult = ReturnType<typeof usePathItemQuery>
export type PathItemLazyQueryHookResult = ReturnType<
  typeof usePathItemLazyQuery
>
export type PathItemSuspenseQueryHookResult = ReturnType<
  typeof usePathItemSuspenseQuery
>
export type PathItemQueryResult = Apollo.QueryResult<
  PathItemQuery,
  PathItemQueryVariables
>
export const PathItemsDocument = gql`
  query PathItems(
    $pathId: Int
    $cohortId: Int
    $sourceId: Int
    $lessonSourceId: Int
    $archivedDateFilter: [DateFilter]
    $cursor: String
  ) {
    pathItems(
      path_id: $pathId
      cohort_id: $cohortId
      source_id: $sourceId
      lesson_source_id: $lessonSourceId
      archivedDateFilter: $archivedDateFilter
      first: 1042
    ) {
      edges {
        node {
          ...PathItem
        }
      }
    }
  }
  ${PathItemFragmentDoc}
`

/**
 * __usePathItemsQuery__
 *
 * To run a query within a React component, call `usePathItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathItemsQuery({
 *   variables: {
 *      pathId: // value for 'pathId'
 *      cohortId: // value for 'cohortId'
 *      sourceId: // value for 'sourceId'
 *      lessonSourceId: // value for 'lessonSourceId'
 *      archivedDateFilter: // value for 'archivedDateFilter'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function usePathItemsQuery(
  baseOptions?: Apollo.QueryHookOptions<PathItemsQuery, PathItemsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PathItemsQuery, PathItemsQueryVariables>(
    PathItemsDocument,
    options
  )
}
export function usePathItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathItemsQuery,
    PathItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PathItemsQuery, PathItemsQueryVariables>(
    PathItemsDocument,
    options
  )
}
export function usePathItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PathItemsQuery, PathItemsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PathItemsQuery, PathItemsQueryVariables>(
    PathItemsDocument,
    options
  )
}
export type PathItemsQueryHookResult = ReturnType<typeof usePathItemsQuery>
export type PathItemsLazyQueryHookResult = ReturnType<
  typeof usePathItemsLazyQuery
>
export type PathItemsSuspenseQueryHookResult = ReturnType<
  typeof usePathItemsSuspenseQuery
>
export type PathItemsQueryResult = Apollo.QueryResult<
  PathItemsQuery,
  PathItemsQueryVariables
>
export const PathPerformanceDocument = gql`
  query PathPerformance($id: Int!) {
    path(id: $id) {
      id
      performance {
        ...PathPerformance
      }
    }
  }
  ${PathPerformanceFragmentDoc}
`

/**
 * __usePathPerformanceQuery__
 *
 * To run a query within a React component, call `usePathPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathPerformanceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePathPerformanceQuery(
  baseOptions: Apollo.QueryHookOptions<
    PathPerformanceQuery,
    PathPerformanceQueryVariables
  > &
    (
      | { variables: PathPerformanceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PathPerformanceQuery, PathPerformanceQueryVariables>(
    PathPerformanceDocument,
    options
  )
}
export function usePathPerformanceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathPerformanceQuery,
    PathPerformanceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PathPerformanceQuery,
    PathPerformanceQueryVariables
  >(PathPerformanceDocument, options)
}
export function usePathPerformanceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PathPerformanceQuery,
        PathPerformanceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PathPerformanceQuery,
    PathPerformanceQueryVariables
  >(PathPerformanceDocument, options)
}
export type PathPerformanceQueryHookResult = ReturnType<
  typeof usePathPerformanceQuery
>
export type PathPerformanceLazyQueryHookResult = ReturnType<
  typeof usePathPerformanceLazyQuery
>
export type PathPerformanceSuspenseQueryHookResult = ReturnType<
  typeof usePathPerformanceSuspenseQuery
>
export type PathPerformanceQueryResult = Apollo.QueryResult<
  PathPerformanceQuery,
  PathPerformanceQueryVariables
>
export const PathPublishDocument = gql`
  query PathPublish($cohort_id: Int) {
    path(cohort_id: $cohort_id) {
      id
      publish {
        path_id
        published
        last_published_date
      }
    }
  }
`

/**
 * __usePathPublishQuery__
 *
 * To run a query within a React component, call `usePathPublishQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathPublishQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathPublishQuery({
 *   variables: {
 *      cohort_id: // value for 'cohort_id'
 *   },
 * });
 */
export function usePathPublishQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PathPublishQuery,
    PathPublishQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PathPublishQuery, PathPublishQueryVariables>(
    PathPublishDocument,
    options
  )
}
export function usePathPublishLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathPublishQuery,
    PathPublishQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PathPublishQuery, PathPublishQueryVariables>(
    PathPublishDocument,
    options
  )
}
export function usePathPublishSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PathPublishQuery,
        PathPublishQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PathPublishQuery, PathPublishQueryVariables>(
    PathPublishDocument,
    options
  )
}
export type PathPublishQueryHookResult = ReturnType<typeof usePathPublishQuery>
export type PathPublishLazyQueryHookResult = ReturnType<
  typeof usePathPublishLazyQuery
>
export type PathPublishSuspenseQueryHookResult = ReturnType<
  typeof usePathPublishSuspenseQuery
>
export type PathPublishQueryResult = Apollo.QueryResult<
  PathPublishQuery,
  PathPublishQueryVariables
>
export const PathDocument = gql`
  query Path($id: Int, $cohort_id: Int, $archivedDateFilter: [DateFilter]) {
    path(id: $id, cohort_id: $cohort_id) {
      ...Path
      items(
        first: 1042
        flatten: true
        archivedDateFilter: $archivedDateFilter
      ) {
        edges {
          node {
            ...PathItem
          }
        }
      }
      schedule {
        start {
          behavior
          date
        }
        end {
          behavior
          date
        }
      }
    }
  }
  ${PathFragmentDoc}
  ${PathItemFragmentDoc}
`

/**
 * __usePathQuery__
 *
 * To run a query within a React component, call `usePathQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathQuery({
 *   variables: {
 *      id: // value for 'id'
 *      cohort_id: // value for 'cohort_id'
 *      archivedDateFilter: // value for 'archivedDateFilter'
 *   },
 * });
 */
export function usePathQuery(
  baseOptions?: Apollo.QueryHookOptions<PathQuery, PathQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PathQuery, PathQueryVariables>(PathDocument, options)
}
export function usePathLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PathQuery, PathQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PathQuery, PathQueryVariables>(
    PathDocument,
    options
  )
}
export function usePathSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PathQuery, PathQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PathQuery, PathQueryVariables>(
    PathDocument,
    options
  )
}
export type PathQueryHookResult = ReturnType<typeof usePathQuery>
export type PathLazyQueryHookResult = ReturnType<typeof usePathLazyQuery>
export type PathSuspenseQueryHookResult = ReturnType<
  typeof usePathSuspenseQuery
>
export type PathQueryResult = Apollo.QueryResult<PathQuery, PathQueryVariables>
export const SyncPathDocument = gql`
  mutation SyncPath($id: Int!) {
    syncPath(id: $id) {
      ...PathItems
    }
  }
  ${PathItemsFragmentDoc}
`
export type SyncPathMutationFn = Apollo.MutationFunction<
  SyncPathMutation,
  SyncPathMutationVariables
>

/**
 * __useSyncPathMutation__
 *
 * To run a mutation, you first call `useSyncPathMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncPathMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncPathMutation, { data, loading, error }] = useSyncPathMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSyncPathMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SyncPathMutation,
    SyncPathMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<SyncPathMutation, SyncPathMutationVariables>(
    SyncPathDocument,
    options
  )
}
export type SyncPathMutationHookResult = ReturnType<typeof useSyncPathMutation>
export type SyncPathMutationResult = Apollo.MutationResult<SyncPathMutation>
export type SyncPathMutationOptions = Apollo.BaseMutationOptions<
  SyncPathMutation,
  SyncPathMutationVariables
>
export const PathSyncPlanDocument = gql`
  query PathSyncPlan($sync_plan: PathSyncPlanInput!) {
    pathSyncPlan(sync_plan: $sync_plan) {
      from_path_id
      to_path_id
      included_changes {
        ...PathSyncPlanChange
      }
      excluded_changes {
        ...PathSyncPlanChange
      }
      hash
    }
  }
  ${PathSyncPlanChangeFragmentDoc}
`

/**
 * __usePathSyncPlanQuery__
 *
 * To run a query within a React component, call `usePathSyncPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathSyncPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathSyncPlanQuery({
 *   variables: {
 *      sync_plan: // value for 'sync_plan'
 *   },
 * });
 */
export function usePathSyncPlanQuery(
  baseOptions: Apollo.QueryHookOptions<
    PathSyncPlanQuery,
    PathSyncPlanQueryVariables
  > &
    (
      | { variables: PathSyncPlanQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PathSyncPlanQuery, PathSyncPlanQueryVariables>(
    PathSyncPlanDocument,
    options
  )
}
export function usePathSyncPlanLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathSyncPlanQuery,
    PathSyncPlanQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PathSyncPlanQuery, PathSyncPlanQueryVariables>(
    PathSyncPlanDocument,
    options
  )
}
export function usePathSyncPlanSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PathSyncPlanQuery,
        PathSyncPlanQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PathSyncPlanQuery, PathSyncPlanQueryVariables>(
    PathSyncPlanDocument,
    options
  )
}
export type PathSyncPlanQueryHookResult = ReturnType<
  typeof usePathSyncPlanQuery
>
export type PathSyncPlanLazyQueryHookResult = ReturnType<
  typeof usePathSyncPlanLazyQuery
>
export type PathSyncPlanSuspenseQueryHookResult = ReturnType<
  typeof usePathSyncPlanSuspenseQuery
>
export type PathSyncPlanQueryResult = Apollo.QueryResult<
  PathSyncPlanQuery,
  PathSyncPlanQueryVariables
>
export const ReorderPathItemsDocument = gql`
  mutation ReorderPathItems($path_id: Int!, $items: [PathItemOrder]!) {
    reorderPathItems(path_id: $path_id, items: $items)
  }
`
export type ReorderPathItemsMutationFn = Apollo.MutationFunction<
  ReorderPathItemsMutation,
  ReorderPathItemsMutationVariables
>

/**
 * __useReorderPathItemsMutation__
 *
 * To run a mutation, you first call `useReorderPathItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderPathItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderPathItemsMutation, { data, loading, error }] = useReorderPathItemsMutation({
 *   variables: {
 *      path_id: // value for 'path_id'
 *      items: // value for 'items'
 *   },
 * });
 */
export function useReorderPathItemsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderPathItemsMutation,
    ReorderPathItemsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ReorderPathItemsMutation,
    ReorderPathItemsMutationVariables
  >(ReorderPathItemsDocument, options)
}
export type ReorderPathItemsMutationHookResult = ReturnType<
  typeof useReorderPathItemsMutation
>
export type ReorderPathItemsMutationResult =
  Apollo.MutationResult<ReorderPathItemsMutation>
export type ReorderPathItemsMutationOptions = Apollo.BaseMutationOptions<
  ReorderPathItemsMutation,
  ReorderPathItemsMutationVariables
>
export const ResetPathItemForUserDocument = gql`
  mutation ResetPathItemForUser($id: Int!, $path_id: Int!) {
    resetPathItemForUser(id: $id, path_id: $path_id) {
      ...PathItem
    }
  }
  ${PathItemFragmentDoc}
`
export type ResetPathItemForUserMutationFn = Apollo.MutationFunction<
  ResetPathItemForUserMutation,
  ResetPathItemForUserMutationVariables
>

/**
 * __useResetPathItemForUserMutation__
 *
 * To run a mutation, you first call `useResetPathItemForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPathItemForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPathItemForUserMutation, { data, loading, error }] = useResetPathItemForUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      path_id: // value for 'path_id'
 *   },
 * });
 */
export function useResetPathItemForUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetPathItemForUserMutation,
    ResetPathItemForUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ResetPathItemForUserMutation,
    ResetPathItemForUserMutationVariables
  >(ResetPathItemForUserDocument, options)
}
export type ResetPathItemForUserMutationHookResult = ReturnType<
  typeof useResetPathItemForUserMutation
>
export type ResetPathItemForUserMutationResult =
  Apollo.MutationResult<ResetPathItemForUserMutation>
export type ResetPathItemForUserMutationOptions = Apollo.BaseMutationOptions<
  ResetPathItemForUserMutation,
  ResetPathItemForUserMutationVariables
>
export const ResetPathItemDocument = gql`
  mutation ResetPathItem($id: Int!, $path_id: Int!) {
    resetPathItem(id: $id, path_id: $path_id) {
      ...PathItem
      path {
        id
        progress
        points {
          path_id
          total
          earned
          total_points_possible
          percentage
          has_points
        }
        next_step_id
        completion_date
      }
    }
  }
  ${PathItemFragmentDoc}
`
export type ResetPathItemMutationFn = Apollo.MutationFunction<
  ResetPathItemMutation,
  ResetPathItemMutationVariables
>

/**
 * __useResetPathItemMutation__
 *
 * To run a mutation, you first call `useResetPathItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPathItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPathItemMutation, { data, loading, error }] = useResetPathItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      path_id: // value for 'path_id'
 *   },
 * });
 */
export function useResetPathItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetPathItemMutation,
    ResetPathItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ResetPathItemMutation,
    ResetPathItemMutationVariables
  >(ResetPathItemDocument, options)
}
export type ResetPathItemMutationHookResult = ReturnType<
  typeof useResetPathItemMutation
>
export type ResetPathItemMutationResult =
  Apollo.MutationResult<ResetPathItemMutation>
export type ResetPathItemMutationOptions = Apollo.BaseMutationOptions<
  ResetPathItemMutation,
  ResetPathItemMutationVariables
>
export const SingleCohortPathDocument = gql`
  query SingleCohortPath($cohort_id: Int!) {
    path(cohort_id: $cohort_id) {
      ...SingleCohortPath
    }
  }
  ${SingleCohortPathFragmentDoc}
`

/**
 * __useSingleCohortPathQuery__
 *
 * To run a query within a React component, call `useSingleCohortPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleCohortPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleCohortPathQuery({
 *   variables: {
 *      cohort_id: // value for 'cohort_id'
 *   },
 * });
 */
export function useSingleCohortPathQuery(
  baseOptions: Apollo.QueryHookOptions<
    SingleCohortPathQuery,
    SingleCohortPathQueryVariables
  > &
    (
      | { variables: SingleCohortPathQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SingleCohortPathQuery, SingleCohortPathQueryVariables>(
    SingleCohortPathDocument,
    options
  )
}
export function useSingleCohortPathLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SingleCohortPathQuery,
    SingleCohortPathQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SingleCohortPathQuery,
    SingleCohortPathQueryVariables
  >(SingleCohortPathDocument, options)
}
export function useSingleCohortPathSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SingleCohortPathQuery,
        SingleCohortPathQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SingleCohortPathQuery,
    SingleCohortPathQueryVariables
  >(SingleCohortPathDocument, options)
}
export type SingleCohortPathQueryHookResult = ReturnType<
  typeof useSingleCohortPathQuery
>
export type SingleCohortPathLazyQueryHookResult = ReturnType<
  typeof useSingleCohortPathLazyQuery
>
export type SingleCohortPathSuspenseQueryHookResult = ReturnType<
  typeof useSingleCohortPathSuspenseQuery
>
export type SingleCohortPathQueryResult = Apollo.QueryResult<
  SingleCohortPathQuery,
  SingleCohortPathQueryVariables
>
export const SkipPathItemForUserDocument = gql`
  mutation SkipPathItemForUser($id: Int!, $path_id: Int!) {
    skipPathItemForUser(id: $id, path_id: $path_id) {
      ...PathItem
    }
  }
  ${PathItemFragmentDoc}
`
export type SkipPathItemForUserMutationFn = Apollo.MutationFunction<
  SkipPathItemForUserMutation,
  SkipPathItemForUserMutationVariables
>

/**
 * __useSkipPathItemForUserMutation__
 *
 * To run a mutation, you first call `useSkipPathItemForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipPathItemForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipPathItemForUserMutation, { data, loading, error }] = useSkipPathItemForUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      path_id: // value for 'path_id'
 *   },
 * });
 */
export function useSkipPathItemForUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SkipPathItemForUserMutation,
    SkipPathItemForUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SkipPathItemForUserMutation,
    SkipPathItemForUserMutationVariables
  >(SkipPathItemForUserDocument, options)
}
export type SkipPathItemForUserMutationHookResult = ReturnType<
  typeof useSkipPathItemForUserMutation
>
export type SkipPathItemForUserMutationResult =
  Apollo.MutationResult<SkipPathItemForUserMutation>
export type SkipPathItemForUserMutationOptions = Apollo.BaseMutationOptions<
  SkipPathItemForUserMutation,
  SkipPathItemForUserMutationVariables
>
export const UnarchivePathItemDocument = gql`
  mutation UnarchivePathItem($id: Int!, $pathId: Int!) {
    unarchivePathItem(id: $id, path_id: $pathId) {
      ...PathItem
    }
  }
  ${PathItemFragmentDoc}
`
export type UnarchivePathItemMutationFn = Apollo.MutationFunction<
  UnarchivePathItemMutation,
  UnarchivePathItemMutationVariables
>

/**
 * __useUnarchivePathItemMutation__
 *
 * To run a mutation, you first call `useUnarchivePathItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchivePathItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchivePathItemMutation, { data, loading, error }] = useUnarchivePathItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useUnarchivePathItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnarchivePathItemMutation,
    UnarchivePathItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UnarchivePathItemMutation,
    UnarchivePathItemMutationVariables
  >(UnarchivePathItemDocument, options)
}
export type UnarchivePathItemMutationHookResult = ReturnType<
  typeof useUnarchivePathItemMutation
>
export type UnarchivePathItemMutationResult =
  Apollo.MutationResult<UnarchivePathItemMutation>
export type UnarchivePathItemMutationOptions = Apollo.BaseMutationOptions<
  UnarchivePathItemMutation,
  UnarchivePathItemMutationVariables
>
export const UnlockPathItemDocument = gql`
  mutation UnlockPathItem(
    $id: Int!
    $path_id: Int!
    $step_lock_password: String!
  ) {
    unlockPathItem(
      id: $id
      path_id: $path_id
      step_lock_password: $step_lock_password
    ) {
      ...PathItem
    }
  }
  ${PathItemFragmentDoc}
`
export type UnlockPathItemMutationFn = Apollo.MutationFunction<
  UnlockPathItemMutation,
  UnlockPathItemMutationVariables
>

/**
 * __useUnlockPathItemMutation__
 *
 * To run a mutation, you first call `useUnlockPathItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockPathItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockPathItemMutation, { data, loading, error }] = useUnlockPathItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      path_id: // value for 'path_id'
 *      step_lock_password: // value for 'step_lock_password'
 *   },
 * });
 */
export function useUnlockPathItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnlockPathItemMutation,
    UnlockPathItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UnlockPathItemMutation,
    UnlockPathItemMutationVariables
  >(UnlockPathItemDocument, options)
}
export type UnlockPathItemMutationHookResult = ReturnType<
  typeof useUnlockPathItemMutation
>
export type UnlockPathItemMutationResult =
  Apollo.MutationResult<UnlockPathItemMutation>
export type UnlockPathItemMutationOptions = Apollo.BaseMutationOptions<
  UnlockPathItemMutation,
  UnlockPathItemMutationVariables
>
export const UpdatePathItemDocument = gql`
  mutation UpdatePathItem(
    $path_id: Int!
    $source_id: Int!
    $order: Int!
    $type: PathItemType!
    $name: String!
    $description: String
    $assignment_type: PathItemAssignmentType
    $is_required: Boolean
    $allow_resets: Int
    $show_grading_feedback: Int
    $completion_comment_required_status: String
    $points: Int
    $minimum_passing_score: Int
    $grading_type: String
    $is_previewable: Boolean
    $lock_password: String
    $time_to_complete: Int
    $requires_api_completion: Boolean
  ) {
    updatePathItem(
      path_id: $path_id
      source_id: $source_id
      type: $type
      name: $name
      order: $order
      description: $description
      assignment_type: $assignment_type
      is_required: $is_required
      allow_resets: $allow_resets
      show_grading_feedback: $show_grading_feedback
      completion_comment_required_status: $completion_comment_required_status
      points: $points
      minimum_passing_score: $minimum_passing_score
      grading_type: $grading_type
      is_previewable: $is_previewable
      lock_password: $lock_password
      time_to_complete: $time_to_complete
      requires_api_completion: $requires_api_completion
    ) {
      ...PathItem
    }
  }
  ${PathItemFragmentDoc}
`
export type UpdatePathItemMutationFn = Apollo.MutationFunction<
  UpdatePathItemMutation,
  UpdatePathItemMutationVariables
>

/**
 * __useUpdatePathItemMutation__
 *
 * To run a mutation, you first call `useUpdatePathItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePathItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePathItemMutation, { data, loading, error }] = useUpdatePathItemMutation({
 *   variables: {
 *      path_id: // value for 'path_id'
 *      source_id: // value for 'source_id'
 *      order: // value for 'order'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      assignment_type: // value for 'assignment_type'
 *      is_required: // value for 'is_required'
 *      allow_resets: // value for 'allow_resets'
 *      show_grading_feedback: // value for 'show_grading_feedback'
 *      completion_comment_required_status: // value for 'completion_comment_required_status'
 *      points: // value for 'points'
 *      minimum_passing_score: // value for 'minimum_passing_score'
 *      grading_type: // value for 'grading_type'
 *      is_previewable: // value for 'is_previewable'
 *      lock_password: // value for 'lock_password'
 *      time_to_complete: // value for 'time_to_complete'
 *      requires_api_completion: // value for 'requires_api_completion'
 *   },
 * });
 */
export function useUpdatePathItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePathItemMutation,
    UpdatePathItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdatePathItemMutation,
    UpdatePathItemMutationVariables
  >(UpdatePathItemDocument, options)
}
export type UpdatePathItemMutationHookResult = ReturnType<
  typeof useUpdatePathItemMutation
>
export type UpdatePathItemMutationResult =
  Apollo.MutationResult<UpdatePathItemMutation>
export type UpdatePathItemMutationOptions = Apollo.BaseMutationOptions<
  UpdatePathItemMutation,
  UpdatePathItemMutationVariables
>
export const UserPathReportCardDocument = gql`
  query UserPathReportCard($id: Int) {
    path(id: $id) {
      ...UserPathReportCard
    }
  }
  ${UserPathReportCardFragmentDoc}
`

/**
 * __useUserPathReportCardQuery__
 *
 * To run a query within a React component, call `useUserPathReportCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPathReportCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPathReportCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserPathReportCardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserPathReportCardQuery,
    UserPathReportCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserPathReportCardQuery,
    UserPathReportCardQueryVariables
  >(UserPathReportCardDocument, options)
}
export function useUserPathReportCardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserPathReportCardQuery,
    UserPathReportCardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserPathReportCardQuery,
    UserPathReportCardQueryVariables
  >(UserPathReportCardDocument, options)
}
export function useUserPathReportCardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserPathReportCardQuery,
        UserPathReportCardQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserPathReportCardQuery,
    UserPathReportCardQueryVariables
  >(UserPathReportCardDocument, options)
}
export type UserPathReportCardQueryHookResult = ReturnType<
  typeof useUserPathReportCardQuery
>
export type UserPathReportCardLazyQueryHookResult = ReturnType<
  typeof useUserPathReportCardLazyQuery
>
export type UserPathReportCardSuspenseQueryHookResult = ReturnType<
  typeof useUserPathReportCardSuspenseQuery
>
export type UserPathReportCardQueryResult = Apollo.QueryResult<
  UserPathReportCardQuery,
  UserPathReportCardQueryVariables
>
export const MissingPathItemDocument = gql`
  query MissingPathItem($id: Int, $pathId: Int) {
    missingPathItem: pathItem(
      id: $id
      path_id: $pathId
      archivedDateFilter: [{ eq: null }, { op: "or" }, { neq: null }]
    ) {
      ...MissingPathItem
    }
    missingSourcePathItem: pathItem(
      source_id: $id
      path_id: $pathId
      archivedDateFilter: [{ eq: null }, { op: "or" }, { neq: null }]
    ) {
      ...MissingPathItem
    }
  }
  ${MissingPathItemFragmentDoc}
`

/**
 * __useMissingPathItemQuery__
 *
 * To run a query within a React component, call `useMissingPathItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useMissingPathItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMissingPathItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useMissingPathItemQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MissingPathItemQuery,
    MissingPathItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<MissingPathItemQuery, MissingPathItemQueryVariables>(
    MissingPathItemDocument,
    options
  )
}
export function useMissingPathItemLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MissingPathItemQuery,
    MissingPathItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    MissingPathItemQuery,
    MissingPathItemQueryVariables
  >(MissingPathItemDocument, options)
}
export function useMissingPathItemSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        MissingPathItemQuery,
        MissingPathItemQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    MissingPathItemQuery,
    MissingPathItemQueryVariables
  >(MissingPathItemDocument, options)
}
export type MissingPathItemQueryHookResult = ReturnType<
  typeof useMissingPathItemQuery
>
export type MissingPathItemLazyQueryHookResult = ReturnType<
  typeof useMissingPathItemLazyQuery
>
export type MissingPathItemSuspenseQueryHookResult = ReturnType<
  typeof useMissingPathItemSuspenseQuery
>
export type MissingPathItemQueryResult = Apollo.QueryResult<
  MissingPathItemQuery,
  MissingPathItemQueryVariables
>
export const ContextDocument = gql`
  query Context {
    ...Context
  }
  ${ContextFragmentDoc}
`

/**
 * __useContextQuery__
 *
 * To run a query within a React component, call `useContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useContextQuery(
  baseOptions?: Apollo.QueryHookOptions<ContextQuery, ContextQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ContextQuery, ContextQueryVariables>(
    ContextDocument,
    options
  )
}
export function useContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ContextQuery, ContextQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ContextQuery, ContextQueryVariables>(
    ContextDocument,
    options
  )
}
export function useContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ContextQuery, ContextQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ContextQuery, ContextQueryVariables>(
    ContextDocument,
    options
  )
}
export type ContextQueryHookResult = ReturnType<typeof useContextQuery>
export type ContextLazyQueryHookResult = ReturnType<typeof useContextLazyQuery>
export type ContextSuspenseQueryHookResult = ReturnType<
  typeof useContextSuspenseQuery
>
export type ContextQueryResult = Apollo.QueryResult<
  ContextQuery,
  ContextQueryVariables
>
export const PositioningContextDocument = gql`
  query PositioningContext($input: PositioningContextInput!) {
    positioningContext(input: $input) {
      id
      context_key
      context_type
    }
  }
`

/**
 * __usePositioningContextQuery__
 *
 * To run a query within a React component, call `usePositioningContextQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositioningContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositioningContextQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePositioningContextQuery(
  baseOptions: Apollo.QueryHookOptions<
    PositioningContextQuery,
    PositioningContextQueryVariables
  > &
    (
      | { variables: PositioningContextQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PositioningContextQuery,
    PositioningContextQueryVariables
  >(PositioningContextDocument, options)
}
export function usePositioningContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PositioningContextQuery,
    PositioningContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PositioningContextQuery,
    PositioningContextQueryVariables
  >(PositioningContextDocument, options)
}
export function usePositioningContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PositioningContextQuery,
        PositioningContextQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PositioningContextQuery,
    PositioningContextQueryVariables
  >(PositioningContextDocument, options)
}
export type PositioningContextQueryHookResult = ReturnType<
  typeof usePositioningContextQuery
>
export type PositioningContextLazyQueryHookResult = ReturnType<
  typeof usePositioningContextLazyQuery
>
export type PositioningContextSuspenseQueryHookResult = ReturnType<
  typeof usePositioningContextSuspenseQuery
>
export type PositioningContextQueryResult = Apollo.QueryResult<
  PositioningContextQuery,
  PositioningContextQueryVariables
>
export const UpdatePositionedObjectsDocument = gql`
  mutation UpdatePositionedObjects(
    $context: PositioningContextInput!
    $positions: [PositionedObjectPositionInput]!
  ) {
    updatePositionedObjects(context: $context, positions: $positions)
  }
`
export type UpdatePositionedObjectsMutationFn = Apollo.MutationFunction<
  UpdatePositionedObjectsMutation,
  UpdatePositionedObjectsMutationVariables
>

/**
 * __useUpdatePositionedObjectsMutation__
 *
 * To run a mutation, you first call `useUpdatePositionedObjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePositionedObjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePositionedObjectsMutation, { data, loading, error }] = useUpdatePositionedObjectsMutation({
 *   variables: {
 *      context: // value for 'context'
 *      positions: // value for 'positions'
 *   },
 * });
 */
export function useUpdatePositionedObjectsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePositionedObjectsMutation,
    UpdatePositionedObjectsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdatePositionedObjectsMutation,
    UpdatePositionedObjectsMutationVariables
  >(UpdatePositionedObjectsDocument, options)
}
export type UpdatePositionedObjectsMutationHookResult = ReturnType<
  typeof useUpdatePositionedObjectsMutation
>
export type UpdatePositionedObjectsMutationResult =
  Apollo.MutationResult<UpdatePositionedObjectsMutation>
export type UpdatePositionedObjectsMutationOptions = Apollo.BaseMutationOptions<
  UpdatePositionedObjectsMutation,
  UpdatePositionedObjectsMutationVariables
>
export const __TestRegistrationPositioningDocument = gql`
  query __TestRegistrationPositioning(
    $first: Int!
    $positioningContext: PositioningContextInput
  ) {
    me {
      id
      registrations(first: $first, positioningContext: $positioningContext) {
        edges {
          node {
            ...__TestRegistration
          }
        }
      }
    }
  }
  ${__TestRegistrationFragmentDoc}
`

/**
 * __use__TestRegistrationPositioningQuery__
 *
 * To run a query within a React component, call `use__TestRegistrationPositioningQuery` and pass it any options that fit your needs.
 * When your component renders, `use__TestRegistrationPositioningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = use__TestRegistrationPositioningQuery({
 *   variables: {
 *      first: // value for 'first'
 *      positioningContext: // value for 'positioningContext'
 *   },
 * });
 */
export function use__TestRegistrationPositioningQuery(
  baseOptions: Apollo.QueryHookOptions<
    __TestRegistrationPositioningQuery,
    __TestRegistrationPositioningQueryVariables
  > &
    (
      | {
          variables: __TestRegistrationPositioningQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    __TestRegistrationPositioningQuery,
    __TestRegistrationPositioningQueryVariables
  >(__TestRegistrationPositioningDocument, options)
}
export function use__TestRegistrationPositioningLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    __TestRegistrationPositioningQuery,
    __TestRegistrationPositioningQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    __TestRegistrationPositioningQuery,
    __TestRegistrationPositioningQueryVariables
  >(__TestRegistrationPositioningDocument, options)
}
export function use__TestRegistrationPositioningSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        __TestRegistrationPositioningQuery,
        __TestRegistrationPositioningQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    __TestRegistrationPositioningQuery,
    __TestRegistrationPositioningQueryVariables
  >(__TestRegistrationPositioningDocument, options)
}
export type __TestRegistrationPositioningQueryHookResult = ReturnType<
  typeof use__TestRegistrationPositioningQuery
>
export type __TestRegistrationPositioningLazyQueryHookResult = ReturnType<
  typeof use__TestRegistrationPositioningLazyQuery
>
export type __TestRegistrationPositioningSuspenseQueryHookResult = ReturnType<
  typeof use__TestRegistrationPositioningSuspenseQuery
>
export type __TestRegistrationPositioningQueryResult = Apollo.QueryResult<
  __TestRegistrationPositioningQuery,
  __TestRegistrationPositioningQueryVariables
>
export const ActiveCertificateDocument = gql`
  query ActiveCertificate {
    certificate {
      id
    }
  }
`

/**
 * __useActiveCertificateQuery__
 *
 * To run a query within a React component, call `useActiveCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveCertificateQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveCertificateQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActiveCertificateQuery,
    ActiveCertificateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ActiveCertificateQuery,
    ActiveCertificateQueryVariables
  >(ActiveCertificateDocument, options)
}
export function useActiveCertificateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActiveCertificateQuery,
    ActiveCertificateQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ActiveCertificateQuery,
    ActiveCertificateQueryVariables
  >(ActiveCertificateDocument, options)
}
export function useActiveCertificateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ActiveCertificateQuery,
        ActiveCertificateQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ActiveCertificateQuery,
    ActiveCertificateQueryVariables
  >(ActiveCertificateDocument, options)
}
export type ActiveCertificateQueryHookResult = ReturnType<
  typeof useActiveCertificateQuery
>
export type ActiveCertificateLazyQueryHookResult = ReturnType<
  typeof useActiveCertificateLazyQuery
>
export type ActiveCertificateSuspenseQueryHookResult = ReturnType<
  typeof useActiveCertificateSuspenseQuery
>
export type ActiveCertificateQueryResult = Apollo.QueryResult<
  ActiveCertificateQuery,
  ActiveCertificateQueryVariables
>
export const CertificateDownloadUrlDocument = gql`
  query CertificateDownloadUrl($pathId: Int) {
    certificate {
      id
      download_url(path_id: $pathId)
    }
  }
`

/**
 * __useCertificateDownloadUrlQuery__
 *
 * To run a query within a React component, call `useCertificateDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCertificateDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCertificateDownloadUrlQuery({
 *   variables: {
 *      pathId: // value for 'pathId'
 *   },
 * });
 */
export function useCertificateDownloadUrlQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CertificateDownloadUrlQuery,
    CertificateDownloadUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CertificateDownloadUrlQuery,
    CertificateDownloadUrlQueryVariables
  >(CertificateDownloadUrlDocument, options)
}
export function useCertificateDownloadUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CertificateDownloadUrlQuery,
    CertificateDownloadUrlQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CertificateDownloadUrlQuery,
    CertificateDownloadUrlQueryVariables
  >(CertificateDownloadUrlDocument, options)
}
export function useCertificateDownloadUrlSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CertificateDownloadUrlQuery,
        CertificateDownloadUrlQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CertificateDownloadUrlQuery,
    CertificateDownloadUrlQueryVariables
  >(CertificateDownloadUrlDocument, options)
}
export type CertificateDownloadUrlQueryHookResult = ReturnType<
  typeof useCertificateDownloadUrlQuery
>
export type CertificateDownloadUrlLazyQueryHookResult = ReturnType<
  typeof useCertificateDownloadUrlLazyQuery
>
export type CertificateDownloadUrlSuspenseQueryHookResult = ReturnType<
  typeof useCertificateDownloadUrlSuspenseQuery
>
export type CertificateDownloadUrlQueryResult = Apollo.QueryResult<
  CertificateDownloadUrlQuery,
  CertificateDownloadUrlQueryVariables
>
export const UpdateUserMembershipDocument = gql`
  mutation UpdateUserMembership($consents: Boolean) {
    updateMemberConsent(consents: $consents) {
      id
      consent_snapshot
      consent_dtime
    }
  }
`
export type UpdateUserMembershipMutationFn = Apollo.MutationFunction<
  UpdateUserMembershipMutation,
  UpdateUserMembershipMutationVariables
>

/**
 * __useUpdateUserMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateUserMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMembershipMutation, { data, loading, error }] = useUpdateUserMembershipMutation({
 *   variables: {
 *      consents: // value for 'consents'
 *   },
 * });
 */
export function useUpdateUserMembershipMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserMembershipMutation,
    UpdateUserMembershipMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateUserMembershipMutation,
    UpdateUserMembershipMutationVariables
  >(UpdateUserMembershipDocument, options)
}
export type UpdateUserMembershipMutationHookResult = ReturnType<
  typeof useUpdateUserMembershipMutation
>
export type UpdateUserMembershipMutationResult =
  Apollo.MutationResult<UpdateUserMembershipMutation>
export type UpdateUserMembershipMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMembershipMutation,
  UpdateUserMembershipMutationVariables
>
export const UserProfileDocument = gql`
  query UserProfile($id: Int!) {
    user(id: $id) {
      ...User
      membership {
        id
        role
        last_active
        last_seen
      }
    }
  }
  ${UserFragmentDoc}
`

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserProfileQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserProfileQuery,
    UserProfileQueryVariables
  > &
    (
      | { variables: UserProfileQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<UserProfileQuery, UserProfileQueryVariables>(
    UserProfileDocument,
    options
  )
}
export function useUserProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserProfileQuery,
    UserProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(
    UserProfileDocument,
    options
  )
}
export function useUserProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserProfileQuery,
        UserProfileQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<UserProfileQuery, UserProfileQueryVariables>(
    UserProfileDocument,
    options
  )
}
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>
export type UserProfileLazyQueryHookResult = ReturnType<
  typeof useUserProfileLazyQuery
>
export type UserProfileSuspenseQueryHookResult = ReturnType<
  typeof useUserProfileSuspenseQuery
>
export type UserProfileQueryResult = Apollo.QueryResult<
  UserProfileQuery,
  UserProfileQueryVariables
>
export const PublishersDocument = gql`
  query Publishers($first: Int!, $cursor: String, $school_id: Int!) {
    context(school_id: $school_id) {
      school {
        ...School
        publishers(first: $first, after: $cursor) {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...Publisher
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${PublisherFragmentDoc}
`

/**
 * __usePublishersQuery__
 *
 * To run a query within a React component, call `usePublishersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *      school_id: // value for 'school_id'
 *   },
 * });
 */
export function usePublishersQuery(
  baseOptions: Apollo.QueryHookOptions<
    PublishersQuery,
    PublishersQueryVariables
  > &
    (
      | { variables: PublishersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PublishersQuery, PublishersQueryVariables>(
    PublishersDocument,
    options
  )
}
export function usePublishersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PublishersQuery,
    PublishersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PublishersQuery, PublishersQueryVariables>(
    PublishersDocument,
    options
  )
}
export function usePublishersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PublishersQuery, PublishersQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PublishersQuery, PublishersQueryVariables>(
    PublishersDocument,
    options
  )
}
export type PublishersQueryHookResult = ReturnType<typeof usePublishersQuery>
export type PublishersLazyQueryHookResult = ReturnType<
  typeof usePublishersLazyQuery
>
export type PublishersSuspenseQueryHookResult = ReturnType<
  typeof usePublishersSuspenseQuery
>
export type PublishersQueryResult = Apollo.QueryResult<
  PublishersQuery,
  PublishersQueryVariables
>
export const UpdateReferralDocument = gql`
  mutation UpdateReferral($referral: String!) {
    updateReferral(referral: $referral) {
      referral
    }
  }
`
export type UpdateReferralMutationFn = Apollo.MutationFunction<
  UpdateReferralMutation,
  UpdateReferralMutationVariables
>

/**
 * __useUpdateReferralMutation__
 *
 * To run a mutation, you first call `useUpdateReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReferralMutation, { data, loading, error }] = useUpdateReferralMutation({
 *   variables: {
 *      referral: // value for 'referral'
 *   },
 * });
 */
export function useUpdateReferralMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateReferralMutation,
    UpdateReferralMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateReferralMutation,
    UpdateReferralMutationVariables
  >(UpdateReferralDocument, options)
}
export type UpdateReferralMutationHookResult = ReturnType<
  typeof useUpdateReferralMutation
>
export type UpdateReferralMutationResult =
  Apollo.MutationResult<UpdateReferralMutation>
export type UpdateReferralMutationOptions = Apollo.BaseMutationOptions<
  UpdateReferralMutation,
  UpdateReferralMutationVariables
>
export const DeleteRegistrationDocument = gql`
  mutation DeleteRegistration($group_id: Int!, $registration_id: Int!) {
    deleteRegistration(group_id: $group_id, registration_id: $registration_id)
  }
`
export type DeleteRegistrationMutationFn = Apollo.MutationFunction<
  DeleteRegistrationMutation,
  DeleteRegistrationMutationVariables
>

/**
 * __useDeleteRegistrationMutation__
 *
 * To run a mutation, you first call `useDeleteRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegistrationMutation, { data, loading, error }] = useDeleteRegistrationMutation({
 *   variables: {
 *      group_id: // value for 'group_id'
 *      registration_id: // value for 'registration_id'
 *   },
 * });
 */
export function useDeleteRegistrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRegistrationMutation,
    DeleteRegistrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteRegistrationMutation,
    DeleteRegistrationMutationVariables
  >(DeleteRegistrationDocument, options)
}
export type DeleteRegistrationMutationHookResult = ReturnType<
  typeof useDeleteRegistrationMutation
>
export type DeleteRegistrationMutationResult =
  Apollo.MutationResult<DeleteRegistrationMutation>
export type DeleteRegistrationMutationOptions = Apollo.BaseMutationOptions<
  DeleteRegistrationMutation,
  DeleteRegistrationMutationVariables
>
export const RegistrationExpirationDocument = gql`
  query RegistrationExpiration($cohortId: Int!) {
    cohort: group(id: $cohortId) {
      id
      name
      price
      is_subscription_only
      access_ends
      resource {
        id
        name
      }
      include_in_plans(first: 25) {
        total
        edges {
          node {
            id
          }
        }
      }
      include_with_products(first: 25) {
        total
        edges {
          node {
            id
          }
        }
      }
      user_registration {
        id
        expiration_dtime
        school_sub_used {
          id
          school_subscription_plan {
            id
          }
          subscription_plan {
            id
            name
          }
          subscription {
            ...Subscription
          }
        }
        group_sub_used {
          id
          price {
            id
            product {
              id
              name
            }
          }
          community_group {
            id
            name
            seat_limit
          }
          subscription {
            ...Subscription
          }
        }
        group_sub_community_membership {
          id
          access_revoked_time
        }
      }
    }
  }
  ${SubscriptionFragmentDoc}
`

/**
 * __useRegistrationExpirationQuery__
 *
 * To run a query within a React component, call `useRegistrationExpirationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationExpirationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationExpirationQuery({
 *   variables: {
 *      cohortId: // value for 'cohortId'
 *   },
 * });
 */
export function useRegistrationExpirationQuery(
  baseOptions: Apollo.QueryHookOptions<
    RegistrationExpirationQuery,
    RegistrationExpirationQueryVariables
  > &
    (
      | { variables: RegistrationExpirationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RegistrationExpirationQuery,
    RegistrationExpirationQueryVariables
  >(RegistrationExpirationDocument, options)
}
export function useRegistrationExpirationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RegistrationExpirationQuery,
    RegistrationExpirationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RegistrationExpirationQuery,
    RegistrationExpirationQueryVariables
  >(RegistrationExpirationDocument, options)
}
export function useRegistrationExpirationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegistrationExpirationQuery,
        RegistrationExpirationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RegistrationExpirationQuery,
    RegistrationExpirationQueryVariables
  >(RegistrationExpirationDocument, options)
}
export type RegistrationExpirationQueryHookResult = ReturnType<
  typeof useRegistrationExpirationQuery
>
export type RegistrationExpirationLazyQueryHookResult = ReturnType<
  typeof useRegistrationExpirationLazyQuery
>
export type RegistrationExpirationSuspenseQueryHookResult = ReturnType<
  typeof useRegistrationExpirationSuspenseQuery
>
export type RegistrationExpirationQueryResult = Apollo.QueryResult<
  RegistrationExpirationQuery,
  RegistrationExpirationQueryVariables
>
export const RegistrationDocument = gql`
  query Registration($group_id: Int!, $registration_id: Int) {
    group(id: $group_id) {
      ...Group
      permissions {
        can_invite_observer
        can_invite_student
        can_invite_moderator
        can_invite_teacher
        can_invite_editor
      }
      registration(id: $registration_id) {
        ...Registration
        user {
          ...User
        }
      }
    }
  }
  ${GroupFragmentDoc}
  ${RegistrationFragmentDoc}
  ${UserFragmentDoc}
`

/**
 * __useRegistrationQuery__
 *
 * To run a query within a React component, call `useRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationQuery({
 *   variables: {
 *      group_id: // value for 'group_id'
 *      registration_id: // value for 'registration_id'
 *   },
 * });
 */
export function useRegistrationQuery(
  baseOptions: Apollo.QueryHookOptions<
    RegistrationQuery,
    RegistrationQueryVariables
  > &
    (
      | { variables: RegistrationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RegistrationQuery, RegistrationQueryVariables>(
    RegistrationDocument,
    options
  )
}
export function useRegistrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RegistrationQuery,
    RegistrationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<RegistrationQuery, RegistrationQueryVariables>(
    RegistrationDocument,
    options
  )
}
export function useRegistrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegistrationQuery,
        RegistrationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<RegistrationQuery, RegistrationQueryVariables>(
    RegistrationDocument,
    options
  )
}
export type RegistrationQueryHookResult = ReturnType<
  typeof useRegistrationQuery
>
export type RegistrationLazyQueryHookResult = ReturnType<
  typeof useRegistrationLazyQuery
>
export type RegistrationSuspenseQueryHookResult = ReturnType<
  typeof useRegistrationSuspenseQuery
>
export type RegistrationQueryResult = Apollo.QueryResult<
  RegistrationQuery,
  RegistrationQueryVariables
>
export const RegistrationsDocument = gql`
  query Registrations(
    $groupId: Int!
    $roleFilter: RoleFilter
    $dateLastActive: DateFilter
    $dateJoined: DateFilter
    $softArchived: DateFilter
    $orderBy: [RegistrationOrderByInput]
    $cursor: String
  ) {
    group(id: $groupId) {
      ...Group
      resource {
        ...Resource
      }
      registrations(
        first: 50
        role_filter: $roleFilter
        last_active: $dateLastActive
        created: $dateJoined
        softArchived: $softArchived
        orderBy: $orderBy
        after: $cursor
      ) {
        total
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...Registration
          }
        }
      }
    }
  }
  ${GroupFragmentDoc}
  ${ResourceFragmentDoc}
  ${RegistrationFragmentDoc}
`

/**
 * __useRegistrationsQuery__
 *
 * To run a query within a React component, call `useRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      roleFilter: // value for 'roleFilter'
 *      dateLastActive: // value for 'dateLastActive'
 *      dateJoined: // value for 'dateJoined'
 *      softArchived: // value for 'softArchived'
 *      orderBy: // value for 'orderBy'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useRegistrationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    RegistrationsQuery,
    RegistrationsQueryVariables
  > &
    (
      | { variables: RegistrationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RegistrationsQuery, RegistrationsQueryVariables>(
    RegistrationsDocument,
    options
  )
}
export function useRegistrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RegistrationsQuery,
    RegistrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<RegistrationsQuery, RegistrationsQueryVariables>(
    RegistrationsDocument,
    options
  )
}
export function useRegistrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RegistrationsQuery,
        RegistrationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RegistrationsQuery,
    RegistrationsQueryVariables
  >(RegistrationsDocument, options)
}
export type RegistrationsQueryHookResult = ReturnType<
  typeof useRegistrationsQuery
>
export type RegistrationsLazyQueryHookResult = ReturnType<
  typeof useRegistrationsLazyQuery
>
export type RegistrationsSuspenseQueryHookResult = ReturnType<
  typeof useRegistrationsSuspenseQuery
>
export type RegistrationsQueryResult = Apollo.QueryResult<
  RegistrationsQuery,
  RegistrationsQueryVariables
>
export const UserProfileRegistrationsDocument = gql`
  query UserProfileRegistrations(
    $cursor: String
    $first: Int = 50
    $id: Int
    $role_filter: RoleFilter
    $progress_filter: ProgressFilter
    $parent_cohort_filter: IDFilter
    $hasParentRegistration: Boolean
    $orderBy: [RegistrationOrderByInput]
  ) {
    user(id: $id) {
      ...User
      registrations(
        first: $first
        after: $cursor
        role_filter: $role_filter
        progress_filter: $progress_filter
        parent_cohort_filter: $parent_cohort_filter
        has_parent_registration: $hasParentRegistration
        orderBy: $orderBy
      ) {
        total
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...UserProfileRegistration
          }
        }
      }
    }
  }
  ${UserFragmentDoc}
  ${UserProfileRegistrationFragmentDoc}
`

/**
 * __useUserProfileRegistrationsQuery__
 *
 * To run a query within a React component, call `useUserProfileRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileRegistrationsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *      id: // value for 'id'
 *      role_filter: // value for 'role_filter'
 *      progress_filter: // value for 'progress_filter'
 *      parent_cohort_filter: // value for 'parent_cohort_filter'
 *      hasParentRegistration: // value for 'hasParentRegistration'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useUserProfileRegistrationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserProfileRegistrationsQuery,
    UserProfileRegistrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserProfileRegistrationsQuery,
    UserProfileRegistrationsQueryVariables
  >(UserProfileRegistrationsDocument, options)
}
export function useUserProfileRegistrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserProfileRegistrationsQuery,
    UserProfileRegistrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserProfileRegistrationsQuery,
    UserProfileRegistrationsQueryVariables
  >(UserProfileRegistrationsDocument, options)
}
export function useUserProfileRegistrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserProfileRegistrationsQuery,
        UserProfileRegistrationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserProfileRegistrationsQuery,
    UserProfileRegistrationsQueryVariables
  >(UserProfileRegistrationsDocument, options)
}
export type UserProfileRegistrationsQueryHookResult = ReturnType<
  typeof useUserProfileRegistrationsQuery
>
export type UserProfileRegistrationsLazyQueryHookResult = ReturnType<
  typeof useUserProfileRegistrationsLazyQuery
>
export type UserProfileRegistrationsSuspenseQueryHookResult = ReturnType<
  typeof useUserProfileRegistrationsSuspenseQuery
>
export type UserProfileRegistrationsQueryResult = Apollo.QueryResult<
  UserProfileRegistrationsQuery,
  UserProfileRegistrationsQueryVariables
>
export const DeferOrExecuteResourceCopyConfigDocument = gql`
  mutation DeferOrExecuteResourceCopyConfig(
    $copyCode: String!
    $targetSchoolId: Int!
  ) {
    deferOrExecuteResourceCopyConfig(
      copy_code: $copyCode
      target_school_id: $targetSchoolId
    ) {
      defer
      execute
    }
  }
`
export type DeferOrExecuteResourceCopyConfigMutationFn =
  Apollo.MutationFunction<
    DeferOrExecuteResourceCopyConfigMutation,
    DeferOrExecuteResourceCopyConfigMutationVariables
  >

/**
 * __useDeferOrExecuteResourceCopyConfigMutation__
 *
 * To run a mutation, you first call `useDeferOrExecuteResourceCopyConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeferOrExecuteResourceCopyConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deferOrExecuteResourceCopyConfigMutation, { data, loading, error }] = useDeferOrExecuteResourceCopyConfigMutation({
 *   variables: {
 *      copyCode: // value for 'copyCode'
 *      targetSchoolId: // value for 'targetSchoolId'
 *   },
 * });
 */
export function useDeferOrExecuteResourceCopyConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeferOrExecuteResourceCopyConfigMutation,
    DeferOrExecuteResourceCopyConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeferOrExecuteResourceCopyConfigMutation,
    DeferOrExecuteResourceCopyConfigMutationVariables
  >(DeferOrExecuteResourceCopyConfigDocument, options)
}
export type DeferOrExecuteResourceCopyConfigMutationHookResult = ReturnType<
  typeof useDeferOrExecuteResourceCopyConfigMutation
>
export type DeferOrExecuteResourceCopyConfigMutationResult =
  Apollo.MutationResult<DeferOrExecuteResourceCopyConfigMutation>
export type DeferOrExecuteResourceCopyConfigMutationOptions =
  Apollo.BaseMutationOptions<
    DeferOrExecuteResourceCopyConfigMutation,
    DeferOrExecuteResourceCopyConfigMutationVariables
  >
export const DeleteResourceCopyConfigLinkDocument = gql`
  mutation DeleteResourceCopyConfigLink($id: Int!) {
    deleteResourceCopyConfigLink(id: $id)
  }
`
export type DeleteResourceCopyConfigLinkMutationFn = Apollo.MutationFunction<
  DeleteResourceCopyConfigLinkMutation,
  DeleteResourceCopyConfigLinkMutationVariables
>

/**
 * __useDeleteResourceCopyConfigLinkMutation__
 *
 * To run a mutation, you first call `useDeleteResourceCopyConfigLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResourceCopyConfigLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResourceCopyConfigLinkMutation, { data, loading, error }] = useDeleteResourceCopyConfigLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteResourceCopyConfigLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteResourceCopyConfigLinkMutation,
    DeleteResourceCopyConfigLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DeleteResourceCopyConfigLinkMutation,
    DeleteResourceCopyConfigLinkMutationVariables
  >(DeleteResourceCopyConfigLinkDocument, options)
}
export type DeleteResourceCopyConfigLinkMutationHookResult = ReturnType<
  typeof useDeleteResourceCopyConfigLinkMutation
>
export type DeleteResourceCopyConfigLinkMutationResult =
  Apollo.MutationResult<DeleteResourceCopyConfigLinkMutation>
export type DeleteResourceCopyConfigLinkMutationOptions =
  Apollo.BaseMutationOptions<
    DeleteResourceCopyConfigLinkMutation,
    DeleteResourceCopyConfigLinkMutationVariables
  >
export const ExecuteDeferredResourceCopyConfigDocument = gql`
  mutation ExecuteDeferredResourceCopyConfig($linkId: Int!) {
    executeDeferredResourceCopyConfig(link_id: $linkId) {
      defer
      execute
    }
  }
`
export type ExecuteDeferredResourceCopyConfigMutationFn =
  Apollo.MutationFunction<
    ExecuteDeferredResourceCopyConfigMutation,
    ExecuteDeferredResourceCopyConfigMutationVariables
  >

/**
 * __useExecuteDeferredResourceCopyConfigMutation__
 *
 * To run a mutation, you first call `useExecuteDeferredResourceCopyConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteDeferredResourceCopyConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeDeferredResourceCopyConfigMutation, { data, loading, error }] = useExecuteDeferredResourceCopyConfigMutation({
 *   variables: {
 *      linkId: // value for 'linkId'
 *   },
 * });
 */
export function useExecuteDeferredResourceCopyConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ExecuteDeferredResourceCopyConfigMutation,
    ExecuteDeferredResourceCopyConfigMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ExecuteDeferredResourceCopyConfigMutation,
    ExecuteDeferredResourceCopyConfigMutationVariables
  >(ExecuteDeferredResourceCopyConfigDocument, options)
}
export type ExecuteDeferredResourceCopyConfigMutationHookResult = ReturnType<
  typeof useExecuteDeferredResourceCopyConfigMutation
>
export type ExecuteDeferredResourceCopyConfigMutationResult =
  Apollo.MutationResult<ExecuteDeferredResourceCopyConfigMutation>
export type ExecuteDeferredResourceCopyConfigMutationOptions =
  Apollo.BaseMutationOptions<
    ExecuteDeferredResourceCopyConfigMutation,
    ExecuteDeferredResourceCopyConfigMutationVariables
  >
export const ResourceCopyConfigDocument = gql`
  query ResourceCopyConfig($key: String!) {
    resourceCopyConfig(key: $key) {
      ...ResourceCopyConfig
    }
  }
  ${ResourceCopyConfigFragmentDoc}
`

/**
 * __useResourceCopyConfigQuery__
 *
 * To run a query within a React component, call `useResourceCopyConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceCopyConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceCopyConfigQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useResourceCopyConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceCopyConfigQuery,
    ResourceCopyConfigQueryVariables
  > &
    (
      | { variables: ResourceCopyConfigQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ResourceCopyConfigQuery,
    ResourceCopyConfigQueryVariables
  >(ResourceCopyConfigDocument, options)
}
export function useResourceCopyConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceCopyConfigQuery,
    ResourceCopyConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceCopyConfigQuery,
    ResourceCopyConfigQueryVariables
  >(ResourceCopyConfigDocument, options)
}
export function useResourceCopyConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceCopyConfigQuery,
        ResourceCopyConfigQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceCopyConfigQuery,
    ResourceCopyConfigQueryVariables
  >(ResourceCopyConfigDocument, options)
}
export type ResourceCopyConfigQueryHookResult = ReturnType<
  typeof useResourceCopyConfigQuery
>
export type ResourceCopyConfigLazyQueryHookResult = ReturnType<
  typeof useResourceCopyConfigLazyQuery
>
export type ResourceCopyConfigSuspenseQueryHookResult = ReturnType<
  typeof useResourceCopyConfigSuspenseQuery
>
export type ResourceCopyConfigQueryResult = Apollo.QueryResult<
  ResourceCopyConfigQuery,
  ResourceCopyConfigQueryVariables
>
export const ResourceCopyConfigConnectionsDocument = gql`
  query ResourceCopyConfigConnections(
    $first: Int!
    $keys: [String]
    $fromSpaceId: Int
  ) {
    resourceCopyConfigConnections(
      first: $first
      keys: $keys
      fromSpaceId: $fromSpaceId
    ) {
      edges {
        node {
          ...ResourceCopyConfig
        }
      }
    }
  }
  ${ResourceCopyConfigFragmentDoc}
`

/**
 * __useResourceCopyConfigConnectionsQuery__
 *
 * To run a query within a React component, call `useResourceCopyConfigConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceCopyConfigConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceCopyConfigConnectionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      keys: // value for 'keys'
 *      fromSpaceId: // value for 'fromSpaceId'
 *   },
 * });
 */
export function useResourceCopyConfigConnectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceCopyConfigConnectionsQuery,
    ResourceCopyConfigConnectionsQueryVariables
  > &
    (
      | {
          variables: ResourceCopyConfigConnectionsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ResourceCopyConfigConnectionsQuery,
    ResourceCopyConfigConnectionsQueryVariables
  >(ResourceCopyConfigConnectionsDocument, options)
}
export function useResourceCopyConfigConnectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceCopyConfigConnectionsQuery,
    ResourceCopyConfigConnectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceCopyConfigConnectionsQuery,
    ResourceCopyConfigConnectionsQueryVariables
  >(ResourceCopyConfigConnectionsDocument, options)
}
export function useResourceCopyConfigConnectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceCopyConfigConnectionsQuery,
        ResourceCopyConfigConnectionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceCopyConfigConnectionsQuery,
    ResourceCopyConfigConnectionsQueryVariables
  >(ResourceCopyConfigConnectionsDocument, options)
}
export type ResourceCopyConfigConnectionsQueryHookResult = ReturnType<
  typeof useResourceCopyConfigConnectionsQuery
>
export type ResourceCopyConfigConnectionsLazyQueryHookResult = ReturnType<
  typeof useResourceCopyConfigConnectionsLazyQuery
>
export type ResourceCopyConfigConnectionsSuspenseQueryHookResult = ReturnType<
  typeof useResourceCopyConfigConnectionsSuspenseQuery
>
export type ResourceCopyConfigConnectionsQueryResult = Apollo.QueryResult<
  ResourceCopyConfigConnectionsQuery,
  ResourceCopyConfigConnectionsQueryVariables
>
export const ResourceCopyConfigLinkConnectionsDocument = gql`
  query ResourceCopyConfigLinkConnections(
    $first: Int!
    $copiedTimeDateFilter: DateFilter
    $hideFromLocationsFilter: [ResourceCopyConfigLinkLocationFilter]
  ) {
    resourceCopyConfigLinkConnections(
      first: $first
      copiedTimeDateFilter: $copiedTimeDateFilter
      hideFromLocationsFilter: $hideFromLocationsFilter
    ) {
      edges {
        node {
          ...ResourceCopyConfigLink
        }
      }
    }
  }
  ${ResourceCopyConfigLinkFragmentDoc}
`

/**
 * __useResourceCopyConfigLinkConnectionsQuery__
 *
 * To run a query within a React component, call `useResourceCopyConfigLinkConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceCopyConfigLinkConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceCopyConfigLinkConnectionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      copiedTimeDateFilter: // value for 'copiedTimeDateFilter'
 *      hideFromLocationsFilter: // value for 'hideFromLocationsFilter'
 *   },
 * });
 */
export function useResourceCopyConfigLinkConnectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceCopyConfigLinkConnectionsQuery,
    ResourceCopyConfigLinkConnectionsQueryVariables
  > &
    (
      | {
          variables: ResourceCopyConfigLinkConnectionsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ResourceCopyConfigLinkConnectionsQuery,
    ResourceCopyConfigLinkConnectionsQueryVariables
  >(ResourceCopyConfigLinkConnectionsDocument, options)
}
export function useResourceCopyConfigLinkConnectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceCopyConfigLinkConnectionsQuery,
    ResourceCopyConfigLinkConnectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceCopyConfigLinkConnectionsQuery,
    ResourceCopyConfigLinkConnectionsQueryVariables
  >(ResourceCopyConfigLinkConnectionsDocument, options)
}
export function useResourceCopyConfigLinkConnectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceCopyConfigLinkConnectionsQuery,
        ResourceCopyConfigLinkConnectionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceCopyConfigLinkConnectionsQuery,
    ResourceCopyConfigLinkConnectionsQueryVariables
  >(ResourceCopyConfigLinkConnectionsDocument, options)
}
export type ResourceCopyConfigLinkConnectionsQueryHookResult = ReturnType<
  typeof useResourceCopyConfigLinkConnectionsQuery
>
export type ResourceCopyConfigLinkConnectionsLazyQueryHookResult = ReturnType<
  typeof useResourceCopyConfigLinkConnectionsLazyQuery
>
export type ResourceCopyConfigLinkConnectionsSuspenseQueryHookResult =
  ReturnType<typeof useResourceCopyConfigLinkConnectionsSuspenseQuery>
export type ResourceCopyConfigLinkConnectionsQueryResult = Apollo.QueryResult<
  ResourceCopyConfigLinkConnectionsQuery,
  ResourceCopyConfigLinkConnectionsQueryVariables
>
export const ResourceCopyConfigLinkDocument = gql`
  query ResourceCopyConfigLink($id: Int!) {
    resourceCopyConfigLink(id: $id) {
      ...ResourceCopyConfigLink
    }
  }
  ${ResourceCopyConfigLinkFragmentDoc}
`

/**
 * __useResourceCopyConfigLinkQuery__
 *
 * To run a query within a React component, call `useResourceCopyConfigLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceCopyConfigLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceCopyConfigLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourceCopyConfigLinkQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceCopyConfigLinkQuery,
    ResourceCopyConfigLinkQueryVariables
  > &
    (
      | { variables: ResourceCopyConfigLinkQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ResourceCopyConfigLinkQuery,
    ResourceCopyConfigLinkQueryVariables
  >(ResourceCopyConfigLinkDocument, options)
}
export function useResourceCopyConfigLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceCopyConfigLinkQuery,
    ResourceCopyConfigLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceCopyConfigLinkQuery,
    ResourceCopyConfigLinkQueryVariables
  >(ResourceCopyConfigLinkDocument, options)
}
export function useResourceCopyConfigLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceCopyConfigLinkQuery,
        ResourceCopyConfigLinkQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceCopyConfigLinkQuery,
    ResourceCopyConfigLinkQueryVariables
  >(ResourceCopyConfigLinkDocument, options)
}
export type ResourceCopyConfigLinkQueryHookResult = ReturnType<
  typeof useResourceCopyConfigLinkQuery
>
export type ResourceCopyConfigLinkLazyQueryHookResult = ReturnType<
  typeof useResourceCopyConfigLinkLazyQuery
>
export type ResourceCopyConfigLinkSuspenseQueryHookResult = ReturnType<
  typeof useResourceCopyConfigLinkSuspenseQuery
>
export type ResourceCopyConfigLinkQueryResult = Apollo.QueryResult<
  ResourceCopyConfigLinkQuery,
  ResourceCopyConfigLinkQueryVariables
>
export const ResourcePublisherDocument = gql`
  query ResourcePublisher($id: Int) {
    resource(id: $id) {
      id
      publisher {
        ...Publisher
      }
    }
  }
  ${PublisherFragmentDoc}
`

/**
 * __useResourcePublisherQuery__
 *
 * To run a query within a React component, call `useResourcePublisherQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcePublisherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcePublisherQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourcePublisherQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ResourcePublisherQuery,
    ResourcePublisherQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ResourcePublisherQuery,
    ResourcePublisherQueryVariables
  >(ResourcePublisherDocument, options)
}
export function useResourcePublisherLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourcePublisherQuery,
    ResourcePublisherQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourcePublisherQuery,
    ResourcePublisherQueryVariables
  >(ResourcePublisherDocument, options)
}
export function useResourcePublisherSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourcePublisherQuery,
        ResourcePublisherQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourcePublisherQuery,
    ResourcePublisherQueryVariables
  >(ResourcePublisherDocument, options)
}
export type ResourcePublisherQueryHookResult = ReturnType<
  typeof useResourcePublisherQuery
>
export type ResourcePublisherLazyQueryHookResult = ReturnType<
  typeof useResourcePublisherLazyQuery
>
export type ResourcePublisherSuspenseQueryHookResult = ReturnType<
  typeof useResourcePublisherSuspenseQuery
>
export type ResourcePublisherQueryResult = Apollo.QueryResult<
  ResourcePublisherQuery,
  ResourcePublisherQueryVariables
>
export const ResourceDocument = gql`
  query Resource($id: Int!) {
    resource(id: $id) {
      ...Resource
    }
  }
  ${ResourceFragmentDoc}
`

/**
 * __useResourceQuery__
 *
 * To run a query within a React component, call `useResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourceQuery(
  baseOptions: Apollo.QueryHookOptions<ResourceQuery, ResourceQueryVariables> &
    ({ variables: ResourceQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ResourceQuery, ResourceQueryVariables>(
    ResourceDocument,
    options
  )
}
export function useResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceQuery,
    ResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ResourceQuery, ResourceQueryVariables>(
    ResourceDocument,
    options
  )
}
export function useResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ResourceQuery, ResourceQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ResourceQuery, ResourceQueryVariables>(
    ResourceDocument,
    options
  )
}
export type ResourceQueryHookResult = ReturnType<typeof useResourceQuery>
export type ResourceLazyQueryHookResult = ReturnType<
  typeof useResourceLazyQuery
>
export type ResourceSuspenseQueryHookResult = ReturnType<
  typeof useResourceSuspenseQuery
>
export type ResourceQueryResult = Apollo.QueryResult<
  ResourceQuery,
  ResourceQueryVariables
>
export const ShowHideResourceCopyConfigLinkDocument = gql`
  mutation ShowHideResourceCopyConfigLink(
    $id: Int!
    $show: [ResourceCopyConfigLinkLocation]
    $hide: [ResourceCopyConfigLinkLocation]
  ) {
    showHideResourceCopyConfigLink(id: $id, show: $show, hide: $hide) {
      ...ResourceCopyConfigLink
    }
  }
  ${ResourceCopyConfigLinkFragmentDoc}
`
export type ShowHideResourceCopyConfigLinkMutationFn = Apollo.MutationFunction<
  ShowHideResourceCopyConfigLinkMutation,
  ShowHideResourceCopyConfigLinkMutationVariables
>

/**
 * __useShowHideResourceCopyConfigLinkMutation__
 *
 * To run a mutation, you first call `useShowHideResourceCopyConfigLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShowHideResourceCopyConfigLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [showHideResourceCopyConfigLinkMutation, { data, loading, error }] = useShowHideResourceCopyConfigLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      show: // value for 'show'
 *      hide: // value for 'hide'
 *   },
 * });
 */
export function useShowHideResourceCopyConfigLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ShowHideResourceCopyConfigLinkMutation,
    ShowHideResourceCopyConfigLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ShowHideResourceCopyConfigLinkMutation,
    ShowHideResourceCopyConfigLinkMutationVariables
  >(ShowHideResourceCopyConfigLinkDocument, options)
}
export type ShowHideResourceCopyConfigLinkMutationHookResult = ReturnType<
  typeof useShowHideResourceCopyConfigLinkMutation
>
export type ShowHideResourceCopyConfigLinkMutationResult =
  Apollo.MutationResult<ShowHideResourceCopyConfigLinkMutation>
export type ShowHideResourceCopyConfigLinkMutationOptions =
  Apollo.BaseMutationOptions<
    ShowHideResourceCopyConfigLinkMutation,
    ShowHideResourceCopyConfigLinkMutationVariables
  >
export const LicenseOfferingDocument = gql`
  query LicenseOffering($id: Int!, $school_id: Int!) {
    context(school_id: $school_id) {
      school {
        ...School
        license_offering(id: $id) {
          ...LicenseOffering
          resource {
            ...Resource
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${LicenseOfferingFragmentDoc}
  ${ResourceFragmentDoc}
`

/**
 * __useLicenseOfferingQuery__
 *
 * To run a query within a React component, call `useLicenseOfferingQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicenseOfferingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicenseOfferingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      school_id: // value for 'school_id'
 *   },
 * });
 */
export function useLicenseOfferingQuery(
  baseOptions: Apollo.QueryHookOptions<
    LicenseOfferingQuery,
    LicenseOfferingQueryVariables
  > &
    (
      | { variables: LicenseOfferingQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<LicenseOfferingQuery, LicenseOfferingQueryVariables>(
    LicenseOfferingDocument,
    options
  )
}
export function useLicenseOfferingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LicenseOfferingQuery,
    LicenseOfferingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    LicenseOfferingQuery,
    LicenseOfferingQueryVariables
  >(LicenseOfferingDocument, options)
}
export function useLicenseOfferingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        LicenseOfferingQuery,
        LicenseOfferingQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    LicenseOfferingQuery,
    LicenseOfferingQueryVariables
  >(LicenseOfferingDocument, options)
}
export type LicenseOfferingQueryHookResult = ReturnType<
  typeof useLicenseOfferingQuery
>
export type LicenseOfferingLazyQueryHookResult = ReturnType<
  typeof useLicenseOfferingLazyQuery
>
export type LicenseOfferingSuspenseQueryHookResult = ReturnType<
  typeof useLicenseOfferingSuspenseQuery
>
export type LicenseOfferingQueryResult = Apollo.QueryResult<
  LicenseOfferingQuery,
  LicenseOfferingQueryVariables
>
export const LicenseResourceDocument = gql`
  mutation LicenseResource(
    $resource_id: Int!
    $license_offering_id: Int!
    $licensee_school_id: Int
    $use_group_subscription_id: Int
    $name: String
    $seat_count: Int
    $role: LicenseRoleEnum
    $payment_token: String
    $coupon_code: String
  ) {
    licenseResource(
      resource_id: $resource_id
      license_offering_id: $license_offering_id
      licensee_school_id: $licensee_school_id
      use_group_subscription_id: $use_group_subscription_id
      name: $name
      seat_count: $seat_count
      role: $role
      payment_token: $payment_token
      coupon_code: $coupon_code
    ) {
      ...ResourceLicense
    }
  }
  ${ResourceLicenseFragmentDoc}
`
export type LicenseResourceMutationFn = Apollo.MutationFunction<
  LicenseResourceMutation,
  LicenseResourceMutationVariables
>

/**
 * __useLicenseResourceMutation__
 *
 * To run a mutation, you first call `useLicenseResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLicenseResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [licenseResourceMutation, { data, loading, error }] = useLicenseResourceMutation({
 *   variables: {
 *      resource_id: // value for 'resource_id'
 *      license_offering_id: // value for 'license_offering_id'
 *      licensee_school_id: // value for 'licensee_school_id'
 *      use_group_subscription_id: // value for 'use_group_subscription_id'
 *      name: // value for 'name'
 *      seat_count: // value for 'seat_count'
 *      role: // value for 'role'
 *      payment_token: // value for 'payment_token'
 *      coupon_code: // value for 'coupon_code'
 *   },
 * });
 */
export function useLicenseResourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LicenseResourceMutation,
    LicenseResourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    LicenseResourceMutation,
    LicenseResourceMutationVariables
  >(LicenseResourceDocument, options)
}
export type LicenseResourceMutationHookResult = ReturnType<
  typeof useLicenseResourceMutation
>
export type LicenseResourceMutationResult =
  Apollo.MutationResult<LicenseResourceMutation>
export type LicenseResourceMutationOptions = Apollo.BaseMutationOptions<
  LicenseResourceMutation,
  LicenseResourceMutationVariables
>
export const ResourceLicenseDocument = gql`
  query ResourceLicense($id: Int) {
    resource_license(id: $id) {
      ...ResourceLicense
    }
  }
  ${ResourceLicenseFragmentDoc}
`

/**
 * __useResourceLicenseQuery__
 *
 * To run a query within a React component, call `useResourceLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceLicenseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResourceLicenseQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ResourceLicenseQuery,
    ResourceLicenseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ResourceLicenseQuery, ResourceLicenseQueryVariables>(
    ResourceLicenseDocument,
    options
  )
}
export function useResourceLicenseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceLicenseQuery,
    ResourceLicenseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceLicenseQuery,
    ResourceLicenseQueryVariables
  >(ResourceLicenseDocument, options)
}
export function useResourceLicenseSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceLicenseQuery,
        ResourceLicenseQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceLicenseQuery,
    ResourceLicenseQueryVariables
  >(ResourceLicenseDocument, options)
}
export type ResourceLicenseQueryHookResult = ReturnType<
  typeof useResourceLicenseQuery
>
export type ResourceLicenseLazyQueryHookResult = ReturnType<
  typeof useResourceLicenseLazyQuery
>
export type ResourceLicenseSuspenseQueryHookResult = ReturnType<
  typeof useResourceLicenseSuspenseQuery
>
export type ResourceLicenseQueryResult = Apollo.QueryResult<
  ResourceLicenseQuery,
  ResourceLicenseQueryVariables
>
export const ScopedResourceLicenseDocument = gql`
  query ScopedResourceLicense($schoolId: Int!, $resourceLicenseId: Int!) {
    context(school_id: $schoolId) {
      school {
        id
        resource_license(id: $resourceLicenseId) {
          ...ResourceLicense
        }
      }
    }
  }
  ${ResourceLicenseFragmentDoc}
`

/**
 * __useScopedResourceLicenseQuery__
 *
 * To run a query within a React component, call `useScopedResourceLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useScopedResourceLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScopedResourceLicenseQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      resourceLicenseId: // value for 'resourceLicenseId'
 *   },
 * });
 */
export function useScopedResourceLicenseQuery(
  baseOptions: Apollo.QueryHookOptions<
    ScopedResourceLicenseQuery,
    ScopedResourceLicenseQueryVariables
  > &
    (
      | { variables: ScopedResourceLicenseQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ScopedResourceLicenseQuery,
    ScopedResourceLicenseQueryVariables
  >(ScopedResourceLicenseDocument, options)
}
export function useScopedResourceLicenseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ScopedResourceLicenseQuery,
    ScopedResourceLicenseQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ScopedResourceLicenseQuery,
    ScopedResourceLicenseQueryVariables
  >(ScopedResourceLicenseDocument, options)
}
export function useScopedResourceLicenseSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ScopedResourceLicenseQuery,
        ScopedResourceLicenseQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ScopedResourceLicenseQuery,
    ScopedResourceLicenseQueryVariables
  >(ScopedResourceLicenseDocument, options)
}
export type ScopedResourceLicenseQueryHookResult = ReturnType<
  typeof useScopedResourceLicenseQuery
>
export type ScopedResourceLicenseLazyQueryHookResult = ReturnType<
  typeof useScopedResourceLicenseLazyQuery
>
export type ScopedResourceLicenseSuspenseQueryHookResult = ReturnType<
  typeof useScopedResourceLicenseSuspenseQuery
>
export type ScopedResourceLicenseQueryResult = Apollo.QueryResult<
  ScopedResourceLicenseQuery,
  ScopedResourceLicenseQueryVariables
>
export const CopyResourceDocument = gql`
  mutation CopyResource(
    $id: Int!
    $to_school: Int
    $create_offering: Boolean
    $create_registration_with_role: RegistrationRoleEnum
  ) {
    copyResource(
      id: $id
      to_school: $to_school
      create_offering: $create_offering
      create_registration_with_role: $create_registration_with_role
    ) {
      ...Resource
    }
  }
  ${ResourceFragmentDoc}
`
export type CopyResourceMutationFn = Apollo.MutationFunction<
  CopyResourceMutation,
  CopyResourceMutationVariables
>

/**
 * __useCopyResourceMutation__
 *
 * To run a mutation, you first call `useCopyResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyResourceMutation, { data, loading, error }] = useCopyResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      to_school: // value for 'to_school'
 *      create_offering: // value for 'create_offering'
 *      create_registration_with_role: // value for 'create_registration_with_role'
 *   },
 * });
 */
export function useCopyResourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CopyResourceMutation,
    CopyResourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CopyResourceMutation,
    CopyResourceMutationVariables
  >(CopyResourceDocument, options)
}
export type CopyResourceMutationHookResult = ReturnType<
  typeof useCopyResourceMutation
>
export type CopyResourceMutationResult =
  Apollo.MutationResult<CopyResourceMutation>
export type CopyResourceMutationOptions = Apollo.BaseMutationOptions<
  CopyResourceMutation,
  CopyResourceMutationVariables
>
export const ManageResourceDocument = gql`
  query ManageResource($id: Int) {
    resource(id: $id) {
      ...ManageResource
    }
  }
  ${ManageResourceFragmentDoc}
`

/**
 * __useManageResourceQuery__
 *
 * To run a query within a React component, call `useManageResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useManageResourceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ManageResourceQuery,
    ManageResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ManageResourceQuery, ManageResourceQueryVariables>(
    ManageResourceDocument,
    options
  )
}
export function useManageResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ManageResourceQuery,
    ManageResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ManageResourceQuery, ManageResourceQueryVariables>(
    ManageResourceDocument,
    options
  )
}
export function useManageResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ManageResourceQuery,
        ManageResourceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ManageResourceQuery,
    ManageResourceQueryVariables
  >(ManageResourceDocument, options)
}
export type ManageResourceQueryHookResult = ReturnType<
  typeof useManageResourceQuery
>
export type ManageResourceLazyQueryHookResult = ReturnType<
  typeof useManageResourceLazyQuery
>
export type ManageResourceSuspenseQueryHookResult = ReturnType<
  typeof useManageResourceSuspenseQuery
>
export type ManageResourceQueryResult = Apollo.QueryResult<
  ManageResourceQuery,
  ManageResourceQueryVariables
>
export const ResourceEditorsDocument = gql`
  query ResourceEditors($id: Int, $cursor: String) {
    resource(id: $id) {
      ...Resource
      registration_meta {
        editor_registration_count
      }
      group(type: curriculum) {
        id
        registrations(first: 10, role_filter: { eq: editor }, after: $cursor) {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              id
              role
              softArchivedTime
              user {
                ...User
              }
            }
          }
        }
      }
    }
  }
  ${ResourceFragmentDoc}
  ${UserFragmentDoc}
`

/**
 * __useResourceEditorsQuery__
 *
 * To run a query within a React component, call `useResourceEditorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceEditorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceEditorsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useResourceEditorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ResourceEditorsQuery,
    ResourceEditorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ResourceEditorsQuery, ResourceEditorsQueryVariables>(
    ResourceEditorsDocument,
    options
  )
}
export function useResourceEditorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceEditorsQuery,
    ResourceEditorsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceEditorsQuery,
    ResourceEditorsQueryVariables
  >(ResourceEditorsDocument, options)
}
export function useResourceEditorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceEditorsQuery,
        ResourceEditorsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceEditorsQuery,
    ResourceEditorsQueryVariables
  >(ResourceEditorsDocument, options)
}
export type ResourceEditorsQueryHookResult = ReturnType<
  typeof useResourceEditorsQuery
>
export type ResourceEditorsLazyQueryHookResult = ReturnType<
  typeof useResourceEditorsLazyQuery
>
export type ResourceEditorsSuspenseQueryHookResult = ReturnType<
  typeof useResourceEditorsSuspenseQuery
>
export type ResourceEditorsQueryResult = Apollo.QueryResult<
  ResourceEditorsQuery,
  ResourceEditorsQueryVariables
>
export const UpdateResourceAdvancedDocument = gql`
  mutation UpdateResourceAdvanced(
    $id: Int!
    $name: String!
    $resource_type: ResourceType!
    $trailer_embed_code: String
    $visibility_level_override: Int
    $certificate_generator_class: String
    $discussion_enabled: Boolean
  ) {
    updateResource(
      id: $id
      name: $name
      resource_type: $resource_type
      trailer_embed_code: $trailer_embed_code
      visibility_level_override: $visibility_level_override
      certificate_generator_class: $certificate_generator_class
      discussion_enabled: $discussion_enabled
    ) {
      ...ManageResource
    }
  }
  ${ManageResourceFragmentDoc}
`
export type UpdateResourceAdvancedMutationFn = Apollo.MutationFunction<
  UpdateResourceAdvancedMutation,
  UpdateResourceAdvancedMutationVariables
>

/**
 * __useUpdateResourceAdvancedMutation__
 *
 * To run a mutation, you first call `useUpdateResourceAdvancedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceAdvancedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceAdvancedMutation, { data, loading, error }] = useUpdateResourceAdvancedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      resource_type: // value for 'resource_type'
 *      trailer_embed_code: // value for 'trailer_embed_code'
 *      visibility_level_override: // value for 'visibility_level_override'
 *      certificate_generator_class: // value for 'certificate_generator_class'
 *      discussion_enabled: // value for 'discussion_enabled'
 *   },
 * });
 */
export function useUpdateResourceAdvancedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateResourceAdvancedMutation,
    UpdateResourceAdvancedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateResourceAdvancedMutation,
    UpdateResourceAdvancedMutationVariables
  >(UpdateResourceAdvancedDocument, options)
}
export type UpdateResourceAdvancedMutationHookResult = ReturnType<
  typeof useUpdateResourceAdvancedMutation
>
export type UpdateResourceAdvancedMutationResult =
  Apollo.MutationResult<UpdateResourceAdvancedMutation>
export type UpdateResourceAdvancedMutationOptions = Apollo.BaseMutationOptions<
  UpdateResourceAdvancedMutation,
  UpdateResourceAdvancedMutationVariables
>
export const UpdateResourceDetailsDocument = gql`
  mutation UpdateResourceDetails(
    $id: Int!
    $name: String!
    $resource_type: ResourceType!
    $description: String
    $short_description: String
    $trailer_embed_code: String
    $authors: [Int]
    $categories: [Int]
    $visibility_level_override: Int
    $cover_image: String
  ) {
    updateResource(
      id: $id
      name: $name
      resource_type: $resource_type
      description: $description
      short_description: $short_description
      trailer_embed_code: $trailer_embed_code
      authors: $authors
      categories: $categories
      visibility_level_override: $visibility_level_override
      cover_image: $cover_image
    ) {
      ...ManageResource
    }
  }
  ${ManageResourceFragmentDoc}
`
export type UpdateResourceDetailsMutationFn = Apollo.MutationFunction<
  UpdateResourceDetailsMutation,
  UpdateResourceDetailsMutationVariables
>

/**
 * __useUpdateResourceDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateResourceDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceDetailsMutation, { data, loading, error }] = useUpdateResourceDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      resource_type: // value for 'resource_type'
 *      description: // value for 'description'
 *      short_description: // value for 'short_description'
 *      trailer_embed_code: // value for 'trailer_embed_code'
 *      authors: // value for 'authors'
 *      categories: // value for 'categories'
 *      visibility_level_override: // value for 'visibility_level_override'
 *      cover_image: // value for 'cover_image'
 *   },
 * });
 */
export function useUpdateResourceDetailsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateResourceDetailsMutation,
    UpdateResourceDetailsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateResourceDetailsMutation,
    UpdateResourceDetailsMutationVariables
  >(UpdateResourceDetailsDocument, options)
}
export type UpdateResourceDetailsMutationHookResult = ReturnType<
  typeof useUpdateResourceDetailsMutation
>
export type UpdateResourceDetailsMutationResult =
  Apollo.MutationResult<UpdateResourceDetailsMutation>
export type UpdateResourceDetailsMutationOptions = Apollo.BaseMutationOptions<
  UpdateResourceDetailsMutation,
  UpdateResourceDetailsMutationVariables
>
export const UpdateResourceMenuDocument = gql`
  mutation UpdateResourceMenu(
    $id: Int!
    $name: String!
    $resource_type: ResourceType!
    $cover_image: String
  ) {
    updateResource(
      id: $id
      name: $name
      resource_type: $resource_type
      cover_image: $cover_image
    ) {
      ...ManageResource
    }
  }
  ${ManageResourceFragmentDoc}
`
export type UpdateResourceMenuMutationFn = Apollo.MutationFunction<
  UpdateResourceMenuMutation,
  UpdateResourceMenuMutationVariables
>

/**
 * __useUpdateResourceMenuMutation__
 *
 * To run a mutation, you first call `useUpdateResourceMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceMenuMutation, { data, loading, error }] = useUpdateResourceMenuMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      resource_type: // value for 'resource_type'
 *      cover_image: // value for 'cover_image'
 *   },
 * });
 */
export function useUpdateResourceMenuMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateResourceMenuMutation,
    UpdateResourceMenuMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateResourceMenuMutation,
    UpdateResourceMenuMutationVariables
  >(UpdateResourceMenuDocument, options)
}
export type UpdateResourceMenuMutationHookResult = ReturnType<
  typeof useUpdateResourceMenuMutation
>
export type UpdateResourceMenuMutationResult =
  Apollo.MutationResult<UpdateResourceMenuMutation>
export type UpdateResourceMenuMutationOptions = Apollo.BaseMutationOptions<
  UpdateResourceMenuMutation,
  UpdateResourceMenuMutationVariables
>
export const UpdateResourceDocument = gql`
  mutation UpdateResource(
    $id: Int!
    $name: String!
    $resource_type: ResourceType!
    $cover_image: String
    $description: String
    $short_description: String
    $authors: [Int]
    $categories: [Int]
    $trailer_embed_code: String
    $visibility_level_override: Int
    $certificate_generator_class: String
    $discussion_enabled: Boolean
    $certificateJSON: JSON
  ) {
    updateResource(
      id: $id
      name: $name
      resource_type: $resource_type
      cover_image: $cover_image
      description: $description
      short_description: $short_description
      authors: $authors
      categories: $categories
      trailer_embed_code: $trailer_embed_code
      visibility_level_override: $visibility_level_override
      certificate_generator_class: $certificate_generator_class
      discussion_enabled: $discussion_enabled
      certificate_json: $certificateJSON
    ) {
      ...ManageResource
    }
  }
  ${ManageResourceFragmentDoc}
`
export type UpdateResourceMutationFn = Apollo.MutationFunction<
  UpdateResourceMutation,
  UpdateResourceMutationVariables
>

/**
 * __useUpdateResourceMutation__
 *
 * To run a mutation, you first call `useUpdateResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResourceMutation, { data, loading, error }] = useUpdateResourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      resource_type: // value for 'resource_type'
 *      cover_image: // value for 'cover_image'
 *      description: // value for 'description'
 *      short_description: // value for 'short_description'
 *      authors: // value for 'authors'
 *      categories: // value for 'categories'
 *      trailer_embed_code: // value for 'trailer_embed_code'
 *      visibility_level_override: // value for 'visibility_level_override'
 *      certificate_generator_class: // value for 'certificate_generator_class'
 *      discussion_enabled: // value for 'discussion_enabled'
 *      certificateJSON: // value for 'certificateJSON'
 *   },
 * });
 */
export function useUpdateResourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateResourceMutation,
    UpdateResourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateResourceMutation,
    UpdateResourceMutationVariables
  >(UpdateResourceDocument, options)
}
export type UpdateResourceMutationHookResult = ReturnType<
  typeof useUpdateResourceMutation
>
export type UpdateResourceMutationResult =
  Apollo.MutationResult<UpdateResourceMutation>
export type UpdateResourceMutationOptions = Apollo.BaseMutationOptions<
  UpdateResourceMutation,
  UpdateResourceMutationVariables
>
export const CurriculumSubscriptionPlansDocument = gql`
  query CurriculumSubscriptionPlans(
    $visibilityCode: String
    $visibilityCodeFilter: StringFilter
  ) {
    school {
      id
      curriculum_plans(
        first: 50
        visibility_code: $visibilityCode
        visibility_code_filter: $visibilityCodeFilter
      ) {
        edges {
          node {
            ...SchoolCurriculumPlan
          }
        }
      }
    }
  }
  ${SchoolCurriculumPlanFragmentDoc}
`

/**
 * __useCurriculumSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useCurriculumSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurriculumSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurriculumSubscriptionPlansQuery({
 *   variables: {
 *      visibilityCode: // value for 'visibilityCode'
 *      visibilityCodeFilter: // value for 'visibilityCodeFilter'
 *   },
 * });
 */
export function useCurriculumSubscriptionPlansQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CurriculumSubscriptionPlansQuery,
    CurriculumSubscriptionPlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CurriculumSubscriptionPlansQuery,
    CurriculumSubscriptionPlansQueryVariables
  >(CurriculumSubscriptionPlansDocument, options)
}
export function useCurriculumSubscriptionPlansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurriculumSubscriptionPlansQuery,
    CurriculumSubscriptionPlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CurriculumSubscriptionPlansQuery,
    CurriculumSubscriptionPlansQueryVariables
  >(CurriculumSubscriptionPlansDocument, options)
}
export function useCurriculumSubscriptionPlansSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurriculumSubscriptionPlansQuery,
        CurriculumSubscriptionPlansQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CurriculumSubscriptionPlansQuery,
    CurriculumSubscriptionPlansQueryVariables
  >(CurriculumSubscriptionPlansDocument, options)
}
export type CurriculumSubscriptionPlansQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionPlansQuery
>
export type CurriculumSubscriptionPlansLazyQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionPlansLazyQuery
>
export type CurriculumSubscriptionPlansSuspenseQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionPlansSuspenseQuery
>
export type CurriculumSubscriptionPlansQueryResult = Apollo.QueryResult<
  CurriculumSubscriptionPlansQuery,
  CurriculumSubscriptionPlansQueryVariables
>
export const CurriculumSubscriptionDocument = gql`
  query CurriculumSubscription(
    $schoolId: Int!
    $curriculumSubscriptionId: Int!
  ) {
    context(school_id: $schoolId) {
      school {
        curriculum_subscription(id: $curriculumSubscriptionId) {
          ...CurriculumSubscription
        }
      }
    }
  }
  ${CurriculumSubscriptionFragmentDoc}
`

/**
 * __useCurriculumSubscriptionQuery__
 *
 * To run a query within a React component, call `useCurriculumSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurriculumSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurriculumSubscriptionQuery({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      curriculumSubscriptionId: // value for 'curriculumSubscriptionId'
 *   },
 * });
 */
export function useCurriculumSubscriptionQuery(
  baseOptions: Apollo.QueryHookOptions<
    CurriculumSubscriptionQuery,
    CurriculumSubscriptionQueryVariables
  > &
    (
      | { variables: CurriculumSubscriptionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CurriculumSubscriptionQuery,
    CurriculumSubscriptionQueryVariables
  >(CurriculumSubscriptionDocument, options)
}
export function useCurriculumSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurriculumSubscriptionQuery,
    CurriculumSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CurriculumSubscriptionQuery,
    CurriculumSubscriptionQueryVariables
  >(CurriculumSubscriptionDocument, options)
}
export function useCurriculumSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurriculumSubscriptionQuery,
        CurriculumSubscriptionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CurriculumSubscriptionQuery,
    CurriculumSubscriptionQueryVariables
  >(CurriculumSubscriptionDocument, options)
}
export type CurriculumSubscriptionQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionQuery
>
export type CurriculumSubscriptionLazyQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionLazyQuery
>
export type CurriculumSubscriptionSuspenseQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionSuspenseQuery
>
export type CurriculumSubscriptionQueryResult = Apollo.QueryResult<
  CurriculumSubscriptionQuery,
  CurriculumSubscriptionQueryVariables
>
export const CurriculumSubscriptionsDocument = gql`
  query CurriculumSubscriptions {
    school {
      ...School
      curriculum_subscriptions(first: 50) {
        edges {
          node {
            ...CurriculumSubscription
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${CurriculumSubscriptionFragmentDoc}
`

/**
 * __useCurriculumSubscriptionsQuery__
 *
 * To run a query within a React component, call `useCurriculumSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurriculumSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurriculumSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurriculumSubscriptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CurriculumSubscriptionsQuery,
    CurriculumSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    CurriculumSubscriptionsQuery,
    CurriculumSubscriptionsQueryVariables
  >(CurriculumSubscriptionsDocument, options)
}
export function useCurriculumSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurriculumSubscriptionsQuery,
    CurriculumSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    CurriculumSubscriptionsQuery,
    CurriculumSubscriptionsQueryVariables
  >(CurriculumSubscriptionsDocument, options)
}
export function useCurriculumSubscriptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CurriculumSubscriptionsQuery,
        CurriculumSubscriptionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    CurriculumSubscriptionsQuery,
    CurriculumSubscriptionsQueryVariables
  >(CurriculumSubscriptionsDocument, options)
}
export type CurriculumSubscriptionsQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionsQuery
>
export type CurriculumSubscriptionsLazyQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionsLazyQuery
>
export type CurriculumSubscriptionsSuspenseQueryHookResult = ReturnType<
  typeof useCurriculumSubscriptionsSuspenseQuery
>
export type CurriculumSubscriptionsQueryResult = Apollo.QueryResult<
  CurriculumSubscriptionsQuery,
  CurriculumSubscriptionsQueryVariables
>
export const BlurredThemeBackgroundImageDocument = gql`
  query BlurredThemeBackgroundImage(
    $url: String!
    $width: Int
    $height: Int
    $blur: Int
    $high: Int
    $blend: Int
    $balph: Int
    $fm: String
    $q: Int
    $bm: String
  ) {
    media {
      image(
        url: $url
        width: $width
        height: $height
        blur: $blur
        high: $high
        blend: $blend
        balph: $balph
        fm: $fm
        q: $q
        bm: $bm
      )
    }
  }
`

/**
 * __useBlurredThemeBackgroundImageQuery__
 *
 * To run a query within a React component, call `useBlurredThemeBackgroundImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlurredThemeBackgroundImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlurredThemeBackgroundImageQuery({
 *   variables: {
 *      url: // value for 'url'
 *      width: // value for 'width'
 *      height: // value for 'height'
 *      blur: // value for 'blur'
 *      high: // value for 'high'
 *      blend: // value for 'blend'
 *      balph: // value for 'balph'
 *      fm: // value for 'fm'
 *      q: // value for 'q'
 *      bm: // value for 'bm'
 *   },
 * });
 */
export function useBlurredThemeBackgroundImageQuery(
  baseOptions: Apollo.QueryHookOptions<
    BlurredThemeBackgroundImageQuery,
    BlurredThemeBackgroundImageQueryVariables
  > &
    (
      | { variables: BlurredThemeBackgroundImageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BlurredThemeBackgroundImageQuery,
    BlurredThemeBackgroundImageQueryVariables
  >(BlurredThemeBackgroundImageDocument, options)
}
export function useBlurredThemeBackgroundImageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BlurredThemeBackgroundImageQuery,
    BlurredThemeBackgroundImageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BlurredThemeBackgroundImageQuery,
    BlurredThemeBackgroundImageQueryVariables
  >(BlurredThemeBackgroundImageDocument, options)
}
export function useBlurredThemeBackgroundImageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BlurredThemeBackgroundImageQuery,
        BlurredThemeBackgroundImageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BlurredThemeBackgroundImageQuery,
    BlurredThemeBackgroundImageQueryVariables
  >(BlurredThemeBackgroundImageDocument, options)
}
export type BlurredThemeBackgroundImageQueryHookResult = ReturnType<
  typeof useBlurredThemeBackgroundImageQuery
>
export type BlurredThemeBackgroundImageLazyQueryHookResult = ReturnType<
  typeof useBlurredThemeBackgroundImageLazyQuery
>
export type BlurredThemeBackgroundImageSuspenseQueryHookResult = ReturnType<
  typeof useBlurredThemeBackgroundImageSuspenseQuery
>
export type BlurredThemeBackgroundImageQueryResult = Apollo.QueryResult<
  BlurredThemeBackgroundImageQuery,
  BlurredThemeBackgroundImageQueryVariables
>
export const CreateSpaceDocument = gql`
  mutation CreateSpace(
    $name: String!
    $subdomain: String!
    $copy: [String]
    $utm_source: String
    $utm_medium: String
    $utm_campaign: String
    $theme: ThemeInput
  ) {
    createSchool(
      name: $name
      subdomain: $subdomain
      copy: $copy
      utm_source: $utm_source
      utm_medium: $utm_medium
      utm_campaign: $utm_campaign
      theme: $theme
    ) {
      ...CreatedSpace
    }
  }
  ${CreatedSpaceFragmentDoc}
`
export type CreateSpaceMutationFn = Apollo.MutationFunction<
  CreateSpaceMutation,
  CreateSpaceMutationVariables
>

/**
 * __useCreateSpaceMutation__
 *
 * To run a mutation, you first call `useCreateSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSpaceMutation, { data, loading, error }] = useCreateSpaceMutation({
 *   variables: {
 *      name: // value for 'name'
 *      subdomain: // value for 'subdomain'
 *      copy: // value for 'copy'
 *      utm_source: // value for 'utm_source'
 *      utm_medium: // value for 'utm_medium'
 *      utm_campaign: // value for 'utm_campaign'
 *      theme: // value for 'theme'
 *   },
 * });
 */
export function useCreateSpaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSpaceMutation,
    CreateSpaceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateSpaceMutation, CreateSpaceMutationVariables>(
    CreateSpaceDocument,
    options
  )
}
export type CreateSpaceMutationHookResult = ReturnType<
  typeof useCreateSpaceMutation
>
export type CreateSpaceMutationResult =
  Apollo.MutationResult<CreateSpaceMutation>
export type CreateSpaceMutationOptions = Apollo.BaseMutationOptions<
  CreateSpaceMutation,
  CreateSpaceMutationVariables
>
export const SpaceBillingPlanSetDocument = gql`
  query SpaceBillingPlanSet {
    account {
      id
      billing_plan_set {
        id
        name
        is_default
        plans {
          ...SpaceBillingPlanSetPlan
        }
      }
    }
  }
  ${SpaceBillingPlanSetPlanFragmentDoc}
`

/**
 * __useSpaceBillingPlanSetQuery__
 *
 * To run a query within a React component, call `useSpaceBillingPlanSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpaceBillingPlanSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceBillingPlanSetQuery({
 *   variables: {
 *   },
 * });
 */
export function useSpaceBillingPlanSetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SpaceBillingPlanSetQuery,
    SpaceBillingPlanSetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SpaceBillingPlanSetQuery,
    SpaceBillingPlanSetQueryVariables
  >(SpaceBillingPlanSetDocument, options)
}
export function useSpaceBillingPlanSetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SpaceBillingPlanSetQuery,
    SpaceBillingPlanSetQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SpaceBillingPlanSetQuery,
    SpaceBillingPlanSetQueryVariables
  >(SpaceBillingPlanSetDocument, options)
}
export function useSpaceBillingPlanSetSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SpaceBillingPlanSetQuery,
        SpaceBillingPlanSetQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SpaceBillingPlanSetQuery,
    SpaceBillingPlanSetQueryVariables
  >(SpaceBillingPlanSetDocument, options)
}
export type SpaceBillingPlanSetQueryHookResult = ReturnType<
  typeof useSpaceBillingPlanSetQuery
>
export type SpaceBillingPlanSetLazyQueryHookResult = ReturnType<
  typeof useSpaceBillingPlanSetLazyQuery
>
export type SpaceBillingPlanSetSuspenseQueryHookResult = ReturnType<
  typeof useSpaceBillingPlanSetSuspenseQuery
>
export type SpaceBillingPlanSetQueryResult = Apollo.QueryResult<
  SpaceBillingPlanSetQuery,
  SpaceBillingPlanSetQueryVariables
>
export const SpaceSsoLinkDocument = gql`
  query SpaceSSOLink($spaceId: Int!, $pathname: String!) {
    context(school_id: $spaceId) {
      school {
        id
        url(pathname: $pathname)
        sso_link(pathname: $pathname)
      }
    }
  }
`

/**
 * __useSpaceSsoLinkQuery__
 *
 * To run a query within a React component, call `useSpaceSsoLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpaceSsoLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpaceSsoLinkQuery({
 *   variables: {
 *      spaceId: // value for 'spaceId'
 *      pathname: // value for 'pathname'
 *   },
 * });
 */
export function useSpaceSsoLinkQuery(
  baseOptions: Apollo.QueryHookOptions<
    SpaceSsoLinkQuery,
    SpaceSsoLinkQueryVariables
  > &
    (
      | { variables: SpaceSsoLinkQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SpaceSsoLinkQuery, SpaceSsoLinkQueryVariables>(
    SpaceSsoLinkDocument,
    options
  )
}
export function useSpaceSsoLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SpaceSsoLinkQuery,
    SpaceSsoLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SpaceSsoLinkQuery, SpaceSsoLinkQueryVariables>(
    SpaceSsoLinkDocument,
    options
  )
}
export function useSpaceSsoLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SpaceSsoLinkQuery,
        SpaceSsoLinkQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SpaceSsoLinkQuery, SpaceSsoLinkQueryVariables>(
    SpaceSsoLinkDocument,
    options
  )
}
export type SpaceSsoLinkQueryHookResult = ReturnType<
  typeof useSpaceSsoLinkQuery
>
export type SpaceSsoLinkLazyQueryHookResult = ReturnType<
  typeof useSpaceSsoLinkLazyQuery
>
export type SpaceSsoLinkSuspenseQueryHookResult = ReturnType<
  typeof useSpaceSsoLinkSuspenseQuery
>
export type SpaceSsoLinkQueryResult = Apollo.QueryResult<
  SpaceSsoLinkQuery,
  SpaceSsoLinkQueryVariables
>
export const SubdomainDocument = gql`
  query Subdomain($subdomain: String) {
    subdomain(subdomain: $subdomain) {
      id
      subdomain
    }
  }
`

/**
 * __useSubdomainQuery__
 *
 * To run a query within a React component, call `useSubdomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubdomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubdomainQuery({
 *   variables: {
 *      subdomain: // value for 'subdomain'
 *   },
 * });
 */
export function useSubdomainQuery(
  baseOptions?: Apollo.QueryHookOptions<SubdomainQuery, SubdomainQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SubdomainQuery, SubdomainQueryVariables>(
    SubdomainDocument,
    options
  )
}
export function useSubdomainLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubdomainQuery,
    SubdomainQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SubdomainQuery, SubdomainQueryVariables>(
    SubdomainDocument,
    options
  )
}
export function useSubdomainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<SubdomainQuery, SubdomainQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SubdomainQuery, SubdomainQueryVariables>(
    SubdomainDocument,
    options
  )
}
export type SubdomainQueryHookResult = ReturnType<typeof useSubdomainQuery>
export type SubdomainLazyQueryHookResult = ReturnType<
  typeof useSubdomainLazyQuery
>
export type SubdomainSuspenseQueryHookResult = ReturnType<
  typeof useSubdomainSuspenseQuery
>
export type SubdomainQueryResult = Apollo.QueryResult<
  SubdomainQuery,
  SubdomainQueryVariables
>
export const UpdateSpaceProfileDocument = gql`
  mutation UpdateSpaceProfile(
    $id: Int!
    $school_type: SchoolType
    $plan_to_sell: Boolean
  ) {
    updateSchoolProfile(
      id: $id
      school_type: $school_type
      plan_to_sell: $plan_to_sell
    ) {
      id
      school_type
      plan_to_sell
    }
  }
`
export type UpdateSpaceProfileMutationFn = Apollo.MutationFunction<
  UpdateSpaceProfileMutation,
  UpdateSpaceProfileMutationVariables
>

/**
 * __useUpdateSpaceProfileMutation__
 *
 * To run a mutation, you first call `useUpdateSpaceProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpaceProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpaceProfileMutation, { data, loading, error }] = useUpdateSpaceProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      school_type: // value for 'school_type'
 *      plan_to_sell: // value for 'plan_to_sell'
 *   },
 * });
 */
export function useUpdateSpaceProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSpaceProfileMutation,
    UpdateSpaceProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateSpaceProfileMutation,
    UpdateSpaceProfileMutationVariables
  >(UpdateSpaceProfileDocument, options)
}
export type UpdateSpaceProfileMutationHookResult = ReturnType<
  typeof useUpdateSpaceProfileMutation
>
export type UpdateSpaceProfileMutationResult =
  Apollo.MutationResult<UpdateSpaceProfileMutation>
export type UpdateSpaceProfileMutationOptions = Apollo.BaseMutationOptions<
  UpdateSpaceProfileMutation,
  UpdateSpaceProfileMutationVariables
>
export const UserCreatedSpaceMembershipsDocument = gql`
  query UserCreatedSpaceMemberships {
    me {
      id
      memberships(first: 1, role_filter: { eq: administrator }, global: true) {
        edges {
          node {
            id
            school {
              subdomain
              ...CreatedSpace
            }
          }
        }
      }
    }
  }
  ${CreatedSpaceFragmentDoc}
`

/**
 * __useUserCreatedSpaceMembershipsQuery__
 *
 * To run a query within a React component, call `useUserCreatedSpaceMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCreatedSpaceMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCreatedSpaceMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserCreatedSpaceMembershipsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserCreatedSpaceMembershipsQuery,
    UserCreatedSpaceMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserCreatedSpaceMembershipsQuery,
    UserCreatedSpaceMembershipsQueryVariables
  >(UserCreatedSpaceMembershipsDocument, options)
}
export function useUserCreatedSpaceMembershipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserCreatedSpaceMembershipsQuery,
    UserCreatedSpaceMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserCreatedSpaceMembershipsQuery,
    UserCreatedSpaceMembershipsQueryVariables
  >(UserCreatedSpaceMembershipsDocument, options)
}
export function useUserCreatedSpaceMembershipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserCreatedSpaceMembershipsQuery,
        UserCreatedSpaceMembershipsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserCreatedSpaceMembershipsQuery,
    UserCreatedSpaceMembershipsQueryVariables
  >(UserCreatedSpaceMembershipsDocument, options)
}
export type UserCreatedSpaceMembershipsQueryHookResult = ReturnType<
  typeof useUserCreatedSpaceMembershipsQuery
>
export type UserCreatedSpaceMembershipsLazyQueryHookResult = ReturnType<
  typeof useUserCreatedSpaceMembershipsLazyQuery
>
export type UserCreatedSpaceMembershipsSuspenseQueryHookResult = ReturnType<
  typeof useUserCreatedSpaceMembershipsSuspenseQuery
>
export type UserCreatedSpaceMembershipsQueryResult = Apollo.QueryResult<
  UserCreatedSpaceMembershipsQuery,
  UserCreatedSpaceMembershipsQueryVariables
>
export const UserSpaceMembershipsDocument = gql`
  query UserSpaceMemberships {
    me {
      id
      memberships(first: 1042, global: true) {
        edges {
          node {
            ...UserSpaceMembership
          }
        }
      }
    }
  }
  ${UserSpaceMembershipFragmentDoc}
`

/**
 * __useUserSpaceMembershipsQuery__
 *
 * To run a query within a React component, call `useUserSpaceMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSpaceMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSpaceMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSpaceMembershipsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserSpaceMembershipsQuery,
    UserSpaceMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserSpaceMembershipsQuery,
    UserSpaceMembershipsQueryVariables
  >(UserSpaceMembershipsDocument, options)
}
export function useUserSpaceMembershipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserSpaceMembershipsQuery,
    UserSpaceMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserSpaceMembershipsQuery,
    UserSpaceMembershipsQueryVariables
  >(UserSpaceMembershipsDocument, options)
}
export function useUserSpaceMembershipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserSpaceMembershipsQuery,
        UserSpaceMembershipsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserSpaceMembershipsQuery,
    UserSpaceMembershipsQueryVariables
  >(UserSpaceMembershipsDocument, options)
}
export type UserSpaceMembershipsQueryHookResult = ReturnType<
  typeof useUserSpaceMembershipsQuery
>
export type UserSpaceMembershipsLazyQueryHookResult = ReturnType<
  typeof useUserSpaceMembershipsLazyQuery
>
export type UserSpaceMembershipsSuspenseQueryHookResult = ReturnType<
  typeof useUserSpaceMembershipsSuspenseQuery
>
export type UserSpaceMembershipsQueryResult = Apollo.QueryResult<
  UserSpaceMembershipsQuery,
  UserSpaceMembershipsQueryVariables
>
export const ScheduleItemDocument = gql`
  mutation ScheduleItem(
    $schedule_context: ScheduleItemContext!
    $starts: DateTime
    $due: DateTime
    $passive_starts: Boolean
    $passive_due: Boolean
  ) {
    scheduleItem(
      schedule_context: $schedule_context
      starts: $starts
      due: $due
      passive_starts: $passive_starts
      passive_due: $passive_due
    ) {
      ...PathItem
    }
  }
  ${PathItemFragmentDoc}
`
export type ScheduleItemMutationFn = Apollo.MutationFunction<
  ScheduleItemMutation,
  ScheduleItemMutationVariables
>

/**
 * __useScheduleItemMutation__
 *
 * To run a mutation, you first call `useScheduleItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleItemMutation, { data, loading, error }] = useScheduleItemMutation({
 *   variables: {
 *      schedule_context: // value for 'schedule_context'
 *      starts: // value for 'starts'
 *      due: // value for 'due'
 *      passive_starts: // value for 'passive_starts'
 *      passive_due: // value for 'passive_due'
 *   },
 * });
 */
export function useScheduleItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ScheduleItemMutation,
    ScheduleItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ScheduleItemMutation,
    ScheduleItemMutationVariables
  >(ScheduleItemDocument, options)
}
export type ScheduleItemMutationHookResult = ReturnType<
  typeof useScheduleItemMutation
>
export type ScheduleItemMutationResult =
  Apollo.MutationResult<ScheduleItemMutation>
export type ScheduleItemMutationOptions = Apollo.BaseMutationOptions<
  ScheduleItemMutation,
  ScheduleItemMutationVariables
>
export const CreateStoreLinkDocument = gql`
  mutation CreateStoreLink($schoolId: Int!, $copy: [String]) {
    createStoreLink(school_id: $schoolId, copy: $copy) {
      id
      licensee {
        ...School
        sso_link(pathname: "/home/teach/")
      }
      store {
        ...Store
      }
    }
  }
  ${SchoolFragmentDoc}
  ${StoreFragmentDoc}
`
export type CreateStoreLinkMutationFn = Apollo.MutationFunction<
  CreateStoreLinkMutation,
  CreateStoreLinkMutationVariables
>

/**
 * __useCreateStoreLinkMutation__
 *
 * To run a mutation, you first call `useCreateStoreLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoreLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStoreLinkMutation, { data, loading, error }] = useCreateStoreLinkMutation({
 *   variables: {
 *      schoolId: // value for 'schoolId'
 *      copy: // value for 'copy'
 *   },
 * });
 */
export function useCreateStoreLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateStoreLinkMutation,
    CreateStoreLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CreateStoreLinkMutation,
    CreateStoreLinkMutationVariables
  >(CreateStoreLinkDocument, options)
}
export type CreateStoreLinkMutationHookResult = ReturnType<
  typeof useCreateStoreLinkMutation
>
export type CreateStoreLinkMutationResult =
  Apollo.MutationResult<CreateStoreLinkMutation>
export type CreateStoreLinkMutationOptions = Apollo.BaseMutationOptions<
  CreateStoreLinkMutation,
  CreateStoreLinkMutationVariables
>
export const ResourceOfferingsDocument = gql`
  query ResourceOfferings(
    $id: Int
    $cursor: String
    $school_id: Int!
    $licensee_school_id: Int!
    $licenseeIdFilter: IDFilter
    $include_school_license: Boolean!
    $skip_group_offerings: Boolean!
    $skip_license_offerings: Boolean!
    $licensing_mode: LicenseOfferingLicensingMode
  ) {
    context(school_id: $school_id) {
      school {
        ...School
        resource(id: $id) {
          id
          license_offerings(first: 50, licensing_mode: $licensing_mode)
            @skip(if: $skip_license_offerings) {
            total
            edges {
              node {
                ...LicenseOffering
                school_license(licensee_school_id: $licensee_school_id)
                  @include(if: $include_school_license) {
                  id
                }
                include_in_school_curriculum_subscriptions(
                  first: 1
                  licensee_id: $licenseeIdFilter
                ) {
                  total
                }
              }
            }
          }
          group_offerings: groups(
            first: 50
            after: $cursor
            visibility_filter: { gte: members_only }
          ) @skip(if: $skip_group_offerings) {
            total
            pageInfo {
              endCursor
              hasNextPage
            }
            edges {
              node {
                ...Group
                include_in_plans(first: 10) {
                  edges {
                    node {
                      ...SchoolSubscriptionPlan
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${LicenseOfferingFragmentDoc}
  ${GroupFragmentDoc}
  ${SchoolSubscriptionPlanFragmentDoc}
`

/**
 * __useResourceOfferingsQuery__
 *
 * To run a query within a React component, call `useResourceOfferingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceOfferingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceOfferingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      cursor: // value for 'cursor'
 *      school_id: // value for 'school_id'
 *      licensee_school_id: // value for 'licensee_school_id'
 *      licenseeIdFilter: // value for 'licenseeIdFilter'
 *      include_school_license: // value for 'include_school_license'
 *      skip_group_offerings: // value for 'skip_group_offerings'
 *      skip_license_offerings: // value for 'skip_license_offerings'
 *      licensing_mode: // value for 'licensing_mode'
 *   },
 * });
 */
export function useResourceOfferingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ResourceOfferingsQuery,
    ResourceOfferingsQueryVariables
  > &
    (
      | { variables: ResourceOfferingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ResourceOfferingsQuery,
    ResourceOfferingsQueryVariables
  >(ResourceOfferingsDocument, options)
}
export function useResourceOfferingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ResourceOfferingsQuery,
    ResourceOfferingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ResourceOfferingsQuery,
    ResourceOfferingsQueryVariables
  >(ResourceOfferingsDocument, options)
}
export function useResourceOfferingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ResourceOfferingsQuery,
        ResourceOfferingsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ResourceOfferingsQuery,
    ResourceOfferingsQueryVariables
  >(ResourceOfferingsDocument, options)
}
export type ResourceOfferingsQueryHookResult = ReturnType<
  typeof useResourceOfferingsQuery
>
export type ResourceOfferingsLazyQueryHookResult = ReturnType<
  typeof useResourceOfferingsLazyQuery
>
export type ResourceOfferingsSuspenseQueryHookResult = ReturnType<
  typeof useResourceOfferingsSuspenseQuery
>
export type ResourceOfferingsQueryResult = Apollo.QueryResult<
  ResourceOfferingsQuery,
  ResourceOfferingsQueryVariables
>
export const StoreLinkDocument = gql`
  query StoreLink {
    storeLink {
      ...StoreLink
    }
  }
  ${StoreLinkFragmentDoc}
`

/**
 * __useStoreLinkQuery__
 *
 * To run a query within a React component, call `useStoreLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoreLinkQuery(
  baseOptions?: Apollo.QueryHookOptions<StoreLinkQuery, StoreLinkQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<StoreLinkQuery, StoreLinkQueryVariables>(
    StoreLinkDocument,
    options
  )
}
export function useStoreLinkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StoreLinkQuery,
    StoreLinkQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<StoreLinkQuery, StoreLinkQueryVariables>(
    StoreLinkDocument,
    options
  )
}
export function useStoreLinkSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<StoreLinkQuery, StoreLinkQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<StoreLinkQuery, StoreLinkQueryVariables>(
    StoreLinkDocument,
    options
  )
}
export type StoreLinkQueryHookResult = ReturnType<typeof useStoreLinkQuery>
export type StoreLinkLazyQueryHookResult = ReturnType<
  typeof useStoreLinkLazyQuery
>
export type StoreLinkSuspenseQueryHookResult = ReturnType<
  typeof useStoreLinkSuspenseQuery
>
export type StoreLinkQueryResult = Apollo.QueryResult<
  StoreLinkQuery,
  StoreLinkQueryVariables
>
export const StoreLinksDocument = gql`
  query StoreLinks($licensorId: IDFilter) {
    storeLinks(first: 10, licensor_id: $licensorId) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...StoreLink
        }
      }
    }
  }
  ${StoreLinkFragmentDoc}
`

/**
 * __useStoreLinksQuery__
 *
 * To run a query within a React component, call `useStoreLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreLinksQuery({
 *   variables: {
 *      licensorId: // value for 'licensorId'
 *   },
 * });
 */
export function useStoreLinksQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StoreLinksQuery,
    StoreLinksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<StoreLinksQuery, StoreLinksQueryVariables>(
    StoreLinksDocument,
    options
  )
}
export function useStoreLinksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StoreLinksQuery,
    StoreLinksQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<StoreLinksQuery, StoreLinksQueryVariables>(
    StoreLinksDocument,
    options
  )
}
export function useStoreLinksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<StoreLinksQuery, StoreLinksQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<StoreLinksQuery, StoreLinksQueryVariables>(
    StoreLinksDocument,
    options
  )
}
export type StoreLinksQueryHookResult = ReturnType<typeof useStoreLinksQuery>
export type StoreLinksLazyQueryHookResult = ReturnType<
  typeof useStoreLinksLazyQuery
>
export type StoreLinksSuspenseQueryHookResult = ReturnType<
  typeof useStoreLinksSuspenseQuery
>
export type StoreLinksQueryResult = Apollo.QueryResult<
  StoreLinksQuery,
  StoreLinksQueryVariables
>
export const StoreDocument = gql`
  query Store {
    store {
      ...Store
    }
  }
  ${StoreFragmentDoc}
`

/**
 * __useStoreQuery__
 *
 * To run a query within a React component, call `useStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoreQuery(
  baseOptions?: Apollo.QueryHookOptions<StoreQuery, StoreQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<StoreQuery, StoreQueryVariables>(
    StoreDocument,
    options
  )
}
export function useStoreLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<StoreQuery, StoreQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<StoreQuery, StoreQueryVariables>(
    StoreDocument,
    options
  )
}
export function useStoreSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<StoreQuery, StoreQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<StoreQuery, StoreQueryVariables>(
    StoreDocument,
    options
  )
}
export type StoreQueryHookResult = ReturnType<typeof useStoreQuery>
export type StoreLazyQueryHookResult = ReturnType<typeof useStoreLazyQuery>
export type StoreSuspenseQueryHookResult = ReturnType<
  typeof useStoreSuspenseQuery
>
export type StoreQueryResult = Apollo.QueryResult<
  StoreQuery,
  StoreQueryVariables
>
export const StoreResourceDocument = gql`
  query StoreResource(
    $id: Int
    $school_id: Int!
    $include_publisher: Boolean!
    $include_school_license: Boolean!
    $include_license_offerings: Boolean!
    $licensee_school_id: Int!
    $licenseeIdFilter: IDFilter
  ) {
    context(school_id: $school_id) {
      school {
        ...School
        resource(id: $id) {
          ...Resource
          blurred_background: background_image(blur: 500, width: 250)
          school {
            ...School
          }
          publisher @include(if: $include_publisher) {
            ...Publisher
            theme {
              ...Theme
            }
          }
          registration_meta {
            editor_registration_count
          }
          trailer_embed_code
          visibility_level_override
          certificate_generator_class
          licensed_from_resource_id
          school_licenses(first: 1, licensee_school_id: $licensee_school_id)
            @include(if: $include_school_license) {
            edges {
              node {
                id
                group {
                  id
                  resource_id
                }
              }
            }
          }
          authors(first: 50) {
            total
            pageInfo {
              endCursor
              hasNextPage
            }
            edges {
              node {
                ...Author
              }
            }
          }
          categories(first: 50) {
            total
            pageInfo {
              endCursor
              hasNextPage
            }
            edges {
              node {
                ...Category
              }
            }
          }
          groups(first: 10) {
            total
            pageInfo {
              endCursor
              hasNextPage
            }
            edges {
              node {
                ...Group
                path(type: source) {
                  id
                  items(first: 1) {
                    total
                  }
                }
              }
            }
          }
          license_offerings(first: 1, licensing_mode: school_licensing)
            @include(if: $include_license_offerings) {
            total
            edges {
              node {
                ...LicenseOffering
                include_in_school_curriculum_subscriptions(
                  first: 1
                  licensee_id: $licenseeIdFilter
                ) {
                  total
                }
              }
            }
          }
          group(type: curriculum) {
            id
            path(type: source) {
              id
              items(first: 1) {
                total
              }
              previewable_steps(first: 3) {
                edges {
                  node {
                    id
                    source_id
                    name
                    assignment_type
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${ResourceFragmentDoc}
  ${PublisherFragmentDoc}
  ${ThemeFragmentDoc}
  ${AuthorFragmentDoc}
  ${CategoryFragmentDoc}
  ${GroupFragmentDoc}
  ${LicenseOfferingFragmentDoc}
`

/**
 * __useStoreResourceQuery__
 *
 * To run a query within a React component, call `useStoreResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      school_id: // value for 'school_id'
 *      include_publisher: // value for 'include_publisher'
 *      include_school_license: // value for 'include_school_license'
 *      include_license_offerings: // value for 'include_license_offerings'
 *      licensee_school_id: // value for 'licensee_school_id'
 *      licenseeIdFilter: // value for 'licenseeIdFilter'
 *   },
 * });
 */
export function useStoreResourceQuery(
  baseOptions: Apollo.QueryHookOptions<
    StoreResourceQuery,
    StoreResourceQueryVariables
  > &
    (
      | { variables: StoreResourceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<StoreResourceQuery, StoreResourceQueryVariables>(
    StoreResourceDocument,
    options
  )
}
export function useStoreResourceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StoreResourceQuery,
    StoreResourceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<StoreResourceQuery, StoreResourceQueryVariables>(
    StoreResourceDocument,
    options
  )
}
export function useStoreResourceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StoreResourceQuery,
        StoreResourceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    StoreResourceQuery,
    StoreResourceQueryVariables
  >(StoreResourceDocument, options)
}
export type StoreResourceQueryHookResult = ReturnType<
  typeof useStoreResourceQuery
>
export type StoreResourceLazyQueryHookResult = ReturnType<
  typeof useStoreResourceLazyQuery
>
export type StoreResourceSuspenseQueryHookResult = ReturnType<
  typeof useStoreResourceSuspenseQuery
>
export type StoreResourceQueryResult = Apollo.QueryResult<
  StoreResourceQuery,
  StoreResourceQueryVariables
>
export const StoreResourcesDocument = gql`
  query StoreResources(
    $cursor: String
    $first: Int!
    $role: RoleFilter
    $search: String
    $author_ids: IDFilter
    $category_ids: IDFilter
    $publisher_ids: IDFilter
    $resource_types: ResourceTypeFilter
    $visibility: ResourceVisibility
    $school_id: Int!
    $licensee_school_id: Int!
    $include_school_license: Boolean!
    $user_registered: IDFilter
  ) {
    context(school_id: $school_id) {
      school {
        ...School
        resources(
          first: $first
          after: $cursor
          role: $role
          search: $search
          visibility: $visibility
          author_ids: $author_ids
          category_ids: $category_ids
          publisher_ids: $publisher_ids
          resource_types: $resource_types
          user_registered: $user_registered
        ) {
          total
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...Resource
              curriculum: group(type: curriculum) {
                id
              }
              publisher {
                ...Publisher
              }
              authors(first: 2) {
                total
                edges {
                  node {
                    ...Author
                  }
                }
              }
              school_licenses(
                first: 1
                licensee_school_id: $licensee_school_id
              ) @include(if: $include_school_license) {
                edges {
                  node {
                    id
                  }
                }
              }
              license_offerings(first: 1, licensing_mode: school_licensing) {
                total
              }
            }
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${ResourceFragmentDoc}
  ${PublisherFragmentDoc}
  ${AuthorFragmentDoc}
`

/**
 * __useStoreResourcesQuery__
 *
 * To run a query within a React component, call `useStoreResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreResourcesQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *      role: // value for 'role'
 *      search: // value for 'search'
 *      author_ids: // value for 'author_ids'
 *      category_ids: // value for 'category_ids'
 *      publisher_ids: // value for 'publisher_ids'
 *      resource_types: // value for 'resource_types'
 *      visibility: // value for 'visibility'
 *      school_id: // value for 'school_id'
 *      licensee_school_id: // value for 'licensee_school_id'
 *      include_school_license: // value for 'include_school_license'
 *      user_registered: // value for 'user_registered'
 *   },
 * });
 */
export function useStoreResourcesQuery(
  baseOptions: Apollo.QueryHookOptions<
    StoreResourcesQuery,
    StoreResourcesQueryVariables
  > &
    (
      | { variables: StoreResourcesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<StoreResourcesQuery, StoreResourcesQueryVariables>(
    StoreResourcesDocument,
    options
  )
}
export function useStoreResourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StoreResourcesQuery,
    StoreResourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<StoreResourcesQuery, StoreResourcesQueryVariables>(
    StoreResourcesDocument,
    options
  )
}
export function useStoreResourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StoreResourcesQuery,
        StoreResourcesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    StoreResourcesQuery,
    StoreResourcesQueryVariables
  >(StoreResourcesDocument, options)
}
export type StoreResourcesQueryHookResult = ReturnType<
  typeof useStoreResourcesQuery
>
export type StoreResourcesLazyQueryHookResult = ReturnType<
  typeof useStoreResourcesLazyQuery
>
export type StoreResourcesSuspenseQueryHookResult = ReturnType<
  typeof useStoreResourcesSuspenseQuery
>
export type StoreResourcesQueryResult = Apollo.QueryResult<
  StoreResourcesQuery,
  StoreResourcesQueryVariables
>
export const StripeProductsDocument = gql`
  query StripeProducts(
    $first: Int!
    $after: String
    $ids: IDFilter
    $includeInactive: Boolean
  ) {
    stripeProducts(
      first: $first
      after: $after
      ids: $ids
      include_inactive: $includeInactive
    ) {
      edges {
        node {
          ...StripeProduct
          stripe_prices(first: 50) {
            edges {
              node {
                ...StripePrice
              }
            }
          }
        }
      }
    }
  }
  ${StripeProductFragmentDoc}
  ${StripePriceFragmentDoc}
`

/**
 * __useStripeProductsQuery__
 *
 * To run a query within a React component, call `useStripeProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeProductsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      ids: // value for 'ids'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useStripeProductsQuery(
  baseOptions: Apollo.QueryHookOptions<
    StripeProductsQuery,
    StripeProductsQueryVariables
  > &
    (
      | { variables: StripeProductsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<StripeProductsQuery, StripeProductsQueryVariables>(
    StripeProductsDocument,
    options
  )
}
export function useStripeProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StripeProductsQuery,
    StripeProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<StripeProductsQuery, StripeProductsQueryVariables>(
    StripeProductsDocument,
    options
  )
}
export function useStripeProductsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        StripeProductsQuery,
        StripeProductsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    StripeProductsQuery,
    StripeProductsQueryVariables
  >(StripeProductsDocument, options)
}
export type StripeProductsQueryHookResult = ReturnType<
  typeof useStripeProductsQuery
>
export type StripeProductsLazyQueryHookResult = ReturnType<
  typeof useStripeProductsLazyQuery
>
export type StripeProductsSuspenseQueryHookResult = ReturnType<
  typeof useStripeProductsSuspenseQuery
>
export type StripeProductsQueryResult = Apollo.QueryResult<
  StripeProductsQuery,
  StripeProductsQueryVariables
>
export const CancelSchoolSubscriptionDocument = gql`
  mutation CancelSchoolSubscription(
    $for_user: Int
    $cancel_immediately: Boolean
  ) {
    cancelSchoolSubscription(
      for_user: $for_user
      cancel_immediately: $cancel_immediately
    ) {
      ...SchoolSubscription
    }
  }
  ${SchoolSubscriptionFragmentDoc}
`
export type CancelSchoolSubscriptionMutationFn = Apollo.MutationFunction<
  CancelSchoolSubscriptionMutation,
  CancelSchoolSubscriptionMutationVariables
>

/**
 * __useCancelSchoolSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSchoolSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSchoolSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSchoolSubscriptionMutation, { data, loading, error }] = useCancelSchoolSubscriptionMutation({
 *   variables: {
 *      for_user: // value for 'for_user'
 *      cancel_immediately: // value for 'cancel_immediately'
 *   },
 * });
 */
export function useCancelSchoolSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelSchoolSubscriptionMutation,
    CancelSchoolSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CancelSchoolSubscriptionMutation,
    CancelSchoolSubscriptionMutationVariables
  >(CancelSchoolSubscriptionDocument, options)
}
export type CancelSchoolSubscriptionMutationHookResult = ReturnType<
  typeof useCancelSchoolSubscriptionMutation
>
export type CancelSchoolSubscriptionMutationResult =
  Apollo.MutationResult<CancelSchoolSubscriptionMutation>
export type CancelSchoolSubscriptionMutationOptions =
  Apollo.BaseMutationOptions<
    CancelSchoolSubscriptionMutation,
    CancelSchoolSubscriptionMutationVariables
  >
export const FeatureIncludedCountDocument = gql`
  query FeatureIncludedCount {
    account {
      ...FeatureIncludedCount
    }
  }
  ${FeatureIncludedCountFragmentDoc}
`

/**
 * __useFeatureIncludedCountQuery__
 *
 * To run a query within a React component, call `useFeatureIncludedCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureIncludedCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureIncludedCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeatureIncludedCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FeatureIncludedCountQuery,
    FeatureIncludedCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    FeatureIncludedCountQuery,
    FeatureIncludedCountQueryVariables
  >(FeatureIncludedCountDocument, options)
}
export function useFeatureIncludedCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FeatureIncludedCountQuery,
    FeatureIncludedCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    FeatureIncludedCountQuery,
    FeatureIncludedCountQueryVariables
  >(FeatureIncludedCountDocument, options)
}
export function useFeatureIncludedCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        FeatureIncludedCountQuery,
        FeatureIncludedCountQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    FeatureIncludedCountQuery,
    FeatureIncludedCountQueryVariables
  >(FeatureIncludedCountDocument, options)
}
export type FeatureIncludedCountQueryHookResult = ReturnType<
  typeof useFeatureIncludedCountQuery
>
export type FeatureIncludedCountLazyQueryHookResult = ReturnType<
  typeof useFeatureIncludedCountLazyQuery
>
export type FeatureIncludedCountSuspenseQueryHookResult = ReturnType<
  typeof useFeatureIncludedCountSuspenseQuery
>
export type FeatureIncludedCountQueryResult = Apollo.QueryResult<
  FeatureIncludedCountQuery,
  FeatureIncludedCountQueryVariables
>
export const RedeemSchoolGiftSubscriptionDocument = gql`
  mutation RedeemSchoolGiftSubscription(
    $school_subscription_plan_id: Int!
    $code: String!
  ) {
    redeemSchoolGiftSubscription(
      school_subscription_plan_id: $school_subscription_plan_id
      code: $code
    ) {
      ...SchoolSubscription
    }
  }
  ${SchoolSubscriptionFragmentDoc}
`
export type RedeemSchoolGiftSubscriptionMutationFn = Apollo.MutationFunction<
  RedeemSchoolGiftSubscriptionMutation,
  RedeemSchoolGiftSubscriptionMutationVariables
>

/**
 * __useRedeemSchoolGiftSubscriptionMutation__
 *
 * To run a mutation, you first call `useRedeemSchoolGiftSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemSchoolGiftSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemSchoolGiftSubscriptionMutation, { data, loading, error }] = useRedeemSchoolGiftSubscriptionMutation({
 *   variables: {
 *      school_subscription_plan_id: // value for 'school_subscription_plan_id'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useRedeemSchoolGiftSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RedeemSchoolGiftSubscriptionMutation,
    RedeemSchoolGiftSubscriptionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RedeemSchoolGiftSubscriptionMutation,
    RedeemSchoolGiftSubscriptionMutationVariables
  >(RedeemSchoolGiftSubscriptionDocument, options)
}
export type RedeemSchoolGiftSubscriptionMutationHookResult = ReturnType<
  typeof useRedeemSchoolGiftSubscriptionMutation
>
export type RedeemSchoolGiftSubscriptionMutationResult =
  Apollo.MutationResult<RedeemSchoolGiftSubscriptionMutation>
export type RedeemSchoolGiftSubscriptionMutationOptions =
  Apollo.BaseMutationOptions<
    RedeemSchoolGiftSubscriptionMutation,
    RedeemSchoolGiftSubscriptionMutationVariables
  >
export const SchoolGiftSubscriptionDocument = gql`
  query SchoolGiftSubscription($code: String, $id: Int) {
    school {
      ...School
      gift_subscription(code: $code, id: $id) {
        ...SchoolGiftSubscription
      }
    }
  }
  ${SchoolFragmentDoc}
  ${SchoolGiftSubscriptionFragmentDoc}
`

/**
 * __useSchoolGiftSubscriptionQuery__
 *
 * To run a query within a React component, call `useSchoolGiftSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolGiftSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolGiftSubscriptionQuery({
 *   variables: {
 *      code: // value for 'code'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSchoolGiftSubscriptionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SchoolGiftSubscriptionQuery,
    SchoolGiftSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SchoolGiftSubscriptionQuery,
    SchoolGiftSubscriptionQueryVariables
  >(SchoolGiftSubscriptionDocument, options)
}
export function useSchoolGiftSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchoolGiftSubscriptionQuery,
    SchoolGiftSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchoolGiftSubscriptionQuery,
    SchoolGiftSubscriptionQueryVariables
  >(SchoolGiftSubscriptionDocument, options)
}
export function useSchoolGiftSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchoolGiftSubscriptionQuery,
        SchoolGiftSubscriptionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchoolGiftSubscriptionQuery,
    SchoolGiftSubscriptionQueryVariables
  >(SchoolGiftSubscriptionDocument, options)
}
export type SchoolGiftSubscriptionQueryHookResult = ReturnType<
  typeof useSchoolGiftSubscriptionQuery
>
export type SchoolGiftSubscriptionLazyQueryHookResult = ReturnType<
  typeof useSchoolGiftSubscriptionLazyQuery
>
export type SchoolGiftSubscriptionSuspenseQueryHookResult = ReturnType<
  typeof useSchoolGiftSubscriptionSuspenseQuery
>
export type SchoolGiftSubscriptionQueryResult = Apollo.QueryResult<
  SchoolGiftSubscriptionQuery,
  SchoolGiftSubscriptionQueryVariables
>
export const SchoolGroupSubscriptionDocument = gql`
  query SchoolGroupSubscription($id: Int!) {
    schoolGroupSubscription(id: $id) {
      ...SchoolGroupSubscription
    }
  }
  ${SchoolGroupSubscriptionFragmentDoc}
`

/**
 * __useSchoolGroupSubscriptionQuery__
 *
 * To run a query within a React component, call `useSchoolGroupSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolGroupSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolGroupSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSchoolGroupSubscriptionQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchoolGroupSubscriptionQuery,
    SchoolGroupSubscriptionQueryVariables
  > &
    (
      | { variables: SchoolGroupSubscriptionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SchoolGroupSubscriptionQuery,
    SchoolGroupSubscriptionQueryVariables
  >(SchoolGroupSubscriptionDocument, options)
}
export function useSchoolGroupSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchoolGroupSubscriptionQuery,
    SchoolGroupSubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchoolGroupSubscriptionQuery,
    SchoolGroupSubscriptionQueryVariables
  >(SchoolGroupSubscriptionDocument, options)
}
export function useSchoolGroupSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchoolGroupSubscriptionQuery,
        SchoolGroupSubscriptionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchoolGroupSubscriptionQuery,
    SchoolGroupSubscriptionQueryVariables
  >(SchoolGroupSubscriptionDocument, options)
}
export type SchoolGroupSubscriptionQueryHookResult = ReturnType<
  typeof useSchoolGroupSubscriptionQuery
>
export type SchoolGroupSubscriptionLazyQueryHookResult = ReturnType<
  typeof useSchoolGroupSubscriptionLazyQuery
>
export type SchoolGroupSubscriptionSuspenseQueryHookResult = ReturnType<
  typeof useSchoolGroupSubscriptionSuspenseQuery
>
export type SchoolGroupSubscriptionQueryResult = Apollo.QueryResult<
  SchoolGroupSubscriptionQuery,
  SchoolGroupSubscriptionQueryVariables
>
export const SchoolGroupSubscriptionsDocument = gql`
  query SchoolGroupSubscriptions($first: Int = 10, $licenseOfferingId: Int) {
    schoolGroupSubscriptions(
      first: $first
      license_offering_id: $licenseOfferingId
    ) {
      edges {
        node {
          ...SchoolGroupSubscription
        }
      }
    }
  }
  ${SchoolGroupSubscriptionFragmentDoc}
`

/**
 * __useSchoolGroupSubscriptionsQuery__
 *
 * To run a query within a React component, call `useSchoolGroupSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolGroupSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolGroupSubscriptionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      licenseOfferingId: // value for 'licenseOfferingId'
 *   },
 * });
 */
export function useSchoolGroupSubscriptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SchoolGroupSubscriptionsQuery,
    SchoolGroupSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SchoolGroupSubscriptionsQuery,
    SchoolGroupSubscriptionsQueryVariables
  >(SchoolGroupSubscriptionsDocument, options)
}
export function useSchoolGroupSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchoolGroupSubscriptionsQuery,
    SchoolGroupSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchoolGroupSubscriptionsQuery,
    SchoolGroupSubscriptionsQueryVariables
  >(SchoolGroupSubscriptionsDocument, options)
}
export function useSchoolGroupSubscriptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchoolGroupSubscriptionsQuery,
        SchoolGroupSubscriptionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchoolGroupSubscriptionsQuery,
    SchoolGroupSubscriptionsQueryVariables
  >(SchoolGroupSubscriptionsDocument, options)
}
export type SchoolGroupSubscriptionsQueryHookResult = ReturnType<
  typeof useSchoolGroupSubscriptionsQuery
>
export type SchoolGroupSubscriptionsLazyQueryHookResult = ReturnType<
  typeof useSchoolGroupSubscriptionsLazyQuery
>
export type SchoolGroupSubscriptionsSuspenseQueryHookResult = ReturnType<
  typeof useSchoolGroupSubscriptionsSuspenseQuery
>
export type SchoolGroupSubscriptionsQueryResult = Apollo.QueryResult<
  SchoolGroupSubscriptionsQuery,
  SchoolGroupSubscriptionsQueryVariables
>
export const SchoolSubscriptionPlansDocument = gql`
  query SchoolSubscriptionPlans(
    $ids: IDFilter
    $visibility_code: String
    $visibility_code_filter: StringFilter
    $ignore_visibility: Boolean
    $giftable: Boolean
    $interval: SubscriptionIntervalType
    $intervalFilter: SubscriptionIntervalFilter
    $positioningContext: PositioningContextInput
    $orderBy: [SchoolSubscriptionPlanOrderByInput]
  ) {
    school {
      ...School
      subscription_plans(
        first: 50
        ids: $ids
        visibility_code: $visibility_code
        visibility_code_filter: $visibility_code_filter
        ignore_visibility: $ignore_visibility
        giftable: $giftable
        interval: $interval
        interval_filter: $intervalFilter
        positioningContext: $positioningContext
        orderBy: $orderBy
      ) {
        total
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...PositionedSchoolSubscriptionPlan
          }
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${PositionedSchoolSubscriptionPlanFragmentDoc}
`

/**
 * __useSchoolSubscriptionPlansQuery__
 *
 * To run a query within a React component, call `useSchoolSubscriptionPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolSubscriptionPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolSubscriptionPlansQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      visibility_code: // value for 'visibility_code'
 *      visibility_code_filter: // value for 'visibility_code_filter'
 *      ignore_visibility: // value for 'ignore_visibility'
 *      giftable: // value for 'giftable'
 *      interval: // value for 'interval'
 *      intervalFilter: // value for 'intervalFilter'
 *      positioningContext: // value for 'positioningContext'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSchoolSubscriptionPlansQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SchoolSubscriptionPlansQuery,
    SchoolSubscriptionPlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SchoolSubscriptionPlansQuery,
    SchoolSubscriptionPlansQueryVariables
  >(SchoolSubscriptionPlansDocument, options)
}
export function useSchoolSubscriptionPlansLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchoolSubscriptionPlansQuery,
    SchoolSubscriptionPlansQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SchoolSubscriptionPlansQuery,
    SchoolSubscriptionPlansQueryVariables
  >(SchoolSubscriptionPlansDocument, options)
}
export function useSchoolSubscriptionPlansSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchoolSubscriptionPlansQuery,
        SchoolSubscriptionPlansQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SchoolSubscriptionPlansQuery,
    SchoolSubscriptionPlansQueryVariables
  >(SchoolSubscriptionPlansDocument, options)
}
export type SchoolSubscriptionPlansQueryHookResult = ReturnType<
  typeof useSchoolSubscriptionPlansQuery
>
export type SchoolSubscriptionPlansLazyQueryHookResult = ReturnType<
  typeof useSchoolSubscriptionPlansLazyQuery
>
export type SchoolSubscriptionPlansSuspenseQueryHookResult = ReturnType<
  typeof useSchoolSubscriptionPlansSuspenseQuery
>
export type SchoolSubscriptionPlansQueryResult = Apollo.QueryResult<
  SchoolSubscriptionPlansQuery,
  SchoolSubscriptionPlansQueryVariables
>
export const SendGiftSubscriptionEmailDocument = gql`
  mutation SendGiftSubscriptionEmail(
    $gift_id: Int!
    $recipient_email: String!
  ) {
    sendGiftSubscriptionEmail(
      gift_id: $gift_id
      recipient_email: $recipient_email
    )
  }
`
export type SendGiftSubscriptionEmailMutationFn = Apollo.MutationFunction<
  SendGiftSubscriptionEmailMutation,
  SendGiftSubscriptionEmailMutationVariables
>

/**
 * __useSendGiftSubscriptionEmailMutation__
 *
 * To run a mutation, you first call `useSendGiftSubscriptionEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGiftSubscriptionEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGiftSubscriptionEmailMutation, { data, loading, error }] = useSendGiftSubscriptionEmailMutation({
 *   variables: {
 *      gift_id: // value for 'gift_id'
 *      recipient_email: // value for 'recipient_email'
 *   },
 * });
 */
export function useSendGiftSubscriptionEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendGiftSubscriptionEmailMutation,
    SendGiftSubscriptionEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SendGiftSubscriptionEmailMutation,
    SendGiftSubscriptionEmailMutationVariables
  >(SendGiftSubscriptionEmailDocument, options)
}
export type SendGiftSubscriptionEmailMutationHookResult = ReturnType<
  typeof useSendGiftSubscriptionEmailMutation
>
export type SendGiftSubscriptionEmailMutationResult =
  Apollo.MutationResult<SendGiftSubscriptionEmailMutation>
export type SendGiftSubscriptionEmailMutationOptions =
  Apollo.BaseMutationOptions<
    SendGiftSubscriptionEmailMutation,
    SendGiftSubscriptionEmailMutationVariables
  >
export const SubscriptionDiscountDocument = gql`
  query SubscriptionDiscount($discount_code: String!, $school_plan_id: Int!) {
    schoolSubscriptionDiscount(
      discount_code: $discount_code
      school_plan_id: $school_plan_id
    ) {
      discount_percent
      discounted_price
      discounted_subscription_cycles
      currency_display_discount_price
      currency_display_discount_amount
    }
  }
`

/**
 * __useSubscriptionDiscountQuery__
 *
 * To run a query within a React component, call `useSubscriptionDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionDiscountQuery({
 *   variables: {
 *      discount_code: // value for 'discount_code'
 *      school_plan_id: // value for 'school_plan_id'
 *   },
 * });
 */
export function useSubscriptionDiscountQuery(
  baseOptions: Apollo.QueryHookOptions<
    SubscriptionDiscountQuery,
    SubscriptionDiscountQueryVariables
  > &
    (
      | { variables: SubscriptionDiscountQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SubscriptionDiscountQuery,
    SubscriptionDiscountQueryVariables
  >(SubscriptionDiscountDocument, options)
}
export function useSubscriptionDiscountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubscriptionDiscountQuery,
    SubscriptionDiscountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SubscriptionDiscountQuery,
    SubscriptionDiscountQueryVariables
  >(SubscriptionDiscountDocument, options)
}
export function useSubscriptionDiscountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubscriptionDiscountQuery,
        SubscriptionDiscountQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SubscriptionDiscountQuery,
    SubscriptionDiscountQueryVariables
  >(SubscriptionDiscountDocument, options)
}
export type SubscriptionDiscountQueryHookResult = ReturnType<
  typeof useSubscriptionDiscountQuery
>
export type SubscriptionDiscountLazyQueryHookResult = ReturnType<
  typeof useSubscriptionDiscountLazyQuery
>
export type SubscriptionDiscountSuspenseQueryHookResult = ReturnType<
  typeof useSubscriptionDiscountSuspenseQuery
>
export type SubscriptionDiscountQueryResult = Apollo.QueryResult<
  SubscriptionDiscountQuery,
  SubscriptionDiscountQueryVariables
>
export const SubscriptionDocument = gql`
  query Subscription($id: Int!) {
    subscription(id: $id) {
      ...Subscription
      payment_intent_client_secret
      stripe_publishable_api_key
    }
  }
  ${SubscriptionFragmentDoc}
`

/**
 * __useSubscriptionQuery__
 *
 * To run a query within a React component, call `useSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscriptionQuery(
  baseOptions: Apollo.QueryHookOptions<
    SubscriptionQuery,
    SubscriptionQueryVariables
  > &
    (
      | { variables: SubscriptionQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SubscriptionQuery, SubscriptionQueryVariables>(
    SubscriptionDocument,
    options
  )
}
export function useSubscriptionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubscriptionQuery,
    SubscriptionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SubscriptionQuery, SubscriptionQueryVariables>(
    SubscriptionDocument,
    options
  )
}
export function useSubscriptionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubscriptionQuery,
        SubscriptionQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<SubscriptionQuery, SubscriptionQueryVariables>(
    SubscriptionDocument,
    options
  )
}
export type SubscriptionQueryHookResult = ReturnType<
  typeof useSubscriptionQuery
>
export type SubscriptionLazyQueryHookResult = ReturnType<
  typeof useSubscriptionLazyQuery
>
export type SubscriptionSuspenseQueryHookResult = ReturnType<
  typeof useSubscriptionSuspenseQuery
>
export type SubscriptionQueryResult = Apollo.QueryResult<
  SubscriptionQuery,
  SubscriptionQueryVariables
>
export const SubscriptionsDocument = gql`
  query Subscriptions($paymentIntentNeedingActionIdFilter: IDFilter) {
    subscriptions(
      first: 10
      payment_intent_needing_action_id: $paymentIntentNeedingActionIdFilter
    ) {
      total
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...Subscription
        }
      }
    }
  }
  ${SubscriptionFragmentDoc}
`

/**
 * __useSubscriptionsQuery__
 *
 * To run a query within a React component, call `useSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsQuery({
 *   variables: {
 *      paymentIntentNeedingActionIdFilter: // value for 'paymentIntentNeedingActionIdFilter'
 *   },
 * });
 */
export function useSubscriptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SubscriptionsQuery,
    SubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(
    SubscriptionsDocument,
    options
  )
}
export function useSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SubscriptionsQuery,
    SubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(
    SubscriptionsDocument,
    options
  )
}
export function useSubscriptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SubscriptionsQuery,
        SubscriptionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SubscriptionsQuery,
    SubscriptionsQueryVariables
  >(SubscriptionsDocument, options)
}
export type SubscriptionsQueryHookResult = ReturnType<
  typeof useSubscriptionsQuery
>
export type SubscriptionsLazyQueryHookResult = ReturnType<
  typeof useSubscriptionsLazyQuery
>
export type SubscriptionsSuspenseQueryHookResult = ReturnType<
  typeof useSubscriptionsSuspenseQuery
>
export type SubscriptionsQueryResult = Apollo.QueryResult<
  SubscriptionsQuery,
  SubscriptionsQueryVariables
>
export const HomeCohortMembersDocument = gql`
  query HomeCohortMembers($groupId: Int!) {
    group(id: $groupId) {
      ...HomeCohortMembers
    }
  }
  ${HomeCohortMembersFragmentDoc}
`

/**
 * __useHomeCohortMembersQuery__
 *
 * To run a query within a React component, call `useHomeCohortMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeCohortMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeCohortMembersQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useHomeCohortMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    HomeCohortMembersQuery,
    HomeCohortMembersQueryVariables
  > &
    (
      | { variables: HomeCohortMembersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    HomeCohortMembersQuery,
    HomeCohortMembersQueryVariables
  >(HomeCohortMembersDocument, options)
}
export function useHomeCohortMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomeCohortMembersQuery,
    HomeCohortMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    HomeCohortMembersQuery,
    HomeCohortMembersQueryVariables
  >(HomeCohortMembersDocument, options)
}
export function useHomeCohortMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HomeCohortMembersQuery,
        HomeCohortMembersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    HomeCohortMembersQuery,
    HomeCohortMembersQueryVariables
  >(HomeCohortMembersDocument, options)
}
export type HomeCohortMembersQueryHookResult = ReturnType<
  typeof useHomeCohortMembersQuery
>
export type HomeCohortMembersLazyQueryHookResult = ReturnType<
  typeof useHomeCohortMembersLazyQuery
>
export type HomeCohortMembersSuspenseQueryHookResult = ReturnType<
  typeof useHomeCohortMembersSuspenseQuery
>
export type HomeCohortMembersQueryResult = Apollo.QueryResult<
  HomeCohortMembersQuery,
  HomeCohortMembersQueryVariables
>
export const HomeMentorGroupsMembershipsDocument = gql`
  query HomeMentorGroupsMemberships {
    me {
      id
      mentorGroupMemberships(
        first: 1
        role: { gte: moderator }
        mentor_group_seat_limit_filter: { neq: 1 }
      ) {
        total
        edges {
          node {
            id
            role
            group_id
          }
        }
      }
    }
  }
`

/**
 * __useHomeMentorGroupsMembershipsQuery__
 *
 * To run a query within a React component, call `useHomeMentorGroupsMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeMentorGroupsMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeMentorGroupsMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeMentorGroupsMembershipsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    HomeMentorGroupsMembershipsQuery,
    HomeMentorGroupsMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    HomeMentorGroupsMembershipsQuery,
    HomeMentorGroupsMembershipsQueryVariables
  >(HomeMentorGroupsMembershipsDocument, options)
}
export function useHomeMentorGroupsMembershipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomeMentorGroupsMembershipsQuery,
    HomeMentorGroupsMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    HomeMentorGroupsMembershipsQuery,
    HomeMentorGroupsMembershipsQueryVariables
  >(HomeMentorGroupsMembershipsDocument, options)
}
export function useHomeMentorGroupsMembershipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HomeMentorGroupsMembershipsQuery,
        HomeMentorGroupsMembershipsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    HomeMentorGroupsMembershipsQuery,
    HomeMentorGroupsMembershipsQueryVariables
  >(HomeMentorGroupsMembershipsDocument, options)
}
export type HomeMentorGroupsMembershipsQueryHookResult = ReturnType<
  typeof useHomeMentorGroupsMembershipsQuery
>
export type HomeMentorGroupsMembershipsLazyQueryHookResult = ReturnType<
  typeof useHomeMentorGroupsMembershipsLazyQuery
>
export type HomeMentorGroupsMembershipsSuspenseQueryHookResult = ReturnType<
  typeof useHomeMentorGroupsMembershipsSuspenseQuery
>
export type HomeMentorGroupsMembershipsQueryResult = Apollo.QueryResult<
  HomeMentorGroupsMembershipsQuery,
  HomeMentorGroupsMembershipsQueryVariables
>
export const HomeRegistrationsDocument = gql`
  query HomeRegistrations(
    $first: Int!
    $positioningContext: PositioningContextInput
    $orderBy: [RegistrationOrderByInput]
    $softArchived: DateFilter
    $progressFilter: ProgressFilter
    $lastSeen: DateFilter
  ) {
    me {
      id
      registrations(
        first: $first
        positioningContext: $positioningContext
        orderBy: $orderBy
        softArchived: $softArchived
        lastSeen: $lastSeen
        progress_filter: $progressFilter
      ) {
        edges {
          node {
            ...HomeRegistration
          }
        }
      }
    }
  }
  ${HomeRegistrationFragmentDoc}
`

/**
 * __useHomeRegistrationsQuery__
 *
 * To run a query within a React component, call `useHomeRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeRegistrationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      positioningContext: // value for 'positioningContext'
 *      orderBy: // value for 'orderBy'
 *      softArchived: // value for 'softArchived'
 *      progressFilter: // value for 'progressFilter'
 *      lastSeen: // value for 'lastSeen'
 *   },
 * });
 */
export function useHomeRegistrationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    HomeRegistrationsQuery,
    HomeRegistrationsQueryVariables
  > &
    (
      | { variables: HomeRegistrationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    HomeRegistrationsQuery,
    HomeRegistrationsQueryVariables
  >(HomeRegistrationsDocument, options)
}
export function useHomeRegistrationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomeRegistrationsQuery,
    HomeRegistrationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    HomeRegistrationsQuery,
    HomeRegistrationsQueryVariables
  >(HomeRegistrationsDocument, options)
}
export function useHomeRegistrationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HomeRegistrationsQuery,
        HomeRegistrationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    HomeRegistrationsQuery,
    HomeRegistrationsQueryVariables
  >(HomeRegistrationsDocument, options)
}
export type HomeRegistrationsQueryHookResult = ReturnType<
  typeof useHomeRegistrationsQuery
>
export type HomeRegistrationsLazyQueryHookResult = ReturnType<
  typeof useHomeRegistrationsLazyQuery
>
export type HomeRegistrationsSuspenseQueryHookResult = ReturnType<
  typeof useHomeRegistrationsSuspenseQuery
>
export type HomeRegistrationsQueryResult = Apollo.QueryResult<
  HomeRegistrationsQuery,
  HomeRegistrationsQueryVariables
>
export const HomeResourceCopyConfigLinkConnectionsDocument = gql`
  query HomeResourceCopyConfigLinkConnections(
    $first: Int!
    $copiedTimeDateFilter: DateFilter
    $hideFromLocationsFilter: [ResourceCopyConfigLinkLocationFilter]
  ) {
    resourceCopyConfigLinkConnections(
      first: $first
      copiedTimeDateFilter: $copiedTimeDateFilter
      hideFromLocationsFilter: $hideFromLocationsFilter
    ) {
      edges {
        node {
          ...HomeResourceCopyConfigLink
        }
      }
    }
  }
  ${HomeResourceCopyConfigLinkFragmentDoc}
`

/**
 * __useHomeResourceCopyConfigLinkConnectionsQuery__
 *
 * To run a query within a React component, call `useHomeResourceCopyConfigLinkConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeResourceCopyConfigLinkConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeResourceCopyConfigLinkConnectionsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      copiedTimeDateFilter: // value for 'copiedTimeDateFilter'
 *      hideFromLocationsFilter: // value for 'hideFromLocationsFilter'
 *   },
 * });
 */
export function useHomeResourceCopyConfigLinkConnectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    HomeResourceCopyConfigLinkConnectionsQuery,
    HomeResourceCopyConfigLinkConnectionsQueryVariables
  > &
    (
      | {
          variables: HomeResourceCopyConfigLinkConnectionsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    HomeResourceCopyConfigLinkConnectionsQuery,
    HomeResourceCopyConfigLinkConnectionsQueryVariables
  >(HomeResourceCopyConfigLinkConnectionsDocument, options)
}
export function useHomeResourceCopyConfigLinkConnectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomeResourceCopyConfigLinkConnectionsQuery,
    HomeResourceCopyConfigLinkConnectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    HomeResourceCopyConfigLinkConnectionsQuery,
    HomeResourceCopyConfigLinkConnectionsQueryVariables
  >(HomeResourceCopyConfigLinkConnectionsDocument, options)
}
export function useHomeResourceCopyConfigLinkConnectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HomeResourceCopyConfigLinkConnectionsQuery,
        HomeResourceCopyConfigLinkConnectionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    HomeResourceCopyConfigLinkConnectionsQuery,
    HomeResourceCopyConfigLinkConnectionsQueryVariables
  >(HomeResourceCopyConfigLinkConnectionsDocument, options)
}
export type HomeResourceCopyConfigLinkConnectionsQueryHookResult = ReturnType<
  typeof useHomeResourceCopyConfigLinkConnectionsQuery
>
export type HomeResourceCopyConfigLinkConnectionsLazyQueryHookResult =
  ReturnType<typeof useHomeResourceCopyConfigLinkConnectionsLazyQuery>
export type HomeResourceCopyConfigLinkConnectionsSuspenseQueryHookResult =
  ReturnType<typeof useHomeResourceCopyConfigLinkConnectionsSuspenseQuery>
export type HomeResourceCopyConfigLinkConnectionsQueryResult =
  Apollo.QueryResult<
    HomeResourceCopyConfigLinkConnectionsQuery,
    HomeResourceCopyConfigLinkConnectionsQueryVariables
  >
export const HomeResourceCopyConfigLinkRegistrationDocument = gql`
  query HomeResourceCopyConfigLinkRegistration($id: Int!) {
    resourceCopyConfigLink(id: $id) {
      ...HomeResourceCopyConfigLink
    }
  }
  ${HomeResourceCopyConfigLinkFragmentDoc}
`

/**
 * __useHomeResourceCopyConfigLinkRegistrationQuery__
 *
 * To run a query within a React component, call `useHomeResourceCopyConfigLinkRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeResourceCopyConfigLinkRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeResourceCopyConfigLinkRegistrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHomeResourceCopyConfigLinkRegistrationQuery(
  baseOptions: Apollo.QueryHookOptions<
    HomeResourceCopyConfigLinkRegistrationQuery,
    HomeResourceCopyConfigLinkRegistrationQueryVariables
  > &
    (
      | {
          variables: HomeResourceCopyConfigLinkRegistrationQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    HomeResourceCopyConfigLinkRegistrationQuery,
    HomeResourceCopyConfigLinkRegistrationQueryVariables
  >(HomeResourceCopyConfigLinkRegistrationDocument, options)
}
export function useHomeResourceCopyConfigLinkRegistrationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomeResourceCopyConfigLinkRegistrationQuery,
    HomeResourceCopyConfigLinkRegistrationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    HomeResourceCopyConfigLinkRegistrationQuery,
    HomeResourceCopyConfigLinkRegistrationQueryVariables
  >(HomeResourceCopyConfigLinkRegistrationDocument, options)
}
export function useHomeResourceCopyConfigLinkRegistrationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HomeResourceCopyConfigLinkRegistrationQuery,
        HomeResourceCopyConfigLinkRegistrationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    HomeResourceCopyConfigLinkRegistrationQuery,
    HomeResourceCopyConfigLinkRegistrationQueryVariables
  >(HomeResourceCopyConfigLinkRegistrationDocument, options)
}
export type HomeResourceCopyConfigLinkRegistrationQueryHookResult = ReturnType<
  typeof useHomeResourceCopyConfigLinkRegistrationQuery
>
export type HomeResourceCopyConfigLinkRegistrationLazyQueryHookResult =
  ReturnType<typeof useHomeResourceCopyConfigLinkRegistrationLazyQuery>
export type HomeResourceCopyConfigLinkRegistrationSuspenseQueryHookResult =
  ReturnType<typeof useHomeResourceCopyConfigLinkRegistrationSuspenseQuery>
export type HomeResourceCopyConfigLinkRegistrationQueryResult =
  Apollo.QueryResult<
    HomeResourceCopyConfigLinkRegistrationQuery,
    HomeResourceCopyConfigLinkRegistrationQueryVariables
  >
export const HomeResourceGroupsDocument = gql`
  query HomeResourceGroups($resourceId: Int) {
    resource(id: $resourceId) {
      groups(first: 50) {
        total
        edges {
          group: node {
            ...HomeGroup
          }
        }
      }
    }
  }
  ${HomeGroupFragmentDoc}
`

/**
 * __useHomeResourceGroupsQuery__
 *
 * To run a query within a React component, call `useHomeResourceGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeResourceGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeResourceGroupsQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useHomeResourceGroupsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    HomeResourceGroupsQuery,
    HomeResourceGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    HomeResourceGroupsQuery,
    HomeResourceGroupsQueryVariables
  >(HomeResourceGroupsDocument, options)
}
export function useHomeResourceGroupsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomeResourceGroupsQuery,
    HomeResourceGroupsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    HomeResourceGroupsQuery,
    HomeResourceGroupsQueryVariables
  >(HomeResourceGroupsDocument, options)
}
export function useHomeResourceGroupsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HomeResourceGroupsQuery,
        HomeResourceGroupsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    HomeResourceGroupsQuery,
    HomeResourceGroupsQueryVariables
  >(HomeResourceGroupsDocument, options)
}
export type HomeResourceGroupsQueryHookResult = ReturnType<
  typeof useHomeResourceGroupsQuery
>
export type HomeResourceGroupsLazyQueryHookResult = ReturnType<
  typeof useHomeResourceGroupsLazyQuery
>
export type HomeResourceGroupsSuspenseQueryHookResult = ReturnType<
  typeof useHomeResourceGroupsSuspenseQuery
>
export type HomeResourceGroupsQueryResult = Apollo.QueryResult<
  HomeResourceGroupsQuery,
  HomeResourceGroupsQueryVariables
>
export const InboxPendingReviewCountsDocument = gql`
  query InboxPendingReviewCounts(
    $targetIds: IntFilter!
    $targetType: InboxPendingReviewTarget!
  ) {
    inboxPendingReviewConnections(
      first: 1042
      target_ids: $targetIds
      target_type: $targetType
    ) {
      edges {
        node {
          id
          count
        }
      }
    }
  }
`

/**
 * __useInboxPendingReviewCountsQuery__
 *
 * To run a query within a React component, call `useInboxPendingReviewCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxPendingReviewCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxPendingReviewCountsQuery({
 *   variables: {
 *      targetIds: // value for 'targetIds'
 *      targetType: // value for 'targetType'
 *   },
 * });
 */
export function useInboxPendingReviewCountsQuery(
  baseOptions: Apollo.QueryHookOptions<
    InboxPendingReviewCountsQuery,
    InboxPendingReviewCountsQueryVariables
  > &
    (
      | { variables: InboxPendingReviewCountsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    InboxPendingReviewCountsQuery,
    InboxPendingReviewCountsQueryVariables
  >(InboxPendingReviewCountsDocument, options)
}
export function useInboxPendingReviewCountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InboxPendingReviewCountsQuery,
    InboxPendingReviewCountsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    InboxPendingReviewCountsQuery,
    InboxPendingReviewCountsQueryVariables
  >(InboxPendingReviewCountsDocument, options)
}
export function useInboxPendingReviewCountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        InboxPendingReviewCountsQuery,
        InboxPendingReviewCountsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    InboxPendingReviewCountsQuery,
    InboxPendingReviewCountsQueryVariables
  >(InboxPendingReviewCountsDocument, options)
}
export type InboxPendingReviewCountsQueryHookResult = ReturnType<
  typeof useInboxPendingReviewCountsQuery
>
export type InboxPendingReviewCountsLazyQueryHookResult = ReturnType<
  typeof useInboxPendingReviewCountsLazyQuery
>
export type InboxPendingReviewCountsSuspenseQueryHookResult = ReturnType<
  typeof useInboxPendingReviewCountsSuspenseQuery
>
export type InboxPendingReviewCountsQueryResult = Apollo.QueryResult<
  InboxPendingReviewCountsQuery,
  InboxPendingReviewCountsQueryVariables
>
export const PathwrightIntercomGuidanceTeamMembersDocument = gql`
  query PathwrightIntercomGuidanceTeamMembers {
    integrations {
      intercom {
        team {
          id
          name
          avatar
        }
      }
    }
  }
`

/**
 * __usePathwrightIntercomGuidanceTeamMembersQuery__
 *
 * To run a query within a React component, call `usePathwrightIntercomGuidanceTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathwrightIntercomGuidanceTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathwrightIntercomGuidanceTeamMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePathwrightIntercomGuidanceTeamMembersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PathwrightIntercomGuidanceTeamMembersQuery,
    PathwrightIntercomGuidanceTeamMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    PathwrightIntercomGuidanceTeamMembersQuery,
    PathwrightIntercomGuidanceTeamMembersQueryVariables
  >(PathwrightIntercomGuidanceTeamMembersDocument, options)
}
export function usePathwrightIntercomGuidanceTeamMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathwrightIntercomGuidanceTeamMembersQuery,
    PathwrightIntercomGuidanceTeamMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    PathwrightIntercomGuidanceTeamMembersQuery,
    PathwrightIntercomGuidanceTeamMembersQueryVariables
  >(PathwrightIntercomGuidanceTeamMembersDocument, options)
}
export function usePathwrightIntercomGuidanceTeamMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PathwrightIntercomGuidanceTeamMembersQuery,
        PathwrightIntercomGuidanceTeamMembersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    PathwrightIntercomGuidanceTeamMembersQuery,
    PathwrightIntercomGuidanceTeamMembersQueryVariables
  >(PathwrightIntercomGuidanceTeamMembersDocument, options)
}
export type PathwrightIntercomGuidanceTeamMembersQueryHookResult = ReturnType<
  typeof usePathwrightIntercomGuidanceTeamMembersQuery
>
export type PathwrightIntercomGuidanceTeamMembersLazyQueryHookResult =
  ReturnType<typeof usePathwrightIntercomGuidanceTeamMembersLazyQuery>
export type PathwrightIntercomGuidanceTeamMembersSuspenseQueryHookResult =
  ReturnType<typeof usePathwrightIntercomGuidanceTeamMembersSuspenseQuery>
export type PathwrightIntercomGuidanceTeamMembersQueryResult =
  Apollo.QueryResult<
    PathwrightIntercomGuidanceTeamMembersQuery,
    PathwrightIntercomGuidanceTeamMembersQueryVariables
  >
export const SoftArchiveRegistrationDocument = gql`
  mutation SoftArchiveRegistration($id: Int!, $softArchive: Boolean) {
    softArchiveRegistration(id: $id, softArchive: $softArchive) {
      ...HomeRegistration
    }
  }
  ${HomeRegistrationFragmentDoc}
`
export type SoftArchiveRegistrationMutationFn = Apollo.MutationFunction<
  SoftArchiveRegistrationMutation,
  SoftArchiveRegistrationMutationVariables
>

/**
 * __useSoftArchiveRegistrationMutation__
 *
 * To run a mutation, you first call `useSoftArchiveRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftArchiveRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softArchiveRegistrationMutation, { data, loading, error }] = useSoftArchiveRegistrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      softArchive: // value for 'softArchive'
 *   },
 * });
 */
export function useSoftArchiveRegistrationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SoftArchiveRegistrationMutation,
    SoftArchiveRegistrationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    SoftArchiveRegistrationMutation,
    SoftArchiveRegistrationMutationVariables
  >(SoftArchiveRegistrationDocument, options)
}
export type SoftArchiveRegistrationMutationHookResult = ReturnType<
  typeof useSoftArchiveRegistrationMutation
>
export type SoftArchiveRegistrationMutationResult =
  Apollo.MutationResult<SoftArchiveRegistrationMutation>
export type SoftArchiveRegistrationMutationOptions = Apollo.BaseMutationOptions<
  SoftArchiveRegistrationMutation,
  SoftArchiveRegistrationMutationVariables
>
export const UpdateUserDocument = gql`
  mutation UpdateUser($user: UserInput!, $profile: UserProfileInput!) {
    updateUser(user: $user, profile: $profile) {
      ...User
    }
  }
  ${UserFragmentDoc}
`
export type UpdateUserMutationFn = Apollo.MutationFunction<
  UpdateUserMutation,
  UpdateUserMutationVariables
>

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *      profile: // value for 'profile'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserMutation,
    UpdateUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(
    UpdateUserDocument,
    options
  )
}
export type UpdateUserMutationHookResult = ReturnType<
  typeof useUpdateUserMutation
>
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserMutation,
  UpdateUserMutationVariables
>
export const UserMentorGroupMembershipsDocument = gql`
  query UserMentorGroupMemberships(
    $role: MentorGroupMembershipRoleFilter
    $mentorGroupSeatLimit: Int
    $mentorGroupSeatLimitFilter: IntFilter
    $mentorGroupSeatsFilled: Int
    $mentorGroupSeatsFilledFilter: IntFilter
    $include_group: Boolean!
    $or: MentorGroupMembershipOr
  ) {
    me {
      id
      mentorGroupMemberships(
        first: 50
        role: $role
        mentor_group_seat_limit: $mentorGroupSeatLimit
        mentor_group_seat_limit_filter: $mentorGroupSeatLimitFilter
        mentor_group_seats_filled: $mentorGroupSeatsFilled
        mentor_group_seats_filled_filter: $mentorGroupSeatsFilledFilter
        _or: $or
      ) {
        edges {
          node {
            id
            role
            created
            group_id
            group @include(if: $include_group) {
              ...MentorGroup
              memberships(first: 5) {
                total
                edges {
                  node {
                    id
                    user {
                      ...User
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${MentorGroupFragmentDoc}
  ${UserFragmentDoc}
`

/**
 * __useUserMentorGroupMembershipsQuery__
 *
 * To run a query within a React component, call `useUserMentorGroupMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMentorGroupMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMentorGroupMembershipsQuery({
 *   variables: {
 *      role: // value for 'role'
 *      mentorGroupSeatLimit: // value for 'mentorGroupSeatLimit'
 *      mentorGroupSeatLimitFilter: // value for 'mentorGroupSeatLimitFilter'
 *      mentorGroupSeatsFilled: // value for 'mentorGroupSeatsFilled'
 *      mentorGroupSeatsFilledFilter: // value for 'mentorGroupSeatsFilledFilter'
 *      include_group: // value for 'include_group'
 *      or: // value for 'or'
 *   },
 * });
 */
export function useUserMentorGroupMembershipsQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserMentorGroupMembershipsQuery,
    UserMentorGroupMembershipsQueryVariables
  > &
    (
      | { variables: UserMentorGroupMembershipsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserMentorGroupMembershipsQuery,
    UserMentorGroupMembershipsQueryVariables
  >(UserMentorGroupMembershipsDocument, options)
}
export function useUserMentorGroupMembershipsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserMentorGroupMembershipsQuery,
    UserMentorGroupMembershipsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserMentorGroupMembershipsQuery,
    UserMentorGroupMembershipsQueryVariables
  >(UserMentorGroupMembershipsDocument, options)
}
export function useUserMentorGroupMembershipsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserMentorGroupMembershipsQuery,
        UserMentorGroupMembershipsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserMentorGroupMembershipsQuery,
    UserMentorGroupMembershipsQueryVariables
  >(UserMentorGroupMembershipsDocument, options)
}
export type UserMentorGroupMembershipsQueryHookResult = ReturnType<
  typeof useUserMentorGroupMembershipsQuery
>
export type UserMentorGroupMembershipsLazyQueryHookResult = ReturnType<
  typeof useUserMentorGroupMembershipsLazyQuery
>
export type UserMentorGroupMembershipsSuspenseQueryHookResult = ReturnType<
  typeof useUserMentorGroupMembershipsSuspenseQuery
>
export type UserMentorGroupMembershipsQueryResult = Apollo.QueryResult<
  UserMentorGroupMembershipsQuery,
  UserMentorGroupMembershipsQueryVariables
>
export const UserMentorGroupSubscriptionsDocument = gql`
  query UserMentorGroupSubscriptions {
    me {
      id
      mentorGroupMemberships(first: 50, group_type: group_subscription) {
        edges {
          node {
            ...UserMentorGroupSubscriptionMembership
          }
        }
      }
    }
  }
  ${UserMentorGroupSubscriptionMembershipFragmentDoc}
`

/**
 * __useUserMentorGroupSubscriptionsQuery__
 *
 * To run a query within a React component, call `useUserMentorGroupSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMentorGroupSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMentorGroupSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserMentorGroupSubscriptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserMentorGroupSubscriptionsQuery,
    UserMentorGroupSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserMentorGroupSubscriptionsQuery,
    UserMentorGroupSubscriptionsQueryVariables
  >(UserMentorGroupSubscriptionsDocument, options)
}
export function useUserMentorGroupSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserMentorGroupSubscriptionsQuery,
    UserMentorGroupSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserMentorGroupSubscriptionsQuery,
    UserMentorGroupSubscriptionsQueryVariables
  >(UserMentorGroupSubscriptionsDocument, options)
}
export function useUserMentorGroupSubscriptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserMentorGroupSubscriptionsQuery,
        UserMentorGroupSubscriptionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserMentorGroupSubscriptionsQuery,
    UserMentorGroupSubscriptionsQueryVariables
  >(UserMentorGroupSubscriptionsDocument, options)
}
export type UserMentorGroupSubscriptionsQueryHookResult = ReturnType<
  typeof useUserMentorGroupSubscriptionsQuery
>
export type UserMentorGroupSubscriptionsLazyQueryHookResult = ReturnType<
  typeof useUserMentorGroupSubscriptionsLazyQuery
>
export type UserMentorGroupSubscriptionsSuspenseQueryHookResult = ReturnType<
  typeof useUserMentorGroupSubscriptionsSuspenseQuery
>
export type UserMentorGroupSubscriptionsQueryResult = Apollo.QueryResult<
  UserMentorGroupSubscriptionsQuery,
  UserMentorGroupSubscriptionsQueryVariables
>
export const UserPaymentHistoryDocument = gql`
  query UserPaymentHistory {
    me {
      id
      payment_history {
        download_url
        payments {
          item
          total
          currency_display
          date
          is_failed
        }
      }
    }
  }
`

/**
 * __useUserPaymentHistoryQuery__
 *
 * To run a query within a React component, call `useUserPaymentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPaymentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPaymentHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPaymentHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserPaymentHistoryQuery,
    UserPaymentHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    UserPaymentHistoryQuery,
    UserPaymentHistoryQueryVariables
  >(UserPaymentHistoryDocument, options)
}
export function useUserPaymentHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserPaymentHistoryQuery,
    UserPaymentHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    UserPaymentHistoryQuery,
    UserPaymentHistoryQueryVariables
  >(UserPaymentHistoryDocument, options)
}
export function useUserPaymentHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UserPaymentHistoryQuery,
        UserPaymentHistoryQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    UserPaymentHistoryQuery,
    UserPaymentHistoryQueryVariables
  >(UserPaymentHistoryDocument, options)
}
export type UserPaymentHistoryQueryHookResult = ReturnType<
  typeof useUserPaymentHistoryQuery
>
export type UserPaymentHistoryLazyQueryHookResult = ReturnType<
  typeof useUserPaymentHistoryLazyQuery
>
export type UserPaymentHistorySuspenseQueryHookResult = ReturnType<
  typeof useUserPaymentHistorySuspenseQuery
>
export type UserPaymentHistoryQueryResult = Apollo.QueryResult<
  UserPaymentHistoryQuery,
  UserPaymentHistoryQueryVariables
>
